/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			var _m = moreModules[moduleId];
/******/
/******/ 			// Check if module is deduplicated
/******/ 			switch(typeof _m) {
/******/ 			case "object":
/******/ 				// Module can be created from a template
/******/ 				modules[moduleId] = (function(_m) {
/******/ 					var args = _m.slice(1), templateId = _m[0];
/******/ 					return function (a,b,c) {
/******/ 						modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 					};
/******/ 				}(_m));
/******/ 				break;
/******/ 			case "function":
/******/ 				// Normal module
/******/ 				modules[moduleId] = _m;
/******/ 				break;
/******/ 			default:
/******/ 				// Module is a copy of another module
/******/ 				modules[moduleId] = modules[_m];
/******/ 				break;
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"2":"LoginPage","3":"LoggedInPage","4":"LoadingPage"}[chunkId]||chunkId) + "." + "7efde769d3fee97e95fa" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	// We need to set the app prefix before doing anything else, so it applies to styles too.
	// eslint-disable-next-line no-unused-vars
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _webpackEntry = __webpack_require__(1004);
	
	var _webpackEntry2 = _interopRequireDefault(_webpackEntry);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _routingAppFacade = __webpack_require__(949);
	
	var _routingAppFacade2 = _interopRequireDefault(_routingAppFacade);
	
	var _bluebird = __webpack_require__(208);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	_reflux2['default'].setPromiseFactory(function (handlers) {
	  return new _bluebird2['default'](handlers);
	});
	
	window.onload = function () {
	  var appContainer = document.createElement('div');
	  document.body.appendChild(appContainer);
	  _reactDom2['default'].render(_react2['default'].createElement(_routingAppFacade2['default'], null), appContainer);
	};

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(1);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(384);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _injectionCombinedProvider = __webpack_require__(205);
	
	var _injectionCombinedProvider2 = _interopRequireDefault(_injectionCombinedProvider);
	
	/* global storeProvider */
	
	var StoreProvider = (function () {
	  function StoreProvider() {
	    _classCallCheck(this, StoreProvider);
	  }
	
	  _createClass(StoreProvider, [{
	    key: 'getStore',
	    value: function getStore(storeName) {
	      var result = _injectionCombinedProvider2['default'].get(storeName);
	      if (!result[storeName + 'Store']) {
	        throw new Error('Requested store "' + storeName + '" is not registered.');
	      }
	      return result[storeName + 'Store'];
	    }
	  }]);
	
	  return StoreProvider;
	})();
	
	if (typeof storeProvider === 'undefined') {
	  window.storeProvider = new StoreProvider();
	}
	
	exports['default'] = storeProvider;
	module.exports = exports['default'];

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(582);

/***/ },
/* 5 */,
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _injectionCombinedProvider = __webpack_require__(205);
	
	var _injectionCombinedProvider2 = _interopRequireDefault(_injectionCombinedProvider);
	
	/* global actionsProvider */
	
	var ActionsProvider = (function () {
	  function ActionsProvider() {
	    _classCallCheck(this, ActionsProvider);
	  }
	
	  _createClass(ActionsProvider, [{
	    key: 'getActions',
	    value: function getActions(actionsName) {
	      var result = _injectionCombinedProvider2['default'].get(actionsName);
	      if (!result[actionsName + 'Actions']) {
	        throw new Error('Requested actions "' + actionsName + '" is not registered.');
	      }
	      return result[actionsName + 'Actions'];
	    }
	  }]);
	
	  return ActionsProvider;
	})();
	
	if (typeof actionsProvider === 'undefined') {
	  window.actionsProvider = new ActionsProvider();
	}
	
	exports['default'] = actionsProvider;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _toastr = __webpack_require__(1256);
	
	var _toastr2 = _interopRequireDefault(_toastr);
	
	var UserNotification = {
	  error: function error(message, title) {
	    _toastr2['default'].error(message, title || 'Error', {
	      debug: false,
	      positionClass: 'toast-bottom-full-width',
	      onclick: null,
	      showDuration: 300,
	      hideDuration: 1000,
	      timeOut: 10000,
	      extendedTimeOut: 1000
	    });
	  },
	  warning: function warning(message, title) {
	    _toastr2['default'].warning(message, title || 'Attention', {
	      debug: false,
	      positionClass: 'toast-bottom-full-width',
	      onclick: null,
	      showDuration: 300,
	      hideDuration: 1000,
	      timeOut: 7000,
	      extendedTimeOut: 1000
	    });
	  },
	  success: function success(message, title) {
	    _toastr2['default'].success(message, title || 'Information', {
	      debug: false,
	      positionClass: 'toast-bottom-full-width',
	      onclick: null,
	      showDuration: 300,
	      hideDuration: 1000,
	      timeOut: 7000,
	      extendedTimeOut: 1000
	    });
	  }
	};
	
	exports['default'] = UserNotification;
	module.exports = exports['default'];

/***/ },
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _qs = __webpack_require__(126);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _urijs = __webpack_require__(51);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var _utilAppConfig = __webpack_require__(153);
	
	var _utilAppConfig2 = _interopRequireDefault(_utilAppConfig);
	
	var URLUtils = {
	  qualifyUrl: function qualifyUrl(url) {
	    return new _urijs2['default'](_utilAppConfig2['default'].gl2ServerUrl() + url).normalizePathname().toString();
	  },
	  appPrefixed: function appPrefixed(url) {
	    return this.concatURLPath(_utilAppConfig2['default'].gl2AppPathPrefix(), url);
	  },
	  getParsedSearch: function getParsedSearch(location) {
	    var search = {};
	    var query = location.search;
	    if (query) {
	      if (query.indexOf('?') === 0 && query.length > 1) {
	        query = query.substr(1, query.length - 1);
	        search = _qs2['default'].parse(query);
	      }
	    }
	
	    return search;
	  },
	  getParsedHash: function getParsedHash(location) {
	    var result = {};
	    var hash = location.hash;
	    if (hash) {
	      if (hash.indexOf('#') === 0 && hash.length > 1) {
	        hash = hash.substr(1, hash.length - 1);
	        result = _qs2['default'].parse(hash);
	      }
	    }
	    return result;
	  },
	  replaceHashParam: function replaceHashParam(name, newValue) {
	    var origHash = this.getParsedHash(window.location);
	    origHash[name] = newValue;
	    window.location.replace('#' + _qs2['default'].stringify(origHash));
	  },
	  concatURLPath: function concatURLPath() {
	    for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	      allArgs[_key] = arguments[_key];
	    }
	
	    var args = Array(allArgs.length);
	    for (var i = 0; i < allArgs.length; i++) {
	      args[i] = allArgs[i];
	    }
	
	    var joinedPath = '/' + args.join('/');
	    return joinedPath.replace(/[\/]+/g, '/');
	  }
	};
	
	exports['default'] = URLUtils;
	module.exports = exports['default'];

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	exports['default'] = fetch;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _superagentBluebirdPromise = __webpack_require__(1252);
	
	var _superagentBluebirdPromise2 = _interopRequireDefault(_superagentBluebirdPromise);
	
	var _bluebird = __webpack_require__(208);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _routingRoutes = __webpack_require__(11);
	
	var _routingRoutes2 = _interopRequireDefault(_routingRoutes);
	
	var _utilHistory = __webpack_require__(206);
	
	var _utilHistory2 = _interopRequireDefault(_utilHistory);
	
	var FetchError = (function (_Error) {
	  _inherits(FetchError, _Error);
	
	  function FetchError(message, additional) {
	    _classCallCheck(this, FetchError);
	
	    _get(Object.getPrototypeOf(FetchError.prototype), 'constructor', this).call(this, message);
	    this.message = message || additional.message || 'Undefined error.';
	    /* eslint-disable no-console */
	    try {
	      console.error('There was an error fetching a resource: ' + this.message + '.', 'Additional information: ' + (additional.body && additional.body.message ? additional.body.message : 'Not available'));
	    } catch (e) {
	      console.error('There was an error fetching a resource: ' + this.message + '. No additional information available.');
	    }
	    /* eslint-enable no-console */
	
	    this.additional = additional;
	  }
	
	  return FetchError;
	})(Error);
	
	exports.FetchError = FetchError;
	
	var Builder = (function () {
	  function Builder(method, url) {
	    _classCallCheck(this, Builder);
	
	    this.request = (0, _superagentBluebirdPromise2['default'])(method, url.replace(/([^:])\/\//, '$1/')).set('X-Requested-With', 'XMLHttpRequest');
	  }
	
	  _createClass(Builder, [{
	    key: 'authenticated',
	    value: function authenticated() {
	      var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	      var token = SessionStore.getSessionId();
	
	      return this.session(token);
	    }
	  }, {
	    key: 'session',
	    value: function session(sessionId) {
	      this.request = this.request.auth(sessionId, 'session');
	
	      return this;
	    }
	  }, {
	    key: 'setHeader',
	    value: function setHeader(header, value) {
	      this.request = this.request.set(header, value);
	
	      return this;
	    }
	  }, {
	    key: 'json',
	    value: function json(body) {
	      this.request = this.request.send(body).type('json').accept('json').then(function (resp) {
	        if (resp.ok) {
	          var ServerAvailabilityActions = _injectionActionsProvider2['default'].getActions('ServerAvailability');
	          ServerAvailabilityActions.reportSuccess();
	          return resp.body;
	        }
	
	        throw new FetchError(resp.statusText, resp);
	      }, function (error) {
	        var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	        if (SessionStore.isLoggedIn() && error.status === 401) {
	          var SessionActions = _injectionActionsProvider2['default'].getActions('Session');
	          SessionActions.logout(SessionStore.getSessionId());
	        }
	
	        // Redirect to the start page if a user is logged in but not allowed to access a certain HTTP API.
	        if (SessionStore.isLoggedIn() && error.status === 403) {
	          _utilHistory2['default'].replaceState(null, _routingRoutes2['default'].STARTPAGE);
	        }
	
	        if (error.originalError && !error.originalError.status) {
	          var ServerAvailabilityActions = _injectionActionsProvider2['default'].getActions('ServerAvailability');
	          ServerAvailabilityActions.reportError(error);
	        }
	
	        throw new FetchError(error.statusText, error);
	      });
	
	      return this;
	    }
	  }, {
	    key: 'build',
	    value: function build() {
	      return this.request;
	    }
	  }]);
	
	  return Builder;
	})();
	
	exports.Builder = Builder;
	
	function fetch(method, url, body) {
	  var promise = function promise() {
	    return new Builder(method, url).authenticated().json(body).build();
	  };
	
	  var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	
	  if (!SessionStore.isLoggedIn()) {
	    return new _bluebird2['default'](function (resolve, reject) {
	      var SessionActions = _injectionActionsProvider2['default'].getActions('Session');
	      SessionActions.login.completed.listen(function () {
	        promise().then(resolve, reject);
	      });
	    });
	  }
	  return promise();
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilAppConfig = __webpack_require__(153);
	
	var _utilAppConfig2 = _interopRequireDefault(_utilAppConfig);
	
	var _graylogWebPluginPlugin = __webpack_require__(39);
	
	var _urijs = __webpack_require__(51);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	/*
	 * Global registry of plugin routes. Route names are generated automatically from the route path, by removing
	 * any colons, replacing slashes with underscores, and making the string uppercase. Below there is an example of how
	 * to access the routes.
	 *
	 * Plugin register example:
	 * routes: [
	 *           { path: '/system/pipelines', component: Foo },
	 *           { path: '/system/pipelines/:pipelineId', component: Bar },
	 * ]
	 *
	 * Using routes on plugin components:
	 * <LinkContainer to={Routes.pluginRoutes('SYSTEM_PIPELINES')}>...</LinkContainer>
	 * <LinkContainer to={Routes.pluginRoutes('SYSTEM_PIPELINES_PIPELINEID')(123)}>...</LinkContainer>
	 *
	 */
	var pluginRoutes = {};
	_graylogWebPluginPlugin.PluginStore.exports('routes').forEach(function (pluginRoute) {
	  var uri = new _urijs2['default'](pluginRoute.path);
	  var segments = uri.segment();
	  var key = segments.map(function (segment) {
	    return segment.replace(':', '');
	  }).join('_').toUpperCase();
	  var paramNames = segments.filter(function (segment) {
	    return segment.startsWith(':');
	  });
	
	  if (paramNames.length > 0) {
	    pluginRoutes[key] = function () {
	      for (var _len = arguments.length, paramValues = Array(_len), _key = 0; _key < _len; _key++) {
	        paramValues[_key] = arguments[_key];
	      }
	
	      paramNames.forEach(function (param, idx) {
	        var value = String(paramValues[idx]);
	        uri.segment(segments.indexOf(param), value);
	      });
	
	      return uri.pathname();
	    };
	
	    return;
	  }
	
	  pluginRoutes[key] = pluginRoute.path;
	});
	
	var Routes = {
	  STARTPAGE: '/',
	  SEARCH: '/search',
	  STREAMS: '/streams',
	  SOURCES: '/sources',
	  DASHBOARDS: '/dashboards',
	  GETTING_STARTED: '/gettingstarted',
	  SYSTEM: {
	    CONFIGURATIONS: '/system/configurations',
	    CONTENTPACKS: {
	      LIST: '/system/contentpacks',
	      EXPORT: '/system/contentpacks/export'
	    },
	    GROKPATTERNS: '/system/grokpatterns',
	    INDICES: {
	      LIST: '/system/indices',
	      FAILURES: '/system/indices/failures'
	    },
	    INPUTS: '/system/inputs',
	    LOGGING: '/system/logging',
	    METRICS: function METRICS(nodeId) {
	      return '/system/metrics/node/' + nodeId;
	    },
	    NODES: {
	      LIST: '/system/nodes',
	      SHOW: function SHOW(nodeId) {
	        return '/system/nodes/' + nodeId;
	      }
	    },
	    THREADDUMP: function THREADDUMP(nodeId) {
	      return '/system/threaddump/' + nodeId;
	    },
	    OUTPUTS: '/system/outputs',
	    OVERVIEW: '/system/overview',
	    LDAP: {
	      SETTINGS: '/system/ldap',
	      GROUPS: '/system/ldap/groups'
	    },
	    AUTHENTICATION: {
	      OVERVIEW: '/system/authentication',
	      ROLES: '/system/authentication/roles',
	      USERS: {
	        CREATE: '/system/authentication/users/new',
	        edit: function edit(username) {
	          return '/system/authentication/users/edit/' + username;
	        },
	        LIST: '/system/authentication/users'
	      },
	      PROVIDERS: {
	        CONFIG: '/system/authentication/config',
	        provider: function provider(name) {
	          return '/system/authentication/config/' + name;
	        }
	      }
	    }
	  },
	  search_with_query: function search_with_query(query, rangeType, timeRange) {
	    var route = new _urijs2['default'](Routes.SEARCH);
	    var queryParams = {
	      q: query
	    };
	    if (rangeType && timeRange) {
	      queryParams[rangeType] = timeRange;
	    }
	    route.query(queryParams);
	    return route.resource();
	  },
	  _common_search_url: function _common_search_url(resource, query, timeRange, resolution) {
	    var route = new _urijs2['default'](resource);
	    var queryParams = {
	      q: query,
	      interval: resolution
	    };
	
	    if (timeRange) {
	      Object.keys(timeRange).forEach(function (key) {
	        queryParams[key] = timeRange[key];
	      });
	    }
	
	    route.query(queryParams);
	    return route.resource();
	  },
	  search: function search(query, timeRange, resolution) {
	    return Routes._common_search_url(Routes.SEARCH, query, timeRange, resolution);
	  },
	  message_show: function message_show(index, messageId) {
	    return '/messages/' + index + '/' + messageId;
	  },
	  stream_edit: function stream_edit(streamId) {
	    return '/streams/' + streamId + '/edit';
	  },
	  stream_edit_example: function stream_edit_example(streamId, index, messageId) {
	    return Routes.stream_edit(streamId) + '?index=' + index + '&message_id=' + messageId;
	  },
	  stream_outputs: function stream_outputs(streamId) {
	    return '/streams/' + streamId + '/outputs';
	  },
	  stream_alerts: function stream_alerts(streamId) {
	    return '/streams/' + streamId + '/alerts';
	  },
	  stream_search: function stream_search(streamId, query, timeRange, resolution) {
	    return Routes._common_search_url(Routes.STREAMS + '/' + streamId + '/search', query, timeRange, resolution);
	  },
	  legacy_stream_search: function legacy_stream_search(streamId) {
	    return '/streams/' + streamId + '/messages';
	  },
	
	  dashboard_show: function dashboard_show(dashboardId) {
	    return '/dashboards/' + dashboardId;
	  },
	
	  node: function node(nodeId) {
	    return '/system/nodes/' + nodeId;
	  },
	
	  node_inputs: function node_inputs(nodeId) {
	    return Routes.SYSTEM.INPUTS + '/' + nodeId;
	  },
	  global_input_extractors: function global_input_extractors(inputId) {
	    return '/system/inputs/' + inputId + '/extractors';
	  },
	  local_input_extractors: function local_input_extractors(nodeId, inputId) {
	    return '/system/inputs/' + nodeId + '/' + inputId + '/extractors';
	  },
	  export_extractors: function export_extractors(nodeId, inputId) {
	    return Routes.local_input_extractors(nodeId, inputId) + '/export';
	  },
	  import_extractors: function import_extractors(nodeId, inputId) {
	    return Routes.local_input_extractors(nodeId, inputId) + '/import';
	  },
	  new_extractor: function new_extractor(nodeId, inputId, extractorType, fieldName, index, messageId) {
	    var route = new _urijs2['default']('/system/inputs/' + nodeId + '/' + inputId + '/extractors/new');
	    var queryParams = {
	      extractor_type: extractorType,
	      field: fieldName,
	      example_index: index,
	      example_id: messageId
	    };
	    route.search(queryParams);
	
	    return route.resource();
	  },
	  edit_extractor: function edit_extractor(nodeId, inputId, extractorId) {
	    return '/system/inputs/' + nodeId + '/' + inputId + '/extractors/' + extractorId + '/edit';
	  },
	
	  edit_input_extractor: function edit_input_extractor(nodeId, inputId, extractorId) {
	    return '/system/inputs/' + nodeId + '/' + inputId + '/extractors/' + extractorId + '/edit';
	  },
	  getting_started: function getting_started(fromMenu) {
	    return Routes.GETTING_STARTED + '?menu=' + fromMenu;
	  },
	  filtered_metrics: function filtered_metrics(nodeId, filter) {
	    return Routes.SYSTEM.METRICS(nodeId) + '?filter=' + filter;
	  }
	};
	
	var qualifyUrls = function qualifyUrls(routes, appPrefix) {
	  var qualifiedRoutes = {};
	
	  Object.keys(routes).forEach(function (routeName) {
	    switch (typeof routes[routeName]) {
	      case 'string':
	        qualifiedRoutes[routeName] = '' + appPrefix + routes[routeName];
	        break;
	      case 'function':
	        qualifiedRoutes[routeName] = function () {
	          var result = routes[routeName].apply(routes, arguments);
	          return '' + appPrefix + result;
	        };
	        break;
	      case 'object':
	        qualifiedRoutes[routeName] = qualifyUrls(routes[routeName], appPrefix);
	        break;
	      default:
	        break;
	    }
	  });
	
	  return qualifiedRoutes;
	};
	
	var defaultExport = _utilAppConfig2['default'].gl2AppPathPrefix() ? qualifyUrls(Routes, _utilAppConfig2['default'].gl2AppPathPrefix()) : Routes;
	window.pluginRoutes = _utilAppConfig2['default'].gl2AppPathPrefix() ? qualifyUrls(pluginRoutes, _utilAppConfig2['default'].gl2AppPathPrefix()) : pluginRoutes;
	
	// Plugin routes need to be prefixed separately, so we add them to the Routes object just at the end.
	defaultExport.pluginRoute = function (key) {
	  var route = window.pluginRoutes[key];
	  if (!route) {
	    console.error('Could not find plugin route \'' + key + '\'.');
	  }
	
	  return route;
	};
	
	exports['default'] = defaultExport;
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = __vendor;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(798);

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = function(React, desc) {
		desc.displayName = "ReactProxy";
		desc.render = function() {
			var Component = this.state.component;
			if(Component) {
				return React.createElement(Component, this.props, this.props.children);
			} else if(this.renderUnavailable) {
				return this.renderUnavailable();
			} else {
				return null;
			}
		};
		desc.getInitialState = function() {
			return { component: this.loadComponent() };
		};
		desc.componentDidMount = function() {
			if(!this.state.component) {
				this.loadComponent(function(component) {
					if(this.isMounted()) {
						this.setState({ component: component });
					}
				}.bind(this));
			}
		};
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _qs = __webpack_require__(126);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var ApiRoutes = {
	  AlarmCallbacksApiController: {
	    available: function available(streamId) {
	      return { url: '/streams/' + streamId + '/alarmcallbacks/available' };
	    },
	    create: function create(streamId) {
	      return { url: '/streams/' + streamId + '/alarmcallbacks' };
	    },
	    'delete': function _delete(streamId, alarmCallbackId) {
	      return { url: '/streams/' + streamId + '/alarmcallbacks/' + alarmCallbackId };
	    },
	    list: function list(streamId) {
	      return { url: '/streams/' + streamId + '/alarmcallbacks' };
	    },
	    update: function update(streamId, alarmCallbackId) {
	      return { url: '/streams/' + streamId + '/alarmcallbacks/' + alarmCallbackId };
	    }
	  },
	  AlarmCallbackHistoryApiController: {
	    list: function list(streamId, alertId) {
	      return { url: '/streams/' + streamId + '/alerts/' + alertId + '/history' };
	    }
	  },
	  AlertsApiController: {
	    list: function list(streamId, since) {
	      return { url: '/streams/' + streamId + '/alerts/?since=' + since };
	    },
	    listPaginated: function listPaginated(streamId, skip, limit) {
	      return { url: '/streams/' + streamId + '/alerts/paginated?skip=' + skip + '&limit=' + limit };
	    },
	    listAllStreams: function listAllStreams(since) {
	      return { url: '/streams/alerts/?since=' + since };
	    }
	  },
	  BundlesApiController: {
	    apply: function apply(bundleId) {
	      return { url: '/system/bundles/' + bundleId + '/apply' };
	    },
	    create: function create() {
	      return { url: '/system/bundles' };
	    },
	    'delete': function _delete(bundleId) {
	      return { url: '/system/bundles/' + bundleId };
	    },
	    'export': function _export() {
	      return { url: '/system/bundles/export' };
	    },
	    list: function list() {
	      return { url: '/system/bundles' };
	    }
	  },
	  CodecTypesController: {
	    list: function list() {
	      return { url: '/system/codecs/types/all' };
	    }
	  },
	  CountsApiController: {
	    total: function total() {
	      return { url: '/count/total' };
	    }
	  },
	  ClusterApiResource: {
	    list: function list() {
	      return { url: '/system/cluster/nodes' };
	    },
	    node: function node() {
	      return { url: '/system/cluster/node' };
	    }
	  },
	  DashboardsApiController: {
	    create: function create() {
	      return { url: '/dashboards' };
	    },
	    index: function index() {
	      return { url: '/dashboards' };
	    },
	    get: function get(id) {
	      return { url: '/dashboards/' + id };
	    },
	    'delete': function _delete(id) {
	      return { url: '/dashboards/' + id };
	    },
	    update: function update(id) {
	      return { url: '/dashboards/' + id };
	    },
	    addWidget: function addWidget(id) {
	      return { url: '/dashboards/' + id + '/widgets' };
	    },
	    removeWidget: function removeWidget(dashboardId, widgetId) {
	      return { url: '/dashboards/' + dashboardId + '/widgets/' + widgetId };
	    },
	    widget: function widget(dashboardId, widgetId) {
	      return { url: '/dashboards/' + dashboardId + '/widgets/' + widgetId };
	    },
	    updateWidget: function updateWidget(dashboardId, widgetId) {
	      return { url: '/dashboards/' + dashboardId + '/widgets/' + widgetId };
	    },
	    widgetValue: function widgetValue(dashboardId, widgetId) {
	      return { url: '/dashboards/' + dashboardId + '/widgets/' + widgetId + '/value' };
	    },
	    updatePositions: function updatePositions(dashboardId) {
	      return { url: '/dashboards/' + dashboardId + '/positions' };
	    }
	  },
	  DecoratorsResource: {
	    available: function available() {
	      return { url: '/search/decorators/available' };
	    },
	    create: function create() {
	      return { url: '/search/decorators' };
	    },
	    get: function get() {
	      return { url: '/search/decorators' };
	    },
	    remove: function remove(decoratorId) {
	      return { url: '/search/decorators/' + decoratorId };
	    },
	    update: function update(decoratorId) {
	      return { url: '/search/decorators/' + decoratorId };
	    }
	  },
	  DeflectorApiController: {
	    cycle: function cycle() {
	      return { url: '/cluster/deflector/cycle' };
	    },
	    list: function list() {
	      return { url: '/system/deflector' };
	    }
	  },
	  IndexerClusterApiController: {
	    health: function health() {
	      return { url: '/system/indexer/cluster/health' };
	    },
	    name: function name() {
	      return { url: '/system/indexer/cluster/name' };
	    }
	  },
	  IndexerFailuresApiController: {
	    count: function count(since) {
	      return { url: '/system/indexer/failures/count?since=' + since };
	    },
	    list: function list(limit, offset) {
	      return { url: '/system/indexer/failures?limit=' + limit + '&offset=' + offset };
	    }
	  },
	  IndexerOverviewApiResource: {
	    list: function list() {
	      return { url: '/system/indexer/overview' };
	    }
	  },
	  IndexRangesApiController: {
	    list: function list() {
	      return { url: '/system/indices/ranges' };
	    },
	    rebuild: function rebuild() {
	      return { url: '/system/indices/ranges/rebuild' };
	    },
	    rebuildSingle: function rebuildSingle(index) {
	      return { url: '/system/indices/ranges/' + index + '/rebuild' };
	    }
	  },
	  IndicesApiController: {
	    close: function close(indexName) {
	      return { url: '/system/indexer/indices/' + indexName + '/close' };
	    },
	    'delete': function _delete(indexName) {
	      return { url: '/system/indexer/indices/' + indexName };
	    },
	    list: function list() {
	      return { url: '/system/indexer/indices' };
	    },
	    listClosed: function listClosed() {
	      return { url: '/system/indexer/indices/closed' };
	    },
	    multiple: function multiple() {
	      return { url: '/system/indexer/indices/multiple' };
	    },
	    reopen: function reopen(indexName) {
	      return { url: '/system/indexer/indices/' + indexName + '/reopen' };
	    }
	  },
	  InputsApiController: {
	    list: function list() {
	      return { url: '/system/inputs' };
	    },
	    get: function get(id) {
	      return { url: '/system/inputs/' + id };
	    },
	    globalRecentMessage: function globalRecentMessage(inputId) {
	      return { url: '/' + inputId };
	    }
	  },
	  InputStatesController: {
	    start: function start(inputId) {
	      return { url: '/system/inputstates/' + inputId };
	    },
	    stop: function stop(inputId) {
	      return { url: '/system/inputstates/' + inputId };
	    }
	  },
	  ClusterInputStatesController: {
	    list: function list() {
	      return { url: '/cluster/inputstates' };
	    },
	    start: function start(inputId) {
	      return { url: '/cluster/inputstates/' + inputId };
	    },
	    stop: function stop(inputId) {
	      return { url: '/cluster/inputstates/' + inputId };
	    }
	  },
	  ClusterLoggersResource: {
	    loggers: function loggers() {
	      return { url: '/cluster/system/loggers' };
	    },
	    subsystems: function subsystems() {
	      return { url: '/cluster/system/loggers/subsystems' };
	    },
	    setSubsystemLoggerLevel: function setSubsystemLoggerLevel(nodeId, subsystem, loglevel) {
	      return { url: '/cluster/system/loggers/' + nodeId + '/subsystems/' + subsystem + '/level/' + loglevel };
	    }
	  },
	  MessageFieldsApiController: {
	    list: function list() {
	      return { url: '/system/fields' };
	    }
	  },
	  MetricsApiController: {
	    multiple: function multiple() {
	      return { url: '/system/metrics/multiple' };
	    },
	    byNamespace: function byNamespace(namespace) {
	      return { url: '/system/metrics/namespace/' + namespace };
	    }
	  },
	  ClusterMetricsApiController: {
	    multiple: function multiple(nodeId) {
	      return { url: '/cluster/' + nodeId + '/metrics/multiple' };
	    },
	    multipleAllNodes: function multipleAllNodes() {
	      return { url: '/cluster/metrics/multiple' };
	    },
	    byNamespace: function byNamespace(nodeId, namespace) {
	      return { url: '/cluster/' + nodeId + '/metrics/namespace/' + namespace };
	    }
	  },
	  NotificationsApiController: {
	    'delete': function _delete(type) {
	      return { url: '/system/notifications/' + type };
	    },
	    list: function list() {
	      return { url: '/system/notifications' };
	    }
	  },
	  OutputsApiController: {
	    index: function index() {
	      return { url: '/system/outputs' };
	    },
	    create: function create() {
	      return { url: '/system/outputs' };
	    },
	    'delete': function _delete(outputId) {
	      return { url: '/system/outputs/' + outputId };
	    },
	    update: function update(outputId) {
	      return { url: '/system/outputs/' + outputId };
	    },
	    availableType: function availableType(type) {
	      return { url: '/system/outputs/available/' + type };
	    },
	    availableTypes: function availableTypes() {
	      return { url: '/system/outputs/available' };
	    }
	  },
	  RolesApiController: {
	    listRoles: function listRoles() {
	      return { url: '/roles' };
	    },
	    createRole: function createRole() {
	      return { url: '/roles' };
	    },
	    updateRole: function updateRole(rolename) {
	      return { url: '/roles/' + rolename };
	    },
	    deleteRole: function deleteRole(rolename) {
	      return { url: '/roles/' + rolename };
	    },
	    loadMembers: function loadMembers(rolename) {
	      return { url: '/roles/' + rolename + '/members' };
	    }
	  },
	  SavedSearchesApiController: {
	    create: function create() {
	      return { url: '/search/saved' };
	    },
	    'delete': function _delete(savedSearchId) {
	      return { url: '/search/saved/' + savedSearchId };
	    },
	    update: function update(savedSearchId) {
	      return { url: '/search/saved/' + savedSearchId };
	    }
	  },
	  SessionsApiController: {
	    validate: function validate() {
	      return { url: '/system/sessions' };
	    }
	  },
	  StreamAlertsApiController: {
	    create: function create(streamId) {
	      return { url: '/streams/' + streamId + '/alerts/conditions' };
	    },
	    'delete': function _delete(streamId, alertConditionId) {
	      return { url: '/streams/' + streamId + '/alerts/conditions/' + alertConditionId };
	    },
	    list: function list(streamId) {
	      return { url: '/streams/' + streamId + '/alerts/conditions' };
	    },
	    update: function update(streamId, alertConditionId) {
	      return { url: '/streams/' + streamId + '/alerts/conditions/' + alertConditionId };
	    },
	    addReceiver: function addReceiver(streamId, type, entity) {
	      return { url: '/streams/' + streamId + '/alerts/receivers?entity=' + entity + '&type=' + type };
	    },
	    deleteReceiver: function deleteReceiver(streamId, type, entity) {
	      return { url: '/streams/' + streamId + '/alerts/receivers?entity=' + entity + '&type=' + type };
	    },
	    sendDummyAlert: function sendDummyAlert(streamId) {
	      return { url: '/streams/' + streamId + '/alerts/sendDummyAlert' };
	    }
	  },
	  StreamsApiController: {
	    get: function get(streamId) {
	      return { url: '/streams/' + streamId };
	    },
	    create: function create() {
	      return { url: '/streams' };
	    },
	    update: function update(streamId) {
	      return { url: '/streams/' + streamId };
	    },
	    cloneStream: function cloneStream(streamId) {
	      return { url: '/streams/' + streamId + '/clone' };
	    },
	    'delete': function _delete(streamId) {
	      return { url: '/streams/' + streamId };
	    },
	    pause: function pause(streamId) {
	      return { url: '/streams/' + streamId + '/pause' };
	    },
	    resume: function resume(streamId) {
	      return { url: '/streams/' + streamId + '/resume' };
	    },
	    testMatch: function testMatch(streamId) {
	      return { url: '/streams/' + streamId + '/testMatch' };
	    }
	  },
	  StreamOutputsApiController: {
	    add: function add(streamId) {
	      return { url: '/streams/' + streamId + '/outputs' };
	    },
	    index: function index(streamId) {
	      return { url: '/streams/' + streamId + '/outputs' };
	    },
	    'delete': function _delete(streamId, outputId) {
	      return { url: '/streams/' + streamId + '/outputs/' + outputId };
	    }
	  },
	  StreamRulesApiController: {
	    'delete': function _delete(streamId, streamRuleId) {
	      return { url: '/streams/' + streamId + '/rules/' + streamRuleId };
	    },
	    update: function update(streamId, streamRuleId) {
	      return { url: '/streams/' + streamId + '/rules/' + streamRuleId };
	    },
	    create: function create(streamId) {
	      return { url: '/streams/' + streamId + '/rules' };
	    }
	  },
	  SystemApiController: {
	    info: function info() {
	      return { url: '/system' };
	    },
	    jvm: function jvm() {
	      return { url: '/system/jvm' };
	    },
	    fields: function fields() {
	      return { url: '/system/fields' };
	    }
	  },
	  SystemJobsApiController: {
	    list: function list() {
	      return { url: '/cluster/jobs' };
	    },
	    getJob: function getJob(jobId) {
	      return { url: '/cluster/jobs/' + jobId };
	    },
	    cancelJob: function cancelJob(jobId) {
	      return { url: '/cluster/jobs/' + jobId };
	    }
	  },
	  SystemMessagesApiController: {
	    all: function all(page) {
	      return { url: '/system/messages?page=' + page };
	    }
	  },
	  ToolsApiController: {
	    grokTest: function grokTest() {
	      return { url: '/tools/grok_tester' };
	    },
	    jsonTest: function jsonTest() {
	      return { url: '/tools/json_tester' };
	    },
	    naturalDateTest: function naturalDateTest(text) {
	      return { url: '/tools/natural_date_tester?string=' + text };
	    },
	    regexTest: function regexTest() {
	      return { url: '/tools/regex_tester' };
	    },
	    regexReplaceTest: function regexReplaceTest() {
	      return { url: '/tools/regex_replace_tester' };
	    },
	    splitAndIndexTest: function splitAndIndexTest() {
	      return { url: '/tools/split_and_index_tester' };
	    },
	    substringTest: function substringTest() {
	      return { url: '/tools/substring_tester' };
	    }
	  },
	  UniversalSearchApiController: {
	    _streamFilter: function _streamFilter(streamId) {
	      return streamId ? { filter: 'streams:' + streamId } : {};
	    },
	    _buildBaseQueryString: function _buildBaseQueryString(query, timerange, streamId) {
	      var queryString = {};
	
	      var streamFilter = this._streamFilter(streamId);
	
	      queryString.query = query;
	      Object.keys(timerange).forEach(function (key) {
	        queryString[key] = timerange[key];
	      });
	      Object.keys(streamFilter).forEach(function (key) {
	        queryString[key] = streamFilter[key];
	      });
	
	      return queryString;
	    },
	    _buildUrl: function _buildUrl(url, queryString) {
	      return url + '?' + _qs2['default'].stringify(queryString);
	    },
	    search: function search(type, query, timerange, streamId, limit, offset, sortField, sortOrder, decorate) {
	      var url = '/search/universal/' + type;
	      var queryString = this._buildBaseQueryString(query, timerange, streamId);
	
	      if (limit) {
	        queryString.limit = limit;
	      }
	      if (offset) {
	        queryString.offset = offset;
	      }
	      if (sortField && sortOrder) {
	        queryString.sort = sortField + ':' + sortOrder;
	      }
	
	      if (decorate !== undefined) {
	        queryString.decorate = decorate;
	      }
	
	      return { url: this._buildUrl(url, queryString) };
	    },
	    'export': function _export(type, query, timerange, streamId, limit, offset, fields) {
	      var url = '/search/universal/' + type + '/export';
	      var queryString = this._buildBaseQueryString(query, timerange, streamId);
	
	      if (limit) {
	        queryString.limit = limit;
	      }
	      if (offset) {
	        queryString.offset = offset;
	      }
	
	      if (fields) {
	        queryString.fields = fields.join(',');
	      }
	
	      return { url: this._buildUrl(url, queryString) };
	    },
	    histogram: function histogram(type, query, resolution, timerange, streamId) {
	      var url = '/search/universal/' + type + '/histogram';
	      var queryString = this._buildBaseQueryString(query, timerange, streamId);
	      queryString.interval = resolution;
	
	      return { url: this._buildUrl(url, queryString) };
	    },
	    fieldHistogram: function fieldHistogram(type, query, field, resolution, timerange, streamId, includeCardinality) {
	      var url = '/search/universal/' + type + '/fieldhistogram';
	      var queryString = this._buildBaseQueryString(query, timerange, streamId);
	      queryString.interval = resolution;
	      queryString.field = field;
	      queryString.cardinality = includeCardinality;
	      return { url: this._buildUrl(url, queryString) };
	    },
	    fieldStats: function fieldStats(type, query, field, timerange, streamId) {
	      var url = '/search/universal/' + type + '/stats';
	      var queryString = this._buildBaseQueryString(query, timerange, streamId);
	      queryString.field = field;
	      return { url: this._buildUrl(url, queryString) };
	    },
	    fieldTerms: function fieldTerms(type, query, field, timerange, streamId) {
	      var url = '/search/universal/' + type + '/terms';
	      var queryString = this._buildBaseQueryString(query, timerange, streamId);
	      queryString.field = field;
	      return { url: this._buildUrl(url, queryString) };
	    }
	  },
	  UsageStatsApiController: {
	    pluginEnabled: function pluginEnabled() {
	      return { url: '/plugins/org.graylog.plugins.usagestatistics/config' };
	    },
	    setOptOutState: function setOptOutState() {
	      return { url: '/plugins/org.graylog.plugins.usagestatistics/opt-out' };
	    }
	  },
	  UsersApiController: {
	    changePassword: function changePassword(username) {
	      return { url: '/users/' + username + '/password' };
	    },
	    create: function create() {
	      return { url: '/users' };
	    },
	    list: function list() {
	      return { url: '/users' };
	    },
	    load: function load(username) {
	      return { url: '/users/' + username };
	    },
	    'delete': function _delete(username) {
	      return { url: '/users/' + username };
	    },
	    update: function update(username) {
	      return { url: '/users/' + username };
	    }
	  },
	  DashboardsController: {
	    show: function show(id) {
	      return { url: '/dashboards/' + id };
	    }
	  },
	  ExtractorsController: {
	    create: function create(inputId) {
	      return { url: '/system/inputs/' + inputId + '/extractors' };
	    },
	    'delete': function _delete(inputId, extractorId) {
	      return { url: '/system/inputs/' + inputId + '/extractors/' + extractorId };
	    },
	    order: function order(inputId) {
	      return { url: '/system/inputs/' + inputId + '/extractors/order' };
	    },
	    update: function update(inputId, extractorId) {
	      return { url: '/system/inputs/' + inputId + '/extractors/' + extractorId };
	    }
	  },
	  MessagesController: {
	    analyze: function analyze(index, string) {
	      return { url: '/messages/' + index + '/analyze?string=' + string };
	    },
	    parse: function parse() {
	      return { url: '/messages/parse' };
	    },
	    single: function single(index, messageId) {
	      return { url: '/messages/' + index + '/' + messageId };
	    }
	  },
	  ping: function ping() {
	    return { url: '/' };
	  }
	};
	
	exports['default'] = ApiRoutes;
	module.exports = exports['default'];

/***/ },
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 1.5.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function() {
	
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        VERSION = '1.5.6',
	        // internal storage for language config files
	        languages = {},
	        defaults = {
	            currentLanguage: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0'
	        },
	        options = {
	            currentLanguage: defaults.currentLanguage,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat
	        },
	        byteSuffixes = {
	            bytes: ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            iec: ['B','KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	
	    // Numeral prototype object
	    function Numeral(number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed (value, maxDecimals, roundingFunction, optionals) {
	        var splitValue = value.toString().split('.'),
	            minDecimals = maxDecimals - (optionals || 0),
	            boundedPrecision,
	            optionalsRegExp,
	            power,
	            output;
	
	        // Use the smallest precision value possible to avoid errors from floating point representation
	        if (splitValue.length === 2) {
	          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	        } else {
	          boundedPrecision = minDecimals;
	        }
	
	        power = Math.pow(10, boundedPrecision);
	
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(boundedPrecision);
	
	        if (optionals > maxDecimals - boundedPrecision) {
	            optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral(n, format, roundingFunction) {
	        var output;
	
	        if (n._value === 0 && options.zeroFormat !== null) {
	            output = options.zeroFormat;
	        } else if (n._value === null && options.nullFormat !== null) {
	            output = options.nullFormat;
	        } else {
	            // figure out what kind of format we are dealing with
	            if (format.indexOf('$') > -1) {
	                output = formatCurrency(n, format, roundingFunction);
	            } else if (format.indexOf('%') > -1) {
	                output = formatPercentage(n, format, roundingFunction);
	            } else if (format.indexOf(':') > -1) {
	                output = formatTime(n, format);
	            } else if (format.indexOf('b') > -1 || format.indexOf('ib') > -1) {
	                output = formatBytes(n, format, roundingFunction);
	            } else if (format.indexOf('o') > -1) {
	                output = formatOrdinal(n, format, roundingFunction);
	            } else {
	                output = formatNumber(n._value, format, roundingFunction);
	            }
	        }
	
	        return output;
	    }
	
	    function formatCurrency(n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction, false);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex) {
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[options.currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[options.currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[options.currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[options.currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatBytes(n, format, roundingFunction) {
	        var output,
	            suffixes = format.indexOf('ib') > -1 ? byteSuffixes.iec : byteSuffixes.bytes,
	            value = n._value,
	            suffix = '',
	            power,
	            min,
	            max;
	
	        // check for space before
	        if (format.indexOf(' b') > -1 || format.indexOf(' ib') > -1) {
	            suffix = ' ';
	            format = format.replace(' ib', '').replace(' b', '');
	        } else {
	            format = format.replace('ib', '').replace('b', '');
	        }
	
	        for (power = 0; power <= suffixes.length; power++) {
	            min = Math.pow(1024, power);
	            max = Math.pow(1024, power + 1);
	
	            if (value === null || value === 0 || value >= min && value < max) {
	                suffix += suffixes[power];
	
	                if (min > 0) {
	                    value = value / min;
	                }
	
	                break;
	            }
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        return output + suffix;
	    }
	
	    function formatOrdinal(n, format, roundingFunction) {
	        var output,
	            ordinal = '';
	
	        // check for space before
	        if (format.indexOf(' o') > -1) {
	            ordinal = ' ';
	            format = format.replace(' o', '');
	        } else {
	            format = format.replace('o', '');
	        }
	
	        ordinal += languages[options.currentLanguage].ordinal(n._value);
	
	        output = formatNumber(n._value, format, roundingFunction);
	
	        return output + ordinal;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
	            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
	
	        return hours + ':' + ((minutes < 10) ? '0' + minutes : minutes) + ':' + ((seconds < 10) ? '0' + seconds : seconds);
	    }
	
	    function formatNumber(value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false, // force abbreviation to thousands
	            abbrM = false, // force abbreviation to millions
	            abbrB = false, // force abbreviation to billions
	            abbrT = false, // force abbreviation to trillions
	            abbrForce = false, // force abbreviation
	            abs,
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        if (value === null) {
	            value = 0;
	        }
	
	        abs = Math.abs(value);
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	            }
	
	            format = format.replace(new RegExp(abbr + 'a[KMBT]?'), '');
	
	            if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                // trillion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.trillion;
	                value = value / Math.pow(10, 12);
	            } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                // billion
	                abbr = abbr + languages[options.currentLanguage].abbreviations.billion;
	                value = value / Math.pow(10, 9);
	            } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                // million
	                abbr = abbr + languages[options.currentLanguage].abbreviations.million;
	                value = value / Math.pow(10, 6);
	            } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                // thousand
	                abbr = abbr + languages[options.currentLanguage].abbreviations.thousand;
	                value = value / Math.pow(10, 3);
	            }
	        }
	
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        w = value.toString().split('.')[0];
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            if (precision.indexOf('[') > -1) {
	                precision = precision.replace(']', '');
	                precision = precision.split('[');
	                d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	            } else {
	                d = toFixed(value, precision.length, roundingFunction);
	            }
	
	            w = d.split('.')[0];
	
	            if (d.indexOf('.') > -1) {
	                d = languages[options.currentLanguage].delimiters.decimal + d.split('.')[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, null, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[options.currentLanguage].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        return ((negP && neg) ? '(' : '') + ((!negP && neg) ? '-' : '') + ((!neg && signed) ? '+' : '') + w + d + ((abbr) ? abbr : '') + ((negP && neg) ? ')' : '');
	    }
	
	
	    /************************************
	        Unformatting
	    ************************************/
	
	    // revert to number
	    function unformatNumeral(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power,
	            value;
	
	        if (string.indexOf(':') > -1) {
	            value = unformatTime(string);
	        } else {
	            if (string === options.zeroFormat || string === options.nullFormat) {
	                value = 0;
	            } else {
	                if (languages[options.currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(languages[options.currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[options.currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[options.currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power <= byteSuffixes.bytes.length; power++) {
	                    bytesMultiplier = ((string.indexOf(byteSuffixes.bytes[power]) > -1) || (string.indexOf(byteSuffixes.iec[power]) > -1))? Math.pow(1024, power) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                value = bytesMultiplier ? bytesMultiplier : 1;
	                value *= stringOriginal.match(thousandRegExp) ? Math.pow(10, 3) : 1;
	                value *= stringOriginal.match(millionRegExp) ? Math.pow(10, 6) : 1;
	                value *= stringOriginal.match(billionRegExp) ? Math.pow(10, 9) : 1;
	                value *= stringOriginal.match(trillionRegExp) ? Math.pow(10, 12) : 1;
	                // check for percentage
	                value *= string.indexOf('%') > -1 ? 0.01 : 1;
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	                // remove non numbers
	                value *= Number(string.replace(/[^0-9\.]+/g, ''));
	                // round if we are talking about bytes
	                value = bytesMultiplier ? Math.ceil(value) : value;
	            }
	        }
	
	        n._value = value;
	
	        return n._value;
	    }
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	            // minutes
	            seconds = seconds + (Number(timeArray[1]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + (Number(timeArray[0]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    numeral = function(input) {
	        if (numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (input === null) {
	            input = null;
	        } else if (!Number(input)) {
	            input = numeral.fn.unformat(input);
	        } else {
	            input = Number(input);
	        }
	
	        return new Numeral(input);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    numeral.language = function(key, values) {
	        if (!key) {
	            return options.currentLanguage;
	        }
	
	        key = key.toLowerCase();
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	
	            options.currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return numeral;
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    numeral.languageData = function(key) {
	        if (!key) {
	            return languages[options.currentLanguage];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            languageData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if ( !! val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.languageData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current language
	            languageData = numeral.languageData(culture);
	        } catch (e) {
	            languageData = numeral.languageData(numeral.language());
	        }
	
	        //setup the delimiters and currency symbol based on culture/language
	        _currSymbol = languageData.currency.symbol;
	        _abbrObj = languageData.abbreviations;
	        _decimalSep = languageData.delimiters.decimal;
	        if (languageData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = languageData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    // Production steps of ECMA-262, Edition 5, 15.4.4.21
	    // Reference: http://es5.github.io/#x15.4.4.21
	    if (!Array.prototype.reduce) {
	        Array.prototype.reduce = function(callback /*, initialValue*/) {
	            'use strict';
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(this), len = t.length >>> 0, k = 0, value;
	
	            if (arguments.length === 2) {
	                value = arguments[1];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        };
	    }
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function(prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	
	    numeral.fn = Numeral.prototype = {
	
	        clone: function() {
	            return numeral(this);
	        },
	
	        format: function (inputString, roundingFunction) {
	            return formatNumeral(this,
	                inputString ? inputString : options.defaultFormat,
	                roundingFunction !== undefined ? roundingFunction : Math.round
	            );
	        },
	
	        unformat: function (inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') {
	                return inputString;
	            }
	
	            return unformatNumeral(this, inputString ? inputString : options.defaultFormat);
	        },
	
	        value: function() {
	            return this._value;
	        },
	
	        valueOf: function() {
	            return this._value;
	        },
	
	        set: function(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) * (curr * corrFactor) /
	                    (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(this);


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(3);

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var PermissionsMixin = {
	  _isWildCard: function _isWildCard(permissionSet) {
	    return permissionSet.indexOf('*') > -1;
	  },
	
	  _permissionPredicate: function _permissionPredicate(permissionSet, p) {
	    if (p.split(':').length === 3) {
	      // eslint-disable-next-line prefer-template
	      return permissionSet.indexOf(p) > -1 || permissionSet.indexOf(p.split(':').slice(0, 2).join(':') + ':*') > -1;
	    }
	    return permissionSet.indexOf(p) > -1 || permissionSet.indexOf(p + ':*') > -1;
	  },
	
	  isPermitted: function isPermitted(permissionSet, permissions) {
	    var _this = this;
	
	    if (this._isWildCard(permissionSet)) {
	      return true;
	    }
	    if (permissions.every) {
	      return permissions.every(function (p) {
	        return _this._permissionPredicate(permissionSet, p);
	      });
	    }
	    return this._permissionPredicate(permissionSet, permissions);
	  },
	
	  isAnyPermitted: function isAnyPermitted(permissionSet, permissions) {
	    var _this2 = this;
	
	    if (this._isWildCard(permissionSet)) {
	      return true;
	    }
	    return permissions.some(function (p) {
	      return _this2._permissionPredicate(permissionSet, p);
	    });
	  }
	};
	
	exports['default'] = PermissionsMixin;
	module.exports = exports['default'];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(19);

/***/ },
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(596);

/***/ },
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _momentTimezone = __webpack_require__(1284);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _utilAppConfig = __webpack_require__(153);
	
	var _utilAppConfig2 = _interopRequireDefault(_utilAppConfig);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var CurrentUserStore = _injectionStoreProvider2['default'].getStore('CurrentUser');
	
	var currentUser = CurrentUserStore.get();
	CurrentUserStore.listen(function (state) {
	  return currentUser = state.currentUser;
	});
	
	var DateTime = (function () {
	  _createClass(DateTime, null, [{
	    key: 'ignoreTZ',
	    // Standard, but not really nice to read. Mostly used for machine communication
	
	    // Discards TZ information and treats date time as user's local. Helpful when getting a Javascript Date object
	    value: function ignoreTZ(dateTime) {
	      return new DateTime((0, _momentTimezone2['default'])(dateTime).format(DateTime.Formats.TIMESTAMP));
	    }
	
	    // Converts UTC without TZ information into user's local time
	  }, {
	    key: 'fromUTCDateTime',
	    value: function fromUTCDateTime(dateTime) {
	      return new DateTime(_momentTimezone2['default'].utc(dateTime));
	    }
	  }, {
	    key: '_cleanDateTimeString',
	    value: function _cleanDateTimeString(dateTimeString) {
	      if (dateTimeString instanceof String) {
	        return dateTimeString.trim();
	      }
	      return dateTimeString;
	    }
	  }, {
	    key: 'getAcceptedFormats',
	    value: function getAcceptedFormats() {
	      // First date format matching the date wins, so we order them by strictness
	      return [DateTime.Formats.ISO_8601, DateTime.Formats.TIMESTAMP_TZ, DateTime.Formats.DATETIME_TZ, DateTime.Formats.TIMESTAMP, DateTime.Formats.DATETIME, DateTime.Formats.COMPLETE, DateTime.Formats.DATE];
	    }
	
	    // Tries to parse the given string using `.getAcceptedFormats`
	  }, {
	    key: 'parseFromString',
	    value: function parseFromString(dateTimeString) {
	      var parsedDateTime = _momentTimezone2['default'].tz(DateTime._cleanDateTimeString(dateTimeString), DateTime.getAcceptedFormats(), true, DateTime.getUserTimezone());
	      if (!parsedDateTime.isValid()) {
	        throw new Error('Date time ' + dateTimeString + ' is not valid');
	      }
	
	      return new DateTime(parsedDateTime);
	    }
	  }, {
	    key: 'getUserTimezone',
	    value: function getUserTimezone() {
	      return currentUser ? currentUser.timezone : _utilAppConfig2['default'].rootTimeZone();
	    }
	  }, {
	    key: 'Formats',
	    get: function get() {
	      return {
	        DATE: 'YYYY-MM-DD',
	        DATETIME: 'YYYY-MM-DD HH:mm:ss', // Use to show local times when decimal second precision is not important
	        DATETIME_TZ: 'YYYY-MM-DD HH:mm:ss Z', // Use when decimal second precision is not important, but TZ is
	        TIMESTAMP: 'YYYY-MM-DD HH:mm:ss.SSS', // Use to show local times when decimal second precision is important (e.g. search results)
	        TIMESTAMP_TZ: 'YYYY-MM-DD HH:mm:ss.SSS Z', // Use to show times when decimal second precision is important, in a different TZ
	        COMPLETE: 'dddd D MMMM YYYY, HH:mm ZZ', // Easy to read date time, specially useful for graphs
	        ISO_8601: 'YYYY-MM-DDTHH:mm:ss.SSSZ' };
	    }
	  }]);
	
	  function DateTime(dateTime) {
	    _classCallCheck(this, DateTime);
	
	    if (!dateTime) {
	      this.dateTime = DateTime.now();
	      return;
	    }
	    // Always use user's local time
	    this.dateTime = _momentTimezone2['default'].tz(dateTime, DateTime.getUserTimezone());
	  }
	
	  _createClass(DateTime, [{
	    key: 'toBrowserLocalTime',
	
	    // Converts the DateTime to the user's browser local time
	    value: function toBrowserLocalTime() {
	      var localOffset = new Date().getTimezoneOffset();
	      this.dateTime.utcOffset(-localOffset);
	      return this;
	    }
	
	    // Changes the timezone of the DateTime
	  }, {
	    key: 'toTimeZone',
	    value: function toTimeZone(tz) {
	      this.dateTime.tz(tz);
	      return this;
	    }
	  }, {
	    key: 'toRelativeString',
	    value: function toRelativeString() {
	      return this.dateTime.fromNow();
	    }
	
	    // Returns internal moment object
	  }, {
	    key: 'toMoment',
	    value: function toMoment() {
	      return this.dateTime;
	    }
	
	    // Returns a Javascript Date object
	  }, {
	    key: 'toDate',
	    value: function toDate() {
	      return this.dateTime.toDate();
	    }
	
	    // Returns an ISO_8601 formatted string
	  }, {
	    key: 'toISOString',
	    value: function toISOString() {
	      return this.dateTime.toISOString();
	    }
	  }, {
	    key: 'toString',
	    value: function toString(format) {
	      var effectiveFormat = format;
	      if (format === undefined || format === null) {
	        if (this.dateTime.milliseconds() === 0) {
	          effectiveFormat = DateTime.Formats.DATETIME;
	        } else {
	          effectiveFormat = DateTime.Formats.TIMESTAMP;
	        }
	      }
	      return this.dateTime.format(effectiveFormat);
	    }
	  }], [{
	    key: 'now',
	    value: function now() {
	      return _momentTimezone2['default'].tz((0, _momentTimezone2['default'])(), DateTime.getUserTimezone());
	    }
	  }]);
	
	  return DateTime;
	})();
	
	exports['default'] = DateTime;
	module.exports = exports['default'];

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _numeral = __webpack_require__(21);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var NumberUtils = {
	  normalizeNumber: function normalizeNumber(number) {
	    switch (number) {
	      case 'NaN':
	        return NaN;
	      case 'Infinity':
	        return Number.MAX_VALUE;
	      case '-Infinity':
	        return Number.MIN_VALUE;
	      default:
	        return number;
	    }
	  },
	  normalizeGraphNumber: function normalizeGraphNumber(number) {
	    switch (number) {
	      case 'NaN':
	      case 'Infinity':
	      case '-Infinity':
	        return 0;
	      default:
	        return number;
	    }
	  },
	  formatNumber: function formatNumber(number) {
	    try {
	      return (0, _numeral2['default'])(this.normalizeNumber(number)).format('0,0.[00]');
	    } catch (e) {
	      return number;
	    }
	  },
	  formatPercentage: function formatPercentage(percentage) {
	    try {
	      return (0, _numeral2['default'])(this.normalizeNumber(percentage)).format('0.00%');
	    } catch (e) {
	      return percentage;
	    }
	  },
	  formatBytes: function formatBytes(number) {
	    _numeral2['default'].zeroFormat('0B');
	
	    var formattedNumber = undefined;
	    try {
	      formattedNumber = (0, _numeral2['default'])(this.normalizeNumber(number)).format('0.0b');
	    } catch (e) {
	      formattedNumber = number;
	    }
	
	    _numeral2['default'].zeroFormat(null);
	
	    return formattedNumber;
	  },
	  isNumber: function isNumber(possibleNumber) {
	    return possibleNumber !== '' && !isNaN(possibleNumber);
	  }
	};
	
	exports['default'] = NumberUtils;
	module.exports = exports['default'];

/***/ },
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  PluginManifest: __webpack_require__(1161),
	  PluginStore: __webpack_require__(1162),
	}


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _routingRoutes = __webpack_require__(11);
	
	var _routingRoutes2 = _interopRequireDefault(_routingRoutes);
	
	var ExtractorTypes = Object.freeze({
	  COPY_INPUT: 'copy_input',
	  GROK: 'grok',
	  JSON: 'json',
	  REGEX: 'regex',
	  REGEX_REPLACE: 'regex_replace',
	  SPLIT_AND_INDEX: 'split_and_index',
	  SUBSTRING: 'substring'
	});
	
	var ExtractorUtils = {
	  ConverterTypes: Object.freeze({
	    NUMERIC: 'numeric',
	    DATE: 'date',
	    HASH: 'hash',
	    SPLIT_AND_COUNT: 'split_and_count',
	    IP_ANONYMIZER: 'ip_anonymizer',
	    SYSLOG_PRI_LEVEL: 'syslog_pri_level',
	    SYSLOG_PRI_FACILITY: 'syslog_pri_facility',
	    TOKENIZER: 'tokenizer',
	    CSV: 'csv',
	    LOWERCASE: 'lowercase',
	    UPPERCASE: 'uppercase',
	    FLEXDATE: 'flexdate'
	  }),
	  ExtractorTypes: ExtractorTypes,
	  EXTRACTOR_TYPES: Object.keys(ExtractorTypes).map(function (type) {
	    return type.toLocaleLowerCase();
	  }),
	
	  getNewExtractorRoutes: function getNewExtractorRoutes(sourceNodeId, sourceInputId, fieldName, messageIndex, messageId) {
	    var routes = {};
	    this.EXTRACTOR_TYPES.forEach(function (extractorType) {
	      routes[extractorType] = _routingRoutes2['default'].new_extractor(sourceNodeId, sourceInputId, extractorType, fieldName, messageIndex, messageId);
	    });
	
	    return routes;
	  },
	
	  getReadableExtractorTypeName: function getReadableExtractorTypeName(extractorType) {
	    switch (extractorType) {
	      case ExtractorTypes.COPY_INPUT:
	        return 'Copy input';
	      case ExtractorTypes.GROK:
	        return 'Grok pattern';
	      case ExtractorTypes.JSON:
	        return 'JSON';
	      case ExtractorTypes.REGEX:
	        return 'Regular expression';
	      case ExtractorTypes.REGEX_REPLACE:
	        return 'Replace with regular expression';
	      case ExtractorTypes.SPLIT_AND_INDEX:
	        return 'Split & Index';
	      case ExtractorTypes.SUBSTRING:
	        return 'Substring';
	      default:
	        return extractorType;
	    }
	  },
	
	  getReadableConverterTypeName: function getReadableConverterTypeName(converterType) {
	    switch (converterType) {
	      case this.ConverterTypes.NUMERIC:
	        return 'Numeric';
	      case this.ConverterTypes.DATE:
	        return 'Date';
	      case this.ConverterTypes.FLEXDATE:
	        return 'Flexible Date';
	      case this.ConverterTypes.HASH:
	        return 'Hash';
	      case this.ConverterTypes.LOWERCASE:
	        return 'Lowercase';
	      case this.ConverterTypes.UPPERCASE:
	        return 'Uppercase';
	      case this.ConverterTypes.TOKENIZER:
	        return 'Key = Value Pairs To Fields';
	      case this.ConverterTypes.CSV:
	        return 'CSV To Fields';
	      case this.ConverterTypes.SPLIT_AND_COUNT:
	        return 'Split & Count';
	      case this.ConverterTypes.IP_ANONYMIZER:
	        return 'Anonymize IPv4 Addresses';
	      case this.ConverterTypes.SYSLOG_PRI_LEVEL:
	        return 'Syslog Level From PRI';
	      case this.ConverterTypes.SYSLOG_PRI_FACILITY:
	        return 'Syslog Facility From PRI';
	      default:
	        return converterType;
	    }
	  },
	
	  getEffectiveConfiguration: function getEffectiveConfiguration(defaultConfiguration, currentConfiguration) {
	    var effectiveConfiguration = {};
	
	    for (var key in defaultConfiguration) {
	      if (defaultConfiguration.hasOwnProperty(key)) {
	        effectiveConfiguration[key] = defaultConfiguration[key];
	      }
	    }
	
	    for (var key in currentConfiguration) {
	      if (currentConfiguration.hasOwnProperty(key)) {
	        effectiveConfiguration[key] = currentConfiguration[key];
	      }
	    }
	
	    return effectiveConfiguration;
	  }
	};
	
	exports['default'] = ExtractorUtils;
	module.exports = exports['default'];

/***/ },
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var StringUtils = {
	  tempDocument: document.createElement('textarea'),
	  capitalizeFirstLetter: function capitalizeFirstLetter(text) {
	    return text.charAt(0).toUpperCase() + text.slice(1);
	  },
	  escapeHTML: function escapeHTML(text) {
	    this.tempDocument.textContent = text;
	    return this.tempDocument.innerHTML;
	  },
	  unescapeHTML: function unescapeHTML(text) {
	    this.tempDocument.innerHTML = text;
	    return this.tempDocument.textContent;
	  },
	  pluralize: function pluralize(number, singular, plural) {
	    return number === 1 || number === '1' ? singular : plural;
	  }
	};
	
	exports['default'] = StringUtils;
	module.exports = exports['default'];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(586);

/***/ },
/* 48 */,
/* 49 */,
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.1";
	
	} ) );


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 *
	 * Version: 1.18.4
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory(__webpack_require__(639), __webpack_require__(637), __webpack_require__(638));
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(639), __webpack_require__(637), __webpack_require__(638)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
	  }
	}(this, function (punycode, IPv6, SLD, root) {
	  'use strict';
	  /*global location, escape, unescape */
	  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
	  /*jshint camelcase: false */
	
	  // save current URI variable, if any
	  var _URI = root && root.URI;
	
	  function URI(url, base) {
	    var _urlSupplied = arguments.length >= 1;
	    var _baseSupplied = arguments.length >= 2;
	
	    // Allow instantiation without the 'new' keyword
	    if (!(this instanceof URI)) {
	      if (_urlSupplied) {
	        if (_baseSupplied) {
	          return new URI(url, base);
	        }
	
	        return new URI(url);
	      }
	
	      return new URI();
	    }
	
	    if (url === undefined) {
	      if (_urlSupplied) {
	        throw new TypeError('undefined is not a valid argument for URI');
	      }
	
	      if (typeof location !== 'undefined') {
	        url = location.href + '';
	      } else {
	        url = '';
	      }
	    }
	
	    this.href(url);
	
	    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
	    if (base !== undefined) {
	      return this.absoluteTo(base);
	    }
	
	    return this;
	  }
	
	  URI.version = '1.18.4';
	
	  var p = URI.prototype;
	  var hasOwn = Object.prototype.hasOwnProperty;
	
	  function escapeRegEx(string) {
	    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
	    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
	  }
	
	  function getType(value) {
	    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
	    if (value === undefined) {
	      return 'Undefined';
	    }
	
	    return String(Object.prototype.toString.call(value)).slice(8, -1);
	  }
	
	  function isArray(obj) {
	    return getType(obj) === 'Array';
	  }
	
	  function filterArrayValues(data, value) {
	    var lookup = {};
	    var i, length;
	
	    if (getType(value) === 'RegExp') {
	      lookup = null;
	    } else if (isArray(value)) {
	      for (i = 0, length = value.length; i < length; i++) {
	        lookup[value[i]] = true;
	      }
	    } else {
	      lookup[value] = true;
	    }
	
	    for (i = 0, length = data.length; i < length; i++) {
	      /*jshint laxbreak: true */
	      var _match = lookup && lookup[data[i]] !== undefined
	        || !lookup && value.test(data[i]);
	      /*jshint laxbreak: false */
	      if (_match) {
	        data.splice(i, 1);
	        length--;
	        i--;
	      }
	    }
	
	    return data;
	  }
	
	  function arrayContains(list, value) {
	    var i, length;
	
	    // value may be string, number, array, regexp
	    if (isArray(value)) {
	      // Note: this can be optimized to O(n) (instead of current O(m * n))
	      for (i = 0, length = value.length; i < length; i++) {
	        if (!arrayContains(list, value[i])) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    var _type = getType(value);
	    for (i = 0, length = list.length; i < length; i++) {
	      if (_type === 'RegExp') {
	        if (typeof list[i] === 'string' && list[i].match(value)) {
	          return true;
	        }
	      } else if (list[i] === value) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function arraysEqual(one, two) {
	    if (!isArray(one) || !isArray(two)) {
	      return false;
	    }
	
	    // arrays can't be equal if they have different amount of content
	    if (one.length !== two.length) {
	      return false;
	    }
	
	    one.sort();
	    two.sort();
	
	    for (var i = 0, l = one.length; i < l; i++) {
	      if (one[i] !== two[i]) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  function trimSlashes(text) {
	    var trim_expression = /^\/+|\/+$/g;
	    return text.replace(trim_expression, '');
	  }
	
	  URI._parts = function() {
	    return {
	      protocol: null,
	      username: null,
	      password: null,
	      hostname: null,
	      urn: null,
	      port: null,
	      path: null,
	      query: null,
	      fragment: null,
	      // state
	      duplicateQueryParameters: URI.duplicateQueryParameters,
	      escapeQuerySpace: URI.escapeQuerySpace
	    };
	  };
	  // state: allow duplicate query parameters (a=1&a=1)
	  URI.duplicateQueryParameters = false;
	  // state: replaces + with %20 (space in query strings)
	  URI.escapeQuerySpace = true;
	  // static properties
	  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
	  URI.idn_expression = /[^a-z0-9\.-]/i;
	  URI.punycode_expression = /(xn--)/i;
	  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
	  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
	  // credits to Rich Brown
	  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
	  // specification: http://www.ietf.org/rfc/rfc4291.txt
	  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
	  // expression used is "gruber revised" (@gruber v2) determined to be the
	  // best solution in a regex-golf we did a couple of ages ago at
	  // * http://mathiasbynens.be/demo/url-regex
	  // * http://rodneyrehm.de/t/url-regex.html
	  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
	  URI.findUri = {
	    // valid "scheme://" or "www."
	    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
	    // everything up to the next whitespace
	    end: /[\s\r\n]|$/,
	    // trim trailing punctuation captured by end RegExp
	    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
	    // balanced parens inclusion (), [], {}, <>
	    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
	  };
	  // http://www.iana.org/assignments/uri-schemes.html
	  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
	  URI.defaultPorts = {
	    http: '80',
	    https: '443',
	    ftp: '21',
	    gopher: '70',
	    ws: '80',
	    wss: '443'
	  };
	  // allowed hostname characters according to RFC 3986
	  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
	  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . -
	  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.-]/;
	  // map DOM Elements to their URI attribute
	  URI.domAttributes = {
	    'a': 'href',
	    'blockquote': 'cite',
	    'link': 'href',
	    'base': 'href',
	    'script': 'src',
	    'form': 'action',
	    'img': 'src',
	    'area': 'href',
	    'iframe': 'src',
	    'embed': 'src',
	    'source': 'src',
	    'track': 'src',
	    'input': 'src', // but only if type="image"
	    'audio': 'src',
	    'video': 'src'
	  };
	  URI.getDomAttribute = function(node) {
	    if (!node || !node.nodeName) {
	      return undefined;
	    }
	
	    var nodeName = node.nodeName.toLowerCase();
	    // <input> should only expose src for type="image"
	    if (nodeName === 'input' && node.type !== 'image') {
	      return undefined;
	    }
	
	    return URI.domAttributes[nodeName];
	  };
	
	  function escapeForDumbFirefox36(value) {
	    // https://github.com/medialize/URI.js/issues/91
	    return escape(value);
	  }
	
	  // encoding / decoding according to RFC3986
	  function strictEncodeURIComponent(string) {
	    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
	    return encodeURIComponent(string)
	      .replace(/[!'()*]/g, escapeForDumbFirefox36)
	      .replace(/\*/g, '%2A');
	  }
	  URI.encode = strictEncodeURIComponent;
	  URI.decode = decodeURIComponent;
	  URI.iso8859 = function() {
	    URI.encode = escape;
	    URI.decode = unescape;
	  };
	  URI.unicode = function() {
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = decodeURIComponent;
	  };
	  URI.characters = {
	    pathname: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
	        map: {
	          // -._~!'()*
	          '%24': '$',
	          '%26': '&',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%3A': ':',
	          '%40': '@'
	        }
	      },
	      decode: {
	        expression: /[\/\?#]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23'
	        }
	      }
	    },
	    reserved: {
	      encode: {
	        // RFC3986 2.1: For consistency, URI producers and normalizers should
	        // use uppercase hexadecimal digits for all percent-encodings.
	        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
	        map: {
	          // gen-delims
	          '%3A': ':',
	          '%2F': '/',
	          '%3F': '?',
	          '%23': '#',
	          '%5B': '[',
	          '%5D': ']',
	          '%40': '@',
	          // sub-delims
	          '%21': '!',
	          '%24': '$',
	          '%26': '&',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '='
	        }
	      }
	    },
	    urnpath: {
	      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
	      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
	      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
	      // note that the colon character is not featured in the encoding map; this is because URI.js
	      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
	      // should not appear unencoded in a segment itself.
	      // See also the note above about RFC3986 and capitalalized hex digits.
	      encode: {
	        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
	        map: {
	          '%21': '!',
	          '%24': '$',
	          '%27': '\'',
	          '%28': '(',
	          '%29': ')',
	          '%2A': '*',
	          '%2B': '+',
	          '%2C': ',',
	          '%3B': ';',
	          '%3D': '=',
	          '%40': '@'
	        }
	      },
	      // These characters are the characters called out by RFC2141 as "reserved" characters that
	      // should never appear in a URN, plus the colon character (see note above).
	      decode: {
	        expression: /[\/\?#:]/g,
	        map: {
	          '/': '%2F',
	          '?': '%3F',
	          '#': '%23',
	          ':': '%3A'
	        }
	      }
	    }
	  };
	  URI.encodeQuery = function(string, escapeQuerySpace) {
	    var escaped = URI.encode(string + '');
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
	  };
	  URI.decodeQuery = function(string, escapeQuerySpace) {
	    string += '';
	    if (escapeQuerySpace === undefined) {
	      escapeQuerySpace = URI.escapeQuerySpace;
	    }
	
	    try {
	      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
	    } catch(e) {
	      // we're not going to mess with weird encodings,
	      // give up and return the undecoded original string
	      // see https://github.com/medialize/URI.js/issues/87
	      // see https://github.com/medialize/URI.js/issues/92
	      return string;
	    }
	  };
	  // generate encode/decode path functions
	  var _parts = {'encode':'encode', 'decode':'decode'};
	  var _part;
	  var generateAccessor = function(_group, _part) {
	    return function(string) {
	      try {
	        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
	          return URI.characters[_group][_part].map[c];
	        });
	      } catch (e) {
	        // we're not going to mess with weird encodings,
	        // give up and return the undecoded original string
	        // see https://github.com/medialize/URI.js/issues/87
	        // see https://github.com/medialize/URI.js/issues/92
	        return string;
	      }
	    };
	  };
	
	  for (_part in _parts) {
	    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
	    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
	  }
	
	  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
	    return function(string) {
	      // Why pass in names of functions, rather than the function objects themselves? The
	      // definitions of some functions (but in particular, URI.decode) will occasionally change due
	      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
	      // that the functions we use here are "fresh".
	      var actualCodingFunc;
	      if (!_innerCodingFuncName) {
	        actualCodingFunc = URI[_codingFuncName];
	      } else {
	        actualCodingFunc = function(string) {
	          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
	        };
	      }
	
	      var segments = (string + '').split(_sep);
	
	      for (var i = 0, length = segments.length; i < length; i++) {
	        segments[i] = actualCodingFunc(segments[i]);
	      }
	
	      return segments.join(_sep);
	    };
	  };
	
	  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
	  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
	  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
	  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
	  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
	
	  URI.encodeReserved = generateAccessor('reserved', 'encode');
	
	  URI.parse = function(string, parts) {
	    var pos;
	    if (!parts) {
	      parts = {};
	    }
	    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
	
	    // extract fragment
	    pos = string.indexOf('#');
	    if (pos > -1) {
	      // escaping?
	      parts.fragment = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract query
	    pos = string.indexOf('?');
	    if (pos > -1) {
	      // escaping?
	      parts.query = string.substring(pos + 1) || null;
	      string = string.substring(0, pos);
	    }
	
	    // extract protocol
	    if (string.substring(0, 2) === '//') {
	      // relative-scheme
	      parts.protocol = null;
	      string = string.substring(2);
	      // extract "user:pass@host:port"
	      string = URI.parseAuthority(string, parts);
	    } else {
	      pos = string.indexOf(':');
	      if (pos > -1) {
	        parts.protocol = string.substring(0, pos) || null;
	        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
	          // : may be within the path
	          parts.protocol = undefined;
	        } else if (string.substring(pos + 1, pos + 3) === '//') {
	          string = string.substring(pos + 3);
	
	          // extract "user:pass@host:port"
	          string = URI.parseAuthority(string, parts);
	        } else {
	          string = string.substring(pos + 1);
	          parts.urn = true;
	        }
	      }
	    }
	
	    // what's left must be the path
	    parts.path = string;
	
	    // and we're done
	    return parts;
	  };
	  URI.parseHost = function(string, parts) {
	    // Copy chrome, IE, opera backslash-handling behavior.
	    // Back slashes before the query string get converted to forward slashes
	    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
	    // See: https://code.google.com/p/chromium/issues/detail?id=25916
	    // https://github.com/medialize/URI.js/pull/233
	    string = string.replace(/\\/g, '/');
	
	    // extract host:port
	    var pos = string.indexOf('/');
	    var bracketPos;
	    var t;
	
	    if (pos === -1) {
	      pos = string.length;
	    }
	
	    if (string.charAt(0) === '[') {
	      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
	      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
	      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
	      bracketPos = string.indexOf(']');
	      parts.hostname = string.substring(1, bracketPos) || null;
	      parts.port = string.substring(bracketPos + 2, pos) || null;
	      if (parts.port === '/') {
	        parts.port = null;
	      }
	    } else {
	      var firstColon = string.indexOf(':');
	      var firstSlash = string.indexOf('/');
	      var nextColon = string.indexOf(':', firstColon + 1);
	      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
	        // IPv6 host contains multiple colons - but no port
	        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
	        parts.hostname = string.substring(0, pos) || null;
	        parts.port = null;
	      } else {
	        t = string.substring(0, pos).split(':');
	        parts.hostname = t[0] || null;
	        parts.port = t[1] || null;
	      }
	    }
	
	    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
	      pos++;
	      string = '/' + string;
	    }
	
	    return string.substring(pos) || '/';
	  };
	  URI.parseAuthority = function(string, parts) {
	    string = URI.parseUserinfo(string, parts);
	    return URI.parseHost(string, parts);
	  };
	  URI.parseUserinfo = function(string, parts) {
	    // extract username:password
	    var firstSlash = string.indexOf('/');
	    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
	    var t;
	
	    // authority@ must come before /path
	    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
	      t = string.substring(0, pos).split(':');
	      parts.username = t[0] ? URI.decode(t[0]) : null;
	      t.shift();
	      parts.password = t[0] ? URI.decode(t.join(':')) : null;
	      string = string.substring(pos + 1);
	    } else {
	      parts.username = null;
	      parts.password = null;
	    }
	
	    return string;
	  };
	  URI.parseQuery = function(string, escapeQuerySpace) {
	    if (!string) {
	      return {};
	    }
	
	    // throw out the funky business - "?"[name"="value"&"]+
	    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
	
	    if (!string) {
	      return {};
	    }
	
	    var items = {};
	    var splits = string.split('&');
	    var length = splits.length;
	    var v, name, value;
	
	    for (var i = 0; i < length; i++) {
	      v = splits[i].split('=');
	      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
	      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
	      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
	
	      if (hasOwn.call(items, name)) {
	        if (typeof items[name] === 'string' || items[name] === null) {
	          items[name] = [items[name]];
	        }
	
	        items[name].push(value);
	      } else {
	        items[name] = value;
	      }
	    }
	
	    return items;
	  };
	
	  URI.build = function(parts) {
	    var t = '';
	
	    if (parts.protocol) {
	      t += parts.protocol + ':';
	    }
	
	    if (!parts.urn && (t || parts.hostname)) {
	      t += '//';
	    }
	
	    t += (URI.buildAuthority(parts) || '');
	
	    if (typeof parts.path === 'string') {
	      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
	        t += '/';
	      }
	
	      t += parts.path;
	    }
	
	    if (typeof parts.query === 'string' && parts.query) {
	      t += '?' + parts.query;
	    }
	
	    if (typeof parts.fragment === 'string' && parts.fragment) {
	      t += '#' + parts.fragment;
	    }
	    return t;
	  };
	  URI.buildHost = function(parts) {
	    var t = '';
	
	    if (!parts.hostname) {
	      return '';
	    } else if (URI.ip6_expression.test(parts.hostname)) {
	      t += '[' + parts.hostname + ']';
	    } else {
	      t += parts.hostname;
	    }
	
	    if (parts.port) {
	      t += ':' + parts.port;
	    }
	
	    return t;
	  };
	  URI.buildAuthority = function(parts) {
	    return URI.buildUserinfo(parts) + URI.buildHost(parts);
	  };
	  URI.buildUserinfo = function(parts) {
	    var t = '';
	
	    if (parts.username) {
	      t += URI.encode(parts.username);
	    }
	
	    if (parts.password) {
	      t += ':' + URI.encode(parts.password);
	    }
	
	    if (t) {
	      t += '@';
	    }
	
	    return t;
	  };
	  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
	    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
	    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
	    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
	    // URI.js treats the query string as being application/x-www-form-urlencoded
	    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
	
	    var t = '';
	    var unique, key, i, length;
	    for (key in data) {
	      if (hasOwn.call(data, key) && key) {
	        if (isArray(data[key])) {
	          unique = {};
	          for (i = 0, length = data[key].length; i < length; i++) {
	            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
	              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
	              if (duplicateQueryParameters !== true) {
	                unique[data[key][i] + ''] = true;
	              }
	            }
	          }
	        } else if (data[key] !== undefined) {
	          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
	        }
	      }
	    }
	
	    return t.substring(1);
	  };
	  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
	    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
	    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
	    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
	  };
	
	  URI.addQuery = function(data, name, value) {
	    if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.addQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (data[name] === undefined) {
	        data[name] = value;
	        return;
	      } else if (typeof data[name] === 'string') {
	        data[name] = [data[name]];
	      }
	
	      if (!isArray(value)) {
	        value = [value];
	      }
	
	      data[name] = (data[name] || []).concat(value);
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	  };
	  URI.removeQuery = function(data, name, value) {
	    var i, length, key;
	
	    if (isArray(name)) {
	      for (i = 0, length = name.length; i < length; i++) {
	        data[name[i]] = undefined;
	      }
	    } else if (getType(name) === 'RegExp') {
	      for (key in data) {
	        if (name.test(key)) {
	          data[key] = undefined;
	        }
	      }
	    } else if (typeof name === 'object') {
	      for (key in name) {
	        if (hasOwn.call(name, key)) {
	          URI.removeQuery(data, key, name[key]);
	        }
	      }
	    } else if (typeof name === 'string') {
	      if (value !== undefined) {
	        if (getType(value) === 'RegExp') {
	          if (!isArray(data[name]) && value.test(data[name])) {
	            data[name] = undefined;
	          } else {
	            data[name] = filterArrayValues(data[name], value);
	          }
	        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
	          data[name] = undefined;
	        } else if (isArray(data[name])) {
	          data[name] = filterArrayValues(data[name], value);
	        }
	      } else {
	        data[name] = undefined;
	      }
	    } else {
	      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
	    }
	  };
	  URI.hasQuery = function(data, name, value, withinArray) {
	    switch (getType(name)) {
	      case 'String':
	        // Nothing to do here
	        break;
	
	      case 'RegExp':
	        for (var key in data) {
	          if (hasOwn.call(data, key)) {
	            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
	              return true;
	            }
	          }
	        }
	
	        return false;
	
	      case 'Object':
	        for (var _key in name) {
	          if (hasOwn.call(name, _key)) {
	            if (!URI.hasQuery(data, _key, name[_key])) {
	              return false;
	            }
	          }
	        }
	
	        return true;
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
	    }
	
	    switch (getType(value)) {
	      case 'Undefined':
	        // true if exists (but may be empty)
	        return name in data; // data[name] !== undefined;
	
	      case 'Boolean':
	        // true if exists and non-empty
	        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
	        return value === _booly;
	
	      case 'Function':
	        // allow complex comparison
	        return !!value(data[name], name, data);
	
	      case 'Array':
	        if (!isArray(data[name])) {
	          return false;
	        }
	
	        var op = withinArray ? arrayContains : arraysEqual;
	        return op(data[name], value);
	
	      case 'RegExp':
	        if (!isArray(data[name])) {
	          return Boolean(data[name] && data[name].match(value));
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      case 'Number':
	        value = String(value);
	        /* falls through */
	      case 'String':
	        if (!isArray(data[name])) {
	          return data[name] === value;
	        }
	
	        if (!withinArray) {
	          return false;
	        }
	
	        return arrayContains(data[name], value);
	
	      default:
	        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
	    }
	  };
	
	
	  URI.joinPaths = function() {
	    var input = [];
	    var segments = [];
	    var nonEmptySegments = 0;
	
	    for (var i = 0; i < arguments.length; i++) {
	      var url = new URI(arguments[i]);
	      input.push(url);
	      var _segments = url.segment();
	      for (var s = 0; s < _segments.length; s++) {
	        if (typeof _segments[s] === 'string') {
	          segments.push(_segments[s]);
	        }
	
	        if (_segments[s]) {
	          nonEmptySegments++;
	        }
	      }
	    }
	
	    if (!segments.length || !nonEmptySegments) {
	      return new URI('');
	    }
	
	    var uri = new URI('').segment(segments);
	
	    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
	      uri.path('/' + uri.path());
	    }
	
	    return uri.normalize();
	  };
	
	  URI.commonPath = function(one, two) {
	    var length = Math.min(one.length, two.length);
	    var pos;
	
	    // find first non-matching character
	    for (pos = 0; pos < length; pos++) {
	      if (one.charAt(pos) !== two.charAt(pos)) {
	        pos--;
	        break;
	      }
	    }
	
	    if (pos < 1) {
	      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
	    }
	
	    // revert to last /
	    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
	      pos = one.substring(0, pos).lastIndexOf('/');
	    }
	
	    return one.substring(0, pos + 1);
	  };
	
	  URI.withinString = function(string, callback, options) {
	    options || (options = {});
	    var _start = options.start || URI.findUri.start;
	    var _end = options.end || URI.findUri.end;
	    var _trim = options.trim || URI.findUri.trim;
	    var _parens = options.parens || URI.findUri.parens;
	    var _attributeOpen = /[a-z0-9-]=["']?$/i;
	
	    _start.lastIndex = 0;
	    while (true) {
	      var match = _start.exec(string);
	      if (!match) {
	        break;
	      }
	
	      var start = match.index;
	      if (options.ignoreHtml) {
	        // attribut(e=["']?$)
	        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
	        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
	          continue;
	        }
	      }
	
	      var end = start + string.slice(start).search(_end);
	      var slice = string.slice(start, end);
	      // make sure we include well balanced parens
	      var parensEnd = -1;
	      while (true) {
	        var parensMatch = _parens.exec(slice);
	        if (!parensMatch) {
	          break;
	        }
	
	        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
	        parensEnd = Math.max(parensEnd, parensMatchEnd);
	      }
	
	      if (parensEnd > -1) {
	        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd + 1).replace(_trim, '');
	      } else {
	        slice = slice.replace(_trim, '');
	      }
	
	      if (options.ignore && options.ignore.test(slice)) {
	        continue;
	      }
	
	      end = start + slice.length;
	      var result = callback(slice, start, end, string);
	      if (result === undefined) {
	        _start.lastIndex = end;
	        continue;
	      }
	
	      result = String(result);
	      string = string.slice(0, start) + result + string.slice(end);
	      _start.lastIndex = start + result.length;
	    }
	
	    _start.lastIndex = 0;
	    return string;
	  };
	
	  URI.ensureValidHostname = function(v) {
	    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
	    // they are not part of DNS and therefore ignored by URI.js
	
	    if (v.match(URI.invalid_hostname_characters)) {
	      // test punycode
	      if (!punycode) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-] and Punycode.js is not available');
	      }
	
	      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	    }
	  };
	
	  // noConflict
	  URI.noConflict = function(removeAll) {
	    if (removeAll) {
	      var unconflicted = {
	        URI: this.noConflict()
	      };
	
	      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
	        unconflicted.URITemplate = root.URITemplate.noConflict();
	      }
	
	      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
	        unconflicted.IPv6 = root.IPv6.noConflict();
	      }
	
	      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
	        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
	      }
	
	      return unconflicted;
	    } else if (root.URI === this) {
	      root.URI = _URI;
	    }
	
	    return this;
	  };
	
	  p.build = function(deferBuild) {
	    if (deferBuild === true) {
	      this._deferred_build = true;
	    } else if (deferBuild === undefined || this._deferred_build) {
	      this._string = URI.build(this._parts);
	      this._deferred_build = false;
	    }
	
	    return this;
	  };
	
	  p.clone = function() {
	    return new URI(this);
	  };
	
	  p.valueOf = p.toString = function() {
	    return this.build(false)._string;
	  };
	
	
	  function generateSimpleAccessor(_part){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        this._parts[_part] = v || null;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  function generatePrefixAccessor(_part, _key){
	    return function(v, build) {
	      if (v === undefined) {
	        return this._parts[_part] || '';
	      } else {
	        if (v !== null) {
	          v = v + '';
	          if (v.charAt(0) === _key) {
	            v = v.substring(1);
	          }
	        }
	
	        this._parts[_part] = v;
	        this.build(!build);
	        return this;
	      }
	    };
	  }
	
	  p.protocol = generateSimpleAccessor('protocol');
	  p.username = generateSimpleAccessor('username');
	  p.password = generateSimpleAccessor('password');
	  p.hostname = generateSimpleAccessor('hostname');
	  p.port = generateSimpleAccessor('port');
	  p.query = generatePrefixAccessor('query', '?');
	  p.fragment = generatePrefixAccessor('fragment', '#');
	
	  p.search = function(v, build) {
	    var t = this.query(v, build);
	    return typeof t === 'string' && t.length ? ('?' + t) : t;
	  };
	  p.hash = function(v, build) {
	    var t = this.fragment(v, build);
	    return typeof t === 'string' && t.length ? ('#' + t) : t;
	  };
	
	  p.pathname = function(v, build) {
	    if (v === undefined || v === true) {
	      var res = this._parts.path || (this._parts.hostname ? '/' : '');
	      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
	    } else {
	      if (this._parts.urn) {
	        this._parts.path = v ? URI.recodeUrnPath(v) : '';
	      } else {
	        this._parts.path = v ? URI.recodePath(v) : '/';
	      }
	      this.build(!build);
	      return this;
	    }
	  };
	  p.path = p.pathname;
	  p.href = function(href, build) {
	    var key;
	
	    if (href === undefined) {
	      return this.toString();
	    }
	
	    this._string = '';
	    this._parts = URI._parts();
	
	    var _URI = href instanceof URI;
	    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
	    if (href.nodeName) {
	      var attribute = URI.getDomAttribute(href);
	      href = href[attribute] || '';
	      _object = false;
	    }
	
	    // window.location is reported to be an object, but it's not the sort
	    // of object we're looking for:
	    // * location.protocol ends with a colon
	    // * location.query != object.search
	    // * location.hash != object.fragment
	    // simply serializing the unknown object should do the trick
	    // (for location, not for everything...)
	    if (!_URI && _object && href.pathname !== undefined) {
	      href = href.toString();
	    }
	
	    if (typeof href === 'string' || href instanceof String) {
	      this._parts = URI.parse(String(href), this._parts);
	    } else if (_URI || _object) {
	      var src = _URI ? href._parts : href;
	      for (key in src) {
	        if (hasOwn.call(this._parts, key)) {
	          this._parts[key] = src[key];
	        }
	      }
	    } else {
	      throw new TypeError('invalid input');
	    }
	
	    this.build(!build);
	    return this;
	  };
	
	  // identification accessors
	  p.is = function(what) {
	    var ip = false;
	    var ip4 = false;
	    var ip6 = false;
	    var name = false;
	    var sld = false;
	    var idn = false;
	    var punycode = false;
	    var relative = !this._parts.urn;
	
	    if (this._parts.hostname) {
	      relative = false;
	      ip4 = URI.ip4_expression.test(this._parts.hostname);
	      ip6 = URI.ip6_expression.test(this._parts.hostname);
	      ip = ip4 || ip6;
	      name = !ip;
	      sld = name && SLD && SLD.has(this._parts.hostname);
	      idn = name && URI.idn_expression.test(this._parts.hostname);
	      punycode = name && URI.punycode_expression.test(this._parts.hostname);
	    }
	
	    switch (what.toLowerCase()) {
	      case 'relative':
	        return relative;
	
	      case 'absolute':
	        return !relative;
	
	      // hostname identification
	      case 'domain':
	      case 'name':
	        return name;
	
	      case 'sld':
	        return sld;
	
	      case 'ip':
	        return ip;
	
	      case 'ip4':
	      case 'ipv4':
	      case 'inet4':
	        return ip4;
	
	      case 'ip6':
	      case 'ipv6':
	      case 'inet6':
	        return ip6;
	
	      case 'idn':
	        return idn;
	
	      case 'url':
	        return !this._parts.urn;
	
	      case 'urn':
	        return !!this._parts.urn;
	
	      case 'punycode':
	        return punycode;
	    }
	
	    return null;
	  };
	
	  // component specific input validation
	  var _protocol = p.protocol;
	  var _port = p.port;
	  var _hostname = p.hostname;
	
	  p.protocol = function(v, build) {
	    if (v !== undefined) {
	      if (v) {
	        // accept trailing ://
	        v = v.replace(/:(\/\/)?$/, '');
	
	        if (!v.match(URI.protocol_expression)) {
	          throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
	        }
	      }
	    }
	    return _protocol.call(this, v, build);
	  };
	  p.scheme = p.protocol;
	  p.port = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      if (v === 0) {
	        v = null;
	      }
	
	      if (v) {
	        v += '';
	        if (v.charAt(0) === ':') {
	          v = v.substring(1);
	        }
	
	        if (v.match(/[^0-9]/)) {
	          throw new TypeError('Port "' + v + '" contains characters other than [0-9]');
	        }
	      }
	    }
	    return _port.call(this, v, build);
	  };
	  p.hostname = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v !== undefined) {
	      var x = {};
	      var res = URI.parseHost(v, x);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      v = x.hostname;
	    }
	    return _hostname.call(this, v, build);
	  };
	
	  // compound accessors
	  p.origin = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      var protocol = this.protocol();
	      var authority = this.authority();
	      if (!authority) {
	        return '';
	      }
	
	      return (protocol ? protocol + '://' : '') + this.authority();
	    } else {
	      var origin = URI(v);
	      this
	        .protocol(origin.protocol())
	        .authority(origin.authority())
	        .build(!build);
	      return this;
	    }
	  };
	  p.host = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildHost(this._parts) : '';
	    } else {
	      var res = URI.parseHost(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.authority = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
	    } else {
	      var res = URI.parseAuthority(v, this._parts);
	      if (res !== '/') {
	        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.userinfo = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined) {
	      var t = URI.buildUserinfo(this._parts);
	      return t ? t.substring(0, t.length -1) : t;
	    } else {
	      if (v[v.length-1] !== '@') {
	        v += '@';
	      }
	
	      URI.parseUserinfo(v, this._parts);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.resource = function(v, build) {
	    var parts;
	
	    if (v === undefined) {
	      return this.path() + this.search() + this.hash();
	    }
	
	    parts = URI.parse(v);
	    this._parts.path = parts.path;
	    this._parts.query = parts.query;
	    this._parts.fragment = parts.fragment;
	    this.build(!build);
	    return this;
	  };
	
	  // fraction accessors
	  p.subdomain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    // convenience, return "www" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // grab domain and add another segment
	      var end = this._parts.hostname.length - this.domain().length - 1;
	      return this._parts.hostname.substring(0, end) || '';
	    } else {
	      var e = this._parts.hostname.length - this.domain().length;
	      var sub = this._parts.hostname.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(sub));
	
	      if (v && v.charAt(v.length - 1) !== '.') {
	        v += '.';
	      }
	
	      if (v) {
	        URI.ensureValidHostname(v);
	      }
	
	      this._parts.hostname = this._parts.hostname.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.domain = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // convenience, return "example.org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      // if hostname consists of 1 or 2 segments, it must be the domain
	      var t = this._parts.hostname.match(/\./g);
	      if (t && t.length < 2) {
	        return this._parts.hostname;
	      }
	
	      // grab tld and add another segment
	      var end = this._parts.hostname.length - this.tld(build).length - 1;
	      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
	      return this._parts.hostname.substring(end) || '';
	    } else {
	      if (!v) {
	        throw new TypeError('cannot set domain empty');
	      }
	
	      URI.ensureValidHostname(v);
	
	      if (!this._parts.hostname || this.is('IP')) {
	        this._parts.hostname = v;
	      } else {
	        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.tld = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (typeof v === 'boolean') {
	      build = v;
	      v = undefined;
	    }
	
	    // return "org" from "www.example.org"
	    if (v === undefined) {
	      if (!this._parts.hostname || this.is('IP')) {
	        return '';
	      }
	
	      var pos = this._parts.hostname.lastIndexOf('.');
	      var tld = this._parts.hostname.substring(pos + 1);
	
	      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
	        return SLD.get(this._parts.hostname) || tld;
	      }
	
	      return tld;
	    } else {
	      var replace;
	
	      if (!v) {
	        throw new TypeError('cannot set TLD empty');
	      } else if (v.match(/[^a-zA-Z0-9-]/)) {
	        if (SLD && SLD.is(v)) {
	          replace = new RegExp(escapeRegEx(this.tld()) + '$');
	          this._parts.hostname = this._parts.hostname.replace(replace, v);
	        } else {
	          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
	        }
	      } else if (!this._parts.hostname || this.is('IP')) {
	        throw new ReferenceError('cannot set TLD on non-domain host');
	      } else {
	        replace = new RegExp(escapeRegEx(this.tld()) + '$');
	        this._parts.hostname = this._parts.hostname.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.directory = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path && !this._parts.hostname) {
	        return '';
	      }
	
	      if (this._parts.path === '/') {
	        return '/';
	      }
	
	      var end = this._parts.path.length - this.filename().length - 1;
	      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
	
	      return v ? URI.decodePath(res) : res;
	
	    } else {
	      var e = this._parts.path.length - this.filename().length;
	      var directory = this._parts.path.substring(0, e);
	      var replace = new RegExp('^' + escapeRegEx(directory));
	
	      // fully qualifier directories begin with a slash
	      if (!this.is('relative')) {
	        if (!v) {
	          v = '/';
	        }
	
	        if (v.charAt(0) !== '/') {
	          v = '/' + v;
	        }
	      }
	
	      // directories always end with a slash
	      if (v && v.charAt(v.length - 1) !== '/') {
	        v += '/';
	      }
	
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	      this.build(!build);
	      return this;
	    }
	  };
	  p.filename = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var pos = this._parts.path.lastIndexOf('/');
	      var res = this._parts.path.substring(pos+1);
	
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      var mutatedDirectory = false;
	
	      if (v.charAt(0) === '/') {
	        v = v.substring(1);
	      }
	
	      if (v.match(/\.?\//)) {
	        mutatedDirectory = true;
	      }
	
	      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
	      v = URI.recodePath(v);
	      this._parts.path = this._parts.path.replace(replace, v);
	
	      if (mutatedDirectory) {
	        this.normalizePath(build);
	      } else {
	        this.build(!build);
	      }
	
	      return this;
	    }
	  };
	  p.suffix = function(v, build) {
	    if (this._parts.urn) {
	      return v === undefined ? '' : this;
	    }
	
	    if (v === undefined || v === true) {
	      if (!this._parts.path || this._parts.path === '/') {
	        return '';
	      }
	
	      var filename = this.filename();
	      var pos = filename.lastIndexOf('.');
	      var s, res;
	
	      if (pos === -1) {
	        return '';
	      }
	
	      // suffix may only contain alnum characters (yup, I made this up.)
	      s = filename.substring(pos+1);
	      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
	      return v ? URI.decodePathSegment(res) : res;
	    } else {
	      if (v.charAt(0) === '.') {
	        v = v.substring(1);
	      }
	
	      var suffix = this.suffix();
	      var replace;
	
	      if (!suffix) {
	        if (!v) {
	          return this;
	        }
	
	        this._parts.path += '.' + URI.recodePath(v);
	      } else if (!v) {
	        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
	      } else {
	        replace = new RegExp(escapeRegEx(suffix) + '$');
	      }
	
	      if (replace) {
	        v = URI.recodePath(v);
	        this._parts.path = this._parts.path.replace(replace, v);
	      }
	
	      this.build(!build);
	      return this;
	    }
	  };
	  p.segment = function(segment, v, build) {
	    var separator = this._parts.urn ? ':' : '/';
	    var path = this.path();
	    var absolute = path.substring(0, 1) === '/';
	    var segments = path.split(separator);
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (segment !== undefined && typeof segment !== 'number') {
	      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
	    }
	
	    if (absolute) {
	      segments.shift();
	    }
	
	    if (segment < 0) {
	      // allow negative indexes to address from the end
	      segment = Math.max(segments.length + segment, 0);
	    }
	
	    if (v === undefined) {
	      /*jshint laxbreak: true */
	      return segment === undefined
	        ? segments
	        : segments[segment];
	      /*jshint laxbreak: false */
	    } else if (segment === null || segments[segment] === undefined) {
	      if (isArray(v)) {
	        segments = [];
	        // collapse empty elements within array
	        for (var i=0, l=v.length; i < l; i++) {
	          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
	            continue;
	          }
	
	          if (segments.length && !segments[segments.length -1].length) {
	            segments.pop();
	          }
	
	          segments.push(trimSlashes(v[i]));
	        }
	      } else if (v || typeof v === 'string') {
	        v = trimSlashes(v);
	        if (segments[segments.length -1] === '') {
	          // empty trailing elements have to be overwritten
	          // to prevent results such as /foo//bar
	          segments[segments.length -1] = v;
	        } else {
	          segments.push(v);
	        }
	      }
	    } else {
	      if (v) {
	        segments[segment] = trimSlashes(v);
	      } else {
	        segments.splice(segment, 1);
	      }
	    }
	
	    if (absolute) {
	      segments.unshift('');
	    }
	
	    return this.path(segments.join(separator), build);
	  };
	  p.segmentCoded = function(segment, v, build) {
	    var segments, i, l;
	
	    if (typeof segment !== 'number') {
	      build = v;
	      v = segment;
	      segment = undefined;
	    }
	
	    if (v === undefined) {
	      segments = this.segment(segment, v, build);
	      if (!isArray(segments)) {
	        segments = segments !== undefined ? URI.decode(segments) : undefined;
	      } else {
	        for (i = 0, l = segments.length; i < l; i++) {
	          segments[i] = URI.decode(segments[i]);
	        }
	      }
	
	      return segments;
	    }
	
	    if (!isArray(v)) {
	      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
	    } else {
	      for (i = 0, l = v.length; i < l; i++) {
	        v[i] = URI.encode(v[i]);
	      }
	    }
	
	    return this.segment(segment, v, build);
	  };
	
	  // mutating query string
	  var q = p.query;
	  p.query = function(v, build) {
	    if (v === true) {
	      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    } else if (typeof v === 'function') {
	      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	      var result = v.call(this, data);
	      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else if (v !== undefined && typeof v !== 'string') {
	      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	      this.build(!build);
	      return this;
	    } else {
	      return q.call(this, v, build);
	    }
	  };
	  p.setQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	
	    if (typeof name === 'string' || name instanceof String) {
	      data[name] = value !== undefined ? value : null;
	    } else if (typeof name === 'object') {
	      for (var key in name) {
	        if (hasOwn.call(name, key)) {
	          data[key] = name[key];
	        }
	      }
	    } else {
	      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
	    }
	
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.addQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.addQuery(data, name, value === undefined ? null : value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.removeQuery = function(name, value, build) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    URI.removeQuery(data, name, value);
	    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
	    if (typeof name !== 'string') {
	      build = value;
	    }
	
	    this.build(!build);
	    return this;
	  };
	  p.hasQuery = function(name, value, withinArray) {
	    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
	    return URI.hasQuery(data, name, value, withinArray);
	  };
	  p.setSearch = p.setQuery;
	  p.addSearch = p.addQuery;
	  p.removeSearch = p.removeQuery;
	  p.hasSearch = p.hasQuery;
	
	  // sanitizing URLs
	  p.normalize = function() {
	    if (this._parts.urn) {
	      return this
	        .normalizeProtocol(false)
	        .normalizePath(false)
	        .normalizeQuery(false)
	        .normalizeFragment(false)
	        .build();
	    }
	
	    return this
	      .normalizeProtocol(false)
	      .normalizeHostname(false)
	      .normalizePort(false)
	      .normalizePath(false)
	      .normalizeQuery(false)
	      .normalizeFragment(false)
	      .build();
	  };
	  p.normalizeProtocol = function(build) {
	    if (typeof this._parts.protocol === 'string') {
	      this._parts.protocol = this._parts.protocol.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeHostname = function(build) {
	    if (this._parts.hostname) {
	      if (this.is('IDN') && punycode) {
	        this._parts.hostname = punycode.toASCII(this._parts.hostname);
	      } else if (this.is('IPv6') && IPv6) {
	        this._parts.hostname = IPv6.best(this._parts.hostname);
	      }
	
	      this._parts.hostname = this._parts.hostname.toLowerCase();
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePort = function(build) {
	    // remove port of it's the protocol's default
	    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
	      this._parts.port = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizePath = function(build) {
	    var _path = this._parts.path;
	    if (!_path) {
	      return this;
	    }
	
	    if (this._parts.urn) {
	      this._parts.path = URI.recodeUrnPath(this._parts.path);
	      this.build(!build);
	      return this;
	    }
	
	    if (this._parts.path === '/') {
	      return this;
	    }
	
	    _path = URI.recodePath(_path);
	
	    var _was_relative;
	    var _leadingParents = '';
	    var _parent, _pos;
	
	    // handle relative paths
	    if (_path.charAt(0) !== '/') {
	      _was_relative = true;
	      _path = '/' + _path;
	    }
	
	    // handle relative files (as opposed to directories)
	    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
	      _path += '/';
	    }
	
	    // resolve simples
	    _path = _path
	      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
	      .replace(/\/{2,}/g, '/');
	
	    // remember leading parents
	    if (_was_relative) {
	      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
	      if (_leadingParents) {
	        _leadingParents = _leadingParents[0];
	      }
	    }
	
	    // resolve parents
	    while (true) {
	      _parent = _path.search(/\/\.\.(\/|$)/);
	      if (_parent === -1) {
	        // no more ../ to resolve
	        break;
	      } else if (_parent === 0) {
	        // top level cannot be relative, skip it
	        _path = _path.substring(3);
	        continue;
	      }
	
	      _pos = _path.substring(0, _parent).lastIndexOf('/');
	      if (_pos === -1) {
	        _pos = _parent;
	      }
	      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
	    }
	
	    // revert to relative
	    if (_was_relative && this.is('relative')) {
	      _path = _leadingParents + _path.substring(1);
	    }
	
	    this._parts.path = _path;
	    this.build(!build);
	    return this;
	  };
	  p.normalizePathname = p.normalizePath;
	  p.normalizeQuery = function(build) {
	    if (typeof this._parts.query === 'string') {
	      if (!this._parts.query.length) {
	        this._parts.query = null;
	      } else {
	        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
	      }
	
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeFragment = function(build) {
	    if (!this._parts.fragment) {
	      this._parts.fragment = null;
	      this.build(!build);
	    }
	
	    return this;
	  };
	  p.normalizeSearch = p.normalizeQuery;
	  p.normalizeHash = p.normalizeFragment;
	
	  p.iso8859 = function() {
	    // expect unicode input, iso8859 output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = escape;
	    URI.decode = decodeURIComponent;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.unicode = function() {
	    // expect iso8859 input, unicode output
	    var e = URI.encode;
	    var d = URI.decode;
	
	    URI.encode = strictEncodeURIComponent;
	    URI.decode = unescape;
	    try {
	      this.normalize();
	    } finally {
	      URI.encode = e;
	      URI.decode = d;
	    }
	    return this;
	  };
	
	  p.readable = function() {
	    var uri = this.clone();
	    // removing username, password, because they shouldn't be displayed according to RFC 3986
	    uri.username('').password('').normalize();
	    var t = '';
	    if (uri._parts.protocol) {
	      t += uri._parts.protocol + '://';
	    }
	
	    if (uri._parts.hostname) {
	      if (uri.is('punycode') && punycode) {
	        t += punycode.toUnicode(uri._parts.hostname);
	        if (uri._parts.port) {
	          t += ':' + uri._parts.port;
	        }
	      } else {
	        t += uri.host();
	      }
	    }
	
	    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
	      t += '/';
	    }
	
	    t += uri.path(true);
	    if (uri._parts.query) {
	      var q = '';
	      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
	        var kv = (qp[i] || '').split('=');
	        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
	          .replace(/&/g, '%26');
	
	        if (kv[1] !== undefined) {
	          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
	            .replace(/&/g, '%26');
	        }
	      }
	      t += '?' + q.substring(1);
	    }
	
	    t += URI.decodeQuery(uri.hash(), true);
	    return t;
	  };
	
	  // resolving relative and absolute URLs
	  p.absoluteTo = function(base) {
	    var resolved = this.clone();
	    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
	    var basedir, i, p;
	
	    if (this._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    if (!(base instanceof URI)) {
	      base = new URI(base);
	    }
	
	    if (!resolved._parts.protocol) {
	      resolved._parts.protocol = base._parts.protocol;
	    }
	
	    if (this._parts.hostname) {
	      return resolved;
	    }
	
	    for (i = 0; (p = properties[i]); i++) {
	      resolved._parts[p] = base._parts[p];
	    }
	
	    if (!resolved._parts.path) {
	      resolved._parts.path = base._parts.path;
	      if (!resolved._parts.query) {
	        resolved._parts.query = base._parts.query;
	      }
	    } else {
	      if (resolved._parts.path.substring(-2) === '..') {
	        resolved._parts.path += '/';
	      }
	
	      if (resolved.path().charAt(0) !== '/') {
	        basedir = base.directory();
	        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
	        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
	        resolved.normalizePath();
	      }
	    }
	
	    resolved.build();
	    return resolved;
	  };
	  p.relativeTo = function(base) {
	    var relative = this.clone().normalize();
	    var relativeParts, baseParts, common, relativePath, basePath;
	
	    if (relative._parts.urn) {
	      throw new Error('URNs do not have any generally defined hierarchical components');
	    }
	
	    base = new URI(base).normalize();
	    relativeParts = relative._parts;
	    baseParts = base._parts;
	    relativePath = relative.path();
	    basePath = base.path();
	
	    if (relativePath.charAt(0) !== '/') {
	      throw new Error('URI is already relative');
	    }
	
	    if (basePath.charAt(0) !== '/') {
	      throw new Error('Cannot calculate a URI relative to another relative URI');
	    }
	
	    if (relativeParts.protocol === baseParts.protocol) {
	      relativeParts.protocol = null;
	    }
	
	    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
	      return relative.build();
	    }
	
	    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
	      return relative.build();
	    }
	
	    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
	      relativeParts.hostname = null;
	      relativeParts.port = null;
	    } else {
	      return relative.build();
	    }
	
	    if (relativePath === basePath) {
	      relativeParts.path = '';
	      return relative.build();
	    }
	
	    // determine common sub path
	    common = URI.commonPath(relativePath, basePath);
	
	    // If the paths have nothing in common, return a relative URL with the absolute path.
	    if (!common) {
	      return relative.build();
	    }
	
	    var parents = baseParts.path
	      .substring(common.length)
	      .replace(/[^\/]*$/, '')
	      .replace(/.*?\//g, '../');
	
	    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';
	
	    return relative.build();
	  };
	
	  // comparing URIs
	  p.equals = function(uri) {
	    var one = this.clone();
	    var two = new URI(uri);
	    var one_map = {};
	    var two_map = {};
	    var checked = {};
	    var one_query, two_query, key;
	
	    one.normalize();
	    two.normalize();
	
	    // exact match
	    if (one.toString() === two.toString()) {
	      return true;
	    }
	
	    // extract query string
	    one_query = one.query();
	    two_query = two.query();
	    one.query('');
	    two.query('');
	
	    // definitely not equal if not even non-query parts match
	    if (one.toString() !== two.toString()) {
	      return false;
	    }
	
	    // query parameters have the same length, even if they're permuted
	    if (one_query.length !== two_query.length) {
	      return false;
	    }
	
	    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
	    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
	
	    for (key in one_map) {
	      if (hasOwn.call(one_map, key)) {
	        if (!isArray(one_map[key])) {
	          if (one_map[key] !== two_map[key]) {
	            return false;
	          }
	        } else if (!arraysEqual(one_map[key], two_map[key])) {
	          return false;
	        }
	
	        checked[key] = true;
	      }
	    }
	
	    for (key in two_map) {
	      if (hasOwn.call(two_map, key)) {
	        if (!checked[key]) {
	          // two contains a parameter not present in one
	          return false;
	        }
	      }
	    }
	
	    return true;
	  };
	
	  // state
	  p.duplicateQueryParameters = function(v) {
	    this._parts.duplicateQueryParameters = !!v;
	    return this;
	  };
	
	  p.escapeQuerySpace = function(v) {
	    this._parts.escapeQuerySpace = !!v;
	    return this;
	  };
	
	  return URI;
	}));


/***/ },
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.0"
	  };
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = document, d3_documentElement = d3_document.documentElement, d3_window = window;
	  try {
	    d3_array(d3_documentElement.childNodes)[0].nodeType;
	  } catch (e) {
	    d3_array = function(list) {
	      var i = list.length, array = new Array(i);
	      while (i--) array[i] = list[i];
	      return array;
	    };
	  }
	  try {
	    d3_document.createElement("div").style.setProperty("opacity", 0, "");
	  } catch (error) {
	    var d3_element_prototype = d3_window.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = d3_window.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	    d3_element_prototype.setAttribute = function(name, value) {
	      d3_element_setAttribute.call(this, name, value + "");
	    };
	    d3_element_prototype.setAttributeNS = function(space, local, value) {
	      d3_element_setAttributeNS.call(this, space, local, value + "");
	    };
	    d3_style_prototype.setProperty = function(name, value, priority) {
	      d3_style_setProperty.call(this, name, value + "", priority);
	    };
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.zip = function() {
	    if (!(n = arguments.length)) return [];
	    for (var i = -1, m = d3.min(arguments, d3_zipLength), zips = new Array(m); ++i < m; ) {
	      for (var j = -1, n, zip = zips[i] = new Array(n); ++j < n; ) {
	        zip[j] = arguments[j][i];
	      }
	    }
	    return zips;
	  };
	  function d3_zipLength(d) {
	    return d.length;
	  }
	  d3.transpose = function(matrix) {
	    return d3.zip.apply(d3, matrix);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatcher = d3_documentElement.matches || d3_documentElement[d3_vendorSymbol(d3_documentElement, "matchesSelector")], d3_selectMatches = function(n, s) {
	    return d3_selectMatcher.call(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3_selectionRoot;
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: "http://www.w3.org/1999/xhtml",
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0) {
	        prefix = name.slice(0, i);
	        name = name.slice(i + 1);
	      }
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) return d3_window.getComputedStyle(this.node(), null).getPropertyValue(name);
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? function() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    } : function() {
	      return this.ownerDocument.createElementNS(this.namespaceURI, name);
	    };
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (nodeByKeyValue.has(keyValue = key.call(node = group[i], node.__data__, i))) {
	            exitNodes[i] = node;
	          } else {
	            nodeByKeyValue.set(keyValue, node);
	          }
	          keyValues[i] = keyValue;
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    var ns = d3_transitionNamespace(name);
	    return this.each(function() {
	      var lock = this[ns];
	      if (lock) ++lock.active;
	    });
	  };
	  function d3_selection_interrupt(that) {
	    var lock = that.__transition__;
	    if (lock) ++lock.active;
	  }
	  d3.select = function(node) {
	    var group = [ typeof node === "string" ? d3_select(node, d3_document) : node ];
	    group.parentNode = d3_documentElement;
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group = d3_array(typeof nodes === "string" ? d3_selectAll(nodes, d3_document) : nodes);
	    group.parentNode = d3_documentElement;
	    return d3_selection([ group ]);
	  };
	  var d3_selectionRoot = d3.select(d3_documentElement);
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  d3_selection_onFilters.forEach(function(k) {
	    if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	  });
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect = "onselectstart" in d3_document ? null : d3_vendorSymbol(d3_documentElement.style, "userSelect"), d3_event_dragId = 0;
	  function d3_event_dragSuppress() {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement.style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = /WebKit/.test(d3_window.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0 && (d3_window.scrollX || d3_window.scrollY)) {
	        svg = d3.select("body").append("svg").style({
	          position: "absolute",
	          top: 0,
	          left: 0,
	          margin: 0,
	          padding: 0,
	          border: "none"
	        }, "important");
	        var ctm = svg[0][0].getScreenCTM();
	        d3_mouse_bug44083 = !(ctm.f || ctm.e);
	        svg.remove();
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_behavior_dragMouseSubject, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_behavior_dragTouchSubject, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject()).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged && d3.event.target === target);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  function d3_behavior_dragTouchSubject() {
	    return d3.event.target;
	  }
	  function d3_behavior_dragMouseSubject() {
	    return d3_window;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2];
	    var dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1), dr = r1 - r0, S = (dr || Math.log(w1 / w0)) / ρ;
	    function interpolate(t) {
	      var s = t * S;
	      if (dr) {
	        var coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      }
	      return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * s) ];
	    }
	    interpolate.duration = S * 1e3;
	    return interpolate;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: +_
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      });
	      center0 = null;
	    }
	    function mousedowned() {
	      var that = this, target = d3.event.target, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress();
	      d3_selection_interrupt(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged && d3.event.target === target);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress();
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else translate0 = location(center0 = center || d3.mouse(this)), 
	      d3_selection_interrupt(this), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ];
	  var d3_behavior_zoomDelta, d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	    return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	  }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	    return d3.event.wheelDelta;
	  }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	    return -d3.event.detail;
	  }, "MozMousePixelScroll");
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/i.exec(format);
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) return rgb(color.r, color.g, color.b);
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  function d3_identity(d) {
	    return d;
	  }
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (d3_window.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_active, d3_timer_frame = d3_window[d3_vendorSymbol(d3_window, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      f: false,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  };
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now();
	    d3_timer_active = d3_timer_queueHead;
	    while (d3_timer_active) {
	      if (now >= d3_timer_active.t) d3_timer_active.f = d3_timer_active.c(now - d3_timer_active.t);
	      d3_timer_active = d3_timer_active.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.f) {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      } else {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("w" in d && ("W" in d || "U" in d)) {
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < 0) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - point[0], dy = y - point[1], distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b) || /^(#|rgb\(|hsl\()/.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [], n, A = d3.transform(a), B = d3.transform(b), ta = A.translate, tb = B.translate, ra = A.rotate, rb = B.rotate, wa = A.skew, wb = B.skew, ka = A.scale, kb = B.scale;
	    if (ta[0] != tb[0] || ta[1] != tb[1]) {
	      s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: 1,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: 3,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    } else {
	      s.push("");
	    }
	    if (ra != rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(s.pop() + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(s.pop() + "rotate(" + rb + ")");
	    }
	    if (wa != wb) {
	      q.push({
	        i: s.push(s.pop() + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(s.pop() + "skewX(" + wb + ")");
	    }
	    if (ka[0] != kb[0] || ka[1] != kb[1]) {
	      n = s.push(s.pop() + "scale(", null, ",", null, ")");
	      q.push({
	        i: n - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: n - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] != 1 || kb[1] != 1) {
	      s.push(s.pop() + "scale(" + kb + ")");
	    }
	    n = q.length;
	    return function(t) {
	      var i = -1, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: (x - x0) / k
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight / (t.weight + s.weight));
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) alpha = x; else alpha = 0;
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        d3.timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, m = candidates.length, x;
	        while (++j < m) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), k = (da - n * pa) / d3.sum(values), index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = 0;
	      root.y = 0;
	      root.dx = size[0];
	      root.dy = size[1];
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    return d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(.1, n / scale.ticks().length), f = positive ? (e = 1e-12, Math.ceil) : (e = -1e-12, 
	      Math.floor), e;
	      return function(d) {
	        return d / pow(f(log(d) + e)) <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if ((rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	        if (x1 != null) {
	          var rc1 = Math.min(rc, (r1 - lc) / (kc + 1)), t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var rc0 = Math.min(rc, (r0 - lc) / (kc - 1)), t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(r * r * d2 - D * D), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.join("L");
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return d3_svg_lineLinear(points) + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  function d3_transition(groups, namespace, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = namespace;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection) {
	    return arguments.length ? d3_transitionInheritId ? selection.transition() : selection : d3_selectionRoot.transition();
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window.getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window.getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      d3_transitionInheritId = id;
	      d3_selection_each(this, function(node, i, j) {
	        d3_transitionInherit = node[ns][id];
	        type.call(node, node.__data__, i, j);
	      });
	      d3_transitionInherit = inherit;
	      d3_transitionInheritId = inheritId;
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, namespace, id, inherit) {
	    var lock = node[namespace] || (node[namespace] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id];
	    if (!transition) {
	      var time = inherit.time;
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease
	      };
	      inherit = null;
	      ++lock.count;
	      d3.timer(function(elapsed) {
	        var d = node.__data__, delay = transition.delay, duration, ease, timer = d3_timer_active, tweened = [];
	        timer.t = delay + time;
	        if (delay <= elapsed) return start(elapsed - delay);
	        timer.c = start;
	        function start(elapsed) {
	          if (lock.active > id) return stop(false);
	          lock.active = id;
	          transition.event && transition.event.start.call(node, d, i);
	          transition.tween.forEach(function(key, value) {
	            if (value = value.call(node, d, i)) {
	              tweened.push(value);
	            }
	          });
	          ease = transition.ease;
	          duration = transition.duration;
	          d3.timer(function() {
	            timer.c = tick(elapsed || 1) ? d3_true : tick;
	            return 1;
	          }, 0, time);
	        }
	        function tick(elapsed) {
	          if (lock.active !== id) return stop(false);
	          var t = elapsed / duration, e = ease(t), n = tweened.length;
	          while (n > 0) {
	            tweened[--n].call(node, e);
	          }
	          if (t >= 1) return stop(true);
	        }
	        function stop(end) {
	          if (transition.event) transition.event[end ? "end" : "interrupt"].call(node, d, i);
	          if (--lock.count) delete lock[id]; else delete node[namespace];
	          return 1;
	        }
	      }, 0, time);
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = arguments;
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3;
	  this.d3 = d3;
	}();

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(127)(__webpack_require__(1182))

/***/ },
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// Import DC and dependencies
	
	d3 = __webpack_require__(56);
	crossfilter = __webpack_require__(125);
	module.exports = __webpack_require__(1146);


/***/ },
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(585);

/***/ },
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utilMomentUtils = __webpack_require__(1003);
	
	var _utilMomentUtils2 = _interopRequireDefault(_utilMomentUtils);
	
	var _utilNumberUtils = __webpack_require__(37);
	
	var _utilNumberUtils2 = _interopRequireDefault(_utilNumberUtils);
	
	var DEFAULT_MAX_DATA_POINTS = 4000;
	
	var HistogramFormatter = {
	  _firstDataPointTimestamp: function _firstDataPointTimestamp(dataPoints, queryFrom, isSearchAll) {
	    if (isSearchAll) {
	      return _moment2['default'].utc(Number(Object.keys(dataPoints).sort()[0]) * 1000);
	    }
	
	    return _moment2['default'].utc(queryFrom);
	  },
	
	  /**
	   * Formats the histogram to add empty data where there were no results, normalizes its values to
	   * avoid errors in the underlying graphing library, and samples the data, so we don't draw more
	   * points that we can display.
	   *
	   * @param {object} dataPoints: Histogram data as returned from the server {unix_time: value, ...}
	   * @param {object} queryTimeRange: Time ranges of the query that generated the histogram
	   * @param {string} resolution: Histogram resolution
	   * @param {number} screenSize: Screen width to calculate the maximum number of data points returned
	   * @param {boolean} isSearchAll: Indicates if the histogram was made for a search in all messages or not
	   * @param {string} valueKey: Histogram contains objects with different values, this indicates the key
	   *                           to access the value to plot
	   * @param {boolean} legacy: Flag to indicate if the x-axis should contain timestamps in ms or seconds.
	   *                          This was added as Rickshaw only supports the latter format
	   *
	   */
	  format: function format(dataPoints, queryTimeRange, resolution, screenSize, isSearchAll, valueKey) {
	    var legacy = arguments.length <= 6 || arguments[6] === undefined ? false : arguments[6];
	
	    var formattedPoints = [];
	    var maxDataPoints = screenSize && screenSize > 0 ? screenSize : DEFAULT_MAX_DATA_POINTS;
	
	    if (typeof dataPoints === 'object' && !Array.isArray(dataPoints)) {
	      var from = this._firstDataPointTimestamp(dataPoints, queryTimeRange.from, isSearchAll);
	      var to = _moment2['default'].utc(queryTimeRange.to);
	
	      var tempTime = (0, _moment2['default'])(from);
	      var step = _moment2['default'].duration(1, resolution);
	
	      var totalDataPoints = ((to.valueOf() - from.valueOf()) / step.as('milliseconds')).toFixed();
	      var factor = totalDataPoints > maxDataPoints ? (totalDataPoints / maxDataPoints).toFixed() : 1;
	
	      var index = 0;
	      // Position the temporary time to the beginning of the time span we want to graph and iterate through it
	      tempTime = _utilMomentUtils2['default'].startOfResolution(tempTime, resolution);
	      while (tempTime.isBefore(to) || tempTime.isSame(to)) {
	        if (index % factor === 0) {
	          var timestamp = String(tempTime.unix());
	          var value = dataPoints[timestamp];
	
	          var result = 0;
	          // Get the actual value if the result for that time is an object. If there is no result, we'll use 0
	          if (value !== null && value !== undefined) {
	            if (typeof value === 'object') {
	              if (value.hasOwnProperty(valueKey)) {
	                result = value[valueKey];
	              }
	            } else {
	              result = value;
	            }
	          }
	
	          formattedPoints.push({
	            x: legacy ? tempTime.unix() : tempTime.valueOf(),
	            y: _utilNumberUtils2['default'].normalizeGraphNumber(result)
	          });
	        }
	        index += 1;
	        tempTime.add(step);
	      }
	    }
	
	    return formattedPoints;
	  }
	};
	
	exports['default'] = HistogramFormatter;
	module.exports = exports['default'];

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _d3 = __webpack_require__(56);
	
	var _d32 = _interopRequireDefault(_d3);
	
	var D3Utils = {
	  glColourPalette: function glColourPalette() {
	    return _d32['default'].scale.ordinal().range(['#16ACE3', '#FBB040', '#ED8EEF', '#7CE255', '#8DB3ED', '#EAF253', '#CED945', '#EF8DB6', '#D4A8ED', '#F495D9']);
	  },
	
	  // Add a data element to the given D3 selection to show a bootstrap tooltip
	  tooltipRenderlet: function tooltipRenderlet(graph, selector, callback) {
	    graph.on('renderlet', function (chart) {
	      _d32['default'].select(chart.root()[0][0]).selectAll(selector).attr('rel', 'tooltip').attr('data-original-title', callback);
	    });
	  }
	};
	
	exports['default'] = D3Utils;
	module.exports = exports['default'];

/***/ },
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1122).crossfilter;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(1180);
	var Parse = __webpack_require__(1179);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 127 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript !== "undefined")
			execScript(src);
		else
			eval.call(null, src);
	}


/***/ },
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(698);

/***/ },
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _logicDatetimesDateTime = __webpack_require__(31);
	
	var _logicDatetimesDateTime2 = _interopRequireDefault(_logicDatetimesDateTime);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	exports['default'] = {
	  dateTimeFormats: [{ formatString: ".SSS", condition: function condition(d) {
	      return d.milliseconds() !== 0;
	    } }, { formatString: ":s", condition: function condition(d) {
	      return d.seconds() !== 0;
	    } }, { formatString: "HH:mm", condition: function condition(d) {
	      return d.minutes() !== 0;
	    } }, { formatString: "HH:mm", condition: function condition(d) {
	      return d.hours() !== 0;
	    } }, { formatString: "ddd DD", condition: function condition(d) {
	      return d.isoWeekday() !== 1 && d.date() !== 1;
	    } }, { formatString: "MMM DD", condition: function condition(d) {
	      return d.date() !== 1;
	    } }, { formatString: "MMM", condition: function condition(d) {
	      return d.month() !== 0;
	    } }, { formatString: "YYYY", condition: function condition() {
	      return true;
	    } }],
	
	  intervalResolutions: [{ interval: 'year', unit: 'year', step: 1, condition: function condition(duration) {
	      return duration.years() > 1;
	    } }, { interval: 'month', unit: 'month', step: 1, condition: function condition(duration) {
	      return duration.years() === 1 || duration.months() > 1;
	    } }, { interval: 'day', unit: 'date', step: 2, condition: function condition(duration) {
	      return duration.months() === 1 || duration.days() > 10;
	    } }, { interval: 'day', unit: 'date', step: 1, condition: function condition(duration) {
	      return duration.days() > 3;
	    } }, { interval: 'hour', unit: 'hour', step: 12, condition: function condition(duration) {
	      return duration.days() > 1;
	    } }, { interval: 'hour', unit: 'hour', step: 3, condition: function condition(duration) {
	      return duration.days() === 1;
	    } }, { interval: 'hour', unit: 'hour', step: 1, condition: function condition(duration) {
	      return duration.hours() > 1;
	    } }, { interval: 'minute', unit: 'minute', step: 10, condition: function condition(duration) {
	      return duration.hours() === 1 || duration.minutes() > 30;
	    } }, { interval: 'minute', unit: 'minute', step: 5, condition: function condition(duration) {
	      return duration.minutes() > 15;
	    } }, { interval: 'minute', unit: 'minute', step: 1, condition: function condition() {
	      return true;
	    } }],
	
	  customDateTimeFormat: function customDateTimeFormat(tzOffset) {
	    var _this = this;
	
	    if (typeof tzOffset === 'undefined') {
	      tzOffset = null;
	    }
	    return function (date) {
	      var momentDate;
	      var formattedDate;
	
	      if (tzOffset === null) {
	        momentDate = new _logicDatetimesDateTime2['default'](date).toMoment();
	      } else {
	        momentDate = (0, _moment2['default'])(date);
	        momentDate.utcOffset(tzOffset);
	      }
	
	      _this.dateTimeFormats.some(function (format) {
	        if (format.condition(momentDate) === true) {
	          formattedDate = momentDate.format(format.formatString);
	          return true;
	        }
	      });
	
	      return formattedDate;
	    };
	  },
	
	  customTickInterval: function customTickInterval(tzOffset) {
	    var _this2 = this;
	
	    if (typeof tzOffset === 'undefined') {
	      tzOffset = null;
	    }
	    return function (initDateTime, endDateTime, step) {
	      var ticks = [];
	      var runningMoment;
	      var endMoment;
	
	      if (tzOffset === null) {
	        runningMoment = new _logicDatetimesDateTime2['default'](initDateTime).toMoment();
	        endMoment = new _logicDatetimesDateTime2['default'](endDateTime).toMoment();
	      } else {
	        runningMoment = (0, _moment2['default'])(initDateTime);
	        endMoment = (0, _moment2['default'])(endDateTime);
	        runningMoment.utcOffset(tzOffset);
	        endMoment.utcOffset(tzOffset);
	      }
	
	      if (!runningMoment.isValid() || !endMoment.isValid()) {
	        return ticks;
	      }
	
	      var interval;
	      var unit;
	      var duration = _moment2['default'].duration(endMoment.valueOf() - runningMoment.valueOf());
	      _this2.intervalResolutions.some(function (resolution) {
	        if (resolution.condition(duration)) {
	          interval = resolution.interval;
	          unit = resolution.unit;
	          step = resolution.step;
	          return true;
	        }
	      });
	
	      runningMoment.add(1, interval).startOf(interval);
	
	      if (step > 1) {
	        while (runningMoment.isBefore(endMoment)) {
	          if (runningMoment.get(unit) % step === 0) {
	            ticks.push(new Date(runningMoment.valueOf()));
	          }
	          runningMoment.add(1, interval);
	        }
	      } else {
	        while (runningMoment.isBefore(endMoment)) {
	          ticks.push(new Date(runningMoment.valueOf()));
	          runningMoment.add(1, interval);
	        }
	      }
	
	      return ticks;
	    };
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var AppConfig = {
	  gl2ServerUrl: function gl2ServerUrl() {
	    return window.appConfig.gl2ServerUrl;
	  },
	
	  gl2AppPathPrefix: function gl2AppPathPrefix() {
	    return window.appConfig.gl2AppPathPrefix;
	  },
	
	  gl2DevMode: function gl2DevMode() {
	    // The DEVELOPMENT variable will be set by webpack via the DefinePlugin.
	    // eslint-disable-next-line no-undef
	    return typeof DEVELOPMENT !== 'undefined' && DEVELOPMENT;
	  },
	
	  rootTimeZone: function rootTimeZone() {
	    return window.appConfig.rootTimeZone;
	  }
	};
	
	exports['default'] = AppConfig;
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_TIMEOUT = 1000 / 10; // 10 fps
	
	/**
	 * Use when an event handler should be called after a timeout, instead of every time the event is triggered.
	 * This is specially useful for handling window resize callbacks that may be expensive.
	 */
	
	var EventHandlersThrottler = (function () {
	  function EventHandlersThrottler() {
	    _classCallCheck(this, EventHandlersThrottler);
	
	    this.eventMutex = null;
	  }
	
	  /**
	   * @param eventHandler Callback actually handling the event
	   * @param timeout (optional) Time to wait before calling the callback
	   */
	
	  _createClass(EventHandlersThrottler, [{
	    key: "throttle",
	    value: function throttle(eventHandler, timeout) {
	      var _this = this;
	
	      if (this.eventMutex) {
	        return;
	      }
	
	      this.eventMutex = setTimeout(function () {
	        _this.eventMutex = null;
	        eventHandler();
	      }, timeout || DEFAULT_TIMEOUT);
	    }
	  }]);
	
	  return EventHandlersThrottler;
	})();
	
	exports["default"] = EventHandlersThrottler;
	module.exports = exports["default"];

/***/ },
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(127)(__webpack_require__(1181))

/***/ },
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var CombinedProvider = (function () {
	  function CombinedProvider() {
	    _classCallCheck(this, CombinedProvider);
	
	    /* eslint-disable import/no-require */
	    this.actions = {
	      AlarmCallbacks: function AlarmCallbacks() {
	        return __webpack_require__(669);
	      },
	      AlertConditions: function AlertConditions() {
	        return __webpack_require__(670);
	      },
	      AlertReceivers: function AlertReceivers() {
	        return __webpack_require__(671);
	      },
	      Alerts: function Alerts() {
	        return __webpack_require__(672);
	      },
	      CodecTypes: function CodecTypes() {
	        return __webpack_require__(571);
	      },
	      Authentication: function Authentication() {
	        return __webpack_require__(673);
	      },
	      Configuration: function Configuration() {
	        return __webpack_require__(675);
	      },
	      ConfigurationBundles: function ConfigurationBundles() {
	        return __webpack_require__(674);
	      },
	      Decorators: function Decorators() {
	        return __webpack_require__(676);
	      },
	      Deflector: function Deflector() {
	        return __webpack_require__(681);
	      },
	      Extractors: function Extractors() {
	        return __webpack_require__(677);
	      },
	      GettingStarted: function GettingStarted() {
	        return __webpack_require__(678);
	      },
	      HistogramData: function HistogramData() {
	        return __webpack_require__(698);
	      },
	      IndexerCluster: function IndexerCluster() {
	        return __webpack_require__(679);
	      },
	      IndexerOverview: function IndexerOverview() {
	        return __webpack_require__(680);
	      },
	      IndexRanges: function IndexRanges() {
	        return __webpack_require__(682);
	      },
	      Indices: function Indices() {
	        return __webpack_require__(683);
	      },
	      IndicesConfiguration: function IndicesConfiguration() {
	        return __webpack_require__(684);
	      },
	      Inputs: function Inputs() {
	        return __webpack_require__(686);
	      },
	      InputTypes: function InputTypes() {
	        return __webpack_require__(685);
	      },
	      Ldap: function Ldap() {
	        return __webpack_require__(687);
	      },
	      LdapGroups: function LdapGroups() {
	        return __webpack_require__(688);
	      },
	      Loggers: function Loggers() {
	        return __webpack_require__(700);
	      },
	      MessageCounts: function MessageCounts() {
	        return __webpack_require__(689);
	      },
	      Messages: function Messages() {
	        return __webpack_require__(690);
	      },
	      Metrics: function Metrics() {
	        return __webpack_require__(691);
	      },
	      Nodes: function Nodes() {
	        return __webpack_require__(692);
	      },
	      Notifications: function Notifications() {
	        return __webpack_require__(694);
	      },
	      Refresh: function Refresh() {
	        return __webpack_require__(702);
	      },
	      SavedSearches: function SavedSearches() {
	        return __webpack_require__(695);
	      },
	      ServerAvailability: function ServerAvailability() {
	        return __webpack_require__(696);
	      },
	      Session: function Session() {
	        return __webpack_require__(697);
	      },
	      SingleNode: function SingleNode() {
	        return __webpack_require__(693);
	      },
	      Streams: function Streams() {
	        return __webpack_require__(699);
	      },
	      SystemJobs: function SystemJobs() {
	        return __webpack_require__(701);
	      },
	      Widgets: function Widgets() {
	        return __webpack_require__(703);
	      }
	    };
	    this.stores = {
	      AlarmCallbackHistory: function AlarmCallbackHistory() {
	        return __webpack_require__(651);
	      },
	      AlarmCallbacks: function AlarmCallbacks() {
	        return __webpack_require__(953);
	      },
	      AlertConditions: function AlertConditions() {
	        return __webpack_require__(954);
	      },
	      Alerts: function Alerts() {
	        return __webpack_require__(955);
	      },
	      Authentication: function Authentication() {
	        return __webpack_require__(956);
	      },
	      ClusterOverview: function ClusterOverview() {
	        return __webpack_require__(957);
	      },
	      CodecTypes: function CodecTypes() {
	        return __webpack_require__(958);
	      },
	      ConfigurationBundles: function ConfigurationBundles() {
	        return __webpack_require__(959);
	      },
	      Configurations: function Configurations() {
	        return __webpack_require__(960);
	      },
	      CurrentUser: function CurrentUser() {
	        return __webpack_require__(1001);
	      },
	      Dashboards: function Dashboards() {
	        return __webpack_require__(652);
	      },
	      Decorators: function Decorators() {
	        return __webpack_require__(961);
	      },
	      Deflector: function Deflector() {
	        return __webpack_require__(967);
	      },
	      Extractors: function Extractors() {
	        return __webpack_require__(962);
	      },
	      FieldGraphs: function FieldGraphs() {
	        return __webpack_require__(653);
	      },
	      FieldQuickValues: function FieldQuickValues() {
	        return __webpack_require__(654);
	      },
	      Fields: function Fields() {
	        return __webpack_require__(656);
	      },
	      FieldStatistics: function FieldStatistics() {
	        return __webpack_require__(655);
	      },
	      Focus: function Focus() {
	        return __webpack_require__(999);
	      },
	      GettingStarted: function GettingStarted() {
	        return __webpack_require__(963);
	      },
	      GlobalThroughput: function GlobalThroughput() {
	        return __webpack_require__(982);
	      },
	      GrokPatterns: function GrokPatterns() {
	        return __webpack_require__(657);
	      },
	      HistogramData: function HistogramData() {
	        return __webpack_require__(992);
	      },
	      IndexerCluster: function IndexerCluster() {
	        return __webpack_require__(964);
	      },
	      IndexerFailures: function IndexerFailures() {
	        return __webpack_require__(965);
	      },
	      IndexerOverview: function IndexerOverview() {
	        return __webpack_require__(966);
	      },
	      IndexRanges: function IndexRanges() {
	        return __webpack_require__(968);
	      },
	      Indices: function Indices() {
	        return __webpack_require__(970);
	      },
	      IndicesConfiguration: function IndicesConfiguration() {
	        return __webpack_require__(969);
	      },
	      Inputs: function Inputs() {
	        return __webpack_require__(974);
	      },
	      InputStates: function InputStates() {
	        return __webpack_require__(971);
	      },
	      InputStaticFields: function InputStaticFields() {
	        return __webpack_require__(972);
	      },
	      InputTypes: function InputTypes() {
	        return __webpack_require__(973);
	      },
	      Journal: function Journal() {
	        return __webpack_require__(975);
	      },
	      LdapGroups: function LdapGroups() {
	        return __webpack_require__(976);
	      },
	      Ldap: function Ldap() {
	        return __webpack_require__(977);
	      },
	      Loggers: function Loggers() {
	        return __webpack_require__(995);
	      },
	      MessageCounts: function MessageCounts() {
	        return __webpack_require__(979);
	      },
	      MessageFields: function MessageFields() {
	        return __webpack_require__(980);
	      },
	      Messages: function Messages() {
	        return __webpack_require__(981);
	      },
	      Metrics: function Metrics() {
	        return __webpack_require__(983);
	      },
	      Nodes: function Nodes() {
	        return __webpack_require__(984);
	      },
	      Notifications: function Notifications() {
	        return __webpack_require__(986);
	      },
	      Outputs: function Outputs() {
	        return __webpack_require__(658);
	      },
	      Plugins: function Plugins() {
	        return __webpack_require__(987);
	      },
	      Preferences: function Preferences() {
	        return __webpack_require__(665);
	      },
	      Refresh: function Refresh() {
	        return __webpack_require__(1000);
	      },
	      Roles: function Roles() {
	        return __webpack_require__(666);
	      },
	      SavedSearches: function SavedSearches() {
	        return __webpack_require__(988);
	      },
	      Search: function Search() {
	        return __webpack_require__(659);
	      },
	      ServerAvailability: function ServerAvailability() {
	        return __webpack_require__(990);
	      },
	      Session: function Session() {
	        return __webpack_require__(991);
	      },
	      SingleNode: function SingleNode() {
	        return __webpack_require__(985);
	      },
	      Sources: function Sources() {
	        return __webpack_require__(660);
	      },
	      Startpage: function Startpage() {
	        return __webpack_require__(1002);
	      },
	      StreamRules: function StreamRules() {
	        return __webpack_require__(661);
	      },
	      Streams: function Streams() {
	        return __webpack_require__(662);
	      },
	      System: function System() {
	        return __webpack_require__(996);
	      },
	      SystemJobs: function SystemJobs() {
	        return __webpack_require__(997);
	      },
	      SystemLoadBalancer: function SystemLoadBalancer() {
	        return __webpack_require__(978);
	      },
	      SystemMessages: function SystemMessages() {
	        return __webpack_require__(998);
	      },
	      SystemProcessing: function SystemProcessing() {
	        return __webpack_require__(993);
	      },
	      SystemShutdown: function SystemShutdown() {
	        return __webpack_require__(994);
	      },
	      Tools: function Tools() {
	        return __webpack_require__(663);
	      },
	      UniversalSearch: function UniversalSearch() {
	        return __webpack_require__(989);
	      },
	      UsageStatsOptOut: function UsageStatsOptOut() {
	        return __webpack_require__(664);
	      },
	      Users: function Users() {
	        return __webpack_require__(667);
	      },
	      Widgets: function Widgets() {
	        return __webpack_require__(668);
	      }
	    };
	    /* eslint-enable import/no-require */
	  }
	
	  _createClass(CombinedProvider, [{
	    key: 'get',
	    value: function get(name) {
	      var result = {};
	      if (this.stores[name]) {
	        result[name + 'Store'] = this.stores[name]();
	      }
	      if (this.actions[name]) {
	        result[name + 'Actions'] = this.actions[name]();
	      }
	      return result;
	    }
	  }]);
	
	  return CombinedProvider;
	})();
	
	if (typeof window.combinedProvider === 'undefined') {
	  window.combinedProvider = new CombinedProvider();
	}
	
	exports['default'] = window.combinedProvider;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _history = __webpack_require__(1166);
	
	if (!window.graylogHistory) {
	  window.graylogHistory = (0, _history.createHistory)();
	}
	
	exports['default'] = window.graylogHistory;
	module.exports = exports['default'];

/***/ },
/* 207 */,
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 2.11.0
	 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule.js");
	var Queue = _dereq_("./queue.js");
	var util = _dereq_("./util.js");
	
	function Async() {
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule =
	        schedule.isStatic ? schedule(this.drainQueues) : schedule;
	}
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.enableTrampoline = function() {
	    if (!this._trampolineEnabled) {
	        this._trampolineEnabled = true;
	        this._schedule = function(fn) {
	            setTimeout(fn, 0);
	        };
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._normalQueue.length() > 0;
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    if (schedule.isStatic) {
	        schedule = function(fn) { setTimeout(fn, 0); };
	    }
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = new Async();
	module.exports.firstLineError = firstLineError;
	
	},{"./queue.js":28,"./schedule.js":31,"./util.js":38}],3:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (this._isPending()) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, ret._progress, ret, context);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 131072;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~131072);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 131072) === 131072;
	};
	
	Promise.bind = function (thisArg, value) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        maybePromise._then(function() {
	            ret._resolveCallback(value);
	        }, ret._reject, ret._progress, ret, null);
	    } else {
	        ret._resolveCallback(value);
	    }
	    return ret;
	};
	};
	
	},{}],4:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise.js")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise.js":23}],5:[function(_dereq_,module,exports){
	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (false) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	    if (false) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};
	
	},{"./util.js":38}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var errors = _dereq_("./errors.js");
	var async = _dereq_("./async.js");
	var CancellationError = errors.CancellationError;
	
	Promise.prototype._cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    var parent;
	    var promiseToReject = this;
	    while ((parent = promiseToReject._cancellationParent) !== undefined &&
	        parent.isCancellable()) {
	        promiseToReject = parent;
	    }
	    this._unsetCancellable();
	    promiseToReject._target()._rejectCallback(reason, false, true);
	};
	
	Promise.prototype.cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    if (reason === undefined) reason = new CancellationError();
	    async.invokeLater(this._cancel, this, reason);
	    return this;
	};
	
	Promise.prototype.cancellable = function () {
	    if (this._cancellable()) return this;
	    async.enableTrampoline();
	    this._setCancellable();
	    this._cancellationParent = undefined;
	    return this;
	};
	
	Promise.prototype.uncancellable = function () {
	    var ret = this.then();
	    ret._unsetCancellable();
	    return ret;
	};
	
	Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
	    var ret = this._then(didFulfill, didReject, didProgress,
	                         undefined, undefined);
	
	    ret._setCancellable();
	    ret._cancellationParent = undefined;
	    return ret;
	};
	};
	
	},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var warn;
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.parent = function() {
	    return this._parent;
	};
	
	CapturedTrace.prototype.hasParent = function() {
	    return this._parent !== undefined;
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = CapturedTrace.parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = stackFramePattern.test(line) ||
	            "    (No stack trace)" === line;
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	CapturedTrace.parseStackAndMessage = function(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	};
	
	CapturedTrace.formatAndLogError = function(error, title) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (typeof error === "object" || typeof error === "function") {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof warn === "function") {
	            warn(message);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	};
	
	CapturedTrace.unhandledRejection = function (reason) {
	    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
	};
	
	CapturedTrace.isSupported = function () {
	    return typeof captureStackTrace === "function";
	};
	
	CapturedTrace.fireRejectionEvent =
	function(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent(name, reason, promise);
	    } catch (e) {
	        globalEventFired = true;
	        async.throwLater(e);
	    }
	
	    var domEventFired = false;
	    if (fireDomEvent) {
	        try {
	            domEventFired = fireDomEvent(name.toLowerCase(), {
	                reason: reason,
	                promise: promise
	            });
	        } catch (e) {
	            domEventFired = true;
	            async.throwLater(e);
	        }
	    }
	
	    if (!globalEventFired && !localEventFired && !domEventFired &&
	        name === "unhandledRejection") {
	        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
	    }
	};
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj.toString();
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	CapturedTrace.setBounds = function(firstLineError, lastLineError) {
	    if (!CapturedTrace.isSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit = Error.stackTraceLimit + 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	var fireDomEvent;
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function(name, reason, promise) {
	            if (name === "rejectionHandled") {
	                return process.emit(name, promise);
	            } else {
	                return process.emit(name, reason, promise);
	            }
	        };
	    } else {
	        var customEventWorks = false;
	        var anyEventWorks = true;
	        try {
	            var ev = new self.CustomEvent("test");
	            customEventWorks = ev instanceof CustomEvent;
	        } catch (e) {}
	        if (!customEventWorks) {
	            try {
	                var event = document.createEvent("CustomEvent");
	                event.initCustomEvent("testingtheevent", false, true, {});
	                self.dispatchEvent(event);
	            } catch (e) {
	                anyEventWorks = false;
	            }
	        }
	        if (anyEventWorks) {
	            fireDomEvent = function(type, detail) {
	                var event;
	                if (customEventWorks) {
	                    event = new self.CustomEvent(type, {
	                        detail: detail,
	                        bubbles: false,
	                        cancelable: true
	                    });
	                } else if (self.dispatchEvent) {
	                    event = document.createEvent("CustomEvent");
	                    event.initCustomEvent(type, false, true, detail);
	                }
	
	                return event ? !self.dispatchEvent(event) : false;
	            };
	        }
	
	        var toWindowMethodNameMap = {};
	        toWindowMethodNameMap["unhandledRejection"] = ("on" +
	            "unhandledRejection").toLowerCase();
	        toWindowMethodNameMap["rejectionHandled"] = ("on" +
	            "rejectionHandled").toLowerCase();
	
	        return function(name, reason, promise) {
	            var methodName = toWindowMethodNameMap[name];
	            var method = self[methodName];
	            if (!method) return false;
	            if (name === "rejectionHandled") {
	                method.call(self, promise);
	            } else {
	                method.call(self, reason, promise);
	            }
	            return true;
	        };
	    }
	})();
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    warn = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        warn = function(message) {
	            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        warn = function(message) {
	            console.warn("%c" + message, "color: red");
	        };
	    }
	}
	
	return CapturedTrace;
	};
	
	},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util.js");
	var errors = _dereq_("./errors.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var keys = _dereq_("./es5.js").keys;
	var TypeError = errors.TypeError;
	
	function CatchFilter(instances, callback, promise) {
	    this._instances = instances;
	    this._callback = callback;
	    this._promise = promise;
	}
	
	function safePredicate(predicate, e) {
	    var safeObject = {};
	    var retfilter = tryCatch(predicate).call(safeObject, e);
	
	    if (retfilter === errorObj) return retfilter;
	
	    var safeKeys = keys(safeObject);
	    if (safeKeys.length) {
	        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
	        return errorObj;
	    }
	    return retfilter;
	}
	
	CatchFilter.prototype.doFilter = function (e) {
	    var cb = this._callback;
	    var promise = this._promise;
	    var boundTo = promise._boundValue();
	    for (var i = 0, len = this._instances.length; i < len; ++i) {
	        var item = this._instances[i];
	        var itemIsErrorType = item === Error ||
	            (item != null && item.prototype instanceof Error);
	
	        if (itemIsErrorType && e instanceof item) {
	            var ret = tryCatch(cb).call(boundTo, e);
	            if (ret === errorObj) {
	                NEXT_FILTER.e = ret.e;
	                return NEXT_FILTER;
	            }
	            return ret;
	        } else if (typeof item === "function" && !itemIsErrorType) {
	            var shouldHandle = safePredicate(item, e);
	            if (shouldHandle === errorObj) {
	                e = errorObj.e;
	                break;
	            } else if (shouldHandle) {
	                var ret = tryCatch(cb).call(boundTo, e);
	                if (ret === errorObj) {
	                    NEXT_FILTER.e = ret.e;
	                    return NEXT_FILTER;
	                }
	                return ret;
	            }
	        }
	    }
	    NEXT_FILTER.e = e;
	    return NEXT_FILTER;
	};
	
	return CatchFilter;
	};
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, CapturedTrace, isDebugging) {
	var contextStack = [];
	function Context() {
	    this._trace = new CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.pop();
	    }
	};
	
	function createContext() {
	    if (isDebugging()) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	
	Promise.prototype._peekContext = peekContext;
	Promise.prototype._pushContext = Context.prototype._pushContext;
	Promise.prototype._popContext = Context.prototype._popContext;
	
	return createContext;
	};
	
	},{}],10:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, CapturedTrace) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var Warning = _dereq_("./errors.js").Warning;
	var util = _dereq_("./util.js");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var debugging = false || (util.isNode &&
	                    (!!process.env["BLUEBIRD_DEBUG"] ||
	                     process.env["NODE_ENV"] === "development"));
	
	if (util.isNode && process.env["BLUEBIRD_DEBUG"] == 0) debugging = false;
	
	if (debugging) {
	    async.disableTrampolineIfNecessary();
	}
	
	Promise.prototype._ignoreRejections = function() {
	    this._unsetRejectionIsUnhandled();
	    this._bitField = this._bitField | 16777216;
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 16777216) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    CapturedTrace.fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._getCarriedStackTrace() || this._settledValue;
	        this._setUnhandledRejectionIsNotified();
	        CapturedTrace.fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 524288;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~524288);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 524288) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 2097152;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~2097152);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 2097152) > 0;
	};
	
	Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
	    this._bitField = this._bitField | 1048576;
	    this._fulfillmentHandler0 = capturedTrace;
	};
	
	Promise.prototype._isCarryingStackTrace = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._getCarriedStackTrace = function () {
	    return this._isCarryingStackTrace()
	        ? this._fulfillmentHandler0
	        : undefined;
	};
	
	Promise.prototype._captureStackTrace = function () {
	    if (debugging) {
	        this._trace = new CapturedTrace(this._peekContext());
	    }
	    return this;
	};
	
	Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
	    if (debugging && canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = CapturedTrace.parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	};
	
	Promise.prototype._warn = function(message) {
	    var warning = new Warning(message);
	    var ctx = this._peekContext();
	    if (ctx) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = CapturedTrace.parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	    CapturedTrace.formatAndLogError(warning, "");
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() &&
	        debugging === false
	   ) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
	    }
	    debugging = CapturedTrace.isSupported();
	    if (debugging) {
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return debugging && CapturedTrace.isSupported();
	};
	
	if (!CapturedTrace.isSupported()) {
	    Promise.longStackTraces = function(){};
	    debugging = false;
	}
	
	return function() {
	    return debugging;
	};
	};
	
	},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	
	module.exports = function(Promise) {
	var returner = function () {
	    return this;
	};
	var thrower = function () {
	    throw this;
	};
	var returnUndefined = function() {};
	var throwUndefined = function() {
	    throw undefined;
	};
	
	var wrapper = function (value, action) {
	    if (action === 1) {
	        return function () {
	            throw value;
	        };
	    } else if (action === 2) {
	        return function () {
	            return value;
	        };
	    }
	};
	
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value === undefined) return this.then(returnUndefined);
	
	    if (isPrimitive(value)) {
	        return this._then(
	            wrapper(value, 2),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    } else if (value instanceof Promise) {
	        value._ignoreRejections();
	    }
	    return this._then(returner, undefined, undefined, value, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    if (reason === undefined) return this.then(throwUndefined);
	
	    if (isPrimitive(reason)) {
	        return this._then(
	            wrapper(reason, 1),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    }
	    return this._then(thrower, undefined, undefined, reason, undefined);
	};
	};
	
	},{"./util.js":38}],12:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, null, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, null, INTERNAL);
	};
	};
	
	},{}],13:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5.js");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util.js");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};
	
	},{}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	var thrower = util.thrower;
	
	function returnThis() {
	    return this;
	}
	function throwThis() {
	    throw this;
	}
	function return$(r) {
	    return function() {
	        return r;
	    };
	}
	function throw$(r) {
	    return function() {
	        throw r;
	    };
	}
	function promisedFinally(ret, reasonOrValue, isFulfilled) {
	    var then;
	    if (isPrimitive(reasonOrValue)) {
	        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
	    } else {
	        then = isFulfilled ? returnThis : throwThis;
	    }
	    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
	}
	
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue())
	                    : handler();
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, reasonOrValue,
	                                    promise.isFulfilled());
	        }
	    }
	
	    if (promise.isRejected()) {
	        NEXT_FILTER.e = reasonOrValue;
	        return NEXT_FILTER;
	    } else {
	        return reasonOrValue;
	    }
	}
	
	function tapHandler(value) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue(), value)
	                    : handler(value);
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, value, true);
	        }
	    }
	    return value;
	}
	
	Promise.prototype._passThroughHandler = function (handler, isFinally) {
	    if (typeof handler !== "function") return this.then();
	
	    var promiseAndHandler = {
	        promise: this,
	        handler: handler
	    };
	
	    return this._then(
	            isFinally ? finallyHandler : tapHandler,
	            isFinally ? finallyHandler : undefined, undefined,
	            promiseAndHandler, undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThroughHandler(handler, true);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThroughHandler(handler, false);
	};
	};
	
	},{"./util.js":38}],17:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise) {
	var errors = _dereq_("./errors.js");
	var TypeError = errors.TypeError;
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    var promise = this._promise = new Promise(INTERNAL);
	    promise._captureStackTrace();
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	}
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._next(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    if (result === errorObj) {
	        return this._promise._rejectCallback(result.e, false, true);
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._promise._resolveCallback(value);
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._throw(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise._then(
	            this._next,
	            this._throw,
	            undefined,
	            this,
	            null
	       );
	    }
	};
	
	PromiseSpawn.prototype._throw = function (reason) {
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._next = function (value) {
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        spawn._generator = generator;
	        spawn._next(undefined);
	        return spawn.promise();
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};
	
	},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var caller = function(count) {
	        var values = [];
	        for (var i = 1; i <= count; ++i) values.push("holder.p" + i);
	        return new Function("holder", "                                      \n\
	            'use strict';                                                    \n\
	            var callback = holder.fn;                                        \n\
	            return callback(values);                                         \n\
	            ".replace(/values/g, values.join(", ")));
	    };
	    var thenCallbacks = [];
	    var callers = [undefined];
	    for (var i = 1; i <= 5; ++i) {
	        thenCallbacks.push(thenCallback(i));
	        callers.push(caller(i));
	    }
	
	    var Holder = function(total, fn) {
	        this.p1 = this.p2 = this.p3 = this.p4 = this.p5 = null;
	        this.fn = fn;
	        this.total = total;
	        this.now = 0;
	    };
	
	    Holder.prototype.callers = callers;
	    Holder.prototype.checkFulfillment = function(promise) {
	        var now = this.now;
	        now++;
	        var total = this.total;
	        if (now >= total) {
	            var handler = this.callers[total];
	            promise._pushContext();
	            var ret = tryCatch(handler)(this);
	            promise._popContext();
	            if (ret === errorObj) {
	                promise._rejectCallback(ret.e, false, true);
	            } else {
	                promise._resolveCallback(ret);
	            }
	        } else {
	            this.now = now;
	        }
	    };
	
	    var reject = function (reason) {
	        this._reject(reason);
	    };
	}
	}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last < 6 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var holder = new Holder(last, fn);
	                var callbacks = thenCallbacks;
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        if (maybePromise._isPending()) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                        } else if (maybePromise._isFulfilled()) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else {
	                            ret._reject(maybePromise._reason());
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util.js":38}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var PENDING = {};
	var EMPTY_ARRAY = [];
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
	    async.invoke(init, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	function init() {this._init$(undefined, -2);}
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	    if (values[index] === PENDING) {
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var callback = this._callback;
	        var receiver = this._promise._boundValue();
	        this._promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        this._promise._popContext();
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = PENDING;
	                return maybePromise._proxyPromiseArray(this, index);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	
	    }
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    var limit = typeof options === "object" && options !== null
	        ? options.concurrency
	        : 0;
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter);
	}
	
	Promise.prototype.map = function (fn, options) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	    return map(this, fn, options, null).promise();
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    return map(promises, fn, options, _filter).promise();
	};
	
	
	};
	
	},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        ret._popContext();
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn, args, ctx) {
	    if (typeof fn !== "function") {
	        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value = util.isArray(args)
	        ? tryCatch(fn).apply(ctx, args)
	        : tryCatch(fn).call(ctx, args);
	    ret._popContext();
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false, true);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util.js":38}],21:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var target = promise._target();
	        var newReason = target._getCarriedStackTrace();
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback =
	Promise.prototype.nodeify = function (nodeback, options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};
	
	},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	Promise.prototype.progressed = function (handler) {
	    return this._then(undefined, undefined, handler, undefined, undefined);
	};
	
	Promise.prototype._progress = function (progressValue) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._target()._progressUnchecked(progressValue);
	
	};
	
	Promise.prototype._progressHandlerAt = function (index) {
	    return index === 0
	        ? this._progressHandler0
	        : this[(index << 2) + index - 5 + 2];
	};
	
	Promise.prototype._doProgressWith = function (progression) {
	    var progressValue = progression.value;
	    var handler = progression.handler;
	    var promise = progression.promise;
	    var receiver = progression.receiver;
	
	    var ret = tryCatch(handler).call(receiver, progressValue);
	    if (ret === errorObj) {
	        if (ret.e != null &&
	            ret.e.name !== "StopProgressPropagation") {
	            var trace = util.canAttachTrace(ret.e)
	                ? ret.e : new Error(util.toString(ret.e));
	            promise._attachExtraTrace(trace);
	            promise._progress(ret.e);
	        }
	    } else if (ret instanceof Promise) {
	        ret._then(promise._progress, null, null, promise, undefined);
	    } else {
	        promise._progress(ret);
	    }
	};
	
	
	Promise.prototype._progressUnchecked = function (progressValue) {
	    var len = this._length();
	    var progress = this._progress;
	    for (var i = 0; i < len; i++) {
	        var handler = this._progressHandlerAt(i);
	        var promise = this._promiseAt(i);
	        if (!(promise instanceof Promise)) {
	            var receiver = this._receiverAt(i);
	            if (typeof handler === "function") {
	                handler.call(receiver, progressValue, promise);
	            } else if (receiver instanceof PromiseArray &&
	                       !receiver._isResolved()) {
	                receiver._promiseProgressed(progressValue, promise);
	            }
	            continue;
	        }
	
	        if (typeof handler === "function") {
	            async.invoke(this._doProgressWith, this, {
	                handler: handler,
	                promise: promise,
	                receiver: this._receiverAt(i),
	                value: progressValue
	            });
	        } else {
	            async.invoke(progress, promise, progressValue);
	        }
	    }
	};
	};
	
	},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
	};
	var reflect = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	
	var util = _dereq_("./util.js");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var UNDEFINED_BINDING = {};
	var async = _dereq_("./async.js");
	var errors = _dereq_("./errors.js");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {e: null};
	var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array.js")(Promise, INTERNAL,
	                                    tryConvertToPromise, apiRejection);
	var CapturedTrace = _dereq_("./captured_trace.js")();
	var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
	 /*jshint unused:false*/
	var createContext =
	    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
	var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
	var PromiseResolver = _dereq_("./promise_resolver.js");
	var nodebackForPromise = PromiseResolver._nodebackForPromise;
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	
	function Promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
	    }
	    if (this.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._progressHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settledValue = undefined;
	    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (typeof item === "function") {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(
	                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        var catchFilter = new CatchFilter(catchInstances, fn, this);
	        return this._then(undefined, catchFilter.doFilter, undefined,
	            catchFilter, undefined);
	    }
	    return this._then(undefined, fn, undefined, undefined, undefined);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflect, reflect, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject, didProgress) {
	    if (isDebugging() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject, didProgress) {
	    var promise = this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (didFulfill, didReject) {
	    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
	};
	
	Promise.prototype.isCancellable = function () {
	    return !this.isResolved() &&
	        this._cancellable();
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = function(fn) {
	    var ret = new Promise(INTERNAL);
	    var result = tryCatch(fn)(nodebackForPromise(ret));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true, true);
	    }
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.defer = Promise.pending = function () {
	    var promise = new Promise(INTERNAL);
	    return new PromiseResolver(promise);
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        var val = ret;
	        ret = new Promise(INTERNAL);
	        ret._fulfillUnchecked(val);
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var prev = async._schedule;
	    async._schedule = fn;
	    return prev;
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    didProgress,
	    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var ret = haveInternalData ? internalData : new Promise(INTERNAL);
	
	    if (!haveInternalData) {
	        ret._propagateFrom(this, 4 | 1);
	        ret._captureStackTrace();
	    }
	
	    var target = this._target();
	    if (target !== this) {
	        if (receiver === undefined) receiver = this._boundTo;
	        if (!haveInternalData) ret._setIsMigrated();
	    }
	
	    var callbackIndex = target._addCallbacks(didFulfill,
	                                             didReject,
	                                             didProgress,
	                                             ret,
	                                             receiver,
	                                             getDomain());
	
	    if (target._isResolved() && !target._isSettlePromisesQueued()) {
	        async.invoke(
	            target._settlePromiseAtPostResolution, target, callbackIndex);
	    }
	
	    return ret;
	};
	
	Promise.prototype._settlePromiseAtPostResolution = function (index) {
	    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
	    this._settlePromiseAt(index);
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 131071;
	};
	
	Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
	    return (this._bitField & 939524096) > 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 536870912) === 536870912;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -131072) |
	        (len & 131071);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 536870912;
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 33554432;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 33554432) > 0;
	};
	
	Promise.prototype._cancellable = function () {
	    return (this._bitField & 67108864) > 0;
	};
	
	Promise.prototype._setCancellable = function () {
	    this._bitField = this._bitField | 67108864;
	};
	
	Promise.prototype._unsetCancellable = function () {
	    this._bitField = this._bitField & (~67108864);
	};
	
	Promise.prototype._setIsMigrated = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._unsetIsMigrated = function () {
	    this._bitField = this._bitField & (~4194304);
	};
	
	Promise.prototype._isMigrated = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0
	        ? this._receiver0
	        : this[
	            index * 5 - 5 + 4];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return index === 0
	        ? this._promise0
	        : this[index * 5 - 5 + 3];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return index === 0
	        ? this._fulfillmentHandler0
	        : this[index * 5 - 5 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return index === 0
	        ? this._rejectionHandler0
	        : this[index * 5 - 5 + 1];
	};
	
	Promise.prototype._boundValue = function() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	};
	
	Promise.prototype._migrateCallbacks = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var progress = follower._progressHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (promise instanceof Promise) promise._setIsMigrated();
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    progress,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        if (receiver !== undefined) this._receiver0 = receiver;
	        if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this._progressHandler0 =
	                domain === null ? progress : domain.bind(progress);
	        }
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promise;
	        this[base + 4] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this[base + 2] =
	                domain === null ? progress : domain.bind(progress);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	    if (index === 0) {
	        this._promise0 = promiseSlotValue;
	        this._receiver0 = receiver;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promiseSlotValue;
	        this[base + 4] = receiver;
	    }
	    this._setLength(index + 1);
	};
	
	Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
	    this._setProxyHandlers(promiseArray, index);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false, true);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    var propagationFlags = 1 | (shouldBind ? 4 : 0);
	    this._propagateFrom(maybePromise, propagationFlags);
	    var promise = maybePromise._target();
	    if (promise._isPending()) {
	        var len = this._length();
	        for (var i = 0; i < len; ++i) {
	            promise._migrateCallbacks(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (promise._isFulfilled()) {
	        this._fulfillUnchecked(promise._value());
	    } else {
	        this._rejectUnchecked(promise._reason(),
	            promise._getCarriedStackTrace());
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
	    if (!shouldNotMarkOriginatingFromRejection) {
	        util.markAsOriginatingFromRejection(reason);
	    }
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason, hasStack ? undefined : trace);
	};
	
	Promise.prototype._resolveFromResolver = function (resolver) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = tryCatch(resolver)(function(value) {
	        if (promise === null) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }, function (reason) {
	        if (promise === null) return;
	        promise._rejectCallback(reason, synchronous);
	        promise = null;
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined && r === errorObj && promise !== null) {
	        promise._rejectCallback(r.e, true, true);
	        promise = null;
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    if (promise._isRejected()) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY && !this._isRejected()) {
	        x = tryCatch(handler).apply(this._boundValue(), value);
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    promise._popContext();
	
	    if (x === errorObj || x === promise || x === NEXT_FILTER) {
	        var err = x === promise ? makeSelfResolutionError() : x.e;
	        promise._rejectCallback(err, false, true);
	    } else {
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._cleanValues = function () {
	    if (this._cancellable()) {
	        this._cancellationParent = undefined;
	    }
	};
	
	Promise.prototype._propagateFrom = function (parent, flags) {
	    if ((flags & 1) > 0 && parent._cancellable()) {
	        this._setCancellable();
	        this._cancellationParent = parent;
	    }
	    if ((flags & 4) > 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	};
	
	Promise.prototype._fulfill = function (value) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._fulfillUnchecked(value);
	};
	
	Promise.prototype._reject = function (reason, carriedStackTrace) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._rejectUnchecked(reason, carriedStackTrace);
	};
	
	Promise.prototype._settlePromiseAt = function (index) {
	    var promise = this._promiseAt(index);
	    var isPromise = promise instanceof Promise;
	
	    if (isPromise && promise._isMigrated()) {
	        promise._unsetIsMigrated();
	        return async.invoke(this._settlePromiseAt, this, index);
	    }
	    var handler = this._isFulfilled()
	        ? this._fulfillmentHandlerAt(index)
	        : this._rejectionHandlerAt(index);
	
	    var carriedStackTrace =
	        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
	    var value = this._settledValue;
	    var receiver = this._receiverAt(index);
	    this._clearCallbackDataAtIndex(index);
	
	    if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof PromiseArray) {
	        if (!receiver._isResolved()) {
	            if (this._isFulfilled()) {
	                receiver._promiseFulfilled(value, promise);
	            }
	            else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (this._isFulfilled()) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value, carriedStackTrace);
	        }
	    }
	
	    if (index >= 4 && (index & 31) === 4)
	        async.invokeLater(this._setLength, this, 0);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    if (index === 0) {
	        if (!this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 = undefined;
	        }
	        this._rejectionHandler0 =
	        this._progressHandler0 =
	        this._receiver0 =
	        this._promise0 = undefined;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] =
	        this[base + 4] =
	        this[base + 0] =
	        this[base + 1] =
	        this[base + 2] = undefined;
	    }
	};
	
	Promise.prototype._isSettlePromisesQueued = function () {
	    return (this._bitField &
	            -1073741824) === -1073741824;
	};
	
	Promise.prototype._setSettlePromisesQueued = function () {
	    this._bitField = this._bitField | -1073741824;
	};
	
	Promise.prototype._unsetSettlePromisesQueued = function () {
	    this._bitField = this._bitField & (~-1073741824);
	};
	
	Promise.prototype._queueSettlePromises = function() {
	    async.settlePromises(this);
	    this._setSettlePromisesQueued();
	};
	
	Promise.prototype._fulfillUnchecked = function (value) {
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err, undefined);
	    }
	    this._setFulfilled();
	    this._settledValue = value;
	    this._cleanValues();
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    }
	};
	
	Promise.prototype._rejectUncheckedCheckError = function (reason) {
	    var trace = util.ensureErrorObject(reason);
	    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
	};
	
	Promise.prototype._rejectUnchecked = function (reason, trace) {
	    if (reason === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err);
	    }
	    this._setRejected();
	    this._settledValue = reason;
	    this._cleanValues();
	
	    if (this._isFinal()) {
	        async.throwLater(function(e) {
	            if ("stack" in e) {
	                async.invokeFirst(
	                    CapturedTrace.unhandledRejection, undefined, e);
	            }
	            throw e;
	        }, trace === undefined ? reason : trace);
	        return;
	    }
	
	    if (trace !== undefined && trace !== reason) {
	        this._setCarriedStackTrace(trace);
	    }
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    this._unsetSettlePromisesQueued();
	    var len = this._length();
	    for (var i = 0; i < len; i++) {
	        this._settlePromiseAt(i);
	    }
	};
	
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./progress.js")(Promise, PromiseArray);
	_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
	_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
	_dereq_("./direct_resolve.js")(Promise);
	_dereq_("./synchronous_inspection.js")(Promise);
	_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
	Promise.version = "2.11.0";
	Promise.Promise = Promise;
	_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./cancel.js')(Promise);
	_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
	_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
	_dereq_('./nodeify.js')(Promise);
	_dereq_('./call_get.js')(Promise);
	_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./settle.js')(Promise, PromiseArray);
	_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
	_dereq_('./promisify.js')(Promise, INTERNAL);
	_dereq_('./any.js')(Promise);
	_dereq_('./each.js')(Promise, INTERNAL);
	_dereq_('./timers.js')(Promise, INTERNAL);
	_dereq_('./filter.js')(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._progressHandler0 = value;                                         
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	        p._settledValue = value;                                             
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
	    return Promise;                                                          
	
	};
	
	},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection) {
	var util = _dereq_("./util.js");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    var parent;
	    if (values instanceof Promise) {
	        parent = values;
	        promise._propagateFrom(parent, 1 | 4);
	    }
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        this._values = values;
	        if (values._isFulfilled()) {
	            values = values._value();
	            if (!isArray(values)) {
	                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	                this.__hardReject__(err);
	                return;
	            }
	        } else if (values._isPending()) {
	            values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	            return;
	        } else {
	            this._reject(values._reason());
	            return;
	        }
	    } else if (!isArray(values)) {
	        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var promise = this._promise;
	    for (var i = 0; i < len; ++i) {
	        var isResolved = this._isResolved();
	        var maybePromise = tryConvertToPromise(values[i], promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (isResolved) {
	                maybePromise._ignoreRejections();
	            } else if (maybePromise._isPending()) {
	                maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                this._promiseFulfilled(maybePromise._value(), i);
	            } else {
	                this._promiseRejected(maybePromise._reason(), i);
	            }
	        } else if (!isResolved) {
	            this._promiseFulfilled(maybePromise, i);
	        }
	    }
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype.__hardReject__ =
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false, true);
	};
	
	PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
	    this._promise._progress({
	        index: index,
	        value: progressValue
	    });
	};
	
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	PromiseArray.prototype._promiseRejected = function (reason, index) {
	    this._totalResolved++;
	    this._reject(reason);
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util.js":38}],25:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util.js");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors.js");
	var TimeoutError = errors.TimeoutError;
	var OperationalError = errors.OperationalError;
	var haveGetters = util.haveGetters;
	var es5 = _dereq_("./es5.js");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise) {
	    return function(err, value) {
	        if (promise === null) return;
	
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (arguments.length > 2) {
	            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	            promise._fulfill(args);
	        } else {
	            promise._fulfill(value);
	        }
	
	        promise = null;
	    };
	}
	
	
	var PromiseResolver;
	if (!haveGetters) {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	        this.asCallback = nodebackForPromise(promise);
	        this.callback = this.asCallback;
	    };
	}
	else {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	    };
	}
	if (haveGetters) {
	    var prop = {
	        get: function() {
	            return nodebackForPromise(this.promise);
	        }
	    };
	    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
	    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
	}
	
	PromiseResolver._nodebackForPromise = nodebackForPromise;
	
	PromiseResolver.prototype.toString = function () {
	    return "[object PromiseResolver]";
	};
	
	PromiseResolver.prototype.resolve =
	PromiseResolver.prototype.fulfill = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._resolveCallback(value);
	};
	
	PromiseResolver.prototype.reject = function (reason) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._rejectCallback(reason);
	};
	
	PromiseResolver.prototype.progress = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._progress(value);
	};
	
	PromiseResolver.prototype.cancel = function (err) {
	    this.promise.cancel(err);
	};
	
	PromiseResolver.prototype.timeout = function () {
	    this.reject(new TimeoutError("timeout"));
	};
	
	PromiseResolver.prototype.isResolved = function () {
	    return this.promise.isResolved();
	};
	
	PromiseResolver.prototype.toJSON = function () {
	    return this.promise.toJSON();
	};
	
	module.exports = PromiseResolver;
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = _dereq_("./util.js");
	var nodebackForPromise = _dereq_("./promise_resolver.js")
	    ._nodebackForPromise;
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = _dereq_("./errors").TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (false) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL","'use strict';                            \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise);                      \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	        "
	        .replace("Parameters", parameterDeclaration(newParameterCount))
	        .replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode))(
	            Promise,
	            fn,
	            receiver,
	            withAppended,
	            maybeWrapAsError,
	            nodebackForPromise,
	            util.tryCatch,
	            util.errorObj,
	            util.notEnumerableProp,
	            INTERNAL
	        );
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key, fn, suffix);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver) {
	    return makeNodePromisified(callback, receiver, undefined, callback);
	}
	
	Promise.promisify = function (fn, receiver) {
	    if (typeof fn !== "function") {
	        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
	    }
	    options = Object(options);
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier);
	            promisifyAll(value, suffix, filter, promisifier);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier);
	};
	};
	
	
	},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var isObject = util.isObject;
	var es5 = _dereq_("./es5.js");
	
	function PropertiesPromiseArray(obj) {
	    var keys = es5.keys(obj);
	    var len = keys.length;
	    var values = new Array(len * 2);
	    for (var i = 0; i < len; ++i) {
	        var key = keys[i];
	        values[i] = obj[key];
	        values[i + len] = key;
	    }
	    this.constructor$(values);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {
	    this._init$(undefined, -3) ;
	};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val = {};
	        var keyOffset = this.length();
	        for (var i = 0, len = this.length(); i < len; ++i) {
	            val[this._values[i + keyOffset]] = this._values[i];
	        }
	        this._resolve(val);
	    }
	};
	
	PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
	    this._promise._progress({
	        key: this._values[index + this.length()],
	        value: value
	    });
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 4);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};
	
	},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],29:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var isArray = _dereq_("./util.js").isArray;
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else if (!isArray(promises)) {
	        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 4 | 1);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};
	
	},{"./util.js":38}],30:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	function ReductionPromiseArray(promises, fn, accum, _each) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    this._preservedValues = _each === INTERNAL ? [] : null;
	    this._zerothIsAccum = (accum === undefined);
	    this._gotAccum = false;
	    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
	    this._valuesPhase = undefined;
	    var maybePromise = tryConvertToPromise(accum, this._promise);
	    var rejected = false;
	    var isPromise = maybePromise instanceof Promise;
	    if (isPromise) {
	        maybePromise = maybePromise._target();
	        if (maybePromise._isPending()) {
	            maybePromise._proxyPromiseArray(this, -1);
	        } else if (maybePromise._isFulfilled()) {
	            accum = maybePromise._value();
	            this._gotAccum = true;
	        } else {
	            this._reject(maybePromise._reason());
	            rejected = true;
	        }
	    }
	    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._accum = accum;
	    if (!rejected) async.invoke(init, this, undefined);
	}
	function init() {
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._init = function () {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function () {
	    if (this._gotAccum || this._zerothIsAccum) {
	        this._resolve(this._preservedValues !== null
	                        ? [] : this._accum);
	    }
	};
	
	ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    values[index] = value;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var isEach = preservedValues !== null;
	    var gotAccum = this._gotAccum;
	    var valuesPhase = this._valuesPhase;
	    var valuesPhaseIndex;
	    if (!valuesPhase) {
	        valuesPhase = this._valuesPhase = new Array(length);
	        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
	            valuesPhase[valuesPhaseIndex] = 0;
	        }
	    }
	    valuesPhaseIndex = valuesPhase[index];
	
	    if (index === 0 && this._zerothIsAccum) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	        valuesPhase[index] = ((valuesPhaseIndex === 0)
	            ? 1 : 2);
	    } else if (index === -1) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	    } else {
	        if (valuesPhaseIndex === 0) {
	            valuesPhase[index] = 1;
	        } else {
	            valuesPhase[index] = 2;
	            this._accum = value;
	        }
	    }
	    if (!gotAccum) return;
	
	    var callback = this._callback;
	    var receiver = this._promise._boundValue();
	    var ret;
	
	    for (var i = this._reducingIndex; i < length; ++i) {
	        valuesPhaseIndex = valuesPhase[i];
	        if (valuesPhaseIndex === 2) {
	            this._reducingIndex = i + 1;
	            continue;
	        }
	        if (valuesPhaseIndex !== 1) return;
	        value = values[i];
	        this._promise._pushContext();
	        if (isEach) {
	            preservedValues.push(value);
	            ret = tryCatch(callback).call(receiver, value, i, length);
	        }
	        else {
	            ret = tryCatch(callback)
	                .call(receiver, this._accum, value, i, length);
	        }
	        this._promise._popContext();
	
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                valuesPhase[i] = 4;
	                return maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	
	        this._reducingIndex = i + 1;
	        this._accum = ret;
	    }
	
	    this._resolve(isEach ? preservedValues : this._accum);
	};
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	};
	
	},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
	"use strict";
	var schedule;
	var util = _dereq_("./util");
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	};
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = function(fn) {
	        var div = document.createElement("div");
	        var observer = new MutationObserver(fn);
	        observer.observe(div, {attributes: true});
	        return function() { div.classList.toggle("foo"); };
	    };
	    schedule.isStatic = true;
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":38}],32:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	    function(Promise, PromiseArray) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = _dereq_("./util.js");
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 268435456;
	    ret._settledValue = value;
	    this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 134217728;
	    ret._settledValue = reason;
	    this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return new SettledPromiseArray(this).promise();
	};
	};
	
	},{"./util.js":38}],33:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = _dereq_("./util.js");
	var RangeError = _dereq_("./errors.js").RangeError;
	var AggregateError = _dereq_("./errors.js").AggregateError;
	var isArray = util.isArray;
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	    }
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            e.push(this._values[i]);
	        }
	        this._reject(e);
	    }
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};
	
	},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValue = promise._settledValue;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValue = undefined;
	    }
	}
	
	PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.isFulfilled =
	Promise.prototype._isFulfilled = function () {
	    return (this._bitField & 268435456) > 0;
	};
	
	PromiseInspection.prototype.isRejected =
	Promise.prototype._isRejected = function () {
	    return (this._bitField & 134217728) > 0;
	};
	
	PromiseInspection.prototype.isPending =
	Promise.prototype._isPending = function () {
	    return (this._bitField & 402653184) === 0;
	};
	
	PromiseInspection.prototype.isResolved =
	Promise.prototype._isResolved = function () {
	    return (this._bitField & 402653184) > 0;
	};
	
	Promise.prototype.isPending = function() {
	    return this._target()._isPending();
	};
	
	Promise.prototype.isRejected = function() {
	    return this._target()._isRejected();
	};
	
	Promise.prototype.isFulfilled = function() {
	    return this._target()._isFulfilled();
	};
	
	Promise.prototype.isResolved = function() {
	    return this._target()._isResolved();
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue;
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue;
	};
	
	Promise.prototype.value = function() {
	    var target = this._target();
	    if (!target.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return target._settledValue;
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    if (!target.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    target._unsetRejectionIsUnhandled();
	    return target._settledValue;
	};
	
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) {
	            return obj;
	        }
	        else if (isAnyBluebirdPromise(obj)) {
	            var ret = new Promise(INTERNAL);
	            obj._then(
	                ret._fulfillUnchecked,
	                ret._rejectUncheckedCheckError,
	                ret._progressUnchecked,
	                ret,
	                null
	            );
	            return ret;
	        }
	        var then = util.tryCatch(getThen)(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function getThen(obj) {
	    return obj.then;
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    return hasProp.call(obj, "_promise0");
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x,
	                                        resolveFromThenable,
	                                        rejectFromThenable,
	                                        progressFromThenable);
	    synchronous = false;
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolveFromThenable(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function rejectFromThenable(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	
	    function progressFromThenable(value) {
	        if (!promise) return;
	        if (typeof promise._progress === "function") {
	            promise._progress(value);
	        }
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util.js":38}],36:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var TimeoutError = Promise.TimeoutError;
	
	var afterTimeout = function (promise, message) {
	    if (!promise.isPending()) return;
	    
	    var err;
	    if(!util.isPrimitive(message) && (message instanceof Error)) {
	        err = message;
	    } else {
	        if (typeof message !== "string") {
	            message = "operation timed out";
	        }
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._cancel(err);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (value, ms) {
	    if (ms === undefined) {
	        ms = value;
	        value = undefined;
	        var ret = new Promise(INTERNAL);
	        setTimeout(function() { ret._fulfill(); }, ms);
	        return ret;
	    }
	    ms = +ms;
	    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(this, ms);
	};
	
	function successClear(value) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    return value;
	}
	
	function failureClear(reason) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret = this.then().cancellable();
	    ret._cancellationParent = this;
	    var handle = setTimeout(function timeoutTimeout() {
	        afterTimeout(ret, message);
	    }, ms);
	    return ret._then(successClear, failureClear, undefined, handle, undefined);
	};
	
	};
	
	},{"./util.js":38}],37:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext) {
	    var TypeError = _dereq_("./errors.js").TypeError;
	    var inherits = _dereq_("./util.js").inherits;
	    var PromiseInspection = Promise.PromiseInspection;
	
	    function inspectionMapper(inspections) {
	        var len = inspections.length;
	        for (var i = 0; i < len; ++i) {
	            var inspection = inspections[i];
	            if (inspection.isRejected()) {
	                return Promise.reject(inspection.error());
	            }
	            inspections[i] = inspection._settledValue;
	        }
	        return inspections;
	    }
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = Promise.defer();
	        function iterator() {
	            if (i >= len) return ret.resolve();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret.promise;
	    }
	
	    function disposerSuccess(value) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = value;
	        inspection._bitField = 268435456;
	        return dispose(this, inspection).thenReturn(value);
	    }
	
	    function disposerFail(reason) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = reason;
	        inspection._bitField = 134217728;
	        return dispose(this, inspection).thenThrow(reason);
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return null;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== null
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new Array(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var promise = Promise.settle(resources)
	            .then(inspectionMapper)
	            .then(function(vals) {
	                promise._pushContext();
	                var ret;
	                try {
	                    ret = spreadArgs
	                        ? fn.apply(undefined, vals) : fn.call(undefined,  vals);
	                } finally {
	                    promise._popContext();
	                }
	                return ret;
	            })
	            ._then(
	                disposerSuccess, disposerFail, undefined, resources, undefined);
	        resources.promise = promise;
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 262144;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 262144) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~262144);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};
	
	},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5.js");
	var canEvaluate = typeof navigator == "undefined";
	var haveGetters = (function(){
	    try {
	        var o = {};
	        es5.defineProperty(o, "f", {
	            get: function () {
	                return 3;
	            }
	        });
	        return o.f === 3;
	    }
	    catch (e) {
	        return false;
	    }
	
	})();
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return !isPrimitive(value);
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function f() {}
	    f.prototype = obj;
	    var l = 8;
	    while (l--) new f();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    haveGetters: haveGetters,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]"
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5.js":14}]},{},[4])(4)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47), (function() { return this; }()), __webpack_require__(567).setImmediate))

/***/ },
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b8da99937e164750566d6710f5458e82.gif";

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1231)], __WEBPACK_AMD_DEFINE_RESULT__ = function (d3) {
	            return (root.Rickshaw = factory(d3));
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory(require('d3'));
	    } else {
	        root.Rickshaw = factory(d3);
	    }
	}(this, function (d3) {
	/* jshint -W079 */ 
	
	var Rickshaw = {
	
		namespace: function(namespace, obj) {
	
			var parts = namespace.split('.');
	
			var parent = Rickshaw;
	
			for(var i = 1, length = parts.length; i < length; i++) {
				var currentPart = parts[i];
				parent[currentPart] = parent[currentPart] || {};
				parent = parent[currentPart];
			}
			return parent;
		},
	
		keys: function(obj) {
			var keys = [];
			for (var key in obj) keys.push(key);
			return keys;
		},
	
		extend: function(destination, source) {
	
			for (var property in source) {
				destination[property] = source[property];
			}
			return destination;
		},
	
		clone: function(obj) {
			return JSON.parse(JSON.stringify(obj));
		}
	};
	/* Adapted from https://github.com/Jakobo/PTClass */
	
	/*
	Copyright (c) 2005-2010 Sam Stephenson
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	*/
	/* Based on Alex Arnell's inheritance implementation. */
	/** section: Language
	 * class Class
	 *
	 *  Manages Prototype's class-based OOP system.
	 *
	 *  Refer to Prototype's web site for a [tutorial on classes and
	 *  inheritance](http://prototypejs.org/learn/class-inheritance).
	**/
	(function(globalContext) {
	/* ------------------------------------ */
	/* Import from object.js                */
	/* ------------------------------------ */
	var _toString = Object.prototype.toString,
	    NULL_TYPE = 'Null',
	    UNDEFINED_TYPE = 'Undefined',
	    BOOLEAN_TYPE = 'Boolean',
	    NUMBER_TYPE = 'Number',
	    STRING_TYPE = 'String',
	    OBJECT_TYPE = 'Object',
	    FUNCTION_CLASS = '[object Function]';
	function isFunction(object) {
	  return _toString.call(object) === FUNCTION_CLASS;
	}
	function extend(destination, source) {
	  for (var property in source) if (source.hasOwnProperty(property)) // modify protect primitive slaughter
	    destination[property] = source[property];
	  return destination;
	}
	function keys(object) {
	  if (Type(object) !== OBJECT_TYPE) { throw new TypeError(); }
	  var results = [];
	  for (var property in object) {
	    if (object.hasOwnProperty(property)) {
	      results.push(property);
	    }
	  }
	  return results;
	}
	function Type(o) {
	  switch(o) {
	    case null: return NULL_TYPE;
	    case (void 0): return UNDEFINED_TYPE;
	  }
	  var type = typeof o;
	  switch(type) {
	    case 'boolean': return BOOLEAN_TYPE;
	    case 'number':  return NUMBER_TYPE;
	    case 'string':  return STRING_TYPE;
	  }
	  return OBJECT_TYPE;
	}
	function isUndefined(object) {
	  return typeof object === "undefined";
	}
	/* ------------------------------------ */
	/* Import from Function.js              */
	/* ------------------------------------ */
	var slice = Array.prototype.slice;
	function argumentNames(fn) {
	  var names = fn.toString().match(/^[\s\(]*function[^(]*\(([^)]*)\)/)[1]
	    .replace(/\/\/.*?[\r\n]|\/\*(?:.|[\r\n])*?\*\//g, '')
	    .replace(/\s+/g, '').split(',');
	  return names.length == 1 && !names[0] ? [] : names;
	}
	function wrap(fn, wrapper) {
	  var __method = fn;
	  return function() {
	    var a = update([bind(__method, this)], arguments);
	    return wrapper.apply(this, a);
	  }
	}
	function update(array, args) {
	  var arrayLength = array.length, length = args.length;
	  while (length--) array[arrayLength + length] = args[length];
	  return array;
	}
	function merge(array, args) {
	  array = slice.call(array, 0);
	  return update(array, args);
	}
	function bind(fn, context) {
	  if (arguments.length < 2 && isUndefined(arguments[0])) return this;
	  var __method = fn, args = slice.call(arguments, 2);
	  return function() {
	    var a = merge(args, arguments);
	    return __method.apply(context, a);
	  }
	}
	
	/* ------------------------------------ */
	/* Import from Prototype.js             */
	/* ------------------------------------ */
	var emptyFunction = function(){};
	
	var Class = (function() {
	  
	  // Some versions of JScript fail to enumerate over properties, names of which 
	  // correspond to non-enumerable properties in the prototype chain
	  var IS_DONTENUM_BUGGY = (function(){
	    for (var p in { toString: 1 }) {
	      // check actual property name, so that it works with augmented Object.prototype
	      if (p === 'toString') return false;
	    }
	    return true;
	  })();
	  
	  function subclass() {};
	  function create() {
	    var parent = null, properties = [].slice.apply(arguments);
	    if (isFunction(properties[0]))
	      parent = properties.shift();
	
	    function klass() {
	      this.initialize.apply(this, arguments);
	    }
	
	    extend(klass, Class.Methods);
	    klass.superclass = parent;
	    klass.subclasses = [];
	
	    if (parent) {
	      subclass.prototype = parent.prototype;
	      klass.prototype = new subclass;
	      try { parent.subclasses.push(klass) } catch(e) {}
	    }
	
	    for (var i = 0, length = properties.length; i < length; i++)
	      klass.addMethods(properties[i]);
	
	    if (!klass.prototype.initialize)
	      klass.prototype.initialize = emptyFunction;
	
	    klass.prototype.constructor = klass;
	    return klass;
	  }
	
	  function addMethods(source) {
	    var ancestor   = this.superclass && this.superclass.prototype,
	        properties = keys(source);
	
	    // IE6 doesn't enumerate `toString` and `valueOf` (among other built-in `Object.prototype`) properties,
	    // Force copy if they're not Object.prototype ones.
	    // Do not copy other Object.prototype.* for performance reasons
	    if (IS_DONTENUM_BUGGY) {
	      if (source.toString != Object.prototype.toString)
	        properties.push("toString");
	      if (source.valueOf != Object.prototype.valueOf)
	        properties.push("valueOf");
	    }
	
	    for (var i = 0, length = properties.length; i < length; i++) {
	      var property = properties[i], value = source[property];
	      if (ancestor && isFunction(value) &&
	          argumentNames(value)[0] == "$super") {
	        var method = value;
	        value = wrap((function(m) {
	          return function() { return ancestor[m].apply(this, arguments); };
	        })(property), method);
	
	        value.valueOf = bind(method.valueOf, method);
	        value.toString = bind(method.toString, method);
	      }
	      this.prototype[property] = value;
	    }
	
	    return this;
	  }
	
	  return {
	    create: create,
	    Methods: {
	      addMethods: addMethods
	    }
	  };
	})();
	
	if (globalContext.exports) {
	  globalContext.exports.Class = Class;
	}
	else {
	  globalContext.Class = Class;
	}
	})(Rickshaw);
	Rickshaw.namespace('Rickshaw.Compat.ClassList');
	
	Rickshaw.Compat.ClassList = function() {
	
		/* adapted from http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
	
		if (typeof document !== "undefined" && !("classList" in document.createElement("a"))) {
	
		(function (view) {
	
		"use strict";
	
		var
			  classListProp = "classList"
			, protoProp = "prototype"
			, elemCtrProto = (view.HTMLElement || view.Element)[protoProp]
			, objCtr = Object
			, strTrim = String[protoProp].trim || function () {
				return this.replace(/^\s+|\s+$/g, "");
			}
			, arrIndexOf = Array[protoProp].indexOf || function (item) {
				var
					  i = 0
					, len = this.length
				;
				for (; i < len; i++) {
					if (i in this && this[i] === item) {
						return i;
					}
				}
				return -1;
			}
			// Vendors: please allow content code to instantiate DOMExceptions
			, DOMEx = function (type, message) {
				this.name = type;
				this.code = DOMException[type];
				this.message = message;
			}
			, checkTokenAndGetIndex = function (classList, token) {
				if (token === "") {
					throw new DOMEx(
						  "SYNTAX_ERR"
						, "An invalid or illegal string was specified"
					);
				}
				if (/\s/.test(token)) {
					throw new DOMEx(
						  "INVALID_CHARACTER_ERR"
						, "String contains an invalid character"
					);
				}
				return arrIndexOf.call(classList, token);
			}
			, ClassList = function (elem) {
				var
					  trimmedClasses = strTrim.call(elem.className)
					, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
					, i = 0
					, len = classes.length
				;
				for (; i < len; i++) {
					this.push(classes[i]);
				}
				this._updateClassName = function () {
					elem.className = this.toString();
				};
			}
			, classListProto = ClassList[protoProp] = []
			, classListGetter = function () {
				return new ClassList(this);
			}
		;
		// Most DOMException implementations don't allow calling DOMException's toString()
		// on non-DOMExceptions. Error's toString() is sufficient here.
		DOMEx[protoProp] = Error[protoProp];
		classListProto.item = function (i) {
			return this[i] || null;
		};
		classListProto.contains = function (token) {
			token += "";
			return checkTokenAndGetIndex(this, token) !== -1;
		};
		classListProto.add = function (token) {
			token += "";
			if (checkTokenAndGetIndex(this, token) === -1) {
				this.push(token);
				this._updateClassName();
			}
		};
		classListProto.remove = function (token) {
			token += "";
			var index = checkTokenAndGetIndex(this, token);
			if (index !== -1) {
				this.splice(index, 1);
				this._updateClassName();
			}
		};
		classListProto.toggle = function (token) {
			token += "";
			if (checkTokenAndGetIndex(this, token) === -1) {
				this.add(token);
			} else {
				this.remove(token);
			}
		};
		classListProto.toString = function () {
			return this.join(" ");
		};
	
		if (objCtr.defineProperty) {
			var classListPropDesc = {
				  get: classListGetter
				, enumerable: true
				, configurable: true
			};
			try {
				objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
			} catch (ex) { // IE 8 doesn't support enumerable:true
				if (ex.number === -0x7FF5EC54) {
					classListPropDesc.enumerable = false;
					objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
				}
			}
		} else if (objCtr[protoProp].__defineGetter__) {
			elemCtrProto.__defineGetter__(classListProp, classListGetter);
		}
	
		}(window));
	
		}
	};
	
	if ( (typeof RICKSHAW_NO_COMPAT !== "undefined" && !RICKSHAW_NO_COMPAT) || typeof RICKSHAW_NO_COMPAT === "undefined") {
		new Rickshaw.Compat.ClassList();
	}
	Rickshaw.namespace('Rickshaw.Graph');
	
	Rickshaw.Graph = function(args) {
	
		var self = this;
	
		this.initialize = function(args) {
	
			if (!args.element) throw "Rickshaw.Graph needs a reference to an element";
			if (args.element.nodeType !== 1) throw "Rickshaw.Graph element was defined but not an HTML element";
	
			this.element = args.element;
			this.series = args.series;
			this.window = {};
	
			this.updateCallbacks = [];
			this.configureCallbacks = [];
	
			this.defaults = {
				interpolation: 'cardinal',
				offset: 'zero',
				min: undefined,
				max: undefined,
				preserve: false,
				xScale: undefined,
				yScale: undefined,
				stack: true
			};
	
			this._loadRenderers();
			this.configure(args);
			this.validateSeries(args.series);
	
			this.series.active = function() { return self.series.filter( function(s) { return !s.disabled } ) };
			this.setSize({ width: args.width, height: args.height });
			this.element.classList.add('rickshaw_graph');
	
			this.vis = d3.select(this.element)
				.append("svg:svg")
				.attr('width', this.width)
				.attr('height', this.height);
	
			this.discoverRange();
		};
	
		this._loadRenderers = function() {
	
			for (var name in Rickshaw.Graph.Renderer) {
				if (!name || !Rickshaw.Graph.Renderer.hasOwnProperty(name)) continue;
				var r = Rickshaw.Graph.Renderer[name];
				if (!r || !r.prototype || !r.prototype.render) continue;
				self.registerRenderer(new r( { graph: self } ));
			}
		};
	
		this.validateSeries = function(series) {
	
			if (!Array.isArray(series) && !(series instanceof Rickshaw.Series)) {
				var seriesSignature = Object.prototype.toString.apply(series);
				throw "series is not an array: " + seriesSignature;
			}
	
			var pointsCount;
	
			series.forEach( function(s) {
	
				if (!(s instanceof Object)) {
					throw "series element is not an object: " + s;
				}
				if (!(s.data)) {
					throw "series has no data: " + JSON.stringify(s);
				}
				if (!Array.isArray(s.data)) {
					throw "series data is not an array: " + JSON.stringify(s.data);
				}
				
				if (s.data.length > 0) {
					var x = s.data[0].x;
					var y = s.data[0].y;
	
					if (typeof x != 'number' || ( typeof y != 'number' && y !== null ) ) {
						throw "x and y properties of points should be numbers instead of " +
							(typeof x) + " and " + (typeof y);
					}
				}
	
				if (s.data.length >= 3) {
					// probe to sanity check sort order
					if (s.data[2].x < s.data[1].x || s.data[1].x < s.data[0].x || s.data[s.data.length - 1].x < s.data[0].x) {
						throw "series data needs to be sorted on x values for series name: " + s.name;
					}
				}
	
			}, this );
		};
	
		this.dataDomain = function() {
	
			var data = this.series.map( function(s) { return s.data } );
	
			var min = d3.min( data.map( function(d) { return d[0].x } ) );
			var max = d3.max( data.map( function(d) { return d[d.length - 1].x } ) );
	
			return [min, max];
		};
	
		this.discoverRange = function() {
	
			var domain = this.renderer.domain();
	
			// this.*Scale is coming from the configuration dictionary
			// which may be referenced by the Graph creator, or shared
			// with other Graphs. We need to ensure we copy the scale
			// so that our mutations do not change the object given to us.
			// Hence the .copy()
			this.x = (this.xScale || d3.scale.linear()).copy().domain(domain.x).range([0, this.width]);
			this.y = (this.yScale || d3.scale.linear()).copy().domain(domain.y).range([this.height, 0]);
	
			this.x.magnitude = d3.scale.linear()
				.domain([domain.x[0] - domain.x[0], domain.x[1] - domain.x[0]])
				.range([0, this.width]);
	
			this.y.magnitude = d3.scale.linear()
				.domain([domain.y[0] - domain.y[0], domain.y[1] - domain.y[0]])
				.range([0, this.height]);
		};
	
		this.render = function() {
	
			var stackedData = this.stackData();
			this.discoverRange();
	
			this.renderer.render();
	
			this.updateCallbacks.forEach( function(callback) {
				callback();
			} );
	
		};
	
		this.update = this.render;
	
		this.stackData = function() {
	
			var data = this.series.active()
				.map( function(d) { return d.data } )
				.map( function(d) { return d.filter( function(d) { return this._slice(d) }, this ) }, this);
	
			var preserve = this.preserve;
			if (!preserve) {
				this.series.forEach( function(series) {
					if (series.scale) {
						// data must be preserved when a scale is used
						preserve = true;
					}
				} );
			}
	
			data = preserve ? Rickshaw.clone(data) : data;
	
			this.series.active().forEach( function(series, index) {
				if (series.scale) {
					// apply scale to each series
					var seriesData = data[index];
					if(seriesData) {
						seriesData.forEach( function(d) {
							d.y = series.scale(d.y);
						} );
					}
				}
			} );
	
			this.stackData.hooks.data.forEach( function(entry) {
				data = entry.f.apply(self, [data]);
			} );
	
			var stackedData;
	
			if (!this.renderer.unstack) {
	
				this._validateStackable();
	
				var layout = d3.layout.stack();
				layout.offset( self.offset );
				stackedData = layout(data);
			}
	
			stackedData = stackedData || data;
	
			if (this.renderer.unstack) {
				stackedData.forEach( function(seriesData) {
					seriesData.forEach( function(d) {
						d.y0 = d.y0 === undefined ? 0 : d.y0;
					} );
				} );
			}
	
			this.stackData.hooks.after.forEach( function(entry) {
				stackedData = entry.f.apply(self, [data]);
			} );
	
			var i = 0;
			this.series.forEach( function(series) {
				if (series.disabled) return;
				series.stack = stackedData[i++];
			} );
	
			this.stackedData = stackedData;
			return stackedData;
		};
	
		this._validateStackable = function() {
	
			var series = this.series;
			var pointsCount;
	
			series.forEach( function(s) {
	
				pointsCount = pointsCount || s.data.length;
	
				if (pointsCount && s.data.length != pointsCount) {
					throw "stacked series cannot have differing numbers of points: " +
						pointsCount + " vs " + s.data.length + "; see Rickshaw.Series.fill()";
				}
	
			}, this );
		};
	
		this.stackData.hooks = { data: [], after: [] };
	
		this._slice = function(d) {
	
			if (this.window.xMin || this.window.xMax) {
	
				var isInRange = true;
	
				if (this.window.xMin && d.x < this.window.xMin) isInRange = false;
				if (this.window.xMax && d.x > this.window.xMax) isInRange = false;
	
				return isInRange;
			}
	
			return true;
		};
	
		this.onUpdate = function(callback) {
			this.updateCallbacks.push(callback);
		};
	
		this.onConfigure = function(callback) {
			this.configureCallbacks.push(callback);
		};
	
		this.registerRenderer = function(renderer) {
			this._renderers = this._renderers || {};
			this._renderers[renderer.name] = renderer;
		};
	
		this.configure = function(args) {
	
			this.config = this.config || {};
	
			if (args.width || args.height) {
				this.setSize(args);
			}
	
			Rickshaw.keys(this.defaults).forEach( function(k) {
				this.config[k] = k in args ? args[k]
					: k in this ? this[k]
					: this.defaults[k];
			}, this );
	
			Rickshaw.keys(this.config).forEach( function(k) {
				this[k] = this.config[k];
			}, this );
	
			if ('stack' in args) args.unstack = !args.stack;
	
			var renderer = args.renderer || (this.renderer && this.renderer.name) || 'stack';
			this.setRenderer(renderer, args);
	
			this.configureCallbacks.forEach( function(callback) {
				callback(args);
			} );
		};
	
		this.setRenderer = function(r, args) {
			if (typeof r == 'function') {
				this.renderer = new r( { graph: self } );
				this.registerRenderer(this.renderer);
			} else {
				if (!this._renderers[r]) {
					throw "couldn't find renderer " + r;
				}
				this.renderer = this._renderers[r];
			}
	
			if (typeof args == 'object') {
				this.renderer.configure(args);
			}
		};
	
		this.setSize = function(args) {
	
			args = args || {};
	
			if (typeof window !== 'undefined') {
				var style = window.getComputedStyle(this.element, null);
				var elementWidth = parseInt(style.getPropertyValue('width'), 10);
				var elementHeight = parseInt(style.getPropertyValue('height'), 10);
			}
	
			this.width = args.width || elementWidth || 400;
			this.height = args.height || elementHeight || 250;
	
			this.vis && this.vis
				.attr('width', this.width)
				.attr('height', this.height);
		};
	
		this.initialize(args);
	};
	Rickshaw.namespace('Rickshaw.Fixtures.Color');
	
	Rickshaw.Fixtures.Color = function() {
	
		this.schemes = {};
	
		this.schemes.spectrum14 = [
			'#ecb796',
			'#dc8f70',
			'#b2a470',
			'#92875a',
			'#716c49',
			'#d2ed82',
			'#bbe468',
			'#a1d05d',
			'#e7cbe6',
			'#d8aad6',
			'#a888c2',
			'#9dc2d3',
			'#649eb9',
			'#387aa3'
		].reverse();
	
		this.schemes.spectrum2000 = [
			'#57306f',
			'#514c76',
			'#646583',
			'#738394',
			'#6b9c7d',
			'#84b665',
			'#a7ca50',
			'#bfe746',
			'#e2f528',
			'#fff726',
			'#ecdd00',
			'#d4b11d',
			'#de8800',
			'#de4800',
			'#c91515',
			'#9a0000',
			'#7b0429',
			'#580839',
			'#31082b'
		];
	
		this.schemes.spectrum2001 = [
			'#2f243f',
			'#3c2c55',
			'#4a3768',
			'#565270',
			'#6b6b7c',
			'#72957f',
			'#86ad6e',
			'#a1bc5e',
			'#b8d954',
			'#d3e04e',
			'#ccad2a',
			'#cc8412',
			'#c1521d',
			'#ad3821',
			'#8a1010',
			'#681717',
			'#531e1e',
			'#3d1818',
			'#320a1b'
		];
	
		this.schemes.classic9 = [
			'#423d4f',
			'#4a6860',
			'#848f39',
			'#a2b73c',
			'#ddcb53',
			'#c5a32f',
			'#7d5836',
			'#963b20',
			'#7c2626',
			'#491d37',
			'#2f254a'
		].reverse();
	
		this.schemes.httpStatus = {
			503: '#ea5029',
			502: '#d23f14',
			500: '#bf3613',
			410: '#efacea',
			409: '#e291dc',
			403: '#f457e8',
			408: '#e121d2',
			401: '#b92dae',
			405: '#f47ceb',
			404: '#a82a9f',
			400: '#b263c6',
			301: '#6fa024',
			302: '#87c32b',
			307: '#a0d84c',
			304: '#28b55c',
			200: '#1a4f74',
			206: '#27839f',
			201: '#52adc9',
			202: '#7c979f',
			203: '#a5b8bd',
			204: '#c1cdd1'
		};
	
		this.schemes.colorwheel = [
			'#b5b6a9',
			'#858772',
			'#785f43',
			'#96557e',
			'#4682b4',
			'#65b9ac',
			'#73c03a',
			'#cb513a'
		].reverse();
	
		this.schemes.cool = [
			'#5e9d2f',
			'#73c03a',
			'#4682b4',
			'#7bc3b8',
			'#a9884e',
			'#c1b266',
			'#a47493',
			'#c09fb5'
		];
	
		this.schemes.munin = [
			'#00cc00',
			'#0066b3',
			'#ff8000',
			'#ffcc00',
			'#330099',
			'#990099',
			'#ccff00',
			'#ff0000',
			'#808080',
			'#008f00',
			'#00487d',
			'#b35a00',
			'#b38f00',
			'#6b006b',
			'#8fb300',
			'#b30000',
			'#bebebe',
			'#80ff80',
			'#80c9ff',
			'#ffc080',
			'#ffe680',
			'#aa80ff',
			'#ee00cc',
			'#ff8080',
			'#666600',
			'#ffbfff',
			'#00ffcc',
			'#cc6699',
			'#999900'
		];
	};
	Rickshaw.namespace('Rickshaw.Fixtures.RandomData');
	
	Rickshaw.Fixtures.RandomData = function(timeInterval) {
	
		var addData;
		timeInterval = timeInterval || 1;
	
		var lastRandomValue = 200;
	
		var timeBase = Math.floor(new Date().getTime() / 1000);
	
		this.addData = function(data) {
	
			var randomValue = Math.random() * 100 + 15 + lastRandomValue;
			var index = data[0].length;
	
			var counter = 1;
	
			data.forEach( function(series) {
				var randomVariance = Math.random() * 20;
				var v = randomValue / 25  + counter++ +
					(Math.cos((index * counter * 11) / 960) + 2) * 15 +
					(Math.cos(index / 7) + 2) * 7 +
					(Math.cos(index / 17) + 2) * 1;
	
				series.push( { x: (index * timeInterval) + timeBase, y: v + randomVariance } );
			} );
	
			lastRandomValue = randomValue * 0.85;
		};
	
		this.removeData = function(data) {
			data.forEach( function(series) {
				series.shift();
			} );
			timeBase += timeInterval;
		};
	};
	
	Rickshaw.namespace('Rickshaw.Fixtures.Time');
	
	Rickshaw.Fixtures.Time = function() {
	
		var self = this;
	
		this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
		this.units = [
			{
				name: 'decade',
				seconds: 86400 * 365.25 * 10,
				formatter: function(d) { return (parseInt(d.getUTCFullYear() / 10, 10) * 10) }
			}, {
				name: 'year',
				seconds: 86400 * 365.25,
				formatter: function(d) { return d.getUTCFullYear() }
			}, {
				name: 'month',
				seconds: 86400 * 30.5,
				formatter: function(d) { return self.months[d.getUTCMonth()] }
			}, {
				name: 'week',
				seconds: 86400 * 7,
				formatter: function(d) { return self.formatDate(d) }
			}, {
				name: 'day',
				seconds: 86400,
				formatter: function(d) { return d.getUTCDate() }
			}, {
				name: '6 hour',
				seconds: 3600 * 6,
				formatter: function(d) { return self.formatTime(d) }
			}, {
				name: 'hour',
				seconds: 3600,
				formatter: function(d) { return self.formatTime(d) }
			}, {
				name: '15 minute',
				seconds: 60 * 15,
				formatter: function(d) { return self.formatTime(d) }
			}, {
				name: 'minute',
				seconds: 60,
				formatter: function(d) { return d.getUTCMinutes() }
			}, {
				name: '15 second',
				seconds: 15,
				formatter: function(d) { return d.getUTCSeconds() + 's' }
			}, {
				name: 'second',
				seconds: 1,
				formatter: function(d) { return d.getUTCSeconds() + 's' }
			}, {
				name: 'decisecond',
				seconds: 1/10,
				formatter: function(d) { return d.getUTCMilliseconds() + 'ms' }
			}, {
				name: 'centisecond',
				seconds: 1/100,
				formatter: function(d) { return d.getUTCMilliseconds() + 'ms' }
			}
		];
	
		this.unit = function(unitName) {
			return this.units.filter( function(unit) { return unitName == unit.name } ).shift();
		};
	
		this.formatDate = function(d) {
			return d3.time.format('%b %e')(d);
		};
	
		this.formatTime = function(d) {
			return d.toUTCString().match(/(\d+:\d+):/)[1];
		};
	
		this.ceil = function(time, unit) {
	
			var date, floor, year;
	
			if (unit.name == 'month') {
	
				date = new Date(time * 1000);
	
				floor = Date.UTC(date.getUTCFullYear(), date.getUTCMonth()) / 1000;
				if (floor == time) return time;
	
				year = date.getUTCFullYear();
				var month = date.getUTCMonth();
	
				if (month == 11) {
					month = 0;
					year = year + 1;
				} else {
					month += 1;
				}
	
				return Date.UTC(year, month) / 1000;
			}
	
			if (unit.name == 'year') {
	
				date = new Date(time * 1000);
	
				floor = Date.UTC(date.getUTCFullYear(), 0) / 1000;
				if (floor == time) return time;
	
				year = date.getUTCFullYear() + 1;
	
				return Date.UTC(year, 0) / 1000;
			}
	
			return Math.ceil(time / unit.seconds) * unit.seconds;
		};
	};
	Rickshaw.namespace('Rickshaw.Fixtures.Time.Local');
	
	Rickshaw.Fixtures.Time.Local = function() {
	
		var self = this;
	
		this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
		this.units = [
			{
				name: 'decade',
				seconds: 86400 * 365.25 * 10,
				formatter: function(d) { return (parseInt(d.getFullYear() / 10, 10) * 10) }
			}, {
				name: 'year',
				seconds: 86400 * 365.25,
				formatter: function(d) { return d.getFullYear() }
			}, {
				name: 'month',
				seconds: 86400 * 30.5,
				formatter: function(d) { return self.months[d.getMonth()] }
			}, {
				name: 'week',
				seconds: 86400 * 7,
				formatter: function(d) { return self.formatDate(d) }
			}, {
				name: 'day',
				seconds: 86400,
				formatter: function(d) { return d.getDate() }
			}, {
				name: '6 hour',
				seconds: 3600 * 6,
				formatter: function(d) { return self.formatTime(d) }
			}, {
				name: 'hour',
				seconds: 3600,
				formatter: function(d) { return self.formatTime(d) }
			}, {
				name: '15 minute',
				seconds: 60 * 15,
				formatter: function(d) { return self.formatTime(d) }
			}, {
				name: 'minute',
				seconds: 60,
				formatter: function(d) { return d.getMinutes() }
			}, {
				name: '15 second',
				seconds: 15,
				formatter: function(d) { return d.getSeconds() + 's' }
			}, {
				name: 'second',
				seconds: 1,
				formatter: function(d) { return d.getSeconds() + 's' }
			}, {
				name: 'decisecond',
				seconds: 1/10,
				formatter: function(d) { return d.getMilliseconds() + 'ms' }
			}, {
				name: 'centisecond',
				seconds: 1/100,
				formatter: function(d) { return d.getMilliseconds() + 'ms' }
			}
		];
	
		this.unit = function(unitName) {
			return this.units.filter( function(unit) { return unitName == unit.name } ).shift();
		};
	
		this.formatDate = function(d) {
			return d3.time.format('%b %e')(d);
		};
	
		this.formatTime = function(d) {
			return d.toString().match(/(\d+:\d+):/)[1];
		};
	
		this.ceil = function(time, unit) {
	
			var date, floor, year, offset;
	
			if (unit.name == 'day') {
	
				var nearFuture = new Date((time + unit.seconds - 1) * 1000);
	
				var rounded = new Date(0);
				rounded.setFullYear(nearFuture.getFullYear());
				rounded.setMonth(nearFuture.getMonth());
				rounded.setDate(nearFuture.getDate());
				rounded.setMilliseconds(0);
				rounded.setSeconds(0);
				rounded.setMinutes(0);
				rounded.setHours(0);
	
				return rounded.getTime() / 1000;
			}
	
			if (unit.name == 'month') {
	
				date = new Date(time * 1000);
	
				floor = new Date(date.getFullYear(), date.getMonth()).getTime() / 1000;
				if (floor == time) return time;
	
				year = date.getFullYear();
				var month = date.getMonth();
	
				if (month == 11) {
					month = 0;
					year = year + 1;
				} else {
					month += 1;
				}
	
				return new Date(year, month).getTime() / 1000;
			}
	
			if (unit.name == 'year') {
	
				date = new Date(time * 1000);
	
				floor = new Date(date.getUTCFullYear(), 0).getTime() / 1000;
				if (floor == time) return time;
	
				year = date.getFullYear() + 1;
	
				return new Date(year, 0).getTime() / 1000;
			}
			offset = new Date(time * 1000).getTimezoneOffset() * 60;
			return Math.ceil((time - offset) / unit.seconds) * unit.seconds + offset;
		};
	};
	Rickshaw.namespace('Rickshaw.Fixtures.Number');
	
	Rickshaw.Fixtures.Number.formatKMBT = function(y) {
		var abs_y = Math.abs(y);
		if (abs_y >= 1000000000000)   { return y / 1000000000000 + "T" }
		else if (abs_y >= 1000000000) { return y / 1000000000 + "B" }
		else if (abs_y >= 1000000)    { return y / 1000000 + "M" }
		else if (abs_y >= 1000)       { return y / 1000 + "K" }
		else if (abs_y < 1 && y > 0)  { return y.toFixed(2) }
		else if (abs_y === 0)         { return '' }
		else                      { return y }
	};
	
	Rickshaw.Fixtures.Number.formatBase1024KMGTP = function(y) {
	    var abs_y = Math.abs(y);
	    if (abs_y >= 1125899906842624)  { return y / 1125899906842624 + "P" }
	    else if (abs_y >= 1099511627776){ return y / 1099511627776 + "T" }
	    else if (abs_y >= 1073741824)   { return y / 1073741824 + "G" }
	    else if (abs_y >= 1048576)      { return y / 1048576 + "M" }
	    else if (abs_y >= 1024)         { return y / 1024 + "K" }
	    else if (abs_y < 1 && y > 0)    { return y.toFixed(2) }
	    else if (abs_y === 0)           { return '' }
	    else                        { return y }
	};
	Rickshaw.namespace("Rickshaw.Color.Palette");
	
	Rickshaw.Color.Palette = function(args) {
	
		var color = new Rickshaw.Fixtures.Color();
	
		args = args || {};
		this.schemes = {};
	
		this.scheme = color.schemes[args.scheme] || args.scheme || color.schemes.colorwheel;
		this.runningIndex = 0;
		this.generatorIndex = 0;
	
		if (args.interpolatedStopCount) {
			var schemeCount = this.scheme.length - 1;
			var i, j, scheme = [];
			for (i = 0; i < schemeCount; i++) {
				scheme.push(this.scheme[i]);
				var generator = d3.interpolateHsl(this.scheme[i], this.scheme[i + 1]);
				for (j = 1; j < args.interpolatedStopCount; j++) {
					scheme.push(generator((1 / args.interpolatedStopCount) * j));
				}
			}
			scheme.push(this.scheme[this.scheme.length - 1]);
			this.scheme = scheme;
		}
		this.rotateCount = this.scheme.length;
	
		this.color = function(key) {
			return this.scheme[key] || this.scheme[this.runningIndex++] || this.interpolateColor() || '#808080';
		};
	
		this.interpolateColor = function() {
			if (!Array.isArray(this.scheme)) return;
			var color;
			if (this.generatorIndex == this.rotateCount * 2 - 1) {
				color = d3.interpolateHsl(this.scheme[this.generatorIndex], this.scheme[0])(0.5);
				this.generatorIndex = 0;
				this.rotateCount *= 2;
			} else {
				color = d3.interpolateHsl(this.scheme[this.generatorIndex], this.scheme[this.generatorIndex + 1])(0.5);
				this.generatorIndex++;
			}
			this.scheme.push(color);
			return color;
		};
	
	};
	Rickshaw.namespace('Rickshaw.Graph.Ajax');
	
	Rickshaw.Graph.Ajax = Rickshaw.Class.create( {
	
		initialize: function(args) {
	
			this.dataURL = args.dataURL;
	
			this.onData = args.onData || function(d) { return d };
			this.onComplete = args.onComplete || function() {};
			this.onError = args.onError || function() {};
	
			this.args = args; // pass through to Rickshaw.Graph
	
			this.request();
		},
	
		request: function() {
	
			jQuery.ajax( {
				url: this.dataURL,
				dataType: 'json',
				success: this.success.bind(this),
				error: this.error.bind(this)
			} );
		},
	
		error: function() {
	
			console.log("error loading dataURL: " + this.dataURL);
			this.onError(this);
		},
	
		success: function(data, status) {
	
			data = this.onData(data);
			this.args.series = this._splice({ data: data, series: this.args.series });
	
			this.graph = this.graph || new Rickshaw.Graph(this.args);
			this.graph.render();
	
			this.onComplete(this);
		},
	
		_splice: function(args) {
	
			var data = args.data;
			var series = args.series;
	
			if (!args.series) return data;
	
			series.forEach( function(s) {
	
				var seriesKey = s.key || s.name;
				if (!seriesKey) throw "series needs a key or a name";
	
				data.forEach( function(d) {
	
					var dataKey = d.key || d.name;
					if (!dataKey) throw "data needs a key or a name";
	
					if (seriesKey == dataKey) {
						var properties = ['color', 'name', 'data'];
						properties.forEach( function(p) {
							if (d[p]) s[p] = d[p];
						} );
					}
				} );
			} );
	
			return series;
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Annotate');
	
	Rickshaw.Graph.Annotate = function(args) {
	
		var graph = this.graph = args.graph;
		this.elements = { timeline: args.element };
		
		var self = this;
	
		this.data = {};
	
		this.elements.timeline.classList.add('rickshaw_annotation_timeline');
	
		this.add = function(time, content, end_time) {
			self.data[time] = self.data[time] || {'boxes': []};
			self.data[time].boxes.push({content: content, end: end_time});
		};
	
		this.update = function() {
	
			Rickshaw.keys(self.data).forEach( function(time) {
	
				var annotation = self.data[time];
				var left = self.graph.x(time);
	
				if (left < 0 || left > self.graph.x.range()[1]) {
					if (annotation.element) {
						annotation.line.classList.add('offscreen');
						annotation.element.style.display = 'none';
					}
	
					annotation.boxes.forEach( function(box) {
						if ( box.rangeElement ) box.rangeElement.classList.add('offscreen');
					});
	
					return;
				}
	
				if (!annotation.element) {
					var element = annotation.element = document.createElement('div');
					element.classList.add('annotation');
					this.elements.timeline.appendChild(element);
					element.addEventListener('click', function(e) {
						element.classList.toggle('active');
						annotation.line.classList.toggle('active');
						annotation.boxes.forEach( function(box) {
							if ( box.rangeElement ) box.rangeElement.classList.toggle('active');
						});
					}, false);
						
				}
	
				annotation.element.style.left = left + 'px';
				annotation.element.style.display = 'block';
	
				annotation.boxes.forEach( function(box) {
	
	
					var element = box.element;
	
					if (!element) {
						element = box.element = document.createElement('div');
						element.classList.add('content');
						element.innerHTML = box.content;
						annotation.element.appendChild(element);
	
						annotation.line = document.createElement('div');
						annotation.line.classList.add('annotation_line');
						self.graph.element.appendChild(annotation.line);
	
						if ( box.end ) {
							box.rangeElement = document.createElement('div');
							box.rangeElement.classList.add('annotation_range');
							self.graph.element.appendChild(box.rangeElement);
						}
	
					}
	
					if ( box.end ) {
	
						var annotationRangeStart = left;
						var annotationRangeEnd   = Math.min( self.graph.x(box.end), self.graph.x.range()[1] );
	
						// annotation makes more sense at end
						if ( annotationRangeStart > annotationRangeEnd ) {
							annotationRangeEnd   = left;
							annotationRangeStart = Math.max( self.graph.x(box.end), self.graph.x.range()[0] );
						}
	
						var annotationRangeWidth = annotationRangeEnd - annotationRangeStart;
	
						box.rangeElement.style.left  = annotationRangeStart + 'px';
						box.rangeElement.style.width = annotationRangeWidth + 'px';
	
						box.rangeElement.classList.remove('offscreen');
					}
	
					annotation.line.classList.remove('offscreen');
					annotation.line.style.left = left + 'px';
				} );
			}, this );
		};
	
		this.graph.onUpdate( function() { self.update() } );
	};
	Rickshaw.namespace('Rickshaw.Graph.Axis.Time');
	
	Rickshaw.Graph.Axis.Time = function(args) {
	
		var self = this;
	
		this.graph = args.graph;
		this.elements = [];
		this.ticksTreatment = args.ticksTreatment || 'plain';
		this.fixedTimeUnit = args.timeUnit;
	
		var time = args.timeFixture || new Rickshaw.Fixtures.Time();
	
		this.appropriateTimeUnit = function() {
	
			var unit;
			var units = time.units;
	
			var domain = this.graph.x.domain();
			var rangeSeconds = domain[1] - domain[0];
	
			units.forEach( function(u) {
				if (Math.floor(rangeSeconds / u.seconds) >= 2) {
					unit = unit || u;
				}
			} );
	
			return (unit || time.units[time.units.length - 1]);
		};
	
		this.tickOffsets = function() {
	
			var domain = this.graph.x.domain();
	
			var unit = this.fixedTimeUnit || this.appropriateTimeUnit();
			var count = Math.ceil((domain[1] - domain[0]) / unit.seconds);
	
			var runningTick = domain[0];
	
			var offsets = [];
	
			for (var i = 0; i < count; i++) {
	
				var tickValue = time.ceil(runningTick, unit);
				runningTick = tickValue + unit.seconds / 2;
	
				offsets.push( { value: tickValue, unit: unit } );
			}
	
			return offsets;
		};
	
		this.render = function() {
	
			this.elements.forEach( function(e) {
				e.parentNode.removeChild(e);
			} );
	
			this.elements = [];
	
			var offsets = this.tickOffsets();
	
			offsets.forEach( function(o) {
				
				if (self.graph.x(o.value) > self.graph.x.range()[1]) return;
		
				var element = document.createElement('div');
				element.style.left = self.graph.x(o.value) + 'px';
				element.classList.add('x_tick');
				element.classList.add(self.ticksTreatment);
	
				var title = document.createElement('div');
				title.classList.add('title');
				title.innerHTML = o.unit.formatter(new Date(o.value * 1000));
				element.appendChild(title);
	
				self.graph.element.appendChild(element);
				self.elements.push(element);
	
			} );
		};
	
		this.graph.onUpdate( function() { self.render() } );
	};
	
	Rickshaw.namespace('Rickshaw.Graph.Axis.X');
	
	Rickshaw.Graph.Axis.X = function(args) {
	
		var self = this;
		var berthRate = 0.10;
	
		this.initialize = function(args) {
	
			this.graph = args.graph;
			this.orientation = args.orientation || 'top';
	
			this.pixelsPerTick = args.pixelsPerTick || 75;
			if (args.ticks) this.staticTicks = args.ticks;
			if (args.tickValues) this.tickValues = args.tickValues;
	
			this.tickSize = args.tickSize || 4;
			this.ticksTreatment = args.ticksTreatment || 'plain';
	
			if (args.element) {
	
				this.element = args.element;
				this._discoverSize(args.element, args);
	
				this.vis = d3.select(args.element)
					.append("svg:svg")
					.attr('height', this.height)
					.attr('width', this.width)
					.attr('class', 'rickshaw_graph x_axis_d3');
	
				this.element = this.vis[0][0];
				this.element.style.position = 'relative';
	
				this.setSize({ width: args.width, height: args.height });
	
			} else {
				this.vis = this.graph.vis;
			}
	
			this.graph.onUpdate( function() { self.render() } );
		};
	
		this.setSize = function(args) {
	
			args = args || {};
			if (!this.element) return;
	
			this._discoverSize(this.element.parentNode, args);
	
			this.vis
				.attr('height', this.height)
				.attr('width', this.width * (1 + berthRate));
	
			var berth = Math.floor(this.width * berthRate / 2);
			this.element.style.left = -1 * berth + 'px';
		};
	
		this.render = function() {
	
			if (this._renderWidth !== undefined && this.graph.width !== this._renderWidth) this.setSize({ auto: true });
	
			var axis = d3.svg.axis().scale(this.graph.x).orient(this.orientation);
			axis.tickFormat( args.tickFormat || function(x) { return x } );
			if (this.tickValues) axis.tickValues(this.tickValues);
	
			this.ticks = this.staticTicks || Math.floor(this.graph.width / this.pixelsPerTick);
	
			var berth = Math.floor(this.width * berthRate / 2) || 0;
			var bar_offset = this.graph.renderer.name == "bar" && Math.ceil(this.graph.width * 0.95 / this.graph.series[0].data.length / 2) || 0;
	
			var transform;
	
			if (this.orientation == 'top') {
				var yOffset = this.height || this.graph.height;
				transform = 'translate(' + (berth + bar_offset) + ',' + yOffset + ')';
			} else {
				transform = 'translate(' + (berth + bar_offset) + ', 0)';
			}
	
			if (this.element) {
				this.vis.selectAll('*').remove();
			}
	
			this.vis
				.append("svg:g")
				.attr("class", ["x_ticks_d3", this.ticksTreatment].join(" "))
				.attr("transform", transform)
				.call(axis.ticks(this.ticks).tickSubdivide(0).tickSize(this.tickSize));
	
			var gridSize = (this.orientation == 'bottom' ? 1 : -1) * this.graph.height;
	
			this.graph.vis
				.append("svg:g")
				.attr("class", "x_grid_d3")
				.call(axis.ticks(this.ticks).tickSubdivide(0).tickSize(gridSize))
				.selectAll('text')
				.each(function() { this.parentNode.setAttribute('data-x-value', this.textContent) });
	
			this._renderHeight = this.graph.height;
		};
	
		this._discoverSize = function(element, args) {
	
			if (typeof window !== 'undefined') {
	
				var style = window.getComputedStyle(element, null);
				var elementHeight = parseInt(style.getPropertyValue('height'), 10);
	
				if (!args.auto) {
					var elementWidth = parseInt(style.getPropertyValue('width'), 10);
				}
			}
	
			this.width = (args.width || elementWidth || this.graph.width) * (1 + berthRate);
			this.height = args.height || elementHeight || 40;
		};
	
		this.initialize(args);
	};
	
	Rickshaw.namespace('Rickshaw.Graph.Axis.Y');
	
	Rickshaw.Graph.Axis.Y = Rickshaw.Class.create( {
	
		initialize: function(args) {
	
			this.graph = args.graph;
			this.orientation = args.orientation || 'right';
	
			this.pixelsPerTick = args.pixelsPerTick || 75;
			if (args.ticks) this.staticTicks = args.ticks;
			if (args.tickValues) this.tickValues = args.tickValues;
	
			this.tickSize = args.tickSize || 4;
			this.ticksTreatment = args.ticksTreatment || 'plain';
	
			this.tickFormat = args.tickFormat || function(y) { return y };
	
			this.berthRate = 0.10;
	
			if (args.element) {
	
				this.element = args.element;
				this.vis = d3.select(args.element)
					.append("svg:svg")
					.attr('class', 'rickshaw_graph y_axis');
	
				this.element = this.vis[0][0];
				this.element.style.position = 'relative';
	
				this.setSize({ width: args.width, height: args.height });
	
			} else {
				this.vis = this.graph.vis;
			}
	
			var self = this;
			this.graph.onUpdate( function() { self.render() } );
		},
	
		setSize: function(args) {
	
			args = args || {};
	
			if (!this.element) return;
	
			if (typeof window !== 'undefined') {
	
				var style = window.getComputedStyle(this.element.parentNode, null);
				var elementWidth = parseInt(style.getPropertyValue('width'), 10);
	
				if (!args.auto) {
					var elementHeight = parseInt(style.getPropertyValue('height'), 10);
				}
			}
	
			this.width = args.width || elementWidth || this.graph.width * this.berthRate;
			this.height = args.height || elementHeight || this.graph.height;
	
			this.vis
				.attr('width', this.width)
				.attr('height', this.height * (1 + this.berthRate));
	
			var berth = this.height * this.berthRate;
	
			if (this.orientation == 'left') {
				this.element.style.top = -1 * berth + 'px';
			}
		},
	
		render: function() {
	
			if (this._renderHeight !== undefined && this.graph.height !== this._renderHeight) this.setSize({ auto: true });
	
			this.ticks = this.staticTicks || Math.floor(this.graph.height / this.pixelsPerTick);
	
			var axis = this._drawAxis(this.graph.y);
	
			this._drawGrid(axis);
	
			this._renderHeight = this.graph.height;
		},
	
		_drawAxis: function(scale) {
			var axis = d3.svg.axis().scale(scale).orient(this.orientation);
			axis.tickFormat(this.tickFormat);
			if (this.tickValues) axis.tickValues(this.tickValues);
	
			if (this.orientation == 'left') {
				var berth = this.height * this.berthRate;
				var transform = 'translate(' + this.width + ', ' + berth + ')';
			}
	
			if (this.element) {
				this.vis.selectAll('*').remove();
			}
	
			this.vis
				.append("svg:g")
				.attr("class", ["y_ticks", this.ticksTreatment].join(" "))
				.attr("transform", transform)
				.call(axis.ticks(this.ticks).tickSubdivide(0).tickSize(this.tickSize));
	
			return axis;
		},
	
		_drawGrid: function(axis) {
			var gridSize = (this.orientation == 'right' ? 1 : -1) * this.graph.width;
	
			this.graph.vis
				.append("svg:g")
				.attr("class", "y_grid")
				.call(axis.ticks(this.ticks).tickSubdivide(0).tickSize(gridSize))
				.selectAll('text')
				.each(function() { this.parentNode.setAttribute('data-y-value', this.textContent) });
		}
	} );
	Rickshaw.namespace('Rickshaw.Graph.Axis.Y.Scaled');
	
	Rickshaw.Graph.Axis.Y.Scaled = Rickshaw.Class.create( Rickshaw.Graph.Axis.Y, {
	
	  initialize: function($super, args) {
	
	    if (typeof(args.scale) === 'undefined') {
	      throw new Error('Scaled requires scale');
	    }
	
	    this.scale = args.scale;
	
	    if (typeof(args.grid) === 'undefined') {
	      this.grid = true;
	    } else {
	      this.grid = args.grid;
	    }
	
	    $super(args);
	
	  },
	
	  _drawAxis: function($super, scale) {
	    // Adjust scale's domain to compensate for adjustments to the
	    // renderer's domain (e.g. padding).
	    var domain = this.scale.domain();
	    var renderDomain = this.graph.renderer.domain().y;
	
	    var extents = [
	      Math.min.apply(Math, domain),
	      Math.max.apply(Math, domain)];
	
	    // A mapping from the ideal render domain [0, 1] to the extent
	    // of the original scale's domain.  This is used to calculate
	    // the extents of the adjusted domain.
	    var extentMap = d3.scale.linear().domain([0, 1]).range(extents);
	
	    var adjExtents = [
	      extentMap(renderDomain[0]),
	      extentMap(renderDomain[1])];
	
	    // A mapping from the original domain to the adjusted domain.
	    var adjustment = d3.scale.linear().domain(extents).range(adjExtents);
	
	    // Make a copy of the custom scale, apply the adjusted domain, and
	    // copy the range to match the graph's scale.
	    var adjustedScale = this.scale.copy()
	      .domain(domain.map(adjustment))
	      .range(scale.range());
	
	    return $super(adjustedScale);
	  },
	
	  _drawGrid: function($super, axis) {
	    if (this.grid) {
	      // only draw the axis if the grid option is true
	      $super(axis);
	    }
	  }
	} );
	Rickshaw.namespace('Rickshaw.Graph.Behavior.Series.Highlight');
	
	Rickshaw.Graph.Behavior.Series.Highlight = function(args) {
	
		this.graph = args.graph;
		this.legend = args.legend;
	
		var self = this;
	
		var colorSafe = {};
		var activeLine = null;
	
		var disabledColor = args.disabledColor || function(seriesColor) {
			return d3.interpolateRgb(seriesColor, d3.rgb('#d8d8d8'))(0.8).toString();
		};
	
		this.addHighlightEvents = function (l) {
	
			l.element.addEventListener( 'mouseover', function(e) {
	
				if (activeLine) return;
				else activeLine = l;
	
				self.legend.lines.forEach( function(line) {
	
					if (l === line) {
	
						// if we're not in a stacked renderer bring active line to the top
						if (self.graph.renderer.unstack && (line.series.renderer ? line.series.renderer.unstack : true)) {
	
							var seriesIndex = self.graph.series.indexOf(line.series);
							line.originalIndex = seriesIndex;
	
							var series = self.graph.series.splice(seriesIndex, 1)[0];
							self.graph.series.push(series);
						}
						return;
					}
	
					colorSafe[line.series.name] = colorSafe[line.series.name] || line.series.color;
					line.series.color = disabledColor(line.series.color);
	
				} );
	
				self.graph.update();
	
			}, false );
	
			l.element.addEventListener( 'mouseout', function(e) {
	
				if (!activeLine) return;
				else activeLine = null;
	
				self.legend.lines.forEach( function(line) {
	
					// return reordered series to its original place
					if (l === line && line.hasOwnProperty('originalIndex')) {
	
						var series = self.graph.series.pop();
						self.graph.series.splice(line.originalIndex, 0, series);
						delete line.originalIndex;
					}
	
					if (colorSafe[line.series.name]) {
						line.series.color = colorSafe[line.series.name];
					}
				} );
	
				self.graph.update();
	
			}, false );
		};
	
		if (this.legend) {
			this.legend.lines.forEach( function(l) {
				self.addHighlightEvents(l);
			} );
		}
	
	};
	Rickshaw.namespace('Rickshaw.Graph.Behavior.Series.Order');
	
	Rickshaw.Graph.Behavior.Series.Order = function(args) {
	
		this.graph = args.graph;
		this.legend = args.legend;
	
		var self = this;
	
		if (typeof window.jQuery == 'undefined') {
			throw "couldn't find jQuery at window.jQuery";
		}
	
		if (typeof window.jQuery.ui == 'undefined') {
			throw "couldn't find jQuery UI at window.jQuery.ui";
		}
	
		jQuery(function() {
			jQuery(self.legend.list).sortable( {
				containment: 'parent',
				tolerance: 'pointer',
				update: function( event, ui ) {
					var series = [];
					jQuery(self.legend.list).find('li').each( function(index, item) {
						if (!item.series) return;
						series.push(item.series);
					} );
	
					for (var i = self.graph.series.length - 1; i >= 0; i--) {
						self.graph.series[i] = series.shift();
					}
	
					self.graph.update();
				}
			} );
			jQuery(self.legend.list).disableSelection();
		});
	
		//hack to make jquery-ui sortable behave
		this.graph.onUpdate( function() { 
			var h = window.getComputedStyle(self.legend.element).height;
			self.legend.element.style.height = h;
		} );
	};
	Rickshaw.namespace('Rickshaw.Graph.Behavior.Series.Toggle');
	
	Rickshaw.Graph.Behavior.Series.Toggle = function(args) {
	
		this.graph = args.graph;
		this.legend = args.legend;
	
		var self = this;
	
		this.addAnchor = function(line) {
	
			var anchor = document.createElement('a');
			anchor.innerHTML = '&#10004;';
			anchor.classList.add('action');
			line.element.insertBefore(anchor, line.element.firstChild);
	
			anchor.onclick = function(e) {
				if (line.series.disabled) {
					line.series.enable();
					line.element.classList.remove('disabled');
				} else { 
					if (this.graph.series.filter(function(s) { return !s.disabled }).length <= 1) return;
					line.series.disable();
					line.element.classList.add('disabled');
				}
	
				self.graph.update();
	
			}.bind(this);
			
	                var label = line.element.getElementsByTagName('span')[0];
	                label.onclick = function(e){
	
	                        var disableAllOtherLines = line.series.disabled;
	                        if ( ! disableAllOtherLines ) {
	                                for ( var i = 0; i < self.legend.lines.length; i++ ) {
	                                        var l = self.legend.lines[i];
	                                        if ( line.series === l.series ) {
	                                                // noop
	                                        } else if ( l.series.disabled ) {
	                                                // noop
	                                        } else {
	                                                disableAllOtherLines = true;
	                                                break;
	                                        }
	                                }
	                        }
	
	                        // show all or none
	                        if ( disableAllOtherLines ) {
	
	                                // these must happen first or else we try ( and probably fail ) to make a no line graph
	                                line.series.enable();
	                                line.element.classList.remove('disabled');
	
	                                self.legend.lines.forEach(function(l){
	                                        if ( line.series === l.series ) {
	                                                // noop
	                                        } else {
	                                                l.series.disable();
	                                                l.element.classList.add('disabled');
	                                        }
	                                });
	
	                        } else {
	
	                                self.legend.lines.forEach(function(l){
	                                        l.series.enable();
	                                        l.element.classList.remove('disabled');
	                                });
	
	                        }
	
	                        self.graph.update();
	
	                };
	
		};
	
		if (this.legend) {
	
			var $ = jQuery;
			if (typeof $ != 'undefined' && $(this.legend.list).sortable) {
	
				$(this.legend.list).sortable( {
					start: function(event, ui) {
						ui.item.bind('no.onclick',
							function(event) {
								event.preventDefault();
							}
						);
					},
					stop: function(event, ui) {
						setTimeout(function(){
							ui.item.unbind('no.onclick');
						}, 250);
					}
				});
			}
	
			this.legend.lines.forEach( function(l) {
				self.addAnchor(l);
			} );
		}
	
		this._addBehavior = function() {
	
			this.graph.series.forEach( function(s) {
				
				s.disable = function() {
	
					if (self.graph.series.length <= 1) {
						throw('only one series left');
					}
					
					s.disabled = true;
				};
	
				s.enable = function() {
					s.disabled = false;
				};
			} );
		};
		this._addBehavior();
	
		this.updateBehaviour = function () { this._addBehavior() };
	
	};
	Rickshaw.namespace('Rickshaw.Graph.HoverDetail');
	
	Rickshaw.Graph.HoverDetail = Rickshaw.Class.create({
	
		initialize: function(args) {
	
			var graph = this.graph = args.graph;
	
			this.xFormatter = args.xFormatter || function(x) {
				return new Date( x * 1000 ).toUTCString();
			};
	
			this.yFormatter = args.yFormatter || function(y) {
				return y === null ? y : y.toFixed(2);
			};
	
			var element = this.element = document.createElement('div');
			element.className = 'detail';
	
			this.visible = true;
			graph.element.appendChild(element);
	
			this.lastEvent = null;
			this._addListeners();
	
			this.onShow = args.onShow;
			this.onHide = args.onHide;
			this.onRender = args.onRender;
	
			this.formatter = args.formatter || this.formatter;
	
		},
	
		formatter: function(series, x, y, formattedX, formattedY, d) {
			return series.name + ':&nbsp;' + formattedY;
		},
	
		update: function(e) {
	
			e = e || this.lastEvent;
			if (!e) return;
			this.lastEvent = e;
	
			if (!e.target.nodeName.match(/^(path|svg|rect|circle)$/)) return;
	
			var graph = this.graph;
	
			var eventX = e.offsetX || e.layerX;
			var eventY = e.offsetY || e.layerY;
	
			var j = 0;
			var points = [];
			var nearestPoint;
	
			this.graph.series.active().forEach( function(series) {
	
				var data = this.graph.stackedData[j++];
	
				if (!data.length)
					return;
	
				var domainX = graph.x.invert(eventX);
	
				var domainIndexScale = d3.scale.linear()
					.domain([data[0].x, data.slice(-1)[0].x])
					.range([0, data.length - 1]);
	
				var approximateIndex = Math.round(domainIndexScale(domainX));
				if (approximateIndex == data.length - 1) approximateIndex--;
	
				var dataIndex = Math.min(approximateIndex || 0, data.length - 1);
	
				for (var i = approximateIndex; i < data.length - 1;) {
	
					if (!data[i] || !data[i + 1]) break;
	
					if (data[i].x <= domainX && data[i + 1].x > domainX) {
						dataIndex = Math.abs(domainX - data[i].x) < Math.abs(domainX - data[i + 1].x) ? i : i + 1;
						break;
					}
	
					if (data[i + 1].x <= domainX) { i++ } else { i-- }
				}
	
				if (dataIndex < 0) dataIndex = 0;
				var value = data[dataIndex];
	
				var distance = Math.sqrt(
					Math.pow(Math.abs(graph.x(value.x) - eventX), 2) +
					Math.pow(Math.abs(graph.y(value.y + value.y0) - eventY), 2)
				);
	
				var xFormatter = series.xFormatter || this.xFormatter;
				var yFormatter = series.yFormatter || this.yFormatter;
	
				var point = {
					formattedXValue: xFormatter(value.x),
					formattedYValue: yFormatter(series.scale ? series.scale.invert(value.y) : value.y),
					series: series,
					value: value,
					distance: distance,
					order: j,
					name: series.name
				};
	
				if (!nearestPoint || distance < nearestPoint.distance) {
					nearestPoint = point;
				}
	
				points.push(point);
	
			}, this );
	
			if (!nearestPoint)
				return;
	
			nearestPoint.active = true;
	
			var domainX = nearestPoint.value.x;
			var formattedXValue = nearestPoint.formattedXValue;
	
			this.element.innerHTML = '';
			this.element.style.left = graph.x(domainX) + 'px';
	
			this.visible && this.render( {
				points: points,
				detail: points, // for backwards compatibility
				mouseX: eventX,
				mouseY: eventY,
				formattedXValue: formattedXValue,
				domainX: domainX
			} );
		},
	
		hide: function() {
			this.visible = false;
			this.element.classList.add('inactive');
	
			if (typeof this.onHide == 'function') {
				this.onHide();
			}
		},
	
		show: function() {
			this.visible = true;
			this.element.classList.remove('inactive');
	
			if (typeof this.onShow == 'function') {
				this.onShow();
			}
		},
	
		render: function(args) {
	
			var graph = this.graph;
			var points = args.points;
			var point = points.filter( function(p) { return p.active } ).shift();
	
			if (point.value.y === null) return;
	
			var formattedXValue = point.formattedXValue;
			var formattedYValue = point.formattedYValue;
	
			this.element.innerHTML = '';
			this.element.style.left = graph.x(point.value.x) + 'px';
	
			var xLabel = document.createElement('div');
	
			xLabel.className = 'x_label';
			xLabel.innerHTML = formattedXValue;
			this.element.appendChild(xLabel);
	
			var item = document.createElement('div');
	
			item.className = 'item';
	
			// invert the scale if this series displays using a scale
			var series = point.series;
			var actualY = series.scale ? series.scale.invert(point.value.y) : point.value.y;
	
			item.innerHTML = this.formatter(series, point.value.x, actualY, formattedXValue, formattedYValue, point);
			item.style.top = this.graph.y(point.value.y0 + point.value.y) + 'px';
	
			this.element.appendChild(item);
	
			var dot = document.createElement('div');
	
			dot.className = 'dot';
			dot.style.top = item.style.top;
			dot.style.borderColor = series.color;
	
			this.element.appendChild(dot);
	
			if (point.active) {
				item.classList.add('active');
				dot.classList.add('active');
			}
	
			// Assume left alignment until the element has been displayed and
			// bounding box calculations are possible.
			var alignables = [xLabel, item];
			alignables.forEach(function(el) {
				el.classList.add('left');
			});
	
			this.show();
	
			// If left-alignment results in any error, try right-alignment.
			var leftAlignError = this._calcLayoutError(alignables);
			if (leftAlignError > 0) {
				alignables.forEach(function(el) {
					el.classList.remove('left');
					el.classList.add('right');
				});
	
				// If right-alignment is worse than left alignment, switch back.
				var rightAlignError = this._calcLayoutError(alignables);
				if (rightAlignError > leftAlignError) {
					alignables.forEach(function(el) {
						el.classList.remove('right');
						el.classList.add('left');
					});
				}
			}
	
			if (typeof this.onRender == 'function') {
				this.onRender(args);
			}
		},
	
		_calcLayoutError: function(alignables) {
			// Layout error is calculated as the number of linear pixels by which
			// an alignable extends past the left or right edge of the parent.
			var parentRect = this.element.parentNode.getBoundingClientRect();
	
			var error = 0;
			var alignRight = alignables.forEach(function(el) {
				var rect = el.getBoundingClientRect();
				if (!rect.width) {
					return;
				}
	
				if (rect.right > parentRect.right) {
					error += rect.right - parentRect.right;
				}
	
				if (rect.left < parentRect.left) {
					error += parentRect.left - rect.left;
				}
			});
			return error;
		},
	
		_addListeners: function() {
	
			this.graph.element.addEventListener(
				'mousemove',
				function(e) {
					this.visible = true;
					this.update(e);
				}.bind(this),
				false
			);
	
			this.graph.onUpdate( function() { this.update() }.bind(this) );
	
			this.graph.element.addEventListener(
				'mouseout',
				function(e) {
					if (e.relatedTarget && !(e.relatedTarget.compareDocumentPosition(this.graph.element) & Node.DOCUMENT_POSITION_CONTAINS)) {
						this.hide();
					}
				}.bind(this),
				false
			);
		}
	});
	Rickshaw.namespace('Rickshaw.Graph.JSONP');
	
	Rickshaw.Graph.JSONP = Rickshaw.Class.create( Rickshaw.Graph.Ajax, {
	
		request: function() {
	
			jQuery.ajax( {
				url: this.dataURL,
				dataType: 'jsonp',
				success: this.success.bind(this),
				error: this.error.bind(this)
			} );
		}
	} );
	Rickshaw.namespace('Rickshaw.Graph.Legend');
	
	Rickshaw.Graph.Legend = Rickshaw.Class.create( {
	
		className: 'rickshaw_legend',
	
		initialize: function(args) {
			this.element = args.element;
			this.graph = args.graph;
			this.naturalOrder = args.naturalOrder;
	
			this.element.classList.add(this.className);
	
			this.list = document.createElement('ul');
			this.element.appendChild(this.list);
	
			this.render();
	
			// we could bind this.render.bind(this) here
			// but triggering the re-render would lose the added
			// behavior of the series toggle
			this.graph.onUpdate( function() {} );
		},
	
		render: function() {
			var self = this;
	
			while ( this.list.firstChild ) {
				this.list.removeChild( this.list.firstChild );
			}
			this.lines = [];
	
			var series = this.graph.series
				.map( function(s) { return s } );
	
			if (!this.naturalOrder) {
				series = series.reverse();
			}
	
			series.forEach( function(s) {
				self.addLine(s);
			} );
	
	
		},
	
		addLine: function (series) {
			var line = document.createElement('li');
			line.className = 'line';
			if (series.disabled) {
				line.className += ' disabled';
			}
			if (series.className) {
				d3.select(line).classed(series.className, true);
			}
			var swatch = document.createElement('div');
			swatch.className = 'swatch';
			swatch.style.backgroundColor = series.color;
	
			line.appendChild(swatch);
	
			var label = document.createElement('span');
			label.className = 'label';
			label.innerHTML = series.name;
	
			line.appendChild(label);
			this.list.appendChild(line);
	
			line.series = series;
	
			if (series.noLegend) {
				line.style.display = 'none';
			}
	
			var _line = { element: line, series: series };
			if (this.shelving) {
				this.shelving.addAnchor(_line);
				this.shelving.updateBehaviour();
			}
			if (this.highlighter) {
				this.highlighter.addHighlightEvents(_line);
			}
			this.lines.push(_line);
			return line;
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.RangeSlider');
	
	Rickshaw.Graph.RangeSlider = Rickshaw.Class.create({
	
		initialize: function(args) {
	
			var $ = jQuery;
			var self = this;
			var element = this.element = args.element;
			var graphs = this.graphs = args.graphs;
			if (!graphs) {
				graphs = this.graph = args.graph;
			}
			if (graphs.constructor !== Array) {
				graphs = [graphs];
			}
			this.graph = graphs[0];
	
			this.slideCallbacks = [];
	
			this.build();
	
			for (var i = 0; i < graphs.length; i++) {
				graphs[i].onUpdate(function() {
					self.update();
				}.bind(self));
	
				graphs[i].onConfigure(function() {
					$(element)[0].style.width = graphs[i].width + 'px';
				}.bind(self));
			}
	
		},
	
		build: function() {
	
			var domain;
			var element = this.element;
			var $ = jQuery;
			var self = this;
			var graphs = this.graphs || this.graph;
	
			if (graphs.constructor !== Array) {
				graphs = [graphs];
			}
	
			// base the slider's min/max on the first graph
			this.graph = graphs[0];
			domain = graphs[0].dataDomain();
	
			$(function() {
				$(element).slider({
					range: true,
					min: domain[0],
					max: domain[1],
					values: [
						domain[0],
						domain[1]
					],
					start: function(event, ui) {
						self.slideStarted({ event: event, ui: ui });
					},
					stop: function(event, ui) {
						self.slideFinished({ event: event, ui: ui });
					},
					slide: function(event, ui) {
						if (!self.slideShouldUpdate(event, ui))
							return;
	
						if (ui.values[1] <= ui.values[0]) return;
	
						for (var i = 0; i < graphs.length; i++) {
							self.processSlideChange({
								event: event,
								ui: ui,
								graph: graphs[i]
							});
						}
					}
				} );
			} );
	
			graphs[0].onConfigure(function() {
				$(element)[0].style.width = graphs[0].width + 'px';
			}.bind(this));
	
		},
	
		update: function() {
	
			var element = this.element;
			var graph = this.graph;
			var $ = jQuery;
	
			var values = $(element).slider('option', 'values');
	
			var domain = graph.dataDomain();
	
			$(element).slider('option', 'min', domain[0]);
			$(element).slider('option', 'max', domain[1]);
	
			if (graph.window.xMin == null) {
				values[0] = domain[0];
			}
			if (graph.window.xMax == null) {
				values[1] = domain[1];
			}
	
			$(element).slider('option', 'values', values);
		},
	
		onSlide: function(callback) {
			this.slideCallbacks.push(callback);
		},
	
		processSlideChange: function(args) {
			var event = args.event;
			var ui = args.ui;
			var graph = args.graph;
	
			graph.window.xMin = ui.values[0];
			graph.window.xMax = ui.values[1];
			graph.update();
	
			var domain = graph.dataDomain();
	
			// if we're at an extreme, stick there
			if (domain[0] == ui.values[0]) {
				graph.window.xMin = undefined;
			}
	
			if (domain[1] == ui.values[1]) {
				graph.window.xMax = undefined;
			}
	
			this.slideCallbacks.forEach(function(callback) {
				callback(graph, graph.window.xMin, graph.window.xMax);
			});
	
		},
	
		// allows the slide updates to bail out if sliding is not permitted
		slideShouldUpdate: function() {
			return true;
		},
	
		slideStarted: function() {
			return;
		},
	
		slideFinished: function() {
			return;
		}
	});
	
	Rickshaw.namespace('Rickshaw.Graph.RangeSlider.Preview');
	
	Rickshaw.Graph.RangeSlider.Preview = Rickshaw.Class.create({
	
		initialize: function(args) {
	
			if (!args.element) throw "Rickshaw.Graph.RangeSlider.Preview needs a reference to an element";
			if (!args.graph && !args.graphs) throw "Rickshaw.Graph.RangeSlider.Preview needs a reference to an graph or an array of graphs";
	
			this.element = args.element;
			this.element.style.position = 'relative';
	
			this.graphs = args.graph ? [ args.graph ] : args.graphs;
	
			this.defaults = {
				height: 75,
				width: 400,
				gripperColor: undefined,
				frameTopThickness: 3,
				frameHandleThickness: 10,
				frameColor: "#d4d4d4",
				frameOpacity: 1,
				minimumFrameWidth: 0,
				heightRatio: 0.2
			};
	
			this.heightRatio = args.heightRatio || this.defaults.heightRatio;
			this.defaults.gripperColor = d3.rgb(this.defaults.frameColor).darker().toString(); 
	
			this.configureCallbacks = [];
			this.slideCallbacks = [];
	
			this.previews = [];
	
			if (!args.width) this.widthFromGraph = true;
			if (!args.height) this.heightFromGraph = true;
	
			if (this.widthFromGraph || this.heightFromGraph) {
				this.graphs[0].onConfigure(function () {
					this.configure(args); this.render();
				}.bind(this));
			}
	
			args.width = args.width || this.graphs[0].width || this.defaults.width;
			args.height = args.height || this.graphs[0].height * this.heightRatio || this.defaults.height;
	
			this.configure(args);
			this.render();
		},
	
		onSlide: function(callback) {
			this.slideCallbacks.push(callback);
		},
	
		onConfigure: function(callback) {
			this.configureCallbacks.push(callback);
		},
	
		configure: function(args) {
	
			this.config = this.config || {};
	
			this.configureCallbacks.forEach(function(callback) {
				callback(args);
			});
	
			Rickshaw.keys(this.defaults).forEach(function(k) {
				this.config[k] = k in args ? args[k]
					: k in this.config ? this.config[k]
					: this.defaults[k];
			}, this);
	
			if ('width' in args || 'height' in args) {
	
				if (this.widthFromGraph) {
					this.config.width = this.graphs[0].width;
				}
	
				if (this.heightFromGraph) {
					this.config.height = this.graphs[0].height * this.heightRatio;
					this.previewHeight = this.config.height;
				}
	
				this.previews.forEach(function(preview) {
	
					var height = this.previewHeight / this.graphs.length - this.config.frameTopThickness * 2;
					var width = this.config.width - this.config.frameHandleThickness * 2;
					preview.setSize({ width: width, height: height });
	
					if (this.svg) {
						var svgHeight = height + this.config.frameHandleThickness * 2;
						var svgWidth = width + this.config.frameHandleThickness * 2;
						this.svg.style("width", svgWidth + "px");
						this.svg.style("height", svgHeight + "px");
					}
				}, this);
			}
		},
	
		render: function() {
	
			var self = this;
	
			this.svg = d3.select(this.element)
				.selectAll("svg.rickshaw_range_slider_preview")
				.data([null]);
	
			this.previewHeight = this.config.height - (this.config.frameTopThickness * 2);
			this.previewWidth = this.config.width - (this.config.frameHandleThickness * 2);
	
			this.currentFrame = [0, this.previewWidth];
	
			var buildGraph = function(parent, index) {
	
				var graphArgs = Rickshaw.extend({}, parent.config);
				var height = self.previewHeight / self.graphs.length;
				var renderer = parent.renderer.name;
	
				Rickshaw.extend(graphArgs, {
					element: this.appendChild(document.createElement("div")),
					height: height,
					width: self.previewWidth,
					series: parent.series,
					renderer: renderer
				});
	
				var graph = new Rickshaw.Graph(graphArgs);
				self.previews.push(graph);
	
				parent.onUpdate(function() { graph.render(); self.render() });
	
				parent.onConfigure(function(args) { 
					// don't propagate height
					delete args.height;
					args.width = args.width - self.config.frameHandleThickness * 2;
					graph.configure(args);
					graph.render();
				});
	
				graph.render();
			};
	
			var graphContainer = d3.select(this.element)
				.selectAll("div.rickshaw_range_slider_preview_container")
				.data(this.graphs);
	
			var translateCommand = "translate(" +
				this.config.frameHandleThickness + "px, " +
				this.config.frameTopThickness + "px)";
	
			graphContainer.enter()
				.append("div")
				.classed("rickshaw_range_slider_preview_container", true)
				.style("-webkit-transform", translateCommand)
				.style("-moz-transform", translateCommand)
				.style("-ms-transform", translateCommand)
				.style("transform", translateCommand)
				.each(buildGraph);
	
			graphContainer.exit()
				.remove();
	
			// Use the first graph as the "master" for the frame state
			var masterGraph = this.graphs[0];
	
			var domainScale = d3.scale.linear()
				.domain([0, this.previewWidth])
				.range(masterGraph.dataDomain());
	
			var currentWindow = [masterGraph.window.xMin, masterGraph.window.xMax];
	
			this.currentFrame[0] = currentWindow[0] === undefined ? 
				0 : Math.round(domainScale.invert(currentWindow[0]));
	
			if (this.currentFrame[0] < 0) this.currentFrame[0] = 0;
	
			this.currentFrame[1] = currentWindow[1] === undefined ?
				this.previewWidth : domainScale.invert(currentWindow[1]);
	
			if (this.currentFrame[1] - this.currentFrame[0] < self.config.minimumFrameWidth) {
				this.currentFrame[1] = (this.currentFrame[0] || 0) + self.config.minimumFrameWidth;
			}
	
			this.svg.enter()
				.append("svg")
				.classed("rickshaw_range_slider_preview", true)
				.style("height", this.config.height + "px")
				.style("width", this.config.width + "px")
				.style("position", "absolute")
				.style("top", 0);
	
			this._renderDimming();
			this._renderFrame();
			this._renderGrippers();
			this._renderHandles();
			this._renderMiddle();
	
			this._registerMouseEvents();
		},
	
		_renderDimming: function() {
	
			var element = this.svg
				.selectAll("path.dimming")
				.data([null]);
	
			element.enter()
				.append("path")
				.attr("fill", "white")
				.attr("fill-opacity", "0.7")
				.attr("fill-rule", "evenodd")
				.classed("dimming", true);
	
			var path = "";
			path += " M " + this.config.frameHandleThickness + " " + this.config.frameTopThickness;
			path += " h " + this.previewWidth;
			path += " v " + this.previewHeight;
			path += " h " + -this.previewWidth;
			path += " z ";
			path += " M " + Math.max(this.currentFrame[0], this.config.frameHandleThickness) + " " + this.config.frameTopThickness;
			path += " H " + Math.min(this.currentFrame[1] + this.config.frameHandleThickness * 2, this.previewWidth + this.config.frameHandleThickness);
			path += " v " + this.previewHeight;
			path += " H " + Math.max(this.currentFrame[0], this.config.frameHandleThickness);
			path += " z";
	
			element.attr("d", path);
		},
	
		_renderFrame: function() {
	
			var element = this.svg
				.selectAll("path.frame")
				.data([null]);
	
			element.enter()
				.append("path")
				.attr("stroke", "white")
				.attr("stroke-width", "1px")
				.attr("stroke-linejoin", "round")
				.attr("fill", this.config.frameColor)
				.attr("fill-opacity", this.config.frameOpacity)
				.attr("fill-rule", "evenodd")
				.classed("frame", true);
	
			var path = "";
			path += " M " + this.currentFrame[0] + " 0";
			path += " H " + (this.currentFrame[1] + (this.config.frameHandleThickness * 2));
			path += " V " + this.config.height;
			path += " H " + (this.currentFrame[0]);
			path += " z";
			path += " M " + (this.currentFrame[0] + this.config.frameHandleThickness) + " " + this.config.frameTopThickness;
			path += " H " + (this.currentFrame[1] + this.config.frameHandleThickness);
			path += " v " + this.previewHeight;
			path += " H " + (this.currentFrame[0] + this.config.frameHandleThickness);
			path += " z";
	
			element.attr("d", path);
		},
	
		_renderGrippers: function() {
	
			var gripper = this.svg.selectAll("path.gripper")
				.data([null]);
	
			gripper.enter()
				.append("path")
				.attr("stroke", this.config.gripperColor)
				.classed("gripper", true);
	
			var path = "";
	
			[0.4, 0.6].forEach(function(spacing) {
				path += " M " + Math.round((this.currentFrame[0] + (this.config.frameHandleThickness * spacing))) + " " + Math.round(this.config.height * 0.3);
				path += " V " + Math.round(this.config.height * 0.7);
				path += " M " + Math.round((this.currentFrame[1] + (this.config.frameHandleThickness * (1 + spacing)))) + " " + Math.round(this.config.height * 0.3);
				path += " V " + Math.round(this.config.height * 0.7);
			}.bind(this));
	
			gripper.attr("d", path);
		},
	
		_renderHandles: function() {
	
			var leftHandle = this.svg.selectAll("rect.left_handle")
				.data([null]);
	
			leftHandle.enter()
				.append("rect")
				.attr('width', this.config.frameHandleThickness)
				.style("cursor", "ew-resize")
				.style("fill-opacity", "0")
				.classed("left_handle", true);
	
			leftHandle
				.attr('x', this.currentFrame[0])
				.attr('height', this.config.height);
	
			var rightHandle = this.svg.selectAll("rect.right_handle")
				.data([null]);
	
			rightHandle.enter()
				.append("rect")
				.attr('width', this.config.frameHandleThickness)
				.style("cursor", "ew-resize")
				.style("fill-opacity", "0")
				.classed("right_handle", true);
	
			rightHandle
				.attr('x', this.currentFrame[1] + this.config.frameHandleThickness)
				.attr('height', this.config.height);
		},
	
		_renderMiddle: function() {
	
			var middleHandle = this.svg.selectAll("rect.middle_handle")
				.data([null]);
	
			middleHandle.enter()
				.append("rect")
				.style("cursor", "move")
				.style("fill-opacity", "0")
				.classed("middle_handle", true);
	
			middleHandle
				.attr('width', Math.max(0, this.currentFrame[1] - this.currentFrame[0]))
				.attr('x', this.currentFrame[0] + this.config.frameHandleThickness)
				.attr('height', this.config.height);
		},
	
		_registerMouseEvents: function() {
	
			var element = d3.select(this.element);
	
			var drag = {
				target: null,
				start: null,
				stop: null,
				left: false,
				right: false,
				rigid: false
			};
	
			var self = this;
	
			function onMousemove(datum, index) {
	
				drag.stop = self._getClientXFromEvent(d3.event, drag);
				var distanceTraveled = drag.stop - drag.start;
				var frameAfterDrag = self.frameBeforeDrag.slice(0);
				var minimumFrameWidth = self.config.minimumFrameWidth;
	
				if (drag.rigid) {
					minimumFrameWidth = self.frameBeforeDrag[1] - self.frameBeforeDrag[0];
				}
				if (drag.left) {
					frameAfterDrag[0] = Math.max(frameAfterDrag[0] + distanceTraveled, 0);
				}
				if (drag.right) {
					frameAfterDrag[1] = Math.min(frameAfterDrag[1] + distanceTraveled, self.previewWidth);
				}
	
				var currentFrameWidth = frameAfterDrag[1] - frameAfterDrag[0];
	
				if (currentFrameWidth <= minimumFrameWidth) {
	
					if (drag.left) {
						frameAfterDrag[0] = frameAfterDrag[1] - minimumFrameWidth;
					}
					if (drag.right) {
						frameAfterDrag[1] = frameAfterDrag[0] + minimumFrameWidth;
					}
					if (frameAfterDrag[0] <= 0) {
						frameAfterDrag[1] -= frameAfterDrag[0];
						frameAfterDrag[0] = 0;
					}
					if (frameAfterDrag[1] >= self.previewWidth) {
						frameAfterDrag[0] -= (frameAfterDrag[1] - self.previewWidth);
						frameAfterDrag[1] = self.previewWidth;
					}
				}
	
				self.graphs.forEach(function(graph) {
	
					var domainScale = d3.scale.linear()
						.interpolate(d3.interpolateNumber)
						.domain([0, self.previewWidth])
						.range(graph.dataDomain());
	
					var windowAfterDrag = [
						domainScale(frameAfterDrag[0]),
						domainScale(frameAfterDrag[1])
					];
	
					self.slideCallbacks.forEach(function(callback) {
						callback(graph, windowAfterDrag[0], windowAfterDrag[1]);
					});
	
					if (frameAfterDrag[0] === 0) {
						windowAfterDrag[0] = undefined;
					}
					if (frameAfterDrag[1] === self.previewWidth) {
						windowAfterDrag[1] = undefined;
					}
					graph.window.xMin = windowAfterDrag[0];
					graph.window.xMax = windowAfterDrag[1];
	
					graph.update();
				});
			}
	
			function onMousedown() {
				drag.target = d3.event.target;
				drag.start = self._getClientXFromEvent(d3.event, drag);
				self.frameBeforeDrag = self.currentFrame.slice();
				d3.event.preventDefault ? d3.event.preventDefault() : d3.event.returnValue = false;
				d3.select(document).on("mousemove.rickshaw_range_slider_preview", onMousemove);
				d3.select(document).on("mouseup.rickshaw_range_slider_preview", onMouseup);
				d3.select(document).on("touchmove.rickshaw_range_slider_preview", onMousemove);
				d3.select(document).on("touchend.rickshaw_range_slider_preview", onMouseup);
				d3.select(document).on("touchcancel.rickshaw_range_slider_preview", onMouseup);
			}
	
			function onMousedownLeftHandle(datum, index) {
				drag.left = true;
				onMousedown();
			}
	
			function onMousedownRightHandle(datum, index) {
				drag.right = true;
				onMousedown();
			}
	
			function onMousedownMiddleHandle(datum, index) {
				drag.left = true;
				drag.right = true;
				drag.rigid = true;
				onMousedown();
			}
	
			function onMouseup(datum, index) {
				d3.select(document).on("mousemove.rickshaw_range_slider_preview", null);
				d3.select(document).on("mouseup.rickshaw_range_slider_preview", null);
				d3.select(document).on("touchmove.rickshaw_range_slider_preview", null);
				d3.select(document).on("touchend.rickshaw_range_slider_preview", null);
				d3.select(document).on("touchcancel.rickshaw_range_slider_preview", null);
				delete self.frameBeforeDrag;
				drag.left = false;
				drag.right = false;
				drag.rigid = false;
			}
	
			element.select("rect.left_handle").on("mousedown", onMousedownLeftHandle);
			element.select("rect.right_handle").on("mousedown", onMousedownRightHandle);
			element.select("rect.middle_handle").on("mousedown", onMousedownMiddleHandle);
			element.select("rect.left_handle").on("touchstart", onMousedownLeftHandle);
			element.select("rect.right_handle").on("touchstart", onMousedownRightHandle);
			element.select("rect.middle_handle").on("touchstart", onMousedownMiddleHandle);
		},
	
		_getClientXFromEvent: function(event, drag) {
	
			switch (event.type) {
				case 'touchstart':
				case 'touchmove':
					var touchList = event.changedTouches;
					var touch = null;
					for (var touchIndex = 0; touchIndex < touchList.length; touchIndex++) {
						if (touchList[touchIndex].target === drag.target) {
							touch = touchList[touchIndex];
							break;
						}
					}
					return touch !== null ? touch.clientX : undefined;
	
				default:
					return event.clientX;
			}
		}
	});
	
	Rickshaw.namespace("Rickshaw.Graph.Renderer");
	
	Rickshaw.Graph.Renderer = Rickshaw.Class.create( {
	
		initialize: function(args) {
			this.graph = args.graph;
			this.tension = args.tension || this.tension;
			this.configure(args);
		},
	
		seriesPathFactory: function() {
			//implement in subclass
		},
	
		seriesStrokeFactory: function() {
			// implement in subclass
		},
	
		defaults: function() {
			return {
				tension: 0.8,
				strokeWidth: 2,
				unstack: true,
				padding: { top: 0.01, right: 0, bottom: 0.01, left: 0 },
				stroke: false,
				fill: false,
				opacity: 1
			};
		},
	
		domain: function(data) {
			// Requires that at least one series contains some data
			var stackedData = data || this.graph.stackedData || this.graph.stackData();
	
			// filter out any series that may be empty in the current x-domain
			stackedData = stackedData.filter(function (a) { return a && a.length !== 0; });
	
			var xMin = +Infinity;
			var xMax = -Infinity;
	
			var yMin = +Infinity;
			var yMax = -Infinity;
	
			stackedData.forEach( function(series) {
	
				series.forEach( function(d) {
	
					if (d.y == null) return;
	
					var y = d.y + d.y0;
	
					if (y < yMin) yMin = y;
					if (y > yMax) yMax = y;
				} );
	
				if (!series.length) return;
	
				if (series[0].x < xMin) xMin = series[0].x;
				if (series[series.length - 1].x > xMax) xMax = series[series.length - 1].x;
			} );
	
			xMin -= (xMax - xMin) * this.padding.left;
			xMax += (xMax - xMin) * this.padding.right;
	
			yMin = this.graph.min === 'auto' ? yMin : this.graph.min || 0;
			yMax = this.graph.max === undefined ? yMax : this.graph.max;
	
			if (this.graph.min === 'auto' || yMin < 0) {
				yMin -= (yMax - yMin) * this.padding.bottom;
			}
	
			if (this.graph.max === undefined) {
				yMax += (yMax - yMin) * this.padding.top;
			}
	
			return { x: [xMin, xMax], y: [yMin, yMax] };
		},
	
		render: function(args) {
	
			args = args || {};
	
			var graph = this.graph;
			var series = args.series || graph.series;
	
			var vis = args.vis || graph.vis;
			vis.selectAll('*').remove();
	
			var data = series
				.filter(function(s) { return !s.disabled })
				.map(function(s) { return s.stack });
	
			var pathNodes = vis.selectAll("path.path")
				.data(data)
				.enter().append("svg:path")
				.classed('path', true)
				.attr("d", this.seriesPathFactory());
	
			if (this.stroke) {
	                        var strokeNodes = vis.selectAll('path.stroke')
	                                .data(data)
	                                .enter().append("svg:path")
					.classed('stroke', true)
					.attr("d", this.seriesStrokeFactory());
			}
	
			var i = 0;
			series.forEach( function(series) {
				if (series.disabled) return;
				series.path = pathNodes[0][i];
				if (this.stroke) series.stroke = strokeNodes[0][i];
				this._styleSeries(series);
				i++;
			}, this );
	
		},
	
		_styleSeries: function(series) {
	
			var fill = this.fill ? series.color : 'none';
			var stroke = this.stroke ? series.color : 'none';
			var strokeWidth = series.strokeWidth ? series.strokeWidth : this.strokeWidth;
			var opacity = series.opacity ? series.opacity : this.opacity;
	
			series.path.setAttribute('fill', fill);
			series.path.setAttribute('stroke', stroke);
			series.path.setAttribute('stroke-width', strokeWidth);
			series.path.setAttribute('opacity', opacity);
	
			if (series.className) {
				d3.select(series.path).classed(series.className, true);
			}
			if (series.className && this.stroke) {
				d3.select(series.stroke).classed(series.className, true);
			}
		},
	
		configure: function(args) {
	
			args = args || {};
	
			Rickshaw.keys(this.defaults()).forEach( function(key) {
	
				if (!args.hasOwnProperty(key)) {
					this[key] = this[key] || this.graph[key] || this.defaults()[key];
					return;
				}
	
				if (typeof this.defaults()[key] == 'object') {
	
					Rickshaw.keys(this.defaults()[key]).forEach( function(k) {
	
						this[key][k] =
							args[key][k] !== undefined ? args[key][k] :
							this[key][k] !== undefined ? this[key][k] :
							this.defaults()[key][k];
					}, this );
	
				} else {
					this[key] =
						args[key] !== undefined ? args[key] :
						this[key] !== undefined ? this[key] :
						this.graph[key] !== undefined ? this.graph[key] :
						this.defaults()[key];
				}
	
			}, this );
		},
	
		setStrokeWidth: function(strokeWidth) {
			if (strokeWidth !== undefined) {
				this.strokeWidth = strokeWidth;
			}
		},
	
		setTension: function(tension) {
			if (tension !== undefined) {
				this.tension = tension;
			}
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Renderer.Line');
	
	Rickshaw.Graph.Renderer.Line = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'line',
	
		defaults: function($super) {
	
			return Rickshaw.extend( $super(), {
				unstack: true,
				fill: false,
				stroke: true
			} );
		},
	
		seriesPathFactory: function() {
	
			var graph = this.graph;
	
			var factory = d3.svg.line()
				.x( function(d) { return graph.x(d.x) } )
				.y( function(d) { return graph.y(d.y) } )
				.interpolate(this.graph.interpolation).tension(this.tension);
	
			factory.defined && factory.defined( function(d) { return d.y !== null } );
			return factory;
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Renderer.Stack');
	
	Rickshaw.Graph.Renderer.Stack = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'stack',
	
		defaults: function($super) {
	
			return Rickshaw.extend( $super(), {
				fill: true,
				stroke: false,
				unstack: false
			} );
		},
	
		seriesPathFactory: function() {
	
			var graph = this.graph;
	
			var factory = d3.svg.area()
				.x( function(d) { return graph.x(d.x) } )
				.y0( function(d) { return graph.y(d.y0) } )
				.y1( function(d) { return graph.y(d.y + d.y0) } )
				.interpolate(this.graph.interpolation).tension(this.tension);
	
			factory.defined && factory.defined( function(d) { return d.y !== null } );
			return factory;
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Renderer.Bar');
	
	Rickshaw.Graph.Renderer.Bar = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'bar',
	
		defaults: function($super) {
	
			var defaults = Rickshaw.extend( $super(), {
				gapSize: 0.05,
				unstack: false,
				opacity: 1.0
			} );
	
			delete defaults.tension;
			return defaults;
		},
	
		initialize: function($super, args) {
			args = args || {};
			this.gapSize = args.gapSize || this.gapSize;
			$super(args);
		},
	
		domain: function($super) {
	
			var domain = $super();
	
			var frequentInterval = this._frequentInterval(this.graph.stackedData.slice(-1).shift());
			domain.x[1] += Number(frequentInterval.magnitude);
	
			return domain;
		},
	
		barWidth: function(series) {
	
			var frequentInterval = this._frequentInterval(series.stack);
			var barWidth = this.graph.x.magnitude(frequentInterval.magnitude) * (1 - this.gapSize);
	
			return barWidth;
		},
	
		render: function(args) {
	
			args = args || {};
	
			var graph = this.graph;
			var series = args.series || graph.series;
	
			var vis = args.vis || graph.vis;
			vis.selectAll('*').remove();
	
			var barWidth = this.barWidth(series.active()[0]);
			var barXOffset = 0;
	
			var activeSeriesCount = series.filter( function(s) { return !s.disabled; } ).length;
			var seriesBarWidth = this.unstack ? barWidth / activeSeriesCount : barWidth;
	
			var transform = function(d) {
				// add a matrix transform for negative values
				var matrix = [ 1, 0, 0, (d.y < 0 ? -1 : 1), 0, (d.y < 0 ? graph.y.magnitude(Math.abs(d.y)) * 2 : 0) ];
				return "matrix(" + matrix.join(',') + ")";
			};
	
			series.forEach( function(series) {
	
				if (series.disabled) return;
	
				var barWidth = this.barWidth(series);
	
				var nodes = vis.selectAll("path")
					.data(series.stack.filter( function(d) { return d.y !== null } ))
					.enter().append("svg:rect")
					.attr("x", function(d) { return graph.x(d.x) + barXOffset })
					.attr("y", function(d) { return (graph.y(d.y0 + Math.abs(d.y))) * (d.y < 0 ? -1 : 1 ) })
					.attr("width", seriesBarWidth)
					.attr("height", function(d) { return graph.y.magnitude(Math.abs(d.y)) })
					.attr("opacity", series.opacity)
					.attr("transform", transform);
	
				Array.prototype.forEach.call(nodes[0], function(n) {
					n.setAttribute('fill', series.color);
				} );
	
				if (this.unstack) barXOffset += seriesBarWidth;
	
			}, this );
		},
	
		_frequentInterval: function(data) {
	
			var intervalCounts = {};
	
			for (var i = 0; i < data.length - 1; i++) {
				var interval = data[i + 1].x - data[i].x;
				intervalCounts[interval] = intervalCounts[interval] || 0;
				intervalCounts[interval]++;
			}
	
			var frequentInterval = { count: 0, magnitude: 1 };
			
			// Sorting object's keys returned to guarantee consistency when iterating over
			// Keys order in `for .. in` loop is not specified and browsers behave differently here
			// This results with different invterval value being calculated for different browsers
			// See last but one section here: http://www.ecma-international.org/ecma-262/5.1/#sec-12.6.4
			var keysSorted = Rickshaw.keys(intervalCounts).sort(function asc(a, b) { return Number(a) - Number(b); });
			keysSorted.forEach( function(i) {
				if (frequentInterval.count < intervalCounts[i]) {
					frequentInterval = {
						count: intervalCounts[i],
						magnitude: i
					};
				}
			} );
	
			return frequentInterval;
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Renderer.Area');
	
	Rickshaw.Graph.Renderer.Area = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'area',
	
		defaults: function($super) {
	
			return Rickshaw.extend( $super(), {
				unstack: false,
				fill: false,
				stroke: false
			} );
		},
	
		seriesPathFactory: function() {
	
			var graph = this.graph;
	
			var factory = d3.svg.area()
				.x( function(d) { return graph.x(d.x) } )
				.y0( function(d) { return graph.y(d.y0) } )
				.y1( function(d) { return graph.y(d.y + d.y0) } )
				.interpolate(graph.interpolation).tension(this.tension);
	
			factory.defined && factory.defined( function(d) { return d.y !== null } );
			return factory;
		},
	
		seriesStrokeFactory: function() {
	
			var graph = this.graph;
	
			var factory = d3.svg.line()
				.x( function(d) { return graph.x(d.x) } )
				.y( function(d) { return graph.y(d.y + d.y0) } )
				.interpolate(graph.interpolation).tension(this.tension);
	
			factory.defined && factory.defined( function(d) { return d.y !== null } );
			return factory;
		},
	
		render: function(args) {
	
			args = args || {};
	
			var graph = this.graph;
			var series = args.series || graph.series;
	
			var vis = args.vis || graph.vis;
			vis.selectAll('*').remove();
	
			// insert or stacked areas so strokes lay on top of areas
			var method = this.unstack ? 'append' : 'insert';
	
			var data = series
				.filter(function(s) { return !s.disabled })
				.map(function(s) { return s.stack });
	
			var nodes = vis.selectAll("path")
				.data(data)
				.enter()[method]("svg:g", 'g');
	
			nodes.append("svg:path")
				.attr("d", this.seriesPathFactory())
				.attr("class", 'area');
	
			if (this.stroke) {
				nodes.append("svg:path")
					.attr("d", this.seriesStrokeFactory())
					.attr("class", 'line');
			}
	
			var i = 0;
			series.forEach( function(series) {
				if (series.disabled) return;
				series.path = nodes[0][i++];
				this._styleSeries(series);
			}, this );
		},
	
		_styleSeries: function(series) {
	
			if (!series.path) return;
	
			d3.select(series.path).select('.area')
				.attr('fill', series.color);
	
			if (this.stroke) {
				d3.select(series.path).select('.line')
					.attr('fill', 'none')
					.attr('stroke', series.stroke || d3.interpolateRgb(series.color, 'black')(0.125))
					.attr('stroke-width', this.strokeWidth);
			}
	
			if (series.className) {
				series.path.setAttribute('class', series.className);
			}
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Renderer.ScatterPlot');
	
	Rickshaw.Graph.Renderer.ScatterPlot = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'scatterplot',
	
		defaults: function($super) {
	
			return Rickshaw.extend( $super(), {
				unstack: true,
				fill: true,
				stroke: false,
				padding:{ top: 0.01, right: 0.01, bottom: 0.01, left: 0.01 },
				dotSize: 4
			} );
		},
	
		initialize: function($super, args) {
			$super(args);
		},
	
		render: function(args) {
	
			args = args || {};
	
			var graph = this.graph;
	
			var series = args.series || graph.series;
			var vis = args.vis || graph.vis;
	
			var dotSize = this.dotSize;
	
			vis.selectAll('*').remove();
	
			series.forEach( function(series) {
	
				if (series.disabled) return;
				var opacity = series.opacity ? series.opacity : 1;
	
				var nodes = vis.selectAll("path")
					.data(series.stack.filter( function(d) { return d.y !== null } ))
					.enter().append("svg:circle")
						.attr("cx", function(d) { return graph.x(d.x) })
						.attr("cy", function(d) { return graph.y(d.y) })
						.attr("r", function(d) { return ("r" in d) ? d.r : dotSize})
						.attr("opacity", function(d) { return ("opacity" in d) ? d.opacity : opacity});
				if (series.className) {
					nodes.classed(series.className, true);
				}
				
				Array.prototype.forEach.call(nodes[0], function(n) {
					n.setAttribute('fill', series.color);
				} );
	
			}, this );
		}
	} );
	Rickshaw.namespace('Rickshaw.Graph.Renderer.Multi');
	
	Rickshaw.Graph.Renderer.Multi = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'multi',
	
		initialize: function($super, args) {
	
			$super(args);
		},
	
		defaults: function($super) {
	
			return Rickshaw.extend( $super(), {
				unstack: true,
				fill: false,
				stroke: true 
			} );
		},
	
		configure: function($super, args) {
	
			args = args || {};
			this.config = args;
			$super(args);
		},
	
		domain: function($super) {
	
			this.graph.stackData();
	
			var domains = [];
	
			var groups = this._groups();
			this._stack(groups);
	
			groups.forEach( function(group) {
	
				var data = group.series
					.filter( function(s) { return !s.disabled } )
					.map( function(s) { return s.stack });
	
				if (!data.length) return;
				
				var domain = null;
				if (group.renderer && group.renderer.domain) {
					domain = group.renderer.domain(data);
				}
				else {
					domain = $super(data);
				}
				domains.push(domain);
			});
	
			var xMin = d3.min(domains.map( function(d) { return d.x[0] } ));
			var xMax = d3.max(domains.map( function(d) { return d.x[1] } ));
			var yMin = d3.min(domains.map( function(d) { return d.y[0] } ));
			var yMax = d3.max(domains.map( function(d) { return d.y[1] } ));
	
			return { x: [xMin, xMax], y: [yMin, yMax] };
		},
	
		_groups: function() {
	
			var graph = this.graph;
	
			var renderGroups = {};
	
			graph.series.forEach( function(series) {
	
				if (series.disabled) return;
	
				if (!renderGroups[series.renderer]) {
	
					var ns = "http://www.w3.org/2000/svg";
					var vis = document.createElementNS(ns, 'g');
	
					graph.vis[0][0].appendChild(vis);
	
					var renderer = graph._renderers[series.renderer];
	
					var config = {};
	
					var defaults = [ this.defaults(), renderer.defaults(), this.config, this.graph ];
					defaults.forEach(function(d) { Rickshaw.extend(config, d) });
	
					renderer.configure(config);
	
					renderGroups[series.renderer] = {
						renderer: renderer,
						series: [],
						vis: d3.select(vis)
					};
				}
					
				renderGroups[series.renderer].series.push(series);
	
			}, this);
	
			var groups = [];
	
			Object.keys(renderGroups).forEach( function(key) {
				var group = renderGroups[key];
				groups.push(group);
			});
	
			return groups;
		},
	
		_stack: function(groups) {
	
			groups.forEach( function(group) {
	
				var series = group.series
					.filter( function(series) { return !series.disabled } );
	
				var data = series
					.map( function(series) { return series.stack } );
	
				if (!group.renderer.unstack) {
	
					var layout = d3.layout.stack();
					var stackedData = Rickshaw.clone(layout(data));
	
					series.forEach( function(series, index) {
						series._stack = Rickshaw.clone(stackedData[index]);
					});
				}
	
			}, this );
	
			return groups;
	
		},
	
		render: function() {
	
			this.graph.series.forEach( function(series) {
				if (!series.renderer) {
					throw new Error("Each series needs a renderer for graph 'multi' renderer");
				}
			});
	
			this.graph.vis.selectAll('*').remove();
	
			var groups = this._groups();
			groups = this._stack(groups);
	
			groups.forEach( function(group) {
	
				var series = group.series
					.filter( function(series) { return !series.disabled } );
	
				series.active = function() { return series };
	
				group.renderer.render({ series: series, vis: group.vis });
				series.forEach(function(s) { s.stack = s._stack || s.stack || s.data; });
			});
		}
	
	} );
	Rickshaw.namespace('Rickshaw.Graph.Renderer.LinePlot');
	
	Rickshaw.Graph.Renderer.LinePlot = Rickshaw.Class.create( Rickshaw.Graph.Renderer, {
	
		name: 'lineplot',
	
		defaults: function($super) {
	
			return Rickshaw.extend( $super(), {
				unstack: true,
				fill: false,
				stroke: true,
				padding:{ top: 0.01, right: 0.01, bottom: 0.01, left: 0.01 },
				dotSize: 3,
				strokeWidth: 2
			} );
		},
	
		seriesPathFactory: function() {
	
			var graph = this.graph;
	
			var factory = d3.svg.line()
				.x( function(d) { return graph.x(d.x) } )
				.y( function(d) { return graph.y(d.y) } )
				.interpolate(this.graph.interpolation).tension(this.tension);
	
			factory.defined && factory.defined( function(d) { return d.y !== null } );
			return factory;
		},
	
		render: function(args) {
	
			args = args || {};
	
			var graph = this.graph;
	
			var series = args.series || graph.series;
			var vis = args.vis || graph.vis;
	
			var dotSize = this.dotSize;
	
			vis.selectAll('*').remove();
	
			var data = series
				.filter(function(s) { return !s.disabled })
				.map(function(s) { return s.stack });
	
			var nodes = vis.selectAll("path")
				.data(data)
				.enter().append("svg:path")
				.attr("d", this.seriesPathFactory());
	
			var i = 0;
			series.forEach(function(series) {
				if (series.disabled) return;
				series.path = nodes[0][i++];
				this._styleSeries(series);
			}, this);
	
			series.forEach(function(series) {
	
				if (series.disabled) return;
	
				var nodes = vis.selectAll("x")
					.data(series.stack.filter( function(d) { return d.y !== null } ))
					.enter().append("svg:circle")
					.attr("cx", function(d) { return graph.x(d.x) })
					.attr("cy", function(d) { return graph.y(d.y) })
					.attr("r", function(d) { return ("r" in d) ? d.r : dotSize});
	
				Array.prototype.forEach.call(nodes[0], function(n) {
					if (!n) return;
					n.setAttribute('data-color', series.color);
					n.setAttribute('fill', 'white');
					n.setAttribute('stroke', series.color);
					n.setAttribute('stroke-width', this.strokeWidth);
	
				}.bind(this));
	
			}, this);
		}
	} );
	
	Rickshaw.namespace('Rickshaw.Graph.Smoother');
	
	Rickshaw.Graph.Smoother = Rickshaw.Class.create({
	
		initialize: function(args) {
	
			this.graph = args.graph;
			this.element = args.element;
			this.aggregationScale = 1;
	
			this.build();
	
			this.graph.stackData.hooks.data.push( {
				name: 'smoother',
				orderPosition: 50,
				f: this.transformer.bind(this)
			} );
		},
	
		build: function() {
	
			var self = this;
			var $ = jQuery;
	
			if (this.element) {
				$( function() {
					$(self.element).slider( {
						min: 1,
						max: 100,
						slide: function( event, ui ) {
							self.setScale(ui.value);
						}
					} );
				} );
			}
		},
	
		setScale: function(scale) {
	
			if (scale < 1) {
				throw "scale out of range: " + scale;
			}
	
			this.aggregationScale = scale;
			this.graph.update();
		},
	
		transformer: function(data) {
	
			if (this.aggregationScale == 1) return data;
	
			var aggregatedData = [];
	
			data.forEach( function(seriesData) {
	
				var aggregatedSeriesData = [];
	
				while (seriesData.length) {
	
					var avgX = 0, avgY = 0;
					var slice = seriesData.splice(0, this.aggregationScale);
	
					slice.forEach( function(d) {
						avgX += d.x / slice.length;
						avgY += d.y / slice.length;
					} );
	
					aggregatedSeriesData.push( { x: avgX, y: avgY } );
				}
	
				aggregatedData.push(aggregatedSeriesData);
	
			}.bind(this) );
	
			return aggregatedData;
		}
	});
	
	Rickshaw.namespace('Rickshaw.Graph.Socketio');
	
	Rickshaw.Graph.Socketio = Rickshaw.Class.create( Rickshaw.Graph.Ajax, {
		request: function() {
			var socket = io.connect(this.dataURL);
			var self = this;
			socket.on('rickshaw', function (data) {
				self.success(data);
			});
		}
	} );
	Rickshaw.namespace('Rickshaw.Series');
	
	Rickshaw.Series = Rickshaw.Class.create( Array, {
	
		initialize: function (data, palette, options) {
	
			options = options || {};
	
			this.palette = new Rickshaw.Color.Palette(palette);
	
			this.timeBase = typeof(options.timeBase) === 'undefined' ? 
				Math.floor(new Date().getTime() / 1000) : 
				options.timeBase;
	
			var timeInterval = typeof(options.timeInterval) == 'undefined' ?
				1000 :
				options.timeInterval;
	
			this.setTimeInterval(timeInterval);
	
			if (data && (typeof(data) == "object") && Array.isArray(data)) {
				data.forEach( function(item) { this.addItem(item) }, this );
			}
		},
	
		addItem: function(item) {
	
			if (typeof(item.name) === 'undefined') {
				throw('addItem() needs a name');
			}
	
			item.color = (item.color || this.palette.color(item.name));
			item.data = (item.data || []);
	
			// backfill, if necessary
			if ((item.data.length === 0) && this.length && (this.getIndex() > 0)) {
				this[0].data.forEach( function(plot) {
					item.data.push({ x: plot.x, y: 0 });
				} );
			} else if (item.data.length === 0) {
				item.data.push({ x: this.timeBase - (this.timeInterval || 0), y: 0 });
			} 
	
			this.push(item);
	
			if (this.legend) {
				this.legend.addLine(this.itemByName(item.name));
			}
		},
	
		addData: function(data, x) {
	
			var index = this.getIndex();
	
			Rickshaw.keys(data).forEach( function(name) {
				if (! this.itemByName(name)) {
					this.addItem({ name: name });
				}
			}, this );
	
			this.forEach( function(item) {
				item.data.push({ 
					x: x || (index * this.timeInterval || 1) + this.timeBase, 
					y: (data[item.name] || 0) 
				});
			}, this );
		},
	
		getIndex: function () {
			return (this[0] && this[0].data && this[0].data.length) ? this[0].data.length : 0;
		},
	
		itemByName: function(name) {
	
			for (var i = 0; i < this.length; i++) {
				if (this[i].name == name)
					return this[i];
			}
		},
	
		setTimeInterval: function(iv) {
			this.timeInterval = iv / 1000;
		},
	
		setTimeBase: function (t) {
			this.timeBase = t;
		},
	
		dump: function() {
	
			var data = {
				timeBase: this.timeBase,
				timeInterval: this.timeInterval,
				items: []
			};
	
			this.forEach( function(item) {
	
				var newItem = {
					color: item.color,
					name: item.name,
					data: []
				};
	
				item.data.forEach( function(plot) {
					newItem.data.push({ x: plot.x, y: plot.y });
				} );
	
				data.items.push(newItem);
			} );
	
			return data;
		},
	
		load: function(data) {
	
			if (data.timeInterval) {
				this.timeInterval = data.timeInterval;
			}
	
			if (data.timeBase) {
				this.timeBase = data.timeBase;
			}
	
			if (data.items) {
				data.items.forEach( function(item) {
					this.push(item);
					if (this.legend) {
						this.legend.addLine(this.itemByName(item.name));
					}
	
				}, this );
			}
		}
	} );
	
	Rickshaw.Series.zeroFill = function(series) {
		Rickshaw.Series.fill(series, 0);
	};
	
	Rickshaw.Series.fill = function(series, fill) {
	
		var x;
		var i = 0;
	
		var data = series.map( function(s) { return s.data } );
	
		while ( i < Math.max.apply(null, data.map( function(d) { return d.length } )) ) {
	
			x = Math.min.apply( null, 
				data
					.filter(function(d) { return d[i] })
					.map(function(d) { return d[i].x })
			);
	
			data.forEach( function(d) {
				if (!d[i] || d[i].x != x) {
					d.splice(i, 0, { x: x, y: fill });
				}
			} );
	
			i++;
		}
	};
	
	Rickshaw.namespace('Rickshaw.Series.FixedDuration');
	
	Rickshaw.Series.FixedDuration = Rickshaw.Class.create(Rickshaw.Series, {
	
		initialize: function (data, palette, options) {
	
			options = options || {};
	
			if (typeof(options.timeInterval) === 'undefined') {
				throw new Error('FixedDuration series requires timeInterval');
			}
	
			if (typeof(options.maxDataPoints) === 'undefined') {
				throw new Error('FixedDuration series requires maxDataPoints');
			}
	
			this.palette = new Rickshaw.Color.Palette(palette);
			this.timeBase = typeof(options.timeBase) === 'undefined' ? Math.floor(new Date().getTime() / 1000) : options.timeBase;
			this.setTimeInterval(options.timeInterval);
	
			if (this[0] && this[0].data && this[0].data.length) {
				this.currentSize = this[0].data.length;
				this.currentIndex = this[0].data.length;
			} else {
				this.currentSize  = 0;
				this.currentIndex = 0;
			}
	
			this.maxDataPoints = options.maxDataPoints;
	
	
			if (data && (typeof(data) == "object") && Array.isArray(data)) {
				data.forEach( function (item) { this.addItem(item) }, this );
				this.currentSize  += 1;
				this.currentIndex += 1;
			}
	
			// reset timeBase for zero-filled values if needed
			this.timeBase -= (this.maxDataPoints - this.currentSize) * this.timeInterval;
	
			// zero-fill up to maxDataPoints size if we don't have that much data yet
			if ((typeof(this.maxDataPoints) !== 'undefined') && (this.currentSize < this.maxDataPoints)) {
				for (var i = this.maxDataPoints - this.currentSize - 1; i > 1; i--) {
					this.currentSize  += 1;
					this.currentIndex += 1;
					this.forEach( function (item) {
						item.data.unshift({ x: ((i-1) * this.timeInterval || 1) + this.timeBase, y: 0, i: i });
					}, this );
				}
			}
		},
	
		addData: function($super, data, x) {
	
			$super(data, x);
	
			this.currentSize += 1;
			this.currentIndex += 1;
	
			if (this.maxDataPoints !== undefined) {
				while (this.currentSize > this.maxDataPoints) {
					this.dropData();
				}
			}
		},
	
		dropData: function() {
	
			this.forEach(function(item) {
				item.data.splice(0, 1);
			} );
	
			this.currentSize -= 1;
		},
	
		getIndex: function () {
			return this.currentIndex;
		}
	} );
	
		return Rickshaw;
	}));


/***/ },
/* 221 */,
/* 222 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAABgBAMAAAA0pnCnAAAAElBMVEVDi8lYl85Hi8VenNJQlM5Ci8ooz7SQAAAA1ElEQVR4AczYMRWDAADE0CwYQAEWeCehFhr/VroUDeTGG/8Y/Oy/+/LZSx9+9+w8nvelD0M0GKLBEA2GaDBEgyEaDNFgiAZDNBiiwRANhmiwQwN2aMASzVGiuUI0nCEa7hANC9GwEA0L0bAQDQvRsBANC9GwEA0L0bAQDQvRsBANC9GwEA0L0bAQDQvREIqdEoqdljvwrx07EAAAAAAA8n9thAwf+AN/4A/8gT/wB/7AH/gDf+AP/IE/8Af+wB/4A3/gD/yBP/AH/sAf+AN/4A/8gT8wqYYo5m5uSpMAAAAASUVORK5CYII="

/***/ },
/* 223 */,
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(81);

/***/ },
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _numeral = __webpack_require__(21);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _crossfilter = __webpack_require__(125);
	
	var _crossfilter2 = _interopRequireDefault(_crossfilter);
	
	var _dc = __webpack_require__(95);
	
	var _dc2 = _interopRequireDefault(_dc);
	
	var _d3 = __webpack_require__(56);
	
	var _d32 = _interopRequireDefault(_d3);
	
	// eslint-disable-next-line no-unused-vars
	
	var _jquery = __webpack_require__(13);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _deepEqual = __webpack_require__(132);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _logicDatetimesDateTime = __webpack_require__(31);
	
	var _logicDatetimesDateTime2 = _interopRequireDefault(_logicDatetimesDateTime);
	
	var _logicGraphsHistogramFormatter = __webpack_require__(120);
	
	var _logicGraphsHistogramFormatter2 = _interopRequireDefault(_logicGraphsHistogramFormatter);
	
	var _utilD3Utils = __webpack_require__(121);
	
	var _utilD3Utils2 = _interopRequireDefault(_utilD3Utils);
	
	var _utilNumberUtils = __webpack_require__(37);
	
	var _utilNumberUtils2 = _interopRequireDefault(_utilNumberUtils);
	
	var _legacyGraphHelper = __webpack_require__(152);
	
	var _legacyGraphHelper2 = _interopRequireDefault(_legacyGraphHelper);
	
	__webpack_require__(84);
	__webpack_require__(199);
	
	var GraphFactory = {
	  create: function create(config, domNode, tooltipTitleFormatter) {
	    var graph = undefined;
	    switch (config.renderer) {
	      case 'line':
	        graph = _dc2['default'].lineChart(domNode);
	        _utilD3Utils2['default'].tooltipRenderlet(graph, '.chart-body circle.dot', tooltipTitleFormatter);
	        break;
	      case 'area':
	        graph = _dc2['default'].lineChart(domNode);
	        graph.renderArea(true);
	        _utilD3Utils2['default'].tooltipRenderlet(graph, '.chart-body circle.dot', tooltipTitleFormatter);
	        break;
	      case 'bar':
	        graph = _dc2['default'].barChart(domNode);
	        graph.centerBar(true);
	        _utilD3Utils2['default'].tooltipRenderlet(graph, '.chart-body rect.bar', tooltipTitleFormatter);
	        break;
	      case 'scatterplot':
	        graph = _dc2['default'].lineChart(domNode);
	        graph.renderDataPoints({ radius: 2, fillOpacity: 1, strokeOpacity: 1 });
	        _utilD3Utils2['default'].tooltipRenderlet(graph, '.chart-body circle.dot', tooltipTitleFormatter);
	        break;
	      default:
	        throw new Error("Unsupported renderer '" + config.renderer + "'");
	    }
	
	    if (config.renderer === 'line' || config.renderer === 'area') {
	      graph.interpolate(config.interpolation);
	    }
	
	    // Bar charts with clip padding overflow the x axis
	    if (config.renderer !== 'bar') {
	      graph.clipPadding(5);
	    }
	
	    return graph;
	  }
	};
	
	var GraphVisualization = _react2['default'].createClass({
	  displayName: 'GraphVisualization',
	
	  propTypes: {
	    id: _react.PropTypes.string.isRequired,
	    data: _react.PropTypes.object.isRequired,
	    config: _react.PropTypes.object.isRequired,
	    computationTimeRange: _react.PropTypes.object,
	    height: _react.PropTypes.number,
	    width: _react.PropTypes.number
	  },
	  statics: {
	    getReadableFieldChartStatisticalFunction: function getReadableFieldChartStatisticalFunction(statisticalFunction) {
	      switch (statisticalFunction) {
	        case 'count':
	          return 'total';
	        case 'total':
	          return 'sum';
	        default:
	          return statisticalFunction;
	      }
	    }
	  },
	  getInitialState: function getInitialState() {
	    this.triggerRender = true;
	    this.graphData = (0, _crossfilter2['default'])();
	    this.dimension = this.graphData.dimension(function (d) {
	      return d.x;
	    });
	    this.group = this.dimension.group().reduceSum(function (d) {
	      return d.y;
	    });
	
	    return {
	      dataPoints: []
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.renderGraph();
	    this._updateData(this.props.data, this.props.config);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ((0, _deepEqual2['default'])(this.props, nextProps)) {
	      return;
	    }
	
	    if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
	      this._resizeVisualization(nextProps.width, nextProps.height);
	    }
	    this._updateData(nextProps.data, nextProps.config);
	  },
	  _updateData: function _updateData(data, config) {
	    var isSearchAll = config.timerange.type === 'relative' && config.timerange.range === 0;
	    var dataPoints = _logicGraphsHistogramFormatter2['default'].format(data, this.props.computationTimeRange, config.interval, this.props.width, isSearchAll, config.valuetype);
	
	    this.setState({ dataPoints: this._normalizeData(dataPoints) }, this.drawData);
	  },
	  _normalizeData: function _normalizeData(data) {
	    if (data === null || data === undefined || !Array.isArray(data)) {
	      return [];
	    }
	    return data.map(function (dataPoint) {
	      dataPoint.y = _utilNumberUtils2['default'].normalizeGraphNumber(dataPoint.y);
	      return dataPoint;
	    });
	  },
	  _formatTooltipTitle: function _formatTooltipTitle(d) {
	    var formattedKey = d.x === undefined ? d.x : new _logicDatetimesDateTime2['default'](d.x).toString(_logicDatetimesDateTime2['default'].Formats.COMPLETE);
	
	    var formattedValue = undefined;
	    try {
	      formattedValue = (0, _numeral2['default'])(d.y).format('0,0.[00]');
	    } catch (e) {
	      formattedValue = _d32['default'].format('.2r')(d.y);
	    }
	
	    var valueText = GraphVisualization.getReadableFieldChartStatisticalFunction(this.props.config.valuetype) + ' ' + this.props.config.field + ': ' + formattedValue;
	    var keyText = '<span class="date">' + formattedKey + '</span>';
	
	    return '<div class="datapoint-info">' + valueText + '<br>' + keyText + '</div>';
	  },
	  _resizeVisualization: function _resizeVisualization(width, height) {
	    this.graph.width(width).height(height);
	    this.triggerRender = true;
	  },
	  drawData: function drawData() {
	    var _this = this;
	
	    this.graph.xUnits(function () {
	      return Math.max(_this.state.dataPoints.length - 1, 1);
	    });
	    this.graphData.remove();
	    this.graphData.add(this.state.dataPoints);
	
	    // Fix to make Firefox render tooltips in the right place
	    // TODO: Find the cause of this
	    if (this.triggerRender) {
	      this.graph.render();
	      this.triggerRender = false;
	    } else {
	      this.graph.redraw();
	    }
	  },
	  renderGraph: function renderGraph() {
	    var graphDomNode = _reactDom2['default'].findDOMNode(this);
	
	    this.graph = GraphFactory.create(this.props.config, graphDomNode, this._formatTooltipTitle);
	    this.graph.width(this.props.width).height(this.props.height).margins({ left: 50, right: 15, top: 10, bottom: 35 }).dimension(this.dimension).group(this.group).x(_d32['default'].time.scale()).elasticX(true).elasticY(true).renderHorizontalGridLines(true).brushOn(false).xAxisLabel('Time').yAxisLabel(this.props.config.field).renderTitle(false).colors(_utilD3Utils2['default'].glColourPalette());
	
	    $(graphDomNode).tooltip({
	      'selector': '[rel="tooltip"]',
	      'container': 'body',
	      'placement': 'auto',
	      'delay': { show: 300, hide: 100 },
	      'html': true
	    });
	
	    this.graph.xAxis().ticks(_legacyGraphHelper2['default'].customTickInterval()).tickFormat(_legacyGraphHelper2['default'].customDateTimeFormat());
	    this.graph.yAxis().ticks(3).tickFormat(function (value) {
	      return Math.abs(value) > 1e+30 ? value.toPrecision(1) : _d32['default'].format('.2s')(value);
	    });
	    this.graph.render();
	  },
	  render: function render() {
	    return _react2['default'].createElement('div', { id: 'visualization-' + this.props.id, className: 'graph ' + this.props.config.renderer });
	  }
	});
	
	exports['default'] = GraphVisualization;
	module.exports = exports['default'];

/***/ },
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9a25466e5ac752f14dfa013fad9730a.jpg";

/***/ },
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ },
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var refs = 0;
	var dispose;
	var content = __webpack_require__(1128);
	if(typeof content === 'string') content = [[module.id, content, '']];
	exports.use = exports.ref = function() {
		if(!(refs++)) {
			exports.locals = content.locals;
			dispose = __webpack_require__(20)(content, {});
		}
		return exports;
	};
	exports.unuse = exports.unref = function() {
		if(!(--refs)) {
			dispose();
			dispose = null;
		}
	};
	if(false) {
		var lastRefs = module.hot.data && module.hot.data.refs || 0;
		if(lastRefs) {
			exports.ref();
			if(!content.locals) {
				refs = lastRefs;
			}
		}
		if(!content.locals) {
			module.hot.accept();
		}
		module.hot.dispose(function(data) {
			data.refs = content.locals ? 0 : refs;
			if(dispose) {
				dispose();
			}
		});
	}

/***/ },
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(636);

/***/ },
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var CodecTypesActions = _reflux2['default'].createActions({
	  list: { asyncResult: true }
	});
	
	exports['default'] = CodecTypesActions;
	module.exports = exports['default'];

/***/ },
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _rickshaw = __webpack_require__(220);
	
	var _rickshaw2 = _interopRequireDefault(_rickshaw);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _legacyGraphHelper = __webpack_require__(152);
	
	var _legacyGraphHelper2 = _interopRequireDefault(_legacyGraphHelper);
	
	_rickshaw2['default'].namespace('Rickshaw.Fixtures.Graylog2Time');
	
	var Graylog2Time = function Graylog2Time() {
	
		var self = this;
	
		this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
		this.units = [{
			name: 'decade',
			seconds: 86400 * 365.25 * 10,
			formatter: function formatter(d) {
				return self.formatDate(d);
			}
		}, {
			name: 'year',
			seconds: 86400 * 365.25,
			formatter: function formatter(d) {
				return self.formatDate(d);
			}
		}, {
			name: 'month',
			seconds: 86400 * 30.5,
			formatter: function formatter(d) {
				return self.formatDate(d);
			}
		}, {
			name: 'week',
			seconds: 86400 * 7,
			formatter: function formatter(d) {
				return self.formatDate(d);
			}
		}, {
			name: 'day',
			seconds: 86400,
			formatter: function formatter(d) {
				return self.formatDate(d);
			}
		}, {
			name: '3 hours',
			seconds: 3600 * 3,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: 'hour',
			seconds: 3600,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: '15 minutes',
			seconds: 60 * 15,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: '5 minutes',
			seconds: 60 * 5,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: 'minute',
			seconds: 60,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: '15 second',
			seconds: 15,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: 'second',
			seconds: 1,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}, {
			name: 'millisecond',
			seconds: 1 / 1000,
			formatter: function formatter(d) {
				return self.formatDateTime(d);
			}
		}];
	
		this.unit = function (unitName) {
			return this.units.filter(function (unit) {
				return unitName == unit.name;
			}).shift();
		};
	
		this.formatDateTime = _legacyGraphHelper2['default'].customDateTimeFormat();
	
		// Data in histograms is calculated using UTC. When the histogram resolution is day or lower,
		// we can't extrapolate the data to the user's local time, so we use UTC instead.
		this.formatDate = _legacyGraphHelper2['default'].customDateTimeFormat(0);
	
		this.ceil = function (time, unit) {
	
			var date, floor, year;
	
			if (unit.name == 'week') {
				var momentDate = _moment2['default'].utc(time * 1000);
				momentDate.startOf('isoWeek');
	
				if (momentDate.unix() == time) return time;
	
				momentDate.add(1, 'week');
				return momentDate.unix();
			}
	
			if (unit.name == 'month') {
	
				date = new Date(time * 1000);
	
				floor = Date.UTC(date.getUTCFullYear(), date.getUTCMonth()) / 1000;
				if (floor == time) return time;
	
				year = date.getUTCFullYear();
				var month = date.getUTCMonth();
	
				if (month == 11) {
					month = 0;
					year = year + 1;
				} else {
					month += 1;
				}
	
				return Date.UTC(year, month) / 1000;
			}
	
			if (unit.name == 'year') {
	
				date = new Date(time * 1000);
	
				floor = Date.UTC(date.getUTCFullYear(), 0) / 1000;
				if (floor == time) return time;
	
				year = date.getUTCFullYear() + 1;
	
				return Date.UTC(year, 0) / 1000;
			}
	
			return Math.ceil(time / unit.seconds) * unit.seconds;
		};
	};
	
	_rickshaw2['default'].Fixtures.Graylog2Time = Graylog2Time;
	
	exports['default'] = Graylog2Time;
	module.exports = exports['default'];

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(13);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(627);
	
	var _rickshaw = __webpack_require__(220);
	
	var _rickshaw2 = _interopRequireDefault(_rickshaw);
	
	var _utilNumberUtils = __webpack_require__(37);
	
	var _utilNumberUtils2 = _interopRequireDefault(_utilNumberUtils);
	
	var _logicDatetimesDateTime = __webpack_require__(31);
	
	var _logicDatetimesDateTime2 = _interopRequireDefault(_logicDatetimesDateTime);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var SearchStore = _injectionStoreProvider2['default'].getStore('Search');
	
	_rickshaw2['default'].namespace('Rickshaw.Graph.Graylog2Selector');
	
	var Graylog2Selector = _rickshaw2['default'].Class.create({
	
	    initialize: function initialize(args) {
	        var graph = args.graph;
	        this.graph = args.graph;
	        this.build();
	        graph.onUpdate((function () {
	            this.update();
	        }).bind(this));
	    },
	
	    build: function build() {
	        var graph = this.graph;
	        var parent = graph.element.getElementsByTagName('svg')[0];
	
	        var selectingActive = false;
	        var position = this.position = {};
	
	        // Create selector box.
	        var selectionBox = document.createElement('div');
	        selectionBox.setAttribute('class', 'graph-range-selector');
	        graph.element.appendChild(selectionBox);
	
	        parent.oncontextmenu = function () {
	            e.preventDefault();
	        };
	
	        // Function to reset selection.
	        var clearSelection = function clearSelection() {
	            selectionBox.style.transition = 'opacity 0.2s ease-out';
	            selectionBox.style.opacity = 0;
	
	            setTimeout(function () {
	                selectionBox.style.width = 0;
	                selectionBox.style.height = 0;
	                selectionBox.style.top = 0;
	                selectionBox.style.left = 0;
	            }, 200);
	
	            parent.style.pointerEvents = 'auto';
	            graph.element.style.cursor = 'auto';
	        };
	
	        var selectionDraw = function selectionDraw(startPointX) {
	            if (selectingActive === true) {
	                parent.style.pointerEvents = 'none';
	            }
	
	            graph.element.style.cursor = 'crosshair';
	            graph.element.addEventListener('mousemove', function (e) {
	                if (selectingActive === true) {
	                    position.x = e.offsetX | e.layerX;
	                    position.deltaX = Math.round(Math.max(position.x, startPointX) - Math.min(position.x, startPointX));
	                    position.minX = Math.min(position.x, startPointX);
	                    position.maxX = position.minX + position.deltaX;
	
	                    selectionBox.style.transition = 'none';
	                    selectionBox.style.opacity = '1';
	                    selectionBox.style.width = position.deltaX + "px";
	                    selectionBox.style.height = '100%';
	                    selectionBox.style.left = position.minX + "px";
	                } else {
	                    return false;
	                }
	            }, false);
	        };
	
	        // On click in graph until button is released again. (begin of drag)
	        graph.element.addEventListener('mousedown', function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	
	            if (e.button === 0 | e.button === 1) {
	                var startPointX = e.layerX;
	                selectionBox.style.left = e.layerX;
	                selectingActive = true;
	                selectionDraw(startPointX);
	            } else {
	                return;
	            }
	        }, true);
	
	        // On mouse button release after click. (end of drag / complete)
	        graph.element.addEventListener('mouseup', function (e) {
	            selectingActive = false;
	            position.xMin = Math.round(graph.x.invert(position.minX));
	            position.xMax = Math.round(graph.x.invert(position.maxX));
	
	            var from = (0, _jquery2['default'])('#universalsearch .absolute .absolute-from-human');
	            var to = (0, _jquery2['default'])('#universalsearch .absolute .absolute-to-human');
	
	            if (!_utilNumberUtils2['default'].isNumber(position.xMin) || !_utilNumberUtils2['default'].isNumber(position.xMax)) {
	                clearSelection();
	                return;
	            }
	
	            var fromDate = new _logicDatetimesDateTime2['default'](position.xMin * 1000);
	            var toDate = new _logicDatetimesDateTime2['default'](position.xMax * 1000);
	
	            SearchStore.changeTimeRange('absolute', { from: fromDate.toString(), to: toDate.toString() });
	
	            (0, _jquery2['default'])(".timerange-selector-container").effect("bounce", {
	                complete: function complete() {
	                    // Submit search directly if alt key is pressed.
	                    if (e.altKey) {
	                        submitSearch();
	                    }
	                }
	            });
	
	            clearSelection();
	        }, false);
	
	        // Stop at chart boundaries.
	        if (graph.dataDomain()[0] === position.xMin) {
	            graph.window.xMin = undefined;
	        }
	        if (graph.dataDomain()[1] === position.xMax) {
	            graph.window.xMax = undefined;
	        }
	
	        graph.window.xMin = position.xMin;
	        graph.window.xMax = position.xMax;
	    },
	
	    update: function update() {
	        var graph = this.graph,
	            position = this.position;
	        graph.window.xMin = position.xMin;
	        graph.window.xMax = position.xMax;
	
	        if (graph.window.xMin === null) {
	            position.xMin = graph.dataDomain()[0];
	        }
	
	        if (graph.window.xMax === null) {
	            position.xMax = graph.dataDomain()[1];
	        }
	
	        position.xMin = graph.window.xMin;
	        position.xMax = graph.window.xMax;
	    }
	
	});
	
	_rickshaw2['default'].Graph.Graylog2Selector = Graylog2Selector;
	exports['default'] = Graylog2Selector;
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Store = {
	  set: function set(key, value) {
	    localStorage.setItem(key, JSON.stringify(value));
	  },
	
	  get: function get(key) {
	    var value = localStorage.getItem(key);
	    if (value === undefined || value === null) {
	      return undefined;
	    }
	
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      return value;
	    }
	  },
	
	  "delete": function _delete(key) {
	    localStorage.removeItem(key);
	  }
	};
	
	exports["default"] = Store;
	module.exports = exports["default"];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _logicMessageMessageFieldsFilter = __webpack_require__(903);
	
	var _logicMessageMessageFieldsFilter2 = _interopRequireDefault(_logicMessageMessageFieldsFilter);
	
	var MessageFormatter = {
	  formatMessageSummary: function formatMessageSummary(messageSummary) {
	    var message = messageSummary.message;
	    return this.formatMessage(message._id, messageSummary.index, message, message, messageSummary.highlight_ranges, messageSummary.decoration_stats);
	  },
	
	  formatResultMessage: function formatResultMessage(resultMessage) {
	    var message = resultMessage.message;
	    return this.formatMessage(message.id, resultMessage.index, message, message.fields, resultMessage.highlight_ranges, resultMessage.decoration_stats);
	  },
	
	  formatMessage: function formatMessage(id, index, message, fields, highlightRanges, decorationStats) {
	    var filteredFields = _logicMessageMessageFieldsFilter2['default'].filterFields(fields);
	    return {
	      id: id,
	      timestamp: (0, _moment2['default'])(message.timestamp).unix(),
	      filtered_fields: filteredFields,
	      formatted_fields: filteredFields,
	      fields: fields,
	      index: index,
	      source_node_id: fields.gl2_source_node,
	      source_input_id: fields.gl2_source_input,
	      stream_ids: message.streams,
	      highlight_ranges: highlightRanges,
	      decoration_stats: decorationStats
	    };
	  }
	};
	
	exports['default'] = MessageFormatter;
	module.exports = exports['default'];

/***/ },
/* 593 */,
/* 594 */
/***/ function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ },
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1d9c7945c7bc7dd0909105119bfbc191.eot";

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "56d9d42e23863ce0ee8e8c2e2f22843f.eot";

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "43d5342998f3607bd61a8239e98b1160.eot";

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "09e00aa7622ece30a0f1e06b55f66c2a.eot";

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4d82460ef260eb1589e73528cbfb257.eot";

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f28eb362fb6afe946d822ee5451c2146.eot";

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(1277);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(645);
	
	var _DOMUtils = __webpack_require__(640);
	
	var _deprecate = __webpack_require__(224);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	          process.env.NODE_ENV !== 'production' ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Effects Bounce 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Bounce Effect
	//>>group: Effects
	//>>description: Bounces an element horizontally or vertically n times.
	//>>docs: http://api.jqueryui.com/bounce-effect/
	//>>demos: http://jqueryui.com/effect/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(13),
				__webpack_require__(50),
				__webpack_require__(1169)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	return $.effects.define( "bounce", function( options, done ) {
		var upAnim, downAnim, refValue,
			element = $( this ),
	
			// Defaults:
			mode = options.mode,
			hide = mode === "hide",
			show = mode === "show",
			direction = options.direction || "up",
			distance = options.distance,
			times = options.times || 5,
	
			// Number of internal animations
			anims = times * 2 + ( show || hide ? 1 : 0 ),
			speed = options.duration / anims,
			easing = options.easing,
	
			// Utility:
			ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
			motion = ( direction === "up" || direction === "left" ),
			i = 0,
	
			queuelen = element.queue().length;
	
		$.effects.createPlaceholder( element );
	
		refValue = element.css( ref );
	
		// Default distance for the BIGGEST bounce is the outer Distance / 3
		if ( !distance ) {
			distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
		}
	
		if ( show ) {
			downAnim = { opacity: 1 };
			downAnim[ ref ] = refValue;
	
			// If we are showing, force opacity 0 and set the initial position
			// then do the "first" animation
			element
				.css( "opacity", 0 )
				.css( ref, motion ? -distance * 2 : distance * 2 )
				.animate( downAnim, speed, easing );
		}
	
		// Start at the smallest distance if we are hiding
		if ( hide ) {
			distance = distance / Math.pow( 2, times - 1 );
		}
	
		downAnim = {};
		downAnim[ ref ] = refValue;
	
		// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
		for ( ; i < times; i++ ) {
			upAnim = {};
			upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;
	
			element
				.animate( upAnim, speed, easing )
				.animate( downAnim, speed, easing );
	
			distance = hide ? distance * 2 : distance / 2;
		}
	
		// Last Bounce when Hiding
		if ( hide ) {
			upAnim = { opacity: 0 };
			upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;
	
			element.animate( upAnim, speed, easing );
		}
	
		element.queue( done );
	
		$.effects.unshift( element, queuelen, anims + 1 );
	} );
	
	} ) );


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Draggable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Draggable
	//>>group: Interactions
	//>>description: Enables dragging functionality for any element.
	//>>docs: http://api.jqueryui.com/draggable/
	//>>demos: http://jqueryui.com/draggable/
	//>>css.structure: ../../themes/base/draggable.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(13),
				__webpack_require__(629),
				__webpack_require__(1168),
				__webpack_require__(1171),
				__webpack_require__(1172),
				__webpack_require__(1173),
				__webpack_require__(1174),
				__webpack_require__(50),
				__webpack_require__(431)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.draggable", $.ui.mouse, {
		version: "1.12.1",
		widgetEventPrefix: "drag",
		options: {
			addClasses: true,
			appendTo: "parent",
			axis: false,
			connectToSortable: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			grid: false,
			handle: false,
			helper: "original",
			iframeFix: false,
			opacity: false,
			refreshPositions: false,
			revert: false,
			revertDuration: 500,
			scope: "default",
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			snap: false,
			snapMode: "both",
			snapTolerance: 20,
			stack: false,
			zIndex: false,
	
			// Callbacks
			drag: null,
			start: null,
			stop: null
		},
		_create: function() {
	
			if ( this.options.helper === "original" ) {
				this._setPositionRelative();
			}
			if ( this.options.addClasses ) {
				this._addClass( "ui-draggable" );
			}
			this._setHandleClassName();
	
			this._mouseInit();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "handle" ) {
				this._removeHandleClassName();
				this._setHandleClassName();
			}
		},
	
		_destroy: function() {
			if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
				this.destroyOnClear = true;
				return;
			}
			this._removeHandleClassName();
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var o = this.options;
	
			// Among others, prevent a drag on a resizable-handle
			if ( this.helper || o.disabled ||
					$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
				return false;
			}
	
			//Quit if we're not on a valid handle
			this.handle = this._getHandle( event );
			if ( !this.handle ) {
				return false;
			}
	
			this._blurActiveElement( event );
	
			this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );
	
			return true;
	
		},
	
		_blockFrames: function( selector ) {
			this.iframeBlocks = this.document.find( selector ).map( function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( "position", "absolute" )
					.appendTo( iframe.parent() )
					.outerWidth( iframe.outerWidth() )
					.outerHeight( iframe.outerHeight() )
					.offset( iframe.offset() )[ 0 ];
			} );
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_blurActiveElement: function( event ) {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				target = $( event.target );
	
			// Don't blur if the event occurred on an element that is within
			// the currently focused element
			// See #10527, #12472
			if ( target.closest( activeElement ).length ) {
				return;
			}
	
			// Blur any element that currently has focus, see #4261
			$.ui.safeBlur( activeElement );
		},
	
		_mouseStart: function( event ) {
	
			var o = this.options;
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			this._addClass( this.helper, "ui-draggable-dragging" );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			//If ddmanager is used for droppables, set the global draggable
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Store the helper's css position
			this.cssPosition = this.helper.css( "position" );
			this.scrollParent = this.helper.scrollParent( true );
			this.offsetParent = this.helper.offsetParent();
			this.hasFixedAncestor = this.helper.parents().filter( function() {
					return $( this ).css( "position" ) === "fixed";
				} ).length > 0;
	
			//The element's absolute position on the page minus margins
			this.positionAbs = this.element.offset();
			this._refreshOffsets( event );
	
			//Generate the original position
			this.originalPosition = this.position = this._generatePosition( event, false );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Set a containment if given in the options
			this._setContainment();
	
			//Trigger event + callbacks
			if ( this._trigger( "start", event ) === false ) {
				this._clear();
				return false;
			}
	
			//Recache the helper size
			this._cacheHelperProportions();
	
			//Prepare the droppable offsets
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			// Execute the drag once - this causes the helper not to be visible before getting its
			// correct position
			this._mouseDrag( event, true );
	
			// If the ddmanager is used for droppables, inform the manager that dragging has started
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStart( this, event );
			}
	
			return true;
		},
	
		_refreshOffsets: function( event ) {
			this.offset = {
				top: this.positionAbs.top - this.margins.top,
				left: this.positionAbs.left - this.margins.left,
				scroll: false,
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset()
			};
	
			this.offset.click = {
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			};
		},
	
		_mouseDrag: function( event, noPropagation ) {
	
			// reset any necessary cached properties (see #5009)
			if ( this.hasFixedAncestor ) {
				this.offset.parent = this._getParentOffset();
			}
	
			//Compute the helpers position
			this.position = this._generatePosition( event, true );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Call plugins and callbacks and use the resulting position if something is returned
			if ( !noPropagation ) {
				var ui = this._uiHash();
				if ( this._trigger( "drag", event, ui ) === false ) {
					this._mouseUp( new $.Event( "mouseup", event ) );
					return false;
				}
				this.position = ui.position;
			}
	
			this.helper[ 0 ].style.left = this.position.left + "px";
			this.helper[ 0 ].style.top = this.position.top + "px";
	
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			//If we are using droppables, inform the manager about the drop
			var that = this,
				dropped = false;
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				dropped = $.ui.ddmanager.drop( this, event );
			}
	
			//if a drop comes from outside (a sortable)
			if ( this.dropped ) {
				dropped = this.dropped;
				this.dropped = false;
			}
	
			if ( ( this.options.revert === "invalid" && !dropped ) ||
					( this.options.revert === "valid" && dropped ) ||
					this.options.revert === true || ( $.isFunction( this.options.revert ) &&
					this.options.revert.call( this.element, dropped ) )
			) {
				$( this.helper ).animate(
					this.originalPosition,
					parseInt( this.options.revertDuration, 10 ),
					function() {
						if ( that._trigger( "stop", event ) !== false ) {
							that._clear();
						}
					}
				);
			} else {
				if ( this._trigger( "stop", event ) !== false ) {
					this._clear();
				}
			}
	
			return false;
		},
	
		_mouseUp: function( event ) {
			this._unblockFrames();
	
			// If the ddmanager is used for droppables, inform the manager that dragging has stopped
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStop( this, event );
			}
	
			// Only need to focus if the event occurred on the draggable itself, see #10527
			if ( this.handleElement.is( event.target ) ) {
	
				// The interaction is over; whether or not the click resulted in a drag,
				// focus the element
				this.element.trigger( "focus" );
			}
	
			return $.ui.mouse.prototype._mouseUp.call( this, event );
		},
	
		cancel: function() {
	
			if ( this.helper.is( ".ui-draggable-dragging" ) ) {
				this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
			} else {
				this._clear();
			}
	
			return this;
	
		},
	
		_getHandle: function( event ) {
			return this.options.handle ?
				!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
				true;
		},
	
		_setHandleClassName: function() {
			this.handleElement = this.options.handle ?
				this.element.find( this.options.handle ) : this.element;
			this._addClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_removeHandleClassName: function() {
			this._removeClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helperIsFunction = $.isFunction( o.helper ),
				helper = helperIsFunction ?
					$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
					( o.helper === "clone" ?
						this.element.clone().removeAttr( "id" ) :
						this.element );
	
			if ( !helper.parents( "body" ).length ) {
				helper.appendTo( ( o.appendTo === "parent" ?
					this.element[ 0 ].parentNode :
					o.appendTo ) );
			}
	
			// Http://bugs.jqueryui.com/ticket/9446
			// a helper function can return the original element
			// which wouldn't have been set to relative in _create
			if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
				this._setPositionRelative();
			}
	
			if ( helper[ 0 ] !== this.element[ 0 ] &&
					!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
				helper.css( "position", "absolute" );
			}
	
			return helper;
	
		},
	
		_setPositionRelative: function() {
			if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
				this.element[ 0 ].style.position = "relative";
			}
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_isRootNode: function( element ) {
			return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			var po = this.offsetParent.offset(),
				document = this.document[ 0 ];
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
			if ( this.cssPosition !== "relative" ) {
				return { top: 0, left: 0 };
			}
	
			var p = this.element.position(),
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
			};
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
				right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
				bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var isUserScrollable, c, ce,
				o = this.options,
				document = this.document[ 0 ];
	
			this.relativeContainer = null;
	
			if ( !o.containment ) {
				this.containment = null;
				return;
			}
	
			if ( o.containment === "window" ) {
				this.containment = [
					$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
					$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
					$( window ).scrollLeft() + $( window ).width() -
						this.helperProportions.width - this.margins.left,
					$( window ).scrollTop() +
						( $( window ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment === "document" ) {
				this.containment = [
					0,
					0,
					$( document ).width() - this.helperProportions.width - this.margins.left,
					( $( document ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment.constructor === Array ) {
				this.containment = o.containment;
				return;
			}
	
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
	
			c = $( o.containment );
			ce = c[ 0 ];
	
			if ( !ce ) {
				return;
			}
	
			isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );
	
			this.containment = [
				( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
				( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
				( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width -
					this.margins.left -
					this.margins.right,
				( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height -
					this.margins.top -
					this.margins.bottom
			];
			this.relativeContainer = c;
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
	
			var mod = d === "absolute" ? 1 : -1,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event, constrainPosition ) {
	
			var containment, co, top, left,
				o = this.options,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
				pageX = event.pageX,
				pageY = event.pageY;
	
			// Cache the scroll
			if ( !scrollIsRootNode || !this.offset.scroll ) {
				this.offset.scroll = {
					top: this.scrollParent.scrollTop(),
					left: this.scrollParent.scrollLeft()
				};
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			// If we are not dragging yet, we won't check for options
			if ( constrainPosition ) {
				if ( this.containment ) {
					if ( this.relativeContainer ) {
						co = this.relativeContainer.offset();
						containment = [
							this.containment[ 0 ] + co.left,
							this.containment[ 1 ] + co.top,
							this.containment[ 2 ] + co.left,
							this.containment[ 3 ] + co.top
						];
					} else {
						containment = this.containment;
					}
	
					if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
						pageX = containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
						pageY = containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
						pageX = containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
						pageY = containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
	
					//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
					// argument errors in IE (see ticket #6950)
					top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
						this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
					pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
						top - this.offset.click.top > containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;
	
					left = o.grid[ 0 ] ? this.originalPageX +
						Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
						this.originalPageX;
					pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
						left - this.offset.click.left > containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
				}
	
				if ( o.axis === "y" ) {
					pageX = this.originalPageX;
				}
	
				if ( o.axis === "x" ) {
					pageY = this.originalPageY;
				}
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
				)
			};
	
		},
	
		_clear: function() {
			this._removeClass( this.helper, "ui-draggable-dragging" );
			if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
				this.helper.remove();
			}
			this.helper = null;
			this.cancelHelperRemoval = false;
			if ( this.destroyOnClear ) {
				this.destroy();
			}
		},
	
		// From now on bulk stuff - mainly helpers
	
		_trigger: function( type, event, ui ) {
			ui = ui || this._uiHash();
			$.ui.plugin.call( this, type, [ event, ui, this ], true );
	
			// Absolute position and offset (see #6884 ) have to be recalculated after plugins
			if ( /^(drag|start|stop)/.test( type ) ) {
				this.positionAbs = this._convertPositionTo( "absolute" );
				ui.offset = this.positionAbs;
			}
			return $.Widget.prototype._trigger.call( this, type, event, ui );
		},
	
		plugins: {},
	
		_uiHash: function() {
			return {
				helper: this.helper,
				position: this.position,
				originalPosition: this.originalPosition,
				offset: this.positionAbs
			};
		}
	
	} );
	
	$.ui.plugin.add( "draggable", "connectToSortable", {
		start: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.sortables = [];
			$( draggable.options.connectToSortable ).each( function() {
				var sortable = $( this ).sortable( "instance" );
	
				if ( sortable && !sortable.options.disabled ) {
					draggable.sortables.push( sortable );
	
					// RefreshPositions is called at drag start to refresh the containerCache
					// which is used in drag. This ensures it's initialized and synchronized
					// with any changes that might have happened on the page since initialization.
					sortable.refreshPositions();
					sortable._trigger( "activate", event, uiSortable );
				}
			} );
		},
		stop: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.cancelHelperRemoval = false;
	
			$.each( draggable.sortables, function() {
				var sortable = this;
	
				if ( sortable.isOver ) {
					sortable.isOver = 0;
	
					// Allow this sortable to handle removing the helper
					draggable.cancelHelperRemoval = true;
					sortable.cancelHelperRemoval = false;
	
					// Use _storedCSS To restore properties in the sortable,
					// as this also handles revert (#9675) since the draggable
					// may have modified them in unexpected ways (#8809)
					sortable._storedCSS = {
						position: sortable.placeholder.css( "position" ),
						top: sortable.placeholder.css( "top" ),
						left: sortable.placeholder.css( "left" )
					};
	
					sortable._mouseStop( event );
	
					// Once drag has ended, the sortable should return to using
					// its original helper, not the shared helper from draggable
					sortable.options.helper = sortable.options._helper;
				} else {
	
					// Prevent this Sortable from removing the helper.
					// However, don't set the draggable to remove the helper
					// either as another connected Sortable may yet handle the removal.
					sortable.cancelHelperRemoval = true;
	
					sortable._trigger( "deactivate", event, uiSortable );
				}
			} );
		},
		drag: function( event, ui, draggable ) {
			$.each( draggable.sortables, function() {
				var innermostIntersecting = false,
					sortable = this;
	
				// Copy over variables that sortable's _intersectsWith uses
				sortable.positionAbs = draggable.positionAbs;
				sortable.helperProportions = draggable.helperProportions;
				sortable.offset.click = draggable.offset.click;
	
				if ( sortable._intersectsWith( sortable.containerCache ) ) {
					innermostIntersecting = true;
	
					$.each( draggable.sortables, function() {
	
						// Copy over variables that sortable's _intersectsWith uses
						this.positionAbs = draggable.positionAbs;
						this.helperProportions = draggable.helperProportions;
						this.offset.click = draggable.offset.click;
	
						if ( this !== sortable &&
								this._intersectsWith( this.containerCache ) &&
								$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
							innermostIntersecting = false;
						}
	
						return innermostIntersecting;
					} );
				}
	
				if ( innermostIntersecting ) {
	
					// If it intersects, we use a little isOver variable and set it once,
					// so that the move-in stuff gets fired only once.
					if ( !sortable.isOver ) {
						sortable.isOver = 1;
	
						// Store draggable's parent in case we need to reappend to it later.
						draggable._parent = ui.helper.parent();
	
						sortable.currentItem = ui.helper
							.appendTo( sortable.element )
							.data( "ui-sortable-item", true );
	
						// Store helper option to later restore it
						sortable.options._helper = sortable.options.helper;
	
						sortable.options.helper = function() {
							return ui.helper[ 0 ];
						};
	
						// Fire the start events of the sortable with our passed browser event,
						// and our own helper (so it doesn't create a new one)
						event.target = sortable.currentItem[ 0 ];
						sortable._mouseCapture( event, true );
						sortable._mouseStart( event, true, true );
	
						// Because the browser event is way off the new appended portlet,
						// modify necessary variables to reflect the changes
						sortable.offset.click.top = draggable.offset.click.top;
						sortable.offset.click.left = draggable.offset.click.left;
						sortable.offset.parent.left -= draggable.offset.parent.left -
							sortable.offset.parent.left;
						sortable.offset.parent.top -= draggable.offset.parent.top -
							sortable.offset.parent.top;
	
						draggable._trigger( "toSortable", event );
	
						// Inform draggable that the helper is in a valid drop zone,
						// used solely in the revert option to handle "valid/invalid".
						draggable.dropped = sortable.element;
	
						// Need to refreshPositions of all sortables in the case that
						// adding to one sortable changes the location of the other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
	
						// Hack so receive/update callbacks work (mostly)
						draggable.currentItem = draggable.element;
						sortable.fromOutside = draggable;
					}
	
					if ( sortable.currentItem ) {
						sortable._mouseDrag( event );
	
						// Copy the sortable's position because the draggable's can potentially reflect
						// a relative position, while sortable is always absolute, which the dragged
						// element has now become. (#8809)
						ui.position = sortable.position;
					}
				} else {
	
					// If it doesn't intersect with the sortable, and it intersected before,
					// we fake the drag stop of the sortable, but make sure it doesn't remove
					// the helper by using cancelHelperRemoval.
					if ( sortable.isOver ) {
	
						sortable.isOver = 0;
						sortable.cancelHelperRemoval = true;
	
						// Calling sortable's mouseStop would trigger a revert,
						// so revert must be temporarily false until after mouseStop is called.
						sortable.options._revert = sortable.options.revert;
						sortable.options.revert = false;
	
						sortable._trigger( "out", event, sortable._uiHash( sortable ) );
						sortable._mouseStop( event, true );
	
						// Restore sortable behaviors that were modfied
						// when the draggable entered the sortable area (#9481)
						sortable.options.revert = sortable.options._revert;
						sortable.options.helper = sortable.options._helper;
	
						if ( sortable.placeholder ) {
							sortable.placeholder.remove();
						}
	
						// Restore and recalculate the draggable's offset considering the sortable
						// may have modified them in unexpected ways. (#8809, #10669)
						ui.helper.appendTo( draggable._parent );
						draggable._refreshOffsets( event );
						ui.position = draggable._generatePosition( event, true );
	
						draggable._trigger( "fromSortable", event );
	
						// Inform draggable that the helper is no longer in a valid drop zone
						draggable.dropped = false;
	
						// Need to refreshPositions of all sortables just in case removing
						// from one sortable changes the location of other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
					}
				}
			} );
		}
	} );
	
	$.ui.plugin.add( "draggable", "cursor", {
		start: function( event, ui, instance ) {
			var t = $( "body" ),
				o = instance.options;
	
			if ( t.css( "cursor" ) ) {
				o._cursor = t.css( "cursor" );
			}
			t.css( "cursor", o.cursor );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._cursor ) {
				$( "body" ).css( "cursor", o._cursor );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "opacity", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
			if ( t.css( "opacity" ) ) {
				o._opacity = t.css( "opacity" );
			}
			t.css( "opacity", o.opacity );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._opacity ) {
				$( ui.helper ).css( "opacity", o._opacity );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "scroll", {
		start: function( event, ui, i ) {
			if ( !i.scrollParentNotHidden ) {
				i.scrollParentNotHidden = i.helper.scrollParent( false );
			}
	
			if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
					i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
				i.overflowOffset = i.scrollParentNotHidden.offset();
			}
		},
		drag: function( event, ui, i  ) {
	
			var o = i.options,
				scrolled = false,
				scrollParent = i.scrollParentNotHidden[ 0 ],
				document = i.document[ 0 ];
	
			if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
				if ( !o.axis || o.axis !== "x" ) {
					if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
							o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
					} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
							o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
					}
				}
	
			} else {
	
				if ( !o.axis || o.axis !== "x" ) {
					if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
					} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() - o.scrollSpeed
						);
					} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() + o.scrollSpeed
						);
					}
				}
	
			}
	
			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( i, event );
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "snap", {
		start: function( event, ui, i ) {
	
			var o = i.options;
	
			i.snapElements = [];
	
			$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
				.each( function() {
					var $t = $( this ),
						$o = $t.offset();
					if ( this !== i.element[ 0 ] ) {
						i.snapElements.push( {
							item: this,
							width: $t.outerWidth(), height: $t.outerHeight(),
							top: $o.top, left: $o.left
						} );
					}
				} );
	
		},
		drag: function( event, ui, inst ) {
	
			var ts, bs, ls, rs, l, r, t, b, i, first,
				o = inst.options,
				d = o.snapTolerance,
				x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
				y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
	
			for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {
	
				l = inst.snapElements[ i ].left - inst.margins.left;
				r = l + inst.snapElements[ i ].width;
				t = inst.snapElements[ i ].top - inst.margins.top;
				b = t + inst.snapElements[ i ].height;
	
				if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
						!$.contains( inst.snapElements[ i ].item.ownerDocument,
						inst.snapElements[ i ].item ) ) {
					if ( inst.snapElements[ i ].snapping ) {
						( inst.options.snap.release &&
							inst.options.snap.release.call(
								inst.element,
								event,
								$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
							) );
					}
					inst.snapElements[ i ].snapping = false;
					continue;
				}
	
				if ( o.snapMode !== "inner" ) {
					ts = Math.abs( t - y2 ) <= d;
					bs = Math.abs( b - y1 ) <= d;
					ls = Math.abs( l - x2 ) <= d;
					rs = Math.abs( r - x1 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l - inst.helperProportions.width
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r
						} ).left;
					}
				}
	
				first = ( ts || bs || ls || rs );
	
				if ( o.snapMode !== "outer" ) {
					ts = Math.abs( t - y1 ) <= d;
					bs = Math.abs( b - y2 ) <= d;
					ls = Math.abs( l - x1 ) <= d;
					rs = Math.abs( r - x2 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r - inst.helperProportions.width
						} ).left;
					}
				}
	
				if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
					( inst.options.snap.snap &&
						inst.options.snap.snap.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), {
								snapItem: inst.snapElements[ i ].item
							} ) ) );
				}
				inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );
	
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "stack", {
		start: function( event, ui, instance ) {
			var min,
				o = instance.options,
				group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
					return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
						( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
				} );
	
			if ( !group.length ) { return; }
	
			min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
			$( group ).each( function( i ) {
				$( this ).css( "zIndex", min + i );
			} );
			this.css( "zIndex", ( min + group.length ) );
		}
	} );
	
	$.ui.plugin.add( "draggable", "zIndex", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
	
			if ( t.css( "zIndex" ) ) {
				o._zIndex = t.css( "zIndex" );
			}
			t.css( "zIndex", o.zIndex );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
	
			if ( o._zIndex ) {
				$( ui.helper ).css( "zIndex", o._zIndex );
			}
		}
	} );
	
	return $.ui.draggable;
	
	} ) );


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(13),
				__webpack_require__(1170),
				__webpack_require__(50),
				__webpack_require__(431)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	return $.widget( "ui.mouse", {
		version: "1.12.1",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	} ) );


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(1123),
	      utf8 = __webpack_require__(594).utf8,
	      isBuffer = __webpack_require__(1167),
	      bin = __webpack_require__(594).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ },
/* 631 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	internals.hexTable = new Array(256);
	for (var h = 0; h < 256; ++h) {
	    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
	}
	
	
	exports.arrayToObject = function (source, options) {
	
	    var obj = options.plainObjects ? Object.create(null) : {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source, options) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else if (typeof target === 'object') {
	            target[source] = true;
	        }
	        else {
	            target = [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target, options);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!Object.prototype.hasOwnProperty.call(target, key)) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value, options);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    if (typeof str !== 'string') {
	        str = '' + str;
	    }
	
	    var out = '';
	    for (var i = 0, il = str.length; i < il; ++i) {
	        var c = str.charCodeAt(i);
	
	        if (c === 0x2D || // -
	            c === 0x2E || // .
	            c === 0x5F || // _
	            c === 0x7E || // ~
	            (c >= 0x30 && c <= 0x39) || // 0-9
	            (c >= 0x41 && c <= 0x5A) || // a-z
	            (c >= 0x61 && c <= 0x7A)) { // A-Z
	
	            out += str[i];
	            continue;
	        }
	
	        if (c < 0x80) {
	            out += internals.hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
	            continue;
	        }
	
	        ++i;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
	        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	              obj.constructor.isBuffer &&
	              obj.constructor.isBuffer(obj));
	};


/***/ },
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 * IPv6 Support
	 *
	 * Version: 1.18.4
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.IPv6 = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  /*
	  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
	  var _out = IPv6.best(_in);
	  var _expected = "fe80::204:61ff:fe9d:f156";
	
	  console.log(_in, _out, _expected, _out === _expected);
	  */
	
	  // save current IPv6 variable, if any
	  var _IPv6 = root && root.IPv6;
	
	  function bestPresentation(address) {
	    // based on:
	    // Javascript to test an IPv6 address for proper format, and to
	    // present the "best text representation" according to IETF Draft RFC at
	    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
	    // 8 Feb 2010 Rich Brown, Dartware, LLC
	    // Please feel free to use this code as long as you provide a link to
	    // http://www.intermapper.com
	    // http://intermapper.com/support/tools/IPV6-Validator.aspx
	    // http://download.dartware.com/thirdparty/ipv6validator.js
	
	    var _address = address.toLowerCase();
	    var segments = _address.split(':');
	    var length = segments.length;
	    var total = 8;
	
	    // trim colons (:: or ::a:b:c… or …a:b:c::)
	    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
	      // must have been ::
	      // remove first two items
	      segments.shift();
	      segments.shift();
	    } else if (segments[0] === '' && segments[1] === '') {
	      // must have been ::xxxx
	      // remove the first item
	      segments.shift();
	    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
	      // must have been xxxx::
	      segments.pop();
	    }
	
	    length = segments.length;
	
	    // adjust total segments for IPv4 trailer
	    if (segments[length - 1].indexOf('.') !== -1) {
	      // found a "." which means IPv4
	      total = 7;
	    }
	
	    // fill empty segments them with "0000"
	    var pos;
	    for (pos = 0; pos < length; pos++) {
	      if (segments[pos] === '') {
	        break;
	      }
	    }
	
	    if (pos < total) {
	      segments.splice(pos, 1, '0000');
	      while (segments.length < total) {
	        segments.splice(pos, 0, '0000');
	      }
	    }
	
	    // strip leading zeros
	    var _segments;
	    for (var i = 0; i < total; i++) {
	      _segments = segments[i].split('');
	      for (var j = 0; j < 3 ; j++) {
	        if (_segments[0] === '0' && _segments.length > 1) {
	          _segments.splice(0,1);
	        } else {
	          break;
	        }
	      }
	
	      segments[i] = _segments.join('');
	    }
	
	    // find longest sequence of zeroes and coalesce them into one segment
	    var best = -1;
	    var _best = 0;
	    var _current = 0;
	    var current = -1;
	    var inzeroes = false;
	    // i; already declared
	
	    for (i = 0; i < total; i++) {
	      if (inzeroes) {
	        if (segments[i] === '0') {
	          _current += 1;
	        } else {
	          inzeroes = false;
	          if (_current > _best) {
	            best = current;
	            _best = _current;
	          }
	        }
	      } else {
	        if (segments[i] === '0') {
	          inzeroes = true;
	          current = i;
	          _current = 1;
	        }
	      }
	    }
	
	    if (_current > _best) {
	      best = current;
	      _best = _current;
	    }
	
	    if (_best > 1) {
	      segments.splice(best, _best, '');
	    }
	
	    length = segments.length;
	
	    // assemble remaining segments
	    var result = '';
	    if (segments[0] === '')  {
	      result = ':';
	    }
	
	    for (i = 0; i < length; i++) {
	      result += segments[i];
	      if (i === length - 1) {
	        break;
	      }
	
	      result += ':';
	    }
	
	    if (segments[length - 1] === '') {
	      result += ':';
	    }
	
	    return result;
	  }
	
	  function noConflict() {
	    /*jshint validthis: true */
	    if (root.IPv6 === this) {
	      root.IPv6 = _IPv6;
	    }
	  
	    return this;
	  }
	
	  return {
	    best: bestPresentation,
	    noConflict: noConflict
	  };
	}));


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * URI.js - Mutating URLs
	 * Second Level Domain (SLD) Support
	 *
	 * Version: 1.18.4
	 *
	 * Author: Rodney Rehm
	 * Web: http://medialize.github.io/URI.js/
	 *
	 * Licensed under
	 *   MIT License http://www.opensource.org/licenses/mit-license
	 *
	 */
	
	(function (root, factory) {
	  'use strict';
	  // https://github.com/umdjs/umd/blob/master/returnExports.js
	  if (typeof module === 'object' && module.exports) {
	    // Node
	    module.exports = factory();
	  } else if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Browser globals (root is window)
	    root.SecondLevelDomains = factory(root);
	  }
	}(this, function (root) {
	  'use strict';
	
	  // save current SecondLevelDomains variable, if any
	  var _SecondLevelDomains = root && root.SecondLevelDomains;
	
	  var SLD = {
	    // list of known Second Level Domains
	    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
	    // ----
	    // publicsuffix.org is more current and actually used by a couple of browsers internally.
	    // downside is it also contains domains like "dyndns.org" - which is fine for the security
	    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
	    // ----
	    list: {
	      'ac':' com gov mil net org ',
	      'ae':' ac co gov mil name net org pro sch ',
	      'af':' com edu gov net org ',
	      'al':' com edu gov mil net org ',
	      'ao':' co ed gv it og pb ',
	      'ar':' com edu gob gov int mil net org tur ',
	      'at':' ac co gv or ',
	      'au':' asn com csiro edu gov id net org ',
	      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
	      'bb':' biz co com edu gov info net org store tv ',
	      'bh':' biz cc com edu gov info net org ',
	      'bn':' com edu gov net org ',
	      'bo':' com edu gob gov int mil net org tv ',
	      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
	      'bs':' com edu gov net org ',
	      'bz':' du et om ov rg ',
	      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
	      'ck':' biz co edu gen gov info net org ',
	      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
	      'co':' com edu gov mil net nom org ',
	      'cr':' ac c co ed fi go or sa ',
	      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
	      'do':' art com edu gob gov mil net org sld web ',
	      'dz':' art asso com edu gov net org pol ',
	      'ec':' com edu fin gov info med mil net org pro ',
	      'eg':' com edu eun gov mil name net org sci ',
	      'er':' com edu gov ind mil net org rochest w ',
	      'es':' com edu gob nom org ',
	      'et':' biz com edu gov info name net org ',
	      'fj':' ac biz com info mil name net org pro ',
	      'fk':' ac co gov net nom org ',
	      'fr':' asso com f gouv nom prd presse tm ',
	      'gg':' co net org ',
	      'gh':' com edu gov mil org ',
	      'gn':' ac com gov net org ',
	      'gr':' com edu gov mil net org ',
	      'gt':' com edu gob ind mil net org ',
	      'gu':' com edu gov net org ',
	      'hk':' com edu gov idv net org ',
	      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
	      'id':' ac co go mil net or sch web ',
	      'il':' ac co gov idf k12 muni net org ',
	      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
	      'iq':' com edu gov i mil net org ',
	      'ir':' ac co dnssec gov i id net org sch ',
	      'it':' edu gov ',
	      'je':' co net org ',
	      'jo':' com edu gov mil name net org sch ',
	      'jp':' ac ad co ed go gr lg ne or ',
	      'ke':' ac co go info me mobi ne or sc ',
	      'kh':' com edu gov mil net org per ',
	      'ki':' biz com de edu gov info mob net org tel ',
	      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
	      'kn':' edu gov net org ',
	      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
	      'kw':' com edu gov net org ',
	      'ky':' com edu gov net org ',
	      'kz':' com edu gov mil net org ',
	      'lb':' com edu gov net org ',
	      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
	      'lr':' com edu gov net org ',
	      'lv':' asn com conf edu gov id mil net org ',
	      'ly':' com edu gov id med net org plc sch ',
	      'ma':' ac co gov m net org press ',
	      'mc':' asso tm ',
	      'me':' ac co edu gov its net org priv ',
	      'mg':' com edu gov mil nom org prd tm ',
	      'mk':' com edu gov inf name net org pro ',
	      'ml':' com edu gov net org presse ',
	      'mn':' edu gov org ',
	      'mo':' com edu gov net org ',
	      'mt':' com edu gov net org ',
	      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
	      'mw':' ac co com coop edu gov int museum net org ',
	      'mx':' com edu gob net org ',
	      'my':' com edu gov mil name net org sch ',
	      'nf':' arts com firm info net other per rec store web ',
	      'ng':' biz com edu gov mil mobi name net org sch ',
	      'ni':' ac co com edu gob mil net nom org ',
	      'np':' com edu gov mil net org ',
	      'nr':' biz com edu gov info net org ',
	      'om':' ac biz co com edu gov med mil museum net org pro sch ',
	      'pe':' com edu gob mil net nom org sld ',
	      'ph':' com edu gov i mil net ngo org ',
	      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
	      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
	      'pr':' ac biz com edu est gov info isla name net org pro prof ',
	      'ps':' com edu gov net org plo sec ',
	      'pw':' belau co ed go ne or ',
	      'ro':' arts com firm info nom nt org rec store tm www ',
	      'rs':' ac co edu gov in org ',
	      'sb':' com edu gov net org ',
	      'sc':' com edu gov net org ',
	      'sh':' co com edu gov net nom org ',
	      'sl':' com edu gov net org ',
	      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
	      'sv':' com edu gob org red ',
	      'sz':' ac co org ',
	      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
	      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
	      'tw':' club com ebiz edu game gov idv mil net org ',
	      'mu':' ac co com gov net or org ',
	      'mz':' ac co edu gov org ',
	      'na':' co com ',
	      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
	      'pa':' abo ac com edu gob ing med net nom org sld ',
	      'pt':' com edu gov int net nome org publ ',
	      'py':' com edu gov mil net org ',
	      'qa':' com edu gov mil net org ',
	      're':' asso com nom ',
	      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
	      'rw':' ac co com edu gouv gov int mil net ',
	      'sa':' com edu gov med net org pub sch ',
	      'sd':' com edu gov info med net org tv ',
	      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
	      'sg':' com edu gov idn net org per ',
	      'sn':' art com edu gouv org perso univ ',
	      'sy':' com edu gov mil net news org ',
	      'th':' ac co go in mi net or ',
	      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
	      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
	      'tz':' ac co go ne or ',
	      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
	      'ug':' ac co go ne or org sc ',
	      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
	      'us':' dni fed isa kids nsn ',
	      'uy':' com edu gub mil net org ',
	      've':' co com edu gob info mil net org web ',
	      'vi':' co com k12 net org ',
	      'vn':' ac biz com edu gov health info int name net org pro ',
	      'ye':' co com gov ltd me net org plc ',
	      'yu':' ac co edu gov org ',
	      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
	      'zm':' ac co com edu gov net org sch '
	    },
	    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
	    // in both performance and memory footprint. No initialization required.
	    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
	    // Following methods use lastIndexOf() rather than array.split() in order
	    // to avoid any memory allocations.
	    has: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
	    },
	    is: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return false;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset >= 0) {
	        return false;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return false;
	      }
	      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
	    },
	    get: function(domain) {
	      var tldOffset = domain.lastIndexOf('.');
	      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
	        return null;
	      }
	      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
	      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
	        return null;
	      }
	      var sldList = SLD.list[domain.slice(tldOffset+1)];
	      if (!sldList) {
	        return null;
	      }
	      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
	        return null;
	      }
	      return domain.slice(sldOffset+1);
	    },
	    noConflict: function(){
	      if (root.SecondLevelDomains === this) {
	        root.SecondLevelDomains = _SecondLevelDomains;
	      }
	      return this;
	    }
	  };
	
	  return SLD;
	}));


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.4.0 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw new RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) {
				// in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else {
				// in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else {
			// in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)(module), (function() { return this; }())))

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(132);

/***/ },
/* 641 */,
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(329);

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(50);

/***/ },
/* 644 */,
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(80);

/***/ },
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var ApiRoutes = __webpack_require__(15);
	var fetch = __webpack_require__(10)['default'];
	var AlarmCallbackHistoryStore = (function () {
	    function AlarmCallbackHistoryStore() {}
	    AlarmCallbackHistoryStore.prototype.listForAlert = function (streamId, alertId) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Fetching alarm callback history failed with status: " + error, "Could not retrieve alarm callback history.");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.AlarmCallbackHistoryApiController.list(streamId, alertId).url);
	        return fetch('GET', url).then(function (response) {
	            return response.histories;
	        }, failCallback);
	    };
	    return AlarmCallbackHistoryStore;
	})();
	var alarmCallbackHistoryStore = new AlarmCallbackHistoryStore();
	module.exports = alarmCallbackHistoryStore;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path='../../../node_modules/immutable/dist/immutable.d.ts'/>
	/// <reference path='../../routing/ApiRoutes.d.ts' />
	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var Immutable = __webpack_require__(22);
	var UserNotification = __webpack_require__(7);
	var ApiRoutes = __webpack_require__(15);
	var URLUtils = __webpack_require__(9);
	var Builder = __webpack_require__(10).Builder;
	var fetch = __webpack_require__(10)['default'];
	var PermissionsMixin = __webpack_require__(24);
	var StoreProvider = __webpack_require__(3);
	var CurrentUserStore = StoreProvider.getStore('CurrentUser');
	var DashboardsStore = (function () {
	    function DashboardsStore() {
	        this._onWritableDashboardsChanged = [];
	        this._onDashboardsChanged = [];
	        this._dashboards = Immutable.List();
	        this._writableDashboards = Immutable.Map();
	    }
	    Object.defineProperty(DashboardsStore.prototype, "dashboards", {
	        get: function get() {
	            return this._dashboards;
	        },
	        set: function set(newDashboards) {
	            this._dashboards = newDashboards;
	            this._emitDashboardsChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DashboardsStore.prototype._emitDashboardsChange = function () {
	        var _this = this;
	        this._onDashboardsChanged.forEach(function (callback) {
	            return callback(_this.dashboards);
	        });
	    };
	    Object.defineProperty(DashboardsStore.prototype, "writableDashboards", {
	        get: function get() {
	            return this._writableDashboards;
	        },
	        set: function set(newDashboards) {
	            this._writableDashboards = newDashboards;
	            this._emitWritableDashboardsChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DashboardsStore.prototype._emitWritableDashboardsChange = function () {
	        var _this = this;
	        this._onWritableDashboardsChanged.forEach(function (callback) {
	            return callback(_this.writableDashboards);
	        });
	    };
	    DashboardsStore.prototype.addOnWritableDashboardsChangedCallback = function (dashboardChangeCallback) {
	        this._onWritableDashboardsChanged.push(dashboardChangeCallback);
	    };
	    DashboardsStore.prototype.addOnDashboardsChangedCallback = function (dashboardChangeCallback) {
	        this._onDashboardsChanged.push(dashboardChangeCallback);
	    };
	    DashboardsStore.prototype.updateWritableDashboards = function () {
	        var _this = this;
	        var permissions = CurrentUserStore.get().permissions;
	        var promise = this.updateDashboards();
	        promise.then(function () {
	            var dashboards = {};
	            _this.getWritableDashboardList(permissions).forEach(function (dashboard) {
	                dashboards[dashboard.id] = dashboard;
	            });
	            _this.writableDashboards = Immutable.Map(dashboards);
	        });
	    };
	    DashboardsStore.prototype.updateDashboards = function () {
	        var _this = this;
	        var promise = this.listDashboards();
	        promise.then(function (dashboardList) {
	            _this.dashboards = dashboardList;
	        });
	        return promise;
	    };
	    DashboardsStore.prototype.listDashboards = function () {
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.index().url);
	        var promise = fetch('GET', url).then(function (response) {
	            var dashboardList = Immutable.List(response.dashboards);
	            return dashboardList;
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Loading dashboard list failed with status: " + error, "Could not load dashboards");
	            }
	        });
	        return promise;
	    };
	    DashboardsStore.prototype.getWritableDashboardList = function (permissions) {
	        return this.dashboards.toArray().filter(function (dashboard) {
	            return PermissionsMixin.isPermitted(permissions, 'dashboards:edit:' + dashboard.id);
	        });
	    };
	    DashboardsStore.prototype.get = function (id) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.get(id).url);
	        var promise = new Builder('GET', url).authenticated().setHeader('X-Graylog-No-Session-Extension', 'true').json().build();
	        promise['catch'](function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Loading your dashboard failed with status: " + error.message, "Could not load your dashboard");
	            }
	        });
	        return promise;
	    };
	    DashboardsStore.prototype.createDashboard = function (title, description) {
	        var _this = this;
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.create().url);
	        var promise = fetch('POST', url, { title: title, description: description }).then(function (response) {
	            UserNotification.success("Dashboard successfully created");
	            _this.updateWritableDashboards();
	            return response.dashboard_id;
	        }, function (error) {
	            UserNotification.error("Creating dashboard \"" + title + "\" failed with status: " + error, "Could not create dashboard");
	        });
	        return promise;
	    };
	    DashboardsStore.prototype.saveDashboard = function (dashboard) {
	        var _this = this;
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.update(dashboard.id).url);
	        var promise = fetch('PUT', url, { title: dashboard.title, description: dashboard.description });
	        promise.then(function () {
	            UserNotification.success("Dashboard successfully updated");
	            _this.updateWritableDashboards();
	        }, function (error) {
	            UserNotification.error("Saving dashboard \"" + dashboard.title + "\" failed with status: " + error, "Could not save dashboard");
	        });
	        return promise;
	    };
	    DashboardsStore.prototype.remove = function (dashboard) {
	        var _this = this;
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController['delete'](dashboard.id).url);
	        var promise = fetch('DELETE', url);
	        promise.then(function () {
	            UserNotification.success("Dashboard successfully deleted");
	            _this.updateWritableDashboards();
	        }, function (error) {
	            UserNotification.error("Deleting dashboard \"" + dashboard.title + "\" failed with status: " + error, "Could not delete dashboard");
	        });
	        return promise;
	    };
	    DashboardsStore.prototype.updatePositions = function (dashboard, positions) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.updatePositions(dashboard.id).url);
	        var promise = fetch('PUT', url, { positions: positions })['catch'](function (error) {
	            UserNotification.error("Updating widget positions for dashboard \"" + dashboard.title + "\" failed with status: " + error.message, "Could not update dashboard");
	        });
	        return promise;
	    };
	    return DashboardsStore;
	})();
	var dashboardsStore = new DashboardsStore();
	module.exports = dashboardsStore;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path='../../../node_modules/immutable/dist/immutable.d.ts'/>
	"use strict";
	var $ = __webpack_require__(13);
	var Immutable = __webpack_require__(22);
	var Store = __webpack_require__(591);
	var fieldCharts = __webpack_require__(898);
	var generateId = fieldCharts.generateId;
	var FieldChart = fieldCharts.FieldChart;
	var EventHandlersThrottler = __webpack_require__(154);
	var UserNotification = __webpack_require__(7);
	var FieldGraphsStore = (function () {
	    function FieldGraphsStore() {
	        var _this = this;
	        this.resetStore();
	        this._eventsThrottle = new EventHandlersThrottler();
	        $(document).on('created.graylog.fieldgraph', function (event, data) {
	            _this.saveGraph(data.graphOptions['chartid'], data.graphOptions);
	            _this.combineStackedGraphs(data.graphOptions['chartid']);
	            _this.renderedGraphs.add(data.graphOptions['chartid']);
	            if (typeof _this.onFieldGraphCreated === 'function') {
	                _this.onFieldGraphCreated(data.graphOptions['chartid']);
	            }
	        });
	        $(document).on('failed.graylog.fieldgraph', function (event, data) {
	            UserNotification.error(data.errorMessage, "Could not create field graph");
	            _this.deleteGraph(data.graphId);
	        });
	        $(document).on('updated.graylog.fieldgraph', function (event, data) {
	            _this.saveGraph(data.graphOptions['chartid'], data.graphOptions);
	        });
	        $(document).on('merged.graylog.fieldgraph', function (event, data) {
	            _this.updateStackedGraphs(data.targetGraphId, data.draggedGraphId);
	        });
	        window.addEventListener('resize', function () {
	            _this._eventsThrottle.throttle(function () {
	                return _this.redrawGraphs();
	            });
	        });
	    }
	    FieldGraphsStore.prototype.resetStore = function () {
	        this.renderedGraphs = Immutable.Set();
	        this._fieldGraphs = Immutable.Map(Store.get("pinned-field-charts"));
	        this._stackedGraphs = Immutable.fromJS(Store.get("stacked-graphs") || {}, function (key, value) {
	            var isIndexed = Immutable.Iterable.isIndexed(value);
	            return isIndexed ? value.toSet() : value.toMap();
	        });
	        FieldChart.reload();
	    };
	    Object.defineProperty(FieldGraphsStore.prototype, "fieldGraphs", {
	        get: function get() {
	            return this._fieldGraphs;
	        },
	        set: function set(newFieldGraphs) {
	            this._fieldGraphs = newFieldGraphs;
	            Store.set("pinned-field-charts", newFieldGraphs.toJS());
	            if (typeof this.onFieldGraphsUpdated === 'function') {
	                this.onFieldGraphsUpdated(newFieldGraphs);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FieldGraphsStore.prototype, "stackedGraphs", {
	        get: function get() {
	            return this._stackedGraphs;
	        },
	        set: function set(newStackedGraphs) {
	            this._stackedGraphs = newStackedGraphs;
	            Store.set("stacked-graphs", newStackedGraphs.toJS());
	            if (typeof this.onFieldGraphsMerged === 'function') {
	                this.onFieldGraphsMerged(newStackedGraphs);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FieldGraphsStore.prototype.combineStackedGraphs = function (graphId) {
	        var _this = this;
	        this.renderedGraphs = this.renderedGraphs.add(graphId);
	        if (this.stackedGraphs.has(graphId)) {
	            var stackedGraphs = this.stackedGraphs.get(graphId);
	            stackedGraphs.forEach(function (stackedGraphId) {
	                if (_this.renderedGraphs.has(stackedGraphId)) {
	                    _this.stackGraphs(graphId, stackedGraphId);
	                }
	            });
	        } else {
	            this.stackedGraphs.forEach(function (stackedGraphs, targetGraphId) {
	                if (stackedGraphs.has(graphId) && _this.renderedGraphs.has(targetGraphId)) {
	                    _this.stackGraphs(targetGraphId, graphId);
	                }
	            });
	        }
	    };
	    FieldGraphsStore.prototype.saveGraph = function (graphId, graphOptions) {
	        this.fieldGraphs = this.fieldGraphs.set(graphId, graphOptions);
	    };
	    FieldGraphsStore.prototype.deleteGraph = function (graphId) {
	        if (this.fieldGraphs.has(graphId)) {
	            this.fieldGraphs = this.fieldGraphs['delete'](graphId);
	            if (this.stackedGraphs.has(graphId)) {
	                this.deleteStackedGraphs(graphId);
	            }
	        }
	    };
	    FieldGraphsStore.prototype.updateStackedGraphs = function (targetGraphId, sourceGraphId) {
	        var newStackedGraphs = this.stackedGraphs;
	        if (newStackedGraphs.has(targetGraphId)) {
	            // targetGraphId was a stacked graph
	            newStackedGraphs = newStackedGraphs.set(targetGraphId, newStackedGraphs.get(targetGraphId).add(sourceGraphId));
	        } else if (newStackedGraphs.has(sourceGraphId)) {
	            // draggedGraphId was a stacked graph
	            var draggedMergedGraphs = newStackedGraphs.get(sourceGraphId);
	            newStackedGraphs = newStackedGraphs.set(targetGraphId, draggedMergedGraphs.add(sourceGraphId));
	            newStackedGraphs = newStackedGraphs['delete'](sourceGraphId);
	        } else {
	            // None of the graphs were merged
	            newStackedGraphs = newStackedGraphs.set(targetGraphId, Immutable.Set().add(sourceGraphId));
	        }
	        this.stackedGraphs = newStackedGraphs;
	    };
	    FieldGraphsStore.prototype.deleteStackedGraphs = function (graphId) {
	        var _this = this;
	        var stackedGraphs = this.stackedGraphs.get(graphId);
	        stackedGraphs.forEach(function (stackedGraphId) {
	            return _this.deleteGraph(stackedGraphId);
	        });
	        this.stackedGraphs = this.stackedGraphs['delete'](graphId);
	    };
	    FieldGraphsStore.prototype.newFieldGraph = function (field, options) {
	        var graphId = generateId();
	        var givenOptions = Immutable.Map(options);
	        var defaultOptions = Immutable.Map({ chartid: graphId, field: field });
	        this.saveGraph(graphId, defaultOptions.merge(givenOptions).toJS());
	    };
	    FieldGraphsStore.prototype.renderFieldGraph = function (graphOptions, graphContainer, options) {
	        if (options === void 0) {
	            options = { 'new': true };
	        }
	        if (options['new']) {
	            FieldChart.renderNewFieldChart(graphOptions, graphContainer);
	        } else {
	            FieldChart.renderFieldChart(graphOptions, graphContainer, { newGraph: false });
	        }
	    };
	    FieldGraphsStore.prototype.updateFieldGraphData = function (graphId) {
	        var seriesName = graphId;
	        var graphOptions = this.fieldGraphs.get(graphId);
	        var effectiveGraphId;
	        // First we figure out if the graphId is part of a stacked graph
	        this.stackedGraphs.some(function (stackedGraphsIds, containerGraphId) {
	            if (stackedGraphsIds.has(graphId)) {
	                effectiveGraphId = containerGraphId;
	                return true;
	            }
	        });
	        // If it is not part of a stacked graph, use the graphId given as argument
	        if (!effectiveGraphId) {
	            effectiveGraphId = graphId;
	        }
	        FieldChart.updateFieldChartData(effectiveGraphId, graphOptions, seriesName);
	    };
	    FieldGraphsStore.prototype.stackGraphs = function (targetGraphId, sourceGraphId) {
	        FieldChart.stackGraphs(targetGraphId, sourceGraphId);
	    };
	    FieldGraphsStore.prototype.getFieldGraphAsCreateWidgetRequestParams = function (graphId, widgetType) {
	        var graphOptions = this.fieldGraphs.get(graphId);
	        if (graphOptions === undefined) {
	            throw 'Invalid graph ID "' + graphId + '"';
	        }
	        var requestParams = {
	            valuetype: graphOptions['valuetype'],
	            renderer: graphOptions['renderer'],
	            interpolation: graphOptions['interpolation'],
	            interval: graphOptions['interval'],
	            field: graphOptions['field'],
	            query: graphOptions['query'],
	            rangeType: graphOptions['rangetype']
	        };
	        switch (graphOptions['rangetype']) {
	            case "relative":
	                requestParams['relative'] = graphOptions['range']['relative'];
	                break;
	            case "absolute":
	                requestParams['from'] = graphOptions['range']['from'];
	                requestParams['to'] = graphOptions['range']['to'];
	                break;
	            case "keyword":
	                requestParams['keyword'] = graphOptions['range']['keyword'];
	                break;
	        }
	        return requestParams;
	    };
	    FieldGraphsStore.prototype.getSeriesInformation = function (graphOptions) {
	        var series = {
	            query: graphOptions['query'],
	            field: graphOptions['field'],
	            statistical_function: graphOptions['valuetype']
	        };
	        return series;
	    };
	    FieldGraphsStore.prototype.getStackedGraphAsCreateWidgetRequestParams = function (graphId, widgetType) {
	        var _this = this;
	        var graphOptions = this.fieldGraphs.get(graphId);
	        if (graphOptions === undefined) {
	            throw 'Invalid graph ID "' + graphId + '"';
	        }
	        var requestParams = {
	            renderer: graphOptions['renderer'],
	            interpolation: graphOptions['interpolation'],
	            interval: graphOptions['interval'],
	            rangeType: graphOptions['rangetype']
	        };
	        var series = [this.getSeriesInformation(graphOptions)];
	        var stackedGraphs = this.stackedGraphs.get(graphId);
	        stackedGraphs.forEach(function (stackedGraphId) {
	            var stackedGraph = _this.fieldGraphs.get(stackedGraphId);
	            series.push(_this.getSeriesInformation(stackedGraph));
	        }, this);
	        requestParams['series'] = series;
	        switch (graphOptions['rangetype']) {
	            case "relative":
	                requestParams['relative'] = graphOptions['range']['relative'];
	                break;
	            case "absolute":
	                requestParams['from'] = graphOptions['range']['from'];
	                requestParams['to'] = graphOptions['range']['to'];
	                break;
	            case "keyword":
	                requestParams['keyword'] = graphOptions['range']['keyword'];
	                break;
	        }
	        return requestParams;
	    };
	    FieldGraphsStore.prototype.redrawGraphs = function () {
	        this.fieldGraphs.forEach(function (fieldGraph, id) {
	            return FieldChart.redraw(id);
	        });
	    };
	    FieldGraphsStore.FUNCTIONS = Immutable.OrderedMap({
	        count: 'Total',
	        mean: 'Mean',
	        min: 'Minimum',
	        max: 'Maximum',
	        total: 'Sum',
	        cardinality: 'Cardinality'
	    });
	    return FieldGraphsStore;
	})();
	var fieldGraphsStore = new FieldGraphsStore();
	module.exports = fieldGraphsStore;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var fetch = __webpack_require__(10)['default'];
	var StoreProvider = __webpack_require__(3);
	var SearchStore = StoreProvider.getStore('Search');
	var UserNotification = __webpack_require__(7);
	var ApiRoutes = __webpack_require__(15);
	var URLUtils = __webpack_require__(9);
	var FieldQuickValuesStore = {
	    getQuickValues: function getQuickValues(field) {
	        var originalSearchURLParams = SearchStore.getOriginalSearchURLParams();
	        var streamId = SearchStore.searchInStream ? SearchStore.searchInStream.id : null;
	        var rangeType = originalSearchURLParams.get('rangetype');
	        var timerange = {};
	        switch (rangeType) {
	            case 'relative':
	                timerange['range'] = originalSearchURLParams.get('relative');
	                break;
	            case 'absolute':
	                timerange['from'] = originalSearchURLParams.get('from');
	                timerange['to'] = originalSearchURLParams.get('to');
	                break;
	            case 'keyword':
	                timerange['keyword'] = originalSearchURLParams.get('keyword');
	                break;
	        }
	        var url = ApiRoutes.UniversalSearchApiController.fieldTerms(rangeType, originalSearchURLParams.get('q') || '*', field, timerange, streamId).url;
	        url = URLUtils.qualifyUrl(url);
	        var promise = fetch('GET', url);
	        promise['catch'](function (error) {
	            UserNotification.error('Loading quick values failed with status: ' + error, 'Could not load quick values');
	        });
	        return promise;
	    }
	};
	module.exports = FieldQuickValuesStore;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	/// <reference path='../../../node_modules/immutable/dist/immutable.d.ts'/>
	/// <reference path="../../../declarations/node/node.d.ts" />
	"use strict";
	var fetch = __webpack_require__(10)['default'];
	var Immutable = __webpack_require__(22);
	var ApiRoutes = __webpack_require__(15);
	var URLUtils = __webpack_require__(9);
	var UserNotification = __webpack_require__(7);
	var StoreProvider = __webpack_require__(3);
	var SearchStore = StoreProvider.getStore('Search');
	var FieldStatisticsStore = {
	    FUNCTIONS: Immutable.OrderedMap({
	        count: 'Total',
	        mean: 'Mean',
	        min: 'Minimum',
	        max: 'Maximum',
	        std_deviation: 'Std. deviation',
	        variance: 'Variance',
	        sum: 'Sum',
	        cardinality: 'Cardinality'
	    }),
	    getFieldStatistics: function getFieldStatistics(field) {
	        var originalSearchURLParams = SearchStore.getOriginalSearchURLParams();
	        var streamId = SearchStore.searchInStream ? SearchStore.searchInStream.id : null;
	        var rangeType = originalSearchURLParams.get('rangetype');
	        var timerange = {};
	        switch (rangeType) {
	            case 'relative':
	                timerange['range'] = originalSearchURLParams.get('relative');
	                break;
	            case 'absolute':
	                timerange['from'] = originalSearchURLParams.get('from');
	                timerange['to'] = originalSearchURLParams.get('to');
	                break;
	            case 'keyword':
	                timerange['keyword'] = originalSearchURLParams.get('keyword');
	                break;
	        }
	        var url = ApiRoutes.UniversalSearchApiController.fieldStats(rangeType, originalSearchURLParams.get('q') || '*', field, timerange, streamId).url;
	        url = URLUtils.qualifyUrl(url);
	        var promise = fetch('GET', url);
	        promise['catch'](function (error) {
	            UserNotification.error("Loading field statistics failed with status: " + error, "Could not load field statistics");
	        });
	        return promise;
	    }
	};
	module.exports = FieldStatisticsStore;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var ApiRoutes = __webpack_require__(15);
	var fetch = __webpack_require__(10)['default'];
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var FieldsStore = {
	    loadFields: function loadFields() {
	        var url = ApiRoutes.SystemApiController.fields().url;
	        var promise = fetch('GET', URLUtils.qualifyUrl(url));
	        promise = promise.then(function (data) {
	            return data.fields;
	        });
	        promise['catch'](function (errorThrown) {
	            UserNotification.error("Loading field information failed with status: " + errorThrown.additional.message, "Could not load field information");
	        });
	        return promise;
	    }
	};
	module.exports = FieldsStore;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var fetch = __webpack_require__(10)['default'];
	var GrokPatternsStore = {
	    URL: URLUtils.qualifyUrl('/system/grok'),
	    loadPatterns: function loadPatterns(callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Loading Grok patterns failed with status: " + error.message, "Could not load Grok patterns");
	        };
	        // get the current list of patterns and sort it by name
	        fetch('GET', this.URL).then(function (resp) {
	            var patterns = resp.patterns;
	            patterns.sort(function (pattern1, pattern2) {
	                return pattern1.name.toLowerCase().localeCompare(pattern2.name.toLowerCase());
	            });
	            callback(patterns);
	        }, failCallback);
	    },
	    savePattern: function savePattern(pattern, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Saving Grok pattern \"" + pattern.name + "\" failed with status: " + error.message, "Could not save Grok pattern");
	        };
	        var requestPattern = {
	            id: pattern.id,
	            pattern: pattern.pattern,
	            name: pattern.name,
	            'content_pack': pattern['content_pack']
	        };
	        var url = this.URL;
	        var method;
	        if (pattern.id === "") {
	            method = 'POST';
	        } else {
	            url += '/' + pattern.id;
	            method = 'PUT';
	        }
	        fetch(method, url, requestPattern).then(function () {
	            callback();
	            var action = pattern.id === "" ? "created" : "updated";
	            var message = "Grok pattern \"" + pattern.name + "\" successfully " + action;
	            UserNotification.success(message);
	        })['catch'](failCallback);
	    },
	    deletePattern: function deletePattern(pattern, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Deleting Grok pattern \"" + pattern.name + "\" failed with status: " + error.message, "Could not delete Grok pattern");
	        };
	        fetch('DELETE', this.URL + "/" + pattern.id).then(function () {
	            callback();
	            UserNotification.success("Grok pattern \"" + pattern.name + "\" successfully deleted");
	        })['catch'](failCallback);
	    },
	    bulkImport: function bulkImport(patterns, replaceAll) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Importing Grok pattern file failed with status: " + error.message, "Could not load Grok patterns");
	        };
	        var promise = fetch('PUT', this.URL + "?replace=" + replaceAll, { patterns: patterns });
	        promise['catch'](failCallback);
	        return promise;
	    }
	};
	module.exports = GrokPatternsStore;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var ApiRoutes = __webpack_require__(15);
	var fetch = __webpack_require__(10)['default'];
	var OutputsStore = {
	    OUTPUTS_URL: URLUtils.qualifyUrl(ApiRoutes.OutputsApiController.index().url),
	    load: function load(callback) {
	        fetch('GET', this.OUTPUTS_URL).then(callback, this._failCallback);
	    },
	    loadForStreamId: function loadForStreamId(streamId, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamOutputsApiController.index(streamId).url);
	        fetch('GET', url).then(callback, this._failCallback);
	    },
	    loadAvailableTypes: function loadAvailableTypes(callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.OutputsApiController.availableTypes().url);
	        fetch('GET', url).then(callback, this._failCallback);
	    },
	    loadAvailable: function loadAvailable(typeName, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.OutputsApiController.availableTypes().url);
	        fetch('GET', url).then(function (resp) {
	            return resp.types[typeName];
	        }, this._failCallback).then(callback);
	    },
	    remove: function remove(outputId, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.OutputsApiController['delete'](outputId).url);
	        fetch('DELETE', url).then(callback, function (error) {
	            UserNotification.error("Terminating output failed with status: " + error, "Could not terminate output");
	        });
	    },
	    save: function save(output, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Saving Output \"" + output.title + "\" failed with status: " + error, "Could not save Output");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.OutputsApiController.create().url);
	        fetch('POST', url, output).then(callback, failCallback);
	    },
	    update: function update(output, deltas, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Updating Output \"" + output.title + "\" failed with status: " + error, "Could not update Output");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.OutputsApiController.update(output.id).url);
	        fetch('PUT', url, deltas).then(callback, failCallback);
	    },
	    _failCallback: function _failCallback(error) {
	        UserNotification.error("Loading outputs failed with status: " + error, "Could not load outputs");
	    }
	};
	module.exports = OutputsStore;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/jquery/jquery.d.ts" />
	/// <reference path="../../../declarations/node/node.d.ts" />
	/// <reference path='../../../node_modules/immutable/dist/immutable.d.ts'/>
	'use strict';
	var Immutable = __webpack_require__(22);
	var Routes = __webpack_require__(11);
	var Qs = __webpack_require__(126);
	var URLUtils = __webpack_require__(9);
	var moment = __webpack_require__(23);
	var history = __webpack_require__(206);
	var SearchStore = (function () {
	    function SearchStore() {
	        var _this = this;
	        this.load(true);
	        window.addEventListener('resize', function () {
	            return _this.width = window.innerWidth;
	        });
	    }
	    SearchStore.prototype.load = function (firstLoad) {
	        var parsedSearch = Immutable.Map(URLUtils.getParsedSearch(window.location));
	        this.originalSearch = SearchStore._initializeOriginalSearch(parsedSearch);
	        if (firstLoad) {
	            this.query = this.originalSearch.get('query');
	            this.rangeType = this.originalSearch.get('rangeType');
	            this.rangeParams = this.originalSearch.get('rangeParams');
	            this.page = this.originalSearch.get('page');
	            this.resolution = this.originalSearch.get('resolution');
	            this.highlightMessage = this.originalSearch.get('highlightMessage');
	        } else {
	            this._query = this.originalSearch.get('query');
	            this._rangeType = this.originalSearch.get('rangeType');
	            this._rangeParams = this.originalSearch.get('rangeParams');
	            this._page = this.originalSearch.get('page');
	            this._resolution = this.originalSearch.get('resolution');
	            this._highlightMessage = this.originalSearch.get('highlightMessage');
	        }
	        this.savedSearch = this.originalSearch.get('saved');
	        this.sortField = this.originalSearch.get('sortField');
	        this.sortOrder = this.originalSearch.get('sortOrder');
	        this.width = window.innerWidth;
	    };
	    SearchStore.prototype.unload = function () {
	        var _this = this;
	        window.removeEventListener('resize', function () {
	            return _this.width = window.innerWidth;
	        });
	    };
	    SearchStore.prototype.initializeFieldsFromHash = function () {
	        var parsedSearch = Immutable.Map(URLUtils.getParsedSearch(window.location));
	        var parsedHash = Immutable.Map(URLUtils.getParsedHash(window.location));
	        var fieldsFromHash = parsedHash.get('fields');
	        var fieldsFromQuery = parsedSearch.get('fields');
	        if (fieldsFromHash === undefined) {
	            // no hash value, fall back to query if present
	            if (fieldsFromQuery === undefined) {
	                // neither hash nor query set, fall back to defaults
	                this.fields = Immutable.Set(['message', 'source']);
	            } else {
	                this.fields = Immutable.Set(fieldsFromQuery.split(','));
	            }
	        } else {
	            // hash value, if present, always wins
	            this.fields = Immutable.Set(fieldsFromHash.split(','));
	        }
	    };
	    Object.defineProperty(SearchStore.prototype, "query", {
	        get: function get() {
	            return this._query;
	        },
	        set: function set(newQuery) {
	            this._query = newQuery;
	            if (this.onParamsChanged !== undefined) {
	                this.onParamsChanged(this.getParams());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchStore.prototype, "page", {
	        get: function get() {
	            return this._page;
	        },
	        set: function set(newPage) {
	            if (this._page === undefined) {
	                this._page = newPage;
	            } else {
	                this._reloadSearchWithNewParam('page', newPage);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchStore.prototype, "rangeType", {
	        get: function get() {
	            return this._rangeType;
	        },
	        set: function set(newRangeType) {
	            this._rangeType = newRangeType;
	            this.rangeParams = this.originalSearch.get('rangeType') === newRangeType ? this.originalSearch.get('rangeParams') : Immutable.Map();
	            if (this.onParamsChanged !== undefined) {
	                this.onParamsChanged(this.getParams());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchStore.prototype, "rangeParams", {
	        get: function get() {
	            return this._rangeParams;
	        },
	        set: function set(value) {
	            this._rangeParams = value;
	            if (this.onParamsChanged !== undefined) {
	                this.onParamsChanged(this.getParams());
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchStore.prototype, "resolution", {
	        get: function get() {
	            return this._resolution;
	        },
	        set: function set(newResolution) {
	            if (this._resolution === undefined) {
	                this._resolution = newResolution;
	            } else {
	                this._reloadSearchWithNewParam('interval', newResolution);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchStore.prototype, "fields", {
	        get: function get() {
	            return this._fields;
	        },
	        set: function set(newFields) {
	            // TODO: Add parameters once we know how to handle them
	            //URLUtils.replaceHashParam('fields', newFields.join(','));
	            this._fields = newFields;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchStore.prototype, "highlightMessage", {
	        get: function get() {
	            return this._highlightMessage;
	        },
	        set: function set(id) {
	            this._highlightMessage = id;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SearchStore.prototype.sort = function (sortField, sortOrder) {
	        this._reloadSearchWithNewParams(Immutable.Map({ sortField: sortField, sortOrder: sortOrder }));
	    };
	    SearchStore._initializeOriginalSearch = function (parsedSearch) {
	        var originalSearch = Immutable.Map();
	        originalSearch = originalSearch.set('query', parsedSearch.get('q', ''));
	        originalSearch = originalSearch.set('resolution', parsedSearch.get('interval'));
	        originalSearch = originalSearch.set('page', Math.max(parsedSearch.get('page', 1), 1));
	        originalSearch = originalSearch.set('rangeType', parsedSearch.get('rangetype', 'relative'));
	        originalSearch = originalSearch.set('sortField', parsedSearch.get('sortField', 'timestamp'));
	        originalSearch = originalSearch.set('sortOrder', parsedSearch.get('sortOrder', 'desc'));
	        originalSearch = originalSearch.set('highlightMessage', parsedSearch.get('highlightMessage', ''));
	        if (parsedSearch.get('saved') !== undefined) {
	            originalSearch = originalSearch.set('saved', parsedSearch.get('saved'));
	        }
	        var rangeParams;
	        switch (originalSearch.get('rangeType')) {
	            case 'relative':
	                rangeParams = Immutable.Map({ relative: Number(parsedSearch.get('relative', 5 * 60)) });
	                break;
	            case 'absolute':
	                rangeParams = Immutable.Map({
	                    from: parsedSearch.get('from', null),
	                    to: parsedSearch.get('to', null)
	                });
	                break;
	            case 'keyword':
	                rangeParams = Immutable.Map({ keyword: parsedSearch.get('keyword', '') });
	                break;
	            default:
	                throw 'Unsupported range type ' + originalSearch.get('rangeType');
	        }
	        return originalSearch.set('rangeParams', rangeParams);
	    };
	    SearchStore.prototype.addSearchTerm = function (field, value, operator) {
	        var term = field + ":" + SearchStore.escape(value);
	        var effectiveOperator = operator || SearchStore.AND_OPERATOR;
	        this.addQueryTerm(term, effectiveOperator);
	    };
	    SearchStore.prototype.changeTimeRange = function (newRangeType, newRangeParams) {
	        this.rangeType = newRangeType;
	        this.rangeParams = Immutable.fromJS(newRangeParams);
	    };
	    SearchStore.prototype._submitSearch = function (event) {
	        if (this.onSubmitSearch !== undefined) {
	            this.onSubmitSearch();
	        }
	    };
	    SearchStore.prototype.savedSearchDeleted = function (savedSearchId) {
	        if (savedSearchId === this.savedSearch) {
	            this._submitSearch(null);
	        }
	    };
	    SearchStore.isPhrase = function (searchTerm) {
	        return String(searchTerm).indexOf(" ") !== -1;
	    };
	    SearchStore.escape = function (searchTerm) {
	        var escapedTerm = String(searchTerm);
	        // Replace newlines.
	        escapedTerm = escapedTerm.replace(/\r\n/g, " ");
	        escapedTerm = escapedTerm.replace(/\n/g, " ");
	        escapedTerm = escapedTerm.replace(/<br>/g, " ");
	        if (this.isPhrase(escapedTerm)) {
	            escapedTerm = String(escapedTerm).replace(/\"/g, '\\"');
	            escapedTerm = '"' + escapedTerm + '"';
	        } else {
	            // Escape all lucene special characters from the source: && || : \ / + - ! ( ) { } [ ] ^ " ~ * ?
	            escapedTerm = String(escapedTerm).replace(/(&&|\|\||[\:\\\/\+\-\!\(\)\{\}\[\]\^\"\~\*\?])/g, "\\$&");
	        }
	        return escapedTerm;
	    };
	    SearchStore.prototype.queryContainsTerm = function (termInQuestion) {
	        return this.query.indexOf(termInQuestion) != -1;
	    };
	    SearchStore.prototype.addQueryTerm = function (term, operator) {
	        if (this.queryContainsTerm(term)) {
	            return;
	        }
	        var newQuery = "";
	        if (typeof operator !== 'undefined' && this.query !== "" && this.query !== "*") {
	            newQuery = this.query + " " + operator + " ";
	        }
	        newQuery += term;
	        this.query = newQuery;
	        if (this.onAddQueryTerm !== undefined) {
	            this.onAddQueryTerm();
	        }
	    };
	    SearchStore.prototype.getParams = function () {
	        return {
	            query: this.query,
	            rangeType: this.rangeType,
	            rangeParams: this.rangeParams
	        };
	    };
	    // Get initial search params, with names used in AJAX requests
	    SearchStore.prototype.getOriginalSearchParams = function () {
	        var originalParams = Immutable.Map();
	        originalParams = originalParams.set('range_type', this.originalSearch.get('rangeType'));
	        originalParams = originalParams.merge(this.originalSearch.get('rangeParams'));
	        originalParams = originalParams.set('query', this.originalSearch.get('query'));
	        originalParams = originalParams.set('interval', this.originalSearch.get('resolution'));
	        if (this.searchInStream) {
	            originalParams = originalParams.set('streamId', this.searchInStream.id);
	        }
	        return originalParams;
	    };
	    // Get initial search params with the current selected fields
	    SearchStore.prototype.getOriginalSearchParamsWithFields = function () {
	        var originalParams = this.getOriginalSearchParams();
	        originalParams = originalParams.set('fields', this.fields.join(','));
	        return originalParams;
	    };
	    // Get initial search params, with the names used in a search URL request
	    SearchStore.prototype.getOriginalSearchURLParams = function () {
	        var originalURLParams = Immutable.Map();
	        originalURLParams = originalURLParams.set('rangetype', this.originalSearch.get('rangeType'));
	        originalURLParams = originalURLParams.merge(this.originalSearch.get('rangeParams'));
	        originalURLParams = originalURLParams.set('q', this.originalSearch.get('query'));
	        originalURLParams = originalURLParams.set('interval', this.originalSearch.get('resolution'));
	        originalURLParams = originalURLParams.set('page', this.originalSearch.get('page'));
	        originalURLParams = originalURLParams.set('fields', this.fields ? this.fields.join(',') : '');
	        originalURLParams = originalURLParams.set('sortField', this.originalSearch.get('sortField'));
	        originalURLParams = originalURLParams.set('sortOrder', this.originalSearch.get('sortOrder'));
	        if (this.originalSearch.has('saved')) {
	            originalURLParams = originalURLParams.set('saved', this.originalSearch.get('saved'));
	        }
	        return originalURLParams;
	    };
	    SearchStore.prototype.searchBaseLocation = function (action) {
	        var location;
	        if (this.searchInStream) {
	            location = Routes.stream_search(this.searchInStream.id);
	        } else {
	            location = Routes.SEARCH;
	        }
	        return location;
	    };
	    SearchStore.prototype._reloadSearchWithNewParam = function (param, value) {
	        var searchURLParams = this.getOriginalSearchURLParams();
	        searchURLParams = searchURLParams.set("width", this.width);
	        searchURLParams = searchURLParams.set(param, value);
	        this.executeSearch(this.searchBaseLocation("index") + "?" + Qs.stringify(searchURLParams.toJS()));
	    };
	    SearchStore.prototype._reloadSearchWithNewParams = function (newParams) {
	        var searchURLParams = this.getOriginalSearchURLParams();
	        searchURLParams = searchURLParams.set("width", this.width);
	        searchURLParams = searchURLParams.merge(newParams);
	        this.executeSearch(this.searchBaseLocation("index") + "?" + Qs.stringify(searchURLParams.toJS()));
	    };
	    SearchStore.prototype.executeSearch = function (url) {
	        history.pushState(null, url);
	    };
	    SearchStore.prototype.searchSurroundingMessages = function (messageId, fromTime, toTime, filter) {
	        var originalParams = this.getOriginalSearchParamsWithFields().toJS();
	        var query = Object.keys(filter).filter(function (key) {
	            return filter[key];
	        }).map(function (key) {
	            return key + ":\"" + filter[key] + "\"";
	        }).join(' AND ');
	        var params = {
	            rangetype: 'absolute',
	            from: fromTime,
	            to: toTime,
	            q: query,
	            highlightMessage: messageId,
	            fields: originalParams.fields
	        };
	        return this.searchBaseLocation('index') + '?' + Qs.stringify(params);
	    };
	    SearchStore.NOT_OPERATOR = "NOT";
	    SearchStore.OR_OPERATOR = "OR";
	    SearchStore.AND_OPERATOR = "AND";
	    return SearchStore;
	})();
	var searchStore = new SearchStore();
	module.exports = searchStore;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var $ = __webpack_require__(13);
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var StringUtils = __webpack_require__(46);
	var fetch = __webpack_require__(10)['default'];
	var processSourcesData = function processSourcesData(sources) {
	    var total = 0;
	    var sourcesArray = [];
	    $.each(sources, function (name, count) {
	        total += count;
	        sourcesArray.push({ name: StringUtils.escapeHTML(name), message_count: count });
	    });
	    sourcesArray.forEach(function (d) {
	        d.percentage = d.message_count / total * 100;
	    });
	    return sourcesArray;
	};
	var SourcesStore = {
	    SOURCES_URL: '/sources',
	    loadSources: function loadSources(range, callback) {
	        var url = URLUtils.qualifyUrl(this.SOURCES_URL);
	        if (typeof range !== 'undefined') {
	            url += "?range=" + range;
	        }
	        fetch('GET', url).then(function (response) {
	            var sources = processSourcesData(response.sources);
	            callback(sources);
	        })['catch'](function (errorThrown) {
	            UserNotification.error("Loading of sources data failed with status: " + errorThrown + ". Try reloading the page.", "Could not load sources data");
	        });
	    }
	};
	module.exports = SourcesStore;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ApiRoutes = __webpack_require__(15);
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var fetch = __webpack_require__(10)['default'];
	var StreamRulesStore = (function () {
	    function StreamRulesStore() {
	        this.callbacks = [];
	    }
	    StreamRulesStore.prototype.types = function (callback) {
	        var url = "/streams/null/rules/types";
	        var promise = fetch('GET', URLUtils.qualifyUrl(url));
	        return promise;
	    };
	    StreamRulesStore.prototype.list = function (streamId, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Fetching Stream Rules failed with status: " + error, "Could not retrieve Stream Rules");
	        };
	        fetch('GET', URLUtils.qualifyUrl(ApiRoutes.StreamRulesApiController.list(streamId).url)).then(callback, failCallback);
	    };
	    StreamRulesStore.prototype.update = function (streamId, streamRuleId, data, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Updating Stream Rule failed with status: " + error, "Could not update Stream Rule");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamRulesApiController.update(streamId, streamRuleId).url);
	        var request = { field: data.field, type: data.type, value: data.value, inverted: data.inverted, description: data.description };
	        fetch('PUT', url, request).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamRulesStore.prototype.remove = function (streamId, streamRuleId, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Deleting Stream Rule failed with status: " + error, "Could not delete Stream Rule");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamRulesApiController['delete'](streamId, streamRuleId).url);
	        fetch('DELETE', url).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamRulesStore.prototype.create = function (streamId, data, callback) {
	        var failCallback = function failCallback(error) {
	            UserNotification.error("Creating Stream Rule failed with status: " + error, "Could not create Stream Rule");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamRulesApiController.create(streamId).url);
	        fetch('POST', url, data).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamRulesStore.prototype.onChange = function (callback) {
	        this.callbacks.push(callback);
	    };
	    StreamRulesStore.prototype._emitChange = function () {
	        this.callbacks.forEach(function (callback) {
	            return callback();
	        });
	    };
	    return StreamRulesStore;
	})();
	var streamRulesStore = new StreamRulesStore();
	module.exports = streamRulesStore;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var ApiRoutes = __webpack_require__(15);
	var fetch = __webpack_require__(10)['default'];
	var StreamsStore = (function () {
	    function StreamsStore() {
	        this.callbacks = [];
	    }
	    StreamsStore.prototype.listStreams = function () {
	        var url = "/streams";
	        var promise = fetch('GET', URLUtils.qualifyUrl(url)).then(function (result) {
	            return result.streams;
	        })['catch'](function (errorThrown) {
	            UserNotification.error("Loading streams failed with status: " + errorThrown, "Could not load streams");
	        });
	        return promise;
	    };
	    StreamsStore.prototype.load = function (callback) {
	        this.listStreams().then(function (streams) {
	            callback(streams);
	        });
	    };
	    StreamsStore.prototype.get = function (streamId, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Loading Stream failed with status: " + errorThrown, "Could not retrieve Stream");
	        };
	        var url = ApiRoutes.StreamsApiController.get(streamId).url;
	        fetch('GET', URLUtils.qualifyUrl(url)).then(callback, failCallback);
	    };
	    StreamsStore.prototype.remove = function (streamId, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Removing Stream failed with status: " + errorThrown, "Could not remove Stream");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController['delete'](streamId).url);
	        fetch('DELETE', url).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.pause = function (streamId, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Pausing Stream failed with status: " + errorThrown, "Could not pause Stream");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController.pause(streamId).url);
	        return fetch('POST', url).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.resume = function (streamId, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Resuming Stream failed with status: " + errorThrown, "Could not resume Stream");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController.resume(streamId).url);
	        return fetch('POST', url).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.save = function (stream, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Saving Stream failed with status: " + errorThrown, "Could not save Stream");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController.create().url);
	        fetch('POST', url, stream).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.update = function (streamId, data, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Updating Stream failed with status: " + errorThrown, "Could not update Stream");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController.update(streamId).url);
	        fetch('PUT', url, data).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.cloneStream = function (streamId, data, callback) {
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Cloning Stream failed with status: " + errorThrown, "Could not clone Stream");
	        };
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController.cloneStream(streamId).url);
	        fetch('POST', url, data).then(callback, failCallback).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.removeOutput = function (streamId, outputId, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamOutputsApiController['delete'](streamId, outputId).url);
	        fetch('DELETE', url).then(callback, function (errorThrown) {
	            UserNotification.error("Removing output from stream failed with status: " + errorThrown, "Could not remove output from stream");
	        }).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.addOutput = function (streamId, outputId, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamOutputsApiController.add(streamId, outputId).url);
	        fetch('POST', url, { outputs: [outputId] }).then(callback, function (errorThrown) {
	            UserNotification.error("Adding output to stream failed with status: " + errorThrown, "Could not add output to stream");
	        }).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.testMatch = function (streamId, message, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamsApiController.testMatch(streamId).url);
	        fetch('POST', url, message).then(callback, function (error) {
	            UserNotification.error("Testing stream rules of stream failed with status: " + error.message, "Could not test stream rules of stream");
	        });
	    };
	    StreamsStore.prototype.addReceiver = function (streamId, type, entity, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamAlertsApiController.addReceiver(streamId, type, entity).url);
	        fetch('POST', url).then(callback, function (error) {
	            UserNotification.error("Adding stream alert received failed with error: " + error.message, "Could not add stream alert receiver");
	        }).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.deleteReceiver = function (streamId, type, entity, callback) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamAlertsApiController.deleteReceiver(streamId, type, entity).url);
	        fetch('DELETE', url).then(callback, function (error) {
	            UserNotification.error("Deleting stream alert received failed with error: " + error.message, "Could not delete stream alert receiver");
	        }).then(this._emitChange.bind(this));
	    };
	    StreamsStore.prototype.sendDummyAlert = function (streamId) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.StreamAlertsApiController.sendDummyAlert(streamId).url);
	        var promise = fetch('POST', url);
	        return promise;
	    };
	    StreamsStore.prototype.onChange = function (callback) {
	        this.callbacks.push(callback);
	    };
	    StreamsStore.prototype._emitChange = function () {
	        this.callbacks.forEach(function (callback) {
	            return callback();
	        });
	    };
	    return StreamsStore;
	})();
	var streamsStore = new StreamsStore();
	module.exports = streamsStore;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var ApiRoutes = __webpack_require__(15);
	var URLUtils = __webpack_require__(9);
	var UserNotification = __webpack_require__(7);
	var fetch = __webpack_require__(10)['default'];
	var ToolsStore = {
	    testNaturalDate: function testNaturalDate(text) {
	        var url = ApiRoutes.ToolsApiController.naturalDateTest(text).url;
	        var promise = fetch('GET', URLUtils.qualifyUrl(url));
	        promise['catch'](function (errorThrown) {
	            if (errorThrown.additional.status !== 422) {
	                UserNotification.error("Loading keyword preview failed with status: " + errorThrown, "Could not load keyword preview");
	            }
	        });
	        return promise;
	    },
	    testGrok: function testGrok(pattern, namedCapturesOnly, string) {
	        var url = ApiRoutes.ToolsApiController.grokTest().url;
	        var promise = fetch('POST', URLUtils.qualifyUrl(url), { pattern: pattern, string: string, named_captures_only: namedCapturesOnly });
	        promise['catch'](function (errorThrown) {
	            UserNotification.error('Details: ' + errorThrown, 'We were not able to run the grok extraction. Please check your parameters.');
	        });
	        return promise;
	    },
	    testJSON: function testJSON(flatten, listSeparator, keySeparator, kvSeparator, replaceKeyWhitespace, keyWhitespaceReplacement, keyPrefix, string) {
	        var url = ApiRoutes.ToolsApiController.jsonTest().url;
	        var payload = {
	            flatten: flatten,
	            list_separator: listSeparator,
	            key_separator: keySeparator,
	            kv_separator: kvSeparator,
	            replace_key_whitespace: replaceKeyWhitespace,
	            key_whitespace_replacement: keyWhitespaceReplacement,
	            key_prefix: keyPrefix,
	            string: string
	        };
	        var promise = fetch('POST', URLUtils.qualifyUrl(url), payload);
	        promise['catch'](function (errorThrown) {
	            UserNotification.error('Details: ' + errorThrown, 'We were not able to run the JSON extraction. Please check your parameters.');
	        });
	        return promise;
	    },
	    testRegex: function testRegex(regex, string) {
	        var url = ApiRoutes.ToolsApiController.regexTest().url;
	        var promise = fetch('POST', URLUtils.qualifyUrl(url), { regex: regex, string: string });
	        promise['catch'](function (errorThrown) {
	            UserNotification.error('Details: ' + errorThrown, 'Could not try regular expression. Make sure that it is valid.');
	        });
	        return promise;
	    },
	    testRegexReplace: function testRegexReplace(regex, replacement, replaceAll, string) {
	        var url = ApiRoutes.ToolsApiController.regexReplaceTest().url;
	        var payload = {
	            regex: regex,
	            replacement: replacement,
	            replace_all: replaceAll,
	            string: string
	        };
	        var promise = fetch('POST', URLUtils.qualifyUrl(url), payload);
	        promise['catch'](function (errorThrown) {
	            UserNotification.error('Details: ' + errorThrown, 'Could not try regular expression. Make sure that it is valid.');
	        });
	        return promise;
	    },
	    testSplitAndIndex: function testSplitAndIndex(splitBy, index, string) {
	        var url = ApiRoutes.ToolsApiController.splitAndIndexTest().url;
	        var payload = {
	            split_by: splitBy,
	            index: index,
	            string: string
	        };
	        var promise = fetch('POST', URLUtils.qualifyUrl(url), payload);
	        promise['catch'](function (errorThrown) {
	            UserNotification.error('Details: ' + errorThrown, 'We were not able to run the split and index extraction. Please check your parameters.');
	        });
	        return promise;
	    },
	    testSubstring: function testSubstring(beginIndex, endIndex, string) {
	        var url = ApiRoutes.ToolsApiController.substringTest().url;
	        var payload = {
	            start: beginIndex,
	            end: endIndex,
	            string: string
	        };
	        var promise = fetch('POST', URLUtils.qualifyUrl(url), payload);
	        promise['catch'](function (errorThrown) {
	            UserNotification.error('Details: ' + errorThrown, 'We were not able to run the substring extraction. Please check index boundaries.');
	        });
	        return promise;
	    }
	};
	module.exports = ToolsStore;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var ApiRoutes = __webpack_require__(15);
	var URLUtils = __webpack_require__(9);
	var fetch = __webpack_require__(10)['default'];
	var UserNotification = __webpack_require__(7);
	var UsageStatsOptOutStore = {
	    pluginEnabled: function pluginEnabled() {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsageStatsApiController.pluginEnabled().url);
	        var promise = fetch('GET', url);
	        promise = promise.then(function (response) {
	            return response.enabled;
	        })['catch'](function () {
	            // When the plugin is not loaded the CORS options request will fail and we can't tell at this point
	            // what was the cause for the problem. Therefore, we return false and don't notify the user.
	            return false;
	        });
	        return promise;
	    },
	    getOptOutState: function getOptOutState() {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsageStatsApiController.setOptOutState().url);
	        var promise = fetch('GET', url);
	        promise = promise['catch'](function () {
	            // When the plugin is not loaded the CORS options request will fail and we can't tell at this point
	            // what was the cause for the problem. Therefore, we return false and don't notify the user.
	            return null;
	        });
	        return promise;
	    },
	    setOptOut: function setOptOut(notify) {
	        return this._sendOptOutState({ opt_out: true }, function () {
	            if (notify === true) {
	                UserNotification.success("No anonymous usage stats will be sent.", "Opt-out created");
	            }
	        }, function (error) {
	            UserNotification.error("Please try again", "Setting anonymous usage stats opt-out failed: " + error);
	        });
	    },
	    setOptIn: function setOptIn(notify) {
	        return this._sendOptOutState({ opt_out: false }, function () {
	            if (notify === true) {
	                UserNotification.success("Thank you for helping us making Graylog better!");
	            }
	        }, function (error) {
	            UserNotification.error("Please try again", "Opt-in failed: " + error);
	        });
	    },
	    _sendOptOutState: function _sendOptOutState(optOutState, success, error) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsageStatsApiController.setOptOutState().url);
	        var promise = fetch('POST', url, JSON.stringify(optOutState));
	        promise.then(function () {
	            return success();
	        })['catch'](function (error) {
	            return error(error);
	        });
	        return promise;
	    }
	};
	module.exports = UsageStatsOptOutStore;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var fetch = __webpack_require__(10)['default'];
	var PreferencesStore = {
	    URL: URLUtils.qualifyUrl('/users/'),
	    convertPreferenceMapToArray: function convertPreferenceMapToArray(preferencesAsMap) {
	        preferencesAsMap = preferencesAsMap || {};
	        var preferences = Object.keys(preferencesAsMap).map(function (name) {
	            return {
	                name: name,
	                value: preferencesAsMap[name]
	            };
	        });
	        preferences = preferences.sort(function (t1, t2) {
	            return t1.name.localeCompare(t2.name);
	        });
	        return preferences;
	    },
	    convertPreferenceArrayToMap: function convertPreferenceArrayToMap(preferences) {
	        var preferencesAsMap = {};
	        preferences.forEach(function (element) {
	            // TODO: Converting all preferences to booleans for now, we should change this when we support more types
	            preferencesAsMap[element.name] = element.value === true || element.value === 'true';
	        });
	        return preferencesAsMap;
	    },
	    saveUserPreferences: function saveUserPreferences(preferences, callback) {
	        var _this = this;
	        if (!this._userName) {
	            throw new Error("Need to load user preferences before you can save them");
	        }
	        var preferencesAsMap = this.convertPreferenceArrayToMap(preferences);
	        var url = this.URL + this._userName + "/preferences";
	        fetch('PUT', url, { preferences: preferencesAsMap }).then(function () {
	            UserNotification.success("User preferences successfully saved");
	            callback(preferences);
	        }, function (errorThrown) {
	            UserNotification.error("Saving of preferences for \"" + _this._userName + "\" failed with status: " + errorThrown, "Could not save user preferences");
	        });
	    },
	    loadUserPreferences: function loadUserPreferences(userName, callback) {
	        var _this = this;
	        this._userName = userName;
	        var url = this.URL + userName;
	        var successCallback = function successCallback(data) {
	            var sortedArray = _this.convertPreferenceMapToArray(data.preferences);
	            callback(sortedArray);
	        };
	        var failCallback = function failCallback(errorThrown) {
	            UserNotification.error("Loading of user preferences for \"" + userName + "\" failed with status: " + errorThrown + ". Try reloading the page", "Could not retrieve user preferences from server");
	        };
	        fetch('GET', url).then(successCallback, failCallback);
	    }
	};
	module.exports = PreferencesStore;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var ApiRoutes = __webpack_require__(15);
	var fetch = __webpack_require__(10)['default'];
	var RolesStore = {
	    loadRoles: function loadRoles() {
	        var promise = fetch('GET', URLUtils.qualifyUrl(ApiRoutes.RolesApiController.listRoles().url)).then(function (response) {
	            return response.roles;
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Loading role list failed with status: " + error, "Could not load role list");
	            }
	        });
	        return promise;
	    },
	    createRole: function createRole(role) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.RolesApiController.createRole().url);
	        var promise = fetch('POST', url, role);
	        promise.then(function (newRole) {
	            UserNotification.success("Role \"" + newRole.name + "\" was created successfully");
	        }, function (error) {
	            UserNotification.error("Creating role \"" + role.name + "\" failed with status: " + error, "Could not create role");
	        });
	        return promise;
	    },
	    updateRole: function updateRole(rolename, role) {
	        var promise = fetch('PUT', URLUtils.qualifyUrl(ApiRoutes.RolesApiController.updateRole(rolename).url), role);
	        promise.then(function (newRole) {
	            UserNotification.success("Role \"" + newRole.name + "\" was updated successfully");
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Updating role failed with status: " + error, "Could not update role");
	            }
	        });
	        return promise;
	    },
	    deleteRole: function deleteRole(rolename) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.RolesApiController.deleteRole(rolename).url);
	        var promise = fetch('DELETE', url);
	        promise.then(function () {
	            UserNotification.success("Role \"" + rolename + "\" was deleted successfully");
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Deleting role failed with status: " + error, "Could not delete role");
	            }
	        });
	        return promise;
	    },
	    getMembers: function getMembers(rolename) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.RolesApiController.loadMembers(rolename).url);
	        var promise = fetch('GET', url);
	        promise['catch'](function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Could not load role's members with status: " + error, "Could not load role members");
	            }
	        });
	        return promise;
	    }
	};
	module.exports = RolesStore;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var UserNotification = __webpack_require__(7);
	var URLUtils = __webpack_require__(9);
	var ApiRoutes = __webpack_require__(15);
	var fetch = __webpack_require__(10)['default'];
	exports.UsersStore = {
	    editUserFormUrl: function editUserFormUrl(username) {
	        return URLUtils.qualifyUrl("/system/users/edit/" + username);
	    },
	    create: function create(request) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController.create().url);
	        var promise = fetch('POST', url, request);
	        return promise;
	    },
	    loadUsers: function loadUsers() {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController.list().url);
	        var promise = fetch('GET', url).then(function (response) {
	            return response.users;
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Loading user list failed with status: " + error, "Could not load user list");
	            }
	        });
	        return promise;
	    },
	    load: function load(username) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController.load(username).url);
	        var promise = fetch('GET', url);
	        promise['catch'](function (error) {
	            UserNotification.error("Loading user failed with status: " + error, "Could not load user " + username);
	        });
	        return promise;
	    },
	    deleteUser: function deleteUser(username) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController['delete'](username).url);
	        var promise = fetch('DELETE', url);
	        promise.then(function () {
	            UserNotification.success("User \"" + username + "\" was deleted successfully");
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Delete user failed with status: " + error, "Could not delete user");
	            }
	        });
	        return promise;
	    },
	    updateRoles: function updateRoles(username, roles) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController.update(username).url);
	        var promise = fetch('PUT', url, { roles: roles });
	        return promise;
	    },
	    changePassword: function changePassword(username, request) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController.changePassword(username).url);
	        var promise = fetch('PUT', url, request);
	        return promise;
	    },
	    update: function update(username, request) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.UsersApiController.update(username).url);
	        var promise = fetch('PUT', url, request);
	        return promise;
	    }
	};
	module.exports = exports.UsersStore;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/// <reference path="../../../declarations/bluebird/bluebird.d.ts" />
	"use strict";
	var Reflux = __webpack_require__(4);
	var UserNotification = __webpack_require__(7);
	var ApiRoutes = __webpack_require__(15);
	var URLUtils = __webpack_require__(9);
	var Builder = __webpack_require__(10).Builder;
	var fetch = __webpack_require__(10)['default'];
	var ActionsProvider = __webpack_require__(6);
	var WidgetsActions = ActionsProvider.getActions('Widgets');
	var WidgetsStore = Reflux.createStore({
	    listenables: [WidgetsActions],
	    _serializeWidgetForUpdate: function _serializeWidgetForUpdate(widget) {
	        return {
	            description: widget.description,
	            type: widget.type,
	            cache_time: widget.cache_time,
	            creator_user_id: widget.creator_user_id,
	            config: widget.config
	        };
	    },
	    addWidget: function addWidget(dashboardId, widgetType, widgetTitle, widgetConfig) {
	        var widgetData = { description: widgetTitle, type: widgetType, config: widgetConfig };
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.addWidget(dashboardId).url);
	        var promise = fetch('POST', url, widgetData);
	        promise.then(function () {
	            return UserNotification.success("Widget created successfully");
	        }, function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Creating widget failed with status: " + error, "Could not create widget");
	            }
	        });
	        return promise;
	    },
	    loadWidget: function loadWidget(dashboardId, widgetId) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.widget(dashboardId, widgetId).url);
	        var promise = new Builder('GET', url).authenticated().setHeader('X-Graylog-No-Session-Extension', 'true').json().build();
	        promise['catch'](function (error) {
	            if (error.additional.status !== 404) {
	                UserNotification.error("Loading widget information failed with status: " + error, "Could not load widget information");
	            }
	        });
	        return promise;
	    },
	    updateWidget: function updateWidget(dashboardId, widget) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.updateWidget(dashboardId, widget.id).url);
	        var promise = fetch('PUT', url, this._serializeWidgetForUpdate(widget));
	        promise.then(function () {
	            return UserNotification.success("Widget updated successfully");
	        }, function (error) {
	            UserNotification.error("Updating widget \"" + widget.description + "\" failed with status: " + error.message, "Could not update widget");
	        });
	        return promise;
	    },
	    loadValue: function loadValue(dashboardId, widgetId, resolution) {
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.widgetValue(dashboardId, widgetId, resolution).url);
	        return new Builder('GET', url).authenticated().setHeader('X-Graylog-No-Session-Extension', 'true').json().build();
	    },
	    removeWidget: function removeWidget(dashboardId, widgetId) {
	        var _this = this;
	        var url = URLUtils.qualifyUrl(ApiRoutes.DashboardsApiController.removeWidget(dashboardId, widgetId).url);
	        var promise = fetch('DELETE', url).then(function () {
	            _this.trigger({ 'delete': widgetId });
	        });
	        WidgetsActions.removeWidget.promise(promise);
	        return promise;
	    }
	});
	module.exports = WidgetsStore;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var AlarmCallbacksActions = _reflux2['default'].createActions({
	  'available': { asyncResult: true },
	  'delete': { asyncResult: true },
	  'list': { asyncResult: true },
	  'save': { asyncResult: true },
	  'update': { asyncResult: true }
	});
	
	exports['default'] = AlarmCallbacksActions;
	module.exports = exports['default'];

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var AlertConditionsActions = _reflux2['default'].createActions({
	  'available': { asyncResult: true },
	  'delete': { asyncResult: true },
	  'list': { asyncResult: true },
	  'save': { asyncResult: true },
	  'update': { asyncResult: true }
	});
	
	exports['default'] = AlertConditionsActions;
	module.exports = exports['default'];

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var AlertReceiverActions = _reflux2['default'].createActions({
	  'addReceiver': { asyncResult: true },
	  'deleteReceiver': { asyncResult: true },
	  'sendDummyAlert': { asyncResult: true }
	});
	
	exports['default'] = AlertReceiverActions;
	module.exports = exports['default'];

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var AlertsActions = _reflux2['default'].createActions({
	  list: { asyncResult: true },
	  listPaginated: { asyncResult: true },
	  listAllStreams: { asyncResult: true }
	});
	
	exports['default'] = AlertsActions;
	module.exports = exports['default'];

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var AuthenticationActions = _reflux2['default'].createActions({
	  load: { asyncResult: true },
	  update: { asyncResult: true }
	});
	
	exports['default'] = AuthenticationActions;
	module.exports = exports['default'];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var ConfigurationBundlesActions = _reflux2['default'].createActions({
	  'apply': { asyncResult: true },
	  'create': { asyncResult: true },
	  'delete': { asyncResult: true },
	  'export': { asyncResult: true },
	  'list': { asyncResult: true }
	});
	
	exports['default'] = ConfigurationBundlesActions;
	module.exports = exports['default'];

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var ConfigurationActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'listSearchesClusterConfig': { asyncResult: true },
	  'listMessageProcessorsConfig': { asyncResult: true },
	  'update': { asyncResult: true },
	  'updateMessageProcessorsConfig': { asyncResult: true }
	});
	
	exports['default'] = ConfigurationActions;
	module.exports = exports['default'];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var DecoratorsActions = _reflux2['default'].createActions({
	  available: { asyncResult: true },
	  create: { asyncResult: true },
	  list: { asyncResult: true },
	  remove: { asyncResult: true },
	  update: { asyncResult: true }
	});
	
	exports['default'] = DecoratorsActions;
	module.exports = exports['default'];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var ExtractorsActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'get': { asyncResult: true },
	  'create': { asyncResult: true },
	  'save': { asyncResult: true },
	  'update': { asyncResult: true },
	  'delete': { asyncResult: true },
	  'order': { asyncResult: true },
	  'import': {}
	});
	
	exports['default'] = ExtractorsActions;
	module.exports = exports['default'];

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var GettingStartedActions = _reflux2['default'].createActions({
	  'getStatus': { asyncResult: true },
	  'dismiss': { asyncResult: true }
	});
	
	exports['default'] = GettingStartedActions;
	module.exports = exports['default'];

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var IndexerClusterActions = _reflux2['default'].createActions({
	  'health': { asyncResult: true },
	  'name': { asyncResult: true }
	});
	
	exports['default'] = IndexerClusterActions;
	module.exports = exports['default'];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var IndexerOverviewActions = _reflux2['default'].createActions({
	  list: { asyncResult: true }
	});
	
	exports['default'] = IndexerOverviewActions;
	module.exports = exports['default'];

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var DeflectorActions = _reflux2['default'].createActions({
	  'cycle': { asyncResult: true },
	  'list': { asyncResult: true }
	});
	
	exports['default'] = DeflectorActions;
	module.exports = exports['default'];

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var IndexRangesActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'recalculate': { asyncResult: true },
	  'recalculateIndex': { asyncResult: true }
	});
	
	exports['default'] = IndexRangesActions;
	module.exports = exports['default'];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var IndicesActions = _reflux2['default'].createActions({
	  list: { asyncResult: true },
	  close: { asyncResult: true },
	  'delete': { asyncResult: true },
	  multiple: { asyncResult: true },
	  reopen: { asyncResult: true },
	  subscribe: { asyncResult: false },
	  unsubscribe: { asyncResult: false }
	});
	
	exports['default'] = IndicesActions;
	module.exports = exports['default'];

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var IndicesConfigurationActions = _reflux2['default'].createActions({
	  'loadRotationConfig': { asyncResult: true },
	  'loadRotationStrategies': { asyncResult: true },
	  'loadRetentionConfig': { asyncResult: true },
	  'loadRetentionStrategies': { asyncResult: true },
	  'updateRotationConfiguration': { asyncResult: true },
	  'updateRetentionConfiguration': { asyncResult: true }
	});
	
	exports['default'] = IndicesConfigurationActions;
	module.exports = exports['default'];

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var InputTypesActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'get': { asyncResult: true }
	});
	
	exports['default'] = InputTypesActions;
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var InputsActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'get': { asyncResult: true },
	  'create': { asyncResult: true },
	  'delete': { asyncResult: true },
	  'update': { asyncResult: true }
	});
	
	exports['default'] = InputsActions;
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var LdapActions = _reflux2['default'].createActions({
	  'loadSettings': { asyncResult: true },
	  'update': { asyncResult: true },
	  'testServerConnection': { asyncResult: true },
	  'testLogin': { asyncResult: true }
	});
	
	exports['default'] = LdapActions;
	module.exports = exports['default'];

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var LdapGroupsActions = _reflux2['default'].createActions({
	  'loadGroups': { asyncResult: true },
	  'loadMapping': { asyncResult: true },
	  'saveMapping': { asyncResult: true }
	});
	
	exports['default'] = LdapGroupsActions;
	module.exports = exports['default'];

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var MessageCountsActions = _reflux2['default'].createActions({
	  'total': { asyncResult: true }
	});
	
	exports['default'] = MessageCountsActions;
	module.exports = exports['default'];

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var MessagesActions = _reflux2['default'].createActions({
	  loadMessage: { asyncResult: true },
	  fieldTerms: { asyncResult: true },
	  loadRawMessage: { asyncResult: true }
	});
	
	exports['default'] = MessagesActions;
	module.exports = exports['default'];

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var MetricsActions = _reflux2['default'].createActions({
	  'add': { asyncResult: true },
	  'addGlobal': { asyncResult: true },
	  'clear': { asyncResult: true },
	  'filter': { asyncResult: true },
	  'list': { asyncResult: true },
	  'names': { asyncResult: true },
	  'remove': { asyncResult: true },
	  'removeGlobal': { asyncResult: true }
	});
	
	exports['default'] = MetricsActions;
	module.exports = exports['default'];

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var NodesActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true }
	});
	
	exports['default'] = NodesActions;
	module.exports = exports['default'];

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var SingleNodeActions = _reflux2['default'].createActions({
	  'get': { asyncResult: true }
	});
	
	exports['default'] = SingleNodeActions;
	module.exports = exports['default'];

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var NotificationsActions = _reflux2['default'].createActions({
	  'delete': { asyncResult: true },
	  'list': { asyncResult: true }
	});
	
	exports['default'] = NotificationsActions;
	module.exports = exports['default'];

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var SavedSearchesActions = _reflux2['default'].createActions({
	  'create': { asyncResult: true },
	  'update': { asyncResult: true },
	  'list': { asyncResult: true },
	  'execute': { asyncResult: true },
	  'delete': { asyncResult: true }
	});
	
	exports['default'] = SavedSearchesActions;
	module.exports = exports['default'];

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var ServerAvailabilityActions = _reflux2['default'].createActions(['reportError', 'reportSuccess']);
	
	exports['default'] = ServerAvailabilityActions;
	module.exports = exports['default'];

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var SessionActions = _reflux2['default'].createActions({
	  'login': { asyncResult: true },
	  'logout': { asyncResult: true },
	  'validate': { asyncResult: true }
	});
	
	exports['default'] = SessionActions;
	module.exports = exports['default'];

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var HistogramDataActions = _reflux2['default'].createActions({
	  'load': { asyncResult: true }
	});
	
	exports['default'] = HistogramDataActions;
	module.exports = exports['default'];

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var StreamsActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'create': { asyncResult: true },
	  'update': { asyncResult: true },
	  'delete': { asyncResult: true }
	});
	
	exports['default'] = StreamsActions;
	module.exports = exports['default'];

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var LoggersActions = _reflux2['default'].createActions({
	  'loggers': { asyncResult: true },
	  'subsystems': { asyncResult: true },
	  'setSubsystemLoggerLevel': { asyncResult: true }
	});
	
	exports['default'] = LoggersActions;
	module.exports = exports['default'];

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var SystemJobsActions = _reflux2['default'].createActions({
	  'list': { asyncResult: true },
	  'getJob': { asyncResult: true },
	  'cancelJob': { asyncResult: true }
	});
	
	exports['default'] = SystemJobsActions;
	module.exports = exports['default'];

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var RefreshActions = _reflux2['default'].createActions(['changeInterval', 'disable', 'enable']);
	
	exports['default'] = RefreshActions;
	module.exports = exports['default'];

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var WidgetsActions = _reflux2['default'].createActions({
	  'removeWidget': { asyncResult: true }
	});
	
	exports['default'] = WidgetsActions;
	module.exports = exports['default'];

/***/ },
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.generateId = generateId;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(13);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(628);
	
	__webpack_require__(1175);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _numeral = __webpack_require__(21);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _rickshaw = __webpack_require__(220);
	
	var _rickshaw2 = _interopRequireDefault(_rickshaw);
	
	var _legacyRickshawFixturesGraylog2Time = __webpack_require__(589);
	
	var _legacyRickshawFixturesGraylog2Time2 = _interopRequireDefault(_legacyRickshawFixturesGraylog2Time);
	
	var _legacyRickshawGraphGraylog2Selector = __webpack_require__(590);
	
	var _legacyRickshawGraphGraylog2Selector2 = _interopRequireDefault(_legacyRickshawGraphGraylog2Selector);
	
	var _logicDatetimesDateTime = __webpack_require__(31);
	
	var _logicDatetimesDateTime2 = _interopRequireDefault(_logicDatetimesDateTime);
	
	var _componentsVisualizationsGraphVisualization = __webpack_require__(325);
	
	var _componentsVisualizationsGraphVisualization2 = _interopRequireDefault(_componentsVisualizationsGraphVisualization);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilStringUtils = __webpack_require__(46);
	
	var _utilStringUtils2 = _interopRequireDefault(_utilStringUtils);
	
	var _logicGraphsHistogramFormatter = __webpack_require__(120);
	
	var _logicGraphsHistogramFormatter2 = _interopRequireDefault(_logicGraphsHistogramFormatter);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var SearchStore = _injectionStoreProvider2['default'].getStore('Search');
	
	function generateShortId() {
	  return Math.random().toString(36).substr(2, 9);
	}
	
	function generateId() {
	  var r = '';
	  for (var i = 0; i < 4; i++) {
	    r = r + generateShortId();
	  }
	
	  return r;
	}
	
	function sendFailureEvent(graphId, errorMessage) {
	  (0, _jquery2['default'])(document).trigger('failed.graylog.fieldgraph', { graphId: graphId, errorMessage: errorMessage });
	}
	
	function sendCreatedGraphEvent(opts) {
	  (0, _jquery2['default'])(document).trigger('created.graylog.fieldgraph', { graphOptions: opts });
	}
	
	function sendUpdatedGraphEvent(opts) {
	  (0, _jquery2['default'])(document).trigger('updated.graylog.fieldgraph', { graphOptions: opts });
	}
	
	function sendMergedGraphsEvent(targetGraphId, draggedGraphId) {
	  (0, _jquery2['default'])(document).trigger('merged.graylog.fieldgraph', { targetGraphId: targetGraphId, draggedGraphId: draggedGraphId });
	}
	
	var FieldChart = {
	  fieldGraphs: {},
	  GRAPH_HEIGHT: 120,
	  palette: new _rickshaw2['default'].Color.Palette({ scheme: 'colorwheel' }),
	
	  reload: function reload() {
	    this.palette = new _rickshaw2['default'].Color.Palette({ scheme: 'colorwheel' });
	  },
	
	  _getDefaultOptions: function _getDefaultOptions(opts) {
	    var searchParams = SearchStore.getOriginalSearchParams().toJS();
	
	    // Options.
	    if (opts.chartid === undefined) {
	      opts.chartid = generateId();
	    }
	
	    if (opts.interval === undefined) {
	      opts.interval = searchParams.interval || 'minute';
	    }
	
	    if (opts.interpolation === undefined) {
	      opts.interpolation = 'linear';
	    }
	
	    if (opts.renderer === undefined) {
	      opts.renderer = 'bar';
	    }
	
	    if (opts.valuetype === undefined) {
	      opts.valuetype = 'mean';
	    }
	
	    if (opts.query === undefined) {
	      opts.query = searchParams.query;
	    }
	
	    if (opts.createdAt === undefined) {
	      opts.createdAt = (0, _moment2['default'])().valueOf();
	    }
	
	    // Always get stream and time range params from the current search request.
	    // Ignore the streamid, rangetype and range params that have been stored in localStorage. (see FieldGraphsStore)
	    opts.streamid = searchParams.streamId;
	    opts.rangetype = searchParams.range_type;
	    opts.range = {};
	
	    switch (opts.rangetype) {
	      case 'relative':
	        opts.range.relative = searchParams.relative;
	        break;
	      case 'absolute':
	        opts.range.from = searchParams.from;
	        opts.range.to = searchParams.to;
	        break;
	      case 'keyword':
	        opts.range.keyword = searchParams.keyword;
	        break;
	      default:
	    }
	
	    return opts;
	  },
	
	  _getTimeRangeParams: function _getTimeRangeParams(opts) {
	    var timerange = {};
	    switch (opts.rangetype) {
	      case 'relative':
	        timerange.range = opts.range.relative;
	        break;
	      case 'absolute':
	        timerange.from = opts.range.from;
	        timerange.to = opts.range.to;
	        break;
	      case 'keyword':
	        timerange.keyword = opts.range.keyword;
	        break;
	      default:
	    }
	
	    return timerange;
	  },
	
	  _onFieldHistogramLoad: function _onFieldHistogramLoad($graphContainer, $graphElement, $graphYAxis, opts, data) {
	    if (opts.query.trim().length > 0) {
	      (0, _jquery2['default'])('.field-graph-query', $graphContainer).text(opts.query);
	    } else {
	      (0, _jquery2['default'])('.field-graph-query', $graphContainer).text('*');
	    }
	
	    var lines = [];
	    lines.push(JSON.stringify(opts));
	    $graphContainer.attr('data-lines', lines);
	
	    this._updateStatisticalFunctionText($graphContainer, opts);
	
	    // Do not add from time when we search in all messages
	    var from = $graphContainer.data('from') !== undefined ? data.from : undefined;
	
	    var graph = new _rickshaw2['default'].Graph({
	      element: $graphElement[0],
	      width: $graphElement.width(),
	      height: this.GRAPH_HEIGHT,
	      interpolation: opts.interpolation,
	      renderer: opts.renderer,
	      resolution: data.interval,
	      series: [{
	        name: opts.chartid,
	        data: data.values,
	        color: '#26ADE4',
	        gl2_query: opts.query,
	        valuetype: _componentsVisualizationsGraphVisualization2['default'].getReadableFieldChartStatisticalFunction(opts.valuetype),
	        field: opts.field
	      }]
	    });
	
	    new _rickshaw2['default'].Graph.Axis.Y({
	      graph: graph,
	      tickFormat: _rickshaw2['default'].Fixtures.Number.formatKMBT,
	      orientation: 'left',
	      element: $graphYAxis[0],
	      pixelsPerTick: 30
	    });
	
	    new _rickshaw2['default'].Graph.Axis.Time({
	      graph: graph,
	      ticksTreatment: 'glow',
	      timeFixture: new _rickshaw2['default'].Fixtures.Graylog2Time() });
	
	    // Cares about correct TZ handling.
	    new _rickshaw2['default'].Graph.HoverDetail({
	      graph: graph,
	      formatter: function formatter(series, x, y) {
	        var date = '<span class="date">' + new _logicDatetimesDateTime2['default'](x * 1000).toString(_logicDatetimesDateTime2['default'].Formats.COMPLETE) + '</span>';
	        var swatch = '<span class="detail_swatch" style="background-color: ' + series.color + '"></span>';
	        var content = swatch + '[' + series.valuetype + '] ' + series.field + ': ' + (0, _numeral2['default'])(y).format('0,0.[000]') + '<br>' + date;
	        return content;
	      }
	    });
	
	    new _rickshaw2['default'].Graph.Graylog2Selector({
	      graph: graph
	    });
	
	    if (opts.renderer === 'scatterplot') {
	      graph.renderer.dotSize = 2;
	    }
	
	    if (opts.renderer === 'area') {
	      graph.renderer.stroke = true;
	    }
	
	    graph.render();
	
	    this.fieldGraphs[opts.chartid] = graph;
	
	    // Make it draggable.
	    $graphContainer.draggable({
	      handle: '.reposition-handle',
	      cursor: 'move',
	      scope: '#field-graphs',
	      revert: 'invalid', // return to position when not dropped on a droppable.
	      opacity: 0.5,
	      containment: (0, _jquery2['default'])('#field-graphs'),
	      axis: 'y',
	      snap: (0, _jquery2['default'])('.field-graph-container'),
	      snapMode: 'inner'
	    });
	
	    var that = this;
	
	    // ...and droppable.
	    $graphContainer.droppable({
	      scope: '#field-graphs',
	      tolerance: 'intersect',
	      activate: function activate(event, ui) {
	        // Show merge hints on all charts except the dragged one when dragging starts.
	        (0, _jquery2['default'])('#field-graphs .merge-hint').not((0, _jquery2['default'])('.merge-hint', ui.draggable)).show();
	      },
	      deactivate: function deactivate() {
	        // Hide all merge hints when dragging stops.
	        (0, _jquery2['default'])('#field-graphs .merge-hint').hide();
	      },
	      over: function over() {
	        (0, _jquery2['default'])(this).css('background-color', '#C7E2ED');
	        (0, _jquery2['default'])('.merge-hint span', (0, _jquery2['default'])(this)).switchClass('alpha80', 'merge-drop-ready');
	      },
	      out: function out() {
	        (0, _jquery2['default'])(this).css('background-color', '#fff');
	        (0, _jquery2['default'])('.merge-hint span', (0, _jquery2['default'])(this)).switchClass('merge-drop-ready', 'alpha80');
	      },
	      drop: function drop(event, ui) {
	        // Merge charts.
	        var target = (0, _jquery2['default'])(this).attr('data-chart-id');
	        var dragged = ui.draggable.attr('data-chart-id');
	
	        ui.draggable.hide();
	        (0, _jquery2['default'])(this).css('background-color', '#fff');
	
	        that._mergeCharts(target, dragged);
	      }
	    });
	  },
	
	  _onFieldHistogramFail: function _onFieldHistogramFail($graphElement, opts, error) {
	    if (error.additional && error.additional.status === 400) {
	      sendFailureEvent(opts.chartid, 'Field graphs are only available for numeric fields.');
	    } else {
	      var _alert = (0, _jquery2['default'])('<div>').addClass('alert').addClass('alert-warning').text('Field graph could not be loaded, please try again after reloading the page.');
	      $graphElement.html(_alert);
	      var errorMessage = error.additional ? ' with status ' + error.additional.status : ' with error: ' + error.message;
	      _utilUserNotification2['default'].error('Loading field graph for \'' + opts.field + '\' failed ' + errorMessage);
	      console.error(error);
	    }
	  },
	
	  _chartOptionsFromContainer: function _chartOptionsFromContainer(cc) {
	    try {
	      return JSON.parse(cc.attr('data-lines'));
	    } catch (e) {
	      return this._getDefaultOptions();
	    }
	  },
	
	  _changeGraphConfig: function _changeGraphConfig(graphContainer, key, value) {
	    var options = this._chartOptionsFromContainer(graphContainer);
	    options[key] = value;
	
	    graphContainer.attr('data-lines', JSON.stringify(options));
	    sendUpdatedGraphEvent(options);
	  },
	
	  _insertSpinner: function _insertSpinner($graphContainer) {
	    var spinnerElement = (0, _jquery2['default'])('<div class="spinner" style="height: ' + this.GRAPH_HEIGHT + 'px; line-height: ' + this.GRAPH_HEIGHT + 'px;"><i class="fa fa-spin fa-refresh fa-3x spinner"></i></div>');
	    $graphContainer.append(spinnerElement);
	  },
	
	  _deleteSpinner: function _deleteSpinner($graphContainer) {
	    (0, _jquery2['default'])('.spinner', $graphContainer).remove();
	  },
	
	  _fetchData: function _fetchData(opts, timeRangeParams) {
	    var url = _routingApiRoutes2['default'].UniversalSearchApiController.fieldHistogram(opts.rangetype, opts.query || '*', opts.field, opts.interval, timeRangeParams, opts.streamid, opts.valuetype === 'cardinality').url;
	
	    return (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(url)).then(function (response) {
	      var formattedResponse = {
	        time: response.time,
	        interval: response.interval,
	        from: response.queried_timerange.from,
	        to: response.queried_timerange.to
	      };
	
	      formattedResponse.values = _logicGraphsHistogramFormatter2['default'].format(response.results, response.queried_timerange, opts.interval, (0, _jquery2['default'])(window).width(), opts.rangetype === 'relative' && opts.range.relative === 0, opts.valuetype, true);
	
	      return formattedResponse;
	    });
	  },
	
	  renderFieldChart: function renderFieldChart(opts, graphContainer, options) {
	    var _this = this;
	
	    var renderingOptions = options || {};
	    var field = opts.field;
	    var $graphContainer = (0, _jquery2['default'])(graphContainer);
	    var $graphElement = (0, _jquery2['default'])('.field-graph', $graphContainer);
	    var $graphYAxis = (0, _jquery2['default'])('.field-graph-y-axis', $graphContainer);
	
	    if (renderingOptions.newGraph) {
	      this._insertSpinner($graphContainer);
	    }
	
	    opts = this._getDefaultOptions(opts);
	    var timeRangeParams = this._getTimeRangeParams(opts);
	
	    var promise = this._fetchData(opts, timeRangeParams);
	    promise.then(function (data) {
	      // Delete a possibly already existing graph to manage updates.
	      $graphElement.html('');
	      $graphYAxis.html('');
	      $graphYAxis.hide();
	
	      _this._onFieldHistogramLoad($graphContainer, $graphElement, $graphYAxis, opts, data);
	
	      if (renderingOptions.newGraph) {
	        sendCreatedGraphEvent(opts);
	      }
	    })['catch'](function (error) {
	      return _this._onFieldHistogramFail($graphElement, opts, error);
	    })['finally'](function () {
	      $graphYAxis.show();
	      if (renderingOptions.newGraph) {
	        _this._deleteSpinner($graphContainer);
	      }
	    });
	  },
	
	  updateFieldChartData: function updateFieldChartData(graphId, options, seriesName) {
	    var _this2 = this;
	
	    options = this._getDefaultOptions(options);
	    var timeRangeParams = this._getTimeRangeParams(options);
	
	    var promise = this._fetchData(options, timeRangeParams);
	    promise.then(function (data) {
	      var fieldGraph = _this2.fieldGraphs[graphId];
	      if (fieldGraph) {
	        var series = fieldGraph.series.filter(function (aSeries) {
	          return aSeries.name === seriesName;
	        })[0];
	        if (series) {
	          series.data = data.values;
	          fieldGraph.update();
	        }
	      }
	    }, function (error) {
	      _utilUserNotification2['default'].error('Updating field graph data failed: ' + error, 'Could not update field graph data');
	    });
	  },
	
	  _updateStatisticalFunctionText: function _updateStatisticalFunctionText($graphContainer, graphOptions) {
	    (0, _jquery2['default'])('.type-description', $graphContainer).text('[' + _componentsVisualizationsGraphVisualization2['default'].getReadableFieldChartStatisticalFunction(graphOptions.valuetype) + '] ' + graphOptions.field + ', ');
	  },
	
	  renderNewFieldChart: function renderNewFieldChart(options, graphContainer) {
	    this.renderFieldChart(options, graphContainer, { newGraph: true });
	  },
	
	  changeInterpolation: function changeInterpolation(graphContainer, interpolation) {
	    var graphOptions = this._chartOptionsFromContainer(graphContainer);
	    this._changeGraphConfig(graphContainer, 'interpolation', interpolation);
	
	    var graph = this.fieldGraphs[graphOptions.chartid];
	    graph.interpolation = interpolation;
	    graph.render();
	  },
	
	  changeRenderer: function changeRenderer(graphContainer, renderer) {
	    var graphOptions = this._chartOptionsFromContainer(graphContainer);
	    this._changeGraphConfig(graphContainer, 'renderer', renderer);
	
	    var graph = this.fieldGraphs[graphOptions.chartid];
	    graph.setRenderer(renderer);
	
	    if (renderer === 'scatterplot') {
	      graph.renderer.dotSize = 2;
	    }
	
	    if (renderer === 'area') {
	      graph.renderer.stroke = true;
	    }
	
	    graph.renderer.unstack = true;
	    graph.render();
	  },
	
	  changeResolution: function changeResolution(graphContainer, resolution) {
	    var graphOptions = this._chartOptionsFromContainer(graphContainer);
	    graphOptions.interval = resolution;
	    this._changeGraphConfig(graphContainer, 'interval', resolution);
	    this.updateFieldChartData(graphOptions.chartid, graphOptions, graphOptions.chartid);
	  },
	
	  changeStatisticalFunction: function changeStatisticalFunction($graphContainer, statisticalFunction) {
	    var graphOptions = this._chartOptionsFromContainer($graphContainer);
	    graphOptions.valuetype = statisticalFunction;
	    this._changeGraphConfig($graphContainer, 'valuetype', statisticalFunction);
	    this.updateFieldChartData(graphOptions.chartid, graphOptions, graphOptions.chartid);
	    this._updateStatisticalFunctionText($graphContainer, graphOptions);
	  },
	
	  _mergeCharts: function _mergeCharts(targetId, draggedId) {
	    var targetChart = this.fieldGraphs[targetId];
	    var draggedChart = this.fieldGraphs[draggedId];
	
	    var targetElem = (0, _jquery2['default'])('.field-graph-container[data-chart-id=\'' + targetId + '\']');
	
	    for (var i = 0; i < draggedChart.series.length; i++) {
	      var lineColor = this.palette.color();
	      var series = draggedChart.series[i];
	      var query = series.gl2_query;
	
	      if (query === undefined || query === '') {
	        query = '*';
	      }
	
	      // Add query to query list of chart.
	      var queryDescription = '<div class="field-graph-query-color" style="background-color: "' + lineColor + ';"></div> ' + '<span class="type-description">[' + _utilStringUtils2['default'].escapeHTML(series.valuetype) + '] ' + series.field + ', </span> ' + 'Query: <span class="field-graph-query">' + _utilStringUtils2['default'].escapeHTML(query) + '</span>';
	
	      (0, _jquery2['default'])('ul.field-graph-query-container', targetElem).append('<li>' + queryDescription + '</li>');
	
	      var addSeries = {
	        name: series.name,
	        color: lineColor,
	        gl2_query: query,
	        valuetype: _componentsVisualizationsGraphVisualization2['default'].getReadableFieldChartStatisticalFunction(series.valuetype),
	        field: series.field
	      };
	
	      addSeries.data = series.data;
	
	      targetChart.series.push(addSeries);
	    }
	
	    targetChart.renderer.unstack = true;
	
	    sendMergedGraphsEvent(targetId, draggedId);
	
	    // Reflect all the chart changes we made.
	    targetChart.update();
	    targetChart.render();
	  },
	
	  stackGraphs: function stackGraphs(targetGraphId, sourceGraphId) {
	    this._mergeCharts(targetGraphId, sourceGraphId);
	    var sourceGraphElement = (0, _jquery2['default'])('.field-graph-container[data-chart-id="' + sourceGraphId + '"]');
	    sourceGraphElement.hide();
	  },
	
	  redraw: function redraw(graphId) {
	    var graph = this.fieldGraphs[graphId];
	    if (graph) {
	      var $graphContainer = (0, _jquery2['default'])('.field-graph-container[data-chart-id="' + graphId + '"]');
	      var $graphElement = (0, _jquery2['default'])('.field-graph', $graphContainer);
	      graph.configure({ width: $graphElement.width() });
	      graph.render();
	    }
	  }
	};
	
	exports.FieldChart = FieldChart;
	// Changing type of value graphs.
	(0, _jquery2['default'])(document).on('click', '.field-graph-container ul.renderer-selector li a', function (e) {
	  e.preventDefault();
	
	  var graphContainer = (0, _jquery2['default'])(this).closest('.field-graph-container');
	  var type = (0, _jquery2['default'])(this).attr('data-type');
	  FieldChart.changeRenderer(graphContainer, type);
	});
	
	// Changing interpolation of value graphs.
	(0, _jquery2['default'])(document).on('click', '.field-graph-container ul.interpolation-selector li a', function (e) {
	  e.preventDefault();
	
	  var graphContainer = (0, _jquery2['default'])(this).closest('.field-graph-container');
	  var interpolation = (0, _jquery2['default'])(this).attr('data-type');
	  FieldChart.changeInterpolation(graphContainer, interpolation);
	});
	
	// Changing interval of value graphs.
	(0, _jquery2['default'])(document).on('click', '.field-graph-container ul.interval-selector li a', function (e) {
	  e.preventDefault();
	
	  var graphContainer = (0, _jquery2['default'])(this).closest('.field-graph-container');
	  var interval = (0, _jquery2['default'])(this).attr('data-type');
	  FieldChart.changeResolution(graphContainer, interval);
	});
	
	// Changing value type of value graphs.
	(0, _jquery2['default'])(document).on('click', '.field-graph-container ul.valuetype-selector li a', function (e) {
	  e.preventDefault();
	
	  var graphContainer = (0, _jquery2['default'])(this).closest('.field-graph-container');
	  var valuetype = (0, _jquery2['default'])(this).attr('data-type');
	  FieldChart.changeStatisticalFunction(graphContainer, valuetype);
	});

/***/ },
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var MessageFieldsFilter = {
	  FILTERED_FIELDS: [
	  // ElasticSearch fields.
	  '_id', '_ttl', '_source', '_all', '_index', '_type', '_score',
	
	  // Our reserved fields.
	  'gl2_source_node', 'gl2_source_input', 'gl2_source_collector', 'gl2_source_collector_input', 'gl2_remote_ip', 'gl2_remote_port', 'gl2_remote_hostname', 'streams',
	  // TODO Due to be removed in Graylog 3.x
	  'gl2_source_radio', 'gl2_source_radio_input'],
	  filterFields: function filterFields(fields) {
	    var _this = this;
	
	    var result = {};
	
	    Object.keys(fields).forEach(function (field) {
	      if (_this.FILTERED_FIELDS.indexOf(field) < 0) {
	        result[field] = fields[field];
	      }
	    });
	
	    return result;
	  }
	};
	
	exports['default'] = MessageFieldsFilter;
	module.exports = exports['default'];

/***/ },
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(2);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _styleUseableCssLessStylesheetsDisconnectedLess = __webpack_require__(559);
	
	var _styleUseableCssLessStylesheetsDisconnectedLess2 = _interopRequireDefault(_styleUseableCssLessStylesheetsDisconnectedLess);
	
	var ServerUnavailablePage = _react2['default'].createClass({
	  displayName: 'ServerUnavailablePage',
	
	  propTypes: {
	    server: _react2['default'].PropTypes.object
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      showDetails: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    _styleUseableCssLessStylesheetsDisconnectedLess2['default'].use();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _styleUseableCssLessStylesheetsDisconnectedLess2['default'].unuse();
	  },
	
	  _toggleDetails: function _toggleDetails() {
	    this.setState({ showDetails: !this.state.showDetails });
	  },
	
	  _formatErrorMessage: function _formatErrorMessage() {
	    if (!this.state.showDetails) {
	      return null;
	    }
	
	    var noInformationMessage = _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement('hr', null),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'There is no information available.'
	      )
	    );
	
	    if (!this.props.server || !this.props.server.error) {
	      return noInformationMessage;
	    }
	
	    var error = this.props.server.error;
	
	    var errorDetails = [];
	    if (error.message) {
	      errorDetails.push(_react2['default'].createElement(
	        'dt',
	        { key: 'error-title' },
	        'Error message'
	      ), _react2['default'].createElement(
	        'dd',
	        { key: 'error-desc' },
	        error.message
	      ));
	    }
	    if (error.originalError) {
	      var originalError = error.originalError;
	      errorDetails.push(_react2['default'].createElement(
	        'dt',
	        { key: 'status-original-request-title' },
	        'Original Request'
	      ), _react2['default'].createElement(
	        'dd',
	        { key: 'status-original-request-content' },
	        String(originalError.method),
	        ' ',
	        String(originalError.url)
	      ));
	      errorDetails.push(_react2['default'].createElement(
	        'dt',
	        { key: 'status-code-title' },
	        'Status code'
	      ), _react2['default'].createElement(
	        'dd',
	        { key: 'status-code-desc' },
	        String(originalError.status)
	      ));
	
	      if (typeof originalError.toString === 'function') {
	        errorDetails.push(_react2['default'].createElement(
	          'dt',
	          { key: 'full-error-title' },
	          'Full error message'
	        ), _react2['default'].createElement(
	          'dd',
	          { key: 'full-error-desc' },
	          originalError.toString()
	        ));
	      }
	    }
	
	    if (errorDetails.length === 0) {
	      return noInformationMessage;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement('hr', { style: { marginTop: 10, marginBottom: 10 } }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'This is the last response we received from the server:'
	      ),
	      _react2['default'].createElement(
	        _reactBootstrap.Well,
	        { bsSize: 'small', style: { whiteSpace: 'pre-line' } },
	        _react2['default'].createElement(
	          'dl',
	          { style: { marginBottom: 0 } },
	          errorDetails
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _reactBootstrap.Modal,
	      { show: true },
	      _react2['default'].createElement(
	        _reactBootstrap.Modal.Header,
	        null,
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Title,
	          null,
	          _react2['default'].createElement('i', { className: 'fa fa-exclamation-triangle' }),
	          ' Server currently unavailable'
	        )
	      ),
	      _react2['default'].createElement(
	        _reactBootstrap.Modal.Body,
	        null,
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'p',
	            null,
	            'We are experiencing problems connecting to the Graylog server running on ',
	            _react2['default'].createElement(
	              'i',
	              null,
	              _utilURLUtils2['default'].qualifyUrl('')
	            ),
	            '. Please verify that the server is healthy and working correctly.'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'You will be automatically redirected to the previous page once we can connect to the server.'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Do you need a hand?',
	            ' ',
	            _react2['default'].createElement(
	              'a',
	              { href: 'https://www.graylog.org/community-support', target: '_blank' },
	              'We can help you'
	            ),
	            '.'
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '#', onClick: this._toggleDetails },
	              this.state.showDetails ? 'Less details' : 'More details'
	            ),
	            this._formatErrorMessage()
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ServerUnavailablePage;
	module.exports = exports['default'];

/***/ },
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactProxyNameLoginPagePagesLoginPage = __webpack_require__(1228);
	
	var _reactProxyNameLoginPagePagesLoginPage2 = _interopRequireDefault(_reactProxyNameLoginPagePagesLoginPage);
	
	var _reactProxyNameLoadingPagePagesLoadingPage = __webpack_require__(1226);
	
	var _reactProxyNameLoadingPagePagesLoadingPage2 = _interopRequireDefault(_reactProxyNameLoadingPagePagesLoadingPage);
	
	var _reactProxyNameLoggedInPagePagesLoggedInPage = __webpack_require__(1227);
	
	var _reactProxyNameLoggedInPagePagesLoggedInPage2 = _interopRequireDefault(_reactProxyNameLoggedInPagePagesLoggedInPage);
	
	var _pagesServerUnavailablePage = __webpack_require__(932);
	
	var _pagesServerUnavailablePage2 = _interopRequireDefault(_pagesServerUnavailablePage);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	__webpack_require__(1239);
	
	__webpack_require__(1240);
	
	__webpack_require__(1242);
	
	__webpack_require__(1237);
	
	__webpack_require__(1234);
	
	__webpack_require__(1246);
	
	__webpack_require__(1245);
	
	__webpack_require__(1236);
	
	var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	var ServerAvailabilityStore = _injectionStoreProvider2['default'].getStore('ServerAvailability');
	var CurrentUserStore = _injectionStoreProvider2['default'].getStore('CurrentUser');
	
	var AppFacade = _react2['default'].createClass({
	  displayName: 'AppFacade',
	
	  mixins: [_reflux2['default'].connect(SessionStore), _reflux2['default'].connect(ServerAvailabilityStore), _reflux2['default'].connect(CurrentUserStore)],
	
	  componentDidMount: function componentDidMount() {
	    this.interval = setInterval(ServerAvailabilityStore.ping, 20000);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.interval) {
	      clearInterval(this.interval);
	    }
	  },
	
	  render: function render() {
	    if (!this.state.server.up) {
	      return _react2['default'].createElement(_pagesServerUnavailablePage2['default'], { server: this.state.server });
	    }
	    if (!this.state.sessionId) {
	      return _react2['default'].createElement(_reactProxyNameLoginPagePagesLoginPage2['default'], null);
	    }
	    if (!this.state.currentUser) {
	      return _react2['default'].createElement(_reactProxyNameLoadingPagePagesLoadingPage2['default'], { text: 'We are preparing Graylog for you...' });
	    }
	    return _react2['default'].createElement(_reactProxyNameLoggedInPagePagesLoggedInPage2['default'], null);
	  }
	});
	
	exports['default'] = AppFacade;
	module.exports = exports['default'];

/***/ },
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var AlarmCallbacksActions = _injectionActionsProvider2['default'].getActions('AlarmCallbacks');
	
	var AlarmCallbacksStore = _reflux2['default'].createStore({
	  listenables: [AlarmCallbacksActions],
	
	  available: function available(streamId) {
	    var failCallback = function failCallback(error) {
	      return _utilUserNotification2['default'].error('Fetching available AlarmCallback types failed with status: ' + error.message, 'Could not retrieve available AlarmCallbacks');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlarmCallbacksApiController.available(streamId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      return response.types;
	    }, failCallback);
	
	    AlarmCallbacksActions.available.promise(promise);
	
	    return promise;
	  },
	  list: function list(streamId) {
	    var failCallback = function failCallback(error) {
	      return _utilUserNotification2['default'].error('Fetching AlarmCallbacks failed with status: ' + error.message, 'Could not retrieve AlarmCallbacks');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlarmCallbacksApiController.list(streamId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      return response.alarmcallbacks;
	    }, failCallback);
	
	    AlarmCallbacksActions.list.promise(promise);
	  },
	  save: function save(streamId, alarmCallback) {
	    var failCallback = function failCallback(error) {
	      return _utilUserNotification2['default'].error('Saving AlarmCallback failed with status: ' + error.message, 'Could not save AlarmCallback');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlarmCallbacksApiController.create(streamId).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url, alarmCallback)['catch'](failCallback);
	
	    AlarmCallbacksActions.save.promise(promise);
	  },
	  'delete': function _delete(streamId, alarmCallbackId) {
	    var failCallback = function failCallback(error) {
	      return _utilUserNotification2['default'].error('Removing AlarmCallback failed with status: ' + error.message, 'Could not remove AlarmCallback');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlarmCallbacksApiController['delete'](streamId, alarmCallbackId).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url)['catch'](failCallback);
	
	    AlarmCallbacksActions['delete'].promise(promise);
	  },
	  update: function update(streamId, alarmCallbackId, deltas) {
	    var failCallback = function failCallback(error) {
	      return _utilUserNotification2['default'].error('Updating Alarm Callback \'' + alarmCallbackId + '\' failed with status: ' + error.message, 'Could not update Alarm Callback');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlarmCallbacksApiController.update(streamId, alarmCallbackId).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, deltas)['catch'](failCallback);
	
	    AlarmCallbacksActions.update.promise(promise);
	  }
	});
	
	exports['default'] = AlarmCallbacksStore;
	module.exports = exports['default'];

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var AlertConditionsActions = _injectionActionsProvider2['default'].getActions('AlertConditions');
	
	var AlertConditionsStore = _reflux2['default'].createStore({
	  listenables: AlertConditionsActions,
	
	  'delete': function _delete(streamId, alertConditionId) {
	    var failCallback = function failCallback(error) {
	      _utilUserNotification2['default'].error('Removing Alert Condition failed with status: ' + error, 'Could not remove Alert Conditions');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].StreamAlertsApiController['delete'](streamId, alertConditionId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url).then(function () {
	      AlertConditionsActions.list(streamId);
	    }, failCallback);
	    AlertConditionsActions['delete'].promise(promise);
	  },
	  list: function list(streamId) {
	    var _this = this;
	
	    var failCallback = function failCallback(error) {
	      _utilUserNotification2['default'].error('Fetching Alert Conditions failed with status: ' + error, 'Could not retrieve Alert Conditions');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].StreamAlertsApiController.list(streamId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      var conditions = response.conditions.map(function (condition) {
	        condition.stream_id = streamId;
	        return condition;
	      });
	      _this.trigger({ alertConditions: conditions });
	      return conditions;
	    }, failCallback);
	
	    AlertConditionsActions.list.promise(promise);
	    return promise;
	  },
	  save: function save(streamId, alertCondition) {
	    var failCallback = function failCallback(error) {
	      _utilUserNotification2['default'].error('Saving Alert Condition failed with status: ' + error, 'Could not save Alert Condition');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].StreamAlertsApiController.create(streamId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url, alertCondition).then(function () {
	      AlertConditionsActions.list(streamId);
	    }, failCallback);
	
	    AlertConditionsActions.save.promise(promise);
	  },
	  update: function update(streamId, alertConditionId, request) {
	    var failCallback = function failCallback(error) {
	      _utilUserNotification2['default'].error('Saving Alert Condition failed with status: ' + error, 'Could not save Alert Condition');
	    };
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].StreamAlertsApiController.update(streamId, alertConditionId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, request).then(function () {
	      AlertConditionsActions.list(streamId);
	    }, failCallback);
	
	    AlertConditionsActions.update.promise(promise);
	  }
	});
	
	exports['default'] = AlertConditionsStore;
	module.exports = exports['default'];

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var AlertsActions = _injectionActionsProvider2['default'].getActions('Alerts');
	
	var AlertsStore = _reflux2['default'].createStore({
	  listenables: [AlertsActions],
	
	  list: function list(stream, since) {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlertsApiController.list(stream.id, since).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      return _this.trigger({ alerts: response });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching alerts for stream "' + stream.title + '" failed with status: ' + error.message, 'Could not retrieve alerts for stream "' + stream.title + '".');
	    });
	
	    AlertsActions.list.promise(promise);
	  },
	
	  listPaginated: function listPaginated(streamId, skip, limit) {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlertsApiController.listPaginated(streamId, skip, limit).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      return _this2.trigger({ alerts: response });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching alerts failed with status: ' + error.message, 'Could not retrieve alerts.');
	    });
	
	    AlertsActions.listPaginated.promise(promise);
	  },
	
	  listAllStreams: function listAllStreams(since) {
	    var _this3 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].AlertsApiController.listAllStreams(since).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      return _this3.trigger({ alerts: response });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching alerts failed with status: ' + error.message, 'Could not retrieve alerts.');
	    });
	
	    AlertsActions.listAllStreams.promise(promise);
	  }
	});
	
	exports['default'] = AlertsStore;
	module.exports = exports['default'];

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var AuthenticationActions = _injectionActionsProvider2['default'].getActions('Authentication');
	
	var AuthenticationStore = _reflux2['default'].createStore({
	  listenables: [AuthenticationActions],
	  sourceUrl: '/system/authentication/config',
	
	  getInitialState: function getInitialState() {
	    return {
	      authenticators: null
	    };
	  },
	
	  load: function load() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this.trigger({ authenticators: response });
	    }, function (error) {
	      return _utilUserNotification2['default'].error('Unable to load authentication configuration: ' + error, 'Could not load authenticators');
	    });
	
	    AuthenticationActions.load.promise(promise);
	  },
	
	  update: function update(type, config) {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl);
	    if (type === 'providers') {
	      var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, config).then(function (response) {
	        _this2.trigger({ authenticators: response });
	        _utilUserNotification2['default'].success('Configuration updated successfully');
	      }, function (error) {
	        return _utilUserNotification2['default'].error('Unable to save authentication provider configuration: ' + error, 'Could not save configuration');
	      });
	      AuthenticationActions.update.promise(promise);
	    }
	  }
	});
	
	exports['default'] = AuthenticationStore;
	module.exports = exports['default'];

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var NodesStore = _injectionStoreProvider2['default'].getStore('Nodes');
	var SystemProcessingStore = _injectionStoreProvider2['default'].getStore('SystemProcessing');
	var SystemLoadBalancerStore = _injectionStoreProvider2['default'].getStore('SystemLoadBalancer');
	
	var ClusterOverviewStore = _reflux2['default'].createStore({
	  sourceUrl: '/cluster',
	  clusterOverview: undefined,
	
	  init: function init() {
	    this.cluster();
	    this.listenTo(SystemProcessingStore, this.cluster);
	    this.listenTo(SystemLoadBalancerStore, this.cluster);
	    this.listenTo(NodesStore, this.cluster);
	  },
	
	  getInitialState: function getInitialState() {
	    return { clusterOverview: this.clusterOverview };
	  },
	
	  cluster: function cluster() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl));
	    promise.then(function (response) {
	      _this.clusterOverview = response;
	      _this.trigger({ clusterOverview: _this.clusterOverview });
	    }, function (error) {
	      return _utilUserNotification2['default'].error('Getting cluster overview failed: ' + error, 'Could not get cluster overview');
	    });
	
	    return promise;
	  },
	
	  threadDump: function threadDump(nodeId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + nodeId + '/threaddump')).then(function (response) {
	      return response.threaddump;
	    }, function (error) {
	      return _utilUserNotification2['default'].error('Getting thread dump for node \'' + nodeId + '\' failed: ' + error, 'Could not get thread dump');
	    });
	
	    return promise;
	  },
	
	  jvm: function jvm(nodeId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + nodeId + '/jvm'));
	    promise['catch'](function (error) {
	      return _utilUserNotification2['default'].error('Getting JVM information for node \'' + nodeId + '\' failed: ' + error, 'Could not get JVM information');
	    });
	
	    return promise;
	  }
	});
	
	exports['default'] = ClusterOverviewStore;
	module.exports = exports['default'];

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _actionsCodecsCodecTypesActions = __webpack_require__(571);
	
	var _actionsCodecsCodecTypesActions2 = _interopRequireDefault(_actionsCodecsCodecTypesActions);
	
	var CodecTypesStore = _reflux2['default'].createStore({
	  listenables: [_actionsCodecsCodecTypesActions2['default']],
	  codecTypes: undefined,
	
	  getInitialState: function getInitialState() {
	    return { codecTypes: this.codecTypes };
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].CodecTypesController.list().url));
	    promise.then(function (response) {
	      _this.codecTypes = response;
	      _this.trigger(_this.getInitialState());
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching codec types failed with status: ' + error, 'Could not retrieve codec types');
	    });
	
	    _actionsCodecsCodecTypesActions2['default'].list.promise(promise);
	  }
	});
	
	exports['default'] = CodecTypesStore;
	module.exports = exports['default'];

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var SessionActions = _injectionActionsProvider2['default'].getActions('Session');
	var ConfigurationBundlesActions = _injectionActionsProvider2['default'].getActions('ConfigurationBundles');
	
	var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	
	var ConfigurationBundlesStore = _reflux2['default'].createStore({
	  listenables: [ConfigurationBundlesActions],
	
	  apply: function apply(bundleId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].BundlesApiController.apply(bundleId).url));
	
	    ConfigurationBundlesActions.apply.promise(promise);
	  },
	
	  create: function create(request) {
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].BundlesApiController.create().url), request);
	
	    ConfigurationBundlesActions.create.promise(promise);
	  },
	
	  createCompleted: function createCompleted() {
	    this.list();
	  },
	
	  'delete': function _delete(bundleId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].BundlesApiController['delete'](bundleId).url));
	
	    ConfigurationBundlesActions['delete'].promise(promise);
	  },
	
	  deleteCompleted: function deleteCompleted() {
	    this.list();
	  },
	
	  'export': function _export(request) {
	    var builder = new _logicRestFetchProvider.Builder('POST', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].BundlesApiController['export']().url)).authenticated().build();
	    var promise = builder.type('json').accept('json').send(request).then(function (resp) {
	      if (resp.ok) {
	        return resp.text;
	      }
	
	      throw new _logicRestFetchProvider.FetchError(resp.statusText, resp);
	    }, function (error) {
	      if (error.status === 401) {
	        SessionActions.logout(SessionStore.getSessionId());
	      }
	
	      throw new _logicRestFetchProvider.FetchError(error.statusText, error);
	    });
	    ConfigurationBundlesActions['export'].promise(promise);
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].BundlesApiController.list().url)).then(function (result) {
	      _this.trigger({ configurationBundles: result });
	
	      return result;
	    });
	
	    ConfigurationBundlesActions.list.promise(promise);
	  }
	});
	
	exports['default'] = ConfigurationBundlesStore;
	module.exports = exports['default'];

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var ConfigurationActions = _injectionActionsProvider2['default'].getActions('Configuration');
	
	var urlPrefix = '/system/cluster_config';
	
	var ConfigurationsStore = _reflux2['default'].createStore({
	  listenables: [ConfigurationActions],
	
	  configuration: {},
	
	  _url: function _url(path) {
	    return _utilURLUtils2['default'].qualifyUrl(urlPrefix + path);
	  },
	
	  list: function list(configType) {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', this._url('/' + configType));
	    promise.then(function (response) {
	      _this.configuration[configType] = response;
	      _this.trigger({ configuration: _this.configuration });
	    });
	
	    ConfigurationActions.list.promise(promise);
	  },
	
	  listSearchesClusterConfig: function listSearchesClusterConfig() {
	    var _this2 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', this._url('/org.graylog2.indexer.searches.SearchesClusterConfig')).then(function (response) {
	      _this2.trigger({ searchesClusterConfig: response });
	    });
	
	    ConfigurationActions.listSearchesClusterConfig.promise(promise);
	  },
	
	  listMessageProcessorsConfig: function listMessageProcessorsConfig(configType) {
	    var _this3 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl('/system/messageprocessors/config')).then(function (response) {
	      _this3.configuration[configType] = response;
	      _this3.trigger({ configuration: _this3.configuration });
	    });
	
	    ConfigurationActions.listMessageProcessorsConfig.promise(promise);
	  },
	
	  update: function update(configType, config) {
	    var _this4 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', this._url('/' + configType), config);
	
	    promise.then(function (response) {
	      _this4.configuration[configType] = response;
	      _this4.trigger({ configuration: _this4.configuration });
	      _utilUserNotification2['default'].success('Configuration updated successfully');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Search config update failed: ' + error, 'Could not update search config: ' + configType);
	    });
	
	    ConfigurationActions.update.promise(promise);
	  },
	
	  updateMessageProcessorsConfig: function updateMessageProcessorsConfig(configType, config) {
	    var _this5 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', _utilURLUtils2['default'].qualifyUrl('/system/messageprocessors/config'), config);
	
	    promise.then(function (response) {
	      _this5.configuration[configType] = response;
	      _this5.trigger({ configuration: _this5.configuration });
	      _utilUserNotification2['default'].success('Configuration updated successfully');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Message processors config update failed: ' + error, 'Could not update config: ' + configType);
	    });
	
	    ConfigurationActions.updateMessageProcessorsConfig.promise(promise);
	  }
	});
	
	exports['default'] = ConfigurationsStore;
	module.exports = exports['default'];

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var DecoratorsActions = _injectionActionsProvider2['default'].getActions('Decorators');
	
	var DecoratorsStore = _reflux2['default'].createStore({
	  listenables: [DecoratorsActions],
	  state: {},
	  getInitialState: function getInitialState() {
	    return this.state;
	  },
	  init: function init() {
	    DecoratorsActions.available();
	    DecoratorsActions.list();
	  },
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DecoratorsResource.get().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      _this.trigger({ decorators: response });
	      _this.state.decorators = response;
	    });
	    DecoratorsActions.list.promise(promise);
	
	    return promise;
	  },
	  available: function available() {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DecoratorsResource.available().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      _this2.trigger({ types: response });
	      _this2.state.types = response;
	    });
	    DecoratorsActions.available.promise(promise);
	
	    return promise;
	  },
	  create: function create(request) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DecoratorsResource.create().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url, request);
	
	    DecoratorsActions.create.promise(promise);
	
	    return promise;
	  },
	  createCompleted: function createCompleted() {
	    DecoratorsActions.list();
	  },
	  remove: function remove(decoratorId) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DecoratorsResource.remove(decoratorId).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url);
	
	    DecoratorsActions.remove.promise(promise);
	
	    return promise;
	  },
	  removeCompleted: function removeCompleted() {
	    DecoratorsActions.list();
	  },
	  update: function update(decoratorId, request) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DecoratorsResource.update(decoratorId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, request);
	
	    DecoratorsActions.update.promise(promise);
	
	    return promise;
	  },
	  updateCompleted: function updateCompleted() {
	    DecoratorsActions.list();
	  }
	});
	
	exports['default'] = DecoratorsStore;
	module.exports = exports['default'];

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _utilExtractorUtils = __webpack_require__(40);
	
	var _utilExtractorUtils2 = _interopRequireDefault(_utilExtractorUtils);
	
	var _bluebird = __webpack_require__(208);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var ExtractorsActions = _injectionActionsProvider2['default'].getActions('Extractors');
	
	function getExtractorDTO(extractor) {
	  var converters = {};
	  extractor.converters.forEach(function (converter) {
	    converters[converter.type] = converter.config;
	  });
	
	  var conditionValue = extractor.condition_type && extractor.condition_type !== 'none' ? extractor.condition_value : '';
	
	  return {
	    title: extractor.title,
	    cut_or_copy: extractor.cursor_strategy || 'copy',
	    source_field: extractor.source_field,
	    target_field: extractor.target_field,
	    extractor_type: extractor.type || extractor.extractor_type, // "extractor_type" needed for imports
	    extractor_config: extractor.extractor_config,
	    converters: converters,
	    condition_type: extractor.condition_type || 'none',
	    condition_value: conditionValue,
	    order: extractor.order
	  };
	}
	
	var ExtractorsStore = _reflux2['default'].createStore({
	  listenables: [ExtractorsActions],
	  sourceUrl: '/system/inputs/',
	  extractors: undefined,
	  extractor: undefined,
	
	  init: function init() {
	    this.trigger({ extractors: this.extractors, extractor: this.extractor });
	  },
	
	  list: function list(inputId) {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(_utilURLUtils2['default'].concatURLPath(this.sourceUrl, inputId, 'extractors')));
	    promise.then(function (response) {
	      _this.extractors = response.extractors;
	      _this.trigger({ extractors: _this.extractors });
	    });
	
	    ExtractorsActions.list.promise(promise);
	  },
	
	  // Creates an basic extractor object that we can use to create new extractors.
	  'new': function _new(type, field) {
	    if (_utilExtractorUtils2['default'].EXTRACTOR_TYPES.indexOf(type) === -1) {
	      throw new Error('Invalid extractor type provided: ' + type);
	    }
	
	    return {
	      type: type,
	      source_field: field,
	      converters: [],
	      extractor_config: {},
	      target_field: ''
	    };
	  },
	
	  get: function get(inputId, extractorId) {
	    var _this2 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(_utilURLUtils2['default'].concatURLPath(this.sourceUrl, inputId, 'extractors', extractorId)));
	    promise.then(function (response) {
	      _this2.extractor = response;
	      _this2.trigger({ extractor: _this2.extractor });
	    });
	
	    ExtractorsActions.get.promise(promise);
	  },
	
	  save: function save(inputId, extractor) {
	    var promise = undefined;
	
	    if (extractor.id) {
	      promise = this.update(inputId, extractor, true);
	    } else {
	      promise = this.create(inputId, extractor, true);
	    }
	
	    ExtractorsActions.save.promise(promise);
	  },
	
	  _silentExtractorCreate: function _silentExtractorCreate(inputId, extractor) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ExtractorsController.create(inputId).url);
	    return (0, _logicRestFetchProvider2['default'])('POST', url, getExtractorDTO(extractor));
	  },
	
	  create: function create(inputId, extractor, calledFromMethod) {
	    var _this3 = this;
	
	    var promise = this._silentExtractorCreate(inputId, extractor);
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Extractor ' + extractor.title + ' created successfully');
	      if (_this3.extractor) {
	        ExtractorsActions.get.triggerPromise(inputId, extractor.id);
	      }
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Creating extractor failed: ' + error, 'Could not create extractor');
	    });
	
	    if (!calledFromMethod) {
	      ExtractorsActions.create.promise(promise);
	    }
	    return promise;
	  },
	
	  update: function update(inputId, extractor, calledFromMethod) {
	    var _this4 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ExtractorsController.update(inputId, extractor.id).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, getExtractorDTO(extractor));
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Extractor "' + extractor.title + '" updated successfully');
	      if (_this4.extractor) {
	        ExtractorsActions.get.triggerPromise(inputId, extractor.id);
	      }
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Updating extractor failed: ' + error, 'Could not update extractor');
	    });
	
	    if (!calledFromMethod) {
	      ExtractorsActions.update.promise(promise);
	    }
	    return promise;
	  },
	
	  'delete': function _delete(inputId, extractor) {
	    var _this5 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ExtractorsController['delete'](inputId, extractor.id).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url);
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Extractor "' + extractor.title + '" deleted successfully');
	      if (_this5.extractors) {
	        ExtractorsActions.list.triggerPromise(inputId);
	      }
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Deleting extractor failed: ' + error, 'Could not delete extractor ' + extractor.title);
	    });
	
	    ExtractorsActions['delete'].promise(promise);
	  },
	
	  order: function order(inputId, orderedExtractors) {
	    var _this6 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ExtractorsController.order(inputId).url);
	    var orderedExtractorsMap = {};
	    orderedExtractors.forEach(function (extractor, idx) {
	      return orderedExtractorsMap[idx] = extractor.id;
	    });
	
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url, { order: orderedExtractorsMap });
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Extractor positions updated successfully');
	      if (_this6.extractors) {
	        ExtractorsActions.list.triggerPromise(inputId);
	      }
	    });
	    promise['catch'](function (error) {
	      _utilUserNotification2['default'].error('Changing extractor positions failed: ' + error, 'Could not update extractor positions');
	    });
	
	    ExtractorsActions.order.promise(promise);
	  },
	
	  'import': function _import(inputId, extractors) {
	    var _this7 = this;
	
	    var successfulImports = 0;
	    var failedImports = 0;
	    var promises = [];
	
	    extractors.forEach(function (extractor) {
	      var promise = _this7._silentExtractorCreate(inputId, extractor);
	      promise.then(function () {
	        return successfulImports++;
	      })['catch'](function () {
	        return failedImports++;
	      });
	      promises.push(promise);
	    });
	
	    _bluebird2['default'].settle(promises).then(function () {
	      if (failedImports === 0) {
	        _utilUserNotification2['default'].success('Import results: ' + successfulImports + ' extractor(s) imported.', 'Import operation successful');
	      } else {
	        _utilUserNotification2['default'].warning('Import results: ' + successfulImports + ' extractor(s) imported, ' + failedImports + ' error(s).', 'Import operation completed');
	      }
	    });
	  }
	});
	
	exports['default'] = ExtractorsStore;
	module.exports = exports['default'];

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var GettingStartedActions = _injectionActionsProvider2['default'].getActions('GettingStarted');
	
	var GettingStartedStore = _reflux2['default'].createStore({
	  listenables: [GettingStartedActions],
	  sourceUrl: '/system/gettingstarted',
	  status: undefined,
	
	  init: function init() {
	    this.getStatus();
	  },
	
	  getInitialState: function getInitialState() {
	    return { status: this.status };
	  },
	
	  get: function get() {
	    return this.status;
	  },
	
	  getStatus: function getStatus() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl));
	    promise.then(function (response) {
	      _this.status = response;
	      _this.trigger({ status: _this.status });
	    })['catch'](console.error);
	
	    GettingStartedActions.getStatus.promise(promise);
	  },
	
	  dismiss: function dismiss() {
	    var _this2 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/dismiss'), '{}');
	    promise.then(function () {
	      return _this2.getStatus();
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Dismissing Getting Started Guide failed with status: ' + error, 'Could not dismiss guide');
	    });
	
	    GettingStartedActions.dismiss.promise(promise);
	  }
	});
	
	exports['default'] = GettingStartedStore;
	module.exports = exports['default'];

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var IndexerClusterActions = _injectionActionsProvider2['default'].getActions('IndexerCluster');
	
	var IndexerClusterStore = _reflux2['default'].createStore({
	  listenables: [IndexerClusterActions],
	  state: {},
	  init: function init() {
	    this.update();
	  },
	  update: function update() {
	    var _this = this;
	
	    Promise.all([this.health().then(function (health) {
	      _this.state.health = health;
	    }), this.name().then(function (response) {
	      _this.state.name = response.name;
	    })]).then(function () {
	      return _this.trigger(_this.state);
	    });
	  },
	  getInitialState: function getInitialState() {
	    return this.state;
	  },
	  health: function health() {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexerClusterApiController.health().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	
	    IndexerClusterActions.health.promise(promise);
	
	    return promise;
	  },
	  name: function name() {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexerClusterApiController.name().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	
	    IndexerClusterActions.name.promise(promise);
	
	    return promise;
	  }
	});
	
	exports['default'] = IndexerClusterStore;
	module.exports = exports['default'];

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var IndexerFailuresStore = _reflux2['default'].createStore({
	  listenables: [],
	
	  list: function list(limit, offset) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexerFailuresApiController.list(limit, offset).url);
	    return (0, _logicRestFetchProvider2['default'])('GET', url);
	  },
	
	  count: function count(since) {
	    var momentSince = since.format ? since : (0, _moment2['default'])(since);
	    var isoSince = momentSince.format('YYYY-MM-DDTHH:mm:ss.SSS');
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexerFailuresApiController.count(isoSince).url);
	
	    return (0, _logicRestFetchProvider2['default'])('GET', url);
	  }
	});
	
	exports['default'] = IndexerFailuresStore;
	module.exports = exports['default'];

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var IndexerOverviewActions = _injectionActionsProvider2['default'].getActions('IndexerOverview');
	
	var IndexerOverviewStore = _reflux2['default'].createStore({
	  listenables: [IndexerOverviewActions],
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexerOverviewApiResource.list().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      _this.trigger({ indexerOverview: response, indexerOverviewError: undefined });
	    }, function (error) {
	      if (error.additional && error.additional.status === 503) {
	        var errorMessage = error.additional.body && error.additional.body.message ? error.additional.body.message : 'Elasticsearch is unavailable. Check your configuration and logs for more information.';
	        _this.trigger({ indexerOverviewError: errorMessage });
	      }
	    });
	
	    IndexerOverviewActions.list.promise(promise);
	
	    return promise;
	  }
	});
	
	exports['default'] = IndexerOverviewStore;
	module.exports = exports['default'];

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var DeflectorActions = _injectionActionsProvider2['default'].getActions('Deflector');
	
	var DeflectorStore = _reflux2['default'].createStore({
	  listenables: [DeflectorActions],
	  deflector: {
	    info: undefined
	  },
	  init: function init() {
	    DeflectorActions.list();
	  },
	  getInitialState: function getInitialState() {
	    return { deflector: this.deflector };
	  },
	  cycle: function cycle() {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DeflectorApiController.cycle().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url);
	
	    DeflectorActions.cycle.promise(promise);
	  },
	  cycleCompleted: function cycleCompleted() {
	    DeflectorActions.list();
	  },
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].DeflectorApiController.list().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (info) {
	      _this.deflector.info = info;
	      _this.trigger({ deflector: _this.deflector });
	    });
	
	    DeflectorActions.list.promise(promise);
	  }
	});
	
	exports['default'] = DeflectorStore;
	module.exports = exports['default'];

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var IndexRangesActions = _injectionActionsProvider2['default'].getActions('IndexRanges');
	
	var IndexRangesStore = _reflux2['default'].createStore({
	  listenables: [IndexRangesActions],
	  indexRanges: undefined,
	
	  getInitialState: function getInitialState() {
	    return { indexRanges: this.indexRanges };
	  },
	  init: function init() {
	    IndexRangesActions.list();
	  },
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexRangesApiController.list().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this.indexRanges = response.ranges;
	
	      _this.trigger(_this.getInitialState());
	    });
	
	    IndexRangesActions.list.promise(promise);
	  },
	  recalculate: function recalculate() {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexRangesApiController.rebuild().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url);
	    promise.then(_utilUserNotification2['default'].success('Index ranges will be recalculated shortly'))['catch'](function (error) {
	      _utilUserNotification2['default'].error('Could not create a job to start index ranges recalculation, reason: ' + error, 'Error starting index ranges recalculation');
	    });
	
	    IndexRangesActions.recalculate.promise(promise);
	  },
	  recalculateIndex: function recalculateIndex(indexName) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndexRangesApiController.rebuildSingle(indexName).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url);
	    promise.then(_utilUserNotification2['default'].success('Index ranges for ' + indexName + ' will be recalculated shortly'))['catch'](function (error) {
	      _utilUserNotification2['default'].error('Could not create a job to start index ranges recalculation for ' + indexName + ', reason: ' + error, 'Error starting index ranges recalculation for ' + indexName);
	    });
	
	    IndexRangesActions.recalculateIndex.promise(promise);
	  }
	});
	
	exports['default'] = IndexRangesStore;
	module.exports = exports['default'];

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var IndicesConfigurationActions = _injectionActionsProvider2['default'].getActions('IndicesConfiguration');
	
	var urlPrefix = '/system/indices';
	
	var IndicesConfigurationStore = _reflux2['default'].createStore({
	  listenables: [IndicesConfigurationActions],
	
	  rotationStrategies: undefined,
	  retentionStrategies: undefined,
	
	  getInitialState: function getInitialState() {
	    return {
	      activeRotationConfig: undefined,
	      rotationStrategies: undefined,
	      activeRetentionConfig: undefined,
	      retentionStrategies: undefined
	    };
	  },
	
	  _url: function _url(path) {
	    return _utilURLUtils2['default'].qualifyUrl(urlPrefix + path);
	  },
	
	  _addConfigType: function _addConfigType(strategies, data) {
	    // The config object needs to have the "type" field set to the "default_config.type" to make the REST call work.
	    var result = strategies.filter(function (strategy) {
	      return strategy.type === data.strategy;
	    })[0];
	
	    if (result) {
	      data.config.type = result.default_config.type;
	    }
	  },
	
	  loadRotationConfig: function loadRotationConfig() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', this._url('/rotation/config'));
	
	    promise.then(function (response) {
	      _this.trigger({ activeRotationConfig: response });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching rotation config failed: ' + error, 'Could not retrieve rotation config');
	    });
	
	    IndicesConfigurationActions.loadRotationConfig.promise(promise);
	  },
	
	  loadRotationStrategies: function loadRotationStrategies() {
	    var _this2 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', this._url('/rotation/strategies'));
	
	    promise.then(function (response) {
	      _this2.rotationStrategies = response.strategies;
	      _this2.trigger({ rotationStrategies: response.strategies });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching rotation strategies failed: ' + error, 'Could not retrieve rotation strategies');
	    });
	
	    IndicesConfigurationActions.loadRotationStrategies.promise(promise);
	  },
	
	  loadRetentionConfig: function loadRetentionConfig() {
	    var _this3 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', this._url('/retention/config'));
	
	    promise.then(function (response) {
	      _this3.trigger({ activeRetentionConfig: response });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching retention config failed: ' + error, 'Could not retrieve retention config');
	    });
	
	    IndicesConfigurationActions.loadRetentionConfig.promise(promise);
	  },
	
	  loadRetentionStrategies: function loadRetentionStrategies() {
	    var _this4 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', this._url('/retention/strategies'));
	
	    promise.then(function (response) {
	      _this4.retentionStrategies = response.strategies;
	      _this4.trigger({ retentionStrategies: response.strategies });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching retention strategies failed: ' + error, 'Could not retrieve retention strategies');
	    });
	
	    IndicesConfigurationActions.loadRetentionStrategies.promise(promise);
	  },
	
	  updateRotationConfiguration: function updateRotationConfiguration(data) {
	    var _this5 = this;
	
	    this._addConfigType(this.rotationStrategies, data);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', this._url('/rotation/config'), data);
	
	    promise.then(function (response) {
	      _this5.trigger({ activeRotationConfig: response });
	      _utilUserNotification2['default'].success('Index rotation configuration updated successfully');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Updating index rotation config failed: ' + error, 'Unable to update index rotation config');
	    });
	
	    IndicesConfigurationActions.updateRotationConfiguration.promise(promise);
	  },
	
	  updateRetentionConfiguration: function updateRetentionConfiguration(data) {
	    var _this6 = this;
	
	    this._addConfigType(this.retentionStrategies, data);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', this._url('/retention/config'), data);
	
	    promise.then(function (response) {
	      _this6.trigger({ activeRetentionConfig: response });
	      _utilUserNotification2['default'].success('Index retention configuration updated successfully');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Updating index retention config failed: ' + error, 'Unable to update index retention config');
	    });
	
	    IndicesConfigurationActions.updateRetentionConfiguration.promise(promise);
	  }
	});
	
	exports['default'] = IndicesConfigurationStore;
	module.exports = exports['default'];

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var IndicesActions = _injectionActionsProvider2['default'].getActions('Indices');
	
	var IndicesStore = _reflux2['default'].createStore({
	  listenables: [IndicesActions],
	  indices: undefined,
	  closedIndices: undefined,
	  registrations: {},
	
	  init: function init() {
	    IndicesActions.list();
	  },
	  getInitialState: function getInitialState() {
	    return { indices: this.indices, closedIndices: this.closedIndices };
	  },
	  list: function list() {
	    var _this = this;
	
	    var urlList = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndicesApiController.list().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', urlList).then(function (response) {
	      _this.indices = response.all.indices;
	      _this.closedIndices = response.closed.indices;
	      _this.trigger({ indices: _this.indices, closedIndices: _this.closedIndices });
	      return { indices: _this.indices, closedIndices: _this.closedIndices };
	    });
	
	    IndicesActions.list.promise(promise);
	  },
	  multiple: function multiple() {
	    var _this2 = this;
	
	    var indexNames = Object.keys(this.registrations);
	    if (indexNames.length <= 0) {
	      return;
	    }
	    var urlList = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndicesApiController.multiple().url);
	    var request = { indices: indexNames };
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', urlList, request).then(function (response) {
	      if (!_this2.indices) {
	        _this2.indices = response;
	      } else {
	        Object.keys(response).forEach(function (indexName) {
	          _this2.indices[indexName] = response[indexName];
	        });
	      }
	      _this2.trigger({ indices: _this2.indices, closedIndices: _this2.closedIndices });
	      return { indices: _this2.indices, closedIndices: _this2.closedIndices };
	    });
	
	    IndicesActions.multiple.promise(promise);
	  },
	  close: function close(indexName) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndicesApiController.close(indexName).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url);
	
	    IndicesActions.close.promise(promise);
	  },
	  closeCompleted: function closeCompleted() {
	    IndicesActions.list();
	  },
	  'delete': function _delete(indexName) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndicesApiController['delete'](indexName).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url);
	
	    IndicesActions['delete'].promise(promise);
	  },
	  deleteCompleted: function deleteCompleted() {
	    IndicesActions.list();
	  },
	  reopen: function reopen(indexName) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].IndicesApiController.reopen(indexName).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url);
	
	    IndicesActions.reopen.promise(promise);
	  },
	  reopenCompleted: function reopenCompleted() {
	    IndicesActions.list();
	  },
	  subscribe: function subscribe(indexName) {
	    this.registrations[indexName] = this.registrations[indexName] ? this.registrations[indexName] + 1 : 1;
	  },
	  unsubscribe: function unsubscribe(indexName) {
	    this.registrations[indexName] = this.registrations[indexName] > 0 ? this.registrations[indexName] - 1 : 0;
	    if (this.registrations[indexName] === 0) {
	      delete this.registrations[indexName];
	    }
	  }
	});
	
	exports['default'] = IndicesStore;
	module.exports = exports['default'];

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var InputStatesStore = _reflux2['default'].createStore({
	  listenables: [],
	
	  init: function init() {
	    this.list();
	  },
	
	  getInitialState: function getInitialState() {
	    return { inputStates: this.inputStates };
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterInputStatesController.list().url);
	    return (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      var result = {};
	      Object.keys(response).forEach(function (node) {
	        if (!response[node]) {
	          return;
	        }
	        response[node].forEach(function (input) {
	          if (!result[input.id]) {
	            result[input.id] = {};
	          }
	          result[input.id][node] = input;
	        });
	      });
	      _this.inputStates = result;
	      _this.trigger({ inputStates: _this.inputStates });
	
	      return result;
	    });
	  },
	
	  _checkInputStateChangeResponse: function _checkInputStateChangeResponse(input, response, action) {
	    var nodes = Object.keys(response).filter(function (node) {
	      return input.global ? true : node === input.node;
	    });
	    var failedNodes = nodes.filter(function (nodeId) {
	      return response[nodeId] === null;
	    });
	
	    if (failedNodes.length === 0) {
	      _utilUserNotification2['default'].success('Request to ' + action.toLowerCase() + ' input \'' + input.title + '\' was sent successfully.', 'Input \'' + input.title + '\' will be ' + (action === 'START' ? 'started' : 'stopped') + ' shortly');
	    } else if (failedNodes.length === nodes.length) {
	      _utilUserNotification2['default'].error('Request to ' + action.toLowerCase() + ' input \'' + input.title + '\' failed. Check your Graylog logs for more information.', 'Input \'' + input.title + '\' could not be ' + (action === 'START' ? 'started' : 'stopped'));
	    } else {
	      _utilUserNotification2['default'].warning('Request to ' + action.toLowerCase() + ' input \'' + input.title + '\' failed in some nodes. Check your Graylog logs for more information.', 'Input \'' + input.title + '\' could not be ' + (action === 'START' ? 'started' : 'stopped') + ' in all nodes');
	    }
	  },
	
	  start: function start(input) {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterInputStatesController.start(input.id).url);
	    return (0, _logicRestFetchProvider2['default'])('PUT', url).then(function (response) {
	      _this2._checkInputStateChangeResponse(input, response, 'START');
	      _this2.list();
	    }, function (error) {
	      _utilUserNotification2['default'].error('Error starting input \'' + input.title + '\': ' + error, 'Input \'' + input.title + '\' could not be started');
	    });
	  },
	
	  stop: function stop(input) {
	    var _this3 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterInputStatesController.stop(input.id).url);
	    return (0, _logicRestFetchProvider2['default'])('DELETE', url).then(function (response) {
	      _this3._checkInputStateChangeResponse(input, response, 'STOP');
	      _this3.list();
	    }, function (error) {
	      _utilUserNotification2['default'].error('Error stopping input \'' + input.title + '\': ' + error, 'Input \'' + input.title + '\' could not be stopped');
	    });
	  }
	});
	
	exports['default'] = InputStatesStore;
	module.exports = exports['default'];

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var InputStaticFieldsStore = _reflux2['default'].createStore({
	  listenables: [],
	  sourceUrl: function sourceUrl(inputId) {
	    return '/system/inputs/' + inputId + '/staticfields';
	  },
	
	  create: function create(input, name, value) {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(input.id));
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', url, { key: name, value: value });
	    promise.then(function () {
	      _this.trigger({});
	      _utilUserNotification2['default'].success('Static field \'' + name + '\' added to \'' + input.title + '\' successfully');
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Adding static field to input failed with: ' + error, 'Could not add static field to input \'' + input.title + '\'');
	    });
	
	    return promise;
	  },
	
	  destroy: function destroy(input, name) {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(input.id) + '/' + name);
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url);
	    promise.then(function () {
	      _this2.trigger({});
	      _utilUserNotification2['default'].success('Static field \'' + name + '\' removed from \'' + input.title + '\' successfully');
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Removing static field from input failed with: ' + error, 'Could not remove static field \'' + name + ' from input \'' + input.title + '\'');
	    });
	
	    return promise;
	  }
	});
	
	exports['default'] = InputStaticFieldsStore;
	module.exports = exports['default'];

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var InputTypesActions = _injectionActionsProvider2['default'].getActions('InputTypes');
	
	var InputTypesStore = _reflux2['default'].createStore({
	  listenables: [InputTypesActions],
	  sourceUrl: '/system/inputs/types',
	  inputTypes: undefined,
	  inputDescriptions: undefined,
	
	  init: function init() {
	    this.list();
	  },
	
	  getInitialState: function getInitialState() {
	    return { inputTypes: this.inputTypes, inputDescriptions: this.inputDescriptions };
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var promiseTypes = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl));
	    var promiseDescriptions = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/all'));
	    var promise = Promise.all([promiseTypes, promiseDescriptions]);
	    promise.then(function (responses) {
	      _this.inputTypes = responses[0].types;
	      _this.inputDescriptions = responses[1];
	      _this.trigger(_this.getInitialState());
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching Input Types failed with status: ' + error, 'Could not retrieve Inputs');
	    });
	
	    InputTypesActions.list.promise(promise);
	  },
	
	  get: function get(inputTypeId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + inputTypeId));
	
	    promise['catch'](function (error) {
	      _utilUserNotification2['default'].error('Fetching input ' + inputTypeId + ' failed with status: ' + error, 'Could not retrieve input');
	    });
	
	    InputTypesActions.get.promise(promise);
	  }
	});
	
	exports['default'] = InputTypesStore;
	module.exports = exports['default'];

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var InputStaticFieldsStore = _injectionStoreProvider2['default'].getStore('InputStaticFields');
	
	var InputsActions = _injectionActionsProvider2['default'].getActions('Inputs');
	
	var InputsStore = _reflux2['default'].createStore({
	  listenables: [InputsActions],
	  sourceUrl: '/system/inputs',
	  inputs: undefined,
	  input: undefined,
	
	  init: function init() {
	    this.trigger({ inputs: this.inputs, input: this.input });
	    this.listenTo(InputStaticFieldsStore, this.list);
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl));
	    promise.then(function (response) {
	      _this.inputs = response.inputs;
	      _this.trigger({ inputs: _this.inputs });
	
	      return _this.inputs;
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching Inputs failed with status: ' + error, 'Could not retrieve Inputs');
	    });
	
	    InputsActions.list.promise(promise);
	  },
	
	  get: function get(inputId) {
	    var _this2 = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + inputId));
	
	    promise.then(function (response) {
	      _this2.input = response;
	      _this2.trigger({ input: _this2.input });
	
	      return _this2.input;
	    }, function (error) {
	      _utilUserNotification2['default'].error('Fetching input ' + inputId + ' failed with status: ' + error, 'Could not retrieve input');
	    });
	
	    InputsActions.get.promise(promise);
	  },
	
	  create: function create(input) {
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl), input);
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Input \'' + input.title + '\' launched successfully');
	      InputsActions.list();
	    }, function (error) {
	      _utilUserNotification2['default'].error('Launching input \'' + input.title + '\' failed with status: ' + error, 'Could not launch input');
	    });
	
	    InputsActions.create.promise(promise);
	  },
	
	  'delete': function _delete(input) {
	    var inputId = input.id;
	    var inputTitle = input.title;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + inputId));
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Input \'' + inputTitle + '\' deleted successfully');
	      InputsActions.list();
	    }, function (error) {
	      _utilUserNotification2['default'].error('Deleting input \'' + inputTitle + '\' failed with status: ' + error, 'Could not delete input');
	    });
	
	    InputsActions['delete'].promise(promise);
	  },
	
	  update: function update(id, input) {
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + id), input);
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Input \'' + input.title + '\' updated successfully');
	      InputsActions.list();
	    }, function (error) {
	      _utilUserNotification2['default'].error('Updating input \'' + input.title + '\' failed with status: ' + error, 'Could not update input');
	    });
	
	    InputsActions.update.promise(promise);
	  }
	});
	
	InputsStore.inputsAsMap = function (inputsList) {
	  var inputsMap = {};
	  inputsList.forEach(function (input) {
	    inputsMap[input.id] = input;
	  });
	  return inputsMap;
	};
	
	exports['default'] = InputsStore;
	module.exports = exports['default'];

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var JournalStore = _reflux2['default'].createStore({
	  sourceUrl: function sourceUrl(nodeId) {
	    return '/cluster/' + nodeId + '/journal';
	  },
	
	  get: function get(nodeId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(nodeId)));
	    promise['catch'](function (error) {
	      _utilUserNotification2['default'].error('Getting journal information on node ' + nodeId + ' failed: ' + error, 'Could not get journal information');
	    });
	
	    return promise;
	  }
	});
	
	exports['default'] = JournalStore;
	module.exports = exports['default'];

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var LdapGroupsActions = _injectionActionsProvider2['default'].getActions('LdapGroups');
	
	var LdapGroupsStore = _reflux2['default'].createStore({
	  listenables: [LdapGroupsActions],
	  sourceUrl: '/system/ldap',
	  groups: undefined,
	  mapping: undefined,
	
	  getInitialState: function getInitialState() {
	    return { groups: this.groups, mapping: this.mapping };
	  },
	
	  loadGroups: function loadGroups() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/groups');
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      _this.groups = response;
	      _this.trigger({ groups: _this.groups });
	    }, function (error) {
	      if (error.additional.status !== 400) {
	        _utilUserNotification2['default'].error('Loading LDAP group list failed with status: ' + error, 'Could not load LDAP group list');
	      }
	    });
	
	    LdapGroupsActions.loadGroups.promise(promise);
	  },
	
	  loadMapping: function loadMapping() {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/settings/groups');
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      _this2.mapping = response;
	      _this2.trigger({ mapping: _this2.mapping });
	    }, function (error) {
	      _utilUserNotification2['default'].error('Loading LDAP group mapping failed with status: ' + error, 'Could not load LDAP group mapping');
	    });
	
	    LdapGroupsActions.loadMapping.promise(promise);
	  },
	
	  saveMapping: function saveMapping(mapping) {
	    var _this3 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/settings/groups');
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, mapping);
	    promise.then(function () {
	      _this3.loadMapping();
	      _utilUserNotification2['default'].success('LDAP group mapping successfully updated.');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Updating LDAP group mapping failed with status: ' + error, 'Could not update LDAP group mapping');
	    });
	
	    LdapGroupsActions.saveMapping.promise(promise);
	  }
	});
	
	exports['default'] = LdapGroupsStore;
	module.exports = exports['default'];

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var LdapActions = _injectionActionsProvider2['default'].getActions('Ldap');
	
	var LdapStore = _reflux2['default'].createStore({
	  listenables: [LdapActions],
	  sourceUrl: '/system/ldap/',
	  ldapSettings: undefined,
	
	  getInitialState: function getInitialState() {
	    return { ldapSettings: this.ldapSettings };
	  },
	
	  loadSettings: function loadSettings() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/settings');
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    promise.then(function (response) {
	      _this.ldapSettings = response;
	      _this.trigger({ ldapSettings: response });
	    });
	
	    LdapActions.loadSettings.promise(promise);
	  },
	
	  update: function update(newLdapSettings) {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/settings');
	
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, newLdapSettings);
	    promise.then(function () {
	      _this2.loadSettings();
	      _utilUserNotification2['default'].success('LDAP settings saved successfully');
	    }, function (error) {
	      return _utilUserNotification2['default'].error('Saving LDAP settings failed: ' + error, 'Could not save LDAP settings');
	    });
	
	    LdapActions.update.promise(promise);
	  },
	
	  _ldapTest: function _ldapTest(payload) {
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/test');
	    return (0, _logicRestFetchProvider2['default'])('POST', url, payload);
	  },
	
	  testServerConnection: function testServerConnection(newLdapSettings) {
	    var payload = {
	      test_connect_only: true,
	      ldap_uri: newLdapSettings.ldap_uri,
	      system_username: newLdapSettings.system_username,
	      system_password: newLdapSettings.system_password,
	      use_start_tls: newLdapSettings.use_start_tls,
	      trust_all_certificates: newLdapSettings.trust_all_certificates,
	      active_directory: newLdapSettings.active_directory
	    };
	
	    var promise = this._ldapTest(payload);
	
	    LdapActions.testServerConnection.promise(promise);
	  },
	
	  testLogin: function testLogin(newLdapSettings, principal, password) {
	    var payload = {
	      test_connect_only: false,
	      principal: principal,
	      password: password,
	      ldap_uri: newLdapSettings.ldap_uri,
	      system_username: newLdapSettings.system_username,
	      system_password: newLdapSettings.system_password,
	      use_start_tls: newLdapSettings.use_start_tls,
	      trust_all_certificates: newLdapSettings.trust_all_certificates,
	      active_directory: newLdapSettings.active_directory,
	      search_base: newLdapSettings.search_base,
	      search_pattern: newLdapSettings.search_pattern,
	      group_search_base: newLdapSettings.group_search_base,
	      group_id_attribute: newLdapSettings.group_id_attribute,
	      group_search_pattern: newLdapSettings.group_search_pattern
	    };
	
	    var promise = this._ldapTest(payload);
	
	    LdapActions.testLogin.promise(promise);
	  }
	});
	
	exports['default'] = LdapStore;
	module.exports = exports['default'];

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var SystemLoadBalancerStore = _reflux2['default'].createStore({
	  sourceUrl: function sourceUrl(nodeId) {
	    return '/cluster/' + nodeId + '/lbstatus';
	  },
	
	  override: function override(nodeId, status) {
	    var _this = this;
	
	    return (0, _logicRestFetchProvider2['default'])('PUT', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(nodeId) + '/override/' + status)).then(function () {
	      _this.trigger({});
	      _utilUserNotification2['default'].success('Load balancer status successfully changed do \'' + status + '\' in node \'' + nodeId + '\'');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Changing load balancer status in \'' + nodeId + '\' failed: ' + error, 'Could not change load balancer status to \'' + status + '\' in node \'' + nodeId + '\'');
	    });
	  }
	});
	
	exports['default'] = SystemLoadBalancerStore;
	module.exports = exports['default'];

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var MessageCountsActions = _injectionActionsProvider2['default'].getActions('MessageCounts');
	
	var MessageCountsStore = _reflux2['default'].createStore({
	  listenables: [MessageCountsActions],
	  events: undefined,
	
	  init: function init() {
	    this.total();
	  },
	  total: function total() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].CountsApiController.total().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this.events = response.events;
	      _this.trigger({ events: response.events });
	      return response.events;
	    });
	
	    MessageCountsActions.total.promise(promise);
	
	    return promise;
	  }
	});
	
	exports['default'] = MessageCountsStore;
	module.exports = exports['default'];

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _md5 = __webpack_require__(630);
	
	var _md52 = _interopRequireDefault(_md5);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var MessageFieldsStore = _reflux2['default'].createStore({
	  listenables: [],
	  fields: undefined,
	
	  init: function init() {
	    this.list();
	  },
	  getInitialState: function getInitialState() {
	    return { fields: this.fields };
	  },
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].MessageFieldsApiController.list().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      var result = response.fields.map(function (field) {
	        return {
	          hash: (0, _md52['default'])(field),
	          name: field,
	          standard_selected: field === 'message' || field === 'source'
	        };
	      });
	      _this.fields = result;
	      _this.trigger(_this.getInitialState());
	      return result;
	    });
	    return promise;
	  }
	});
	
	exports['default'] = MessageFieldsStore;
	module.exports = exports['default'];

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _logicMessageMessageFormatter = __webpack_require__(592);
	
	var _logicMessageMessageFormatter2 = _interopRequireDefault(_logicMessageMessageFormatter);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var MessagesActions = _injectionActionsProvider2['default'].getActions('Messages');
	
	var MessagesStore = _reflux2['default'].createStore({
	  listenables: [MessagesActions],
	  sourceUrl: '',
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  loadMessage: function loadMessage(index, messageId) {
	    var url = _routingApiRoutes2['default'].MessagesController.single(index.trim(), messageId.trim()).url;
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(url)).then(function (response) {
	      return _logicMessageMessageFormatter2['default'].formatResultMessage(response);
	    }, function (errorThrown) {
	      _utilUserNotification2['default'].error('Loading message information failed with status: ' + errorThrown, 'Could not load message information');
	    });
	
	    MessagesActions.loadMessage.promise(promise);
	  },
	
	  fieldTerms: function fieldTerms(index, string) {
	    var url = _routingApiRoutes2['default'].MessagesController.analyze(index, string).url;
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(url)).then(function (response) {
	      return response.tokens;
	    }, function (error) {
	      _utilUserNotification2['default'].error('Loading field terms failed with status: ' + error, 'Could not load field terms.');
	    });
	
	    MessagesActions.fieldTerms.promise(promise);
	  },
	
	  loadRawMessage: function loadRawMessage(message, remoteAddress, codec, codecConfiguration) {
	    var url = _routingApiRoutes2['default'].MessagesController.parse().url;
	    var payload = {
	      message: message,
	      remote_address: remoteAddress,
	      codec: codec,
	      configuration: codecConfiguration
	    };
	
	    var promise = (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(url), payload).then(function (response) {
	      return _logicMessageMessageFormatter2['default'].formatResultMessage(response);
	    }, function (error) {
	      if (error.additional && error.additional.status === 400) {
	        _utilUserNotification2['default'].error('Please ensure the selected codec and its configuration are right. ' + 'Check your server logs for more information.', 'Could not load raw message');
	        return;
	      }
	      _utilUserNotification2['default'].error('Loading raw message failed with status: ' + error, 'Could not load raw message');
	    });
	
	    MessagesActions.loadRawMessage.promise(promise);
	  }
	});
	
	exports['default'] = MessagesStore;
	module.exports = exports['default'];

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var MetricsStore = _injectionStoreProvider2['default'].getStore('Metrics');
	
	var MetricsActions = _injectionActionsProvider2['default'].getActions('Metrics');
	
	var GlobalThroughputStore = _reflux2['default'].createStore({
	  listenables: [],
	  metrics: {
	    input: 'org.graylog2.throughput.input.1-sec-rate',
	    output: 'org.graylog2.throughput.output.1-sec-rate'
	  },
	
	  init: function init() {
	    MetricsActions.addGlobal(this.metrics.input);
	    MetricsActions.addGlobal(this.metrics.output);
	    this.listenTo(MetricsStore, this.updateMetrics);
	    setInterval(MetricsActions.list, this.INTERVAL);
	  },
	  INTERVAL: 2000,
	  updateMetrics: function updateMetrics(update) {
	    var _this = this;
	
	    if (!update.metrics) {
	      return;
	    }
	    var throughput = {
	      input: 0,
	      output: 0
	    };
	    Object.keys(update.metrics).forEach(function (nodeId) {
	      var inputMetric = update.metrics[nodeId][_this.metrics.input];
	      var outputMetric = update.metrics[nodeId][_this.metrics.output];
	      if (inputMetric) {
	        throughput.input += inputMetric.metric.value;
	      }
	      if (outputMetric) {
	        throughput.output += outputMetric.metric.value;
	      }
	    });
	
	    this.trigger({ throughput: throughput });
	  }
	});
	
	exports['default'] = GlobalThroughputStore;
	module.exports = exports['default'];

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	var NodesStore = _injectionStoreProvider2['default'].getStore('Nodes');
	
	var SessionActions = _injectionActionsProvider2['default'].getActions('Session');
	var MetricsActions = _injectionActionsProvider2['default'].getActions('Metrics');
	
	var MetricsStore = _reflux2['default'].createStore({
	  listenables: [MetricsActions, SessionActions],
	  namespace: 'org',
	  registrations: {},
	  globalRegistrations: {},
	  promises: {},
	
	  init: function init() {
	    this.listenTo(NodesStore, this.updateNodes);
	  },
	  getInitialState: function getInitialState() {
	    return { metricsNames: this.metricsNames, metrics: this.metrics };
	  },
	  updateNodes: function updateNodes(update) {
	    this.nodes = update.nodes;
	  },
	  _allResults: function _allResults(promises) {
	    var accumulator = [];
	    var result = Promise.resolve(null);
	
	    promises.forEach(function (promise) {
	      result = result.then(function () {
	        return promise;
	      }).then(function (value) {
	        return accumulator.push(value);
	      }, function (error) {
	        return accumulator.push(error);
	      });
	    });
	
	    return result.then(function () {
	      return accumulator;
	    });
	  },
	  _metricsToFetch: function _metricsToFetch(localRegistrations, globalRegistrations) {
	    var metricsToFetch = {};
	
	    // First collect all node metric registrations
	    Object.keys(localRegistrations).filter(function (nodeId) {
	      return Object.keys(localRegistrations[nodeId].length > 0);
	    }).forEach(function (nodeId) {
	      Object.keys(localRegistrations[nodeId]).filter(function (metricName) {
	        return localRegistrations[nodeId][metricName] > 0;
	      }).forEach(function (metricName) {
	        metricsToFetch[metricName] = 1;
	      });
	    });
	
	    // Then collect all global metric registrations
	    Object.keys(globalRegistrations).filter(function (metricName) {
	      return globalRegistrations[metricName] > 0;
	    }).forEach(function (metricName) {
	      metricsToFetch[metricName] = 1;
	    });
	    return metricsToFetch;
	  },
	  _buildMetricsFromResponse: function _buildMetricsFromResponse(response) {
	    var metrics = {};
	    Object.keys(response).forEach(function (nodeId) {
	      var nodeMetrics = {};
	
	      if (!response[nodeId]) {
	        return;
	      }
	      response[nodeId].metrics.forEach(function (metric) {
	        nodeMetrics[metric.full_name] = metric;
	      });
	
	      metrics[nodeId] = nodeMetrics;
	    });
	
	    return metrics;
	  },
	  list: function list() {
	    var _this = this;
	
	    if (!SessionStore.isLoggedIn()) {
	      return;
	    }
	
	    var metricsToFetch = this._metricsToFetch(this.registrations, this.globalRegistrations);
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterMetricsApiController.multipleAllNodes().url);
	
	    if (!this.promises.list) {
	      var promise = (0, _logicRestFetchProvider2['default'])('POST', url, { metrics: Object.keys(metricsToFetch) })['finally'](function () {
	        return delete _this.promises.list;
	      });
	
	      promise.then(function (response) {
	        _this.metrics = _this._buildMetricsFromResponse(response);
	        _this.trigger({ metrics: _this.metrics });
	        return _this.metrics;
	      });
	      this.promises.list = promise;
	    }
	
	    MetricsActions.list.promise(this.promises.list);
	    return this.promises.list;
	  },
	  names: function names() {
	    var _this2 = this;
	
	    if (!this.nodes) {
	      console.warn('Node list not yet available, not fetching metrics.');
	      return;
	    }
	
	    var promise = this._allResults(Object.keys(this.nodes).map(function (nodeId) {
	      var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterMetricsApiController.byNamespace(nodeId, _this2.namespace).url);
	      return (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	        return { nodeId: nodeId, names: response.metrics };
	      });
	    })).then(function (responses) {
	      var metricsNames = {};
	      responses.forEach(function (response) {
	        if (response.nodeId) {
	          metricsNames[response.nodeId] = response.names;
	        }
	      });
	      _this2.trigger({ metricsNames: metricsNames });
	      _this2.metricsNames = metricsNames;
	      return metricsNames;
	    });
	
	    MetricsActions.names.promise(promise);
	  },
	  add: function add(nodeId, metricName) {
	    if (!this.registrations[nodeId]) {
	      this.registrations[nodeId] = {};
	    }
	    this.registrations[nodeId][metricName] = this.registrations[nodeId][metricName] ? this.registrations[nodeId][metricName] + 1 : 1;
	  },
	  addGlobal: function addGlobal(metricName) {
	    if (!this.globalRegistrations[metricName]) {
	      this.globalRegistrations[metricName] = 1;
	    } else {
	      this.globalRegistrations[metricName] += 1;
	    }
	  },
	  remove: function remove(nodeId, metricName) {
	    if (!this.registrations[nodeId]) {
	      return;
	    }
	    this.registrations[nodeId][metricName] = this.registrations[nodeId][metricName] > 0 ? this.registrations[nodeId][metricName] - 1 : 0;
	    if (this.registrations[nodeId][metricName] === 0) {
	      delete this.registrations[nodeId][metricName];
	    }
	  },
	  removeGlobal: function removeGlobal(metricName) {
	    if (!this.globalRegistrations[metricName]) {
	      return;
	    }
	    this.globalRegistrations[metricName] = this.globalRegistrations[metricName] > 0 ? this.globalRegistrations[metricName] - 1 : 0;
	    if (this.globalRegistrations[metricName] === 0) {
	      delete this.globalRegistrations[metricName];
	    }
	  }
	});
	
	exports['default'] = MetricsStore;
	module.exports = exports['default'];

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var NodesActions = _injectionActionsProvider2['default'].getActions('Nodes');
	
	var NodesStore = _reflux2['default'].createStore({
	  listenables: [NodesActions],
	  nodes: undefined,
	  clusterId: undefined,
	  nodeCount: 0,
	  INTERVAL: 5000, // 5 seconds
	  promises: {},
	
	  init: function init() {
	    if (this.nodes === undefined) {
	      NodesActions.list();
	      setInterval(NodesActions.list, this.INTERVAL);
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return this.getNodesInfo();
	  },
	
	  getNodesInfo: function getNodesInfo() {
	    return { nodes: this.nodes, clusterId: this.clusterId, nodeCount: this.nodeCount };
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var promise = this.promises.list || (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterApiResource.list().url)).then(function (response) {
	      _this.nodes = {};
	      response.nodes.forEach(function (node) {
	        _this.nodes[node.node_id] = node;
	      });
	      _this.clusterId = _this._clusterId();
	      _this.nodeCount = _this._nodeCount();
	      _this._propagateState();
	    })['finally'](function () {
	      return delete _this.promises.list;
	    });
	
	    this.promises.list = promise;
	
	    NodesActions.list.promise(promise);
	  },
	
	  getNode: function getNode(nodeId) {
	    return this.nodes[nodeId];
	  },
	
	  _clusterId: function _clusterId() {
	    var _this2 = this;
	
	    var nodeInCluster = Object.keys(this.nodes).map(function (id) {
	      return _this2.nodes[id];
	    }).find(function (node) {
	      return node.cluster_id;
	    });
	    return nodeInCluster ? nodeInCluster.cluster_id.toUpperCase() : undefined;
	  },
	
	  _nodeCount: function _nodeCount() {
	    return Object.keys(this.nodes).length;
	  },
	
	  _propagateState: function _propagateState() {
	    this.trigger(this.getNodesInfo());
	  }
	});
	
	exports['default'] = NodesStore;
	module.exports = exports['default'];

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var SingleNodeActions = _injectionActionsProvider2['default'].getActions('SingleNode');
	
	var SingleNodeStore = _reflux2['default'].createStore({
	  listenables: [SingleNodeActions],
	  sourceUrl: '/system/cluster/node',
	  node: undefined,
	
	  init: function init() {
	    this._propagateState();
	  },
	
	  getInitialState: function getInitialState() {
	    return this._getNodeInfo();
	  },
	
	  _getNodeInfo: function _getNodeInfo() {
	    return { node: this.node };
	  },
	
	  _propagateState: function _propagateState() {
	    this.trigger(this._getNodeInfo());
	  },
	
	  get: function get(nodeId) {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(nodeId ? _utilURLUtils2['default'].concatURLPath(this.sourceUrl, nodeId) : this.sourceUrl)).then(function (response) {
	      _this.node = response;
	      _this._propagateState();
	    });
	
	    SingleNodeActions.get.promise(promise);
	  }
	});
	
	exports['default'] = SingleNodeStore;
	module.exports = exports['default'];

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var NotificationsActions = _injectionActionsProvider2['default'].getActions('Notifications');
	
	var NotificationsStore = _reflux2['default'].createStore({
	  listenables: [NotificationsActions],
	  notifications: undefined,
	  promises: {},
	
	  init: function init() {
	    this.list();
	  },
	  getInitialState: function getInitialState() {
	    if (this.notifications) {
	      return this.notifications;
	    }
	
	    return {};
	  },
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].NotificationsApiController.list().url);
	    var promise = this.promises.list || new _logicRestFetchProvider.Builder('GET', url).authenticated().setHeader('X-Graylog-No-Session-Extension', 'true').json().build()['finally'](function () {
	      return delete _this.promises.list;
	    });
	
	    this.promises.list = promise;
	
	    NotificationsActions.list.promise(promise);
	  },
	  listCompleted: function listCompleted(response) {
	    this.notifications = response;
	    this.trigger(response);
	  },
	  'delete': function _delete(type) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].NotificationsApiController['delete'](type).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url);
	
	    NotificationsActions['delete'].promise(promise);
	  },
	  deleteCompleted: function deleteCompleted() {
	    this.list();
	  }
	});
	
	exports['default'] = NotificationsStore;
	module.exports = exports['default'];

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var PluginsStore = _reflux2['default'].createStore({
	  sourceUrl: function sourceUrl(nodeId) {
	    return '/cluster/' + nodeId + '/plugins';
	  },
	
	  list: function list(nodeId) {
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(nodeId))).then(function (response) {
	      return response.plugins;
	    }, function (error) {
	      return _utilUserNotification2['default'].error('Getting plugins on node "' + nodeId + '" failed: ' + error, 'Could not get plugins');
	    });
	
	    return promise;
	  }
	});
	
	exports['default'] = PluginsStore;
	module.exports = exports['default'];

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _qs = __webpack_require__(126);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _routingRoutes = __webpack_require__(11);
	
	var _routingRoutes2 = _interopRequireDefault(_routingRoutes);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var SavedSearchesActions = _injectionActionsProvider2['default'].getActions('SavedSearches');
	
	var SearchStore = _injectionStoreProvider2['default'].getStore('Search');
	
	var SavedSearchesStore = _reflux2['default'].createStore({
	  listenables: [SavedSearchesActions],
	  sourceUrl: '/search/saved',
	  savedSearches: undefined,
	
	  init: function init() {
	    this.trigger({ savedSearches: this.savedSearches });
	  },
	
	  list: function list() {
	    var _this = this;
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(_utilURLUtils2['default'].concatURLPath(this.sourceUrl))).then(function (response) {
	      _this.savedSearches = response.searches;
	      _this.trigger({ savedSearches: _this.savedSearches });
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Fetching saved searches failed with status: ' + error, 'Could not get saved searches');
	    });
	
	    SavedSearchesActions.list.promise(promise);
	  },
	
	  getSavedSearch: function getSavedSearch(searchId) {
	    var currentSavedSearch = undefined;
	    for (var i = 0; i < this.savedSearches.length && !currentSavedSearch; i++) {
	      if (this.savedSearches[i].id === searchId) {
	        currentSavedSearch = this.savedSearches[i];
	      }
	    }
	
	    return currentSavedSearch;
	  },
	
	  isValidTitle: function isValidTitle(searchId, title) {
	    for (var i = 0; i < this.savedSearches.length; i++) {
	      var savedSearch = this.savedSearches[i];
	      if (savedSearch.id !== searchId && savedSearch.title === title) {
	        return false;
	      }
	    }
	
	    return true;
	  },
	
	  execute: function execute(searchId, streamId, width) {
	    var savedSearch = this.getSavedSearch(searchId);
	    if (!savedSearch) {
	      // show notification
	      SavedSearchesActions.load.triggerPromise();
	      return;
	    }
	
	    var searchQuery = {
	      saved: searchId,
	      width: width
	    };
	    for (var paramName in savedSearch.query) {
	      if (Object.hasOwnProperty.call(savedSearch.query, paramName)) {
	        var effectiveParamName = paramName.toLowerCase() === 'query' ? 'q' : paramName.toLowerCase();
	        searchQuery[effectiveParamName] = savedSearch.query[paramName];
	      }
	    }
	
	    var url = undefined;
	    if (streamId) {
	      url = _routingRoutes2['default'].stream_search(streamId);
	    } else {
	      url = _routingRoutes2['default'].SEARCH;
	    }
	    url = url + '?' + _qs2['default'].stringify(searchQuery);
	    SearchStore.executeSearch(url);
	  },
	
	  _createOrUpdate: function _createOrUpdate(title, searchId) {
	    var originalSearchParams = SearchStore.getOriginalSearchParamsWithFields();
	    var queryParams = originalSearchParams.set('rangeType', originalSearchParams.get('range_type'))['delete']('range_type');
	    var params = { title: title, query: queryParams.toJS() };
	
	    var url = undefined;
	    var verb = undefined;
	
	    if (!searchId) {
	      url = _routingApiRoutes2['default'].SavedSearchesApiController.create().url;
	      verb = 'POST';
	    } else {
	      url = _routingApiRoutes2['default'].SavedSearchesApiController.update(searchId).url;
	      verb = 'PUT';
	    }
	
	    return (0, _logicRestFetchProvider2['default'])(verb, _utilURLUtils2['default'].qualifyUrl(url), JSON.stringify(params));
	  },
	
	  create: function create(title) {
	    var promise = this._createOrUpdate(title);
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Search criteria saved as "' + title + '".');
	      SavedSearchesActions.list.triggerPromise();
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Saving search criteria failed with status: ' + error, 'Could not save search criteria');
	    });
	
	    SavedSearchesActions.create.promise(promise);
	  },
	
	  update: function update(searchId, title) {
	    var promise = this._createOrUpdate(title, searchId);
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Saved search "' + title + '" was updated.');
	      SavedSearchesActions.list.triggerPromise();
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Updating saved search "' + title + '" failed with status: ' + error, 'Could not update saved search');
	    });
	
	    SavedSearchesActions.update.promise(promise);
	  },
	
	  'delete': function _delete(searchId) {
	    var _this2 = this;
	
	    var url = _routingApiRoutes2['default'].SavedSearchesApiController['delete'](searchId).url;
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', _utilURLUtils2['default'].qualifyUrl(url));
	    promise.then(function () {
	      _utilUserNotification2['default'].success('Saved search "' + _this2.savedSearches[searchId] + '" was deleted successfully.');
	      SearchStore.savedSearchDeleted(searchId);
	    })['catch'](function (error) {
	      _utilUserNotification2['default'].error('Deleting saved search "' + _this2.savedSearches[searchId] + '" failed with status: ' + error, 'Could not delete saved search');
	    });
	
	    SavedSearchesActions['delete'].promise(promise);
	  }
	});
	
	exports['default'] = SavedSearchesStore;
	module.exports = exports['default'];

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _jquery = __webpack_require__(13);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _md5 = __webpack_require__(630);
	
	var _md52 = _interopRequireDefault(_md5);
	
	var _logicGraphsHistogramFormatter = __webpack_require__(120);
	
	var _logicGraphsHistogramFormatter2 = _interopRequireDefault(_logicGraphsHistogramFormatter);
	
	var _logicMessageMessageFormatter = __webpack_require__(592);
	
	var _logicMessageMessageFormatter2 = _interopRequireDefault(_logicMessageMessageFormatter);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var UniversalSearchStore = _reflux2['default'].createStore({
	  DEFAULT_LIMIT: 150,
	  listenables: [],
	
	  search: function search(type, query, timerange, streamId, limit, page, sortField, sortOrder, decorate) {
	    var timerangeParams = UniversalSearchStore.extractTimeRange(type, timerange);
	    var effectiveLimit = limit || this.DEFAULT_LIMIT;
	    var offset = (page - 1) * effectiveLimit;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].UniversalSearchApiController.search(type, query, timerangeParams, streamId, effectiveLimit, offset, sortField, sortOrder, decorate).url);
	
	    return (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      var result = _jquery2['default'].extend({}, response);
	      result.fields = response.fields.map(function (field) {
	        return {
	          hash: (0, _md52['default'])(field),
	          name: field,
	          standard_selected: field === 'message' || field === 'source'
	        };
	      });
	
	      result.messages = result.messages.map(function (message) {
	        return _logicMessageMessageFormatter2['default'].formatMessageSummary(message);
	      });
	
	      return result;
	    });
	  },
	  histogram: function histogram(type, query, timerange, interval, streamId, maxDataPoints) {
	    var timerangeParams = UniversalSearchStore.extractTimeRange(type, timerange);
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].UniversalSearchApiController.histogram(type, query, interval, timerangeParams, streamId).url);
	
	    return (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      response.histogram_boundaries = response.queried_timerange;
	      response.histogram = _logicGraphsHistogramFormatter2['default'].format(response.results, response.histogram_boundaries, interval, maxDataPoints, type === 'relative' && timerange.relative === 0, null, true);
	      return response;
	    });
	  }
	});
	
	UniversalSearchStore.extractTimeRange = function (type, timerange) {
	  // The server API uses the `range` parameter instead of `relative` for indicating a relative time range.
	  if (type === 'relative') {
	    return { range: timerange.relative };
	  }
	
	  return timerange;
	};
	
	exports['default'] = UniversalSearchStore;
	module.exports = exports['default'];

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var ServerAvailabilityActions = _injectionActionsProvider2['default'].getActions('ServerAvailability');
	
	var ServerAvailabilityStore = _reflux2['default'].createStore({
	  listenables: [ServerAvailabilityActions],
	  server: { up: true },
	  init: function init() {
	    this.ping();
	  },
	  getInitialState: function getInitialState() {
	    return { server: this.server };
	  },
	  ping: function ping() {
	    return new _logicRestFetchProvider.Builder('GET', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ping().url))
	    // Make sure to request JSON to avoid a redirect which breaks in Firefox (see https://github.com/Graylog2/graylog2-server/issues/3312)
	    .setHeader('Accept', 'application/json').build().then(function () {
	      return ServerAvailabilityActions.reportSuccess();
	    }, function (error) {
	      return ServerAvailabilityActions.reportError(error);
	    });
	  },
	  reportError: function reportError(error) {
	    if (this.server.up) {
	      this.server = { up: false, error: error };
	      this.trigger({ server: this.server });
	    }
	  },
	  reportSuccess: function reportSuccess() {
	    if (!this.server.up) {
	      this.server = { up: true };
	      this.trigger({ server: this.server });
	    }
	  }
	});
	
	exports['default'] = ServerAvailabilityStore;
	module.exports = exports['default'];

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _logicLocalStorageStore = __webpack_require__(591);
	
	var _logicLocalStorageStore2 = _interopRequireDefault(_logicLocalStorageStore);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var SessionActions = _injectionActionsProvider2['default'].getActions('Session');
	
	var SessionStore = _reflux2['default'].createStore({
	  listenables: [SessionActions],
	  sourceUrl: '/system/sessions',
	  sessionId: undefined,
	  username: undefined,
	  validatingSession: false,
	
	  init: function init() {
	    this.validate();
	  },
	  getInitialState: function getInitialState() {
	    return this.getSessionInfo();
	  },
	
	  login: function login(username, password, host) {
	    var builder = new _logicRestFetchProvider.Builder('POST', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl)).json({ username: username, password: password, host: host });
	    var promise = builder.build().then(function (sessionInfo) {
	      return { sessionId: sessionInfo.session_id, username: username };
	    });
	
	    SessionActions.login.promise(promise);
	  },
	  logout: function logout(sessionId) {
	    var _this = this;
	
	    var promise = new _logicRestFetchProvider.Builder('DELETE', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + sessionId)).authenticated().build().then(function (resp) {
	      if (resp.ok || resp.status === 401) {
	        _this._removeSession();
	      }
	    }, this._removeSession);
	
	    SessionActions.logout.promise(promise);
	  },
	
	  validate: function validate() {
	    var _this2 = this;
	
	    var sessionId = _logicLocalStorageStore2['default'].get('sessionId');
	    var username = _logicLocalStorageStore2['default'].get('username');
	    this.validatingSession = true;
	    this._propagateState();
	    this._validateSession(sessionId).then(function (response) {
	      if (response.is_valid) {
	        SessionActions.login.completed({
	          sessionId: sessionId || response.session_id,
	          username: username || response.username
	        });
	      } else {
	        _this2._removeSession();
	      }
	    })['finally'](function () {
	      _this2.validatingSession = false;
	      _this2._propagateState();
	    });
	  },
	  _validateSession: function _validateSession(sessionId) {
	    return new _logicRestFetchProvider.Builder('GET', _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SessionsApiController.validate().url)).session(sessionId).json().build();
	  },
	
	  _removeSession: function _removeSession() {
	    _logicLocalStorageStore2['default']['delete']('sessionId');
	    _logicLocalStorageStore2['default']['delete']('username');
	    this.sessionId = undefined;
	    this.username = undefined;
	    this._propagateState();
	  },
	
	  _propagateState: function _propagateState() {
	    this.trigger(this.getSessionInfo());
	  },
	
	  loginCompleted: function loginCompleted(sessionInfo) {
	    _logicLocalStorageStore2['default'].set('sessionId', sessionInfo.sessionId);
	    _logicLocalStorageStore2['default'].set('username', sessionInfo.username);
	    this.sessionId = sessionInfo.sessionId;
	    this.username = sessionInfo.username;
	    this._propagateState();
	  },
	  isLoggedIn: function isLoggedIn() {
	    return this.sessionId !== undefined && this.sessionId !== null;
	  },
	  getSessionId: function getSessionId() {
	    return this.sessionId;
	  },
	  getSessionInfo: function getSessionInfo() {
	    return { sessionId: this.sessionId, username: this.username, validatingSession: this.validatingSession };
	  }
	});
	
	exports['default'] = SessionStore;
	module.exports = exports['default'];

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _urijs = __webpack_require__(51);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var _logicGraphsHistogramFormatter = __webpack_require__(120);
	
	var _logicGraphsHistogramFormatter2 = _interopRequireDefault(_logicGraphsHistogramFormatter);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var HistogramDataActions = _injectionActionsProvider2['default'].getActions('HistogramData');
	
	var HistogramDataStore = _reflux2['default'].createStore({
	  listenables: [HistogramDataActions],
	  sourceUrl: '/search/universal/relative/histogram',
	  histogram: undefined,
	
	  getInitialState: function getInitialState() {
	    return { histogram: this.histogram };
	  },
	
	  load: function load(range, sourceNames, maxDataPoints) {
	    var url = (0, _urijs2['default'])(_utilURLUtils2['default'].qualifyUrl(this.sourceUrl));
	    var urlQuery = {};
	
	    if (typeof sourceNames !== 'undefined' && sourceNames instanceof Array) {
	      urlQuery.query = sourceNames.map(function (source) {
	        return 'source:' + source;
	      }).join(' OR ');
	    } else {
	      urlQuery.query = '*';
	    }
	
	    var interval = 'minute';
	    var rangeAsNumber = Number(range);
	    if (rangeAsNumber >= 365 * 24 * 60 * 60 || rangeAsNumber === 0) {
	      // for years and all interval will be day
	      interval = 'day';
	    } else if (rangeAsNumber >= 31 * 24 * 60 * 60) {
	      // for months interval will be hour
	      interval = 'hour';
	    }
	
	    urlQuery.range = range;
	    urlQuery.interval = interval;
	
	    url.query(urlQuery);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url.toString()).then(function (response) {
	      response.histogram = _logicGraphsHistogramFormatter2['default'].format(response.results, response.queried_timerange, interval, maxDataPoints, rangeAsNumber === 0, null);
	      return response;
	    }, function (error) {
	      _utilUserNotification2['default'].warning('Loading of histogram data failed with status: ' + error, 'Could not load histogram data');
	    });
	
	    HistogramDataActions.load.promise(promise);
	  }
	});
	
	exports['default'] = HistogramDataStore;
	module.exports = exports['default'];

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var SystemProcessingStore = _reflux2['default'].createStore({
	  sourceUrl: function sourceUrl(nodeId) {
	    return '/cluster/' + nodeId + '/processing';
	  },
	
	  pause: function pause(nodeId) {
	    var _this = this;
	
	    return (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(nodeId) + '/pause')).then(function () {
	      _this.trigger({});
	      _utilUserNotification2['default'].success('Message processing paused successfully in \'' + nodeId + '\'');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Pausing message processing in \'' + nodeId + '\' failed: ' + error, 'Could not pause message processing in node \'' + nodeId + '\'');
	    });
	  },
	
	  resume: function resume(nodeId) {
	    var _this2 = this;
	
	    return (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(nodeId) + '/resume')).then(function () {
	      _this2.trigger({});
	      _utilUserNotification2['default'].success('Message processing resumed successfully in \'' + nodeId + '\'');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Resuming message processing in \'' + nodeId + '\' failed: ' + error, 'Could not resume message processing in node \'' + nodeId + '\'');
	    });
	  }
	});
	
	exports['default'] = SystemProcessingStore;
	module.exports = exports['default'];

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var SystemShutdownStore = _reflux2['default'].createStore({
	  sourceUrl: function sourceUrl(nodeId) {
	    return '/cluster/' + nodeId + '/shutdown';
	  },
	
	  shutdown: function shutdown(nodeId) {
	    var _this = this;
	
	    return (0, _logicRestFetchProvider2['default'])('POST', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(nodeId))).then(function () {
	      _this.trigger({});
	      _utilUserNotification2['default'].success('Node \'' + nodeId + '\' will shutdown shortly');
	    }, function (error) {
	      _utilUserNotification2['default'].error('Shutting down node \'' + nodeId + '\' failed: ' + error, 'Could not send shutdown signal to node \'' + nodeId + '\'');
	    });
	  }
	});
	
	exports['default'] = SystemShutdownStore;
	module.exports = exports['default'];

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var LoggersActions = _injectionActionsProvider2['default'].getActions('Loggers');
	
	var LoggersStore = _reflux2['default'].createStore({
	  listenables: [LoggersActions],
	  state: {
	    availableLoglevels: ['fatal', 'error', 'warn', 'info', 'debug', 'trace']
	  },
	  init: function init() {
	    this.loggers();
	    this.subsystems();
	  },
	  getInitialState: function getInitialState() {
	    return this.state;
	  },
	  loggers: function loggers() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterLoggersResource.loggers().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this.state.loggers = response;
	      _this.trigger(_this.state);
	      return response;
	    });
	
	    LoggersActions.loggers.promise(promise);
	  },
	  subsystems: function subsystems() {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterLoggersResource.subsystems().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this2.state.subsystems = response;
	      _this2.trigger(_this2.state);
	      return response;
	    });
	
	    LoggersActions.loggers.promise(promise);
	  },
	  setSubsystemLoggerLevel: function setSubsystemLoggerLevel(nodeId, subsystem, level) {
	    var _this3 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].ClusterLoggersResource.setSubsystemLoggerLevel(nodeId, subsystem, level).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url);
	    promise.then(function () {
	      _this3.init();
	    });
	
	    LoggersActions.setSubsystemLoggerLevel.promise(promise);
	  }
	});
	
	exports['default'] = LoggersStore;
	module.exports = exports['default'];

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var SystemStore = _reflux2['default'].createStore({
	  system: undefined,
	  init: function init() {
	    var _this = this;
	
	    this.info().then(function (response) {
	      _this.trigger({ system: response });
	      _this.system = response;
	    });
	  },
	  getInitialState: function getInitialState() {
	    return { system: this.system };
	  },
	  info: function info() {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SystemApiController.info().url);
	
	    return (0, _logicRestFetchProvider2['default'])('GET', url);
	  },
	  jvm: function jvm() {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SystemApiController.jvm().url);
	
	    return (0, _logicRestFetchProvider2['default'])('GET', url);
	  }
	});
	
	exports['default'] = SystemStore;
	module.exports = exports['default'];

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var SystemJobsActions = _injectionActionsProvider2['default'].getActions('SystemJobs');
	
	var SystemJobsStore = _reflux2['default'].createStore({
	  listenables: [SystemJobsActions],
	
	  jobsById: {},
	
	  getInitialState: function getInitialState() {
	    return { jobs: this.jobs, jobsById: this.jobsById };
	  },
	  list: function list() {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SystemJobsApiController.list().url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this.jobs = response;
	      _this.trigger({ jobs: response });
	
	      return response;
	    });
	    SystemJobsActions.list.promise(promise);
	  },
	  getJob: function getJob(jobId) {
	    var _this2 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SystemJobsApiController.getJob(jobId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url).then(function (response) {
	      _this2.jobsById[response.id] = response;
	      _this2.trigger({ jobsById: _this2.jobsById });
	
	      return response;
	    }, function () {
	      // If we get an error (probably 404 because the job is gone), remove the job from the cache and trigger an update.
	      delete _this2.jobsById[jobId];
	      _this2.trigger({ jobsById: _this2.jobsById });
	    });
	    SystemJobsActions.getJob.promise(promise);
	  },
	  cancelJob: function cancelJob(jobId) {
	    var _this3 = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SystemJobsApiController.cancelJob(jobId).url);
	    var promise = (0, _logicRestFetchProvider2['default'])('DELETE', url).then(function (response) {
	      delete _this3.jobsById[response.id];
	    });
	
	    SystemJobsActions.cancelJob.promise(promise);
	  }
	});
	
	exports['default'] = SystemJobsStore;
	module.exports = exports['default'];

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _routingApiRoutes = __webpack_require__(15);
	
	var _routingApiRoutes2 = _interopRequireDefault(_routingApiRoutes);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var SystemMessagesStore = _reflux2['default'].createStore({
	  listenables: [],
	
	  all: function all(page) {
	    var url = _utilURLUtils2['default'].qualifyUrl(_routingApiRoutes2['default'].SystemMessagesApiController.all(page).url);
	
	    var promise = (0, _logicRestFetchProvider2['default'])('GET', url);
	    return promise;
	  }
	});
	
	exports['default'] = SystemMessagesStore;
	module.exports = exports['default'];

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _jquery = __webpack_require__(13);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var FocusStore = _reflux2['default'].createStore({
	  focus: true,
	  init: function init() {
	    var _this = this;
	
	    (0, _jquery2['default'])(window).blur(function () {
	      _this.trigger({ focus: false });_this.focus = false;
	    });
	    (0, _jquery2['default'])(window).focus(function () {
	      _this.trigger({ focus: true });_this.focus = true;
	    });
	  },
	  getInitialState: function getInitialState() {
	    return { focus: this.focus };
	  }
	});
	
	exports['default'] = FocusStore;
	module.exports = exports['default'];

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var RefreshActions = _injectionActionsProvider2['default'].getActions('Refresh');
	
	var RefreshStore = _reflux2['default'].createStore({
	  listenables: [RefreshActions],
	  interval: 5 * 1000,
	  enabled: false,
	
	  getInitialState: function getInitialState() {
	    return {
	      interval: this.interval,
	      enabled: this.enabled
	    };
	  },
	
	  changeInterval: function changeInterval(newValue) {
	    this.interval = newValue;
	    this._update();
	  },
	
	  disable: function disable() {
	    this.enabled = false;
	    this._update();
	  },
	
	  enable: function enable() {
	    this.enabled = true;
	    this._update();
	  },
	
	  _update: function _update() {
	    this.trigger(this.getInitialState());
	  }
	});
	
	exports['default'] = RefreshStore;
	module.exports = exports['default'];

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var _injectionStoreProvider = __webpack_require__(3);
	
	var _injectionStoreProvider2 = _interopRequireDefault(_injectionStoreProvider);
	
	var _injectionActionsProvider = __webpack_require__(6);
	
	var _injectionActionsProvider2 = _interopRequireDefault(_injectionActionsProvider);
	
	var SessionStore = _injectionStoreProvider2['default'].getStore('Session');
	var StartpageStore = _injectionStoreProvider2['default'].getStore('Startpage');
	
	var SessionActions = _injectionActionsProvider2['default'].getActions('Session');
	
	var CurrentUserStore = _reflux2['default'].createStore({
	  listenables: [SessionActions],
	  sourceUrl: '/users',
	  currentUser: undefined,
	
	  init: function init() {
	    this.listenTo(SessionStore, this.sessionUpdate, this.sessionUpdate);
	    this.listenTo(StartpageStore, this.reload, this.reload);
	  },
	
	  getInitialState: function getInitialState() {
	    return { currentUser: this.currentUser };
	  },
	
	  get: function get() {
	    return this.currentUser;
	  },
	
	  sessionUpdate: function sessionUpdate(sessionInfo) {
	    if (sessionInfo.sessionId && sessionInfo.username) {
	      var username = sessionInfo.username;
	      this.update(username);
	    } else {
	      this.currentUser = undefined;
	      this.trigger({ currentUser: this.currentUser });
	    }
	  },
	
	  reload: function reload() {
	    if (this.currentUser !== undefined) {
	      this.update(this.currentUser.username);
	    }
	  },
	
	  update: function update(username) {
	    var _this = this;
	
	    (0, _logicRestFetchProvider2['default'])('GET', _utilURLUtils2['default'].qualifyUrl(this.sourceUrl + '/' + username)).then(function (resp) {
	      _this.currentUser = resp;
	      _this.trigger({ currentUser: _this.currentUser });
	    });
	  }
	});
	
	exports['default'] = CurrentUserStore;
	module.exports = exports['default'];

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(4);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _utilUserNotification = __webpack_require__(7);
	
	var _utilUserNotification2 = _interopRequireDefault(_utilUserNotification);
	
	var _utilURLUtils = __webpack_require__(9);
	
	var _utilURLUtils2 = _interopRequireDefault(_utilURLUtils);
	
	var _logicRestFetchProvider = __webpack_require__(10);
	
	var _logicRestFetchProvider2 = _interopRequireDefault(_logicRestFetchProvider);
	
	var StartpageStore = _reflux2['default'].createStore({
	  listenables: [],
	  sourceUrl: function sourceUrl(username) {
	    return '/users/' + username;
	  },
	
	  set: function set(username, type, id) {
	    var _this = this;
	
	    var url = _utilURLUtils2['default'].qualifyUrl(this.sourceUrl(username));
	    var payload = {};
	    if (type && id) {
	      payload.type = type;
	      payload.id = id;
	    }
	    var promise = (0, _logicRestFetchProvider2['default'])('PUT', url, { startpage: payload }).then(function () {
	      _this.trigger();
	      _utilUserNotification2['default'].success('Your start page was changed successfully');
	    }, function (error) {
	      return _utilUserNotification2['default'].error('Changing your start page failed with error: ' + error, 'Could not change your start page');
	    });
	
	    return promise;
	  }
	});
	
	exports['default'] = StartpageStore;
	module.exports = exports['default'];

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var MomentUtils = {
	  startOfResolution: function startOfResolution(dateTime, resolution) {
	    var effectiveResolution = resolution;
	    if (resolution === 'week') {
	      effectiveResolution = 'isoWeek'; // Weeks should start on Monday :)
	    }
	
	    return (0, _moment2['default'])(dateTime).startOf(effectiveResolution);
	  }
	};
	
	exports['default'] = MomentUtils;
	module.exports = exports['default'];

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _urijs = __webpack_require__(51);
	
	var _urijs2 = _interopRequireDefault(_urijs);
	
	var _utilAppConfig = __webpack_require__(153);
	
	var _utilAppConfig2 = _interopRequireDefault(_utilAppConfig);
	
	// The webpack-dev-server serves the assets from "/"
	var assetPrefix = _utilAppConfig2['default'].gl2DevMode() ? '/' : '/assets/';
	
	// If app prefix was not set, we need to tell webpack to load chunks from root instead of the relative URL path
	// eslint-disable-next-line camelcase, no-undef
	__webpack_require__.p = _urijs2['default'].joinPaths(_utilAppConfig2['default'].gl2AppPathPrefix(), assetPrefix).path() || assetPrefix;

/***/ },
/* 1005 */,
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */
/***/ function(module, exports) {

	(function(exports){
	crossfilter.version = "1.3.12";
	function crossfilter_identity(d) {
	  return d;
	}
	crossfilter.permute = permute;
	
	function permute(array, index) {
	  for (var i = 0, n = index.length, copy = new Array(n); i < n; ++i) {
	    copy[i] = array[index[i]];
	  }
	  return copy;
	}
	var bisect = crossfilter.bisect = bisect_by(crossfilter_identity);
	
	bisect.by = bisect_by;
	
	function bisect_by(f) {
	
	  // Locate the insertion point for x in a to maintain sorted order. The
	  // arguments lo and hi may be used to specify a subset of the array which
	  // should be considered; by default the entire array is used. If x is already
	  // present in a, the insertion point will be before (to the left of) any
	  // existing entries. The return value is suitable for use as the first
	  // argument to `array.splice` assuming that a is already sorted.
	  //
	  // The returned insertion point i partitions the array a into two halves so
	  // that all v < x for v in a[lo:i] for the left side and all v >= x for v in
	  // a[i:hi] for the right side.
	  function bisectLeft(a, x, lo, hi) {
	    while (lo < hi) {
	      var mid = lo + hi >>> 1;
	      if (f(a[mid]) < x) lo = mid + 1;
	      else hi = mid;
	    }
	    return lo;
	  }
	
	  // Similar to bisectLeft, but returns an insertion point which comes after (to
	  // the right of) any existing entries of x in a.
	  //
	  // The returned insertion point i partitions the array into two halves so that
	  // all v <= x for v in a[lo:i] for the left side and all v > x for v in
	  // a[i:hi] for the right side.
	  function bisectRight(a, x, lo, hi) {
	    while (lo < hi) {
	      var mid = lo + hi >>> 1;
	      if (x < f(a[mid])) hi = mid;
	      else lo = mid + 1;
	    }
	    return lo;
	  }
	
	  bisectRight.right = bisectRight;
	  bisectRight.left = bisectLeft;
	  return bisectRight;
	}
	var heap = crossfilter.heap = heap_by(crossfilter_identity);
	
	heap.by = heap_by;
	
	function heap_by(f) {
	
	  // Builds a binary heap within the specified array a[lo:hi]. The heap has the
	  // property such that the parent a[lo+i] is always less than or equal to its
	  // two children: a[lo+2*i+1] and a[lo+2*i+2].
	  function heap(a, lo, hi) {
	    var n = hi - lo,
	        i = (n >>> 1) + 1;
	    while (--i > 0) sift(a, i, n, lo);
	    return a;
	  }
	
	  // Sorts the specified array a[lo:hi] in descending order, assuming it is
	  // already a heap.
	  function sort(a, lo, hi) {
	    var n = hi - lo,
	        t;
	    while (--n > 0) t = a[lo], a[lo] = a[lo + n], a[lo + n] = t, sift(a, 1, n, lo);
	    return a;
	  }
	
	  // Sifts the element a[lo+i-1] down the heap, where the heap is the contiguous
	  // slice of array a[lo:lo+n]. This method can also be used to update the heap
	  // incrementally, without incurring the full cost of reconstructing the heap.
	  function sift(a, i, n, lo) {
	    var d = a[--lo + i],
	        x = f(d),
	        child;
	    while ((child = i << 1) <= n) {
	      if (child < n && f(a[lo + child]) > f(a[lo + child + 1])) child++;
	      if (x <= f(a[lo + child])) break;
	      a[lo + i] = a[lo + child];
	      i = child;
	    }
	    a[lo + i] = d;
	  }
	
	  heap.sort = sort;
	  return heap;
	}
	var heapselect = crossfilter.heapselect = heapselect_by(crossfilter_identity);
	
	heapselect.by = heapselect_by;
	
	function heapselect_by(f) {
	  var heap = heap_by(f);
	
	  // Returns a new array containing the top k elements in the array a[lo:hi].
	  // The returned array is not sorted, but maintains the heap property. If k is
	  // greater than hi - lo, then fewer than k elements will be returned. The
	  // order of elements in a is unchanged by this operation.
	  function heapselect(a, lo, hi, k) {
	    var queue = new Array(k = Math.min(hi - lo, k)),
	        min,
	        i,
	        x,
	        d;
	
	    for (i = 0; i < k; ++i) queue[i] = a[lo++];
	    heap(queue, 0, k);
	
	    if (lo < hi) {
	      min = f(queue[0]);
	      do {
	        if (x = f(d = a[lo]) > min) {
	          queue[0] = d;
	          min = f(heap(queue, 0, k)[0]);
	        }
	      } while (++lo < hi);
	    }
	
	    return queue;
	  }
	
	  return heapselect;
	}
	var insertionsort = crossfilter.insertionsort = insertionsort_by(crossfilter_identity);
	
	insertionsort.by = insertionsort_by;
	
	function insertionsort_by(f) {
	
	  function insertionsort(a, lo, hi) {
	    for (var i = lo + 1; i < hi; ++i) {
	      for (var j = i, t = a[i], x = f(t); j > lo && f(a[j - 1]) > x; --j) {
	        a[j] = a[j - 1];
	      }
	      a[j] = t;
	    }
	    return a;
	  }
	
	  return insertionsort;
	}
	// Algorithm designed by Vladimir Yaroslavskiy.
	// Implementation based on the Dart project; see lib/dart/LICENSE for details.
	
	var quicksort = crossfilter.quicksort = quicksort_by(crossfilter_identity);
	
	quicksort.by = quicksort_by;
	
	function quicksort_by(f) {
	  var insertionsort = insertionsort_by(f);
	
	  function sort(a, lo, hi) {
	    return (hi - lo < quicksort_sizeThreshold
	        ? insertionsort
	        : quicksort)(a, lo, hi);
	  }
	
	  function quicksort(a, lo, hi) {
	    // Compute the two pivots by looking at 5 elements.
	    var sixth = (hi - lo) / 6 | 0,
	        i1 = lo + sixth,
	        i5 = hi - 1 - sixth,
	        i3 = lo + hi - 1 >> 1,  // The midpoint.
	        i2 = i3 - sixth,
	        i4 = i3 + sixth;
	
	    var e1 = a[i1], x1 = f(e1),
	        e2 = a[i2], x2 = f(e2),
	        e3 = a[i3], x3 = f(e3),
	        e4 = a[i4], x4 = f(e4),
	        e5 = a[i5], x5 = f(e5);
	
	    var t;
	
	    // Sort the selected 5 elements using a sorting network.
	    if (x1 > x2) t = e1, e1 = e2, e2 = t, t = x1, x1 = x2, x2 = t;
	    if (x4 > x5) t = e4, e4 = e5, e5 = t, t = x4, x4 = x5, x5 = t;
	    if (x1 > x3) t = e1, e1 = e3, e3 = t, t = x1, x1 = x3, x3 = t;
	    if (x2 > x3) t = e2, e2 = e3, e3 = t, t = x2, x2 = x3, x3 = t;
	    if (x1 > x4) t = e1, e1 = e4, e4 = t, t = x1, x1 = x4, x4 = t;
	    if (x3 > x4) t = e3, e3 = e4, e4 = t, t = x3, x3 = x4, x4 = t;
	    if (x2 > x5) t = e2, e2 = e5, e5 = t, t = x2, x2 = x5, x5 = t;
	    if (x2 > x3) t = e2, e2 = e3, e3 = t, t = x2, x2 = x3, x3 = t;
	    if (x4 > x5) t = e4, e4 = e5, e5 = t, t = x4, x4 = x5, x5 = t;
	
	    var pivot1 = e2, pivotValue1 = x2,
	        pivot2 = e4, pivotValue2 = x4;
	
	    // e2 and e4 have been saved in the pivot variables. They will be written
	    // back, once the partitioning is finished.
	    a[i1] = e1;
	    a[i2] = a[lo];
	    a[i3] = e3;
	    a[i4] = a[hi - 1];
	    a[i5] = e5;
	
	    var less = lo + 1,   // First element in the middle partition.
	        great = hi - 2;  // Last element in the middle partition.
	
	    // Note that for value comparison, <, <=, >= and > coerce to a primitive via
	    // Object.prototype.valueOf; == and === do not, so in order to be consistent
	    // with natural order (such as for Date objects), we must do two compares.
	    var pivotsEqual = pivotValue1 <= pivotValue2 && pivotValue1 >= pivotValue2;
	    if (pivotsEqual) {
	
	      // Degenerated case where the partitioning becomes a dutch national flag
	      // problem.
	      //
	      // [ |  < pivot  | == pivot | unpartitioned | > pivot  | ]
	      //  ^             ^          ^             ^            ^
	      // left         less         k           great         right
	      //
	      // a[left] and a[right] are undefined and are filled after the
	      // partitioning.
	      //
	      // Invariants:
	      //   1) for x in ]left, less[ : x < pivot.
	      //   2) for x in [less, k[ : x == pivot.
	      //   3) for x in ]great, right[ : x > pivot.
	      for (var k = less; k <= great; ++k) {
	        var ek = a[k], xk = f(ek);
	        if (xk < pivotValue1) {
	          if (k !== less) {
	            a[k] = a[less];
	            a[less] = ek;
	          }
	          ++less;
	        } else if (xk > pivotValue1) {
	
	          // Find the first element <= pivot in the range [k - 1, great] and
	          // put [:ek:] there. We know that such an element must exist:
	          // When k == less, then el3 (which is equal to pivot) lies in the
	          // interval. Otherwise a[k - 1] == pivot and the search stops at k-1.
	          // Note that in the latter case invariant 2 will be violated for a
	          // short amount of time. The invariant will be restored when the
	          // pivots are put into their final positions.
	          while (true) {
	            var greatValue = f(a[great]);
	            if (greatValue > pivotValue1) {
	              great--;
	              // This is the only location in the while-loop where a new
	              // iteration is started.
	              continue;
	            } else if (greatValue < pivotValue1) {
	              // Triple exchange.
	              a[k] = a[less];
	              a[less++] = a[great];
	              a[great--] = ek;
	              break;
	            } else {
	              a[k] = a[great];
	              a[great--] = ek;
	              // Note: if great < k then we will exit the outer loop and fix
	              // invariant 2 (which we just violated).
	              break;
	            }
	          }
	        }
	      }
	    } else {
	
	      // We partition the list into three parts:
	      //  1. < pivot1
	      //  2. >= pivot1 && <= pivot2
	      //  3. > pivot2
	      //
	      // During the loop we have:
	      // [ | < pivot1 | >= pivot1 && <= pivot2 | unpartitioned  | > pivot2  | ]
	      //  ^            ^                        ^              ^             ^
	      // left         less                     k              great        right
	      //
	      // a[left] and a[right] are undefined and are filled after the
	      // partitioning.
	      //
	      // Invariants:
	      //   1. for x in ]left, less[ : x < pivot1
	      //   2. for x in [less, k[ : pivot1 <= x && x <= pivot2
	      //   3. for x in ]great, right[ : x > pivot2
	      for (var k = less; k <= great; k++) {
	        var ek = a[k], xk = f(ek);
	        if (xk < pivotValue1) {
	          if (k !== less) {
	            a[k] = a[less];
	            a[less] = ek;
	          }
	          ++less;
	        } else {
	          if (xk > pivotValue2) {
	            while (true) {
	              var greatValue = f(a[great]);
	              if (greatValue > pivotValue2) {
	                great--;
	                if (great < k) break;
	                // This is the only location inside the loop where a new
	                // iteration is started.
	                continue;
	              } else {
	                // a[great] <= pivot2.
	                if (greatValue < pivotValue1) {
	                  // Triple exchange.
	                  a[k] = a[less];
	                  a[less++] = a[great];
	                  a[great--] = ek;
	                } else {
	                  // a[great] >= pivot1.
	                  a[k] = a[great];
	                  a[great--] = ek;
	                }
	                break;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    // Move pivots into their final positions.
	    // We shrunk the list from both sides (a[left] and a[right] have
	    // meaningless values in them) and now we move elements from the first
	    // and third partition into these locations so that we can store the
	    // pivots.
	    a[lo] = a[less - 1];
	    a[less - 1] = pivot1;
	    a[hi - 1] = a[great + 1];
	    a[great + 1] = pivot2;
	
	    // The list is now partitioned into three partitions:
	    // [ < pivot1   | >= pivot1 && <= pivot2   |  > pivot2   ]
	    //  ^            ^                        ^             ^
	    // left         less                     great        right
	
	    // Recursive descent. (Don't include the pivot values.)
	    sort(a, lo, less - 1);
	    sort(a, great + 2, hi);
	
	    if (pivotsEqual) {
	      // All elements in the second partition are equal to the pivot. No
	      // need to sort them.
	      return a;
	    }
	
	    // In theory it should be enough to call _doSort recursively on the second
	    // partition.
	    // The Android source however removes the pivot elements from the recursive
	    // call if the second partition is too large (more than 2/3 of the list).
	    if (less < i1 && great > i5) {
	      var lessValue, greatValue;
	      while ((lessValue = f(a[less])) <= pivotValue1 && lessValue >= pivotValue1) ++less;
	      while ((greatValue = f(a[great])) <= pivotValue2 && greatValue >= pivotValue2) --great;
	
	      // Copy paste of the previous 3-way partitioning with adaptions.
	      //
	      // We partition the list into three parts:
	      //  1. == pivot1
	      //  2. > pivot1 && < pivot2
	      //  3. == pivot2
	      //
	      // During the loop we have:
	      // [ == pivot1 | > pivot1 && < pivot2 | unpartitioned  | == pivot2 ]
	      //              ^                      ^              ^
	      //            less                     k              great
	      //
	      // Invariants:
	      //   1. for x in [ *, less[ : x == pivot1
	      //   2. for x in [less, k[ : pivot1 < x && x < pivot2
	      //   3. for x in ]great, * ] : x == pivot2
	      for (var k = less; k <= great; k++) {
	        var ek = a[k], xk = f(ek);
	        if (xk <= pivotValue1 && xk >= pivotValue1) {
	          if (k !== less) {
	            a[k] = a[less];
	            a[less] = ek;
	          }
	          less++;
	        } else {
	          if (xk <= pivotValue2 && xk >= pivotValue2) {
	            while (true) {
	              var greatValue = f(a[great]);
	              if (greatValue <= pivotValue2 && greatValue >= pivotValue2) {
	                great--;
	                if (great < k) break;
	                // This is the only location inside the loop where a new
	                // iteration is started.
	                continue;
	              } else {
	                // a[great] < pivot2.
	                if (greatValue < pivotValue1) {
	                  // Triple exchange.
	                  a[k] = a[less];
	                  a[less++] = a[great];
	                  a[great--] = ek;
	                } else {
	                  // a[great] == pivot1.
	                  a[k] = a[great];
	                  a[great--] = ek;
	                }
	                break;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    // The second partition has now been cleared of pivot elements and looks
	    // as follows:
	    // [  *  |  > pivot1 && < pivot2  | * ]
	    //        ^                      ^
	    //       less                  great
	    // Sort the second partition using recursive descent.
	
	    // The second partition looks as follows:
	    // [  *  |  >= pivot1 && <= pivot2  | * ]
	    //        ^                        ^
	    //       less                    great
	    // Simply sort it by recursive descent.
	
	    return sort(a, less, great + 1);
	  }
	
	  return sort;
	}
	
	var quicksort_sizeThreshold = 32;
	var crossfilter_array8 = crossfilter_arrayUntyped,
	    crossfilter_array16 = crossfilter_arrayUntyped,
	    crossfilter_array32 = crossfilter_arrayUntyped,
	    crossfilter_arrayLengthen = crossfilter_arrayLengthenUntyped,
	    crossfilter_arrayWiden = crossfilter_arrayWidenUntyped;
	
	if (typeof Uint8Array !== "undefined") {
	  crossfilter_array8 = function(n) { return new Uint8Array(n); };
	  crossfilter_array16 = function(n) { return new Uint16Array(n); };
	  crossfilter_array32 = function(n) { return new Uint32Array(n); };
	
	  crossfilter_arrayLengthen = function(array, length) {
	    if (array.length >= length) return array;
	    var copy = new array.constructor(length);
	    copy.set(array);
	    return copy;
	  };
	
	  crossfilter_arrayWiden = function(array, width) {
	    var copy;
	    switch (width) {
	      case 16: copy = crossfilter_array16(array.length); break;
	      case 32: copy = crossfilter_array32(array.length); break;
	      default: throw new Error("invalid array width!");
	    }
	    copy.set(array);
	    return copy;
	  };
	}
	
	function crossfilter_arrayUntyped(n) {
	  var array = new Array(n), i = -1;
	  while (++i < n) array[i] = 0;
	  return array;
	}
	
	function crossfilter_arrayLengthenUntyped(array, length) {
	  var n = array.length;
	  while (n < length) array[n++] = 0;
	  return array;
	}
	
	function crossfilter_arrayWidenUntyped(array, width) {
	  if (width > 32) throw new Error("invalid array width!");
	  return array;
	}
	function crossfilter_filterExact(bisect, value) {
	  return function(values) {
	    var n = values.length;
	    return [bisect.left(values, value, 0, n), bisect.right(values, value, 0, n)];
	  };
	}
	
	function crossfilter_filterRange(bisect, range) {
	  var min = range[0],
	      max = range[1];
	  return function(values) {
	    var n = values.length;
	    return [bisect.left(values, min, 0, n), bisect.left(values, max, 0, n)];
	  };
	}
	
	function crossfilter_filterAll(values) {
	  return [0, values.length];
	}
	function crossfilter_null() {
	  return null;
	}
	function crossfilter_zero() {
	  return 0;
	}
	function crossfilter_reduceIncrement(p) {
	  return p + 1;
	}
	
	function crossfilter_reduceDecrement(p) {
	  return p - 1;
	}
	
	function crossfilter_reduceAdd(f) {
	  return function(p, v) {
	    return p + +f(v);
	  };
	}
	
	function crossfilter_reduceSubtract(f) {
	  return function(p, v) {
	    return p - f(v);
	  };
	}
	exports.crossfilter = crossfilter;
	
	function crossfilter() {
	  var crossfilter = {
	    add: add,
	    remove: removeData,
	    dimension: dimension,
	    groupAll: groupAll,
	    size: size
	  };
	
	  var data = [], // the records
	      n = 0, // the number of records; data.length
	      m = 0, // a bit mask representing which dimensions are in use
	      M = 8, // number of dimensions that can fit in `filters`
	      filters = crossfilter_array8(0), // M bits per record; 1 is filtered out
	      filterListeners = [], // when the filters change
	      dataListeners = [], // when data is added
	      removeDataListeners = []; // when data is removed
	
	  // Adds the specified new records to this crossfilter.
	  function add(newData) {
	    var n0 = n,
	        n1 = newData.length;
	
	    // If there's actually new data to add…
	    // Merge the new data into the existing data.
	    // Lengthen the filter bitset to handle the new records.
	    // Notify listeners (dimensions and groups) that new data is available.
	    if (n1) {
	      data = data.concat(newData);
	      filters = crossfilter_arrayLengthen(filters, n += n1);
	      dataListeners.forEach(function(l) { l(newData, n0, n1); });
	    }
	
	    return crossfilter;
	  }
	
	  // Removes all records that match the current filters.
	  function removeData() {
	    var newIndex = crossfilter_index(n, n),
	        removed = [];
	    for (var i = 0, j = 0; i < n; ++i) {
	      if (filters[i]) newIndex[i] = j++;
	      else removed.push(i);
	    }
	
	    // Remove all matching records from groups.
	    filterListeners.forEach(function(l) { l(0, [], removed); });
	
	    // Update indexes.
	    removeDataListeners.forEach(function(l) { l(newIndex); });
	
	    // Remove old filters and data by overwriting.
	    for (var i = 0, j = 0, k; i < n; ++i) {
	      if (k = filters[i]) {
	        if (i !== j) filters[j] = k, data[j] = data[i];
	        ++j;
	      }
	    }
	    data.length = j;
	    while (n > j) filters[--n] = 0;
	  }
	
	  // Adds a new dimension with the specified value accessor function.
	  function dimension(value) {
	    var dimension = {
	      filter: filter,
	      filterExact: filterExact,
	      filterRange: filterRange,
	      filterFunction: filterFunction,
	      filterAll: filterAll,
	      top: top,
	      bottom: bottom,
	      group: group,
	      groupAll: groupAll,
	      dispose: dispose,
	      remove: dispose // for backwards-compatibility
	    };
	
	    var one = ~m & -~m, // lowest unset bit as mask, e.g., 00001000
	        zero = ~one, // inverted one, e.g., 11110111
	        values, // sorted, cached array
	        index, // value rank ↦ object id
	        newValues, // temporary array storing newly-added values
	        newIndex, // temporary array storing newly-added index
	        sort = quicksort_by(function(i) { return newValues[i]; }),
	        refilter = crossfilter_filterAll, // for recomputing filter
	        refilterFunction, // the custom filter function in use
	        indexListeners = [], // when data is added
	        dimensionGroups = [],
	        lo0 = 0,
	        hi0 = 0;
	
	    // Updating a dimension is a two-stage process. First, we must update the
	    // associated filters for the newly-added records. Once all dimensions have
	    // updated their filters, the groups are notified to update.
	    dataListeners.unshift(preAdd);
	    dataListeners.push(postAdd);
	
	    removeDataListeners.push(removeData);
	
	    // Incorporate any existing data into this dimension, and make sure that the
	    // filter bitset is wide enough to handle the new dimension.
	    m |= one;
	    if (M >= 32 ? !one : m & -(1 << M)) {
	      filters = crossfilter_arrayWiden(filters, M <<= 1);
	    }
	    preAdd(data, 0, n);
	    postAdd(data, 0, n);
	
	    // Incorporates the specified new records into this dimension.
	    // This function is responsible for updating filters, values, and index.
	    function preAdd(newData, n0, n1) {
	
	      // Permute new values into natural order using a sorted index.
	      newValues = newData.map(value);
	      newIndex = sort(crossfilter_range(n1), 0, n1);
	      newValues = permute(newValues, newIndex);
	
	      // Bisect newValues to determine which new records are selected.
	      var bounds = refilter(newValues), lo1 = bounds[0], hi1 = bounds[1], i;
	      if (refilterFunction) {
	        for (i = 0; i < n1; ++i) {
	          if (!refilterFunction(newValues[i], i)) filters[newIndex[i] + n0] |= one;
	        }
	      } else {
	        for (i = 0; i < lo1; ++i) filters[newIndex[i] + n0] |= one;
	        for (i = hi1; i < n1; ++i) filters[newIndex[i] + n0] |= one;
	      }
	
	      // If this dimension previously had no data, then we don't need to do the
	      // more expensive merge operation; use the new values and index as-is.
	      if (!n0) {
	        values = newValues;
	        index = newIndex;
	        lo0 = lo1;
	        hi0 = hi1;
	        return;
	      }
	
	      var oldValues = values,
	          oldIndex = index,
	          i0 = 0,
	          i1 = 0;
	
	      // Otherwise, create new arrays into which to merge new and old.
	      values = new Array(n);
	      index = crossfilter_index(n, n);
	
	      // Merge the old and new sorted values, and old and new index.
	      for (i = 0; i0 < n0 && i1 < n1; ++i) {
	        if (oldValues[i0] < newValues[i1]) {
	          values[i] = oldValues[i0];
	          index[i] = oldIndex[i0++];
	        } else {
	          values[i] = newValues[i1];
	          index[i] = newIndex[i1++] + n0;
	        }
	      }
	
	      // Add any remaining old values.
	      for (; i0 < n0; ++i0, ++i) {
	        values[i] = oldValues[i0];
	        index[i] = oldIndex[i0];
	      }
	
	      // Add any remaining new values.
	      for (; i1 < n1; ++i1, ++i) {
	        values[i] = newValues[i1];
	        index[i] = newIndex[i1] + n0;
	      }
	
	      // Bisect again to recompute lo0 and hi0.
	      bounds = refilter(values), lo0 = bounds[0], hi0 = bounds[1];
	    }
	
	    // When all filters have updated, notify index listeners of the new values.
	    function postAdd(newData, n0, n1) {
	      indexListeners.forEach(function(l) { l(newValues, newIndex, n0, n1); });
	      newValues = newIndex = null;
	    }
	
	    function removeData(reIndex) {
	      for (var i = 0, j = 0, k; i < n; ++i) {
	        if (filters[k = index[i]]) {
	          if (i !== j) values[j] = values[i];
	          index[j] = reIndex[k];
	          ++j;
	        }
	      }
	      values.length = j;
	      while (j < n) index[j++] = 0;
	
	      // Bisect again to recompute lo0 and hi0.
	      var bounds = refilter(values);
	      lo0 = bounds[0], hi0 = bounds[1];
	    }
	
	    // Updates the selected values based on the specified bounds [lo, hi].
	    // This implementation is used by all the public filter methods.
	    function filterIndexBounds(bounds) {
	      var lo1 = bounds[0],
	          hi1 = bounds[1];
	
	      if (refilterFunction) {
	        refilterFunction = null;
	        filterIndexFunction(function(d, i) { return lo1 <= i && i < hi1; });
	        lo0 = lo1;
	        hi0 = hi1;
	        return dimension;
	      }
	
	      var i,
	          j,
	          k,
	          added = [],
	          removed = [];
	
	      // Fast incremental update based on previous lo index.
	      if (lo1 < lo0) {
	        for (i = lo1, j = Math.min(lo0, hi1); i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          added.push(k);
	        }
	      } else if (lo1 > lo0) {
	        for (i = lo0, j = Math.min(lo1, hi0); i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          removed.push(k);
	        }
	      }
	
	      // Fast incremental update based on previous hi index.
	      if (hi1 > hi0) {
	        for (i = Math.max(lo1, hi0), j = hi1; i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          added.push(k);
	        }
	      } else if (hi1 < hi0) {
	        for (i = Math.max(lo0, hi1), j = hi0; i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          removed.push(k);
	        }
	      }
	
	      lo0 = lo1;
	      hi0 = hi1;
	      filterListeners.forEach(function(l) { l(one, added, removed); });
	      return dimension;
	    }
	
	    // Filters this dimension using the specified range, value, or null.
	    // If the range is null, this is equivalent to filterAll.
	    // If the range is an array, this is equivalent to filterRange.
	    // Otherwise, this is equivalent to filterExact.
	    function filter(range) {
	      return range == null
	          ? filterAll() : Array.isArray(range)
	          ? filterRange(range) : typeof range === "function"
	          ? filterFunction(range)
	          : filterExact(range);
	    }
	
	    // Filters this dimension to select the exact value.
	    function filterExact(value) {
	      return filterIndexBounds((refilter = crossfilter_filterExact(bisect, value))(values));
	    }
	
	    // Filters this dimension to select the specified range [lo, hi].
	    // The lower bound is inclusive, and the upper bound is exclusive.
	    function filterRange(range) {
	      return filterIndexBounds((refilter = crossfilter_filterRange(bisect, range))(values));
	    }
	
	    // Clears any filters on this dimension.
	    function filterAll() {
	      return filterIndexBounds((refilter = crossfilter_filterAll)(values));
	    }
	
	    // Filters this dimension using an arbitrary function.
	    function filterFunction(f) {
	      refilter = crossfilter_filterAll;
	
	      filterIndexFunction(refilterFunction = f);
	
	      lo0 = 0;
	      hi0 = n;
	
	      return dimension;
	    }
	
	    function filterIndexFunction(f) {
	      var i,
	          k,
	          x,
	          added = [],
	          removed = [];
	
	      for (i = 0; i < n; ++i) {
	        if (!(filters[k = index[i]] & one) ^ !!(x = f(values[i], i))) {
	          if (x) filters[k] &= zero, added.push(k);
	          else filters[k] |= one, removed.push(k);
	        }
	      }
	      filterListeners.forEach(function(l) { l(one, added, removed); });
	    }
	
	    // Returns the top K selected records based on this dimension's order.
	    // Note: observes this dimension's filter, unlike group and groupAll.
	    function top(k) {
	      var array = [],
	          i = hi0,
	          j;
	
	      while (--i >= lo0 && k > 0) {
	        if (!filters[j = index[i]]) {
	          array.push(data[j]);
	          --k;
	        }
	      }
	
	      return array;
	    }
	
	    // Returns the bottom K selected records based on this dimension's order.
	    // Note: observes this dimension's filter, unlike group and groupAll.
	    function bottom(k) {
	      var array = [],
	          i = lo0,
	          j;
	
	      while (i < hi0 && k > 0) {
	        if (!filters[j = index[i]]) {
	          array.push(data[j]);
	          --k;
	        }
	        i++;
	      }
	
	      return array;
	    }
	
	    // Adds a new group to this dimension, using the specified key function.
	    function group(key) {
	      var group = {
	        top: top,
	        all: all,
	        reduce: reduce,
	        reduceCount: reduceCount,
	        reduceSum: reduceSum,
	        order: order,
	        orderNatural: orderNatural,
	        size: size,
	        dispose: dispose,
	        remove: dispose // for backwards-compatibility
	      };
	
	      // Ensure that this group will be removed when the dimension is removed.
	      dimensionGroups.push(group);
	
	      var groups, // array of {key, value}
	          groupIndex, // object id ↦ group id
	          groupWidth = 8,
	          groupCapacity = crossfilter_capacity(groupWidth),
	          k = 0, // cardinality
	          select,
	          heap,
	          reduceAdd,
	          reduceRemove,
	          reduceInitial,
	          update = crossfilter_null,
	          reset = crossfilter_null,
	          resetNeeded = true,
	          groupAll = key === crossfilter_null;
	
	      if (arguments.length < 1) key = crossfilter_identity;
	
	      // The group listens to the crossfilter for when any dimension changes, so
	      // that it can update the associated reduce values. It must also listen to
	      // the parent dimension for when data is added, and compute new keys.
	      filterListeners.push(update);
	      indexListeners.push(add);
	      removeDataListeners.push(removeData);
	
	      // Incorporate any existing data into the grouping.
	      add(values, index, 0, n);
	
	      // Incorporates the specified new values into this group.
	      // This function is responsible for updating groups and groupIndex.
	      function add(newValues, newIndex, n0, n1) {
	        var oldGroups = groups,
	            reIndex = crossfilter_index(k, groupCapacity),
	            add = reduceAdd,
	            initial = reduceInitial,
	            k0 = k, // old cardinality
	            i0 = 0, // index of old group
	            i1 = 0, // index of new record
	            j, // object id
	            g0, // old group
	            x0, // old key
	            x1, // new key
	            g, // group to add
	            x; // key of group to add
	
	        // If a reset is needed, we don't need to update the reduce values.
	        if (resetNeeded) add = initial = crossfilter_null;
	
	        // Reset the new groups (k is a lower bound).
	        // Also, make sure that groupIndex exists and is long enough.
	        groups = new Array(k), k = 0;
	        groupIndex = k0 > 1 ? crossfilter_arrayLengthen(groupIndex, n) : crossfilter_index(n, groupCapacity);
	
	        // Get the first old key (x0 of g0), if it exists.
	        if (k0) x0 = (g0 = oldGroups[0]).key;
	
	        // Find the first new key (x1), skipping NaN keys.
	        while (i1 < n1 && !((x1 = key(newValues[i1])) >= x1)) ++i1;
	
	        // While new keys remain…
	        while (i1 < n1) {
	
	          // Determine the lesser of the two current keys; new and old.
	          // If there are no old keys remaining, then always add the new key.
	          if (g0 && x0 <= x1) {
	            g = g0, x = x0;
	
	            // Record the new index of the old group.
	            reIndex[i0] = k;
	
	            // Retrieve the next old key.
	            if (g0 = oldGroups[++i0]) x0 = g0.key;
	          } else {
	            g = {key: x1, value: initial()}, x = x1;
	          }
	
	          // Add the lesser group.
	          groups[k] = g;
	
	          // Add any selected records belonging to the added group, while
	          // advancing the new key and populating the associated group index.
	          while (!(x1 > x)) {
	            groupIndex[j = newIndex[i1] + n0] = k;
	            if (!(filters[j] & zero)) g.value = add(g.value, data[j]);
	            if (++i1 >= n1) break;
	            x1 = key(newValues[i1]);
	          }
	
	          groupIncrement();
	        }
	
	        // Add any remaining old groups that were greater than all new keys.
	        // No incremental reduce is needed; these groups have no new records.
	        // Also record the new index of the old group.
	        while (i0 < k0) {
	          groups[reIndex[i0] = k] = oldGroups[i0++];
	          groupIncrement();
	        }
	
	        // If we added any new groups before any old groups,
	        // update the group index of all the old records.
	        if (k > i0) for (i0 = 0; i0 < n0; ++i0) {
	          groupIndex[i0] = reIndex[groupIndex[i0]];
	        }
	
	        // Modify the update and reset behavior based on the cardinality.
	        // If the cardinality is less than or equal to one, then the groupIndex
	        // is not needed. If the cardinality is zero, then there are no records
	        // and therefore no groups to update or reset. Note that we also must
	        // change the registered listener to point to the new method.
	        j = filterListeners.indexOf(update);
	        if (k > 1) {
	          update = updateMany;
	          reset = resetMany;
	        } else {
	          if (!k && groupAll) {
	            k = 1;
	            groups = [{key: null, value: initial()}];
	          }
	          if (k === 1) {
	            update = updateOne;
	            reset = resetOne;
	          } else {
	            update = crossfilter_null;
	            reset = crossfilter_null;
	          }
	          groupIndex = null;
	        }
	        filterListeners[j] = update;
	
	        // Count the number of added groups,
	        // and widen the group index as needed.
	        function groupIncrement() {
	          if (++k === groupCapacity) {
	            reIndex = crossfilter_arrayWiden(reIndex, groupWidth <<= 1);
	            groupIndex = crossfilter_arrayWiden(groupIndex, groupWidth);
	            groupCapacity = crossfilter_capacity(groupWidth);
	          }
	        }
	      }
	
	      function removeData() {
	        if (k > 1) {
	          var oldK = k,
	              oldGroups = groups,
	              seenGroups = crossfilter_index(oldK, oldK);
	
	          // Filter out non-matches by copying matching group index entries to
	          // the beginning of the array.
	          for (var i = 0, j = 0; i < n; ++i) {
	            if (filters[i]) {
	              seenGroups[groupIndex[j] = groupIndex[i]] = 1;
	              ++j;
	            }
	          }
	
	          // Reassemble groups including only those groups that were referred
	          // to by matching group index entries.  Note the new group index in
	          // seenGroups.
	          groups = [], k = 0;
	          for (i = 0; i < oldK; ++i) {
	            if (seenGroups[i]) {
	              seenGroups[i] = k++;
	              groups.push(oldGroups[i]);
	            }
	          }
	
	          if (k > 1) {
	            // Reindex the group index using seenGroups to find the new index.
	            for (var i = 0; i < j; ++i) groupIndex[i] = seenGroups[groupIndex[i]];
	          } else {
	            groupIndex = null;
	          }
	          filterListeners[filterListeners.indexOf(update)] = k > 1
	              ? (reset = resetMany, update = updateMany)
	              : k === 1 ? (reset = resetOne, update = updateOne)
	              : reset = update = crossfilter_null;
	        } else if (k === 1) {
	          if (groupAll) return;
	          for (var i = 0; i < n; ++i) if (filters[i]) return;
	          groups = [], k = 0;
	          filterListeners[filterListeners.indexOf(update)] =
	          update = reset = crossfilter_null;
	        }
	      }
	
	      // Reduces the specified selected or deselected records.
	      // This function is only used when the cardinality is greater than 1.
	      function updateMany(filterOne, added, removed) {
	        if (filterOne === one || resetNeeded) return;
	
	        var i,
	            k,
	            n,
	            g;
	
	        // Add the added values.
	        for (i = 0, n = added.length; i < n; ++i) {
	          if (!(filters[k = added[i]] & zero)) {
	            g = groups[groupIndex[k]];
	            g.value = reduceAdd(g.value, data[k]);
	          }
	        }
	
	        // Remove the removed values.
	        for (i = 0, n = removed.length; i < n; ++i) {
	          if ((filters[k = removed[i]] & zero) === filterOne) {
	            g = groups[groupIndex[k]];
	            g.value = reduceRemove(g.value, data[k]);
	          }
	        }
	      }
	
	      // Reduces the specified selected or deselected records.
	      // This function is only used when the cardinality is 1.
	      function updateOne(filterOne, added, removed) {
	        if (filterOne === one || resetNeeded) return;
	
	        var i,
	            k,
	            n,
	            g = groups[0];
	
	        // Add the added values.
	        for (i = 0, n = added.length; i < n; ++i) {
	          if (!(filters[k = added[i]] & zero)) {
	            g.value = reduceAdd(g.value, data[k]);
	          }
	        }
	
	        // Remove the removed values.
	        for (i = 0, n = removed.length; i < n; ++i) {
	          if ((filters[k = removed[i]] & zero) === filterOne) {
	            g.value = reduceRemove(g.value, data[k]);
	          }
	        }
	      }
	
	      // Recomputes the group reduce values from scratch.
	      // This function is only used when the cardinality is greater than 1.
	      function resetMany() {
	        var i,
	            g;
	
	        // Reset all group values.
	        for (i = 0; i < k; ++i) {
	          groups[i].value = reduceInitial();
	        }
	
	        // Add any selected records.
	        for (i = 0; i < n; ++i) {
	          if (!(filters[i] & zero)) {
	            g = groups[groupIndex[i]];
	            g.value = reduceAdd(g.value, data[i]);
	          }
	        }
	      }
	
	      // Recomputes the group reduce values from scratch.
	      // This function is only used when the cardinality is 1.
	      function resetOne() {
	        var i,
	            g = groups[0];
	
	        // Reset the singleton group values.
	        g.value = reduceInitial();
	
	        // Add any selected records.
	        for (i = 0; i < n; ++i) {
	          if (!(filters[i] & zero)) {
	            g.value = reduceAdd(g.value, data[i]);
	          }
	        }
	      }
	
	      // Returns the array of group values, in the dimension's natural order.
	      function all() {
	        if (resetNeeded) reset(), resetNeeded = false;
	        return groups;
	      }
	
	      // Returns a new array containing the top K group values, in reduce order.
	      function top(k) {
	        var top = select(all(), 0, groups.length, k);
	        return heap.sort(top, 0, top.length);
	      }
	
	      // Sets the reduce behavior for this group to use the specified functions.
	      // This method lazily recomputes the reduce values, waiting until needed.
	      function reduce(add, remove, initial) {
	        reduceAdd = add;
	        reduceRemove = remove;
	        reduceInitial = initial;
	        resetNeeded = true;
	        return group;
	      }
	
	      // A convenience method for reducing by count.
	      function reduceCount() {
	        return reduce(crossfilter_reduceIncrement, crossfilter_reduceDecrement, crossfilter_zero);
	      }
	
	      // A convenience method for reducing by sum(value).
	      function reduceSum(value) {
	        return reduce(crossfilter_reduceAdd(value), crossfilter_reduceSubtract(value), crossfilter_zero);
	      }
	
	      // Sets the reduce order, using the specified accessor.
	      function order(value) {
	        select = heapselect_by(valueOf);
	        heap = heap_by(valueOf);
	        function valueOf(d) { return value(d.value); }
	        return group;
	      }
	
	      // A convenience method for natural ordering by reduce value.
	      function orderNatural() {
	        return order(crossfilter_identity);
	      }
	
	      // Returns the cardinality of this group, irrespective of any filters.
	      function size() {
	        return k;
	      }
	
	      // Removes this group and associated event listeners.
	      function dispose() {
	        var i = filterListeners.indexOf(update);
	        if (i >= 0) filterListeners.splice(i, 1);
	        i = indexListeners.indexOf(add);
	        if (i >= 0) indexListeners.splice(i, 1);
	        i = removeDataListeners.indexOf(removeData);
	        if (i >= 0) removeDataListeners.splice(i, 1);
	        return group;
	      }
	
	      return reduceCount().orderNatural();
	    }
	
	    // A convenience function for generating a singleton group.
	    function groupAll() {
	      var g = group(crossfilter_null), all = g.all;
	      delete g.all;
	      delete g.top;
	      delete g.order;
	      delete g.orderNatural;
	      delete g.size;
	      g.value = function() { return all()[0].value; };
	      return g;
	    }
	
	    // Removes this dimension and associated groups and event listeners.
	    function dispose() {
	      dimensionGroups.forEach(function(group) { group.dispose(); });
	      var i = dataListeners.indexOf(preAdd);
	      if (i >= 0) dataListeners.splice(i, 1);
	      i = dataListeners.indexOf(postAdd);
	      if (i >= 0) dataListeners.splice(i, 1);
	      i = removeDataListeners.indexOf(removeData);
	      if (i >= 0) removeDataListeners.splice(i, 1);
	      m &= zero;
	      return filterAll();
	    }
	
	    return dimension;
	  }
	
	  // A convenience method for groupAll on a dummy dimension.
	  // This implementation can be optimized since it always has cardinality 1.
	  function groupAll() {
	    var group = {
	      reduce: reduce,
	      reduceCount: reduceCount,
	      reduceSum: reduceSum,
	      value: value,
	      dispose: dispose,
	      remove: dispose // for backwards-compatibility
	    };
	
	    var reduceValue,
	        reduceAdd,
	        reduceRemove,
	        reduceInitial,
	        resetNeeded = true;
	
	    // The group listens to the crossfilter for when any dimension changes, so
	    // that it can update the reduce value. It must also listen to the parent
	    // dimension for when data is added.
	    filterListeners.push(update);
	    dataListeners.push(add);
	
	    // For consistency; actually a no-op since resetNeeded is true.
	    add(data, 0, n);
	
	    // Incorporates the specified new values into this group.
	    function add(newData, n0) {
	      var i;
	
	      if (resetNeeded) return;
	
	      // Add the added values.
	      for (i = n0; i < n; ++i) {
	        if (!filters[i]) {
	          reduceValue = reduceAdd(reduceValue, data[i]);
	        }
	      }
	    }
	
	    // Reduces the specified selected or deselected records.
	    function update(filterOne, added, removed) {
	      var i,
	          k,
	          n;
	
	      if (resetNeeded) return;
	
	      // Add the added values.
	      for (i = 0, n = added.length; i < n; ++i) {
	        if (!filters[k = added[i]]) {
	          reduceValue = reduceAdd(reduceValue, data[k]);
	        }
	      }
	
	      // Remove the removed values.
	      for (i = 0, n = removed.length; i < n; ++i) {
	        if (filters[k = removed[i]] === filterOne) {
	          reduceValue = reduceRemove(reduceValue, data[k]);
	        }
	      }
	    }
	
	    // Recomputes the group reduce value from scratch.
	    function reset() {
	      var i;
	
	      reduceValue = reduceInitial();
	
	      for (i = 0; i < n; ++i) {
	        if (!filters[i]) {
	          reduceValue = reduceAdd(reduceValue, data[i]);
	        }
	      }
	    }
	
	    // Sets the reduce behavior for this group to use the specified functions.
	    // This method lazily recomputes the reduce value, waiting until needed.
	    function reduce(add, remove, initial) {
	      reduceAdd = add;
	      reduceRemove = remove;
	      reduceInitial = initial;
	      resetNeeded = true;
	      return group;
	    }
	
	    // A convenience method for reducing by count.
	    function reduceCount() {
	      return reduce(crossfilter_reduceIncrement, crossfilter_reduceDecrement, crossfilter_zero);
	    }
	
	    // A convenience method for reducing by sum(value).
	    function reduceSum(value) {
	      return reduce(crossfilter_reduceAdd(value), crossfilter_reduceSubtract(value), crossfilter_zero);
	    }
	
	    // Returns the computed reduce value.
	    function value() {
	      if (resetNeeded) reset(), resetNeeded = false;
	      return reduceValue;
	    }
	
	    // Removes this group and associated event listeners.
	    function dispose() {
	      var i = filterListeners.indexOf(update);
	      if (i >= 0) filterListeners.splice(i);
	      i = dataListeners.indexOf(add);
	      if (i >= 0) dataListeners.splice(i);
	      return group;
	    }
	
	    return reduceCount();
	  }
	
	  // Returns the number of records in this crossfilter, irrespective of any filters.
	  function size() {
	    return n;
	  }
	
	  return arguments.length
	      ? add(arguments[0])
	      : crossfilter;
	}
	
	// Returns an array of size n, big enough to store ids up to m.
	function crossfilter_index(n, m) {
	  return (m < 0x101
	      ? crossfilter_array8 : m < 0x10001
	      ? crossfilter_array16
	      : crossfilter_array32)(n);
	}
	
	// Constructs a new array of size n, with sequential values from 0 to n - 1.
	function crossfilter_range(n) {
	  var range = crossfilter_index(n, n);
	  for (var i = -1; ++i < n;) range[i] = i;
	  return range;
	}
	
	function crossfilter_capacity(w) {
	  return w === 8
	      ? 0x100 : w === 16
	      ? 0x10000
	      : 0x100000000;
	}
	})(typeof exports !== 'undefined' && exports || this);


/***/ },
/* 1123 */
/***/ function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ },
/* 1124 */,
/* 1125 */,
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".dropdown-submenu{position:relative}.dropdown-submenu>.dropdown-menu{top:0;left:100%;margin-top:-6px;margin-left:-1px;border-radius:0 6px 6px 6px}.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu>a:after{display:block;content:\" \";float:right;width:0;height:0;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;border-left-color:#ccc;margin-top:5px;margin-right:-10px}.dropdown-submenu:hover>a:after{border-left-color:#fff}.dropdown-submenu.pull-left{float:none}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px;border-radius:6px 0 6px 6px}.right-menu{right:0;left:auto}.left-submenu{float:none}.left-submenu>.dropdown-menu{border-radius:6px 0 6px 6px;left:auto;margin-left:10px;right:98%}", ""]);
	
	// exports


/***/ },
/* 1127 */,
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "body{font-family:Open Sans,sans-serif;background:url(" + __webpack_require__(427) + ") no-repeat 50% fixed;background-size:cover}#disconnected-box{margin-top:120px}#disconnected-box-content{background-color:#fff;box-shadow:0 0 40px #000}.never-seen-warning{margin-top:4px;margin-left:10px}.via-node-headline{margin-left:20px}.via-node-headline:hover{cursor:pointer}.discovered-node-link{margin-left:20px}.discovered-node-link:hover{cursor:pointer}#nodes-box,hr{margin-top:10px}hr{margin-bottom:10px}.loading-text{font-size:14px}", ""]);
	
	// exports


/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "#editor{height:256px}body{background-color:#e3e3e3;font-family:Open Sans,sans-serif;font-size:12px;overflow-x:hidden;margin-top:45px}ul{list-style-type:none;margin:0}hr{border-top:1px solid #e3e3e3}h1,h2,h3,h4,h5,h6{font-weight:400;padding:0;margin:0;color:#333}h1{font-size:28px}h2{font-size:21px}h3{font-size:18px}h4{font-size:14px;font-weight:700;font-weight:400}a{color:#16ace3}.btn:active,a:active,input[type=checkbox]:active,input[type=file]:active,input[type=radio]:active,select:active{outline:none;outline-offset:0}input.form-control,select.form-control,textarea.form-control{color:#666}.input-group-addon.input-group-separator{border-right-width:0;border-left-width:0}label{font-size:14px}legend small{color:#aaa;margin-left:5px}.btn:focus{background-position:0}#footer{text-align:center;font-size:11px;color:#aaa;margin-bottom:15px}.modal-title{font-size:21px}.modal-dialog{margin-top:55px!important}.modal .modal-backdrop{z-index:0}.modal-backdrop{height:100000%;z-index:1030}.navbar-brand{width:155px}#universalsearch{padding:15px;background-color:#fff;border:1px solid #d1d1d1}#universalsearch-container{padding:0 25px}.content{padding-top:15px;padding-bottom:15px;background-color:#fff;border:1px solid #d1d1d1;margin-bottom:10px}.content p.description{margin-top:3px}.content-head{padding-bottom:0}.content p.description{color:#939393}.content-head p{margin-top:15px}.content-head .actions-lg{float:right}.actions-lg .actions-container{height:60px;margin-top:10px;padding-left:50px}.content-head .actions-sm{padding-bottom:15px}.content-head .description-tooltips .fa-stack{margin-right:3px}.content p.description-tooltips-small .fa-stack{margin-right:1px;position:relative;top:-1px}.content p.description-tooltips{margin-top:10px}.content-col{padding:15px 10px;background-color:#fff;border:1px solid #d1d1d1;margin-top:15px}#sidebar{padding-left:0}@media (max-height:991px){#sidebar{padding-right:0}}@media (min-width:991px){#sidebar{padding-right:15px}}@media (max-width:991px){#sidebar .affix{position:relative}}@media (min-width:991px){#sidebar .affix{top:45px;z-index:1000;position:fixed}}#sidebar .actions{margin-top:10px}#sidebar .actions>div{margin:5px 5px 0 0}#sidebar hr{margin-top:15px;margin-bottom:10px}#main-row{margin-bottom:0}#main-content-sidebar{padding-left:0;padding-right:0}#main-content{margin-top:10px;padding:5px 25px}#main-content-search{margin-bottom:0;margin-top:-15px}#universalsearch{padding:5px;margin-bottom:0;margin-top:15px}.universalsearch-timerange-selector{font-size:12px}.universalsearch-timerange-selector label{font-size:12px;margin-left:5px!important}.universalsearch-timerange-selector .radio input{margin-left:-17px;position:relative;top:-2px}.universalsearch-form{margin-bottom:0}.universalsearch-form #search-container{margin-left:5px}.universalsearch-form button{font-size:13px}.universalsearch-form button.btn-sm{font-size:12px}.universalsearch-form div .query{margin-left:45px;margin-right:25px}.universalsearch-form .query input{font-family:monospace;font-size:13px;width:100%;border:0;background-color:#fff;box-shadow:none;color:inherit;-moz-box-shadow:none;-webkit-box-shadow:none;-webkit-transition:none;transition:none;outline:none;padding:0;margin-left:5px;margin-bottom:5px}.universalsearch-form .form-group{margin-bottom:0}a.fields-set-chooser{margin-right:2px;margin-left:2px}#result-graph-container{margin-right:12px;margin-bottom:25px}#result-graph{margin-top:5px}#result-graph,#result-graph-timeline{margin-left:40px}#y_axis{float:left;height:200px;width:40px}.search-result-fields{margin-top:3px;padding-left:0}.search-result-fields li{margin-top:1px;margin-bottom:1px;padding:2px 0}.search-result-fields label{font-size:12px;display:inline;position:relative;top:3px;font-weight:400!important}.search-result-fields .form-group{margin-bottom:0}.search-result-fields .checkbox{margin:0}.search-result-fields input[type=checkbox]{position:relative;right:4px}.search-result-fields .dropdown .caret{display:none}.search-result-fields button.dropdown-toggle{padding:0}.message-terms{margin-right:8px;font-family:monospace}.support-sources ul{margin-top:5px}.systemjob{margin-top:10px;border-bottom:1px solid #ccc}.systemjob .progress{margin-top:2px;margin-bottom:5px}.systemjob .finished{display:none;position:relative;top:-1px;left:2px;font-family:Arial,sans-serif;font-size:11px}.notifications-none,.systemjobs-none{margin-top:10px}.notification-badge-link:hover{border:0!important;text-decoration:none!important}.row{margin-bottom:15px}.alert,.no-bm{margin-bottom:0}.alert{margin-top:5px}.system-messages{font-size:12px}.notification{margin-top:10px!important}.notification i{color:#000}.notification-head{margin-bottom:5px}.notification-timestamp{margin-left:3px;font-size:10px}.notification-solutions{margin-top:10px}.notification-solutions label{font-size:13px}.notification form{margin-bottom:0}.notification-solutions h4{font-size:13px;font-weight:700;margin-bottom:1px}.notification-solutions .btn{margin-top:3px;font-size:12px;padding:3px 11px}.node-row{border-bottom:1px solid #ccc;padding-bottom:8px;margin-top:15px;margin-bottom:0}.change-message-processing{position:relative;top:-1px}.es-cluster-status{margin-top:10px;margin-bottom:5px}.node-row .hostname{font-size:12px}.rickshaw_graph .x_tick{position:relative;top:38px}.graph-resolution-selector{margin-top:5px;margin-bottom:20px}.graph-resolution-selector li{padding-right:0}.graph-resolution-selector a{text-transform:capitalize}.selected-resolution{font-weight:700}.search-result-fields .fa-cog{position:relative;top:3px}.modal form{margin-bottom:0}s .input-list h2{margin-bottom:5px}.node-row{margin-bottom:8px;margin-top:0}.node-row .well{margin-bottom:0;margin-top:3px;font-family:monospace;font-size:11px}.node-row-info{position:relative;top:2px}.node-row-info form{display:inline}.node-row-info .text{position:relative;top:3px}.node-row-info-negative-correction{position:relative;top:-15px}.input-list .alert{margin-top:10px}.input-new{margin-bottom:8px}.alert-bar{margin:10px -20px 0}.system-messages a{color:#000}.xtrc-new-example{margin-bottom:5px;font-family:monospace;font-size:14px;white-space:pre-wrap;word-wrap:break-word}.xtrc-no-example{margin-top:15px;margin-bottom:12px}.xtrc-hl{background-color:#f8b9b7;padding-top:3px;padding-bottom:3px}#create-extractor{margin-top:10px}.xtrc-converter-subfields{margin-left:20px}.xtrc-list-container{margin-top:15px}.xtrc-list-container h2{margin-bottom:5px}.xtrc-list-container .alert{margin-top:5px}.xtrc-list-drag{margin-top:10px}.manual-selector-form{margin-top:5px}.node-row .xtrc-converters{margin-top:10px}.node-row .xtrc-config li,.node-row .xtrc-converters li{margin-left:10px}.node-row .xtrc-converter-config li{margin-left:20px}.u-light{border-bottom:1px dotted #bbb;margin-bottom:5px;padding-bottom:5px}.xtrc-metrics{margin-top:7px;margin-left:5px}.xtrc-metrics .span4{margin-left:0}.xtrc-metrics h3 .unit{font-size:11px}.xtrc-metrics dl{margin-top:3px;margin-bottom:0}.xtrc-metrics dt{float:left}.xtrc-metrics dd{margin-left:130px}.xtrc-exception-bubble{position:relative;top:-7px;margin-left:2px;cursor:pointer}.extractor-condition-summary{margin-left:5px;margin-top:10px}.success-match{color:#408140}.fail-match{color:#da4f49}.input-docs{margin-left:3px}.input-docs:hover{text-decoration:none}.open-analyze-field{cursor:pointer;font-size:16px;position:relative;top:4px;color:#16ace3}.open-analyze-field-active,.open-analyze-field:hover{color:#1189b5}.analyze-field{margin-top:10px}.analyzer-content dl{margin-top:10px;margin-bottom:5px;border-left:3px solid #eee;padding-left:7px;padding-top:1px;padding-bottom:1px}.analyzer-content dt{float:left;height:25px}.analyzer-content dd{margin-left:120px;height:25px}.analyze-field .statistics .wrong-type{margin-top:5px;color:#bbb}.timerange-selector-container{border-bottom:1px solid #eee;padding-bottom:6px;margin-bottom:8px;margin-left:5px}.input-append,.timerange-selector-container .input-prepend,.timerange-selector select{margin-bottom:0}.timerange-chooser{float:left;margin-right:5px}.timerange-chooser .btn{padding:6px 7px;line-height:15px;font-size:12px}.timerange-chooser .btn .caret{margin-left:1px}.timerange-chooser .selected a{font-weight:700}.master-node{color:#f89406}.permission-select{width:350px}.loglevel-metrics-row{margin-top:2px;margin-left:10px}.loglevel-metrics dl{margin-bottom:5px;margin-top:5px}.loglevel-metrics dt{float:left;margin-right:5px}.subsystems{margin-top:10px;margin-left:10px}.subsystems-row{margin-bottom:10px}#universalsearch .timerange-selector-container .keyword .icon{margin-left:5px}#universalsearch .timerange-selector-container .keyword .keyword-preview{margin-top:4px;margin-left:45px;font-size:11px}#universalsearch .timerange-selector-container .keyword .keyword-preview .fromto span{background-color:#fec;padding-left:3px;padding-right:3px}.no-active-nodes{margin-top:8px}.alpha80{background:#000 transparent;background:rgba(0,0,0,.8)}.alpha70,.alpha80{filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000,endColorstr=#99000000);-ms-filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000,endColorstr=#99000000)}.alpha70{background:#000 transparent;background:rgba(0,0,0,.7)}#scroll-to-hint{position:fixed;left:50%;margin-left:-125px;top:50px;color:#fff;font-size:80px;padding:25px;z-index:2000;width:200px;text-align:center;-webkit-border-radius:10px 10px 10px 10px;-moz-border-radius:10px 10px 10px 10px;cursor:pointer;border-radius:10px 10px 10px 10px}.graph-range-selector{outline:1px solid #eee;background:rgba(0,0,0,.3);position:absolute;top:0;z-index:1;cursor:pointer;pointer-events:none}.rickshaw_graph:active,.rickshaw_graph :active,.rickshaw_graph:focus,.rickshaw_graph :focus{cursor:crosshair!important}.rickshaw_graph .detail .x_label{display:none}.rickshaw_graph .detail .item{line-height:1.4;padding:.5em}.detail_swatch{display:inline-block;width:10px;height:10px;margin:0 4px 0 0}.rickshaw_graph .detail .date{color:#a0a0a0}.input-io .total{color:#b8b8b8}.input-list .static-fields{margin-top:10px;margin-left:3px}.input-list .static-fields ul{margin:0;padding:0}.input-list .static-fields ul .remove-static-field{margin-left:5px}.field-graph-container{padding-bottom:35px}.field-graph-container .dropdown-menu a.selected{font-weight:700}.field-graph-container .type-description{color:#bbb;font-size:11px}.field-graph-container .field-graph-components{margin-top:10px;margin-right:12px}.field-graph-container .field-graph{margin-left:40px;margin-bottom:25px}.field-graph-container .field-graph-y-axis{float:left;height:200px;width:40px}#field-graphs .spinner{margin-bottom:10px;text-align:center}.sources.overlay{background-color:#aaa;height:200px;line-height:200px;opacity:.2;position:absolute;text-align:center;font-size:50px}ul.index-list{margin-left:25px;margin-top:5px;list-style-type:square}.metric-list{padding:0}.metric-list li{margin-bottom:5px}.metric-list li .prefix{color:#aaa}.metric-list li .name{font-size:13px;font-family:monospace;word-break:break-all}.metric-list li .metric{margin-left:10px;padding:10px}.metric-list li .metric h3{margin-bottom:5px}.metric-list dl{margin-top:0;margin-bottom:0}.metrics-filter{margin-bottom:15px!important}dl.metric-def dt{float:left}dl.metric-timer dd{margin-left:125px}dl.metric-meter dd{margin-left:95px}dl.metric-counter dd,dl.metric-gauge dd{margin-left:80px}dl.metric-histogram dd{margin-left:125px}.metric-list li .name .open:hover{text-decoration:none}#user-list th.user-type{width:50px}td.centered{text-align:center}td.limited{max-width:180px;overflow:hidden;text-overflow:ellipsis}.dashboard{color:#333;height:100%;margin:0;overflow:auto;width:100%}.dashboard .gridster .gs-w{background-color:#fff;border:1px solid #d1d1d1;z-index:auto}.dashboard .gridster .player{border-style:dashed;border-color:#d1d1d1}.dashboard .gridster .preview-holder{border:none!important;background:#16ace3!important}.dashboard .gridster .resize-preview-holder{z-index:-1}.dashboard .widget{height:inherit;margin:0;padding:15px}.dashboard .widget .widget-top{position:relative;margin-bottom:-15px;top:-5px;font-size:11px;line-height:11px}.dashboard .widget .controls{position:relative;left:-3px}.dashboard .widget .reloading{margin-right:2px;font-weight:700;color:#0085a7;display:none}.dashboard .widget .search_result_count .value{line-height:70px!important;text-align:center;font-size:70px;position:relative;top:20px}.dashboard .widget .search_result_count .trend-indicators{font-size:25px;height:70px;position:absolute;top:35px;left:345px;width:25px}.dashboard .widget .search_result_count .trend-indicators .trend-icon{height:25px;margin-bottom:-18px}.dashboard .widget .search_result_count .trend-indicators .trend-icons-higher{margin-bottom:5px}.dashboard .widget .search_result_count .icon{color:#ebebeb}.dashboard .widget .loading-failed{color:#ff4646!important}.dashboard .widget .controls{display:none}.dashboard .widget .edit-description{display:none;color:#0085a7!important;font-size:12px}.dashboard .widget .edit-description .icon{color:#0085a7!important}.dashboard .widget .description-form,.dashboard .widget .info .cache-info{display:none}.datatable-badge{border-radius:2px;display:inline-block;padding:5px;vertical-align:baseline}.tooltip .tooltip-inner{max-width:300px}.tooltip .tooltip-inner .datapoint-info{text-align:left}.tooltip .tooltip-inner .datapoint-info .date{color:#e3e5e5}.dashboard .gridster{margin-left:-10px;transition:none}.dashboard .gridster .widget{cursor:move}.dashboard .gridster.gs-resize-disabled .widget{cursor:default}.dashboard .widget .dc-chart{float:none}.dashboard .widget .widget-title{font-size:18px;height:25px;margin-right:130px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dashboard .widget .load-error{color:#ff3b00;margin-right:5px}.dashboard .widget .widget-update-info{text-align:right;float:right;font-size:11px;height:25px;line-height:25px;width:130px}.dashboard .widget .configuration dt{text-transform:capitalize}.dashboard .widget svg{overflow:hidden}.dashboard .widget .number{line-height:70px}.dashboard .widget .number .value{line-height:100px;text-align:center;font-size:70px;position:relative}.dashboard .widget .number .trend-indicators{font-size:25px;height:70px;position:absolute;top:30px;right:20px;width:25px}.dashboard .widget .number .trend-indicators .trend-icon{color:#e3e5e5;height:25px;margin-bottom:-18px}.dashboard .widget .number .trend-indicators .trend-icon.trend-good{color:#8dc63f}.dashboard .widget .number .trend-indicators .trend-icon.trend-bad{color:#be1e2d}.dashboard .widget .number .trend-indicators .trend-icons-higher{margin-bottom:5px}.dashboard .widget .quickvalues-visualization{overflow:auto}.dashboard .widget .quickvalues-graph{text-align:center}.dashboard .widget .graph.scatterplot path.line{display:none}.dashboard .widget .actions{position:absolute;right:15px;bottom:10px}.dashboard .widget .actions div{display:inline-block;margin-left:5px}.dashboard .widget .actions button{padding:0 5px}.dashboard .widget .not-available{font-size:70px}.dashboard .widget .loading,.dashboard .widget .not-available{line-height:100px;text-align:center}.dashboard .widget .loading .spinner,.dashboard .widget .not-available .spinner{vertical-align:middle}.configuration-field-optional{margin-left:5px;font-size:11px}.message-result-fields-range{font-size:11px}.message-result-fields-set{margin-bottom:10px}.message-result-fields-set .btn-mini{padding-top:1px}.index-description{margin-bottom:7px}.index-description .index-info,.index-description .index-info dl{margin-top:5px}.index-details{margin-left:5px}.index-label{vertical-align:text-top}.index-label .label{margin-right:5px}.index-more-actions{font-size:90%;margin-left:5px}.shard-meters{margin-top:10px}.shard-meters dl{margin-bottom:0;margin-top:0}.shard-meters dl dt{float:left}.shard-meters dl dd{margin-left:65px}.shards{margin:0;padding:0;margin-top:5px}.shard-routing .shards .shard{padding:10px;margin:5px;width:50px;float:left;text-align:center}.shard-routing .shards .shard-started{background-color:#dff0d8}.shard-routing .shards .shard-relocating{background-color:#de9df4}.shard-routing .shards .shard-initializing{background-color:#f4ddbc}.shard-routing .shards .shard-unassigned{background-color:#c3c3c3}.shard-routing .shards .shard-primary .id{font-weight:700;margin-bottom:3px;border-bottom:1px solid #000}.shard-routing .description{font-size:11px;margin-top:2px;margin-left:6px}.node-buffer-usage{margin-top:10px;margin-bottom:7px}.journal-details-usage .progress-bar,.node-buffer-usage .progress-bar{text-shadow:0 1px 2px rgba(0,0,0,.4),2px -1px 3px hsla(0,0%,100%,.5)}.journal-details-usage .progress-bar span,.node-buffer-usage .progress-bar span{margin-left:1px}.system-system dt{float:left}.system-system dd{margin-left:75px}dl.system-journal{margin-top:5px;margin-bottom:0}.system-journal dt{float:left}.system-journal dd{margin-left:120px}dl.system-dl{margin:0}.system-dl dt{float:left;clear:left}.system-dl dd{margin-left:180px}.system-rest dt{float:left}.system-rest dd{margin-left:120px}.closed-indices{cursor:pointer}.closed-indices ul{margin-top:5px;list-style-type:square;margin-left:25px}#streamrule-form-modal .well{font-family:Open Sans,sans-serif!important}.search-help{margin:0 5px;line-height:34px}.no-widgets{margin-top:15px}table .dc-table-column{word-break:break-all}.quickvalues-table th,.sources th{background-color:#333;color:#fff;font-weight:400}.quickvalues-table .dc-table-column._3,.sources .dc-table-column._3{padding-right:0;text-align:right}.dynatable-per-page-label,.dynatable-search{font-size:14px}.dynatable-per-page select,.dynatable-search input{position:relative;top:3px;margin-left:3px}.dynatable-pagination-links li:first-child{display:none}.field-graph-query-container{position:relative;padding-left:10px}.field-graph-query{font-family:monospace;color:#9da096}.field-graph-container .reposition-handle{cursor:move}.field-graph-container .merge-hint{text-align:center;position:relative;top:-115px;margin-bottom:-21px;display:none;z-index:2000}.field-graph-container .merge-hint span{padding:15px 50px;font-size:15px;color:#fff}.field-graph-container .merge-drop-ready{background-color:#000}.parse-error{background-color:#f2dede;color:#a94442;padding-left:2px;padding-right:2px}.field-graph-query-color{width:8px;height:8px;display:inline-block;margin-right:1px}.messages th i.sort-order-desc{position:relative;top:-1px}.messages th i.sort-order-item{margin-right:2px;color:#222}.messages th:hover i.sort-order-item,.messages th i.sort-order-active{color:#fff}.add-alert-type{margin-bottom:0}.alert-type-form{font-size:14px;margin-top:15px}.alert-type-form .help-text{color:#939393;font-size:12px;margin-left:10px}.alert-type-form input[type=number],.alert-type-form input[type=text],.alert-type-form select{padding:0 0 0 5px;height:25px;vertical-align:baseline;width:50px}.alert-type-form input[type=text]{width:200px}.alert-type-form input.alert-type-title{width:300px}.add-alert-destination-type{margin-bottom:0}.alert-destination-form{display:none;font-size:14px;margin-top:15px}#add-alert-receivers{margin-top:15px}#add-alert-receivers span.twitter-typeahead{vertical-align:middle}.alert-receivers{padding-left:10px}.alerts{margin-top:15px}.alerts tbody{border:none}.alerts th{background-color:#333;color:#fff;font-weight:400}.alerts th a{display:block}.alerts th a:focus{color:#fff}li.alert-condition-item:not(:last-child){margin-bottom:10px;border-bottom:1px solid #ececec}.alert-condition .in-grace{color:#8c8e86}.alert-conditions hr{margin-top:7px;margin-bottom:7px}.dashboardeditpermissions,.streameditpermissions{margin-top:10px}.query-exception{margin-bottom:0}input.required-input-highlight{border-color:#e9322d;color:#e9322d}.widget .replay-link{color:#000}.widget .replay-link:hover{text-decoration:none}.zeroclipboard-is-hover{color:#333;background-color:#d7d9d9;border-color:#c3c8c8;cursor:move}.zeroclipboard-is-active{color:#1a5273}.result-highlight-colored{background-color:#ffec3d}.result-highlight-control label{font-size:12px;display:inline-block}.result-highlight-control label>*{vertical-align:middle}.node-state{cursor:help}.node-row .dropdown-menu a.selected{font-weight:700}#result-graph-timeline .annotation .content{left:-120px}#result-graph-timeline .annotation .content:before{left:117px}.annotation .content{margin-bottom:10px;cursor:auto!important}.xtrc-order-handle{cursor:move;margin-right:2px}.xtrc-order-active{background-color:#00a5cf}textarea.textarea-xlarge{width:95%;height:300px}.extractor-json{font-family:monospace;font-size:13px}.scrollable-table{width:100%;overflow:auto}.well.configuration-well{margin-top:5px;margin-bottom:0;padding:9px;font-family:monospace;word-wrap:break-word}.well.configuration-well>ul{padding:0;margin:0}.well.react-configuration-well{white-space:pre-line}.well.configuration-well .configuration-section{margin-bottom:10px}.well.configuration-well li:not(:last-child){margin-bottom:5px}.well.configuration-well .key{display:inline}.alert-callback .well.configuration-well .key{display:inline-block;min-width:140px;vertical-align:top}.well.configuration-well .value{display:inline}.alert-callback .well.configuration-well .value{display:inline-block}.card{padding:12px 20px;font-size:15px;font-weight:300;background-color:#fafafa;border:1px solid #ececec;border-radius:2px;margin:10px}.card h1{margin-bottom:5px;font-size:28px;line-height:1;letter-spacing:-1}.card label{font-weight:inherit}.card div{margin-left:0}.card ul li{margin-bottom:5px}.card.info p{margin:0}.card .configuration-bundles .bundle-preview{border:1px solid #ececec;border-radius:2px;background-color:#fff;padding:20px}.card .configuration-bundles .bundle-preview pre{background-color:#f5f5f5}.configuration-bundles .accordion{background-color:#fff;border:1px solid #ececec;border-radius:2px}.configuration-bundles .accordion-group{margin:0;border:0;border-bottom:1px solid #ececec;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0}.configuration-bundles .accordion-inner{padding-left:30px}.configuration-bundles .accordion-inner .upload input[type=file]{height:32px}.configuration-bundles .bundle-preview{background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:3px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05);padding:10px}.configuration-bundles .bundle-preview .preview-actions form{display:inline-block;margin-left:20px;margin-bottom:0}.configuration-bundles .bundle-preview .preview-actions form:first-child{margin-left:0}.configuration-bundles .bundle-preview pre{background-color:#cfcfcf}.configuration-bundles .bundle-preview dd{margin-bottom:10px}.bundle-preview ol,.bundle-preview ul{margin:0 0 10px 25px}.bundle-preview ul{list-style-type:circle}.build-content-pack button.select-all{margin-top:7px;padding:0}#react-configuration-bundles{font-size:14px;font-weight:400;line-height:20px;margin-top:15px}.form-inline label{margin-right:10px}.form-horizontal .help-block.help-standalone{line-height:20px;margin-top:7px}.form-horizontal.pull-left label.control-label{width:auto}.form-horizontal.pull-left div.controls{display:inline-block;float:right;margin-left:20px}.sources-title{height:22px;line-height:22px;vertical-align:top}.sources-filtering{margin-top:10px}.sources-filtering .control-group{margin-bottom:0}#dc-sources-pie-chart svg{margin-top:20px}#dc-sources-pie-chart g.pie-slice.highlighted{fill-opacity:.8}.form-horizontal .control-group .controls .checkbox-control:first-child{padding-top:5px}.form-horizontal .control-group .controls .checkbox-control label.checkbox{display:inline-block}.form-horizontal .control-group .controls .checkbox-control span.help-inline{vertical-align:top}form.extractor-form .control-group label{display:inline-block}.fa-mini{font-size:10px}.configuration-bundles input[type=file]{line-height:inherit!important}table td.actions,table th.actions{width:110px}#grok-pattern-list th.name{min-width:200px}#grok-pattern-list td{word-break:break-all}.btn-text{font-family:Open Sans,sans-serif;font-size:12px;padding:0;vertical-align:baseline}.message-loader-form input{margin-right:5px}ul.streams{padding:0;margin:0}ul.streams li.stream{display:block;padding:15px 0}ul.streams li.stream:not(:last-child){border-bottom:1px solid #6dcff6}ul.streams li.stream .stream-data{margin-top:8px}ul.streams li.stream .stream-data .stream-actions{position:relative;float:right;right:0;bottom:20px}ul.streams li.stream .stream-data .stream-actions form.action-form{display:inline-block}ul.streams li.stream .stream-data .stream-actions .btn-delete{margin-left:15px;margin-right:15px}ul.streams li.stream .stream-data .stream-actions .btn-delete.last{margin-right:0}ul.streams li.stream .stream-description{margin-bottom:3px}ul.streams li.stream .streamrules-details{margin-top:15px}ul.streams li.stream .streamrules-list{margin:0;padding:0}ul.streams li.stream .streamrules-list li{margin-bottom:3px}.stream-stopped{position:relative;top:-3px}ul.entity-list{padding:0;margin:0}ul.entity-list li.entity-list-item{display:block;padding:15px 0}ul.entity-list li.entity-list-item h2 .label{margin-left:5px;line-height:2;vertical-align:bottom}ul.entity-list li.entity-list-item .item-description{min-height:17px;margin:5px 0}ul.entity-list li.entity-list-item .item-actions>.btn,ul.entity-list li.entity-list-item .item-actions>.btn-group,ul.entity-list li.entity-list-item .item-actions>span>.btn{margin-left:5px;margin-bottom:5px}ul.entity-list li.entity-list-item:not(:last-child){border-bottom:1px solid #6dcff6}.breadcrumb{margin-bottom:10px!important;margin-left:-15px;margin-right:-15px}.graylog-node{margin-top:15px}.graylog-node-title{margin-top:8px}dl.graylog-node-state{margin-top:0;margin-bottom:0}dl.graylog-node-state dt{float:left}dl.graylog-node-state dd{margin-left:180px}.graylog-node .graylog-node-heap{margin-top:10px}.graylog-node .graylog-node-heap .progress{height:25px;margin-bottom:5px}span.blob{display:inline-block;width:9px;height:9px;margin-left:2px}#message-table-paginator-top{width:90%}#message-table-paginator-top ul{margin:0}#message-table-paginator-bottom{height:75px;margin-top:20px}#message-table-paginator-bottom nav{background-color:hsla(0,0%,100%,.9);border-top:1px solid #ddd;margin-left:-10px}#message-table-paginator-bottom .affix{z-index:3;bottom:1px}#message-table-paginator-bottom .affix-bottom{position:absolute}#message-table-paginator-bottom .affix-bottom nav{border:0}.search-results-table{border-left:2px solid #e3e3e3;margin-left:-13px;overflow-y:auto}.search-results-table>div{border-left:1px solid #d1d1d1}.messages-container{padding-right:13px;width:100%}table.messages{position:relative;font-size:11px;margin-top:15px;margin-bottom:60px;border-collapse:collapse;padding-left:13px;width:100%;word-break:break-all}table.messages thead>tr{color:#fff}table.messages td,table.messages th{position:relative;left:13px}table.messages>thead th{border:0;font-size:11px;font-weight:400;background-color:#222;white-space:nowrap}table.messages tr{border:0!important}table.messages tbody.message-group{border-top:0}table.messages tbody.message-group-toggled{border-left:7px solid #16ace3}table.messages tbody.message-highlight{border-left:7px solid #8dc63f}table.messages tr.fields-row{cursor:pointer}table.messages tr.fields-row td{padding-top:10px}table.messages tr.message-row td{border-top:0;padding-top:0;padding-bottom:5px;font-family:monospace;color:#16ace3}table.messages tr.message-row{margin-bottom:5px;cursor:pointer}table.messages tr.message-row .message-wrapper{line-height:1.5em;white-space:pre-line;max-height:6em;overflow:hidden}table.messages tr.message-row .message-wrapper:after{content:\"\";text-align:right;position:absolute;width:99%;left:5px;top:4.5em;height:1.5em;background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff 95%)}table.messages tr.message-detail-row{display:none}table.messages tr.message-detail-row td{padding-top:5px;border-top:0}table.messages tr.message-detail-row .row{margin-right:0}table.messages tr.message-detail-row div[class*=col-]{padding-right:0}.message-details-title{height:30px}.message-details-title a{color:#000}.message-details-title .label{font-size:50%;line-height:200%;margin-left:5px;vertical-align:bottom}dl.message-details{margin-top:10px;margin-bottom:0}dl.message-details dt{font-weight:700;margin-left:1px}dl.message-details dd{margin-bottom:5px;padding-bottom:5px;margin-left:1px}dl.message-details-fields span:not(:last-child) dd{border-bottom:1px solid #ececec}dl.message-details-fields dd{white-space:pre-wrap}dl.message-details-fields .field-value{font-family:monospace}dl.message-details-fields dd.message-field .field-value{max-height:500px;overflow:auto}dl.message-details dd.stream-list ul{list-style-type:disc;padding-left:25px}dl.message-details dd.stream-list ul li{margin-top:3px}dl.message-details dd div.message-field-actions{padding-left:10px;position:relative;top:-10px}.greyed-out{filter:alpha(opacity=50);opacity:.5;-moz-opacity:.5;z-index:20}div#navigation-bar ul.dropdown-menu li a{font-size:12px}div#navigation-bar ul.dropdown-menu{padding-top:10px;padding-bottom:10px}div#navigation-bar ul.dropdown-menu li{padding:2px 2px 2px 0}div#navigation-bar ul.dropdown-menu li.divider{padding:0}.indexer-failures-body select.dynatable-per-page-select{position:relative;top:0}table.indexer-failures{margin-top:10px}.graylog-node-heap .progress,.journal-details-usage .progress,.node-buffer-usage .progress,div.row-sm{margin-bottom:5px}.journal-details-usage .progress{margin-top:10px}.journal-details-usage .progress .progress-bar{min-width:3em}.progress-bar{max-width:100%}.graylog-node-heap p{margin-bottom:0}.graylog-node-heap .used-memory{background-color:#9e1f63}.graylog-node-heap .committed-memory{background-color:#f7941e}.graylog-node-heap .max-memory{background-color:#f5f5f5}dl.system-rest,dl.system-system{margin-top:5px;margin-bottom:0}.table-sm{margin-bottom:0}.graylog-input{margin-top:15px;border-bottom:1px}.graylog-input-actions{margin-top:5px;text-align:right}.graylog-input-subtitle{margin-top:5px;margin-bottom:0}.graylog-input-error{position:relative;top:-4px;margin:0;padding:7px 7px 7px 10px}.graylog-input-error a{font-weight:400}.graylog-input-error i.master-node{display:none}.graylog-input-metrics{margin-top:5px}.react-input-metrics{margin-top:5px;font-size:13px}.input-io .value{font-family:monospace}.input-io .persec{margin-left:3px}.input-io .channel-direction{position:relative;left:-1px}.input-io .channel-direction-down{position:relative;top:1px}.input-io .channel-direction-up{position:relative;top:-1px}#field-statistics th{cursor:pointer}.alert-type-form{line-height:26px}.alert-type-form label.radio-inline{margin-right:0;vertical-align:baseline}.alert-type-form .radio-inline input[type=radio]{position:relative;margin-left:-20px;margin-right:5px}.alert-type-form div.well{margin-bottom:0}.alert-type-form .threshold-type{margin:0 5px;vertical-align:baseline}.form-inline .alert-type-form .form-control{vertical-align:baseline}.filter .form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.no-alarm-callbacks{margin-top:10px}div.alert-callback hr{margin-top:10px;margin-bottom:10px}div.alert-callbacks{margin-top:10px}.alarm-callbacks{padding:0}.alarm-callbacks li:not(:last-child){margin-bottom:10px;padding-bottom:10px;border-bottom:1px solid #ececec}.triggered-alerts .page-size{margin-top:-23px}.toggle-stream-button{width:8.5em}.threaddump{font-size:11px}.stream-rules-link{margin-left:5px}.modal-body .form-group{margin-bottom:5px}h2.extractor-title{margin-bottom:2px}p.failure-exception{margin-top:5px;margin-bottom:10px;color:#aaa}i.error-icon{position:relative;top:-3px}.support-sources ul{margin:0;padding:0;margin-top:5px}.failure-object{padding:6px 10px 10px;margin:10px 0 0;font-family:monospace}.stream-description .fa-cube{margin-right:5px}.content-head .btn-lg{font-size:16px}.stream-loader{margin-top:5px}.streamrules-list{margin:0;padding:0}#field-statistics table{margin-top:10px}.quickvalues-visualization{padding-top:15px}.quickvalues-visualization .dc-chart{float:none}.quickvalues-visualization .col-md-8{padding-right:0}.form-inline .typeahead-wrapper{display:inline-block;vertical-align:middle;width:auto}.list-group-header{background-color:#f1f2f2;padding:0 15px}.list-group-header .form-group{margin:0}.form-group-inline{display:inline-block;margin:0}ul.pill-list,ul.tag-list{display:inline-block;list-style:none;padding:0;position:relative}ul.pill-list{margin-left:10px;vertical-align:middle}ul.pill-list>li,ul.tag-list>li{display:inline-block;vertical-align:middle}.tags-input ul.tag-list>li{padding-top:10px;padding-bottom:5px}.pill,.tag{font-size:14px;margin-right:5px}.pill{background-color:#e3e5e5;padding:6px 12px;line-height:1.42857143}.pill,.pill-remove,.tag-remove{color:#333;vertical-align:middle}.pill-remove,.tag-remove{cursor:pointer;margin-left:5px}.pill-remove:before,.tag-remove:before{content:\"\\D7\"}.streamrule-connector-type-form label{font-size:12px}.streamrule-connector-type-form{margin-top:10px;margin-bottom:13px}.streamrule-connector-type-form .form-group{margin-bottom:5px}.streamrule-connector-type-form .radio{margin-top:0;margin-bottom:0}.streamrule-connector-type-form input[type=radio]{margin-top:2px;margin-bottom:2px}#react-gettingstarted{margin-left:-19px;margin-right:-19px;margin-top:-4px}#react-gettingstarted iframe{height:1000px}.sortable-list-cursor{cursor:move}.sortable-list .dragging{opacity:.5}.sortable-list .over{border:1px dashed #8c8e86}.sortable-list .sortable-list-item:first-child .list-group-item{border-top-right-radius:4px;border-top-left-radius:4px}.sortable-list .sortable-list-item:last-child .list-group-item{border-bottom-right-radius:4px;border-bottom-left-radius:4px;margin-bottom:0}.sortable-list .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.sortable-list .list-group-item:last-child{border-bottom-right-radius:0;border-bottom-left-radius:0}.field-analyzer{margin-left:0!important;margin-top:10px!important}.save-button-margin{margin-right:5px}.form-control.message-id-input{width:300px}", ""]);
	
	// exports


/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Open Sans;font-style:normal;font-weight:300;src:local(\"Open Sans Light\"),local(\"OpenSans-Light\");src:url(" + __webpack_require__(623) + ");src:url(" + __webpack_require__(623) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1152) + ") format(\"woff\")}@font-face{font-family:Open Sans;font-style:normal;font-weight:400;src:local(\"Open Sans\"),local(\"OpenSans\");src:url(" + __webpack_require__(624) + ");src:url(" + __webpack_require__(624) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1153) + ") format(\"woff\")}@font-face{font-family:Open Sans;font-style:italic;font-weight:400;src:local(\"Open Sans Italic\"),local(\"OpenSans-Italic\");src:url(" + __webpack_require__(622) + ");src:url(" + __webpack_require__(622) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1151) + ") format(\"woff\")}@font-face{font-family:Open Sans;font-style:normal;font-weight:600;src:local(\"Open Sans Semibold\"),local(\"OpenSans-Semibold\");src:url(" + __webpack_require__(625) + ");src:url(" + __webpack_require__(625) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1154) + ") format(\"woff\")}@font-face{font-family:Open Sans;font-style:normal;font-weight:700;src:local(\"Open Sans Bold\"),local(\"OpenSans-Bold\");src:url(" + __webpack_require__(620) + ");src:url(" + __webpack_require__(620) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1149) + ") format(\"woff\")}@font-face{font-family:Open Sans;font-style:normal;font-weight:800;src:local(\"Open Sans Extrabold\"),local(\"OpenSans-Extrabold\");src:url(" + __webpack_require__(621) + ");src:url(" + __webpack_require__(621) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(1150) + ") format(\"woff\")}", ""]);
	
	// exports


/***/ },
/* 1131 */,
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".ws-important-hide{display:none!important;visibility:hidden!important;position:absolute;top:-999999px}.ws-capture-file>button,.ws-custom-file>button,.ws-po-box button{display:inline-block;overflow:visible;position:relative;margin:0;border:0;padding:0;-webkit-appearance:none;appearance:none;font-family:inherit;background:transparent;cursor:pointer;font-size:inherit;line-height:inherit;touch-action:none}.ws-capture-file>button::-moz-focus-inner,.ws-custom-file>button::-moz-focus-inner,.ws-po-box button::-moz-focus-inner{border:0;padding:0}.ws-capture-file>button[disabled],.ws-custom-file>button[disabled],.ws-po-box button[disabled]{cursor:default;color:#888}[hidden]{display:none}article,aside,canvas,details,figcaption,figure,footer,header,hgroup,main,nav,section,summary{display:block}audio{display:none;height:0;width:0}audio,video{overflow:hidden}audio[controls],video{display:inline-block;min-height:45px;min-width:40px}audio[controls]{width:300px}.polyfill-mediaelement>iframe{border:0;padding:0;margin:0;width:100%;height:100%}.flashblocker-assumed{min-height:20px;min-width:20px;z-index:99999}.cue-display{position:absolute!important;margin:0;padding:0!important;max-width:100%!important;max-height:100%!important;border:0!important;background:none!important;text-align:center;visibility:hidden;font-family:sans-serif;font-size:12px;white-space:pre-wrap;cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cue-display b{font-weight:700}.cue-display i{font-style:italic}.cue-display u{text-decoration:underline}.cue-display span.cue-wrapper{position:absolute;left:0;bottom:0;right:0;display:block;padding:0;margin:0;width:100%;font-size:160%;color:#fff;visibility:visible!important;pointer-events:none}.cue-display .cue-line{display:block}.cue-display span.cue{display:inline-block;padding:3px 5px;background:#000;background:rgba(0,0,0,.7);color:#fff}.cue-display .description-cues{position:absolute;top:-99px;left:-99px;display:block;width:5px;height:5px;overflow:hidden}mark{background-color:#ff9;color:#000;font-style:italic;font-weight:700}.details-open-indicator,.placeholder-box,.placeholder-text,progress span.progress-value{margin:0;padding:0;border:0;width:auto;background:transparent none}output{position:relative}.webshims-visual-hide{position:absolute!important;top:0!important;left:0!important;visibility:hidden!important;width:0!important;height:0!important;overflow:hidden!important}.placeholder-box{position:relative;display:inline-block;zoom:1}.placeholder-box-input{vertical-align:bottom}.placeholder-box-left{float:left}.placeholder-box-right{float:right}.placeholder-text{position:absolute;display:none;top:0;left:0;overflow:hidden;color:#999;line-height:1;cursor:text}.placeholder-text.placeholder-visible,.placeholder-visible .placeholder-text{display:inline-block}.placeholder-box-input .placeholder-text{white-space:nowrap}.placeholder-visible{color:#999}.placeholder-focused.placeholder-visible{color:#ccc}.ws-popover{font-size:13px;display:block;visibility:hidden;overflow:hidden;position:absolute;top:0;left:0;outline:0;padding:0 .92308em;margin:0 0 0 -.92308em;z-index:1100;min-width:3.84615em;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:visibility .4s ease-in-out;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;direction:ltr;-webkit-tap-highlight-color:transparent}.ws-popover.ws-popover-constrained-width{box-sizing:content-box}.ws-popover.ws-is-rtl{direction:rtl;margin:0 0 0 .92308em}.ws-popover.no-transition{display:none}.ws-popover.ws-po-visible{visibility:visible;display:block}.ws-popinline{position:relative;visibility:visible;display:none}.ws-po-outerbox{position:relative;opacity:0;padding:.84615em 0 .69231em;-webkit-transform:translateY(-100%);transform:translateY(-100%);transition:all .4s ease-in-out}[data-vertical=bottom] .ws-po-outerbox{-webkit-transform:translateY(100%);transform:translateY(100%);padding:.30769em 0 .84615em}[data-vertical=middle] .ws-po-outerbox{-webkit-transform:translate(0) scale(.3);transform:translate(0) scale(.3);padding:.30769em 0}.ws-popover.ws-po-visible .ws-po-outerbox,div.ws-popover[data-vertical][data-horizontal].ws-po-visible .ws-po-outerbox{opacity:1;-webkit-transform:translate(0) scale(1);transform:translate(0) scale(1)}.ws-po-box{border:.07692em solid #ccc;background:#fff;color:#000;padding:.38462em .38462em .23077em}.ws-po-arrow{position:absolute;top:.30769em;left:1.53846em;display:block;width:0;height:0;border-left:.61538em solid transparent;border-right:.61538em solid transparent;border-bottom:.61538em solid #ccc;border-top:0;zoom:1}.ws-is-rtl .ws-po-arrow{left:auto;right:1.53846em}[data-horizontal=center] .ws-po-arrow{left:50%;margin-left:-.30769em}[data-horizontal=right] .ws-po-arrow{left:auto;right:1.53846em}[data-vertical=bottom] .ws-po-arrow{top:auto;bottom:.30769em;border-bottom:0;border-top:.61538em solid #ccc}html .ws-po-arrow,html .ws-po-arrow .ws-po-arrowbox{border-left-color:transparent;border-right-color:transparent}[data-vertical=middle] .ws-po-arrow{display:none}.ws-po-arrow .ws-po-arrowbox{position:relative;top:.07692em;left:-.53846em;display:block;width:0;height:0;border-left:.53846em solid transparent;border-right:.53846em solid transparent;border-bottom:.53846em solid #fefefe;border-top:0;z-index:999999999}.ws-is-rtl .ws-po-arrow .ws-po-arrowbox{left:auto;right:-.53846em}[data-vertical=bottom] .ws-po-arrow .ws-po-arrowbox{top:-.61538em;border-bottom:0;border-top:.53846em solid #fefefe}datalist{display:none}input[data-wslist]::-webkit-calendar-picker-indicator{display:none}.datalist-polyfill{position:absolute;text-align:left}.datalist-polyfill .ws-po-box{padding:.38462em 0}.datalist-polyfill .datalist-box{position:relative;max-height:15.38462em;overflow:hidden;overflow-x:hidden!important;overflow-y:auto}.datalist-polyfill .datalist-box li,.datalist-polyfill .datalist-box ul{font-size:100%;list-style:none!important}.datalist-polyfill .datalist-box ul{position:static!important;overflow:hidden;margin:0;padding:.07692em 0;height:auto!important;background-color:#fff;color:#000}.datalist-polyfill .datalist-box li{margin:.07692em 0;padding:.30769em .76923em;white-space:nowrap;cursor:default;zoom:1;overflow:hidden;text-overflow:ellipsis;background-color:#fff;transition:background-color .4s;touch-action:none}.datalist-polyfill .datalist-box mark{font-weight:400;font-style:normal}.datalist-polyfill .datalist-box .option-value{display:block;text-overflow:ellipsis;max-width:100%;color:#000;transition:color .4s}.datalist-polyfill .datalist-box .option-label{display:none;font-size:90%;color:#666;text-overflow:ellipsis;margin-top:.1em;transition:color .4s}.datalist-polyfill .datalist-box .has-option-label .option-label{display:block}.datalist-polyfill .datalist-box .hidden-item{display:none!important}.datalist-polyfill .datalist-box .active-item{cursor:default;background-color:#39f}.datalist-polyfill .datalist-box .active-item .option-value{color:#fff}.datalist-polyfill .datalist-box .active-item .option-label{color:#eee}.validity-alert{display:inline-block;z-index:1000000000}.validity-alert .ws-titlevalue{display:block}.ws-errorbox{display:none;border:0;margin:0;padding:0;overflow:hidden;position:relative;clear:both;font-family:sans-serif}.ws-errorbox p{margin:2px 0 3px;padding:0;color:#a94442}progress{position:relative;display:inline-block;width:164px;height:20px;overflow:hidden;box-sizing:border-box;vertical-align:-.2em}progress.ws-style{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;border:1px solid #ddd;background:#f0f0f0}progress.ws-style::-webkit-progress-bar{border:1px solid #ddd;background:#f0f0f0;border:0 none}progress.ws-style::-moz-progress-bar{border:1px solid #ddd;background:#f0f0f0}progress.ws-style::-ms-fill{animation-name:none;border:1px solid #ddd;background:#f0f0f0}progress.ws-style>span.progress-value{left:0}progress.ws-style.ws-is-rtl>span.progress-value{left:auto;right:0}progress.ws-style::-webkit-progress-value{position:absolute;top:0;bottom:0;height:100%;background:#0063a6 url(" + __webpack_require__(222) + ");border:0}progress.ws-style::-moz-progress-bar{position:absolute;top:0;bottom:0;height:100%;background:#0063a6 url(" + __webpack_require__(222) + ");border:0}progress.ws-style::-ms-fill{animation-name:none;position:absolute;top:0;bottom:0;height:100%;background:#0063a6 url(" + __webpack_require__(222) + ");border:0}progress.ws-style>span.progress-value{display:block!important;position:absolute;top:0;bottom:0;height:100%;background:#0063a6 url(" + __webpack_require__(222) + ");border:0}progress.ws-style:indeterminate::-webkit-progress-bar{background-image:url(" + __webpack_require__(219) + ")}progress.ws-style:indeterminate::-moz-progress-bar{background-image:url(" + __webpack_require__(219) + ")}progress.ws-style:indeterminate{animation-name:none;background-image:url(" + __webpack_require__(219) + ")}progress.ws-style.ws-indeterminate>span.progress-value{display:block!important;width:100%;right:0;background-image:url(" + __webpack_require__(219) + ")}details{overflow:hidden}summary{position:relative}.closed-details-child{display:none!important}.details-open-indicator{margin:-1px 0 0;display:inline-block;margin-right:.4em;width:0;height:0;border-style:solid;border-width:.76923em .38462em 0;border-color:#000 transparent transparent;vertical-align:middle}.closed-details-summary .details-open-indicator{border-width:.38462em 0 .38462em .76923em;border-color:transparent transparent transparent #000}summary.summary-has-focus{outline:1px dotted #aaa;outline-offset:-1px}.ws-capture-file,.ws-custom-file{position:relative;overflow:hidden}.ws-capture-file>button,.ws-capture-file>input,.ws-custom-file>button,.ws-custom-file>input{box-sizing:border-box;cursor:pointer}.ws-capture-file>.ws-file-value,.ws-capture-file>button,.ws-custom-file>.ws-file-value,.ws-custom-file>button{position:relative;z-index:0;display:inline-block;padding:.38462em;border:1px solid #ccc;background:#eee;color:#333;transition:all .4s}.ws-capture-file>button,.ws-custom-file>button{margin-right:.4em;float:left}.ws-capture-file>button{padding-bottom:.30769em;padding-top:.30769em}.ws-custom-file .ws-file-value{display:block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.ws-custom-file .ws-coverfile,.ws-custom-file>input[type=file]{position:absolute;top:-1%;left:-3%;bottom:-1%;right:-1%;height:102%;width:104%;z-index:9;padding:0;margin:0;border:0 none;color:transparent;background:transparent}.ws-custom-file>input[type=file]{filter:alpha(opacity=0);opacity:.00001}.ws-custom-file>input[type=file][disabled]{cursor:default;cursor:not-allowed}.ws-custom-file .ws-coverfile{background:url(" + __webpack_require__(1258) + ");z-index:10;cursor:pointer}[readonly]+.ws-custom-file .ws-coverfile{cursor:default}[disabled]+.ws-custom-file .ws-coverfile{cursor:default;cursor:not-allowed}.ws-custom-file>.moxie-shim{z-index:20}.ws-custom-file.ws-mouseenter>button,.ws-custom-file:hover>button,.ws-custom-file>input[type=file]:focus~button{background:#fff;border-color:#999;background:#eee linear-gradient(transparent,rgba(0,0,0,.05) 40%,rgba(0,0,0,.1))}.ws-custom-file.ws-mouseenter>.ws-file-value,.ws-custom-file:hover>.ws-file-value,.ws-custom-file>input[type=file]:focus~.ws-file-value{border-color:#999}.ws-custom-file.ws-active>.ws-file-value,.ws-custom-file.ws-active>button,.ws-custom-file>input[type=file]:active~.ws-file-value,.ws-custom-file>input[type=file]:active~button{border-color:#000}.ws-custom-file>input[type=file][disabled]~.ws-file-value,.ws-custom-file>input[type=file][disabled]~button{border-color:#bbb;background:#eee;color:#999}.ws-sticky{top:auto;left:auto!important;right:auto!important;bottom:auto;position:static;position:-webkit-sticky;position:-ms-sticky;position:sticky;float:none!important;margin-left:0;margin-right:0}tbody.ws-sticky,tfoot.ws-sticky,thead.ws-sticky{margin-left:-.8px;margin-right:-1px}.ws-sticky.ws-sticky-on{position:fixed!important}.ws-fixedsticky-placeholder{position:static!important;visibility:hidden!important;padding:0;border:0;margin:0;left:-999px;zoom:1}", ""]);
	
	// exports


/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.2 (http://getbootstrap.com)\n * Copyright 2011-2015 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n\n/*!\n * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=479c4402f5d9ee9aeb83)\n * Config saved to config.json and https://gist.github.com/479c4402f5d9ee9aeb83\n *//*! normalize.css v3.0.2 | MIT License | git.io/normalize */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}select{background:#fff!important}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#666;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#9e1f63;text-decoration:none}a:focus,a:hover{color:#5e123b;text-decoration:underline}a:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #fff}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#aaa}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#aaa}.text-primary{color:#9e1f63}a.text-primary:hover{color:#731748}.text-success{color:#3c763d}a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#9e1f63}a.bg-primary:hover{background-color:#731748}.bg-success{background-color:#dff0d8}a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #fff}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #aaa}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #fff}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#aaa}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #fff;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;word-break:break-all;word-wrap:break-word;color:#666;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.row{margin-left:-15px;margin-right:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#aaa}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#666;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#888}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{cursor:not-allowed;background-color:#fff;opacity:1}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date],input[type=datetime-local],input[type=month],input[type=time]{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-left:0;padding-right:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.form-group-sm .form-control{height:30px;line-height:30px}select[multiple].form-group-sm .form-control,textarea.form-group-sm .form-control{height:auto}.form-group-sm .form-control-static{height:30px;padding:5px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.form-group-lg .form-control{height:46px;line-height:46px}select[multiple].form-group-lg .form-control,textarea.form-group-lg .form-control{height:auto}.form-group-lg .form-control-static{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#a6a6a6}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:14.333333px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;pointer-events:none;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.btn-default{color:#333;background-color:#f1f2f2;border-color:#e3e5e5}.btn-default.active,.btn-default.focus,.btn-default:active,.btn-default:focus,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#d7d9d9;border-color:#c3c8c8}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled,.btn-default.disabled.active,.btn-default.disabled.focus,.btn-default.disabled:active,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled],.btn-default[disabled].active,.btn-default[disabled].focus,.btn-default[disabled]:active,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default,fieldset[disabled] .btn-default.active,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:active,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#f1f2f2;border-color:#e3e5e5}.btn-default .badge{color:#f1f2f2;background-color:#333}.btn-primary{color:#fff;background-color:#9e1f63;border-color:#891b56}.btn-primary.active,.btn-primary.focus,.btn-primary:active,.btn-primary:focus,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#731748;border-color:#561136}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled,.btn-primary.disabled.active,.btn-primary.disabled.focus,.btn-primary.disabled:active,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled],.btn-primary[disabled].active,.btn-primary[disabled].focus,.btn-primary[disabled]:active,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary,fieldset[disabled] .btn-primary.active,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:active,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#9e1f63;border-color:#891b56}.btn-primary .badge{color:#9e1f63;background-color:#fff}.btn-success{color:#fff;background-color:#8dc63f;border-color:#80b636}.btn-success.active,.btn-success.focus,.btn-success:active,.btn-success:focus,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#72a230;border-color:#5f8628}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled,.btn-success.disabled.active,.btn-success.disabled.focus,.btn-success.disabled:active,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled],.btn-success[disabled].active,.btn-success[disabled].focus,.btn-success[disabled]:active,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success,fieldset[disabled] .btn-success.active,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:active,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#8dc63f;border-color:#80b636}.btn-success .badge{color:#8dc63f;background-color:#fff}.btn-info{color:#fff;background-color:#16ace3;border-color:#149acc}.btn-info.active,.btn-info.focus,.btn-info:active,.btn-info:focus,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#1189b5;border-color:#0e7094}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled,.btn-info.disabled.active,.btn-info.disabled.focus,.btn-info.disabled:active,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled],.btn-info[disabled].active,.btn-info[disabled].focus,.btn-info[disabled]:active,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info,fieldset[disabled] .btn-info.active,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:active,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#16ace3;border-color:#149acc}.btn-info .badge{color:#16ace3;background-color:#fff}.btn-warning{color:#fff;background-color:#f7941e;border-color:#f38809}.btn-warning.active,.btn-warning.focus,.btn-warning:active,.btn-warning:focus,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#da7a08;border-color:#b86707}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled,.btn-warning.disabled.active,.btn-warning.disabled.focus,.btn-warning.disabled:active,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled],.btn-warning[disabled].active,.btn-warning[disabled].focus,.btn-warning[disabled]:active,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning,fieldset[disabled] .btn-warning.active,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:active,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f7941e;border-color:#f38809}.btn-warning .badge{color:#f7941e;background-color:#fff}.btn-danger{color:#fff;background-color:#ff3b00;border-color:#e63500}.btn-danger.active,.btn-danger.focus,.btn-danger:active,.btn-danger:focus,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#cc2f00;border-color:#a82700}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled,.btn-danger.disabled.active,.btn-danger.disabled.focus,.btn-danger.disabled:active,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled],.btn-danger[disabled].active,.btn-danger[disabled].focus,.btn-danger[disabled]:active,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger,fieldset[disabled] .btn-danger.active,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:active,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#ff3b00;border-color:#e63500}.btn-danger .badge{color:#ff3b00;background-color:#fff}.btn-link{color:#9e1f63;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#5e123b;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#aaa;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none;visibility:hidden}.collapse.in{display:block;visibility:visible}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-property:height,visibility;transition-property:height,visibility;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-timing-function:ease;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#666;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#595959;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#9e1f63}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#aaa}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#aaa;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px solid;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{left:auto;right:0}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-bottom-left-radius:4px;border-top-right-radius:0;border-top-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#888;text-align:center;background-color:#fff;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#fff}.nav>li.disabled>a{color:#aaa}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#aaa;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#fff;border-color:#9e1f63}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#fff #fff #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#888;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#9e1f63}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none;visibility:hidden}.tab-content>.active{display:block;visibility:visible}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;visibility:visible!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#d0d0d0}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#d0d0d0}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#080808;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#d0d0d0}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#d0d0d0}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#d0d0d0}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#aaa}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857143;text-decoration:none;color:#9e1f63;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{color:#5e123b;background-color:#fff;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:2;color:#fff;background-color:#9e1f63;border-color:#9e1f63;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#aaa;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#fff}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#aaa;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#aaa}.label-default[href]:focus,.label-default[href]:hover{background-color:#919191}.label-primary{background-color:#9e1f63}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#731748}.label-success{background-color:#8dc63f}.label-success[href]:focus,.label-success[href]:hover{background-color:#72a230}.label-info{background-color:#16ace3}.label-info[href]:focus,.label-info[href]:hover{background-color:#1189b5}.label-warning{background-color:#f7941e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#da7a08}.label-danger{background-color:#ff3b00}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#cc2f00}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:baseline;white-space:nowrap;text-align:center;background-color:#aaa;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#9e1f63;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding:30px 15px;margin-bottom:30px;background-color:#fff}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#e6e6e6}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding:48px 0}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-left:auto;margin-right:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#9e1f63}.thumbnail .caption{padding:9px;color:#666}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#9e1f63;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#8dc63f}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#16ace3}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f7941e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#ff3b00}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item{color:#555}a.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#fff;color:#aaa;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#aaa}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#9e1f63;border-color:#9e1f63}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#ec9dc7}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#666;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#666}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#9e1f63}.panel-primary>.panel-heading{color:#fff;background-color:#9e1f63;border-color:#9e1f63}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#9e1f63}.panel-primary>.panel-heading .badge{color:#9e1f63;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#9e1f63}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#e3e5e5;border:1px solid #d0d4d4;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:absolute;top:0;right:0;left:0;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5;min-height:16.42857143px}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;visibility:visible;font-family:Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-weight:400;line-height:1.4;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;text-decoration:none;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:1.42857143;text-align:left;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2);white-space:normal}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;-webkit-transition:left .6s ease-in-out;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000;perspective:1000}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-webkit-gradient(linear,left top,right top,color-stop(0,rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-webkit-gradient(linear,left top,right top,color-stop(0,rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;margin-top:-10px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-15px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-15px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-15px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important;visibility:hidden!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ },
/* 1134 */,
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.3.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(1156) + ");src:url(" + __webpack_require__(1155) + "?#iefix&v=4.3.0) format(\"embedded-opentype\"),url(" + __webpack_require__(1159) + ") format(\"woff2\"),url(" + __webpack_require__(1160) + ") format(\"woff\"),url(" + __webpack_require__(1158) + ") format(\"truetype\"),url(" + __webpack_require__(1157) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transform:translate(0)}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);-webkit-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before,.fa-genderless:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}", ""]);
	
	// exports


/***/ },
/* 1136 */,
/* 1137 */,
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".rickshaw_graph .detail{pointer-events:none;position:absolute;top:0;z-index:2;background:rgba(0,0,0,.1);bottom:0;width:1px;transition:opacity .25s linear;-moz-transition:opacity .25s linear;-o-transition:opacity .25s linear;-webkit-transition:opacity .25s linear}.rickshaw_graph .detail.inactive{opacity:0}.rickshaw_graph .detail .item.active{opacity:1}.rickshaw_graph .detail .x_label{font-family:Arial,sans-serif;border-radius:3px;padding:6px;opacity:.5;border:1px solid #e0e0e0;font-size:12px;position:absolute;background:#fff;white-space:nowrap}.rickshaw_graph .detail .x_label.left{left:0}.rickshaw_graph .detail .x_label.right{right:0}.rickshaw_graph .detail .item{position:absolute;z-index:2;border-radius:3px;padding:.25em;font-size:12px;font-family:Arial,sans-serif;opacity:0;background:rgba(0,0,0,.4);color:#fff;border:1px solid rgba(0,0,0,.4);margin-left:1em;margin-right:1em;margin-top:-1em;white-space:nowrap}.rickshaw_graph .detail .item.left{left:0}.rickshaw_graph .detail .item.right{right:0}.rickshaw_graph .detail .item.active{opacity:1;background:rgba(0,0,0,.8)}.rickshaw_graph .detail .item:after{position:absolute;display:block;width:0;height:0;content:\"\";border:5px solid transparent}.rickshaw_graph .detail .item.left:after{top:1em;left:-5px;margin-top:-5px;border-right-color:rgba(0,0,0,.8);border-left-width:0}.rickshaw_graph .detail .item.right:after{top:1em;right:-5px;margin-top:-5px;border-left-color:rgba(0,0,0,.8);border-right-width:0}.rickshaw_graph .detail .dot{width:4px;height:4px;margin-left:-2px;margin-top:-2px;border-radius:5px;position:absolute;box-shadow:0 0 2px rgba(0,0,0,.6);background:#fff;border-width:2px;border-style:solid;display:none;background-clip:padding-box}.rickshaw_graph .detail .dot.active{display:block}.rickshaw_graph{position:relative}.rickshaw_graph svg{display:block;overflow:hidden}.rickshaw_graph .x_tick{position:absolute;top:0;bottom:0;width:0;border-left:1px dotted rgba(0,0,0,.2);pointer-events:none}.rickshaw_graph .x_tick .title{position:absolute;font-size:12px;font-family:Arial,sans-serif;opacity:.5;white-space:nowrap;margin-left:3px;bottom:1px}.rickshaw_annotation_timeline{height:1px;border-top:1px solid #e0e0e0;margin-top:10px;position:relative}.rickshaw_annotation_timeline .annotation{position:absolute;height:6px;width:6px;margin-left:-2px;top:-3px;border-radius:5px;background-color:rgba(0,0,0,.25)}.rickshaw_graph .annotation_line{position:absolute;top:0;bottom:-6px;width:0;border-left:2px solid rgba(0,0,0,.3);display:none}.rickshaw_graph .annotation_line.active{display:block}.rickshaw_graph .annotation_range{background:rgba(0,0,0,.1);display:none;position:absolute;top:0;bottom:-6px}.rickshaw_graph .annotation_range.active{display:block}.rickshaw_graph .annotation_range.active.offscreen{display:none}.rickshaw_annotation_timeline .annotation .content{background:#fff;color:#000;opacity:.9;padding:5px;box-shadow:0 0 2px rgba(0,0,0,.8);border-radius:3px;position:relative;z-index:20;font-size:12px;padding:6px 8px 8px;top:18px;left:-11px;width:160px;display:none;cursor:pointer}.rickshaw_annotation_timeline .annotation .content:before{content:\"\\25B2\";position:absolute;top:-11px;color:#fff;text-shadow:0 -1px 1px rgba(0,0,0,.8)}.rickshaw_annotation_timeline .annotation.active,.rickshaw_annotation_timeline .annotation:hover{background-color:rgba(0,0,0,.8);cursor:none}.rickshaw_annotation_timeline .annotation .content:hover{z-index:50}.rickshaw_annotation_timeline .annotation.active .content{display:block}.rickshaw_annotation_timeline .annotation:hover .content{display:block;z-index:50}.rickshaw_graph .x_axis_d3,.rickshaw_graph .y_axis{fill:none}.rickshaw_graph .x_ticks_d3 .tick,.rickshaw_graph .y_ticks .tick{stroke:rgba(0,0,0,.16);stroke-width:2px;shape-rendering:crisp-edges;pointer-events:none}.rickshaw_graph .x_grid_d3 .tick,.rickshaw_graph .y_grid .tick{z-index:-1;stroke:rgba(0,0,0,.2);stroke-width:1px;stroke-dasharray:1 1}.rickshaw_graph .y_grid .tick[data-y-value=\"0\"]{stroke-dasharray:1 0}.rickshaw_graph .x_grid_d3 path,.rickshaw_graph .y_grid path{fill:none;stroke:none}.rickshaw_graph .x_ticks_d3 path,.rickshaw_graph .y_ticks path{fill:none;stroke:gray}.rickshaw_graph .x_ticks_d3 text,.rickshaw_graph .y_ticks text{opacity:.5;font-size:12px;pointer-events:none}.rickshaw_graph .x_tick.glow .title,.rickshaw_graph .y_ticks.glow text{fill:#000;color:#000;text-shadow:-1px 1px 0 hsla(0,0%,100%,.1),1px -1px 0 hsla(0,0%,100%,.1),1px 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1),0 -1px 0 hsla(0,0%,100%,.1),1px 0 0 hsla(0,0%,100%,.1),-1px 0 0 hsla(0,0%,100%,.1),-1px -1px 0 hsla(0,0%,100%,.1)}.rickshaw_graph .x_tick.inverse .title,.rickshaw_graph .y_ticks.inverse text{fill:#fff;color:#fff;text-shadow:-1px 1px 0 rgba(0,0,0,.8),1px -1px 0 rgba(0,0,0,.8),1px 1px 0 rgba(0,0,0,.8),0 1px 0 rgba(0,0,0,.8),0 -1px 0 rgba(0,0,0,.8),1px 0 0 rgba(0,0,0,.8),-1px 0 0 rgba(0,0,0,.8),-1px -1px 0 rgba(0,0,0,.8)}.rickshaw_legend{font-family:Arial;font-size:12px;color:#fff;background:#404040;display:inline-block;padding:12px 5px;border-radius:2px;position:relative}.rickshaw_legend:hover{z-index:10}.rickshaw_legend .swatch{width:10px;height:10px;border:1px solid rgba(0,0,0,.2)}.rickshaw_legend .line{clear:both;line-height:140%;padding-right:15px}.rickshaw_legend .line .swatch{display:inline-block;margin-right:3px;border-radius:2px}.rickshaw_legend .label{margin:0;white-space:nowrap;display:inline;font-size:inherit;background-color:transparent;color:inherit;font-weight:400;line-height:normal;padding:0;text-shadow:none}.rickshaw_legend .action:hover{opacity:.6}.rickshaw_legend .action{margin-right:.2em;font-size:10px;opacity:.2;cursor:pointer;font-size:14px}.rickshaw_legend .line.disabled{opacity:.4}.rickshaw_legend ul{list-style-type:none;margin:0;padding:0;margin:2px;cursor:pointer}.rickshaw_legend li{padding:0 0 0 2px;min-width:80px;white-space:nowrap}.rickshaw_legend li:hover{background:hsla(0,0%,100%,.08);border-radius:3px}.rickshaw_legend li:active{background:hsla(0,0%,100%,.2);border-radius:3px}", ""]);
	
	// exports


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(19)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999}#toast-container *{box-sizing:border-box}#toast-container>div{margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;border-radius:3px 3px 3px 3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>:hover{box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=\")!important}#toast-container>.toast-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=\")!important}#toast-container>.toast-success{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==\")!important}#toast-container>.toast-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=\")!important}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}@media (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:108px}}@media (min-width:241px)and (max-width:320px){#toast-container>div{padding:8px 8px 8px 50px;width:128px}}@media (min-width:321px)and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:192px}}@media (min-width:481px)and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:300px}}", ""]);
	
	// exports


/***/ },
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 *  dc 2.0.0-beta.19
	 *  http://dc-js.github.io/dc.js/
	 *  Copyright 2012-2015 Nick Zhu & the dc.js Developers
	 *  https://github.com/dc-js/dc.js/blob/master/AUTHORS
	 *
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	(function() { function _dc(d3, crossfilter) {
	'use strict';
	
	/**
	 * The entire dc.js library is scoped under the **dc** name space. It does not introduce
	 * anything else into the global name space.
	 *
	 * Most `dc` functions are designed to allow function chaining, meaning they return the current chart
	 * instance whenever it is appropriate.  The getter forms of functions do not participate in function
	 * chaining because they necessarily return values that are not the chart.  Although some,
	 * such as `.svg` and `.xAxis`, return values that are chainable d3 objects.
	 * @namespace dc
	 * @version 2.0.0-beta.19
	 * @example
	 * // Example chaining
	 * chart.width(300)
	 *      .height(300)
	 *      .filter('sunday');
	 */
	/*jshint -W079*/
	var dc = {
	    version: '2.0.0-beta.19',
	    constants: {
	        CHART_CLASS: 'dc-chart',
	        DEBUG_GROUP_CLASS: 'debug',
	        STACK_CLASS: 'stack',
	        DESELECTED_CLASS: 'deselected',
	        SELECTED_CLASS: 'selected',
	        NODE_INDEX_NAME: '__index__',
	        GROUP_INDEX_NAME: '__group_index__',
	        DEFAULT_CHART_GROUP: '__default_chart_group__',
	        EVENT_DELAY: 40,
	        NEGLIGIBLE_NUMBER: 1e-10
	    },
	    _renderlet: null
	};
	/*jshint +W079*/
	
	dc.chartRegistry = (function () {
	    // chartGroup:string => charts:array
	    var _chartMap = {};
	
	    function initializeChartGroup (group) {
	        if (!group) {
	            group = dc.constants.DEFAULT_CHART_GROUP;
	        }
	
	        if (!_chartMap[group]) {
	            _chartMap[group] = [];
	        }
	
	        return group;
	    }
	
	    return {
	        has: function (chart) {
	            for (var e in _chartMap) {
	                if (_chartMap[e].indexOf(chart) >= 0) {
	                    return true;
	                }
	            }
	            return false;
	        },
	
	        register: function (chart, group) {
	            group = initializeChartGroup(group);
	            _chartMap[group].push(chart);
	        },
	
	        deregister: function (chart, group) {
	            group = initializeChartGroup(group);
	            for (var i = 0; i < _chartMap[group].length; i++) {
	                if (_chartMap[group][i].anchorName() === chart.anchorName()) {
	                    _chartMap[group].splice(i, 1);
	                    break;
	                }
	            }
	        },
	
	        clear: function (group) {
	            if (group) {
	                delete _chartMap[group];
	            } else {
	                _chartMap = {};
	            }
	        },
	
	        list: function (group) {
	            group = initializeChartGroup(group);
	            return _chartMap[group];
	        }
	    };
	})();
	
	dc.registerChart = function (chart, group) {
	    dc.chartRegistry.register(chart, group);
	};
	
	dc.deregisterChart = function (chart, group) {
	    dc.chartRegistry.deregister(chart, group);
	};
	
	dc.hasChart = function (chart) {
	    return dc.chartRegistry.has(chart);
	};
	
	dc.deregisterAllCharts = function (group) {
	    dc.chartRegistry.clear(group);
	};
	
	/**
	 * Clear all filters on all charts within the given chart group. If the chart group is not given then
	 * only charts that belong to the default chart group will be reset.
	 * @memberof dc
	 * @name filterAll
	 * @param {String} [group]
	 */
	dc.filterAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].filterAll();
	    }
	};
	
	/**
	 * Reset zoom level / focus on all charts that belong to the given chart group. If the chart group is
	 * not given then only charts that belong to the default chart group will be reset.
	 * @memberof dc
	 * @name refocusAll
	 * @param {String} [group]
	 */
	dc.refocusAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        if (charts[i].focus) {
	            charts[i].focus();
	        }
	    }
	};
	
	/**
	 * Re-render all charts belong to the given chart group. If the chart group is not given then only
	 * charts that belong to the default chart group will be re-rendered.
	 * @memberof dc
	 * @name renderAll
	 * @param {String} [group]
	 */
	dc.renderAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].render();
	    }
	
	    if (dc._renderlet !== null) {
	        dc._renderlet(group);
	    }
	};
	
	/**
	 * Redraw all charts belong to the given chart group. If the chart group is not given then only charts
	 * that belong to the default chart group will be re-drawn. Redraw is different from re-render since
	 * when redrawing dc tries to update the graphic incrementally, using transitions, instead of starting
	 * from scratch.
	 * @memberof dc
	 * @name redrawAll
	 * @param {String} [group]
	 */
	dc.redrawAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].redraw();
	    }
	
	    if (dc._renderlet !== null) {
	        dc._renderlet(group);
	    }
	};
	
	/**
	 * If this boolean is set truthy, all transitions will be disabled, and changes to the charts will happen
	 * immediately
	 * @memberof dc
	 * @name disableTransitions
	 * @type {Boolean}
	 * @default false
	 */
	dc.disableTransitions = false;
	
	dc.transition = function (selections, duration, callback, name) {
	    if (duration <= 0 || duration === undefined || dc.disableTransitions) {
	        return selections;
	    }
	
	    var s = selections
	        .transition(name)
	        .duration(duration);
	
	    if (typeof(callback) === 'function') {
	        callback(s);
	    }
	
	    return s;
	};
	
	/* somewhat silly, but to avoid duplicating logic */
	dc.optionalTransition = function (enable, duration, callback, name) {
	    if (enable) {
	        return function (selection) {
	            return dc.transition(selection, duration, callback, name);
	        };
	    } else {
	        return function (selection) {
	            return selection;
	        };
	    }
	};
	
	/**
	 * @name units
	 * @memberof dc
	 * @type {{}}
	 */
	dc.units = {};
	
	/**
	 * The default value for `xUnits` for the [Coordinate Grid Chart](#coordinate-grid-chart) and should
	 * be used when the x values are a sequence of integers.
	 * It is a function that counts the number of integers in the range supplied in its start and end parameters.
	 * @name integers
	 * @memberof dc.units
	 * @example
	 * chart.xUnits(dc.units.integers) // already the default
	 * @param {Number} start
	 * @param {Number} end
	 * @returns {Number}
	 */
	dc.units.integers = function (start, end) {
	    return Math.abs(end - start);
	};
	
	/**
	 * This argument can be passed to the `xUnits` function of the to specify ordinal units for the x
	 * axis. Usually this parameter is used in combination with passing `d3.scale.ordinal()` to `.x`.
	 * It just returns the domain passed to it, which for ordinal charts is an array of all values.
	 * @name ordinal
	 * @memberof dc.units
	 * @example
	 * chart.xUnits(dc.units.ordinal)
	 *      .x(d3.scale.ordinal())
	 * @param {*} start
	 * @param {*} end
	 * @param {Array<String>} domain
	 * @returns {Array<String>}
	 */
	dc.units.ordinal = function (start, end, domain) {
	    return domain;
	};
	
	/**
	 * @name fp
	 * @memberof dc.units
	 * @type {{}}
	 */
	dc.units.fp = {};
	/**
	 * This function generates an argument for the [Coordinate Grid Chart's](#coordinate-grid-chart)
	 * `xUnits` function specifying that the x values are floating-point numbers with the given
	 * precision.
	 * The returned function determines how many values at the given precision will fit into the range
	 * supplied in its start and end parameters.
	 * @name precision
	 * @memberof dc.units.fp
	 * @example
	 * // specify values (and ticks) every 0.1 units
	 * chart.xUnits(dc.units.fp.precision(0.1)
	 * // there are 500 units between 0.5 and 1 if the precision is 0.001
	 * var thousandths = dc.units.fp.precision(0.001);
	 * thousandths(0.5, 1.0) // returns 500
	 * @param {Number} precision
	 * @returns {Function} start-end unit function
	 */
	dc.units.fp.precision = function (precision) {
	    var _f = function (s, e) {
	        var d = Math.abs((e - s) / _f.resolution);
	        if (dc.utils.isNegligible(d - Math.floor(d))) {
	            return Math.floor(d);
	        } else {
	            return Math.ceil(d);
	        }
	    };
	    _f.resolution = precision;
	    return _f;
	};
	
	dc.round = {};
	dc.round.floor = function (n) {
	    return Math.floor(n);
	};
	dc.round.ceil = function (n) {
	    return Math.ceil(n);
	};
	dc.round.round = function (n) {
	    return Math.round(n);
	};
	
	dc.override = function (obj, functionName, newFunction) {
	    var existingFunction = obj[functionName];
	    obj['_' + functionName] = existingFunction;
	    obj[functionName] = newFunction;
	};
	
	dc.renderlet = function (_) {
	    if (!arguments.length) {
	        return dc._renderlet;
	    }
	    dc._renderlet = _;
	    return dc;
	};
	
	dc.instanceOfChart = function (o) {
	    return o instanceof Object && o.__dcFlag__ && true;
	};
	
	dc.errors = {};
	
	dc.errors.Exception = function (msg) {
	    var _msg = msg || 'Unexpected internal error';
	
	    this.message = _msg;
	
	    this.toString = function () {
	        return _msg;
	    };
	    this.stack = (new Error()).stack;
	};
	dc.errors.Exception.prototype = Object.create(Error.prototype);
	dc.errors.Exception.prototype.constructor = dc.errors.Exception;
	
	dc.errors.InvalidStateException = function () {
	    dc.errors.Exception.apply(this, arguments);
	};
	
	dc.errors.InvalidStateException.prototype = Object.create(dc.errors.Exception.prototype);
	dc.errors.InvalidStateException.prototype.constructor = dc.errors.InvalidStateException;
	
	dc.errors.BadArgumentException = function() {
	    dc.errors.Exception.apply(this, arguments);
	};
	
	dc.errors.BadArgumentException.prototype = Object.create(dc.errors.Exception.prototype);
	dc.errors.BadArgumentException.prototype.constructor = dc.errors.BadArgumentException;
	
	dc.dateFormat = d3.time.format('%m/%d/%Y');
	
	dc.printers = {};
	
	dc.printers.filters = function (filters) {
	    var s = '';
	
	    for (var i = 0; i < filters.length; ++i) {
	        if (i > 0) {
	            s += ', ';
	        }
	        s += dc.printers.filter(filters[i]);
	    }
	
	    return s;
	};
	
	dc.printers.filter = function (filter) {
	    var s = '';
	
	    if (typeof filter !== 'undefined' && filter !== null) {
	        if (filter instanceof Array) {
	            if (filter.length >= 2) {
	                s = '[' + dc.utils.printSingleValue(filter[0]) + ' -> ' + dc.utils.printSingleValue(filter[1]) + ']';
	            } else if (filter.length >= 1) {
	                s = dc.utils.printSingleValue(filter[0]);
	            }
	        } else {
	            s = dc.utils.printSingleValue(filter);
	        }
	    }
	
	    return s;
	};
	
	dc.pluck = function (n, f) {
	    if (!f) {
	        return function (d) { return d[n]; };
	    }
	    return function (d, i) { return f.call(d, d[n], i); };
	};
	
	dc.utils = {};
	
	dc.utils.printSingleValue = function (filter) {
	    var s = '' + filter;
	
	    if (filter instanceof Date) {
	        s = dc.dateFormat(filter);
	    } else if (typeof(filter) === 'string') {
	        s = filter;
	    } else if (dc.utils.isFloat(filter)) {
	        s = dc.utils.printSingleValue.fformat(filter);
	    } else if (dc.utils.isInteger(filter)) {
	        s = Math.round(filter);
	    }
	
	    return s;
	};
	dc.utils.printSingleValue.fformat = d3.format('.2f');
	
	// FIXME: these assume than any string r is a percentage (whether or not it
	// includes %). They also generate strange results if l is a string.
	dc.utils.add = function (l, r) {
	    if (typeof r === 'string') {
	        r = r.replace('%', '');
	    }
	
	    if (l instanceof Date) {
	        if (typeof r === 'string') {
	            r = +r;
	        }
	        var d = new Date();
	        d.setTime(l.getTime());
	        d.setDate(l.getDate() + r);
	        return d;
	    } else if (typeof r === 'string') {
	        var percentage = (+r / 100);
	        return l > 0 ? l * (1 + percentage) : l * (1 - percentage);
	    } else {
	        return l + r;
	    }
	};
	
	dc.utils.subtract = function (l, r) {
	    if (typeof r === 'string') {
	        r = r.replace('%', '');
	    }
	
	    if (l instanceof Date) {
	        if (typeof r === 'string') {
	            r = +r;
	        }
	        var d = new Date();
	        d.setTime(l.getTime());
	        d.setDate(l.getDate() - r);
	        return d;
	    } else if (typeof r === 'string') {
	        var percentage = (+r / 100);
	        return l < 0 ? l * (1 + percentage) : l * (1 - percentage);
	    } else {
	        return l - r;
	    }
	};
	
	dc.utils.isNumber = function (n) {
	    return n === +n;
	};
	
	dc.utils.isFloat = function (n) {
	    return n === +n && n !== (n | 0);
	};
	
	dc.utils.isInteger = function (n) {
	    return n === +n && n === (n | 0);
	};
	
	dc.utils.isNegligible = function (n) {
	    return !dc.utils.isNumber(n) || (n < dc.constants.NEGLIGIBLE_NUMBER && n > -dc.constants.NEGLIGIBLE_NUMBER);
	};
	
	dc.utils.clamp = function (val, min, max) {
	    return val < min ? min : (val > max ? max : val);
	};
	
	var _idCounter = 0;
	dc.utils.uniqueId = function () {
	    return ++_idCounter;
	};
	
	dc.utils.nameToId = function (name) {
	    return name.toLowerCase().replace(/[\s]/g, '_').replace(/[\.']/g, '');
	};
	
	dc.utils.appendOrSelect = function (parent, selector, tag) {
	    tag = tag || selector;
	    var element = parent.select(selector);
	    if (element.empty()) {
	        element = parent.append(tag);
	    }
	    return element;
	};
	
	dc.utils.safeNumber = function (n) { return dc.utils.isNumber(+n) ? +n : 0;};
	
	dc.logger = {};
	
	dc.logger.enableDebugLog = false;
	
	dc.logger.warn = function (msg) {
	    if (console) {
	        if (console.warn) {
	            console.warn(msg);
	        } else if (console.log) {
	            console.log(msg);
	        }
	    }
	
	    return dc.logger;
	};
	
	dc.logger.debug = function (msg) {
	    if (dc.logger.enableDebugLog && console) {
	        if (console.debug) {
	            console.debug(msg);
	        } else if (console.log) {
	            console.log(msg);
	        }
	    }
	
	    return dc.logger;
	};
	
	dc.logger.deprecate = function (fn, msg) {
	    // Allow logging of deprecation
	    var warned = false;
	    function deprecated () {
	        if (!warned) {
	            dc.logger.warn(msg);
	            warned = true;
	        }
	        return fn.apply(this, arguments);
	    }
	    return deprecated;
	};
	
	dc.events = {
	    current: null
	};
	
	/**
	 * This function triggers a throttled event function with a specified delay (in milli-seconds).  Events
	 * that are triggered repetitively due to user interaction such brush dragging might flood the library
	 * and invoke more renders than can be executed in time. Using this function to wrap your event
	 * function allows the library to smooth out the rendering by throttling events and only responding to
	 * the most recent event.
	 * @name events.trigger
	 * @memberof dc
	 * @example
	 * chart.on('renderlet', function(chart) {
	 *     // smooth the rendering through event throttling
	 *     dc.events.trigger(function(){
	 *         // focus some other chart to the range selected by user on this chart
	 *         someOtherChart.focus(chart.filter());
	 *     });
	 * })
	 * @param {Function} closure
	 * @param {Number} [delay]
	 */
	dc.events.trigger = function (closure, delay) {
	    if (!delay) {
	        closure();
	        return;
	    }
	
	    dc.events.current = closure;
	
	    setTimeout(function () {
	        if (closure === dc.events.current) {
	            closure();
	        }
	    }, delay);
	};
	
	/**
	 * The dc.js filters are functions which are passed into crossfilter to chose which records will be
	 * accumulated to produce values for the charts.  In the crossfilter model, any filters applied on one
	 * dimension will affect all the other dimensions but not that one.  dc always applies a filter
	 * function to the dimension; the function combines multiple filters and if any of them accept a
	 * record, it is filtered in.
	 *
	 * These filter constructors are used as appropriate by the various charts to implement brushing.  We
	 * mention below which chart uses which filter.  In some cases, many instances of a filter will be added.
	 *
	 * Each of the dc.js filters is an object with the following properties:
	 * * `isFiltered` - a function that returns true if a value is within the filter
	 * * `filterType` - a string identifying the filter, here the name of the constructor
	 *
	 * Currently these filter objects are also arrays, but this is not a requirement. Custom filters
	 * can be used as long as they have the properties above.
	 * @name filters
	 * @memberof dc
	 * @type {{}}
	 */
	dc.filters = {};
	
	/**
	 * RangedFilter is a filter which accepts keys between `low` and `high`.  It is used to implement X
	 * axis brushing for the [coordinate grid charts](#coordinate-grid-mixin).
	 *
	 * Its `filterType` is 'RangedFilter'
	 * @name RangedFilter
	 * @memberof dc.filters
	 * @param {Number} low
	 * @param {Number} high
	 * @returns {Array<Number>}
	 * @constructor
	 */
	dc.filters.RangedFilter = function (low, high) {
	    var range = new Array(low, high);
	    range.isFiltered = function (value) {
	        return value >= this[0] && value < this[1];
	    };
	    range.filterType = 'RangedFilter';
	
	    return range;
	};
	
	/**
	 * TwoDimensionalFilter is a filter which accepts a single two-dimensional value.  It is used by the
	 * [heat map chart](#heat-map) to include particular cells as they are clicked.  (Rows and columns are
	 * filtered by filtering all the cells in the row or column.)
	 *
	 * Its `filterType` is 'TwoDimensionalFilter'
	 * @name TwoDimensionalFilter
	 * @memberof dc.filters
	 * @param {Array<Number>} filter
	 * @returns {Array<Number>}
	 * @constructor
	 */
	dc.filters.TwoDimensionalFilter = function (filter) {
	    if (filter === null) { return null; }
	
	    var f = filter;
	    f.isFiltered = function (value) {
	        return value.length && value.length === f.length &&
	               value[0] === f[0] && value[1] === f[1];
	    };
	    f.filterType = 'TwoDimensionalFilter';
	
	    return f;
	};
	
	/**
	 * The RangedTwoDimensionalFilter allows filtering all values which fit within a rectangular
	 * region. It is used by the [scatter plot](#scatter-plot) to implement rectangular brushing.
	 *
	 * It takes two two-dimensional points in the form `[[x1,y1],[x2,y2]]`, and normalizes them so that
	 * `x1 <= x2` and `y1 <- y2`. It then returns a filter which accepts any points which are in the
	 * rectangular range including the lower values but excluding the higher values.
	 *
	 * If an array of two values are given to the RangedTwoDimensionalFilter, it interprets the values as
	 * two x coordinates `x1` and `x2` and returns a filter which accepts any points for which `x1 <= x <
	 * x2`.
	 *
	 * Its `filterType` is 'RangedTwoDimensionalFilter'
	 * @name RangedTwoDimensionalFilter
	 * @memberof dc.filters
	 * @param {Array<Array<Number>>} filter
	 * @returns {Array<Array<Number>>}
	 * @constructor
	 */
	dc.filters.RangedTwoDimensionalFilter = function (filter) {
	    if (filter === null) { return null; }
	
	    var f = filter;
	    var fromBottomLeft;
	
	    if (f[0] instanceof Array) {
	        fromBottomLeft = [
	            [Math.min(filter[0][0], filter[1][0]), Math.min(filter[0][1], filter[1][1])],
	            [Math.max(filter[0][0], filter[1][0]), Math.max(filter[0][1], filter[1][1])]
	        ];
	    } else {
	        fromBottomLeft = [[filter[0], -Infinity], [filter[1], Infinity]];
	    }
	
	    f.isFiltered = function (value) {
	        var x, y;
	
	        if (value instanceof Array) {
	            if (value.length !== 2) {
	                return false;
	            }
	            x = value[0];
	            y = value[1];
	        } else {
	            x = value;
	            y = fromBottomLeft[0][1];
	        }
	
	        return x >= fromBottomLeft[0][0] && x < fromBottomLeft[1][0] &&
	               y >= fromBottomLeft[0][1] && y < fromBottomLeft[1][1];
	    };
	    f.filterType = 'RangedTwoDimensionalFilter';
	
	    return f;
	};
	
	/**
	 * `dc.baseMixin` is an abstract functional object representing a basic `dc` chart object
	 * for all chart and widget implementations. Methods from the `dc.baseMixin` are inherited
	 * and available on all chart implementations in the `dc` library.
	 * @name baseMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.baseMixin}
	 */
	dc.baseMixin = function (_chart) {
	    _chart.__dcFlag__ = dc.utils.uniqueId();
	
	    var _dimension;
	    var _group;
	
	    var _anchor;
	    var _root;
	    var _svg;
	    var _isChild;
	
	    var _minWidth = 200;
	    var _defaultWidth = function (element) {
	        var width = element && element.getBoundingClientRect && element.getBoundingClientRect().width;
	        return (width && width > _minWidth) ? width : _minWidth;
	    };
	    var _width = _defaultWidth;
	
	    var _minHeight = 200;
	    var _defaultHeight = function (element) {
	        var height = element && element.getBoundingClientRect && element.getBoundingClientRect().height;
	        return (height && height > _minHeight) ? height : _minHeight;
	    };
	    var _height = _defaultHeight;
	
	    var _keyAccessor = dc.pluck('key');
	    var _valueAccessor = dc.pluck('value');
	    var _label = dc.pluck('key');
	
	    var _ordering = dc.pluck('key');
	    var _orderSort;
	
	    var _renderLabel = false;
	
	    var _title = function (d) {
	        return _chart.keyAccessor()(d) + ': ' + _chart.valueAccessor()(d);
	    };
	    var _renderTitle = true;
	
	    var _transitionDuration = 750;
	
	    var _filterPrinter = dc.printers.filters;
	
	    var _mandatoryAttributes = ['dimension', 'group'];
	
	    var _chartGroup = dc.constants.DEFAULT_CHART_GROUP;
	
	    var _listeners = d3.dispatch(
	        'preRender',
	        'postRender',
	        'preRedraw',
	        'postRedraw',
	        'filtered',
	        'zoomed',
	        'renderlet',
	        'pretransition');
	
	    var _legend;
	
	    var _filters = [];
	    var _filterHandler = function (dimension, filters) {
	        if (filters.length === 0) {
	            dimension.filter(null);
	        } else if (filters.length === 1 && !filters[0].isFiltered) {
	            // single value and not a function-based filter
	            dimension.filterExact(filters[0]);
	        } else if (filters.length === 1 && filters[0].filterType==='RangedFilter') {
	            // single range-based filter
	            dimension.filterRange(filters[0]);
	        } else {
	            dimension.filterFunction(function (d) {
	                for (var i = 0; i < filters.length; i++) {
	                    var filter = filters[i];
	                    if (filter.isFiltered && filter.isFiltered(d)) {
	                        return true;
	                    } else if (filter <= d && filter >= d) {
	                        return true;
	                    }
	                }
	                return false;
	            });
	        }
	        return filters;
	    };
	
	    var _data = function (group) {
	        return group.all();
	    };
	
	    /**
	     * Set or get the height attribute of a chart. The height is applied to the SVGElement generated by
	     * the chart when rendered (or re-rendered). If a value is given, then it will be used to calculate
	     * the new height and the chart returned for method chaining.  The value can either be a numeric, a
	     * function, or falsy. If no value is specified then the value of the current height attribute will
	     * be returned.
	     *
	     * By default, without an explicit height being given, the chart will select the width of its
	     * anchor element. If that isn't possible it defaults to 200 (provided by the
	     * {@link #dc.baseMixin.minHeight minHeight} property). Setting the value falsy will return
	     * the chart to the default behavior.
	     * @name height
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link #dc.baseMixin+minHeight minHeight}
	     * @example
	     * // Default height
	     * chart.height(function (element) {
	     *     var height = element && element.getBoundingClientRect && element.getBoundingClientRect().height;
	     *     return (height && height > chart.minHeight()) ? height : chart.minHeight();
	     * });
	     *
	     * chart.height(250); // Set the chart's height to 250px;
	     * chart.height(function(anchor) { return doSomethingWith(anchor); }); // set the chart's height with a function
	     * chart.height(null); // reset the height to the default auto calculation
	     * @param {Number|Function} [height]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.height = function (height) {
	        if (!arguments.length) {
	            return _height(_root.node());
	        }
	        _height = d3.functor(height || _defaultHeight);
	        return _chart;
	    };
	
	    /**
	     * Set or get the width attribute of a chart.
	     * @name width
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link #dc.baseMixin+height height}
	     * @see {@link #dc.baseMixin+minWidth minWidth}
	     * @example
	     * // Default width
	     * chart.width(function (element) {
	     *     var width = element && element.getBoundingClientRect && element.getBoundingClientRect().width;
	     *     return (width && width > chart.minWidth()) ? width : chart.minWidth();
	     * });
	     * @param {Number|Function} [width]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.width = function (width) {
	        if (!arguments.length) {
	            return _width(_root.node());
	        }
	        _width = d3.functor(width || _defaultWidth);
	        return _chart;
	    };
	
	    /**
	     * Set or get the minimum width attribute of a chart. This only has effect when used with the default `width` function.
	     * @name minWidth
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link #dc.baseMixin+width width}
	     * @param {Number} [minWidth=200]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.minWidth = function (minWidth) {
	        if (!arguments.length) {
	            return _minWidth;
	        }
	        _minWidth = minWidth;
	        return _chart;
	    };
	
	    /**
	     * Set or get the minimum height attribute of a chart. This only has effect when used with the default `height` function.
	     * @name minHeight
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link #dc.baseMixin+height height}
	     * @param {Number} [minHeight=200]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.minHeight = function (minHeight) {
	        if (!arguments.length) {
	            return _minHeight;
	        }
	        _minHeight = minHeight;
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Set or get the dimension attribute of a chart. In `dc`, a dimension can be any valid [crossfilter
	     * dimension](https://github.com/square/crossfilter/wiki/API-Reference#wiki-dimension).
	     *
	     * If a value is given, then it will be used as the new dimension. If no value is specified then
	     * the current dimension will be returned.
	     * @name dimension
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#dimension crossfilter.dimension}
	     * @example
	     * var index = crossfilter([]);
	     * var dimension = index.dimension(dc.pluck('key'));
	     * chart.dimension(dimension);
	     * @param {crossfilter.dimension} [dimension]
	     * @return {crossfilter.dimension}
	     * @return {dc.baseMixin}
	     */
	    _chart.dimension = function (dimension) {
	        if (!arguments.length) {
	            return _dimension;
	        }
	        _dimension = dimension;
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * Set the data callback or retrieve the chart's data set. The data callback is passed the chart's
	     * group and by default will return `group.all()`. This behavior may be modified to, for instance,
	     * return only the top 5 groups.
	     * @name data
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // Default data function
	     * chart.data(function (group) { return group.all(); });
	     *
	     * chart.data(function (group) { return group.top(5); });
	     * @param {Function} [callback]
	     * @return {*}
	     * @return {dc.baseMixin}
	     */
	    _chart.data = function (callback) {
	        if (!arguments.length) {
	            return _data.call(_chart, _group);
	        }
	        _data = d3.functor(callback);
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Set or get the group attribute of a chart. In `dc` a group is a [crossfilter
	     * group](https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce). Usually the group
	     * should be created from the particular dimension associated with the same chart. If a value is
	     * given, then it will be used as the new group.
	     *
	     * If no value specified then the current group will be returned.
	     * If `name` is specified then it will be used to generate legend label.
	     * @name group
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce crossfilter.group}
	     * @example
	     * var index = crossfilter([]);
	     * var dimension = index.dimension(dc.pluck('key'));
	     * chart.dimension(dimension);
	     * chart.group(dimension.group(crossfilter.reduceSum()));
	     * @param {crossfilter.group} [group]
	     * @param {String} [name]
	     * @return {crossfilter.group}
	     * @return {dc.baseMixin}
	     */
	    _chart.group = function (group, name) {
	        if (!arguments.length) {
	            return _group;
	        }
	        _group = group;
	        _chart._groupName = name;
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * Get or set an accessor to order ordinal dimensions.  This uses `crossfilter.quicksort.by` as the
	     * sort.
	     * @name ordering
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#quicksort_by crossfilter.quicksort.by}
	     * @example
	     * // Default ordering accessor
	     * _chart.ordering(dc.pluck('key'));
	     * @param {Function} [orderFunction]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.ordering = function (orderFunction) {
	        if (!arguments.length) {
	            return _ordering;
	        }
	        _ordering = orderFunction;
	        _orderSort = crossfilter.quicksort.by(_ordering);
	        _chart.expireCache();
	        return _chart;
	    };
	
	    _chart._computeOrderedGroups = function (data) {
	        var dataCopy = data.slice(0);
	
	        if (dataCopy.length <= 1) {
	            return dataCopy;
	        }
	
	        if (!_orderSort) {
	            _orderSort = crossfilter.quicksort.by(_ordering);
	        }
	
	        return _orderSort(dataCopy, 0, dataCopy.length);
	    };
	
	    /**
	     * Clear all filters associated with this chart
	     *
	     * The same can be achieved by calling `chart.filter(null)`.
	     * @name filterAll
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.filterAll = function () {
	        return _chart.filter(null);
	    };
	
	    /**
	     * Execute d3 single selection in the chart's scope using the given selector and return the d3
	     * selection.
	     *
	     * This function is **not chainable** since it does not return a chart instance; however the d3
	     * selection result can be chained to d3 function calls.
	     * @name select
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Selections d3.selection}
	     * @example
	     * // Similar to:
	     * d3.select('#chart-id').select(selector);
	     * @return {d3.selection}
	     */
	    _chart.select = function (s) {
	        return _root.select(s);
	    };
	
	    /**
	     * Execute in scope d3 selectAll using the given selector and return d3 selection result.
	     *
	     * This function is **not chainable** since it does not return a chart instance; however the d3
	     * selection result can be chained to d3 function calls.
	     * @name selectAll
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Selections d3.selection}
	     * @example
	     * // Similar to:
	     * d3.select('#chart-id').selectAll(selector);
	     * @return {d3.selection}
	     */
	    _chart.selectAll = function (s) {
	        return _root ? _root.selectAll(s) : null;
	    };
	
	    /**
	     * Set the root SVGElement to either be an existing chart's root; or any valid [d3 single
	     * selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying a dom
	     * block element such as a div; or a dom element or d3 selection. Optionally registers the chart
	     * within the chartGroup. This class is called internally on chart initialization, but be called
	     * again to relocate the chart. However, it will orphan any previously created SVGElements.
	     * @name anchor
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {anchorChart|anchorSelector|anchorNode} [parent]
	     * @param {String} [chartGroup]
	     * @return {String|node|d3.selection}
	     * @return {dc.baseMixin}
	     */
	    _chart.anchor = function (parent, chartGroup) {
	        if (!arguments.length) {
	            return _anchor;
	        }
	        if (dc.instanceOfChart(parent)) {
	            _anchor = parent.anchor();
	            _root = parent.root();
	            _isChild = true;
	        } else if(parent) {
	            if(parent.select && parent.classed) { // detect d3 selection
	                _anchor = parent.node();
	            } else {
	                _anchor = parent;
	            }
	            _root = d3.select(_anchor);
	            _root.classed(dc.constants.CHART_CLASS, true);
	            dc.registerChart(_chart, chartGroup);
	            _isChild = false;
	        }
	        else {
	            throw new dc.errors.BadArgumentException('parent must be defined');
	        }
	        _chartGroup = chartGroup;
	        return _chart;
	    };
	
	    /**
	     * Returns the DOM id for the chart's anchored location.
	     * @name anchorName
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {String}
	     */
	    _chart.anchorName = function () {
	        var a = _chart.anchor();
	        if (a && a.id) {
	            return a.id;
	        }
	        if (a && a.replace) {
	            return a.replace('#', '');
	        }
	        return 'dc-chart' + _chart.chartID();
	    };
	
	    /**
	     * Returns the root element where a chart resides. Usually it will be the parent div element where
	     * the SVGElement was created. You can also pass in a new root element however this is usually handled by
	     * dc internally. Resetting the root element on a chart outside of dc internals may have
	     * unexpected consequences.
	     * @name root
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement HTMLElement}
	     * @param {HTMLElement} [rootElement]
	     * @return {HTMLElement}
	     * @return {dc.baseMixin}
	     */
	    _chart.root = function (rootElement) {
	        if (!arguments.length) {
	            return _root;
	        }
	        _root = rootElement;
	        return _chart;
	    };
	
	    /**
	     * Returns the top SVGElement for this specific chart. You can also pass in a new SVGElement,
	     * however this is usually handled by dc internally. Resetting the SVGElement on a chart outside
	     * of dc internals may have unexpected consequences.
	     * @name svg
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/SVGElement SVGElement}
	     * @param {SVGElement} [svgElement]
	     * @return {SVGElement}
	     * @return {dc.baseMixin}
	     */
	    _chart.svg = function (svgElement) {
	        if (!arguments.length) {
	            return _svg;
	        }
	        _svg = svgElement;
	        return _chart;
	    };
	
	    /**
	     * Remove the chart's SVGElements from the dom and recreate the container SVGElement.
	     * @name resetSvg
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/SVGElement SVGElement}
	     * @return {SVGElement}
	     */
	    _chart.resetSvg = function () {
	        _chart.select('svg').remove();
	        return generateSvg();
	    };
	
	    function sizeSvg () {
	        if (_svg) {
	            _svg
	                .attr('width', _chart.width())
	                .attr('height', _chart.height());
	        }
	    }
	
	    function generateSvg () {
	        _svg = _chart.root().append('svg');
	        sizeSvg();
	        return _svg;
	    }
	
	    /**
	     * Set or get the filter printer function. The filter printer function is used to generate human
	     * friendly text for filter value(s) associated with the chart instance. By default dc charts use a
	     * default filter printer `dc.printers.filter` that provides simple printing support for both
	     * single value and ranged filters.
	     * @name filterPrinter
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Function} [filterPrinterFunction=dc.printers.filter]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.filterPrinter = function (filterPrinterFunction) {
	        if (!arguments.length) {
	            return _filterPrinter;
	        }
	        _filterPrinter = filterPrinterFunction;
	        return _chart;
	    };
	
	    /**
	     * Turn on optional control elements within the root element. dc currently supports the
	     * following html control elements.
	     * * root.selectAll('.reset') - elements are turned on if the chart has an active filter. This type
	     * of control element is usually used to store a reset link to allow user to reset filter on a
	     * certain chart. This element will be turned off automatically if the filter is cleared.
	     * * root.selectAll('.filter') elements are turned on if the chart has an active filter. The text
	     * content of this element is then replaced with the current filter value using the filter printer
	     * function. This type of element will be turned off automatically if the filter is cleared.
	     * @name turnOnControls
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.turnOnControls = function () {
	        if (_root) {
	            _chart.selectAll('.reset').style('display', null);
	            _chart.selectAll('.filter').text(_filterPrinter(_chart.filters())).style('display', null);
	        }
	        return _chart;
	    };
	
	    /**
	     * Turn off optional control elements within the root element.
	     * @name turnOffControls
	     * @memberof dc.baseMixin
	     * @see {@link #dc.baseMixin+turnOnControls turnOnControls}
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.turnOffControls = function () {
	        if (_root) {
	            _chart.selectAll('.reset').style('display', 'none');
	            _chart.selectAll('.filter').style('display', 'none').text(_chart.filter());
	        }
	        return _chart;
	    };
	
	    /**
	     * Set or get the animation transition duration (in milliseconds) for this chart instance.
	     * @name transitionDuration
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Number} [duration=750]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.transitionDuration = function (duration) {
	        if (!arguments.length) {
	            return _transitionDuration;
	        }
	        _transitionDuration = duration;
	        return _chart;
	    };
	
	    _chart._mandatoryAttributes = function (_) {
	        if (!arguments.length) {
	            return _mandatoryAttributes;
	        }
	        _mandatoryAttributes = _;
	        return _chart;
	    };
	
	    function checkForMandatoryAttributes (a) {
	        if (!_chart[a] || !_chart[a]()) {
	            throw new dc.errors.InvalidStateException('Mandatory attribute chart.' + a +
	                ' is missing on chart[#' + _chart.anchorName() + ']');
	        }
	    }
	
	    /**
	     * Invoking this method will force the chart to re-render everything from scratch. Generally it
	     * should only be used to render the chart for the first time on the page or if you want to make
	     * sure everything is redrawn from scratch instead of relying on the default incremental redrawing
	     * behaviour.
	     * @name render
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.render = function () {
	        _listeners.preRender(_chart);
	
	        if (_mandatoryAttributes) {
	            _mandatoryAttributes.forEach(checkForMandatoryAttributes);
	        }
	
	        var result = _chart._doRender();
	
	        if (_legend) {
	            _legend.render();
	        }
	
	        _chart._activateRenderlets('postRender');
	
	        return result;
	    };
	
	    _chart._activateRenderlets = function (event) {
	        _listeners.pretransition(_chart);
	        if (_chart.transitionDuration() > 0 && _svg) {
	            _svg.transition().duration(_chart.transitionDuration())
	                .each('end', function () {
	                    _listeners.renderlet(_chart);
	                    if (event) {
	                        _listeners[event](_chart);
	                    }
	                });
	        } else {
	            _listeners.renderlet(_chart);
	            if (event) {
	                _listeners[event](_chart);
	            }
	        }
	    };
	
	    /**
	     * Calling redraw will cause the chart to re-render data changes incrementally. If there is no
	     * change in the underlying data dimension then calling this method will have no effect on the
	     * chart. Most chart interaction in dc will automatically trigger this method through internal
	     * events (in particular [dc.redrawAll](#dcredrawallchartgroup)); therefore, you only need to
	     * manually invoke this function if data is manipulated outside of dc's control (for example if
	     * data is loaded in the background using `crossfilter.add()`).
	     * @name redraw
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.redraw = function () {
	        sizeSvg();
	        _listeners.preRedraw(_chart);
	
	        var result = _chart._doRedraw();
	
	        if (_legend) {
	            _legend.render();
	        }
	
	        _chart._activateRenderlets('postRedraw');
	
	        return result;
	    };
	
	    _chart.redrawGroup = function () {
	        dc.redrawAll(_chart.chartGroup());
	    };
	
	    _chart.renderGroup = function () {
	        dc.renderAll(_chart.chartGroup());
	    };
	
	    _chart._invokeFilteredListener = function (f) {
	        if (f !== undefined) {
	            _listeners.filtered(_chart, f);
	        }
	    };
	
	    _chart._invokeZoomedListener = function () {
	        _listeners.zoomed(_chart);
	    };
	
	    var _hasFilterHandler = function (filters, filter) {
	        if (filter === null || typeof(filter) === 'undefined') {
	            return filters.length > 0;
	        }
	        return filters.some(function (f) {
	            return filter <= f && filter >= f;
	        });
	    };
	
	    /**
	     * Set or get the has filter handler. The has filter handler is a function that checks to see if
	     * the chart's current filters include a specific filter.  Using a custom has filter handler allows
	     * you to change the way filters are checked for and replaced.
	     * @name hasFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default has filter handler
	     * chart.hasFilterHandler(function (filters, filter) {
	     *     if (filter === null || typeof(filter) === 'undefined') {
	     *         return filters.length > 0;
	     *     }
	     *     return filters.some(function (f) {
	     *         return filter <= f && filter >= f;
	     *     });
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.hasFilterHandler(function(filters, filter) {
	     *     return false;
	     * });
	     * @param {Function} [hasFilterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.hasFilterHandler = function (hasFilterHandler) {
	        if (!arguments.length) {
	            return _hasFilterHandler;
	        }
	        _hasFilterHandler = hasFilterHandler;
	        return _chart;
	    };
	
	    /**
	     * Check whether any active filter or a specific filter is associated with particular chart instance.
	     * This function is **not chainable**.
	     * @name hasFilter
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link #dc.baseMixin+hasFilterHandler hasFilterHandler}
	     * @param {*} [filter]
	     * @return {Boolean}
	     */
	    _chart.hasFilter = function (filter) {
	        return _hasFilterHandler(_filters, filter);
	    };
	
	    var _removeFilterHandler = function (filters, filter) {
	        for (var i = 0; i < filters.length; i++) {
	            if (filters[i] <= filter && filters[i] >= filter) {
	                filters.splice(i, 1);
	                break;
	            }
	        }
	        return filters;
	    };
	
	    /**
	     * Set or get the remove filter handler. The remove filter handler is a function that removes a
	     * filter from the chart's current filters. Using a custom remove filter handler allows you to
	     * change how filters are removed or perform additional work when removing a filter, e.g. when
	     * using a filter server other than crossfilter.
	     *
	     * Any changes should modify the `filters` array argument and return that array.
	     * @name removeFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default remove filter handler
	     * chart.removeFilterHandler(function (filters, filter) {
	     *     for (var i = 0; i < filters.length; i++) {
	     *         if (filters[i] <= filter && filters[i] >= filter) {
	     *             filters.splice(i, 1);
	     *             break;
	     *         }
	     *     }
	     *     return filters;
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.removeFilterHandler(function(filters, filter) {
	     *     return filters;
	     * });
	     * @param {Function} [removeFilterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.removeFilterHandler = function (removeFilterHandler) {
	        if (!arguments.length) {
	            return _removeFilterHandler;
	        }
	        _removeFilterHandler = removeFilterHandler;
	        return _chart;
	    };
	
	    var _addFilterHandler = function (filters, filter) {
	        filters.push(filter);
	        return filters;
	    };
	
	    /**
	     * Set or get the add filter handler. The add filter handler is a function that adds a filter to
	     * the chart's filter list. Using a custom add filter handler allows you to change the way filters
	     * are added or perform additional work when adding a filter, e.g. when using a filter server other
	     * than crossfilter.
	     *
	     * Any changes should modify the `filters` array argument and return that array.
	     * @name addFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default add filter handler
	     * chart.addFilterHandler(function (filters, filter) {
	     *     filters.push(filter);
	     *     return filters;
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.addFilterHandler(function(filters, filter) {
	     *     return filters;
	     * });
	     * @param {Function} [addFilterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.addFilterHandler = function (addFilterHandler) {
	        if (!arguments.length) {
	            return _addFilterHandler;
	        }
	        _addFilterHandler = addFilterHandler;
	        return _chart;
	    };
	
	    var _resetFilterHandler = function (filters) {
	        return [];
	    };
	
	    /**
	     * Set or get the reset filter handler. The reset filter handler is a function that resets the
	     * chart's filter list by returning a new list. Using a custom reset filter handler allows you to
	     * change the way filters are reset, or perform additional work when resetting the filters,
	     * e.g. when using a filter server other than crossfilter.
	     *
	     * This function should return an array.
	     * @name resetFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default remove filter handler
	     * function (filters) {
	     *     return [];
	     * }
	     *
	     * // custom filter handler (no-op)
	     * chart.resetFilterHandler(function(filters) {
	     *     return filters;
	     * });
	     * @param {Function} [resetFilterHandler]
	     * @return {dc.baseMixin}
	     */
	    _chart.resetFilterHandler = function (resetFilterHandler) {
	        if (!arguments.length) {
	            return _resetFilterHandler;
	        }
	        _resetFilterHandler = resetFilterHandler;
	        return _chart;
	    };
	
	    function applyFilters () {
	        if (_chart.dimension() && _chart.dimension().filter) {
	            var fs = _filterHandler(_chart.dimension(), _filters);
	            _filters = fs ? fs : _filters;
	        }
	    }
	
	    _chart.replaceFilter = function (_) {
	        _filters = [];
	        _chart.filter(_);
	    };
	
	    /**
	     * Filter the chart by the given value or return the current filter if the input parameter is missing.
	     * If the passed filter is not currently in the chart's filters, it is added to the filters by the
	     * {@link #dc.baseMixin+addFilterHandler addFilterHandler}.  If a filter exists already within the chart's
	     * filters, it will be removed by the {@link #dc.baseMixin+removeFilterHandler removeFilterHandler}.  If
	     * a `null` value was passed at the filter, this denotes that the filters should be reset, and is performed
	     * by the {@link #dc.baseMixin+resetFilterHandler resetFilterHandler}.
	     *
	     * Once the filters array has been updated, the filters are applied to the crossfilter.dimension, using the
	     * {@link #dc.baseMixin+filterHandler filterHandler}.
	     * @name filter
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link #dc.baseMixin+addFilterHandler addFilterHandler}
	     * @see {@link #dc.baseMixin+removeFilterHandler removeFilterHandler}
	     * @see {@link #dc.baseMixin+resetFilterHandler resetFilterHandler}
	     * @see {@link #dc.baseMixin+filterHandler filterHandler}
	     * @example
	     * // filter by a single string
	     * chart.filter('Sunday');
	     * // filter by a single age
	     * chart.filter(18);
	     * @param {*} [filter]
	     * @return {dc.baseMixin}
	     */
	    _chart.filter = function (filter) {
	        if (!arguments.length) {
	            return _filters.length > 0 ? _filters[0] : null;
	        }
	        if (filter instanceof Array && filter[0] instanceof Array && !filter.isFiltered) {
	            filter[0].forEach(function (d) {
	                if (_chart.hasFilter(d)) {
	                    _removeFilterHandler(_filters, d);
	                } else {
	                    _addFilterHandler(_filters, d);
	                }
	            });
	        } else if (filter === null) {
	            _filters = _resetFilterHandler(_filters);
	        } else {
	            if (_chart.hasFilter(filter)) {
	                _removeFilterHandler(_filters, filter);
	            } else {
	                _addFilterHandler(_filters, filter);
	            }
	        }
	        applyFilters();
	        _chart._invokeFilteredListener(filter);
	
	        if (_root !== null && _chart.hasFilter()) {
	            _chart.turnOnControls();
	        } else {
	            _chart.turnOffControls();
	        }
	
	        return _chart;
	    };
	
	    /**
	     * Returns all current filters. This method does not perform defensive cloning of the internal
	     * filter array before returning, therefore any modification of the returned array will effect the
	     * chart's internal filter storage.
	     * @name filters
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {Array<*>}
	     */
	    _chart.filters = function () {
	        return _filters;
	    };
	
	    _chart.highlightSelected = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, true);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, false);
	    };
	
	    _chart.fadeDeselected = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, false);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, true);
	    };
	
	    _chart.resetHighlight = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, false);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, false);
	    };
	
	    /**
	     * This function is passed to d3 as the onClick handler for each chart. The default behavior is to
	     * filter on the clicked datum (passed to the callback) and redraw the chart group.
	     * @name onClick
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {*} datum
	     */
	    _chart.onClick = function (datum) {
	        var filter = _chart.keyAccessor()(datum);
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    /**
	     * Set or get the filter handler. The filter handler is a function that performs the filter action
	     * on a specific dimension. Using a custom filter handler allows you to perform additional logic
	     * before or after filtering.
	     * @name filterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#dimension_filter crossfilter.dimension.filter}
	     * @example
	     * // default filter handler
	     * chart.filterHandler(function (dimension, filters) {
	     *     dimension.filter(null);
	     *     if (filters.length === 0) {
	     *         dimension.filter(null);
	     *     } else {
	     *         dimension.filterFunction(function (d) {
	     *             for (var i = 0; i < filters.length; i++) {
	     *                 var filter = filters[i];
	     *                 if (filter.isFiltered && filter.isFiltered(d)) {
	     *                     return true;
	     *                 } else if (filter <= d && filter >= d) {
	     *                     return true;
	     *                 }
	     *             }
	     *             return false;
	     *         });
	     *     }
	     *     return filters;
	     * });
	     *
	     * // custom filter handler
	     * chart.filterHandler(function(dimension, filter){
	     *     var newFilter = filter + 10;
	     *     dimension.filter(newFilter);
	     *     return newFilter; // set the actual filter value to the new value
	     * });
	     * @param {Function} [filterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.filterHandler = function (filterHandler) {
	        if (!arguments.length) {
	            return _filterHandler;
	        }
	        _filterHandler = filterHandler;
	        return _chart;
	    };
	
	    // abstract function stub
	    _chart._doRender = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    _chart.legendables = function () {
	        // do nothing in base, should be overridden by sub-function
	        return [];
	    };
	
	    _chart.legendHighlight = function () {
	        // do nothing in base, should be overridden by sub-function
	    };
	
	    _chart.legendReset = function () {
	        // do nothing in base, should be overridden by sub-function
	    };
	
	    _chart.legendToggle = function () {
	        // do nothing in base, should be overriden by sub-function
	    };
	
	    _chart.isLegendableHidden = function () {
	        // do nothing in base, should be overridden by sub-function
	        return false;
	    };
	
	    /**
	     * Set or get the key accessor function. The key accessor function is used to retrieve the key
	     * value from the crossfilter group. Key values are used differently in different charts, for
	     * example keys correspond to slices in a pie chart and x axis positions in a grid coordinate chart.
	     * @name keyAccessor
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default key accessor
	     * chart.keyAccessor(function(d) { return d.key; });
	     * // custom key accessor for a multi-value crossfilter reduction
	     * chart.keyAccessor(function(p) { return p.value.absGain; });
	     * @param {Function} [keyAccessor]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.keyAccessor = function (keyAccessor) {
	        if (!arguments.length) {
	            return _keyAccessor;
	        }
	        _keyAccessor = keyAccessor;
	        return _chart;
	    };
	
	    /**
	     * Set or get the value accessor function. The value accessor function is used to retrieve the
	     * value from the crossfilter group. Group values are used differently in different charts, for
	     * example values correspond to slice sizes in a pie chart and y axis positions in a grid
	     * coordinate chart.
	     * @name valueAccessor
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default value accessor
	     * chart.valueAccessor(function(d) { return d.value; });
	     * // custom value accessor for a multi-value crossfilter reduction
	     * chart.valueAccessor(function(p) { return p.value.percentageGain; });
	     * @param {Function} [valueAccessor]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.valueAccessor = function (valueAccessor) {
	        if (!arguments.length) {
	            return _valueAccessor;
	        }
	        _valueAccessor = valueAccessor;
	        return _chart;
	    };
	
	    /**
	     * Set or get the label function. The chart class will use this function to render labels for each
	     * child element in the chart, e.g. slices in a pie chart or bubbles in a bubble chart. Not every
	     * chart supports the label function for example bar chart and line chart do not use this function
	     * at all.
	     * @name label
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default label function just return the key
	     * chart.label(function(d) { return d.key; });
	     * // label function has access to the standard d3 data binding and can get quite complicated
	     * chart.label(function(d) { return d.data.key + '(' + Math.floor(d.data.value / all.value() * 100) + '%)'; });
	     * @param {Function} [labelFunction]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.label = function (labelFunction) {
	        if (!arguments.length) {
	            return _label;
	        }
	        _label = labelFunction;
	        _renderLabel = true;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off label rendering
	     * @name renderLabel
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [renderLabel=false]
	     * @return {Boolean}
	     * @return {dc.baseMixin}
	     */
	    _chart.renderLabel = function (renderLabel) {
	        if (!arguments.length) {
	            return _renderLabel;
	        }
	        _renderLabel = renderLabel;
	        return _chart;
	    };
	
	    /**
	     * Set or get the title function. The chart class will use this function to render the SVGElement title
	     * (usually interpreted by browser as tooltips) for each child element in the chart, e.g. a slice
	     * in a pie chart or a bubble in a bubble chart. Almost every chart supports the title function;
	     * however in grid coordinate charts you need to turn off the brush in order to see titles, because
	     * otherwise the brush layer will block tooltip triggering.
	     * @name title
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default title function just return the key
	     * chart.title(function(d) { return d.key + ': ' + d.value; });
	     * // title function has access to the standard d3 data binding and can get quite complicated
	     * chart.title(function(p) {
	     *    return p.key.getFullYear()
	     *        + '\n'
	     *        + 'Index Gain: ' + numberFormat(p.value.absGain) + '\n'
	     *        + 'Index Gain in Percentage: ' + numberFormat(p.value.percentageGain) + '%\n'
	     *        + 'Fluctuation / Index Ratio: ' + numberFormat(p.value.fluctuationPercentage) + '%';
	     * });
	     * @param {Function} [titleFunction]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.title = function (titleFunction) {
	        if (!arguments.length) {
	            return _title;
	        }
	        _title = titleFunction;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off title rendering, or return the state of the render title flag if no arguments are
	     * given.
	     * @name renderTitle
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [renderTitle=true]
	     * @return {Boolean}
	     * @return {dc.baseMixin}
	     */
	    _chart.renderTitle = function (renderTitle) {
	        if (!arguments.length) {
	            return _renderTitle;
	        }
	        _renderTitle = renderTitle;
	        return _chart;
	    };
	
	    /**
	     * A renderlet is similar to an event listener on rendering event. Multiple renderlets can be added
	     * to an individual chart.  Each time a chart is rerendered or redrawn the renderlets are invoked
	     * right after the chart finishes its transitions, giving you a way to modify the SVGElements.
	     * Renderlet functions take the chart instance as the only input parameter and you can
	     * use the dc API or use raw d3 to achieve pretty much any effect.
	     *
	     * Use {@link #dc.baseMixin+on on} with a 'renderlet' prefix.
	     * Generates a random key for the renderlet, which makes it hard to remove.
	     * @name renderlet
	     * @memberof dc.baseMixin
	     * @instance
	     * @deprecated
	     * @example
	     * // do this instead of .renderlet(function(chart) { ... })
	     * chart.on("renderlet", function(chart){
	     *     // mix of dc API and d3 manipulation
	     *     chart.select('g.y').style('display', 'none');
	     *     // its a closure so you can also access other chart variable available in the closure scope
	     *     moveChart.filter(chart.filter());
	     * });
	     * @param {Function} renderletFunction
	     * @return {dc.baseMixin}
	     */
	    _chart.renderlet = dc.logger.deprecate(function (renderletFunction) {
	        _chart.on('renderlet.' + dc.utils.uniqueId(), renderletFunction);
	        return _chart;
	    }, 'chart.renderlet has been deprecated.  Please use chart.on("renderlet.<renderletKey>", renderletFunction)');
	
	    /**
	     * Get or set the chart group to which this chart belongs. Chart groups are rendered or redrawn
	     * together since it is expected they share the same underlying crossfilter data set.
	     * @name chartGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {String} [chartGroup]
	     * @return {String}
	     * @return {dc.baseMixin}
	     */
	    _chart.chartGroup = function (chartGroup) {
	        if (!arguments.length) {
	            return _chartGroup;
	        }
	        if (!_isChild) {
	            dc.deregisterChart(_chart, _chartGroup);
	        }
	        _chartGroup = chartGroup;
	        if (!_isChild) {
	            dc.registerChart(_chart, _chartGroup);
	        }
	        return _chart;
	    };
	
	    /**
	     * Expire the internal chart cache. dc charts cache some data internally on a per chart basis to
	     * speed up rendering and avoid unnecessary calculation; however it might be useful to clear the
	     * cache if you have changed state which will affect rendering.  For example if you invoke the
	     * `crossfilter.add` function or reset group or dimension after rendering it is a good idea to
	     * clear the cache to make sure charts are rendered properly.
	     * @name expireCache
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.expireCache = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    /**
	     * Attach a dc.legend widget to this chart. The legend widget will automatically draw legend labels
	     * based on the color setting and names associated with each group.
	     * @name legend
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * chart.legend(dc.legend().x(400).y(10).itemHeight(13).gap(5))
	     * @param {dc.legend} [legend]
	     * @return {dc.legend}
	     * @return {dc.baseMixin}
	     */
	    _chart.legend = function (legend) {
	        if (!arguments.length) {
	            return _legend;
	        }
	        _legend = legend;
	        _legend.parent(_chart);
	        return _chart;
	    };
	
	    /**
	     * Returns the internal numeric ID of the chart.
	     * @name chartID
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {String}
	     */
	    _chart.chartID = function () {
	        return _chart.__dcFlag__;
	    };
	
	    /**
	     * Set chart options using a configuration object. Each key in the object will cause the method of
	     * the same name to be called with the value to set that attribute for the chart.
	     * @name options
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * chart.options({dimension: myDimension, group: myGroup});
	     * @param {{}} opts
	     * @return {dc.baseMixin}
	     */
	    _chart.options = function (opts) {
	        var applyOptions = [
	            'anchor',
	            'group',
	            'xAxisLabel',
	            'yAxisLabel',
	            'stack',
	            'title',
	            'point',
	            'getColor',
	            'overlayGeoJson'
	        ];
	
	        for (var o in opts) {
	            if (typeof(_chart[o]) === 'function') {
	                if (opts[o] instanceof Array && applyOptions.indexOf(o) !== -1) {
	                    _chart[o].apply(_chart, opts[o]);
	                } else {
	                    _chart[o].call(_chart, opts[o]);
	                }
	            } else {
	                dc.logger.debug('Not a valid option setter name: ' + o);
	            }
	        }
	        return _chart;
	    };
	
	    /**
	     * All dc chart instance supports the following listeners.
	     * Supports the following events:
	     * * `renderlet` - This listener function will be invoked after transitions after redraw and render. Replaces the
	     * deprecated {@link #dc.baseMixin+renderlet renderlet} method.
	     * * `pretransition` - Like `.on('renderlet', ...)` but the event is fired before transitions start.
	     * * `preRender` - This listener function will be invoked before chart rendering.
	     * * `postRender` - This listener function will be invoked after chart finish rendering including
	     * all renderlets' logic.
	     * * `preRedraw` - This listener function will be invoked before chart redrawing.
	     * * `postRedraw` - This listener function will be invoked after chart finish redrawing
	     * including all renderlets' logic.
	     * * `filtered` - This listener function will be invoked after a filter is applied, added or removed.
	     * * `zoomed` - This listener function will be invoked after a zoom is triggered.
	     * @name on
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Internals#dispatch_on d3.dispatch.on}
	     * @example
	     * .on('renderlet', function(chart, filter){...})
	     * .on('pretransition', function(chart, filter){...})
	     * .on('preRender', function(chart){...})
	     * .on('postRender', function(chart){...})
	     * .on('preRedraw', function(chart){...})
	     * .on('postRedraw', function(chart){...})
	     * .on('filtered', function(chart, filter){...})
	     * .on('zoomed', function(chart, filter){...})
	     * @param {String} event
	     * @param {Function} listener
	     * @return {dc.baseMixin}
	     */
	    _chart.on = function (event, listener) {
	        _listeners.on(event, listener);
	        return _chart;
	    };
	
	    return _chart;
	};
	
	/**
	 * Margin is a mixin that provides margin utility functions for both the Row Chart and Coordinate Grid
	 * Charts.
	 * @name marginMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.marginMixin}
	 */
	dc.marginMixin = function (_chart) {
	    var _margin = {top: 10, right: 50, bottom: 30, left: 30};
	
	    /**
	     * Get or set the margins for a particular coordinate grid chart instance. The margins is stored as
	     * an associative Javascript array.
	     * @name margins
	     * @memberof dc.marginMixin
	     * @instance
	     * @example
	     * var leftMargin = chart.margins().left; // 30 by default
	     * chart.margins().left = 50;
	     * leftMargin = chart.margins().left; // now 50
	     * @param {{top: Number, right: Number, left: Number, bottom: Number}} [margins={top: 10, right: 50, bottom: 30, left: 30}]
	     * @return {{top: Number, right: Number, left: Number, bottom: Number}}
	     * @return {dc.marginMixin}
	     */
	    _chart.margins = function (margins) {
	        if (!arguments.length) {
	            return _margin;
	        }
	        _margin = margins;
	        return _chart;
	    };
	
	    _chart.effectiveWidth = function () {
	        return _chart.width() - _chart.margins().left - _chart.margins().right;
	    };
	
	    _chart.effectiveHeight = function () {
	        return _chart.height() - _chart.margins().top - _chart.margins().bottom;
	    };
	
	    return _chart;
	};
	
	/**
	 * The Color Mixin is an abstract chart functional class providing universal coloring support
	 * as a mix-in for any concrete chart implementation.
	 * @name colorMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.colorMixin}
	 */
	dc.colorMixin = function (_chart) {
	    var _colors = d3.scale.category20c();
	    var _defaultAccessor = true;
	
	    var _colorAccessor = function (d) { return _chart.keyAccessor()(d); };
	
	    /**
	     * Retrieve current color scale or set a new color scale. This methods accepts any function that
	     * operates like a d3 scale.
	     * @name colors
	     * @memberof dc.colorMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @example
	     * // alternate categorical scale
	     * chart.colors(d3.scale.category20b());
	     * // ordinal scale
	     * chart.colors(d3.scale.ordinal().range(['red','green','blue']));
	     * // convenience method, the same as above
	     * chart.ordinalColors(['red','green','blue']);
	     * // set a linear scale
	     * chart.linearColors(["#4575b4", "#ffffbf", "#a50026"]);
	     * @param {d3.scale} [colorScale=d3.scale.category20c()]
	     * @return {d3.scale}
	     * @return {dc.colorMixin}
	     */
	    _chart.colors = function (colorScale) {
	        if (!arguments.length) {
	            return _colors;
	        }
	        if (colorScale instanceof Array) {
	            _colors = d3.scale.quantize().range(colorScale); // deprecated legacy support, note: this fails for ordinal domains
	        } else {
	            _colors = d3.functor(colorScale);
	        }
	        return _chart;
	    };
	
	    /**
	     * Convenience method to set the color scale to d3.scale.ordinal with range `r`.
	     * @name ordinalColors
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<String>} r
	     * @return {dc.colorMixin}
	     */
	    _chart.ordinalColors = function (r) {
	        return _chart.colors(d3.scale.ordinal().range(r));
	    };
	
	    /**
	     * Convenience method to set the color scale to an Hcl interpolated linear scale with range `r`.
	     * @name linearColors
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<Number>} r
	     * @return {dc.colorMixin}
	     */
	    _chart.linearColors = function (r) {
	        return _chart.colors(d3.scale.linear()
	                             .range(r)
	                             .interpolate(d3.interpolateHcl));
	    };
	
	    /**
	     * Set or the get color accessor function. This function will be used to map a data point in a
	     * crossfilter group to a color value on the color scale. The default function uses the key
	     * accessor.
	     * @name colorAccessor
	     * @memberof dc.colorMixin
	     * @instance
	     * @example
	     * // default index based color accessor
	     * .colorAccessor(function (d, i){return i;})
	     * // color accessor for a multi-value crossfilter reduction
	     * .colorAccessor(function (d){return d.value.absGain;})
	     * @param {Function} [colorAccessor]
	     * @return {Function}
	     * @return {dc.colorMixin}
	     */
	    _chart.colorAccessor = function (colorAccessor) {
	        if (!arguments.length) {
	            return _colorAccessor;
	        }
	        _colorAccessor = colorAccessor;
	        _defaultAccessor = false;
	        return _chart;
	    };
	
	    // what is this?
	    _chart.defaultColorAccessor = function () {
	        return _defaultAccessor;
	    };
	
	    /**
	     * Set or get the current domain for the color mapping function. The domain must be supplied as an
	     * array.
	     *
	     * Note: previously this method accepted a callback function. Instead you may use a custom scale
	     * set by `.colors`.
	     * @name colorDomain
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<String>} [domain]
	     * @return {Array<String>}
	     * @return {dc.colorMixin}
	     */
	    _chart.colorDomain = function (domain) {
	        if (!arguments.length) {
	            return _colors.domain();
	        }
	        _colors.domain(domain);
	        return _chart;
	    };
	
	    /**
	     * Set the domain by determining the min and max values as retrieved by `.colorAccessor` over the
	     * chart's dataset.
	     * @name calculateColorDomain
	     * @memberof dc.colorMixin
	     * @instance
	     * @return {dc.colorMixin}
	     */
	    _chart.calculateColorDomain = function () {
	        var newDomain = [d3.min(_chart.data(), _chart.colorAccessor()),
	                         d3.max(_chart.data(), _chart.colorAccessor())];
	        _colors.domain(newDomain);
	        return _chart;
	    };
	
	    /**
	     * Get the color for the datum d and counter i. This is used internally by charts to retrieve a color.
	     * @name getColor
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {*} d
	     * @param {Number} [i]
	     * @return {String}
	     */
	    _chart.getColor = function (d, i) {
	        return _colors(_colorAccessor.call(this, d, i));
	    };
	
	    /**
	     * Get the color for the datum d and counter i. This is used internally by charts to retrieve a color.
	     * @name colorCalculator
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {*} [colorCalculator]
	     * @return {*}
	     */
	    _chart.colorCalculator = function (colorCalculator) {
	        if (!arguments.length) {
	            return _chart.getColor;
	        }
	        _chart.getColor = colorCalculator;
	        return _chart;
	    };
	
	    return _chart;
	};
	
	/**
	 * Coordinate Grid is an abstract base chart designed to support a number of coordinate grid based
	 * concrete chart types, e.g. bar chart, line chart, and bubble chart.
	 * @name coordinateGridMixin
	 * @memberof dc
	 * @mixin
	 * @mixes dc.colorMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.baseMixin
	 * @param {Object} _chart
	 * @return {dc.coordinateGridMixin}
	 */
	dc.coordinateGridMixin = function (_chart) {
	    var GRID_LINE_CLASS = 'grid-line';
	    var HORIZONTAL_CLASS = 'horizontal';
	    var VERTICAL_CLASS = 'vertical';
	    var Y_AXIS_LABEL_CLASS = 'y-axis-label';
	    var X_AXIS_LABEL_CLASS = 'x-axis-label';
	    var DEFAULT_AXIS_LABEL_PADDING = 12;
	
	    _chart = dc.colorMixin(dc.marginMixin(dc.baseMixin(_chart)));
	
	    _chart.colors(d3.scale.category10());
	    _chart._mandatoryAttributes().push('x');
	
	    function zoomHandler () {
	        _refocused = true;
	        if (_zoomOutRestrict) {
	            _chart.x().domain(constrainRange(_chart.x().domain(), _xOriginalDomain));
	            if (_rangeChart) {
	                _chart.x().domain(constrainRange(_chart.x().domain(), _rangeChart.x().domain()));
	            }
	        }
	
	        var domain = _chart.x().domain();
	        var domFilter = dc.filters.RangedFilter(domain[0], domain[1]);
	
	        _chart.replaceFilter(domFilter);
	        _chart.rescale();
	        _chart.redraw();
	
	        if (_rangeChart && !rangesEqual(_chart.filter(), _rangeChart.filter())) {
	            dc.events.trigger(function () {
	                _rangeChart.replaceFilter(domFilter);
	                _rangeChart.redraw();
	            });
	        }
	
	        _chart._invokeZoomedListener();
	
	        dc.events.trigger(function () {
	            _chart.redrawGroup();
	        }, dc.constants.EVENT_DELAY);
	
	        _refocused = !rangesEqual(domain, _xOriginalDomain);
	    }
	
	    var _parent;
	    var _g;
	    var _chartBodyG;
	
	    var _x;
	    var _xOriginalDomain;
	    var _xAxis = d3.svg.axis().orient('bottom');
	    var _xUnits = dc.units.integers;
	    var _xAxisPadding = 0;
	    var _xElasticity = false;
	    var _xAxisLabel;
	    var _xAxisLabelPadding = 0;
	    var _lastXDomain;
	
	    var _y;
	    var _yAxis = d3.svg.axis().orient('left');
	    var _yAxisPadding = 0;
	    var _yElasticity = false;
	    var _yAxisLabel;
	    var _yAxisLabelPadding = 0;
	
	    var _brush = d3.svg.brush();
	    var _brushOn = true;
	    var _round;
	
	    var _renderHorizontalGridLine = false;
	    var _renderVerticalGridLine = false;
	
	    var _refocused = false, _resizing = false;
	    var _unitCount;
	
	    var _zoomScale = [1, Infinity];
	    var _zoomOutRestrict = true;
	
	    var _zoom = d3.behavior.zoom().on('zoom', zoomHandler);
	    var _nullZoom = d3.behavior.zoom().on('zoom', null);
	    var _hasBeenMouseZoomable = false;
	
	    var _rangeChart;
	    var _focusChart;
	
	    var _mouseZoomable = false;
	    var _clipPadding = 0;
	
	    var _outerRangeBandPadding = 0.5;
	    var _rangeBandPadding = 0;
	
	    var _useRightYAxis = false;
	
	    /**
	     * When changing the domain of the x or y scale, it is necessary to tell the chart to recalculate
	     * and redraw the axes. (`.rescale()` is called automatically when the x or y scale is replaced
	     * with `.x()` or `.y()`, and has no effect on elastic scales.)
	     * @name rescale
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.rescale = function () {
	        _unitCount = undefined;
	        _resizing = true;
	        return _chart;
	    };
	
	    /**
	     * Get or set the range selection chart associated with this instance. Setting the range selection
	     * chart using this function will automatically update its selection brush when the current chart
	     * zooms in. In return the given range chart will also automatically attach this chart as its focus
	     * chart hence zoom in when range brush updates. See the [Nasdaq 100
	     * Index](http://dc-js.github.com/dc.js/) example for this effect in action.
	     * @name rangeChart
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {dc.coordinateGridMixin} [rangeChart]
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.rangeChart = function (rangeChart) {
	        if (!arguments.length) {
	            return _rangeChart;
	        }
	        _rangeChart = rangeChart;
	        _rangeChart.focusChart(_chart);
	        return _chart;
	    };
	
	    /**
	     * Get or set the scale extent for mouse zooms.
	     * @name zoomScale
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Array<Number|Date>} [extent=[1, Infinity]]
	     * @return {Array<Number|Date>}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.zoomScale = function (extent) {
	        if (!arguments.length) {
	            return _zoomScale;
	        }
	        _zoomScale = extent;
	        return _chart;
	    };
	
	    /**
	     * Get or set the zoom restriction for the chart. If true limits the zoom to origional domain of the chart.
	     * @name zoomOutRestrict
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [zoomOutRestrict=true]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.zoomOutRestrict = function (zoomOutRestrict) {
	        if (!arguments.length) {
	            return _zoomOutRestrict;
	        }
	        _zoomScale[0] = zoomOutRestrict ? 1 : 0;
	        _zoomOutRestrict = zoomOutRestrict;
	        return _chart;
	    };
	
	    _chart._generateG = function (parent) {
	        if (parent === undefined) {
	            _parent = _chart.svg();
	        } else {
	            _parent = parent;
	        }
	
	        _g = _parent.append('g');
	
	        _chartBodyG = _g.append('g').attr('class', 'chart-body')
	            .attr('transform', 'translate(' + _chart.margins().left + ', ' + _chart.margins().top + ')')
	            .attr('clip-path', 'url(#' + getClipPathId() + ')');
	
	        return _g;
	    };
	
	    /**
	     * Get or set the root g element. This method is usually used to retrieve the g element in order to
	     * overlay custom svg drawing programatically. **Caution**: The root g element is usually generated
	     * by dc.js internals, and resetting it might produce unpredictable result.
	     * @name g
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {SVGElement} [gElement]
	     * @return {SVGElement}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.g = function (gElement) {
	        if (!arguments.length) {
	            return _g;
	        }
	        _g = gElement;
	        return _chart;
	    };
	
	    /**
	     * Set or get mouse zoom capability flag (default: false). When turned on the chart will be
	     * zoomable using the mouse wheel. If the range selector chart is attached zooming will also update
	     * the range selection brush on the associated range selector chart.
	     * @name mouseZoomable
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [mouseZoomable=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.mouseZoomable = function (mouseZoomable) {
	        if (!arguments.length) {
	            return _mouseZoomable;
	        }
	        _mouseZoomable = mouseZoomable;
	        return _chart;
	    };
	
	    /**
	     * Retrieve the svg group for the chart body.
	     * @name chartBodyG
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {SVGElement} [chartBodyG]
	     * @return {SVGElement}
	     */
	    _chart.chartBodyG = function (chartBodyG) {
	        if (!arguments.length) {
	            return _chartBodyG;
	        }
	        _chartBodyG = chartBodyG;
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Get or set the x scale. The x scale can be any d3
	     * [quantitive scale](https://github.com/mbostock/d3/wiki/Quantitative-Scales) or
	     * [ordinal scale](https://github.com/mbostock/d3/wiki/Ordinal-Scales).
	     * @name x
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @example
	     * // set x to a linear scale
	     * chart.x(d3.scale.linear().domain([-2500, 2500]))
	     * // set x to a time scale to generate histogram
	     * chart.x(d3.time.scale().domain([new Date(1985, 0, 1), new Date(2012, 11, 31)]))
	     * @param {d3.scale} [xScale]
	     * @return {d3.scale}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.x = function (xScale) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = xScale;
	        _xOriginalDomain = _x.domain();
	        _chart.rescale();
	        return _chart;
	    };
	
	    _chart.xOriginalDomain = function () {
	        return _xOriginalDomain;
	    };
	
	    /**
	     * Set or get the xUnits function. The coordinate grid chart uses the xUnits function to calculate
	     * the number of data projections on x axis such as the number of bars for a bar chart or the
	     * number of dots for a line chart. This function is expected to return a Javascript array of all
	     * data points on x axis, or the number of points on the axis. [d3 time range functions
	     * d3.time.days, d3.time.months, and
	     * d3.time.years](https://github.com/mbostock/d3/wiki/Time-Intervals#aliases) are all valid xUnits
	     * function. dc.js also provides a few units function, see the [Utilities](#utilities) section for
	     * a list of built-in units functions. The default xUnits function is dc.units.integers.
	     * @name xUnits
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * // set x units to count days
	     * chart.xUnits(d3.time.days);
	     * // set x units to count months
	     * chart.xUnits(d3.time.months);
	     *
	     * // A custom xUnits function can be used as long as it follows the following interface:
	     * // units in integer
	     * function(start, end, xDomain) {
	     *      // simply calculates how many integers in the domain
	     *      return Math.abs(end - start);
	     * };
	     *
	     * // fixed units
	     * function(start, end, xDomain) {
	     *      // be aware using fixed units will disable the focus/zoom ability on the chart
	     *      return 1000;
	     * @param {Function} [xUnits]
	     * @return {Function}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.xUnits = function (xUnits) {
	        if (!arguments.length) {
	            return _xUnits;
	        }
	        _xUnits = xUnits;
	        return _chart;
	    };
	
	    /**
	     * Set or get the x axis used by a particular coordinate grid chart instance. This function is most
	     * useful when x axis customization is required. The x axis in dc.js is an instance of a [d3
	     * axis object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-axis); therefore it supports any
	     * valid d3 axis manipulation. **Caution**: The x axis is usually generated internally by dc;
	     * resetting it may cause unexpected results.
	     * @name xAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/SVG-Axes d3.svg.axis}
	     * @example
	     * // customize x axis tick format
	     * chart.xAxis().tickFormat(function(v) {return v + '%';});
	     * // customize x axis tick values
	     * chart.xAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [xAxis=d3.svg.axis().orient('bottom')]
	     * @return {d3.svg.axis}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.xAxis = function (xAxis) {
	        if (!arguments.length) {
	            return _xAxis;
	        }
	        _xAxis = xAxis;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off elastic x axis behavior. If x axis elasticity is turned on, then the grid chart will
	     * attempt to recalculate the x axis range whenever a redraw event is triggered.
	     * @name elasticX
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [elasticX=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.elasticX = function (elasticX) {
	        if (!arguments.length) {
	            return _xElasticity;
	        }
	        _xElasticity = elasticX;
	        return _chart;
	    };
	
	    /**
	     * Set or get x axis padding for the elastic x axis. The padding will be added to both end of the x
	     * axis if elasticX is turned on; otherwise it is ignored.
	     *
	     * padding can be an integer or percentage in string (e.g. '10%'). Padding can be applied to
	     * number or date x axes.  When padding a date axis, an integer represents number of days being padded
	     * and a percentage string will be treated the same as an integer.
	     * @name xAxisPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number|String} [padding=0]
	     * @return {Number|String}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.xAxisPadding = function (padding) {
	        if (!arguments.length) {
	            return _xAxisPadding;
	        }
	        _xAxisPadding = padding;
	        return _chart;
	    };
	
	    /**
	     * Returns the number of units displayed on the x axis using the unit measure configured by
	     * .xUnits.
	     * @name xUnitCount
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {Number}
	     */
	    _chart.xUnitCount = function () {
	        if (_unitCount === undefined) {
	            var units = _chart.xUnits()(_chart.x().domain()[0], _chart.x().domain()[1], _chart.x().domain());
	
	            if (units instanceof Array) {
	                _unitCount = units.length;
	            } else {
	                _unitCount = units;
	            }
	        }
	
	        return _unitCount;
	    };
	
	    /**
	     * Gets or sets whether the chart should be drawn with a right axis instead of a left axis. When
	     * used with a chart in a composite chart, allows both left and right Y axes to be shown on a
	     * chart.
	     * @name useRightYAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [useRightYAxis=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.useRightYAxis = function (useRightYAxis) {
	        if (!arguments.length) {
	            return _useRightYAxis;
	        }
	        _useRightYAxis = useRightYAxis;
	        return _chart;
	    };
	
	    /**
	     * Returns true if the chart is using ordinal xUnits ([dc.units.ordinal](#dcunitsordinal)), or false
	     * otherwise. Most charts behave differently with ordinal data and use the result of this method to
	     * trigger the appropriate logic.
	     * @name isOrdinal
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {Boolean}
	     */
	    _chart.isOrdinal = function () {
	        return _chart.xUnits() === dc.units.ordinal;
	    };
	
	    _chart._useOuterPadding = function () {
	        return true;
	    };
	
	    _chart._ordinalXDomain = function () {
	        var groups = _chart._computeOrderedGroups(_chart.data());
	        return groups.map(_chart.keyAccessor());
	    };
	
	    function compareDomains (d1, d2) {
	        return !d1 || !d2 || d1.length !== d2.length ||
	            d1.some(function (elem, i) { return elem.toString() !== d2[i].toString(); });
	    }
	
	    function prepareXAxis (g, render) {
	        if (!_chart.isOrdinal()) {
	            if (_chart.elasticX()) {
	                _x.domain([_chart.xAxisMin(), _chart.xAxisMax()]);
	            }
	        } else { // _chart.isOrdinal()
	            if (_chart.elasticX() || _x.domain().length === 0) {
	                _x.domain(_chart._ordinalXDomain());
	            }
	        }
	
	        // has the domain changed?
	        var xdom = _x.domain();
	        if (render || compareDomains(_lastXDomain, xdom)) {
	            _chart.rescale();
	        }
	        _lastXDomain = xdom;
	
	        // please can't we always use rangeBands for bar charts?
	        if (_chart.isOrdinal()) {
	            _x.rangeBands([0, _chart.xAxisLength()], _rangeBandPadding,
	                          _chart._useOuterPadding() ? _outerRangeBandPadding : 0);
	        } else {
	            _x.range([0, _chart.xAxisLength()]);
	        }
	
	        _xAxis = _xAxis.scale(_chart.x());
	
	        renderVerticalGridLines(g);
	    }
	
	    _chart.renderXAxis = function (g) {
	        var axisXG = g.selectAll('g.x');
	
	        if (axisXG.empty()) {
	            axisXG = g.append('g')
	                .attr('class', 'axis x')
	                .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart._xAxisY() + ')');
	        }
	
	        var axisXLab = g.selectAll('text.' + X_AXIS_LABEL_CLASS);
	        if (axisXLab.empty() && _chart.xAxisLabel()) {
	            axisXLab = g.append('text')
	                .attr('class', X_AXIS_LABEL_CLASS)
	                .attr('transform', 'translate(' + (_chart.margins().left + _chart.xAxisLength() / 2) + ',' +
	                      (_chart.height() - _xAxisLabelPadding) + ')')
	                .attr('text-anchor', 'middle');
	        }
	        if (_chart.xAxisLabel() && axisXLab.text() !== _chart.xAxisLabel()) {
	            axisXLab.text(_chart.xAxisLabel());
	        }
	
	        dc.transition(axisXG, _chart.transitionDuration())
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart._xAxisY() + ')')
	            .call(_xAxis);
	        dc.transition(axisXLab, _chart.transitionDuration())
	            .attr('transform', 'translate(' + (_chart.margins().left + _chart.xAxisLength() / 2) + ',' +
	                  (_chart.height() - _xAxisLabelPadding) + ')');
	    };
	
	    function renderVerticalGridLines (g) {
	        var gridLineG = g.selectAll('g.' + VERTICAL_CLASS);
	
	        if (_renderVerticalGridLine) {
	            if (gridLineG.empty()) {
	                gridLineG = g.insert('g', ':first-child')
	                    .attr('class', GRID_LINE_CLASS + ' ' + VERTICAL_CLASS)
	                    .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	            }
	
	            var ticks = _xAxis.tickValues() ? _xAxis.tickValues() :
	                    (typeof _x.ticks === 'function' ? _x.ticks(_xAxis.ticks()[0]) : _x.domain());
	
	            var lines = gridLineG.selectAll('line')
	                .data(ticks);
	
	            // enter
	            var linesGEnter = lines.enter()
	                .append('line')
	                .attr('x1', function (d) {
	                    return _x(d);
	                })
	                .attr('y1', _chart._xAxisY() - _chart.margins().top)
	                .attr('x2', function (d) {
	                    return _x(d);
	                })
	                .attr('y2', 0)
	                .attr('opacity', 0);
	            dc.transition(linesGEnter, _chart.transitionDuration())
	                .attr('opacity', 1);
	
	            // update
	            dc.transition(lines, _chart.transitionDuration())
	                .attr('x1', function (d) {
	                    return _x(d);
	                })
	                .attr('y1', _chart._xAxisY() - _chart.margins().top)
	                .attr('x2', function (d) {
	                    return _x(d);
	                })
	                .attr('y2', 0);
	
	            // exit
	            lines.exit().remove();
	        } else {
	            gridLineG.selectAll('line').remove();
	        }
	    }
	
	    _chart._xAxisY = function () {
	        return (_chart.height() - _chart.margins().bottom);
	    };
	
	    _chart.xAxisLength = function () {
	        return _chart.effectiveWidth();
	    };
	
	    /**
	     * Set or get the x axis label. If setting the label, you may optionally include additional padding to
	     * the margin to make room for the label. By default the padded is set to 12 to accomodate the text height.
	     * @name xAxisLabel
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [labelText]
	     * @param {Number} [padding=12]
	     * @return {String}
	     */
	    _chart.xAxisLabel = function (labelText, padding) {
	        if (!arguments.length) {
	            return _xAxisLabel;
	        }
	        _xAxisLabel = labelText;
	        _chart.margins().bottom -= _xAxisLabelPadding;
	        _xAxisLabelPadding = (padding === undefined) ? DEFAULT_AXIS_LABEL_PADDING : padding;
	        _chart.margins().bottom += _xAxisLabelPadding;
	        return _chart;
	    };
	
	    _chart._prepareYAxis = function (g) {
	        if (_y === undefined || _chart.elasticY()) {
	            if (_y === undefined) {
	                _y = d3.scale.linear();
	            }
	            var min = _chart.yAxisMin() || 0,
	                max = _chart.yAxisMax() || 0;
	            _y.domain([min, max]).rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _y.range([_chart.yAxisHeight(), 0]);
	        _yAxis = _yAxis.scale(_y);
	
	        if (_useRightYAxis) {
	            _yAxis.orient('right');
	        }
	
	        _chart._renderHorizontalGridLinesForAxis(g, _y, _yAxis);
	    };
	
	    _chart.renderYAxisLabel = function (axisClass, text, rotation, labelXPosition) {
	        labelXPosition = labelXPosition || _yAxisLabelPadding;
	
	        var axisYLab = _chart.g().selectAll('text.' + Y_AXIS_LABEL_CLASS + '.' + axisClass + '-label');
	        var labelYPosition = (_chart.margins().top + _chart.yAxisHeight() / 2);
	        if (axisYLab.empty() && text) {
	            axisYLab = _chart.g().append('text')
	                .attr('transform', 'translate(' + labelXPosition + ',' + labelYPosition + '),rotate(' + rotation + ')')
	                .attr('class', Y_AXIS_LABEL_CLASS + ' ' + axisClass + '-label')
	                .attr('text-anchor', 'middle')
	                .text(text);
	        }
	        if (text && axisYLab.text() !== text) {
	            axisYLab.text(text);
	        }
	        dc.transition(axisYLab, _chart.transitionDuration())
	            .attr('transform', 'translate(' + labelXPosition + ',' + labelYPosition + '),rotate(' + rotation + ')');
	    };
	
	    _chart.renderYAxisAt = function (axisClass, axis, position) {
	        var axisYG = _chart.g().selectAll('g.' + axisClass);
	        if (axisYG.empty()) {
	            axisYG = _chart.g().append('g')
	                .attr('class', 'axis ' + axisClass)
	                .attr('transform', 'translate(' + position + ',' + _chart.margins().top + ')');
	        }
	
	        dc.transition(axisYG, _chart.transitionDuration())
	            .attr('transform', 'translate(' + position + ',' + _chart.margins().top + ')')
	            .call(axis);
	    };
	
	    _chart.renderYAxis = function () {
	        var axisPosition = _useRightYAxis ? (_chart.width() - _chart.margins().right) : _chart._yAxisX();
	        _chart.renderYAxisAt('y', _yAxis, axisPosition);
	        var labelPosition = _useRightYAxis ? (_chart.width() - _yAxisLabelPadding) : _yAxisLabelPadding;
	        var rotation = _useRightYAxis ? 90 : -90;
	        _chart.renderYAxisLabel('y', _chart.yAxisLabel(), rotation, labelPosition);
	    };
	
	    _chart._renderHorizontalGridLinesForAxis = function (g, scale, axis) {
	        var gridLineG = g.selectAll('g.' + HORIZONTAL_CLASS);
	
	        if (_renderHorizontalGridLine) {
	            var ticks = axis.tickValues() ? axis.tickValues() : scale.ticks(axis.ticks()[0]);
	
	            if (gridLineG.empty()) {
	                gridLineG = g.insert('g', ':first-child')
	                    .attr('class', GRID_LINE_CLASS + ' ' + HORIZONTAL_CLASS)
	                    .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	            }
	
	            var lines = gridLineG.selectAll('line')
	                .data(ticks);
	
	            // enter
	            var linesGEnter = lines.enter()
	                .append('line')
	                .attr('x1', 1)
	                .attr('y1', function (d) {
	                    return scale(d);
	                })
	                .attr('x2', _chart.xAxisLength())
	                .attr('y2', function (d) {
	                    return scale(d);
	                })
	                .attr('opacity', 0);
	            dc.transition(linesGEnter, _chart.transitionDuration())
	                .attr('opacity', 1);
	
	            // update
	            dc.transition(lines, _chart.transitionDuration())
	                .attr('x1', 1)
	                .attr('y1', function (d) {
	                    return scale(d);
	                })
	                .attr('x2', _chart.xAxisLength())
	                .attr('y2', function (d) {
	                    return scale(d);
	                });
	
	            // exit
	            lines.exit().remove();
	        } else {
	            gridLineG.selectAll('line').remove();
	        }
	    };
	
	    _chart._yAxisX = function () {
	        return _chart.useRightYAxis() ? _chart.width() - _chart.margins().right : _chart.margins().left;
	    };
	
	    /**
	     * Set or get the y axis label. If setting the label, you may optionally include additional padding
	     * to the margin to make room for the label. By default the padded is set to 12 to accomodate the
	     * text height.
	     * @name yAxisLabel
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [labelText]
	     * @param {Number} [padding=12]
	     * @return {String}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.yAxisLabel = function (labelText, padding) {
	        if (!arguments.length) {
	            return _yAxisLabel;
	        }
	        _yAxisLabel = labelText;
	        _chart.margins().left -= _yAxisLabelPadding;
	        _yAxisLabelPadding = (padding === undefined) ? DEFAULT_AXIS_LABEL_PADDING : padding;
	        _chart.margins().left += _yAxisLabelPadding;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y scale. The y scale is typically automatically determined by the chart implementation.
	     * @name y
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @param {d3.scale} [yScale]
	     * @return {d3.scale}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.y = function (yScale) {
	        if (!arguments.length) {
	            return _y;
	        }
	        _y = yScale;
	        _chart.rescale();
	        return _chart;
	    };
	
	    /**
	     * Set or get the y axis used by the coordinate grid chart instance. This function is most useful
	     * when y axis customization is required. The y axis in dc.js is simply an instance of a [d3 axis
	     * object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-_axis); therefore it supports any
	     * valid d3 axis manipulation. **Caution**: The y axis is usually generated internally by dc;
	     * resetting it may cause unexpected results.
	     * @name yAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/SVG-Axes d3.svg.axis}
	     * @example
	     * // customize y axis tick format
	     * chart.yAxis().tickFormat(function(v) {return v + '%';});
	     * // customize y axis tick values
	     * chart.yAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [yAxis=d3.svg.axis().orient('left')]
	     * @return {d3.svg.axis}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.yAxis = function (yAxis) {
	        if (!arguments.length) {
	            return _yAxis;
	        }
	        _yAxis = yAxis;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off elastic y axis behavior. If y axis elasticity is turned on, then the grid chart will
	     * attempt to recalculate the y axis range whenever a redraw event is triggered.
	     * @name elasticY
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [elasticY=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.elasticY = function (elasticY) {
	        if (!arguments.length) {
	            return _yElasticity;
	        }
	        _yElasticity = elasticY;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off horizontal grid lines.
	     * @name renderHorizontalGridLines
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [renderHorizontalGridLines=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.renderHorizontalGridLines = function (renderHorizontalGridLines) {
	        if (!arguments.length) {
	            return _renderHorizontalGridLine;
	        }
	        _renderHorizontalGridLine = renderHorizontalGridLines;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off vertical grid lines.
	     * @name renderVerticalGridLines
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [renderVerticalGridLines=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.renderVerticalGridLines = function (renderVerticalGridLines) {
	        if (!arguments.length) {
	            return _renderVerticalGridLine;
	        }
	        _renderVerticalGridLine = renderVerticalGridLines;
	        return _chart;
	    };
	
	    /**
	     * Calculates the minimum x value to display in the chart. Includes xAxisPadding if set.
	     * @name xAxisMin
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.xAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.keyAccessor()(e);
	        });
	        return dc.utils.subtract(min, _xAxisPadding);
	    };
	
	    /**
	     * Calculates the maximum x value to display in the chart. Includes xAxisPadding if set.
	     * @name xAxisMax
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.xAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.keyAccessor()(e);
	        });
	        return dc.utils.add(max, _xAxisPadding);
	    };
	
	    /**
	     * Calculates the minimum y value to display in the chart. Includes yAxisPadding if set.
	     * @name yAxisMin
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.yAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.valueAccessor()(e);
	        });
	        return dc.utils.subtract(min, _yAxisPadding);
	    };
	
	    /**
	     * Calculates the maximum y value to display in the chart. Includes yAxisPadding if set.
	     * @name yAxisMax
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.yAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.valueAccessor()(e);
	        });
	        return dc.utils.add(max, _yAxisPadding);
	    };
	
	    /**
	     * Set or get y axis padding for the elastic y axis. The padding will be added to the top of the y
	     * axis if elasticY is turned on; otherwise it is ignored.
	     *
	     * padding can be an integer or percentage in string (e.g. '10%'). Padding can be applied to
	     * number or date axes. When padding a date axis, an integer represents number of days being padded
	     * and a percentage string will be treated the same as an integer.
	     * @name yAxisPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number|String} [padding=0]
	     * @return {Number}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.yAxisPadding = function (padding) {
	        if (!arguments.length) {
	            return _yAxisPadding;
	        }
	        _yAxisPadding = padding;
	        return _chart;
	    };
	
	    _chart.yAxisHeight = function () {
	        return _chart.effectiveHeight();
	    };
	
	    /**
	     * Set or get the rounding function used to quantize the selection when brushing is enabled.
	     * @name round
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * // set x unit round to by month, this will make sure range selection brush will
	     * // select whole months
	     * chart.round(d3.time.month.round);
	     * @param {Function} [round]
	     * @return {Function}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.round = function (round) {
	        if (!arguments.length) {
	            return _round;
	        }
	        _round = round;
	        return _chart;
	    };
	
	    _chart._rangeBandPadding = function (_) {
	        if (!arguments.length) {
	            return _rangeBandPadding;
	        }
	        _rangeBandPadding = _;
	        return _chart;
	    };
	
	    _chart._outerRangeBandPadding = function (_) {
	        if (!arguments.length) {
	            return _outerRangeBandPadding;
	        }
	        _outerRangeBandPadding = _;
	        return _chart;
	    };
	
	    dc.override(_chart, 'filter', function (_) {
	        if (!arguments.length) {
	            return _chart._filter();
	        }
	
	        _chart._filter(_);
	
	        if (_) {
	            _chart.brush().extent(_);
	        } else {
	            _chart.brush().clear();
	        }
	
	        return _chart;
	    });
	
	    _chart.brush = function (_) {
	        if (!arguments.length) {
	            return _brush;
	        }
	        _brush = _;
	        return _chart;
	    };
	
	    function brushHeight () {
	        return _chart._xAxisY() - _chart.margins().top;
	    }
	
	    _chart.renderBrush = function (g) {
	        if (_brushOn) {
	            _brush.on('brush', _chart._brushing);
	            _brush.on('brushstart', _chart._disableMouseZoom);
	            _brush.on('brushend', configureMouseZoom);
	
	            var gBrush = g.append('g')
	                .attr('class', 'brush')
	                .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')')
	                .call(_brush.x(_chart.x()));
	            _chart.setBrushY(gBrush, false);
	            _chart.setHandlePaths(gBrush);
	
	            if (_chart.hasFilter()) {
	                _chart.redrawBrush(g, false);
	            }
	        }
	    };
	
	    _chart.setHandlePaths = function (gBrush) {
	        gBrush.selectAll('.resize').append('path').attr('d', _chart.resizeHandlePath);
	    };
	
	    _chart.setBrushY = function (gBrush) {
	        gBrush.selectAll('.brush rect')
	            .attr('height', brushHeight());
	        gBrush.selectAll('.resize path')
	            .attr('d', _chart.resizeHandlePath);
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _brush.extent();
	        if (_chart.round()) {
	            extent[0] = extent.map(_chart.round())[0];
	            extent[1] = extent.map(_chart.round())[1];
	
	            _g.select('.brush')
	                .call(_brush.extent(extent));
	        }
	        return extent;
	    };
	
	    _chart.brushIsEmpty = function (extent) {
	        return _brush.empty() || !extent || extent[1] <= extent[0];
	    };
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	
	        _chart.redrawBrush(_g, false);
	
	        if (_chart.brushIsEmpty(extent)) {
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	        } else {
	            var rangedFilter = dc.filters.RangedFilter(extent[0], extent[1]);
	
	            dc.events.trigger(function () {
	                _chart.replaceFilter(rangedFilter);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	        }
	    };
	
	    _chart.redrawBrush = function (g, doTransition) {
	        if (_brushOn) {
	            if (_chart.filter() && _chart.brush().empty()) {
	                _chart.brush().extent(_chart.filter());
	            }
	
	            var gBrush = dc.optionalTransition(doTransition, _chart.transitionDuration())(g.select('g.brush'));
	            _chart.setBrushY(gBrush);
	            gBrush.call(_chart.brush()
	                      .x(_chart.x())
	                      .extent(_chart.brush().extent()));
	        }
	
	        _chart.fadeDeselectedArea();
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        // do nothing, sub-chart should override this function
	    };
	
	    // borrowed from Crossfilter example
	    _chart.resizeHandlePath = function (d) {
	        var e = +(d === 'e'), x = e ? 1 : -1, y = brushHeight() / 3;
	        return 'M' + (0.5 * x) + ',' + y +
	            'A6,6 0 0 ' + e + ' ' + (6.5 * x) + ',' + (y + 6) +
	            'V' + (2 * y - 6) +
	            'A6,6 0 0 ' + e + ' ' + (0.5 * x) + ',' + (2 * y) +
	            'Z' +
	            'M' + (2.5 * x) + ',' + (y + 8) +
	            'V' + (2 * y - 8) +
	            'M' + (4.5 * x) + ',' + (y + 8) +
	            'V' + (2 * y - 8);
	    };
	
	    function getClipPathId () {
	        return _chart.anchorName().replace(/[ .#=\[\]]/g, '-') + '-clip';
	    }
	
	    /**
	     * Get or set the padding in pixels for the clip path. Once set padding will be applied evenly to
	     * the top, left, right, and bottom when the clip path is generated. If set to zero, the clip area
	     * will be exactly the chart body area minus the margins.
	     * @name clipPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number} [padding=5]
	     * @return {Number}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.clipPadding = function (padding) {
	        if (!arguments.length) {
	            return _clipPadding;
	        }
	        _clipPadding = padding;
	        return _chart;
	    };
	
	    function generateClipPath () {
	        var defs = dc.utils.appendOrSelect(_parent, 'defs');
	        // cannot select <clippath> elements; bug in WebKit, must select by id
	        // https://groups.google.com/forum/#!topic/d3-js/6EpAzQ2gU9I
	        var id = getClipPathId();
	        var chartBodyClip = dc.utils.appendOrSelect(defs, '#' + id, 'clipPath').attr('id', id);
	
	        var padding = _clipPadding * 2;
	
	        dc.utils.appendOrSelect(chartBodyClip, 'rect')
	            .attr('width', _chart.xAxisLength() + padding)
	            .attr('height', _chart.yAxisHeight() + padding)
	            .attr('transform', 'translate(-' + _clipPadding + ', -' + _clipPadding + ')');
	    }
	
	    _chart._preprocessData = function () {};
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _chart._preprocessData();
	
	        _chart._generateG();
	        generateClipPath();
	
	        drawChart(true);
	
	        configureMouseZoom();
	
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        _chart._preprocessData();
	
	        drawChart(false);
	        generateClipPath();
	
	        return _chart;
	    };
	
	    function drawChart (render) {
	        if (_chart.isOrdinal()) {
	            _brushOn = false;
	        }
	
	        prepareXAxis(_chart.g(), render);
	        _chart._prepareYAxis(_chart.g());
	
	        _chart.plotData();
	
	        if (_chart.elasticX() || _resizing || render) {
	            _chart.renderXAxis(_chart.g());
	        }
	
	        if (_chart.elasticY() || _resizing || render) {
	            _chart.renderYAxis(_chart.g());
	        }
	
	        if (render) {
	            _chart.renderBrush(_chart.g(), false);
	        } else {
	            _chart.redrawBrush(_chart.g(), _resizing);
	        }
	        _chart.fadeDeselectedArea();
	        _resizing = false;
	    }
	
	    function configureMouseZoom () {
	        if (_mouseZoomable) {
	            _chart._enableMouseZoom();
	        } else if (_hasBeenMouseZoomable) {
	            _chart._disableMouseZoom();
	        }
	    }
	
	    _chart._enableMouseZoom = function () {
	        _hasBeenMouseZoomable = true;
	        _zoom.x(_chart.x())
	            .scaleExtent(_zoomScale)
	            .size([_chart.width(), _chart.height()])
	            .duration(_chart.transitionDuration());
	        _chart.root().call(_zoom);
	    };
	
	    _chart._disableMouseZoom = function () {
	        _chart.root().call(_nullZoom);
	    };
	
	    function constrainRange (range, constraint) {
	        var constrainedRange = [];
	        constrainedRange[0] = d3.max([range[0], constraint[0]]);
	        constrainedRange[1] = d3.min([range[1], constraint[1]]);
	        return constrainedRange;
	    }
	
	    /**
	     * Zoom this chart to focus on the given range. The given range should be an array containing only
	     * 2 elements (`[start, end]`) defining a range in the x domain. If the range is not given or set
	     * to null, then the zoom will be reset. _For focus to work elasticX has to be turned off;
	     * otherwise focus will be ignored.
	     * @name focus
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * chart.on('renderlet', function(chart) {
	     *     // smooth the rendering through event throttling
	     *     dc.events.trigger(function(){
	     *          // focus some other chart to the range selected by user on this chart
	     *          someOtherChart.focus(chart.filter());
	     *     });
	     * })
	     * @param {Array<Number>} [range]
	     */
	    _chart.focus = function (range) {
	        if (hasRangeSelected(range)) {
	            _chart.x().domain(range);
	        } else {
	            _chart.x().domain(_xOriginalDomain);
	        }
	
	        _zoom.x(_chart.x());
	        zoomHandler();
	    };
	
	    _chart.refocused = function () {
	        return _refocused;
	    };
	
	    _chart.focusChart = function (c) {
	        if (!arguments.length) {
	            return _focusChart;
	        }
	        _focusChart = c;
	        _chart.on('filtered', function (chart) {
	            if (!chart.filter()) {
	                dc.events.trigger(function () {
	                    _focusChart.x().domain(_focusChart.xOriginalDomain());
	                });
	            } else if (!rangesEqual(chart.filter(), _focusChart.filter())) {
	                dc.events.trigger(function () {
	                    _focusChart.focus(chart.filter());
	                });
	            }
	        });
	        return _chart;
	    };
	
	    function rangesEqual (range1, range2) {
	        if (!range1 && !range2) {
	            return true;
	        } else if (!range1 || !range2) {
	            return false;
	        } else if (range1.length === 0 && range2.length === 0) {
	            return true;
	        } else if (range1[0].valueOf() === range2[0].valueOf() &&
	            range1[1].valueOf() === range2[1].valueOf()) {
	            return true;
	        }
	        return false;
	    }
	
	    /**
	     * Turn on/off the brush-based range filter. When brushing is on then user can drag the mouse
	     * across a chart with a quantitative scale to perform range filtering based on the extent of the
	     * brush, or click on the bars of an ordinal bar chart or slices of a pie chart to filter and
	     * un-filter them. However turning on the brush filter will disable other interactive elements on
	     * the chart such as highlighting, tool tips, and reference lines. Zooming will still be possible
	     * if enabled, but only via scrolling (panning will be disabled.)
	     * @name brushOn
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [brushOn=true]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.brushOn = function (brushOn) {
	        if (!arguments.length) {
	            return _brushOn;
	        }
	        _brushOn = brushOn;
	        return _chart;
	    };
	
	    function hasRangeSelected (range) {
	        return range instanceof Array && range.length > 1;
	    }
	
	    return _chart;
	};
	
	/**
	 * Stack Mixin is an mixin that provides cross-chart support of stackability using d3.layout.stack.
	 * @name stackMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.stackMixin}
	 */
	dc.stackMixin = function (_chart) {
	
	    function prepareValues (layer, layerIdx) {
	        var valAccessor = layer.accessor || _chart.valueAccessor();
	        layer.name = String(layer.name || layerIdx);
	        layer.values = layer.group.all().map(function (d, i) {
	            return {
	                x: _chart.keyAccessor()(d, i),
	                y: layer.hidden ? null : valAccessor(d, i),
	                data: d,
	                layer: layer.name,
	                hidden: layer.hidden
	            };
	        });
	
	        layer.values = layer.values.filter(domainFilter());
	        return layer.values;
	    }
	
	    var _stackLayout = d3.layout.stack()
	        .values(prepareValues);
	
	    var _stack = [];
	    var _titles = {};
	
	    var _hidableStacks = false;
	
	    function domainFilter () {
	        if (!_chart.x()) {
	            return d3.functor(true);
	        }
	        var xDomain = _chart.x().domain();
	        if (_chart.isOrdinal()) {
	            // TODO #416
	            //var domainSet = d3.set(xDomain);
	            return function () {
	                return true; //domainSet.has(p.x);
	            };
	        }
	        if (_chart.elasticX()) {
	            return function () { return true; };
	        }
	        return function (p) {
	            //return true;
	            return p.x >= xDomain[0] && p.x <= xDomain[xDomain.length - 1];
	        };
	    }
	
	    /**
	     * Stack a new crossfilter group onto this chart with an optional custom value accessor. All stacks
	     * in the same chart will share the same key accessor and therefore the same set of keys.
	     *
	     * For example, in a stacked bar chart, the bars of each stack will be positioned using the same set
	     * of keys on the x axis, while stacked vertically. If name is specified then it will be used to
	     * generate the legend label.
	     * @name stack
	     * @memberof dc.stackMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce crossfilter.group}
	     * @example
	     * // stack group using default accessor
	     * chart.stack(valueSumGroup)
	     * // stack group using custom accessor
	     * .stack(avgByDayGroup, function(d){return d.value.avgByDay;});
	     * @param {crossfilter.group} group
	     * @param {String} [name]
	     * @param {Function} [accessor]
	     * @return {Array<{group: crossfilter.group, name: String, accessor: Function}>}
	     * @return {dc.stackMixin}
	     */
	    _chart.stack = function (group, name, accessor) {
	        if (!arguments.length) {
	            return _stack;
	        }
	
	        if (arguments.length <= 2) {
	            accessor = name;
	        }
	
	        var layer = {group: group};
	        if (typeof name === 'string') {
	            layer.name = name;
	        }
	        if (typeof accessor === 'function') {
	            layer.accessor = accessor;
	        }
	        _stack.push(layer);
	
	        return _chart;
	    };
	
	    dc.override(_chart, 'group', function (g, n, f) {
	        if (!arguments.length) {
	            return _chart._group();
	        }
	        _stack = [];
	        _titles = {};
	        _chart.stack(g, n);
	        if (f) {
	            _chart.valueAccessor(f);
	        }
	        return _chart._group(g, n);
	    });
	
	    /**
	     * Allow named stacks to be hidden or shown by clicking on legend items.
	     * This does not affect the behavior of hideStack or showStack.
	     * @name hidableStacks
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {Boolean} [hidableStacks=false]
	     * @return {Boolean}
	     * @return {dc.stackMixin}
	     */
	    _chart.hidableStacks = function (hidableStacks) {
	        if (!arguments.length) {
	            return _hidableStacks;
	        }
	        _hidableStacks = hidableStacks;
	        return _chart;
	    };
	
	    function findLayerByName (n) {
	        var i = _stack.map(dc.pluck('name')).indexOf(n);
	        return _stack[i];
	    }
	
	    /**
	     * Hide all stacks on the chart with the given name.
	     * The chart must be re-rendered for this change to appear.
	     * @name hideStack
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {String} stackName
	     * @return {dc.stackMixin}
	     */
	    _chart.hideStack = function (stackName) {
	        var layer = findLayerByName(stackName);
	        if (layer) {
	            layer.hidden = true;
	        }
	        return _chart;
	    };
	
	    /**
	     * Show all stacks on the chart with the given name.
	     * The chart must be re-rendered for this change to appear.
	     * @name showStack
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {String} stackName
	     * @return {dc.stackMixin}
	     */
	    _chart.showStack = function (stackName) {
	        var layer = findLayerByName(stackName);
	        if (layer) {
	            layer.hidden = false;
	        }
	        return _chart;
	    };
	
	    _chart.getValueAccessorByIndex = function (index) {
	        return _stack[index].accessor || _chart.valueAccessor();
	    };
	
	    _chart.yAxisMin = function () {
	        var min = d3.min(flattenStack(), function (p) {
	            return (p.y + p.y0 < p.y0) ? (p.y + p.y0) : p.y0;
	        });
	
	        return dc.utils.subtract(min, _chart.yAxisPadding());
	
	    };
	
	    _chart.yAxisMax = function () {
	        var max = d3.max(flattenStack(), function (p) {
	            return p.y + p.y0;
	        });
	
	        return dc.utils.add(max, _chart.yAxisPadding());
	    };
	
	    function flattenStack () {
	        var valueses = _chart.data().map(function (layer) { return layer.values; });
	        return Array.prototype.concat.apply([], valueses);
	    }
	
	    _chart.xAxisMin = function () {
	        var min = d3.min(flattenStack(), dc.pluck('x'));
	        return dc.utils.subtract(min, _chart.xAxisPadding());
	    };
	
	    _chart.xAxisMax = function () {
	        var max = d3.max(flattenStack(), dc.pluck('x'));
	        return dc.utils.add(max, _chart.xAxisPadding());
	    };
	
	    /**
	     * Set or get the title function. Chart class will use this function to render svg title (usually interpreted by
	     * browser as tooltips) for each child element in the chart, i.e. a slice in a pie chart or a bubble in a bubble chart.
	     * Almost every chart supports title function however in grid coordinate chart you need to turn off brush in order to
	     * use title otherwise the brush layer will block tooltip trigger.
	     *
	     * If the first argument is a stack name, the title function will get or set the title for that stack. If stackName
	     * is not provided, the first stack is implied.
	     * @name title
	     * @memberof dc.stackMixin
	     * @instance
	     * @example
	     * // set a title function on 'first stack'
	     * chart.title('first stack', function(d) { return d.key + ': ' + d.value; });
	     * // get a title function from 'second stack'
	     * var secondTitleFunction = chart.title('second stack');
	     * @param {String} [stackName]
	     * @param {Function} [titleAccessor]
	     * @return {String}
	     * @return {dc.stackMixin}
	     */
	    dc.override(_chart, 'title', function (stackName, titleAccessor) {
	        if (!stackName) {
	            return _chart._title();
	        }
	
	        if (typeof stackName === 'function') {
	            return _chart._title(stackName);
	        }
	        if (stackName === _chart._groupName && typeof titleAccessor === 'function') {
	            return _chart._title(titleAccessor);
	        }
	
	        if (typeof titleAccessor !== 'function') {
	            return _titles[stackName] || _chart._title();
	        }
	
	        _titles[stackName] = titleAccessor;
	
	        return _chart;
	    });
	
	    /**
	     * Gets or sets the stack layout algorithm, which computes a baseline for each stack and
	     * propagates it to the next
	     * @name stackLayout
	     * @memberof dc.stackMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Stack-Layout d3.layout.stack}
	     * @param {Function} [stack=d3.layout.stack]
	     * @return {Function}
	     * @return {dc.stackMixin}
	     */
	    _chart.stackLayout = function (stack) {
	        if (!arguments.length) {
	            return _stackLayout;
	        }
	        _stackLayout = stack;
	        return _chart;
	    };
	
	    function visability (l) {
	        return !l.hidden;
	    }
	
	    _chart.data(function () {
	        var layers = _stack.filter(visability);
	        return layers.length ? _chart.stackLayout()(layers) : [];
	    });
	
	    _chart._ordinalXDomain = function () {
	        var flat = flattenStack().map(dc.pluck('data'));
	        var ordered = _chart._computeOrderedGroups(flat);
	        return ordered.map(_chart.keyAccessor());
	    };
	
	    _chart.colorAccessor(function (d) {
	        var layer = this.layer || this.name || d.name || d.layer;
	        return layer;
	    });
	
	    _chart.legendables = function () {
	        return _stack.map(function (layer, i) {
	            return {
	                chart: _chart,
	                name: layer.name,
	                hidden: layer.hidden || false,
	                color: _chart.getColor.call(layer, layer.values, i)
	            };
	        });
	    };
	
	    _chart.isLegendableHidden = function (d) {
	        var layer = findLayerByName(d.name);
	        return layer ? layer.hidden : false;
	    };
	
	    _chart.legendToggle = function (d) {
	        if (_hidableStacks) {
	            if (_chart.isLegendableHidden(d)) {
	                _chart.showStack(d.name);
	            } else {
	                _chart.hideStack(d.name);
	            }
	            //_chart.redraw();
	            _chart.renderGroup();
	        }
	    };
	
	    return _chart;
	};
	
	/**
	 * Cap is a mixin that groups small data elements below a _cap_ into an *others* grouping for both the
	 * Row and Pie Charts.
	 *
	 * The top ordered elements in the group up to the cap amount will be kept in the chart, and the rest
	 * will be replaced with an *others* element, with value equal to the sum of the replaced values. The
	 * keys of the elements below the cap limit are recorded in order to filter by those keys when the
	 * others* element is clicked.
	 * @name capMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.capMixin}
	 */
	dc.capMixin = function (_chart) {
	
	    var _cap = Infinity;
	
	    var _othersLabel = 'Others';
	
	    var _othersGrouper = function (topRows) {
	        var topRowsSum = d3.sum(topRows, _chart.valueAccessor()),
	            allRows = _chart.group().all(),
	            allRowsSum = d3.sum(allRows, _chart.valueAccessor()),
	            topKeys = topRows.map(_chart.keyAccessor()),
	            allKeys = allRows.map(_chart.keyAccessor()),
	            topSet = d3.set(topKeys),
	            others = allKeys.filter(function (d) {return !topSet.has(d);});
	        if (allRowsSum > topRowsSum) {
	            return topRows.concat([{'others': others, 'key': _othersLabel, 'value': allRowsSum - topRowsSum}]);
	        }
	        return topRows;
	    };
	
	    _chart.cappedKeyAccessor = function (d, i) {
	        if (d.others) {
	            return d.key;
	        }
	        return _chart.keyAccessor()(d, i);
	    };
	
	    _chart.cappedValueAccessor = function (d, i) {
	        if (d.others) {
	            return d.value;
	        }
	        return _chart.valueAccessor()(d, i);
	    };
	
	    _chart.data(function (group) {
	        if (_cap === Infinity) {
	            return _chart._computeOrderedGroups(group.all());
	        } else {
	            var topRows = group.top(_cap); // ordered by crossfilter group order (default value)
	            topRows = _chart._computeOrderedGroups(topRows); // re-order using ordering (default key)
	            if (_othersGrouper) {
	                return _othersGrouper(topRows);
	            }
	            return topRows;
	        }
	    });
	
	    /**
	     * Get or set the count of elements to that will be included in the cap.
	     * @name cap
	     * @memberof dc.capMixin
	     * @instance
	     * @param {Number} [count=Infinity]
	     * @return {Number}
	     * @return {dc.capMixin}
	     */
	    _chart.cap = function (count) {
	        if (!arguments.length) {
	            return _cap;
	        }
	        _cap = count;
	        return _chart;
	    };
	
	    /**
	     * Get or set the label for *Others* slice when slices cap is specified
	     * @name othersLabel
	     * @memberof dc.capMixin
	     * @instance
	     * @param {String} [label="Others"]
	     * @return {String}
	     * @return {dc.capMixin}
	     */
	    _chart.othersLabel = function (label) {
	        if (!arguments.length) {
	            return _othersLabel;
	        }
	        _othersLabel = label;
	        return _chart;
	    };
	
	    /**
	     * Get or set the grouper function that will perform the insertion of data for the *Others* slice
	     * if the slices cap is specified. If set to a falsy value, no others will be added. By default the
	     * grouper function computes the sum of all values below the cap.
	     * @name othersGrouper
	     * @memberof dc.capMixin
	     * @instance
	     * @example
	     * // Default others grouper
	     * chart.othersGrouper(function (topRows) {
	     *    var topRowsSum = d3.sum(topRows, _chart.valueAccessor()),
	     *        allRows = _chart.group().all(),
	     *        allRowsSum = d3.sum(allRows, _chart.valueAccessor()),
	     *        topKeys = topRows.map(_chart.keyAccessor()),
	     *        allKeys = allRows.map(_chart.keyAccessor()),
	     *        topSet = d3.set(topKeys),
	     *        others = allKeys.filter(function (d) {return !topSet.has(d);});
	     *    if (allRowsSum > topRowsSum) {
	     *        return topRows.concat([{'others': others, 'key': _othersLabel, 'value': allRowsSum - topRowsSum}]);
	     *    }
	     *    return topRows;
	     * });
	     * // Custom others grouper
	     * chart.othersGrouper(function (data) {
	     *     // compute the value for others, presumably the sum of all values below the cap
	     *     var othersSum  = yourComputeOthersValueLogic(data)
	     *
	     *     // the keys are needed to properly filter when the others element is clicked
	     *     var othersKeys = yourComputeOthersKeysArrayLogic(data);
	     *
	     *     // add the others row to the dataset
	     *     data.push({'key': 'Others', 'value': othersSum, 'others': othersKeys });
	     *
	     *     return data;
	     * });
	     * @param {Function} [grouperFunction]
	     * @return {Function}
	     * @return {dc.capMixin}
	     */
	    _chart.othersGrouper = function (grouperFunction) {
	        if (!arguments.length) {
	            return _othersGrouper;
	        }
	        _othersGrouper = grouperFunction;
	        return _chart;
	    };
	
	    dc.override(_chart, 'onClick', function (d) {
	        if (d.others) {
	            _chart.filter([d.others]);
	        }
	        _chart._onClick(d);
	    });
	
	    return _chart;
	};
	
	/**
	 * This Mixin provides reusable functionalities for any chart that needs to visualize data using bubbles.
	 * @name bubbleMixin
	 * @memberof dc
	 * @mixin
	 * @mixes dc.colorMixin
	 * @param {Object} _chart
	 * @return {dc.bubbleMixin}
	 */
	dc.bubbleMixin = function (_chart) {
	    var _maxBubbleRelativeSize = 0.3;
	    var _minRadiusWithLabel = 10;
	
	    _chart.BUBBLE_NODE_CLASS = 'node';
	    _chart.BUBBLE_CLASS = 'bubble';
	    _chart.MIN_RADIUS = 10;
	
	    _chart = dc.colorMixin(_chart);
	
	    _chart.renderLabel(true);
	
	    _chart.data(function (group) {
	        return group.top(Infinity);
	    });
	
	    var _r = d3.scale.linear().domain([0, 100]);
	
	    var _rValueAccessor = function (d) {
	        return d.r;
	    };
	
	    /**
	     * Get or set the bubble radius scale. By default the bubble chart uses
	     * `d3.scale.linear().domain([0, 100])` as its radius scale.
	     * @name r
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @param {d3.scale} [bubbleRadiusScale=d3.scale.linear().domain([0, 100])]
	     * @return {d3.scale}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.r = function (bubbleRadiusScale) {
	        if (!arguments.length) {
	            return _r;
	        }
	        _r = bubbleRadiusScale;
	        return _chart;
	    };
	
	    /**
	     * Get or set the radius value accessor function. If set, the radius value accessor function will
	     * be used to retrieve a data value for each bubble. The data retrieved then will be mapped using
	     * the r scale to the actual bubble radius. This allows you to encode a data dimension using bubble
	     * size.
	     * @name radiusValueAccessor
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Function} [radiusValueAccessor]
	     * @return {Function}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.radiusValueAccessor = function (radiusValueAccessor) {
	        if (!arguments.length) {
	            return _rValueAccessor;
	        }
	        _rValueAccessor = radiusValueAccessor;
	        return _chart;
	    };
	
	    _chart.rMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.radiusValueAccessor()(e);
	        });
	        return min;
	    };
	
	    _chart.rMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.radiusValueAccessor()(e);
	        });
	        return max;
	    };
	
	    _chart.bubbleR = function (d) {
	        var value = _chart.radiusValueAccessor()(d);
	        var r = _chart.r()(value);
	        if (isNaN(r) || value <= 0) {
	            r = 0;
	        }
	        return r;
	    };
	
	    var labelFunction = function (d) {
	        return _chart.label()(d);
	    };
	
	    var labelOpacity = function (d) {
	        return (_chart.bubbleR(d) > _minRadiusWithLabel) ? 1 : 0;
	    };
	
	    _chart._doRenderLabel = function (bubbleGEnter) {
	        if (_chart.renderLabel()) {
	            var label = bubbleGEnter.select('text');
	
	            if (label.empty()) {
	                label = bubbleGEnter.append('text')
	                    .attr('text-anchor', 'middle')
	                    .attr('dy', '.3em')
	                    .on('click', _chart.onClick);
	            }
	
	            label
	                .attr('opacity', 0)
	                .text(labelFunction);
	            dc.transition(label, _chart.transitionDuration())
	                .attr('opacity', labelOpacity);
	        }
	    };
	
	    _chart.doUpdateLabels = function (bubbleGEnter) {
	        if (_chart.renderLabel()) {
	            var labels = bubbleGEnter.selectAll('text')
	                .text(labelFunction);
	            dc.transition(labels, _chart.transitionDuration())
	                .attr('opacity', labelOpacity);
	        }
	    };
	
	    var titleFunction = function (d) {
	        return _chart.title()(d);
	    };
	
	    _chart._doRenderTitles = function (g) {
	        if (_chart.renderTitle()) {
	            var title = g.select('title');
	
	            if (title.empty()) {
	                g.append('title').text(titleFunction);
	            }
	        }
	    };
	
	    _chart.doUpdateTitles = function (g) {
	        if (_chart.renderTitle()) {
	            g.selectAll('title').text(titleFunction);
	        }
	    };
	
	    /**
	     * Get or set the minimum radius. This will be used to initialize the radius scale's range.
	     * @name minRadius
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [radius=10]
	     * @return {Number}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.minRadius = function (radius) {
	        if (!arguments.length) {
	            return _chart.MIN_RADIUS;
	        }
	        _chart.MIN_RADIUS = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimum radius for label rendering. If a bubble's radius is less than this value
	     * then no label will be rendered.
	     * @name minRadiusWithLabel
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [radius=10]
	     * @return {Number}
	     * @return {dc.bubbleMixin}
	     */
	
	    _chart.minRadiusWithLabel = function (radius) {
	        if (!arguments.length) {
	            return _minRadiusWithLabel;
	        }
	        _minRadiusWithLabel = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the maximum relative size of a bubble to the length of x axis. This value is useful
	     * when the difference in radius between bubbles is too great.
	     * @name maxBubbleRelativeSize
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [relativeSize=0.3]
	     * @return {Number}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.maxBubbleRelativeSize = function (relativeSize) {
	        if (!arguments.length) {
	            return _maxBubbleRelativeSize;
	        }
	        _maxBubbleRelativeSize = relativeSize;
	        return _chart;
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.' + _chart.BUBBLE_NODE_CLASS).each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.' + _chart.BUBBLE_NODE_CLASS).each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    _chart.onClick = function (d) {
	        var filter = d.key;
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    return _chart;
	};
	
	/**
	 * The pie chart implementation is usually used to visualize a small categorical distribution.  The pie
	 * chart uses keyAccessor to determine the slices, and valueAccessor to calculate the size of each
	 * slice relative to the sum of all values. Slices are ordered by `.ordering` which defaults to sorting
	 * by key.
	 * @name pieChart
	 * @memberof dc
	 * @mixes dc.capMixin
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a pie chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.pieChart('#chart-container1');
	 * // create a pie chart under #chart-container2 element using chart group A
	 * var chart2 = dc.pieChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {PieChart}
	 */
	dc.pieChart = function (parent, chartGroup) {
	    var DEFAULT_MIN_ANGLE_FOR_LABEL = 0.5;
	
	    var _sliceCssClass = 'pie-slice';
	    var _emptyCssClass = 'empty-chart';
	    var _emptyTitle = 'empty';
	
	    var _radius,
	        _givenRadius, // specified radius, if any
	        _innerRadius = 0,
	        _externalRadiusPadding = 0;
	
	    var _g;
	    var _cx;
	    var _cy;
	    var _minAngleForLabel = DEFAULT_MIN_ANGLE_FOR_LABEL;
	    var _externalLabelRadius;
	    var _chart = dc.capMixin(dc.colorMixin(dc.baseMixin({})));
	
	    _chart.colorAccessor(_chart.cappedKeyAccessor);
	
	    _chart.title(function (d) {
	        return _chart.cappedKeyAccessor(d) + ': ' + _chart.cappedValueAccessor(d);
	    });
	
	    /**
	     * Get or set the maximum number of slices the pie chart will generate. The top slices are determined by
	     * value from high to low. Other slices exeeding the cap will be rolled up into one single *Others* slice.
	     * @name slicesCap
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cap]
	     * @returns {Chart}
	     */
	    _chart.slicesCap = _chart.cap;
	
	    _chart.label(_chart.cappedKeyAccessor);
	    _chart.renderLabel(true);
	
	    _chart.transitionDuration(350);
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _g = _chart.svg()
	            .append('g')
	            .attr('transform', 'translate(' + _chart.cx() + ',' + _chart.cy() + ')');
	
	        drawChart();
	
	        return _chart;
	    };
	
	    function drawChart () {
	        // set radius on basis of chart dimension if missing
	        _radius = _givenRadius ? _givenRadius : d3.min([_chart.width(), _chart.height()]) / 2;
	
	        var arc = buildArcs();
	
	        var pie = pieLayout();
	        var pieData;
	        // if we have data...
	        if (d3.sum(_chart.data(), _chart.valueAccessor())) {
	            pieData = pie(_chart.data());
	            _g.classed(_emptyCssClass, false);
	        } else {
	            // otherwise we'd be getting NaNs, so override
	            // note: abuse others for its ignoring the value accessor
	            pieData = pie([{key: _emptyTitle, value: 1, others: [_emptyTitle]}]);
	            _g.classed(_emptyCssClass, true);
	        }
	
	        if (_g) {
	            var slices = _g.selectAll('g.' + _sliceCssClass)
	                .data(pieData);
	
	            createElements(slices, arc, pieData);
	
	            updateElements(pieData, arc);
	
	            removeElements(slices);
	
	            highlightFilter();
	
	            dc.transition(_g, _chart.transitionDuration())
	                .attr('transform', 'translate(' + _chart.cx() + ',' + _chart.cy() + ')');
	        }
	    }
	
	    function createElements (slices, arc, pieData) {
	        var slicesEnter = createSliceNodes(slices);
	
	        createSlicePath(slicesEnter, arc);
	
	        createTitles(slicesEnter);
	
	        createLabels(pieData, arc);
	    }
	
	    function createSliceNodes (slices) {
	        var slicesEnter = slices
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return _sliceCssClass + ' _' + i;
	            });
	        return slicesEnter;
	    }
	
	    function createSlicePath (slicesEnter, arc) {
	        var slicePath = slicesEnter.append('path')
	            .attr('fill', fill)
	            .on('click', onClick)
	            .attr('d', function (d, i) {
	                return safeArc(d, i, arc);
	            });
	
	        dc.transition(slicePath, _chart.transitionDuration(), function (s) {
	            s.attrTween('d', tweenPie);
	        });
	    }
	
	    function createTitles (slicesEnter) {
	        if (_chart.renderTitle()) {
	            slicesEnter.append('title').text(function (d) {
	                return _chart.title()(d.data);
	            });
	        }
	    }
	
	    function positionLabels (labelsEnter, arc) {
	        dc.transition(labelsEnter, _chart.transitionDuration())
	            .attr('transform', function (d) {
	                return labelPosition(d, arc);
	            })
	            .attr('text-anchor', 'middle')
	            .text(function (d) {
	                var data = d.data;
	                if ((sliceHasNoData(data) || sliceTooSmall(d)) && !isSelectedSlice(d)) {
	                    return '';
	                }
	                return _chart.label()(d.data);
	            });
	    }
	
	    function createLabels (pieData, arc) {
	        if (_chart.renderLabel()) {
	            var labels = _g.selectAll('text.' + _sliceCssClass)
	                .data(pieData);
	
	            labels.exit().remove();
	
	            var labelsEnter = labels
	                .enter()
	                .append('text')
	                .attr('class', function (d, i) {
	                    var classes = _sliceCssClass + ' _' + i;
	                    if (_externalLabelRadius) {
	                        classes += ' external';
	                    }
	                    return classes;
	                })
	                .on('click', onClick);
	            positionLabels(labelsEnter, arc);
	        }
	    }
	
	    function updateElements (pieData, arc) {
	        updateSlicePaths(pieData, arc);
	        updateLabels(pieData, arc);
	        updateTitles(pieData);
	    }
	
	    function updateSlicePaths (pieData, arc) {
	        var slicePaths = _g.selectAll('g.' + _sliceCssClass)
	            .data(pieData)
	            .select('path')
	            .attr('d', function (d, i) {
	                return safeArc(d, i, arc);
	            });
	        dc.transition(slicePaths, _chart.transitionDuration(),
	            function (s) {
	                s.attrTween('d', tweenPie);
	            }).attr('fill', fill);
	    }
	
	    function updateLabels (pieData, arc) {
	        if (_chart.renderLabel()) {
	            var labels = _g.selectAll('text.' + _sliceCssClass)
	                .data(pieData);
	            positionLabels(labels, arc);
	        }
	    }
	
	    function updateTitles (pieData) {
	        if (_chart.renderTitle()) {
	            _g.selectAll('g.' + _sliceCssClass)
	                .data(pieData)
	                .select('title')
	                .text(function (d) {
	                    return _chart.title()(d.data);
	                });
	        }
	    }
	
	    function removeElements (slices) {
	        slices.exit().remove();
	    }
	
	    function highlightFilter () {
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.' + _sliceCssClass).each(function (d) {
	                if (isSelectedSlice(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.' + _sliceCssClass).each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    }
	
	    /**
	     * Get or set the external radius padding of the pie chart. This will force the radius of the
	     * pie chart to become smaller or larger depending on the value.
	     * @name externalRadiusPadding
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [externalRadiusPadding=0]
	     * @returns {Chart}
	     */
	    _chart.externalRadiusPadding = function (externalRadiusPadding) {
	        if (!arguments.length) {
	            return _externalRadiusPadding;
	        }
	        _externalRadiusPadding = externalRadiusPadding;
	        return _chart;
	    };
	
	    /**
	     * Get or set the inner radius of the pie chart. If the inner radius is greater than 0px then the
	     * pie chart will be rendered as a doughnut chart.
	     * @name innerRadius
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [innerRadius=0]
	     * @returns {Chart}
	     */
	    _chart.innerRadius = function (innerRadius) {
	        if (!arguments.length) {
	            return _innerRadius;
	        }
	        _innerRadius = innerRadius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the outer radius. If the radius is not set, it will be half of the minimum of the
	     * chart width and height.
	     * @name radius
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [radius]
	     * @returns {Chart}
	     */
	    _chart.radius = function (radius) {
	        if (!arguments.length) {
	            return _givenRadius;
	        }
	        _givenRadius = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set center x coordinate position. Default is center of svg.
	     * @name cx
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cx]
	     * @returns {Chart}
	     */
	    _chart.cx = function (cx) {
	        if (!arguments.length) {
	            return (_cx ||  _chart.width() / 2);
	        }
	        _cx = cx;
	        return _chart;
	    };
	
	    /**
	     * Get or set center y coordinate position. Default is center of svg.
	     * @name cy
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cy]
	     * @returns {Chart}
	     */
	    _chart.cy = function (cy) {
	        if (!arguments.length) {
	            return (_cy ||  _chart.height() / 2);
	        }
	        _cy = cy;
	        return _chart;
	    };
	
	    function buildArcs () {
	        return d3.svg.arc().outerRadius(_radius - _externalRadiusPadding).innerRadius(_innerRadius);
	    }
	
	    function isSelectedSlice (d) {
	        return _chart.hasFilter(_chart.cappedKeyAccessor(d.data));
	    }
	
	    _chart._doRedraw = function () {
	        drawChart();
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimal slice angle for label rendering. Any slice with a smaller angle will not
	     * display a slice label.
	     * @name minAngleForLabel
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [minAngleForLabel=0.5]
	     * @returns {Chart}
	     */
	    _chart.minAngleForLabel = function (minAngleForLabel) {
	        if (!arguments.length) {
	            return _minAngleForLabel;
	        }
	        _minAngleForLabel = minAngleForLabel;
	        return _chart;
	    };
	
	    function pieLayout () {
	        return d3.layout.pie().sort(null).value(_chart.cappedValueAccessor);
	    }
	
	    function sliceTooSmall (d) {
	        var angle = (d.endAngle - d.startAngle);
	        return isNaN(angle) || angle < _minAngleForLabel;
	    }
	
	    function sliceHasNoData (d) {
	        return _chart.cappedValueAccessor(d) === 0;
	    }
	
	    function tweenPie (b) {
	        b.innerRadius = _innerRadius;
	        var current = this._current;
	        if (isOffCanvas(current)) {
	            current = {startAngle: 0, endAngle: 0};
	        }
	        var i = d3.interpolate(current, b);
	        this._current = i(0);
	        return function (t) {
	            return safeArc(i(t), 0, buildArcs());
	        };
	    }
	
	    function isOffCanvas (current) {
	        return !current || isNaN(current.startAngle) || isNaN(current.endAngle);
	    }
	
	    function fill (d, i) {
	        return _chart.getColor(d.data, i);
	    }
	
	    function onClick (d, i) {
	        if (_g.attr('class') !== _emptyCssClass) {
	            _chart.onClick(d.data, i);
	        }
	    }
	
	    function safeArc (d, i, arc) {
	        var path = arc(d, i);
	        if (path.indexOf('NaN') >= 0) {
	            path = 'M0,0';
	        }
	        return path;
	    }
	
	    /**
	     * Title to use for the only slice when there is no data.
	     * @name emptyTitle
	     * @memberof dc.pieChart
	     * @instance
	     * @param {String} [title]
	     * @returns {Chart}
	     */
	    _chart.emptyTitle = function (title) {
	        if (arguments.length === 0) {
	            return _emptyTitle;
	        }
	        _emptyTitle = title;
	        return _chart;
	    };
	
	    /**
	     * Position slice labels offset from the outer edge of the chart
	     *
	     * The given argument sets the radial offset.
	     * @name externalLabels
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [radius]
	     * @returns {Chart}
	     */
	    _chart.externalLabels = function (radius) {
	        if (arguments.length === 0) {
	            return _externalLabelRadius;
	        } else if (radius) {
	            _externalLabelRadius = radius;
	        } else {
	            _externalLabelRadius = undefined;
	        }
	
	        return _chart;
	    };
	
	    function labelPosition (d, arc) {
	        var centroid;
	        if (_externalLabelRadius) {
	            centroid = d3.svg.arc()
	                .outerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .innerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .centroid(d);
	        } else {
	            centroid = arc.centroid(d);
	        }
	        if (isNaN(centroid[0]) || isNaN(centroid[1])) {
	            return 'translate(0,0)';
	        } else {
	            return 'translate(' + centroid + ')';
	        }
	    }
	
	    _chart.legendables = function () {
	        return _chart.data().map(function (d, i) {
	            var legendable = {name: d.key, data: d.value, others: d.others, chart: _chart};
	            legendable.color = _chart.getColor(d, i);
	            return legendable;
	        });
	    };
	
	    _chart.legendHighlight = function (d) {
	        highlightSliceFromLegendable(d, true);
	    };
	
	    _chart.legendReset = function (d) {
	        highlightSliceFromLegendable(d, false);
	    };
	
	    _chart.legendToggle = function (d) {
	        _chart.onClick({key: d.name, others: d.others});
	    };
	
	    function highlightSliceFromLegendable (legendable, highlighted) {
	        _chart.selectAll('g.pie-slice').each(function (d) {
	            if (legendable.name === d.data.key) {
	                d3.select(this).classed('highlight', highlighted);
	            }
	        });
	    }
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Concrete bar chart/histogram implementation.
	 *
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * - [Canadian City Crime Stats](http://dc-js.github.com/dc.js/crime/index.html)
	 * @name barChart
	 * @memberof dc
	 * @mixes dc.stackMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a bar chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.barChart('#chart-container1');
	 * // create a bar chart under #chart-container2 element using chart group A
	 * var chart2 = dc.barChart('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.barChart(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.barChart}
	 */
	dc.barChart = function (parent, chartGroup) {
	    var MIN_BAR_WIDTH = 1;
	    var DEFAULT_GAP_BETWEEN_BARS = 2;
	
	    var _chart = dc.stackMixin(dc.coordinateGridMixin({}));
	
	    var _gap = DEFAULT_GAP_BETWEEN_BARS;
	    var _centerBar = false;
	    var _alwaysUseRounding = false;
	
	    var _barWidth;
	
	    dc.override(_chart, 'rescale', function () {
	        _chart._rescale();
	        _barWidth = undefined;
	        return _chart;
	    });
	
	    dc.override(_chart, 'render', function () {
	        if (_chart.round() && _centerBar && !_alwaysUseRounding) {
	            dc.logger.warn('By default, brush rounding is disabled if bars are centered. ' +
	                         'See dc.js bar chart API documentation for details.');
	        }
	
	        return _chart._render();
	    });
	
	    _chart.plotData = function () {
	        var layers = _chart.chartBodyG().selectAll('g.stack')
	            .data(_chart.data());
	
	        calculateBarWidth();
	
	        layers
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return 'stack ' + '_' + i;
	            });
	
	        layers.each(function (d, i) {
	            var layer = d3.select(this);
	
	            renderBars(layer, i, d);
	        });
	    };
	
	    function barHeight (d) {
	        return dc.utils.safeNumber(Math.abs(_chart.y()(d.y + d.y0) - _chart.y()(d.y0)));
	    }
	
	    function renderBars (layer, layerIndex, d) {
	        var bars = layer.selectAll('rect.bar')
	            .data(d.values, dc.pluck('x'));
	
	        var enter = bars.enter()
	            .append('rect')
	            .attr('class', 'bar')
	            .attr('fill', dc.pluck('data', _chart.getColor))
	            .attr('y', _chart.yAxisHeight())
	            .attr('height', 0);
	
	        if (_chart.renderTitle()) {
	            enter.append('title').text(dc.pluck('data', _chart.title(d.name)));
	        }
	
	        if (_chart.isOrdinal()) {
	            bars.on('click', _chart.onClick);
	        }
	
	        dc.transition(bars, _chart.transitionDuration())
	            .attr('x', function (d) {
	                var x = _chart.x()(d.x);
	                if (_centerBar) {
	                    x -= _barWidth / 2;
	                }
	                if (_chart.isOrdinal() && _gap !== undefined) {
	                    x += _gap / 2;
	                }
	                return dc.utils.safeNumber(x);
	            })
	            .attr('y', function (d) {
	                var y = _chart.y()(d.y + d.y0);
	
	                if (d.y < 0) {
	                    y -= barHeight(d);
	                }
	
	                return dc.utils.safeNumber(y);
	            })
	            .attr('width', _barWidth)
	            .attr('height', function (d) {
	                return barHeight(d);
	            })
	            .attr('fill', dc.pluck('data', _chart.getColor))
	            .select('title').text(dc.pluck('data', _chart.title(d.name)));
	
	        dc.transition(bars.exit(), _chart.transitionDuration())
	            .attr('height', 0)
	            .remove();
	    }
	
	    function calculateBarWidth () {
	        if (_barWidth === undefined) {
	            var numberOfBars = _chart.xUnitCount();
	
	            // please can't we always use rangeBands for bar charts?
	            if (_chart.isOrdinal() && _gap === undefined) {
	                _barWidth = Math.floor(_chart.x().rangeBand());
	            } else if (_gap) {
	                _barWidth = Math.floor((_chart.xAxisLength() - (numberOfBars - 1) * _gap) / numberOfBars);
	            } else {
	                _barWidth = Math.floor(_chart.xAxisLength() / (1 + _chart.barPadding()) / numberOfBars);
	            }
	
	            if (_barWidth === Infinity || isNaN(_barWidth) || _barWidth < MIN_BAR_WIDTH) {
	                _barWidth = MIN_BAR_WIDTH;
	            }
	        }
	    }
	
	    _chart.fadeDeselectedArea = function () {
	        var bars = _chart.chartBodyG().selectAll('rect.bar');
	        var extent = _chart.brush().extent();
	
	        if (_chart.isOrdinal()) {
	            if (_chart.hasFilter()) {
	                bars.classed(dc.constants.SELECTED_CLASS, function (d) {
	                    return _chart.hasFilter(d.x);
	                });
	                bars.classed(dc.constants.DESELECTED_CLASS, function (d) {
	                    return !_chart.hasFilter(d.x);
	                });
	            } else {
	                bars.classed(dc.constants.SELECTED_CLASS, false);
	                bars.classed(dc.constants.DESELECTED_CLASS, false);
	            }
	        } else {
	            if (!_chart.brushIsEmpty(extent)) {
	                var start = extent[0];
	                var end = extent[1];
	
	                bars.classed(dc.constants.DESELECTED_CLASS, function (d) {
	                    return d.x < start || d.x >= end;
	                });
	            } else {
	                bars.classed(dc.constants.DESELECTED_CLASS, false);
	            }
	        }
	    };
	
	    /**
	     * Whether the bar chart will render each bar centered around the data position on the x-axis.
	     * @name centerBar
	     * @memberof dc.barChart
	     * @instance
	     * @param {Boolean} [centerBar=false]
	     * @return {Boolean}
	     * @return {dc.barChart}
	     */
	    _chart.centerBar = function (centerBar) {
	        if (!arguments.length) {
	            return _centerBar;
	        }
	        _centerBar = centerBar;
	        return _chart;
	    };
	
	    dc.override(_chart, 'onClick', function (d) {
	        _chart._onClick(d.data);
	    });
	
	    /**
	     * Get or set the spacing between bars as a fraction of bar size. Valid values are between 0-1.
	     * Setting this value will also remove any previously set `gap`. See the
	     * [d3 docs](https://github.com/mbostock/d3/wiki/Ordinal-Scales#wiki-ordinal_rangeBands)
	     * for a visual description of how the padding is applied.
	     * @name barPadding
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [barPadding=0]
	     * @return {Number}
	     * @return {dc.barChart}
	     */
	    _chart.barPadding = function (barPadding) {
	        if (!arguments.length) {
	            return _chart._rangeBandPadding();
	        }
	        _chart._rangeBandPadding(barPadding);
	        _gap = undefined;
	        return _chart;
	    };
	
	    _chart._useOuterPadding = function () {
	        return _gap === undefined;
	    };
	
	    /**
	     * Get or set the outer padding on an ordinal bar chart. This setting has no effect on non-ordinal charts.
	     * Will pad the width by `padding * barWidth` on each side of the chart.
	     * @name outerPadding
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [padding=0.5]
	     * @return {Number}
	     * @return {dc.barChart}
	     */
	    _chart.outerPadding = _chart._outerRangeBandPadding;
	
	    /**
	     * Manually set fixed gap (in px) between bars instead of relying on the default auto-generated
	     * gap.  By default the bar chart implementation will calculate and set the gap automatically
	     * based on the number of data points and the length of the x axis.
	     * @name gap
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [gap=2]
	     * @return {Number}
	     * @return {dc.barChart}
	     */
	    _chart.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _chart;
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _chart.brush().extent();
	        if (_chart.round() && (!_centerBar || _alwaysUseRounding)) {
	            extent[0] = extent.map(_chart.round())[0];
	            extent[1] = extent.map(_chart.round())[1];
	
	            _chart.chartBodyG().select('.brush')
	                .call(_chart.brush().extent(extent));
	        }
	
	        return extent;
	    };
	
	    /**
	     * Set or get whether rounding is enabled when bars are centered. If false, using
	     * rounding with centered bars will result in a warning and rounding will be ignored.  This flag
	     * has no effect if bars are not {@link #dc.barChart+centerBar centered}.
	     * When using standard d3.js rounding methods, the brush often doesn't align correctly with
	     * centered bars since the bars are offset.  The rounding function must add an offset to
	     * compensate, such as in the following example.
	     * @name alwaysUseRounding
	     * @memberof dc.barChart
	     * @instance
	     * @example
	     * chart.round(function(n) { return Math.floor(n) + 0.5; });
	     * @param {Boolean} [alwaysUseRounding=false]
	     * @return {Boolean}
	     * @return {dc.barChart}
	     */
	    _chart.alwaysUseRounding = function (alwaysUseRounding) {
	        if (!arguments.length) {
	            return _alwaysUseRounding;
	        }
	        _alwaysUseRounding = alwaysUseRounding;
	        return _chart;
	    };
	
	    function colorFilter (color, inv) {
	        return function () {
	            var item = d3.select(this);
	            var match = item.attr('fill') === color;
	            return inv ? !match : match;
	        };
	    }
	
	    _chart.legendHighlight = function (d) {
	        if (!_chart.isLegendableHidden(d)) {
	            _chart.g().selectAll('rect.bar')
	                .classed('highlight', colorFilter(d.color))
	                .classed('fadeout', colorFilter(d.color, true));
	        }
	    };
	
	    _chart.legendReset = function () {
	        _chart.g().selectAll('rect.bar')
	            .classed('highlight', false)
	            .classed('fadeout', false);
	    };
	
	    dc.override(_chart, 'xAxisMax', function () {
	        var max = this._xAxisMax();
	        if ('resolution' in _chart.xUnits()) {
	            var res = _chart.xUnits().resolution;
	            max += res;
	        }
	        return max;
	    });
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Concrete line/area chart implementation.
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * - [Canadian City Crime Stats](http://dc-js.github.com/dc.js/crime/index.html)
	 * @name lineChart
	 * @memberof dc
	 * @mixes dc.stackMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a line chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.lineChart('#chart-container1');
	 * // create a line chart under #chart-container2 element using chart group A
	 * var chart2 = dc.lineChart('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.lineChart(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {LineChart}
	 */
	dc.lineChart = function (parent, chartGroup) {
	    var DEFAULT_DOT_RADIUS = 5;
	    var TOOLTIP_G_CLASS = 'dc-tooltip';
	    var DOT_CIRCLE_CLASS = 'dot';
	    var Y_AXIS_REF_LINE_CLASS = 'yRef';
	    var X_AXIS_REF_LINE_CLASS = 'xRef';
	    var DEFAULT_DOT_OPACITY = 1e-6;
	
	    var _chart = dc.stackMixin(dc.coordinateGridMixin({}));
	    var _renderArea = false;
	    var _dotRadius = DEFAULT_DOT_RADIUS;
	    var _dataPointRadius = null;
	    var _dataPointFillOpacity = DEFAULT_DOT_OPACITY;
	    var _dataPointStrokeOpacity = DEFAULT_DOT_OPACITY;
	    var _interpolate = 'linear';
	    var _tension = 0.7;
	    var _defined;
	    var _dashStyle;
	    var _xyTipsOn = true;
	
	    _chart.transitionDuration(500);
	    _chart._rangeBandPadding(1);
	
	    _chart.plotData = function () {
	        var chartBody = _chart.chartBodyG();
	        var layersList = chartBody.selectAll('g.stack-list');
	
	        if (layersList.empty()) {
	            layersList = chartBody.append('g').attr('class', 'stack-list');
	        }
	
	        var layers = layersList.selectAll('g.stack').data(_chart.data());
	
	        var layersEnter = layers
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return 'stack ' + '_' + i;
	            });
	
	        drawLine(layersEnter, layers);
	
	        drawArea(layersEnter, layers);
	
	        drawDots(chartBody, layers);
	    };
	
	    /**
	     * Gets or sets the interpolator to use for lines drawn, by string name, allowing e.g. step
	     * functions, splines, and cubic interpolation.  This is passed to
	     * [d3.svg.line.interpolate](https://github.com/mbostock/d3/wiki/SVG-Shapes#line_interpolate) and
	     * [d3.svg.area.interpolate](https://github.com/mbostock/d3/wiki/SVG-Shapes#area_interpolate),
	     * where you can find a complete list of valid arguments
	     * @name interpolate
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {String} [interpolate='linear']
	     * @returns {Chart}
	     */
	    _chart.interpolate = function (interpolate) {
	        if (!arguments.length) {
	            return _interpolate;
	        }
	        _interpolate = interpolate;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the tension to use for lines drawn, in the range 0 to 1.
	     * This parameter further customizes the interpolation behavior.  It is passed to
	     * [d3.svg.line.tension](https://github.com/mbostock/d3/wiki/SVG-Shapes#line_tension) and
	     * [d3.svg.area.tension](https://github.com/mbostock/d3/wiki/SVG-Shapes#area_tension).
	     * @name tension
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Number} [tension=0.7]
	     * @returns {Chart}
	     */
	    _chart.tension = function (tension) {
	        if (!arguments.length) {
	            return _tension;
	        }
	        _tension = tension;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets a function that will determine discontinuities in the line which should be
	     * skipped: the path will be broken into separate subpaths if some points are undefined.
	     * This function is passed to
	     * [d3.svg.line.defined](https://github.com/mbostock/d3/wiki/SVG-Shapes#line_defined)
	     *
	     * Note: crossfilter will sometimes coerce nulls to 0, so you may need to carefully write
	     * custom reduce functions to get this to work, depending on your data. See
	     * https://github.com/dc-js/dc.js/issues/615#issuecomment-49089248
	     * @name defined
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Function} [defined]
	     * @returns {Chart}
	     */
	    _chart.defined = function (defined) {
	        if (!arguments.length) {
	            return _defined;
	        }
	        _defined = defined;
	        return _chart;
	    };
	
	    /**
	     * Set the line's d3 dashstyle. This value becomes the 'stroke-dasharray' of line. Defaults to empty
	     * array (solid line).
	     * @name dashStyle
	     * @memberof dc.lineChart
	     * @instance
	     * @example
	     * // create a Dash Dot Dot Dot
	     * chart.dashStyle([3,1,1,1]);
	     * @param  {Array<Number>} [dashStyle=[]]
	     * @returns {Chart}
	     */
	    _chart.dashStyle = function (dashStyle) {
	        if (!arguments.length) {
	            return _dashStyle;
	        }
	        _dashStyle = dashStyle;
	        return _chart;
	    };
	
	    /**
	     * Get or set render area flag. If the flag is set to true then the chart will render the area
	     * beneath each line and the line chart effectively becomes an area chart.
	     * @name renderArea
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Boolean} [renderArea=false]
	     * @returns {Chart}
	     */
	    _chart.renderArea = function (renderArea) {
	        if (!arguments.length) {
	            return _renderArea;
	        }
	        _renderArea = renderArea;
	        return _chart;
	    };
	
	    function colors (d, i) {
	        return _chart.getColor.call(d, d.values, i);
	    }
	
	    function drawLine (layersEnter, layers) {
	        var line = d3.svg.line()
	            .x(function (d) {
	                return _chart.x()(d.x);
	            })
	            .y(function (d) {
	                return _chart.y()(d.y + d.y0);
	            })
	            .interpolate(_interpolate)
	            .tension(_tension);
	        if (_defined) {
	            line.defined(_defined);
	        }
	
	        var path = layersEnter.append('path')
	            .attr('class', 'line')
	            .attr('stroke', colors);
	        if (_dashStyle) {
	            path.attr('stroke-dasharray', _dashStyle);
	        }
	
	        dc.transition(layers.select('path.line'), _chart.transitionDuration())
	            //.ease('linear')
	            .attr('stroke', colors)
	            .attr('d', function (d) {
	                return safeD(line(d.values));
	            });
	    }
	
	    function drawArea (layersEnter, layers) {
	        if (_renderArea) {
	            var area = d3.svg.area()
	                .x(function (d) {
	                    return _chart.x()(d.x);
	                })
	                .y(function (d) {
	                    return _chart.y()(d.y + d.y0);
	                })
	                .y0(function (d) {
	                    return _chart.y()(d.y0);
	                })
	                .interpolate(_interpolate)
	                .tension(_tension);
	            if (_defined) {
	                area.defined(_defined);
	            }
	
	            layersEnter.append('path')
	                .attr('class', 'area')
	                .attr('fill', colors)
	                .attr('d', function (d) {
	                    return safeD(area(d.values));
	                });
	
	            dc.transition(layers.select('path.area'), _chart.transitionDuration())
	                //.ease('linear')
	                .attr('fill', colors)
	                .attr('d', function (d) {
	                    return safeD(area(d.values));
	                });
	        }
	    }
	
	    function safeD (d) {
	        return (!d || d.indexOf('NaN') >= 0) ? 'M0,0' : d;
	    }
	
	    function drawDots (chartBody, layers) {
	        if (!_chart.brushOn() && _chart.xyTipsOn()) {
	            var tooltipListClass = TOOLTIP_G_CLASS + '-list';
	            var tooltips = chartBody.select('g.' + tooltipListClass);
	
	            if (tooltips.empty()) {
	                tooltips = chartBody.append('g').attr('class', tooltipListClass);
	            }
	
	            layers.each(function (d, layerIndex) {
	                var points = d.values;
	                if (_defined) {
	                    points = points.filter(_defined);
	                }
	
	                var g = tooltips.select('g.' + TOOLTIP_G_CLASS + '._' + layerIndex);
	                if (g.empty()) {
	                    g = tooltips.append('g').attr('class', TOOLTIP_G_CLASS + ' _' + layerIndex);
	                }
	
	                createRefLines(g);
	
	                var dots = g.selectAll('circle.' + DOT_CIRCLE_CLASS)
	                    .data(points, dc.pluck('x'));
	
	                dots.enter()
	                    .append('circle')
	                    .attr('class', DOT_CIRCLE_CLASS)
	                    .attr('r', getDotRadius())
	                    .style('fill-opacity', _dataPointFillOpacity)
	                    .style('stroke-opacity', _dataPointStrokeOpacity)
	                    .on('mousemove', function () {
	                        var dot = d3.select(this);
	                        showDot(dot);
	                        showRefLines(dot, g);
	                    })
	                    .on('mouseout', function () {
	                        var dot = d3.select(this);
	                        hideDot(dot);
	                        hideRefLines(g);
	                    });
	
	                dots
	                    .attr('cx', function (d) {
	                        return dc.utils.safeNumber(_chart.x()(d.x));
	                    })
	                    .attr('cy', function (d) {
	                        return dc.utils.safeNumber(_chart.y()(d.y + d.y0));
	                    })
	                    .attr('fill', _chart.getColor)
	                    .call(renderTitle, d);
	
	                dots.exit().remove();
	            });
	        }
	    }
	
	    function createRefLines (g) {
	        var yRefLine = g.select('path.' + Y_AXIS_REF_LINE_CLASS).empty() ?
	            g.append('path').attr('class', Y_AXIS_REF_LINE_CLASS) : g.select('path.' + Y_AXIS_REF_LINE_CLASS);
	        yRefLine.style('display', 'none').attr('stroke-dasharray', '5,5');
	
	        var xRefLine = g.select('path.' + X_AXIS_REF_LINE_CLASS).empty() ?
	            g.append('path').attr('class', X_AXIS_REF_LINE_CLASS) : g.select('path.' + X_AXIS_REF_LINE_CLASS);
	        xRefLine.style('display', 'none').attr('stroke-dasharray', '5,5');
	    }
	
	    function showDot (dot) {
	        dot.style('fill-opacity', 0.8);
	        dot.style('stroke-opacity', 0.8);
	        dot.attr('r', _dotRadius);
	        return dot;
	    }
	
	    function showRefLines (dot, g) {
	        var x = dot.attr('cx');
	        var y = dot.attr('cy');
	        var yAxisX = (_chart._yAxisX() - _chart.margins().left);
	        var yAxisRefPathD = 'M' + yAxisX + ' ' + y + 'L' + (x) + ' ' + (y);
	        var xAxisRefPathD = 'M' + x + ' ' + _chart.yAxisHeight() + 'L' + x + ' ' + y;
	        g.select('path.' + Y_AXIS_REF_LINE_CLASS).style('display', '').attr('d', yAxisRefPathD);
	        g.select('path.' + X_AXIS_REF_LINE_CLASS).style('display', '').attr('d', xAxisRefPathD);
	    }
	
	    function getDotRadius () {
	        return _dataPointRadius || _dotRadius;
	    }
	
	    function hideDot (dot) {
	        dot.style('fill-opacity', _dataPointFillOpacity)
	            .style('stroke-opacity', _dataPointStrokeOpacity)
	            .attr('r', getDotRadius());
	    }
	
	    function hideRefLines (g) {
	        g.select('path.' + Y_AXIS_REF_LINE_CLASS).style('display', 'none');
	        g.select('path.' + X_AXIS_REF_LINE_CLASS).style('display', 'none');
	    }
	
	    function renderTitle (dot, d) {
	        if (_chart.renderTitle()) {
	            dot.selectAll('title').remove();
	            dot.append('title').text(dc.pluck('data', _chart.title(d.name)));
	        }
	    }
	
	    /**
	     * Turn on/off the mouseover behavior of an individual data point which renders a circle and x/y axis
	     * dashed lines back to each respective axis.  This is ignored if the chart brush is on (`brushOn`)
	     * @name xyTipsOn
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Boolean} [xyTipsOn=false]
	     * @returns {Chart}
	     */
	    _chart.xyTipsOn = function (xyTipsOn) {
	        if (!arguments.length) {
	            return _xyTipsOn;
	        }
	        _xyTipsOn = xyTipsOn;
	        return _chart;
	    };
	
	    /**
	     * Get or set the radius (in px) for dots displayed on the data points.
	     * @name dotRadius
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Number} [dotRadius=5]
	     * @returns {Chart}
	     */
	    _chart.dotRadius = function (dotRadius) {
	        if (!arguments.length) {
	            return _dotRadius;
	        }
	        _dotRadius = dotRadius;
	        return _chart;
	    };
	
	    /**
	     * Always show individual dots for each datapoint.
	     * If `options` is falsy, it disables data point rendering.
	     *
	     * If no `options` are provided, the current `options` values are instead returned.
	     * @name renderDataPoints
	     * @memberof dc.lineChart
	     * @instance
	     * @example
	     * chart.renderDataPoints({radius: 2, fillOpacity: 0.8, strokeOpacity: 0.8})
	     * @param  {{fillOpacity: Number, strokeOpacity: Number, radius: Number}} [options={fillOpacity: 0.8, strokeOpacity: 0.8, radius: 2}]
	     * @returns {Chart}
	     */
	    _chart.renderDataPoints = function (options) {
	        if (!arguments.length) {
	            return {
	                fillOpacity: _dataPointFillOpacity,
	                strokeOpacity: _dataPointStrokeOpacity,
	                radius: _dataPointRadius
	            };
	        } else if (!options) {
	            _dataPointFillOpacity = DEFAULT_DOT_OPACITY;
	            _dataPointStrokeOpacity = DEFAULT_DOT_OPACITY;
	            _dataPointRadius = null;
	        } else {
	            _dataPointFillOpacity = options.fillOpacity || 0.8;
	            _dataPointStrokeOpacity = options.strokeOpacity || 0.8;
	            _dataPointRadius = options.radius || 2;
	        }
	        return _chart;
	    };
	
	    function colorFilter (color, dashstyle, inv) {
	        return function () {
	            var item = d3.select(this);
	            var match = (item.attr('stroke') === color &&
	                item.attr('stroke-dasharray') === ((dashstyle instanceof Array) ?
	                    dashstyle.join(',') : null)) || item.attr('fill') === color;
	            return inv ? !match : match;
	        };
	    }
	
	    _chart.legendHighlight = function (d) {
	        if (!_chart.isLegendableHidden(d)) {
	            _chart.g().selectAll('path.line, path.area')
	                .classed('highlight', colorFilter(d.color, d.dashstyle))
	                .classed('fadeout', colorFilter(d.color, d.dashstyle, true));
	        }
	    };
	
	    _chart.legendReset = function () {
	        _chart.g().selectAll('path.line, path.area')
	            .classed('highlight', false)
	            .classed('fadeout', false);
	    };
	
	    dc.override(_chart, 'legendables', function () {
	        var legendables = _chart._legendables();
	        if (!_dashStyle) {
	            return legendables;
	        }
	        return legendables.map(function (l) {
	            l.dashstyle = _dashStyle;
	            return l;
	        });
	    });
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The data count widget is a simple widget designed to display the number of records selected by the
	 * current filters out of the total number of records in the data set. Once created the data count widget
	 * will automatically update the text content of the following elements under the parent element.
	 *
	 * '.total-count' - total number of records
	 * '.filter-count' - number of records matched by the current filters
	 *
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * @name dataCount
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * var ndx = crossfilter(data);
	 * var all = ndx.groupAll();
	 *
	 * dc.dataCount('.dc-data-count')
	 *     .dimension(ndx)
	 *     .group(all);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {DataCount}
	 */
	dc.dataCount = function (parent, chartGroup) {
	    var _formatNumber = d3.format(',d');
	    var _chart = dc.baseMixin({});
	    var _html = {some: '', all: ''};
	
	    /**
	     * Gets or sets an optional object specifying HTML templates to use depending how many items are
	     * selected. The text `%total-count` will replaced with the total number of records, and the text
	     * `%filter-count` will be replaced with the number of selected records.
	     * - all: HTML template to use if all items are selected
	     * - some: HTML template to use if not all items are selected
	     * @name html
	     * @memberof dc.dataCount
	     * @instance
	     * @example
	     * counter.html({
	     *      some: '%filter-count out of %total-count records selected',
	     *      all: 'All records selected. Click on charts to apply filters'
	     * })
	     * @param {{some:String, all: String}} [options]
	     * @returns {Chart}
	     */
	    _chart.html = function (options) {
	        if (!arguments.length) {
	            return _html;
	        }
	        if (options.all) {
	            _html.all = options.all;
	        }
	        if (options.some) {
	            _html.some = options.some;
	        }
	        return _chart;
	    };
	
	    /**
	     * Gets or sets an optional function to format the filter count and total count.
	     * @name formatNumber
	     * @memberof dc.dataCount
	     * @instance
	     * @example
	     * counter.formatNumber(d3.format('.2g'))
	     * @param {Function} [formatter=d3.format('.2g')]
	     * @returns {Chart}
	     */
	    _chart.formatNumber = function (formatter) {
	        if (!arguments.length) {
	            return _formatNumber;
	        }
	        _formatNumber = formatter;
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        var tot = _chart.dimension().size(),
	            val = _chart.group().value();
	        var all = _formatNumber(tot);
	        var selected = _formatNumber(val);
	
	        if ((tot === val) && (_html.all !== '')) {
	            _chart.root().html(_html.all.replace('%total-count', all).replace('%filter-count', selected));
	        } else if (_html.some !== '') {
	            _chart.root().html(_html.some.replace('%total-count', all).replace('%filter-count', selected));
	        } else {
	            _chart.selectAll('.total-count').text(all);
	            _chart.selectAll('.filter-count').text(selected);
	        }
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The data table is a simple widget designed to list crossfilter focused data set (rows being
	 * filtered) in a good old tabular fashion.
	 *
	 * Note: Unlike other charts, the data table (and data grid chart) use the group attribute as a keying function
	 * for [nesting](https://github.com/mbostock/d3/wiki/Arrays#-nest) the data together in groups.
	 * Do not pass in a crossfilter group as this will not work.
	 *
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * @name dataTable
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {DataTable}
	 */
	dc.dataTable = function (parent, chartGroup) {
	    var LABEL_CSS_CLASS = 'dc-table-label';
	    var ROW_CSS_CLASS = 'dc-table-row';
	    var COLUMN_CSS_CLASS = 'dc-table-column';
	    var GROUP_CSS_CLASS = 'dc-table-group';
	    var HEAD_CSS_CLASS = 'dc-table-head';
	
	    var _chart = dc.baseMixin({});
	
	    var _size = 25;
	    var _columns = [];
	    var _sortBy = function (d) {
	        return d;
	    };
	    var _order = d3.ascending;
	    var _showGroups = true;
	
	    _chart._doRender = function () {
	        _chart.selectAll('tbody').remove();
	
	        renderRows(renderGroups());
	
	        return _chart;
	    };
	
	    _chart._doColumnValueFormat = function (v, d) {
	        return ((typeof v === 'function') ?
	                v(d) :                          // v as function
	                ((typeof v === 'string') ?
	                 d[v] :                         // v is field name string
	                 v.format(d)                        // v is Object, use fn (element 2)
	                )
	               );
	    };
	
	    _chart._doColumnHeaderFormat = function (d) {
	        // if 'function', convert to string representation
	        // show a string capitalized
	        // if an object then display it's label string as-is.
	        return (typeof d === 'function') ?
	                _chart._doColumnHeaderFnToString(d) :
	                ((typeof d === 'string') ?
	                 _chart._doColumnHeaderCapitalize(d) : String(d.label));
	    };
	
	    _chart._doColumnHeaderCapitalize = function (s) {
	        // capitalize
	        return s.charAt(0).toUpperCase() + s.slice(1);
	    };
	
	    _chart._doColumnHeaderFnToString = function (f) {
	        // columnString(f) {
	        var s = String(f);
	        var i1 = s.indexOf('return ');
	        if (i1 >= 0) {
	            var i2 = s.lastIndexOf(';');
	            if (i2 >= 0) {
	                s = s.substring(i1 + 7, i2);
	                var i3 = s.indexOf('numberFormat');
	                if (i3 >= 0) {
	                    s = s.replace('numberFormat', '');
	                }
	            }
	        }
	        return s;
	    };
	
	    function renderGroups () {
	        // The 'original' example uses all 'functions'.
	        // If all 'functions' are used, then don't remove/add a header, and leave
	        // the html alone. This preserves the functionality of earlier releases.
	        // A 2nd option is a string representing a field in the data.
	        // A third option is to supply an Object such as an array of 'information', and
	        // supply your own _doColumnHeaderFormat and _doColumnValueFormat functions to
	        // create what you need.
	        var bAllFunctions = true;
	        _columns.forEach(function (f) {
	            bAllFunctions = bAllFunctions & (typeof f === 'function');
	        });
	
	        if (!bAllFunctions) {
	            _chart.selectAll('th').remove();
	            var headcols = _chart.root().selectAll('th')
	                .data(_columns);
	
	            var headGroup = headcols
	                .enter()
	                .append('th');
	
	            headGroup
	                .attr('class', HEAD_CSS_CLASS)
	                    .html(function (d) {
	                        return (_chart._doColumnHeaderFormat(d));
	
	                    });
	        }
	
	        var groups = _chart.root().selectAll('tbody')
	            .data(nestEntries(), function (d) {
	                return _chart.keyAccessor()(d);
	            });
	
	        var rowGroup = groups
	            .enter()
	            .append('tbody');
	
	        if (_showGroups === true) {
	            rowGroup
	                .append('tr')
	                .attr('class', GROUP_CSS_CLASS)
	                    .append('td')
	                    .attr('class', LABEL_CSS_CLASS)
	                    .attr('colspan', _columns.length)
	                    .html(function (d) {
	                        return _chart.keyAccessor()(d);
	                    });
	        }
	
	        groups.exit().remove();
	
	        return rowGroup;
	    }
	
	    function nestEntries () {
	        var entries;
	        if (_order === d3.ascending) {
	            entries = _chart.dimension().bottom(_size);
	        } else {
	            entries = _chart.dimension().top(_size);
	        }
	
	        return d3.nest()
	            .key(_chart.group())
	            .sortKeys(_order)
	            .entries(entries.sort(function (a, b) {
	                return _order(_sortBy(a), _sortBy(b));
	            }));
	    }
	
	    function renderRows (groups) {
	        var rows = groups.order()
	            .selectAll('tr.' + ROW_CSS_CLASS)
	            .data(function (d) {
	                return d.values;
	            });
	
	        var rowEnter = rows.enter()
	            .append('tr')
	            .attr('class', ROW_CSS_CLASS);
	
	        _columns.forEach(function (v, i) {
	            rowEnter.append('td')
	                .attr('class', COLUMN_CSS_CLASS + ' _' + i)
	                .html(function (d) {
	                    return _chart._doColumnValueFormat(v, d);
	                });
	        });
	
	        rows.exit().remove();
	
	        return rows;
	    }
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set the table size which determines the number of rows displayed by the widget.
	     * @name size
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number} [size=25]
	     * @returns {Chart}
	     */
	    _chart.size = function (size) {
	        if (!arguments.length) {
	            return _size;
	        }
	        _size = size;
	        return _chart;
	    };
	
	    /**
	     * Get or set column functions. The data table widget now supports several methods of specifying
	     * the columns to display.  The original method, first shown below, uses an array of functions to
	     * generate dynamic columns. Column functions are simple javascript functions with only one input
	     * argument `d` which represents a row in the data set. The return value of these functions will be
	     * used directly to generate table content for each cell. However, this method requires the .html
	     * table entry to have a fixed set of column headers.
	     *
	     * The second example shows you can simply list the data (d) content directly without
	     * specifying it as a function, except where necessary (ie, computed columns).  Note
	     * the data element accessor name is capitalized when displayed in the table. You can
	     * also mix in functions as desired or necessary, but you must use the
	     * Object = [Label, Fn] method as shown below.
	     * You may wish to override the following two functions, which are internally used to
	     * translate the column information or function into a displayed header. The first one
	     * is used on the simple "string" column specifier, the second is used to transform the
	     * String(fn) into something displayable. For the Stock example, the function for Change
	     * becomes a header of 'd.close - d.open'.
	     * _chart._doColumnHeaderCapitalize _chart._doColumnHeaderFnToString
	     * You may use your own Object definition, however you must then override
	     * _chart._doColumnHeaderFormat , _chart._doColumnValueFormat
	     * Be aware that fields without numberFormat specification will be displayed just as
	     * they are stored in the data, unformatted.
	     *
	     * The third example, where all fields are specified using the Object = [Label, Fn] method.
	     * @name columns
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart.columns([
	     *     function(d) { return d.date; },
	     *     function(d) { return d.open; },
	     *     function(d) { return d.close; },
	     *     function(d) { return numberFormat(d.close - d.open); },
	     *     function(d) { return d.volume; }
	     * ]);
	     * @example
	     * chart.columns([
	     *     "date",    // d["date"], ie, a field accessor; capitalized automatically
	     *     "open",    // ...
	     *     "close",   // ...
	     *     ["Change", // Specify an Object = [Label, Fn]
	     *         function (d) { return numberFormat(d.close - d.open); }],
	     *     "volume"   // d["volume"], ie, a field accessor; capitalized automatically
	     * ]);
	     * @example
	     * chart.columns([
	     *     ["Date",   // Specify an Object = [Label, Fn]
	     *         function (d) { return d.date; }],
	     *     ["Open",
	     *         function (d) { return numberFormat(d.open); }],
	     *     ["Close",
	     *         function (d) { return numberFormat(d.close); }],
	     *     ["Change",
	     *         function (d) { return numberFormat(d.close - d.open); }],
	     *     ["Volume",
	     *         function (d) { return d.volume; }]
	     * ]);
	     * @param {Array<Function>} [columns=[]]
	     * @returns {Chart}
	     */
	    _chart.columns = function (columns) {
	        if (!arguments.length) {
	            return _columns;
	        }
	        _columns = columns;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort-by function. This function works as a value accessor at row level and returns a
	     * particular field to be sorted by. Default value: identity function
	     * @name sortBy
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart.sortBy(function(d) {
	     *     return d.date;
	     * });
	     * @param {Function} [sortBy]
	     * @returns {Chart}
	     */
	    _chart.sortBy = function (sortBy) {
	        if (!arguments.length) {
	            return _sortBy;
	        }
	        _sortBy = sortBy;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort order.
	     * @name order
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart.order(d3.descending);
	     * @param {Function} [order=d3.ascending]
	     * @returns {Chart}
	     */
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    /**
	     * Get or set if group rows will be shown.
	     *
	     * The .group() getter-setter must be provided in either case.
	     * @name showGroups
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart
	     *     .group([value], [name])
	     *     .showGroups(true|false);
	     * @param {Boolean} [showGroups=true]
	     * @returns {Chart}
	     */
	    _chart.showGroups = function (showGroups) {
	        if (!arguments.length) {
	            return _showGroups;
	        }
	        _showGroups = showGroups;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Data grid is a simple widget designed to list the filtered records, providing
	 * a simple way to define how the items are displayed.
	 *
	 * Note: Unlike other charts, the data grid chart (and data table) use the group attribute as a keying function
	 * for [nesting](https://github.com/mbostock/d3/wiki/Arrays#-nest) the data together in groups.
	 * Do not pass in a crossfilter group as this will not work.
	 *
	 * Examples:
	 * - [List of members of the european parliament](http://europarl.me/dc.js/web/ep/index.html)
	 * @name dataGrid
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {DataGrid}
	 */
	dc.dataGrid = function (parent, chartGroup) {
	    var LABEL_CSS_CLASS = 'dc-grid-label';
	    var ITEM_CSS_CLASS = 'dc-grid-item';
	    var GROUP_CSS_CLASS = 'dc-grid-group';
	    var GRID_CSS_CLASS = 'dc-grid-top';
	
	    var _chart = dc.baseMixin({});
	
	    var _size = 999; // shouldn't be needed, but you might
	    var _html = function (d) { return 'you need to provide an html() handling param:  ' + JSON.stringify(d); };
	    var _sortBy = function (d) {
	        return d;
	    };
	    var _order = d3.ascending;
	    var _beginSlice = 0, _endSlice;
	
	    var _htmlGroup = function (d) {
	        return '<div class=\'' + GROUP_CSS_CLASS + '\'><h1 class=\'' + LABEL_CSS_CLASS + '\'>' +
	            _chart.keyAccessor()(d) + '</h1></div>';
	    };
	
	    _chart._doRender = function () {
	        _chart.selectAll('div.' + GRID_CSS_CLASS).remove();
	
	        renderItems(renderGroups());
	
	        return _chart;
	    };
	
	    function renderGroups () {
	        var groups = _chart.root().selectAll('div.' + GRID_CSS_CLASS)
	                .data(nestEntries(), function (d) {
	                    return _chart.keyAccessor()(d);
	                });
	
	        var itemGroup = groups
	                .enter()
	                .append('div')
	                .attr('class', GRID_CSS_CLASS);
	
	        if (_htmlGroup) {
	            itemGroup
	                .html(function (d) {
	                    return _htmlGroup(d);
	                });
	        }
	
	        groups.exit().remove();
	        return itemGroup;
	    }
	
	    function nestEntries () {
	        var entries = _chart.dimension().top(_size);
	
	        return d3.nest()
	            .key(_chart.group())
	            .sortKeys(_order)
	            .entries(entries.sort(function (a, b) {
	                return _order(_sortBy(a), _sortBy(b));
	            }).slice(_beginSlice, _endSlice));
	    }
	
	    function renderItems (groups) {
	        var items = groups.order()
	                .selectAll('div.' + ITEM_CSS_CLASS)
	                .data(function (d) {
	                    return d.values;
	                });
	
	        items.enter()
	            .append('div')
	            .attr('class', ITEM_CSS_CLASS)
	            .html(function (d) {
	                return _html(d);
	            });
	
	        items.exit().remove();
	
	        return items;
	    }
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set the index of the beginning slice which determines which entries get displayed by the widget
	     * Useful when implementing pagination.
	     * @name beginSlice
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [beginSlice=0]
	     * @returns {Chart}
	     */
	    _chart.beginSlice = function (beginSlice) {
	        if (!arguments.length) {
	            return _beginSlice;
	        }
	        _beginSlice = beginSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the end slice which determines which entries get displayed by the widget
	     * Useful when implementing pagination.
	     * @name endSlice
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [endSlice]
	     * @returns {Chart}
	     */
	    _chart.endSlice = function (endSlice) {
	        if (!arguments.length) {
	            return _endSlice;
	        }
	        _endSlice = endSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the grid size which determines the number of items displayed by the widget.
	     * @name size
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [size=999]
	     * @returns {Chart}
	     */
	    _chart.size = function (size) {
	        if (!arguments.length) {
	            return _size;
	        }
	        _size = size;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that formats an item. The data grid widget uses a
	     * function to generate dynamic html. Use your favourite templating engine or
	     * generate the string directly.
	     * @name html
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.html(function (d) { return '<div class='item '+data.exampleCategory+''>'+data.exampleString+'</div>';});
	     * @param {Function} [html]
	     * @returns {Chart}
	     */
	    _chart.html = function (html) {
	        if (!arguments.length) {
	            return _html;
	        }
	        _html = html;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that formats a group label.
	     * @name htmlGroup
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.htmlGroup (function (d) { return '<h2>'.d.key . 'with ' . d.values.length .' items</h2>'});
	     * @param {Function} [htmlGroup]
	     * @returns {Chart}
	     */
	    _chart.htmlGroup = function (htmlGroup) {
	        if (!arguments.length) {
	            return _htmlGroup;
	        }
	        _htmlGroup = htmlGroup;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort-by function. This function works as a value accessor at the item
	     * level and returns a particular field to be sorted.
	     * @name sortBy
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.sortBy(function(d) {
	     *     return d.date;
	     * });
	     * @param {Function} [sortByFunction]
	     * @returns {Chart}
	     */
	    _chart.sortBy = function (sortByFunction) {
	        if (!arguments.length) {
	            return _sortBy;
	        }
	        _sortBy = sortByFunction;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort order function.
	     * @name order
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.order(d3.descending);
	     * @param {Function} [order=d3.ascending]
	     * @returns {Chart}
	     */
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A concrete implementation of a general purpose bubble chart that allows data visualization using the
	 * following dimensions:
	 * - x axis position
	 * - y axis position
	 * - bubble radius
	 * - color
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * - [US Venture Capital Landscape 2011](http://dc-js.github.com/dc.js/vc/index.html)
	 * @name bubbleChart
	 * @memberof dc
	 * @mixes dc.bubbleMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a bubble chart under #chart-container1 element using the default global chart group
	 * var bubbleChart1 = dc.bubbleChart('#chart-container1');
	 * // create a bubble chart under #chart-container2 element using chart group A
	 * var bubbleChart2 = dc.bubbleChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {BubbleChart}
	 */
	dc.bubbleChart = function (parent, chartGroup) {
	    var _chart = dc.bubbleMixin(dc.coordinateGridMixin({}));
	
	    var _elasticRadius = false;
	
	    _chart.transitionDuration(750);
	
	    var bubbleLocator = function (d) {
	        return 'translate(' + (bubbleX(d)) + ',' + (bubbleY(d)) + ')';
	    };
	
	    /**
	     * Turn on or off the elastic bubble radius feature, or return the value of the flag. If this
	     * feature is turned on, then bubble radii will be automatically rescaled to fit the chart better.
	     * @name elasticRadius
	     * @memberof dc.bubbleChart
	     * @instance
	     * @param {Boolean} [elasticRadius=false]
	     * @returns {Boolean}
	     */
	    _chart.elasticRadius = function (elasticRadius) {
	        if (!arguments.length) {
	            return _elasticRadius;
	        }
	        _elasticRadius = elasticRadius;
	        return _chart;
	    };
	
	    _chart.plotData = function () {
	        if (_elasticRadius) {
	            _chart.r().domain([_chart.rMin(), _chart.rMax()]);
	        }
	
	        _chart.r().range([_chart.MIN_RADIUS, _chart.xAxisLength() * _chart.maxBubbleRelativeSize()]);
	
	        var bubbleG = _chart.chartBodyG().selectAll('g.' + _chart.BUBBLE_NODE_CLASS)
	            .data(_chart.data(), function (d) { return d.key; });
	
	        renderNodes(bubbleG);
	
	        updateNodes(bubbleG);
	
	        removeNodes(bubbleG);
	
	        _chart.fadeDeselectedArea();
	    };
	
	    function renderNodes (bubbleG) {
	        var bubbleGEnter = bubbleG.enter().append('g');
	
	        bubbleGEnter
	            .attr('class', _chart.BUBBLE_NODE_CLASS)
	            .attr('transform', bubbleLocator)
	            .append('circle').attr('class', function (d, i) {
	                return _chart.BUBBLE_CLASS + ' _' + i;
	            })
	            .on('click', _chart.onClick)
	            .attr('fill', _chart.getColor)
	            .attr('r', 0);
	        dc.transition(bubbleG, _chart.transitionDuration())
	            .selectAll('circle.' + _chart.BUBBLE_CLASS)
	            .attr('r', function (d) {
	                return _chart.bubbleR(d);
	            })
	            .attr('opacity', function (d) {
	                return (_chart.bubbleR(d) > 0) ? 1 : 0;
	            });
	
	        _chart._doRenderLabel(bubbleGEnter);
	
	        _chart._doRenderTitles(bubbleGEnter);
	    }
	
	    function updateNodes (bubbleG) {
	        dc.transition(bubbleG, _chart.transitionDuration())
	            .attr('transform', bubbleLocator)
	            .selectAll('circle.' + _chart.BUBBLE_CLASS)
	            .attr('fill', _chart.getColor)
	            .attr('r', function (d) {
	                return _chart.bubbleR(d);
	            })
	            .attr('opacity', function (d) {
	                return (_chart.bubbleR(d) > 0) ? 1 : 0;
	            });
	
	        _chart.doUpdateLabels(bubbleG);
	        _chart.doUpdateTitles(bubbleG);
	    }
	
	    function removeNodes (bubbleG) {
	        bubbleG.exit().remove();
	    }
	
	    function bubbleX (d) {
	        var x = _chart.x()(_chart.keyAccessor()(d));
	        if (isNaN(x)) {
	            x = 0;
	        }
	        return x;
	    }
	
	    function bubbleY (d) {
	        var y = _chart.y()(_chart.valueAccessor()(d));
	        if (isNaN(y)) {
	            y = 0;
	        }
	        return y;
	    }
	
	    _chart.renderBrush = function () {
	        // override default x axis brush from parent chart
	    };
	
	    _chart.redrawBrush = function () {
	        // override default x axis brush from parent chart
	        _chart.fadeDeselectedArea();
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Composite charts are a special kind of chart that render multiple charts on the same Coordinate
	 * Grid. You can overlay (compose) different bar/line/area charts in a single composite chart to
	 * achieve some quite flexible charting effects.
	 * @name compositeChart
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a composite chart under #chart-container1 element using the default global chart group
	 * var compositeChart1 = dc.compositeChart('#chart-container1');
	 * // create a composite chart under #chart-container2 element using chart group A
	 * var compositeChart2 = dc.compositeChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {CompositeChart}
	 */
	dc.compositeChart = function (parent, chartGroup) {
	
	    var SUB_CHART_CLASS = 'sub';
	    var DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING = 12;
	
	    var _chart = dc.coordinateGridMixin({});
	    var _children = [];
	
	    var _childOptions = {};
	
	    var _shareColors = false,
	        _shareTitle = true;
	
	    var _rightYAxis = d3.svg.axis(),
	        _rightYAxisLabel = 0,
	        _rightYAxisLabelPadding = DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING,
	        _rightY,
	        _rightAxisGridLines = false;
	
	    _chart._mandatoryAttributes([]);
	    _chart.transitionDuration(500);
	
	    dc.override(_chart, '_generateG', function () {
	        var g = this.__generateG();
	
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	
	            generateChildG(child, i);
	
	            if (!child.dimension()) {
	                child.dimension(_chart.dimension());
	            }
	            if (!child.group()) {
	                child.group(_chart.group());
	            }
	
	            child.chartGroup(_chart.chartGroup());
	            child.svg(_chart.svg());
	            child.xUnits(_chart.xUnits());
	            child.transitionDuration(_chart.transitionDuration());
	            child.brushOn(_chart.brushOn());
	            child.renderTitle(_chart.renderTitle());
	            child.elasticX(_chart.elasticX());
	        }
	
	        return g;
	    });
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	        var brushIsEmpty = _chart.brushIsEmpty(extent);
	
	        for (var i = 0; i < _children.length; ++i) {
	            _children[i].filter(null);
	            if (!brushIsEmpty) {
	                _children[i].filter(extent);
	            }
	        }
	    };
	
	    _chart._prepareYAxis = function () {
	        if (leftYAxisChildren().length !== 0) { prepareLeftYAxis(); }
	        if (rightYAxisChildren().length !== 0) { prepareRightYAxis(); }
	
	        if (leftYAxisChildren().length > 0 && !_rightAxisGridLines) {
	            _chart._renderHorizontalGridLinesForAxis(_chart.g(), _chart.y(), _chart.yAxis());
	        } else if (rightYAxisChildren().length > 0) {
	            _chart._renderHorizontalGridLinesForAxis(_chart.g(), _rightY, _rightYAxis);
	        }
	    };
	
	    _chart.renderYAxis = function () {
	        if (leftYAxisChildren().length !== 0) {
	            _chart.renderYAxisAt('y', _chart.yAxis(), _chart.margins().left);
	            _chart.renderYAxisLabel('y', _chart.yAxisLabel(), -90);
	        }
	
	        if (rightYAxisChildren().length !== 0) {
	            _chart.renderYAxisAt('yr', _chart.rightYAxis(), _chart.width() - _chart.margins().right);
	            _chart.renderYAxisLabel('yr', _chart.rightYAxisLabel(), 90, _chart.width() - _rightYAxisLabelPadding);
	        }
	    };
	
	    function prepareRightYAxis () {
	        if (_chart.rightY() === undefined || _chart.elasticY()) {
	            if (_chart.rightY() === undefined) {
	                _chart.rightY(d3.scale.linear());
	            }
	            _chart.rightY().domain([rightYAxisMin(), rightYAxisMax()]).rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _chart.rightY().range([_chart.yAxisHeight(), 0]);
	        _chart.rightYAxis(_chart.rightYAxis().scale(_chart.rightY()));
	
	        _chart.rightYAxis().orient('right');
	    }
	
	    function prepareLeftYAxis () {
	        if (_chart.y() === undefined || _chart.elasticY()) {
	            if (_chart.y() === undefined) {
	                _chart.y(d3.scale.linear());
	            }
	            _chart.y().domain([yAxisMin(), yAxisMax()]).rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _chart.y().range([_chart.yAxisHeight(), 0]);
	        _chart.yAxis(_chart.yAxis().scale(_chart.y()));
	
	        _chart.yAxis().orient('left');
	    }
	
	    function generateChildG (child, i) {
	        child._generateG(_chart.g());
	        child.g().attr('class', SUB_CHART_CLASS + ' _' + i);
	    }
	
	    _chart.plotData = function () {
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	
	            if (!child.g()) {
	                generateChildG(child, i);
	            }
	
	            if (_shareColors) {
	                child.colors(_chart.colors());
	            }
	
	            child.x(_chart.x());
	
	            child.xAxis(_chart.xAxis());
	
	            if (child.useRightYAxis()) {
	                child.y(_chart.rightY());
	                child.yAxis(_chart.rightYAxis());
	            } else {
	                child.y(_chart.y());
	                child.yAxis(_chart.yAxis());
	            }
	
	            child.plotData();
	
	            child._activateRenderlets();
	        }
	    };
	
	    /**
	     * Get or set whether to draw gridlines from the right y axis.  Drawing from the left y axis is the
	     * default behavior. This option is only respected when subcharts with both left and right y-axes
	     * are present.
	     * @name useRightAxisGridLines
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [useRightAxisGridLines=false]
	     * @return {Chart}
	     */
	    _chart.useRightAxisGridLines = function (useRightAxisGridLines) {
	        if (!arguments) {
	            return _rightAxisGridLines;
	        }
	
	        _rightAxisGridLines = useRightAxisGridLines;
	        return _chart;
	    };
	
	    /**
	     * Get or set chart-specific options for all child charts. This is equivalent to calling `.options`
	     * on each child chart.
	     * @name childOptions
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Object} [childOptions]
	     * @return {Chart}
	     */
	    _chart.childOptions = function (childOptions) {
	        if (!arguments.length) {
	            return _childOptions;
	        }
	        _childOptions = childOptions;
	        _children.forEach(function (child) {
	            child.options(_childOptions);
	        });
	        return _chart;
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	            child.brush(_chart.brush());
	            child.fadeDeselectedArea();
	        }
	    };
	
	    /**
	     * Set or get the right y axis label.
	     * @name rightYAxisLabel
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {String} [rightYAxisLabel]
	     * @param {Number} [padding]
	     * @return {Chart}
	     */
	    _chart.rightYAxisLabel = function (rightYAxisLabel, padding) {
	        if (!arguments.length) {
	            return _rightYAxisLabel;
	        }
	        _rightYAxisLabel = rightYAxisLabel;
	        _chart.margins().right -= _rightYAxisLabelPadding;
	        _rightYAxisLabelPadding = (padding === undefined) ? DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING : padding;
	        _chart.margins().right += _rightYAxisLabelPadding;
	        return _chart;
	    };
	
	    /**
	     * Combine the given charts into one single composite coordinate grid chart.
	     * @name compose
	     * @memberof dc.compositeChart
	     * @instance
	     * @example
	     * moveChart.compose([
	     *     // when creating sub-chart you need to pass in the parent chart
	     *     dc.lineChart(moveChart)
	     *         .group(indexAvgByMonthGroup) // if group is missing then parent's group will be used
	     *         .valueAccessor(function (d){return d.value.avg;})
	     *         // most of the normal functions will continue to work in a composed chart
	     *         .renderArea(true)
	     *         .stack(monthlyMoveGroup, function (d){return d.value;})
	     *         .title(function (d){
	     *             var value = d.value.avg?d.value.avg:d.value;
	     *             if(isNaN(value)) value = 0;
	     *             return dateFormat(d.key) + '\n' + numberFormat(value);
	     *         }),
	     *     dc.barChart(moveChart)
	     *         .group(volumeByMonthGroup)
	     *         .centerBar(true)
	     * ]);
	     * @param {Array<Chart>} [subChartArray]
	     * @return {Chart}
	     */
	    _chart.compose = function (subChartArray) {
	        _children = subChartArray;
	        _children.forEach(function (child) {
	            child.height(_chart.height());
	            child.width(_chart.width());
	            child.margins(_chart.margins());
	
	            if (_shareTitle) {
	                child.title(_chart.title());
	            }
	
	            child.options(_childOptions);
	        });
	        return _chart;
	    };
	
	    /**
	     * Returns the child charts which are composed into the composite chart.
	     * @name children
	     * @memberof dc.compositeChart
	     * @instance
	     * @return {Array<Chart>}
	     */
	    _chart.children = function () {
	        return _children;
	    };
	
	    /**
	     * Get or set color sharing for the chart. If set, the `.colors()` value from this chart
	     * will be shared with composed children. Additionally if the child chart implements
	     * Stackable and has not set a custom .colorAccessor, then it will generate a color
	     * specific to its order in the composition.
	     * @name shareColors
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [shareColors=false]
	     * @return {Chart}
	     */
	    _chart.shareColors = function (shareColors) {
	        if (!arguments.length) {
	            return _shareColors;
	        }
	        _shareColors = shareColors;
	        return _chart;
	    };
	
	    /**
	     * Get or set title sharing for the chart. If set, the `.title()` value from this chart will be
	     * shared with composed children.
	     * @name shareTitle
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [shareTitle=true]
	     * @return {Chart}
	     */
	    _chart.shareTitle = function (shareTitle) {
	        if (!arguments.length) {
	            return _shareTitle;
	        }
	        _shareTitle = shareTitle;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y scale for the right axis. The right y scale is typically automatically
	     * generated by the chart implementation.
	     * @name rightY
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {d3.scale} [yScale]
	     * @return {Chart}
	     */
	    _chart.rightY = function (yScale) {
	        if (!arguments.length) {
	            return _rightY;
	        }
	        _rightY = yScale;
	        _chart.rescale();
	        return _chart;
	    };
	
	    function leftYAxisChildren () {
	        return _children.filter(function (child) {
	            return !child.useRightYAxis();
	        });
	    }
	
	    function rightYAxisChildren () {
	        return _children.filter(function (child) {
	            return child.useRightYAxis();
	        });
	    }
	
	    function getYAxisMin (charts) {
	        return charts.map(function (c) {
	            return c.yAxisMin();
	        });
	    }
	
	    delete _chart.yAxisMin;
	    function yAxisMin () {
	        return d3.min(getYAxisMin(leftYAxisChildren()));
	    }
	
	    function rightYAxisMin () {
	        return d3.min(getYAxisMin(rightYAxisChildren()));
	    }
	
	    function getYAxisMax (charts) {
	        return charts.map(function (c) {
	            return c.yAxisMax();
	        });
	    }
	
	    delete _chart.yAxisMax;
	    function yAxisMax () {
	        return dc.utils.add(d3.max(getYAxisMax(leftYAxisChildren())), _chart.yAxisPadding());
	    }
	
	    function rightYAxisMax () {
	        return dc.utils.add(d3.max(getYAxisMax(rightYAxisChildren())), _chart.yAxisPadding());
	    }
	
	    function getAllXAxisMinFromChildCharts () {
	        return _children.map(function (c) {
	            return c.xAxisMin();
	        });
	    }
	
	    dc.override(_chart, 'xAxisMin', function () {
	        return dc.utils.subtract(d3.min(getAllXAxisMinFromChildCharts()), _chart.xAxisPadding());
	    });
	
	    function getAllXAxisMaxFromChildCharts () {
	        return _children.map(function (c) {
	            return c.xAxisMax();
	        });
	    }
	
	    dc.override(_chart, 'xAxisMax', function () {
	        return dc.utils.add(d3.max(getAllXAxisMaxFromChildCharts()), _chart.xAxisPadding());
	    });
	
	    _chart.legendables = function () {
	        return _children.reduce(function (items, child) {
	            if (_shareColors) {
	                child.colors(_chart.colors());
	            }
	            items.push.apply(items, child.legendables());
	            return items;
	        }, []);
	    };
	
	    _chart.legendHighlight = function (d) {
	        for (var j = 0; j < _children.length; ++j) {
	            var child = _children[j];
	            child.legendHighlight(d);
	        }
	    };
	
	    _chart.legendReset = function (d) {
	        for (var j = 0; j < _children.length; ++j) {
	            var child = _children[j];
	            child.legendReset(d);
	        }
	    };
	
	    _chart.legendToggle = function () {
	        console.log('composite should not be getting legendToggle itself');
	    };
	
	    /**
	     * Set or get the right y axis used by the composite chart. This function is most useful when y
	     * axis customization is required. The y axis in dc.js is an instance of a [d3 axis
	     * object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-_axis) therefore it supports any valid
	     * d3 axis manipulation. **Caution**: The y axis is usually generated internally by dc;
	     * resetting it may cause unexpected results.
	     * @name rightYAxis
	     * @memberof dc.compositeChart
	     * @instance
	     * @example
	     * // customize y axis tick format
	     * chart.rightYAxis().tickFormat(function (v) {return v + '%';});
	     * // customize y axis tick values
	     * chart.rightYAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [rightYAxis]
	     * @return {Chart}
	     */
	    _chart.rightYAxis = function (rightYAxis) {
	        if (!arguments.length) {
	            return _rightYAxis;
	        }
	        _rightYAxis = rightYAxis;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A series chart is a chart that shows multiple series of data overlaid on one chart, where the
	 * series is specified in the data. It is a specialization of Composite Chart and inherits all
	 * composite features other than recomposing the chart.
	 * @name seriesChart
	 * @memberof dc
	 * @mixes dc.compositeChart
	 * @example
	 * // create a series chart under #chart-container1 element using the default global chart group
	 * var seriesChart1 = dc.seriesChart("#chart-container1");
	 * // create a series chart under #chart-container2 element using chart group A
	 * var seriesChart2 = dc.seriesChart("#chart-container2", "chartGroupA");
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {SeriesChart}
	 */
	dc.seriesChart = function (parent, chartGroup) {
	    var _chart = dc.compositeChart(parent, chartGroup);
	
	    function keySort (a, b) {
	        return d3.ascending(_chart.keyAccessor()(a), _chart.keyAccessor()(b));
	    }
	
	    var _charts = {};
	    var _chartFunction = dc.lineChart;
	    var _seriesAccessor;
	    var _seriesSort = d3.ascending;
	    var _valueSort = keySort;
	
	    _chart._mandatoryAttributes().push('seriesAccessor', 'chart');
	    _chart.shareColors(true);
	
	    _chart._preprocessData = function () {
	        var keep = [];
	        var childrenChanged;
	        var nester = d3.nest().key(_seriesAccessor);
	        if (_seriesSort) {
	            nester.sortKeys(_seriesSort);
	        }
	        if (_valueSort) {
	            nester.sortValues(_valueSort);
	        }
	        var nesting = nester.entries(_chart.data());
	        var children =
	            nesting.map(function (sub, i) {
	                var subChart = _charts[sub.key] || _chartFunction.call(_chart, _chart, chartGroup, sub.key, i);
	                if (!_charts[sub.key]) {
	                    childrenChanged = true;
	                }
	                _charts[sub.key] = subChart;
	                keep.push(sub.key);
	                return subChart
	                    .dimension(_chart.dimension())
	                    .group({all: d3.functor(sub.values)}, sub.key)
	                    .keyAccessor(_chart.keyAccessor())
	                    .valueAccessor(_chart.valueAccessor())
	                    .brushOn(_chart.brushOn());
	            });
	        // this works around the fact compositeChart doesn't really
	        // have a removal interface
	        Object.keys(_charts)
	            .filter(function (c) {return keep.indexOf(c) === -1;})
	            .forEach(function (c) {
	                clearChart(c);
	                childrenChanged = true;
	            });
	        _chart._compose(children);
	        if (childrenChanged && _chart.legend()) {
	            _chart.legend().render();
	        }
	    };
	
	    function clearChart (c) {
	        if (_charts[c].g()) {
	            _charts[c].g().remove();
	        }
	        delete _charts[c];
	    }
	
	    function resetChildren () {
	        Object.keys(_charts).map(clearChart);
	        _charts = {};
	    }
	
	    /**
	     * Get or set the chart function, which generates the child charts.
	     * @name chart
	     * @memberof dc.seriesChart
	     * @instance
	     * @example
	     * // put interpolation on the line charts used for the series
	     * chart.chart(function(c) { return dc.lineChart(c).interpolate('basis'); })
	     * // do a scatter series chart
	     * chart.chart(dc.scatterPlot)
	     * @param {Function} [chartFunction=dc.lineChart]
	     * @returns {Chart}
	     */
	    _chart.chart = function (chartFunction) {
	        if (!arguments.length) {
	            return _chartFunction;
	        }
	        _chartFunction = chartFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set accessor function for the displayed series. Given a datum, this function
	     * should return the series that datum belongs to.
	     * @name seriesAccessor
	     * @memberof dc.seriesChart
	     * @instance
	     * @param {Function} [accessor]
	     * @returns {Chart}
	     */
	    _chart.seriesAccessor = function (accessor) {
	        if (!arguments.length) {
	            return _seriesAccessor;
	        }
	        _seriesAccessor = accessor;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set a function to sort the list of series by, given series values.
	     * @name seriesSort
	     * @memberof dc.seriesChart
	     * @instance
	     * @example
	     * chart.seriesSort(d3.descending);
	     * @param {Function} [sortFunction=d3.ascending]
	     * @returns {Chart}
	     */
	    _chart.seriesSort = function (sortFunction) {
	        if (!arguments.length) {
	            return _seriesSort;
	        }
	        _seriesSort = sortFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set a function to sort each series values by. By default this is the key accessor which,
	     * for example, will ensure a lineChart series connects its points in increasing key/x order,
	     * rather than haphazardly.
	     * @name valueSort
	     * @memberof dc.seriesChart
	     * @instance
	     * @param {Function} [sortFunction]
	     * @returns {Chart}
	     */
	    _chart.valueSort = function (sortFunction) {
	        if (!arguments.length) {
	            return _valueSort;
	        }
	        _valueSort = sortFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    // make compose private
	    _chart._compose = _chart.compose;
	    delete _chart.compose;
	
	    return _chart;
	};
	
	/**
	 * The geo choropleth chart is designed as an easy way to create a crossfilter driven choropleth map
	 * from GeoJson data. This chart implementation was inspired by [the great d3 choropleth example](http://bl.ocks.org/4060606).
	 * Examples:
	 * - [US Venture Capital Landscape 2011](http://dc-js.github.com/dc.js/vc/index.html)
	 * @name geoChoroplethChart
	 * @memberof dc
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a choropleth chart under '#us-chart' element using the default global chart group
	 * var chart1 = dc.geoChoroplethChart('#us-chart');
	 * // create a choropleth chart under '#us-chart2' element using chart group A
	 * var chart2 = dc.compositeChart('#us-chart2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {GeoChoroplethChart}
	 */
	dc.geoChoroplethChart = function (parent, chartGroup) {
	    var _chart = dc.colorMixin(dc.baseMixin({}));
	
	    _chart.colorAccessor(function (d) {
	        return d || 0;
	    });
	
	    var _geoPath = d3.geo.path();
	    var _projectionFlag;
	
	    var _geoJsons = [];
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	        for (var layerIndex = 0; layerIndex < _geoJsons.length; ++layerIndex) {
	            var states = _chart.svg().append('g')
	                .attr('class', 'layer' + layerIndex);
	
	            var regionG = states.selectAll('g.' + geoJson(layerIndex).name)
	                .data(geoJson(layerIndex).data)
	                .enter()
	                .append('g')
	                .attr('class', geoJson(layerIndex).name);
	
	            regionG
	                .append('path')
	                .attr('fill', 'white')
	                .attr('d', _geoPath);
	
	            regionG.append('title');
	
	            plotData(layerIndex);
	        }
	        _projectionFlag = false;
	    };
	
	    function plotData (layerIndex) {
	        var data = generateLayeredData();
	
	        if (isDataLayer(layerIndex)) {
	            var regionG = renderRegionG(layerIndex);
	
	            renderPaths(regionG, layerIndex, data);
	
	            renderTitle(regionG, layerIndex, data);
	        }
	    }
	
	    function generateLayeredData () {
	        var data = {};
	        var groupAll = _chart.data();
	        for (var i = 0; i < groupAll.length; ++i) {
	            data[_chart.keyAccessor()(groupAll[i])] = _chart.valueAccessor()(groupAll[i]);
	        }
	        return data;
	    }
	
	    function isDataLayer (layerIndex) {
	        return geoJson(layerIndex).keyAccessor;
	    }
	
	    function renderRegionG (layerIndex) {
	        var regionG = _chart.svg()
	            .selectAll(layerSelector(layerIndex))
	            .classed('selected', function (d) {
	                return isSelected(layerIndex, d);
	            })
	            .classed('deselected', function (d) {
	                return isDeselected(layerIndex, d);
	            })
	            .attr('class', function (d) {
	                var layerNameClass = geoJson(layerIndex).name;
	                var regionClass = dc.utils.nameToId(geoJson(layerIndex).keyAccessor(d));
	                var baseClasses = layerNameClass + ' ' + regionClass;
	                if (isSelected(layerIndex, d)) {
	                    baseClasses += ' selected';
	                }
	                if (isDeselected(layerIndex, d)) {
	                    baseClasses += ' deselected';
	                }
	                return baseClasses;
	            });
	        return regionG;
	    }
	
	    function layerSelector (layerIndex) {
	        return 'g.layer' + layerIndex + ' g.' + geoJson(layerIndex).name;
	    }
	
	    function isSelected (layerIndex, d) {
	        return _chart.hasFilter() && _chart.hasFilter(getKey(layerIndex, d));
	    }
	
	    function isDeselected (layerIndex, d) {
	        return _chart.hasFilter() && !_chart.hasFilter(getKey(layerIndex, d));
	    }
	
	    function getKey (layerIndex, d) {
	        return geoJson(layerIndex).keyAccessor(d);
	    }
	
	    function geoJson (index) {
	        return _geoJsons[index];
	    }
	
	    function renderPaths (regionG, layerIndex, data) {
	        var paths = regionG
	            .select('path')
	            .attr('fill', function () {
	                var currentFill = d3.select(this).attr('fill');
	                if (currentFill) {
	                    return currentFill;
	                }
	                return 'none';
	            })
	            .on('click', function (d) {
	                return _chart.onClick(d, layerIndex);
	            });
	
	        dc.transition(paths, _chart.transitionDuration()).attr('fill', function (d, i) {
	            return _chart.getColor(data[geoJson(layerIndex).keyAccessor(d)], i);
	        });
	    }
	
	    _chart.onClick = function (d, layerIndex) {
	        var selectedRegion = geoJson(layerIndex).keyAccessor(d);
	        dc.events.trigger(function () {
	            _chart.filter(selectedRegion);
	            _chart.redrawGroup();
	        });
	    };
	
	    function renderTitle (regionG, layerIndex, data) {
	        if (_chart.renderTitle()) {
	            regionG.selectAll('title').text(function (d) {
	                var key = getKey(layerIndex, d);
	                var value = data[key];
	                return _chart.title()({key: key, value: value});
	            });
	        }
	    }
	
	    _chart._doRedraw = function () {
	        for (var layerIndex = 0; layerIndex < _geoJsons.length; ++layerIndex) {
	            plotData(layerIndex);
	            if (_projectionFlag) {
	                _chart.svg().selectAll('g.' + geoJson(layerIndex).name + ' path').attr('d', _geoPath);
	            }
	        }
	        _projectionFlag = false;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Use this function to insert a new GeoJson map layer. This function can be invoked multiple times
	     * if you have multiple GeoJson data layers to render on top of each other. If you overlay multiple
	     * layers with the same name the new overlay will override the existing one.
	     * @name overlayGeoJson
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @example
	     * // insert a layer for rendering US states
	     * chart.overlayGeoJson(statesJson.features, 'state', function(d) {
	     *      return d.properties.name;
	     * });
	     * @param {Object} json - a geojson feed
	     * @param {String} name - name of the layer
	     * @param {Function} keyAccessor - accessor function used to extract 'key' from the GeoJson data. The key extracted by
	     * this function should match the keys returned by the crossfilter groups.
	     * @returns {Chart}
	     */
	    _chart.overlayGeoJson = function (json, name, keyAccessor) {
	        for (var i = 0; i < _geoJsons.length; ++i) {
	            if (_geoJsons[i].name === name) {
	                _geoJsons[i].data = json;
	                _geoJsons[i].keyAccessor = keyAccessor;
	                return _chart;
	            }
	        }
	        _geoJsons.push({name: name, data: json, keyAccessor: keyAccessor});
	        return _chart;
	    };
	
	    /**
	     * Set custom geo projection function. See the available [d3 geo projection
	     * functions](https://github.com/mbostock/d3/wiki/Geo-Projections).
	     * @name projection
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @param {d3.projection} [projection=d3.projection.albersUsa()]
	     * @returns {Chart}
	     */
	    _chart.projection = function (projection) {
	        _geoPath.projection(projection);
	        _projectionFlag = true;
	        return _chart;
	    };
	
	    /**
	     * Returns all GeoJson layers currently registered with this chart. The returned array is a
	     * reference to this chart's internal data structure, so any modification to this array will also
	     * modify this chart's internal registration.
	     * @name geoJsons
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @returns {Array<{name:String, data: Object, accessor: Function}>}
	     */
	    _chart.geoJsons = function () {
	        return _geoJsons;
	    };
	
	    /**
	     * Returns the [d3.geo.path](https://github.com/mbostock/d3/wiki/Geo-Paths#path) object used to
	     * render the projection and features.  Can be useful for figuring out the bounding box of the
	     * feature set and thus a way to calculate scale and translation for the projection.
	     * @name geoPath
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @returns {d3.geo.path}
	     */
	    _chart.geoPath = function () {
	        return _geoPath;
	    };
	
	    /**
	     * Remove a GeoJson layer from this chart by name
	     * @name removeGeoJson
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @param {String} name
	     * @returns {Chart}
	     */
	    _chart.removeGeoJson = function (name) {
	        var geoJsons = [];
	
	        for (var i = 0; i < _geoJsons.length; ++i) {
	            var layer = _geoJsons[i];
	            if (layer.name !== name) {
	                geoJsons.push(layer);
	            }
	        }
	
	        _geoJsons = geoJsons;
	
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The bubble overlay chart is quite different from the typical bubble chart. With the bubble overlay
	 * chart you can arbitrarily place bubbles on an existing svg or bitmap image, thus changing the
	 * typical x and y positioning while retaining the capability to visualize data using bubble radius
	 * and coloring.
	 * Examples:
	 * - [Canadian City Crime Stats](http://dc-js.github.com/dc.js/crime/index.html)
	 * @name bubbleOverlay
	 * @memberof dc
	 * @mixes dc.bubbleMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a bubble overlay chart on top of the '#chart-container1 svg' element using the default global chart group
	 * var bubbleChart1 = dc.bubbleOverlayChart('#chart-container1').svg(d3.select('#chart-container1 svg'));
	 * // create a bubble overlay chart on top of the '#chart-container2 svg' element using chart group A
	 * var bubbleChart2 = dc.compositeChart('#chart-container2', 'chartGroupA').svg(d3.select('#chart-container2 svg'));
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {BubbleOverlay}
	 */
	dc.bubbleOverlay = function (parent, chartGroup) {
	    var BUBBLE_OVERLAY_CLASS = 'bubble-overlay';
	    var BUBBLE_NODE_CLASS = 'node';
	    var BUBBLE_CLASS = 'bubble';
	
	    /**
	     * **mandatory**
	     *
	     * Set the underlying svg image element. Unlike other dc charts this chart will not generate a svg
	     * element; therefore the bubble overlay chart will not work if this function is not invoked. If the
	     * underlying image is a bitmap, then an empty svg will need to be created on top of the image.
	     * @name svg
	     * @memberof dc.bubbleOverlay
	     * @instance
	     * @example
	     * // set up underlying svg element
	     * chart.svg(d3.select('#chart svg'));
	     * @param {Selection} [imageElement]
	     * @returns {Chart}
	     */
	    var _chart = dc.bubbleMixin(dc.baseMixin({}));
	    var _g;
	    var _points = [];
	
	    _chart.transitionDuration(750);
	
	    _chart.radiusValueAccessor(function (d) {
	        return d.value;
	    });
	
	    /**
	     * **mandatory**
	     *
	     * Set up a data point on the overlay. The name of a data point should match a specific 'key' among
	     * data groups generated using keyAccessor.  If a match is found (point name <-> data group key)
	     * then a bubble will be generated at the position specified by the function. x and y
	     * value specified here are relative to the underlying svg.
	     * @name point
	     * @memberof dc.bubbleOverlay
	     * @instance
	     * @param {String} name
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {Chart}
	     */
	    _chart.point = function (name, x, y) {
	        _points.push({name: name, x: x, y: y});
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        _g = initOverlayG();
	
	        _chart.r().range([_chart.MIN_RADIUS, _chart.width() * _chart.maxBubbleRelativeSize()]);
	
	        initializeBubbles();
	
	        _chart.fadeDeselectedArea();
	
	        return _chart;
	    };
	
	    function initOverlayG () {
	        _g = _chart.select('g.' + BUBBLE_OVERLAY_CLASS);
	        if (_g.empty()) {
	            _g = _chart.svg().append('g').attr('class', BUBBLE_OVERLAY_CLASS);
	        }
	        return _g;
	    }
	
	    function initializeBubbles () {
	        var data = mapData();
	
	        _points.forEach(function (point) {
	            var nodeG = getNodeG(point, data);
	
	            var circle = nodeG.select('circle.' + BUBBLE_CLASS);
	
	            if (circle.empty()) {
	                circle = nodeG.append('circle')
	                    .attr('class', BUBBLE_CLASS)
	                    .attr('r', 0)
	                    .attr('fill', _chart.getColor)
	                    .on('click', _chart.onClick);
	            }
	
	            dc.transition(circle, _chart.transitionDuration())
	                .attr('r', function (d) {
	                    return _chart.bubbleR(d);
	                });
	
	            _chart._doRenderLabel(nodeG);
	
	            _chart._doRenderTitles(nodeG);
	        });
	    }
	
	    function mapData () {
	        var data = {};
	        _chart.data().forEach(function (datum) {
	            data[_chart.keyAccessor()(datum)] = datum;
	        });
	        return data;
	    }
	
	    function getNodeG (point, data) {
	        var bubbleNodeClass = BUBBLE_NODE_CLASS + ' ' + dc.utils.nameToId(point.name);
	
	        var nodeG = _g.select('g.' + dc.utils.nameToId(point.name));
	
	        if (nodeG.empty()) {
	            nodeG = _g.append('g')
	                .attr('class', bubbleNodeClass)
	                .attr('transform', 'translate(' + point.x + ',' + point.y + ')');
	        }
	
	        nodeG.datum(data[point.name]);
	
	        return nodeG;
	    }
	
	    _chart._doRedraw = function () {
	        updateBubbles();
	
	        _chart.fadeDeselectedArea();
	
	        return _chart;
	    };
	
	    function updateBubbles () {
	        var data = mapData();
	
	        _points.forEach(function (point) {
	            var nodeG = getNodeG(point, data);
	
	            var circle = nodeG.select('circle.' + BUBBLE_CLASS);
	
	            dc.transition(circle, _chart.transitionDuration())
	                .attr('r', function (d) {
	                    return _chart.bubbleR(d);
	                })
	                .attr('fill', _chart.getColor);
	
	            _chart.doUpdateLabels(nodeG);
	
	            _chart.doUpdateTitles(nodeG);
	        });
	    }
	
	    _chart.debug = function (flag) {
	        if (flag) {
	            var debugG = _chart.select('g.' + dc.constants.DEBUG_GROUP_CLASS);
	
	            if (debugG.empty()) {
	                debugG = _chart.svg()
	                    .append('g')
	                    .attr('class', dc.constants.DEBUG_GROUP_CLASS);
	            }
	
	            var debugText = debugG.append('text')
	                .attr('x', 10)
	                .attr('y', 20);
	
	            debugG
	                .append('rect')
	                .attr('width', _chart.width())
	                .attr('height', _chart.height())
	                .on('mousemove', function () {
	                    var position = d3.mouse(debugG.node());
	                    var msg = position[0] + ', ' + position[1];
	                    debugText.text(msg);
	                });
	        } else {
	            _chart.selectAll('.debug').remove();
	        }
	
	        return _chart;
	    };
	
	    _chart.anchor(parent, chartGroup);
	
	    return _chart;
	};
	
	/**
	 * Concrete row chart implementation.
	 * @name rowChart
	 * @memberof dc
	 * @mixes dc.capMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a row chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.rowChart('#chart-container1');
	 * // create a row chart under #chart-container2 element using chart group A
	 * var chart2 = dc.rowChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {RowChart}
	 */
	dc.rowChart = function (parent, chartGroup) {
	
	    var _g;
	
	    var _labelOffsetX = 10;
	    var _labelOffsetY = 15;
	    var _hasLabelOffsetY = false;
	    var _dyOffset = '0.35em';  // this helps center labels https://github.com/mbostock/d3/wiki/SVG-Shapes#svg_text
	    var _titleLabelOffsetX = 2;
	
	    var _gap = 5;
	
	    var _fixedBarHeight = false;
	    var _rowCssClass = 'row';
	    var _titleRowCssClass = 'titlerow';
	    var _renderTitleLabel = false;
	
	    var _chart = dc.capMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));
	
	    var _x;
	
	    var _elasticX;
	
	    var _xAxis = d3.svg.axis().orient('bottom');
	
	    var _rowData;
	
	    _chart.rowsCap = _chart.cap;
	
	    function calculateAxisScale () {
	        if (!_x || _elasticX) {
	            var extent = d3.extent(_rowData, _chart.cappedValueAccessor);
	            if (extent[0] > 0) {
	                extent[0] = 0;
	            }
	            _x = d3.scale.linear().domain(extent)
	                .range([0, _chart.effectiveWidth()]);
	        }
	        _xAxis.scale(_x);
	    }
	
	    function drawAxis () {
	        var axisG = _g.select('g.axis');
	
	        calculateAxisScale();
	
	        if (axisG.empty()) {
	            axisG = _g.append('g').attr('class', 'axis');
	        }
	        axisG.attr('transform', 'translate(0, ' + _chart.effectiveHeight() + ')');
	
	        dc.transition(axisG, _chart.transitionDuration())
	            .call(_xAxis);
	    }
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _g = _chart.svg()
	            .append('g')
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	
	        drawChart();
	
	        return _chart;
	    };
	
	    _chart.title(function (d) {
	        return _chart.cappedKeyAccessor(d) + ': ' + _chart.cappedValueAccessor(d);
	    });
	
	    _chart.label(_chart.cappedKeyAccessor);
	
	    /**
	     * Gets or sets the x scale. The x scale can be any d3
	     * [quantitive scale](https://github.com/mbostock/d3/wiki/Quantitative-Scales)
	     * @name x
	     * @memberof dc.rowChart
	     * @instance
	     * @param {d3.scale} [scale]
	     * @returns {Chart}
	     */
	    _chart.x = function (scale) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = scale;
	        return _chart;
	    };
	
	    function drawGridLines () {
	        _g.selectAll('g.tick')
	            .select('line.grid-line')
	            .remove();
	
	        _g.selectAll('g.tick')
	            .append('line')
	            .attr('class', 'grid-line')
	            .attr('x1', 0)
	            .attr('y1', 0)
	            .attr('x2', 0)
	            .attr('y2', function () {
	                return -_chart.effectiveHeight();
	            });
	    }
	
	    function drawChart () {
	        _rowData = _chart.data();
	
	        drawAxis();
	        drawGridLines();
	
	        var rows = _g.selectAll('g.' + _rowCssClass)
	            .data(_rowData);
	
	        createElements(rows);
	        removeElements(rows);
	        updateElements(rows);
	    }
	
	    function createElements (rows) {
	        var rowEnter = rows.enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return _rowCssClass + ' _' + i;
	            });
	
	        rowEnter.append('rect').attr('width', 0);
	
	        createLabels(rowEnter);
	        updateLabels(rows);
	    }
	
	    function removeElements (rows) {
	        rows.exit().remove();
	    }
	
	    function rootValue () {
	        var root = _x(0);
	        return (root === -Infinity || root !== root) ? _x(1) : root;
	    }
	
	    function updateElements (rows) {
	        var n = _rowData.length;
	
	        var height;
	        if (!_fixedBarHeight) {
	            height = (_chart.effectiveHeight() - (n + 1) * _gap) / n;
	        } else {
	            height = _fixedBarHeight;
	        }
	
	        // vertically align label in center unless they override the value via property setter
	        if (!_hasLabelOffsetY) {
	            _labelOffsetY = height / 2;
	        }
	
	        var rect = rows.attr('transform', function (d, i) {
	                return 'translate(0,' + ((i + 1) * _gap + i * height) + ')';
	            }).select('rect')
	            .attr('height', height)
	            .attr('fill', _chart.getColor)
	            .on('click', onClick)
	            .classed('deselected', function (d) {
	                return (_chart.hasFilter()) ? !isSelectedRow(d) : false;
	            })
	            .classed('selected', function (d) {
	                return (_chart.hasFilter()) ? isSelectedRow(d) : false;
	            });
	
	        dc.transition(rect, _chart.transitionDuration())
	            .attr('width', function (d) {
	                return Math.abs(rootValue() - _x(_chart.valueAccessor()(d)));
	            })
	            .attr('transform', translateX);
	
	        createTitles(rows);
	        updateLabels(rows);
	    }
	
	    function createTitles (rows) {
	        if (_chart.renderTitle()) {
	            rows.selectAll('title').remove();
	            rows.append('title').text(_chart.title());
	        }
	    }
	
	    function createLabels (rowEnter) {
	        if (_chart.renderLabel()) {
	            rowEnter.append('text')
	                .on('click', onClick);
	        }
	        if (_chart.renderTitleLabel()) {
	            rowEnter.append('text')
	                .attr('class', _titleRowCssClass)
	                .on('click', onClick);
	        }
	    }
	
	    function updateLabels (rows) {
	        if (_chart.renderLabel()) {
	            var lab = rows.select('text')
	                .attr('x', _labelOffsetX)
	                .attr('y', _labelOffsetY)
	                .attr('dy', _dyOffset)
	                .on('click', onClick)
	                .attr('class', function (d, i) {
	                    return _rowCssClass + ' _' + i;
	                })
	                .text(function (d) {
	                    return _chart.label()(d);
	                });
	            dc.transition(lab, _chart.transitionDuration())
	                .attr('transform', translateX);
	        }
	        if (_chart.renderTitleLabel()) {
	            var titlelab = rows.select('.' + _titleRowCssClass)
	                    .attr('x', _chart.effectiveWidth() - _titleLabelOffsetX)
	                    .attr('y', _labelOffsetY)
	                    .attr('text-anchor', 'end')
	                    .on('click', onClick)
	                    .attr('class', function (d, i) {
	                        return _titleRowCssClass + ' _' + i ;
	                    })
	                    .text(function (d) {
	                        return _chart.title()(d);
	                    });
	            dc.transition(titlelab, _chart.transitionDuration())
	                .attr('transform', translateX);
	        }
	    }
	
	    /**
	     * Turn on/off Title label rendering (values) using SVG style of text-anchor 'end'
	     * @name renderTitleLabel
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Boolean} [renderTitleLabel=false]
	     * @returns {Chart}
	     */
	    _chart.renderTitleLabel = function (renderTitleLabel) {
	        if (!arguments.length) {
	            return _renderTitleLabel;
	        }
	        _renderTitleLabel = renderTitleLabel;
	        return _chart;
	    };
	
	    function onClick (d) {
	        _chart.onClick(d);
	    }
	
	    function translateX (d) {
	        var x = _x(_chart.cappedValueAccessor(d)),
	            x0 = rootValue(),
	            s = x > x0 ? x0 : x;
	        return 'translate(' + s + ',0)';
	    }
	
	    _chart._doRedraw = function () {
	        drawChart();
	        return _chart;
	    };
	
	    /**
	     * Get the x axis for the row chart instance.  Note: not settable for row charts.
	     * See the [d3 axis object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-axis) documention for more information.
	     * @name xAxis
	     * @memberof dc.rowChart
	     * @instance
	     * @example
	     * // customize x axis tick format
	     * chart.xAxis().tickFormat(function (v) {return v + '%';});
	     * // customize x axis tick values
	     * chart.xAxis().tickValues([0, 100, 200, 300]);
	     * @returns {d3.svg.Axis}
	     */
	    _chart.xAxis = function () {
	        return _xAxis;
	    };
	
	    /**
	     * Get or set the fixed bar height. Default is [false] which will auto-scale bars.
	     * For example, if you want to fix the height for a specific number of bars (useful in TopN charts)
	     * you could fix height as follows (where count = total number of bars in your TopN and gap is
	     * your vertical gap space).
	     * @name fixedBarHeight
	     * @memberof dc.rowChart
	     * @instance
	     * @example
	     * chart.fixedBarHeight( chartheight - (count + 1) * gap / count);
	     * @param {Boolean|Number} [fixedBarHeight=false]
	     * @returns {Chart}
	     */
	    _chart.fixedBarHeight = function (fixedBarHeight) {
	        if (!arguments.length) {
	            return _fixedBarHeight;
	        }
	        _fixedBarHeight = fixedBarHeight;
	        return _chart;
	    };
	
	    /**
	     * Get or set the vertical gap space between rows on a particular row chart instance
	     * @name gap
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [gap=5]
	     * @returns {Chart}
	     */
	    _chart.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _chart;
	    };
	
	    /**
	     * Get or set the elasticity on x axis. If this attribute is set to true, then the x axis will rescle to auto-fit the
	     * data range when filtered.
	     * @name elasticX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Boolean} [elasticX]
	     * @returns {Chart}
	     */
	    _chart.elasticX = function (elasticX) {
	        if (!arguments.length) {
	            return _elasticX;
	        }
	        _elasticX = elasticX;
	        return _chart;
	    };
	
	    /**
	     * Get or set the x offset (horizontal space to the top left corner of a row) for labels on a particular row chart.
	     * @name labelOffsetX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [labelOffsetX=10]
	     * @returns {Chart}
	     */
	    _chart.labelOffsetX = function (labelOffsetX) {
	        if (!arguments.length) {
	            return _labelOffsetX;
	        }
	        _labelOffsetX = labelOffsetX;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y offset (vertical space to the top left corner of a row) for labels on a particular row chart.
	     * @name labelOffsetY
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [labelOffsety=15]
	     * @returns {Chart}
	     */
	    _chart.labelOffsetY = function (labelOffsety) {
	        if (!arguments.length) {
	            return _labelOffsetY;
	        }
	        _labelOffsetY = labelOffsety;
	        _hasLabelOffsetY = true;
	        return _chart;
	    };
	
	    /**
	     * Get of set the x offset (horizontal space between right edge of row and right edge or text.
	     * @name titleLabelOffsetX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [titleLabelOffsetX=2]
	     * @returns {Chart}
	     */
	    _chart.titleLabelOffsetX = function (titleLabelOffsetX) {
	        if (!arguments.length) {
	            return _titleLabelOffsetX;
	        }
	        _titleLabelOffsetX = titleLabelOffsetX;
	        return _chart;
	    };
	
	    function isSelectedRow (d) {
	        return _chart.hasFilter(_chart.cappedKeyAccessor(d));
	    }
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Legend is a attachable widget that can be added to other dc charts to render horizontal legend
	 * labels.
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * - [Canadian City Crime Stats](http://dc-js.github.com/dc.js/crime/index.html)
	 * @name legend
	 * @memberof dc
	 * @example
	 * chart.legend(dc.legend().x(400).y(10).itemHeight(13).gap(5))
	 * @returns {Legend}
	 */
	dc.legend = function () {
	    var LABEL_GAP = 2;
	
	    var _legend = {},
	        _parent,
	        _x = 0,
	        _y = 0,
	        _itemHeight = 12,
	        _gap = 5,
	        _horizontal = false,
	        _legendWidth = 560,
	        _itemWidth = 70,
	        _autoItemWidth = false;
	
	    var _g;
	
	    _legend.parent = function (p) {
	        if (!arguments.length) {
	            return _parent;
	        }
	        _parent = p;
	        return _legend;
	    };
	
	    _legend.render = function () {
	        _parent.svg().select('g.dc-legend').remove();
	        _g = _parent.svg().append('g')
	            .attr('class', 'dc-legend')
	            .attr('transform', 'translate(' + _x + ',' + _y + ')');
	        var legendables = _parent.legendables();
	
	        var itemEnter = _g.selectAll('g.dc-legend-item')
	            .data(legendables)
	            .enter()
	            .append('g')
	            .attr('class', 'dc-legend-item')
	            .on('mouseover', function (d) {
	                _parent.legendHighlight(d);
	            })
	            .on('mouseout', function (d) {
	                _parent.legendReset(d);
	            })
	            .on('click', function (d) {
	                d.chart.legendToggle(d);
	            });
	
	        _g.selectAll('g.dc-legend-item')
	            .classed('fadeout', function (d) {
	                return d.chart.isLegendableHidden(d);
	            });
	
	        if (legendables.some(dc.pluck('dashstyle'))) {
	            itemEnter
	                .append('line')
	                .attr('x1', 0)
	                .attr('y1', _itemHeight / 2)
	                .attr('x2', _itemHeight)
	                .attr('y2', _itemHeight / 2)
	                .attr('stroke-width', 2)
	                .attr('stroke-dasharray', dc.pluck('dashstyle'))
	                .attr('stroke', dc.pluck('color'));
	        } else {
	            itemEnter
	                .append('rect')
	                .attr('width', _itemHeight)
	                .attr('height', _itemHeight)
	                .attr('fill', function (d) {return d ? d.color : 'blue';});
	        }
	
	        itemEnter.append('text')
	                .text(dc.pluck('name'))
	                .attr('x', _itemHeight + LABEL_GAP)
	                .attr('y', function () {
	                    return _itemHeight / 2 + (this.clientHeight ? this.clientHeight : 13) / 2 - 2;
	                });
	
	        var _cumulativeLegendTextWidth = 0;
	        var row = 0;
	        itemEnter.attr('transform', function (d, i) {
	            if (_horizontal) {
	                var translateBy = 'translate(' + _cumulativeLegendTextWidth + ',' + row * legendItemHeight() + ')';
	                var itemWidth   = _autoItemWidth === true ? this.getBBox().width + _gap : _itemWidth;
	
	                if ((_cumulativeLegendTextWidth + itemWidth) >= _legendWidth) {
	                    ++row ;
	                    _cumulativeLegendTextWidth = 0 ;
	                } else {
	                    _cumulativeLegendTextWidth += itemWidth;
	                }
	                return translateBy;
	            } else {
	                return 'translate(0,' + i * legendItemHeight() + ')';
	            }
	        });
	    };
	
	    function legendItemHeight () {
	        return _gap + _itemHeight;
	    }
	
	    /**
	     * Set or get x coordinate for legend widget.
	     * @name x
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [x=0]
	     * @returns {Legend}
	     */
	    _legend.x = function (x) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = x;
	        return _legend;
	    };
	
	    /**
	     * Set or get y coordinate for legend widget.
	     * @name y
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [y=0]
	     * @returns {Legend}
	     */
	    _legend.y = function (y) {
	        if (!arguments.length) {
	            return _y;
	        }
	        _y = y;
	        return _legend;
	    };
	
	    /**
	     * Set or get gap between legend items.
	     * @name gap
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [gap=5]
	     * @returns {Legend}
	     */
	    _legend.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _legend;
	    };
	
	    /**
	     * Set or get legend item height.
	     * @name itemHeight
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [itemHeight=12]
	     * @returns {Legend}
	     */
	    _legend.itemHeight = function (itemHeight) {
	        if (!arguments.length) {
	            return _itemHeight;
	        }
	        _itemHeight = itemHeight;
	        return _legend;
	    };
	
	    /**
	     * Position legend horizontally instead of vertically.
	     * @name horizontal
	     * @memberof dc.legend
	     * @instance
	     * @param  {Boolean} [horizontal=false]
	     * @returns {Legend}
	     */
	    _legend.horizontal = function (horizontal) {
	        if (!arguments.length) {
	            return _horizontal;
	        }
	        _horizontal = horizontal;
	        return _legend;
	    };
	
	    /**
	     * Maximum width for horizontal legend.
	     * @name legendWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [legendWidth=500]
	     * @returns {Legend}
	     */
	    _legend.legendWidth = function (legendWidth) {
	        if (!arguments.length) {
	            return _legendWidth;
	        }
	        _legendWidth = legendWidth;
	        return _legend;
	    };
	
	    /**
	     * legendItem width for horizontal legend.
	     * @name itemWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [itemWidth=70]
	     * @returns {Legend}
	     */
	    _legend.itemWidth = function (itemWidth) {
	        if (!arguments.length) {
	            return _itemWidth;
	        }
	        _itemWidth = itemWidth;
	        return _legend;
	    };
	
	    /**
	     * Turn automatic width for legend items on or off. If true, itemWidth() is ignored.
	     * This setting takes into account gap().
	     * @name autoItemWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Boolean} [autoItemWidth=false]
	     * @returns {Legend}
	     */
	    _legend.autoItemWidth = function (autoItemWidth) {
	        if (!arguments.length) {
	            return _autoItemWidth;
	        }
	        _autoItemWidth = autoItemWidth;
	        return _legend;
	    };
	
	    return _legend;
	};
	
	/**
	 * A scatter plot chart
	 * @name scatterPlot
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a scatter plot under #chart-container1 element using the default global chart group
	 * var chart1 = dc.scatterPlot('#chart-container1');
	 * // create a scatter plot under #chart-container2 element using chart group A
	 * var chart2 = dc.scatterPlot('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.scatterPlot(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {SeriesChart}
	 */
	dc.scatterPlot = function (parent, chartGroup) {
	    var _chart = dc.coordinateGridMixin({});
	    var _symbol = d3.svg.symbol();
	
	    var _existenceAccessor = function (d) { return d.value; };
	
	    var originalKeyAccessor = _chart.keyAccessor();
	    _chart.keyAccessor(function (d) { return originalKeyAccessor(d)[0]; });
	    _chart.valueAccessor(function (d) { return originalKeyAccessor(d)[1]; });
	    _chart.colorAccessor(function () { return _chart._groupName; });
	
	    var _locator = function (d) {
	        return 'translate(' + _chart.x()(_chart.keyAccessor()(d)) + ',' +
	                              _chart.y()(_chart.valueAccessor()(d)) + ')';
	    };
	
	    var _symbolSize = 3;
	    var _highlightedSize = 5;
	    var _hiddenSize = 0;
	
	    _symbol.size(function (d) {
	        if (!_existenceAccessor(d)) {
	            return _hiddenSize;
	        } else if (this.filtered) {
	            return Math.pow(_highlightedSize, 2);
	        } else {
	            return Math.pow(_symbolSize, 2);
	        }
	    });
	
	    dc.override(_chart, '_filter', function (filter) {
	        if (!arguments.length) {
	            return _chart.__filter();
	        }
	
	        return _chart.__filter(dc.filters.RangedTwoDimensionalFilter(filter));
	    });
	
	    _chart.plotData = function () {
	        var symbols = _chart.chartBodyG().selectAll('path.symbol')
	            .data(_chart.data());
	
	        symbols
	            .enter()
	        .append('path')
	            .attr('class', 'symbol')
	            .attr('opacity', 0)
	            .attr('fill', _chart.getColor)
	            .attr('transform', _locator);
	
	        dc.transition(symbols, _chart.transitionDuration())
	            .attr('opacity', function (d) { return _existenceAccessor(d) ? 1 : 0; })
	            .attr('fill', _chart.getColor)
	            .attr('transform', _locator)
	            .attr('d', _symbol);
	
	        dc.transition(symbols.exit(), _chart.transitionDuration())
	            .attr('opacity', 0).remove();
	    };
	
	    /**
	     * Get or set the existence accessor.  If a point exists, it is drawn with symbolSize radius and
	     * opacity 1; if it does not exist, it is drawn with hiddenSize radius and opacity 0. By default,
	     * the existence accessor checks if the reduced value is truthy.
	     * @name existenceAccessor
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Function} [accessor]
	     * @returns {Chart}
	     */
	    _chart.existenceAccessor = function (accessor) {
	        if (!arguments.length) {
	            return _existenceAccessor;
	        }
	        _existenceAccessor = accessor;
	        return this;
	    };
	
	    /**
	     * Get or set the symbol type used for each point. By default the symbol is a circle. See the D3
	     * [docs](https://github.com/mbostock/d3/wiki/SVG-Shapes#wiki-symbol_type) for acceptable types.
	     * Type can be a constant or an accessor.
	     * @name symbol
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Function} [type]
	     * @returns {Chart}
	     */
	    _chart.symbol = function (type) {
	        if (!arguments.length) {
	            return _symbol.type();
	        }
	        _symbol.type(type);
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for symbols.
	     * @name symbolSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [symbolSize=3]
	     * @returns {Chart}
	     */
	    _chart.symbolSize = function (symbolSize) {
	        if (!arguments.length) {
	            return _symbolSize;
	        }
	        _symbolSize = symbolSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for highlighted symbols.
	     * @name highlightedSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [highlightedSize=5]
	     * @returns {Chart}
	     */
	    _chart.highlightedSize = function (highlightedSize) {
	        if (!arguments.length) {
	            return _highlightedSize;
	        }
	        _highlightedSize = highlightedSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for symbols when the group is empty.
	     * @name hiddenSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [hiddenSize=0]
	     * @returns {Chart}
	     */
	    _chart.hiddenSize = function (hiddenSize) {
	        if (!arguments.length) {
	            return _hiddenSize;
	        }
	        _hiddenSize = hiddenSize;
	        return _chart;
	    };
	
	    _chart.legendables = function () {
	        return [{chart: _chart, name: _chart._groupName, color: _chart.getColor()}];
	    };
	
	    _chart.legendHighlight = function (d) {
	        resizeSymbolsWhere(function (symbol) {
	            return symbol.attr('fill') === d.color;
	        }, _highlightedSize);
	        _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return d3.select(this).attr('fill') !== d.color;
	        }).classed('fadeout', true);
	    };
	
	    _chart.legendReset = function (d) {
	        resizeSymbolsWhere(function (symbol) {
	            return symbol.attr('fill') === d.color;
	        }, _symbolSize);
	        _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return d3.select(this).attr('fill') !== d.color;
	        }).classed('fadeout', false);
	    };
	
	    function resizeSymbolsWhere (condition, size) {
	        var symbols = _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return condition(d3.select(this));
	        });
	        var oldSize = _symbol.size();
	        _symbol.size(Math.pow(size, 2));
	        dc.transition(symbols, _chart.transitionDuration()).attr('d', _symbol);
	        _symbol.size(oldSize);
	    }
	
	    _chart.setHandlePaths = function () {
	        // no handle paths for poly-brushes
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _chart.brush().extent();
	        if (_chart.round()) {
	            extent[0] = extent[0].map(_chart.round());
	            extent[1] = extent[1].map(_chart.round());
	
	            _chart.g().select('.brush')
	                .call(_chart.brush().extent(extent));
	        }
	        return extent;
	    };
	
	    _chart.brushIsEmpty = function (extent) {
	        return _chart.brush().empty() || !extent || extent[0][0] >= extent[1][0] || extent[0][1] >= extent[1][1];
	    };
	
	    function resizeFiltered (filter) {
	        var symbols = _chart.selectAll('.chart-body path.symbol').each(function (d) {
	            this.filtered = filter && filter.isFiltered(d.key);
	        });
	
	        dc.transition(symbols, _chart.transitionDuration()).attr('d', _symbol);
	    }
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	
	        _chart.redrawBrush(_chart.g());
	
	        if (_chart.brushIsEmpty(extent)) {
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.redrawGroup();
	            });
	
	            resizeFiltered(false);
	
	        } else {
	            var ranged2DFilter = dc.filters.RangedTwoDimensionalFilter(extent);
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.filter(ranged2DFilter);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	
	            resizeFiltered(ranged2DFilter);
	        }
	    };
	
	    _chart.setBrushY = function (gBrush) {
	        gBrush.call(_chart.brush().y(_chart.y()));
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A display of a single numeric value.
	 * Unlike other charts, you do not need to set a dimension. Instead a group object must be provided and
	 * a valueAccessor that returns a single value.
	 * @name numberDisplay
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * // create a number display under #chart-container1 element using the default global chart group
	 * var display1 = dc.numberDisplay('#chart-container1');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {NumberDisplay}
	 */
	dc.numberDisplay = function (parent, chartGroup) {
	    var SPAN_CLASS = 'number-display';
	    var _formatNumber = d3.format('.2s');
	    var _chart = dc.baseMixin({});
	    var _html = {one: '', some: '', none: ''};
	
	    // dimension not required
	    _chart._mandatoryAttributes(['group']);
	
	    /**
	     * Gets or sets an optional object specifying HTML templates to use depending on the number
	     * displayed.  The text `%number` will be replaced with the current value.
	     * - one: HTML template to use if the number is 1
	     * - zero: HTML template to use if the number is 0
	     * - some: HTML template to use otherwise
	     * @name html
	     * @memberof dc.numberDisplay
	     * @instance
	     * @example
	     * numberWidget.html({
	     *      one:'%number record',
	     *      some:'%number records',
	     *      none:'no records'})
	     * @param {{one:String, some:String, none:String}} [html={one: '', some: '', none: ''}]
	     * @returns {Chart}
	     */
	    _chart.html = function (html) {
	        if (!arguments.length) {
	            return _html;
	        }
	        if (html.none) {
	            _html.none = html.none;//if none available
	        } else if (html.one) {
	            _html.none = html.one;//if none not available use one
	        } else if (html.some) {
	            _html.none = html.some;//if none and one not available use some
	        }
	        if (html.one) {
	            _html.one = html.one;//if one available
	        } else if (html.some) {
	            _html.one = html.some;//if one not available use some
	        }
	        if (html.some) {
	            _html.some = html.some;//if some available
	        } else if (html.one) {
	            _html.some = html.one;//if some not available use one
	        }
	        return _chart;
	    };
	
	    /**
	     * Calculate and return the underlying value of the display
	     * @name value
	     * @memberof dc.numberDisplay
	     * @instance
	     * @returns {Number}
	     */
	    _chart.value = function () {
	        return _chart.data();
	    };
	
	    _chart.data(function (group) {
	        var valObj = group.value ? group.value() : group.top(1)[0];
	        return _chart.valueAccessor()(valObj);
	    });
	
	    _chart.transitionDuration(250); // good default
	
	    _chart._doRender = function () {
	        var newValue = _chart.value(),
	            span = _chart.selectAll('.' + SPAN_CLASS);
	
	        if (span.empty()) {
	            span = span.data([0])
	                .enter()
	                .append('span')
	                .attr('class', SPAN_CLASS);
	        }
	
	        span.transition()
	            .duration(_chart.transitionDuration())
	            .ease('quad-out-in')
	            .tween('text', function () {
	                var interp = d3.interpolateNumber(this.lastValue || 0, newValue);
	                this.lastValue = newValue;
	                return function (t) {
	                    var html = null, num = _chart.formatNumber()(interp(t));
	                    if (newValue === 0 && (_html.none !== '')) {
	                        html = _html.none;
	                    } else if (newValue === 1 && (_html.one !== '')) {
	                        html = _html.one;
	                    } else if (_html.some !== '') {
	                        html = _html.some;
	                    }
	                    this.innerHTML = html ? html.replace('%number', num) : num;
	                };
	            });
	    };
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set a function to format the value for the display.
	     * @name formatNumber
	     * @memberof dc.numberDisplay
	     * @instance
	     * @param {Function} [formatter=d3.format('.2s')]
	     * @returns {Chart}
	     */
	    _chart.formatNumber = function (formatter) {
	        if (!arguments.length) {
	            return _formatNumber;
	        }
	        _formatNumber = formatter;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A heat map is matrix that represents the values of two dimensions of data using colors.
	 * @name heatMap
	 * @memberof dc
	 * @mixes dc.colorMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a heat map under #chart-container1 element using the default global chart group
	 * var heatMap1 = dc.heatMap('#chart-container1');
	 * // create a heat map under #chart-container2 element using chart group A
	 * var heatMap2 = dc.heatMap('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {HeatMap}
	 */
	dc.heatMap = function (parent, chartGroup) {
	
	    var DEFAULT_BORDER_RADIUS = 6.75;
	
	    var _chartBody;
	
	    var _cols;
	    var _rows;
	    var _xBorderRadius = DEFAULT_BORDER_RADIUS;
	    var _yBorderRadius = DEFAULT_BORDER_RADIUS;
	
	    var _chart = dc.colorMixin(dc.marginMixin(dc.baseMixin({})));
	    _chart._mandatoryAttributes(['group']);
	    _chart.title(_chart.colorAccessor());
	
	    var _colsLabel = function (d) {
	        return d;
	    };
	    var _rowsLabel = function (d) {
	        return d;
	    };
	
	    /**
	     * Set or get the column label function. The chart class uses this function to render
	     * column labels on the X axis. It is passed the column name.
	     * @name colsLabel
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // the default label function just returns the name
	     * chart.colsLabel(function(d) { return d; });
	     * @param  {Function} [labelFunction=function(d) { return d; }]
	     * @returns {Chart}
	     */
	    _chart.colsLabel = function (labelFunction) {
	        if (!arguments.length) {
	            return _colsLabel;
	        }
	        _colsLabel = labelFunction;
	        return _chart;
	    };
	
	    /**
	     * Set or get the row label function. The chart class uses this function to render
	     * row labels on the Y axis. It is passed the row name.
	     * @name rowsLabel
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // the default label function just returns the name
	     * chart.rowsLabel(function(d) { return d; });
	     * @param  {Function} [labelFunction=function(d) { return d; }]
	     * @returns {Chart}
	     */
	    _chart.rowsLabel = function (labelFunction) {
	        if (!arguments.length) {
	            return _rowsLabel;
	        }
	        _rowsLabel = labelFunction;
	        return _chart;
	    };
	
	    var _xAxisOnClick = function (d) { filterAxis(0, d); };
	    var _yAxisOnClick = function (d) { filterAxis(1, d); };
	    var _boxOnClick = function (d) {
	        var filter = d.key;
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    function filterAxis (axis, value) {
	        var cellsOnAxis = _chart.selectAll('.box-group').filter(function (d) {
	            return d.key[axis] === value;
	        });
	        var unfilteredCellsOnAxis = cellsOnAxis.filter(function (d) {
	            return !_chart.hasFilter(d.key);
	        });
	        dc.events.trigger(function () {
	            if (unfilteredCellsOnAxis.empty()) {
	                cellsOnAxis.each(function (d) {
	                    _chart.filter(d.key);
	                });
	            } else {
	                unfilteredCellsOnAxis.each(function (d) {
	                    _chart.filter(d.key);
	                });
	            }
	            _chart.redrawGroup();
	        });
	    }
	
	    dc.override(_chart, 'filter', function (filter) {
	        if (!arguments.length) {
	            return _chart._filter();
	        }
	
	        return _chart._filter(dc.filters.TwoDimensionalFilter(filter));
	    });
	
	    function uniq (d, i, a) {
	        return !i || a[i - 1] !== d;
	    }
	
	    /**
	     * Gets or sets the values used to create the rows of the heatmap, as an array. By default, all
	     * the values will be fetched from the data using the value accessor, and they will be sorted in
	     * ascending order.
	     * @name rows
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Array<String|Number>} [rows]
	     * @returns {Chart}
	     */
	    _chart.rows = function (rows) {
	        if (arguments.length) {
	            _rows = rows;
	            return _chart;
	        }
	        if (_rows) {
	            return _rows;
	        }
	        var rowValues = _chart.data().map(_chart.valueAccessor());
	        rowValues.sort(d3.ascending);
	        return d3.scale.ordinal().domain(rowValues.filter(uniq));
	    };
	
	    /**
	     * Gets or sets the keys used to create the columns of the heatmap, as an array. By default, all
	     * the values will be fetched from the data using the key accessor, and they will be sorted in
	     * ascending order.
	     * @name cols
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Array<String|Number>} [cols]
	     * @returns {Chart}
	     */
	    _chart.cols = function (cols) {
	        if (arguments.length) {
	            _cols = cols;
	            return _chart;
	        }
	        if (_cols) {
	            return _cols;
	        }
	        var colValues = _chart.data().map(_chart.keyAccessor());
	        colValues.sort(d3.ascending);
	        return d3.scale.ordinal().domain(colValues.filter(uniq));
	    };
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _chartBody = _chart.svg()
	            .append('g')
	            .attr('class', 'heatmap')
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	
	        return _chart._doRedraw();
	    };
	
	    _chart._doRedraw = function () {
	        var rows = _chart.rows(),
	            cols = _chart.cols(),
	            rowCount = rows.domain().length,
	            colCount = cols.domain().length,
	            boxWidth = Math.floor(_chart.effectiveWidth() / colCount),
	            boxHeight = Math.floor(_chart.effectiveHeight() / rowCount);
	
	        cols.rangeRoundBands([0, _chart.effectiveWidth()]);
	        rows.rangeRoundBands([_chart.effectiveHeight(), 0]);
	
	        var boxes = _chartBody.selectAll('g.box-group').data(_chart.data(), function (d, i) {
	            return _chart.keyAccessor()(d, i) + '\0' + _chart.valueAccessor()(d, i);
	        });
	        var gEnter = boxes.enter().append('g')
	            .attr('class', 'box-group');
	
	        gEnter.append('rect')
	            .attr('class', 'heat-box')
	            .attr('fill', 'white')
	            .on('click', _chart.boxOnClick());
	
	        if (_chart.renderTitle()) {
	            gEnter.append('title');
	            boxes.selectAll('title').text(_chart.title());
	        }
	
	        dc.transition(boxes.selectAll('rect'), _chart.transitionDuration())
	            .attr('x', function (d, i) { return cols(_chart.keyAccessor()(d, i)); })
	            .attr('y', function (d, i) { return rows(_chart.valueAccessor()(d, i)); })
	            .attr('rx', _xBorderRadius)
	            .attr('ry', _yBorderRadius)
	            .attr('fill', _chart.getColor)
	            .attr('width', boxWidth)
	            .attr('height', boxHeight);
	
	        boxes.exit().remove();
	
	        var gCols = _chartBody.selectAll('g.cols');
	        if (gCols.empty()) {
	            gCols = _chartBody.append('g').attr('class', 'cols axis');
	        }
	        var gColsText = gCols.selectAll('text').data(cols.domain());
	        gColsText.enter().append('text')
	              .attr('x', function (d) { return cols(d) + boxWidth / 2; })
	              .style('text-anchor', 'middle')
	              .attr('y', _chart.effectiveHeight())
	              .attr('dy', 12)
	              .on('click', _chart.xAxisOnClick())
	              .text(_chart.colsLabel());
	        dc.transition(gColsText, _chart.transitionDuration())
	               .text(_chart.colsLabel())
	               .attr('x', function (d) { return cols(d) + boxWidth / 2; })
	               .attr('y', _chart.effectiveHeight());
	        gColsText.exit().remove();
	        var gRows = _chartBody.selectAll('g.rows');
	        if (gRows.empty()) {
	            gRows = _chartBody.append('g').attr('class', 'rows axis');
	        }
	        var gRowsText = gRows.selectAll('text').data(rows.domain());
	        gRowsText.enter().append('text')
	              .attr('dy', 6)
	              .style('text-anchor', 'end')
	              .attr('x', 0)
	              .attr('dx', -2)
	              .on('click', _chart.yAxisOnClick())
	              .text(_chart.rowsLabel());
	        dc.transition(gRowsText, _chart.transitionDuration())
	              .text(_chart.rowsLabel())
	              .attr('y', function (d) { return rows(d) + boxHeight / 2; });
	        gRowsText.exit().remove();
	
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.box-group').each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.box-group').each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when an individual cell is clicked in the heatmap.
	     * By default, filtering of the cell will be toggled.
	     * @name boxOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @returns {Chart}
	     */
	    _chart.boxOnClick = function (handler) {
	        if (!arguments.length) {
	            return _boxOnClick;
	        }
	        _boxOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when a column tick is clicked in the x axis.
	     * By default, if any cells in the column are unselected, the whole column will be selected,
	     * otherwise the whole column will be unselected.
	     * @name xAxisOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @returns {Chart}
	     */
	    _chart.xAxisOnClick = function (handler) {
	        if (!arguments.length) {
	            return _xAxisOnClick;
	        }
	        _xAxisOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when a row tick is clicked in the y axis.
	     * By default, if any cells in the row are unselected, the whole row will be selected,
	     * otherwise the whole row will be unselected.
	     * @name yAxisOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @returns {Chart}
	     */
	    _chart.yAxisOnClick = function (handler) {
	        if (!arguments.length) {
	            return _yAxisOnClick;
	        }
	        _yAxisOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the X border radius.  Set to 0 to get full rectangles.
	     * @name xBorderRadius
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Number} [xBorderRadius=6.75]
	     * @returns {Chart}
	     */
	    _chart.xBorderRadius = function (xBorderRadius) {
	        if (!arguments.length) {
	            return _xBorderRadius;
	        }
	        _xBorderRadius = xBorderRadius;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the Y border radius.  Set to 0 to get full rectangles.
	     * @name yBorderRadius
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Number} [yBorderRadius=6.75]
	     * @returns {Chart}
	     */
	    _chart.yBorderRadius = function (yBorderRadius) {
	        if (!arguments.length) {
	            return _yBorderRadius;
	        }
	        _yBorderRadius = yBorderRadius;
	        return _chart;
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	// https://github.com/d3/d3-plugins/blob/master/box/box.js
	(function () {
	
	    // Inspired by http://informationandvisualization.de/blog/box-plot
	    d3.box = function () {
	        var width = 1,
	            height = 1,
	            duration = 0,
	            domain = null,
	            value = Number,
	            whiskers = boxWhiskers,
	            quartiles = boxQuartiles,
	            tickFormat = null;
	
	        // For each small multiple…
	        function box (g) {
	            g.each(function (d, i) {
	                d = d.map(value).sort(d3.ascending);
	                var g = d3.select(this),
	                    n = d.length,
	                    min = d[0],
	                    max = d[n - 1];
	
	                // Compute quartiles. Must return exactly 3 elements.
	                var quartileData = d.quartiles = quartiles(d);
	
	                // Compute whiskers. Must return exactly 2 elements, or null.
	                var whiskerIndices = whiskers && whiskers.call(this, d, i),
	                    whiskerData = whiskerIndices && whiskerIndices.map(function (i) { return d[i]; });
	
	                // Compute outliers. If no whiskers are specified, all data are 'outliers'.
	                // We compute the outliers as indices, so that we can join across transitions!
	                var outlierIndices = whiskerIndices ?
	                    d3.range(0, whiskerIndices[0]).concat(d3.range(whiskerIndices[1] + 1, n)) : d3.range(n);
	
	                // Compute the new x-scale.
	                var x1 = d3.scale.linear()
	                    .domain(domain && domain.call(this, d, i) || [min, max])
	                    .range([height, 0]);
	
	                // Retrieve the old x-scale, if this is an update.
	                var x0 = this.__chart__ || d3.scale.linear()
	                    .domain([0, Infinity])
	                    .range(x1.range());
	
	                // Stash the new scale.
	                this.__chart__ = x1;
	
	                // Note: the box, median, and box tick elements are fixed in number,
	                // so we only have to handle enter and update. In contrast, the outliers
	                // and other elements are variable, so we need to exit them! Variable
	                // elements also fade in and out.
	
	                // Update center line: the vertical line spanning the whiskers.
	                var center = g.selectAll('line.center')
	                    .data(whiskerData ? [whiskerData] : []);
	
	                center.enter().insert('line', 'rect')
	                    .attr('class', 'center')
	                    .attr('x1', width / 2)
	                    .attr('y1', function (d) { return x0(d[0]); })
	                    .attr('x2', width / 2)
	                    .attr('y2', function (d) { return x0(d[1]); })
	                    .style('opacity', 1e-6)
	                  .transition()
	                    .duration(duration)
	                    .style('opacity', 1)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); });
	
	                center.transition()
	                    .duration(duration)
	                    .style('opacity', 1)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); });
	
	                center.exit().transition()
	                    .duration(duration)
	                    .style('opacity', 1e-6)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); })
	                    .remove();
	
	                // Update innerquartile box.
	                var box = g.selectAll('rect.box')
	                    .data([quartileData]);
	
	                box.enter().append('rect')
	                    .attr('class', 'box')
	                    .attr('x', 0)
	                    .attr('y', function (d) { return x0(d[2]); })
	                    .attr('width', width)
	                    .attr('height', function (d) { return x0(d[0]) - x0(d[2]); })
	                  .transition()
	                    .duration(duration)
	                    .attr('y', function (d) { return x1(d[2]); })
	                    .attr('height', function (d) { return x1(d[0]) - x1(d[2]); });
	
	                box.transition()
	                    .duration(duration)
	                    .attr('y', function (d) { return x1(d[2]); })
	                    .attr('height', function (d) { return x1(d[0]) - x1(d[2]); });
	
	                // Update median line.
	                var medianLine = g.selectAll('line.median')
	                    .data([quartileData[1]]);
	
	                medianLine.enter().append('line')
	                    .attr('class', 'median')
	                    .attr('x1', 0)
	                    .attr('y1', x0)
	                    .attr('x2', width)
	                    .attr('y2', x0)
	                    .transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1);
	
	                medianLine.transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1);
	
	                // Update whiskers.
	                var whisker = g.selectAll('line.whisker')
	                    .data(whiskerData || []);
	
	                whisker.enter().insert('line', 'circle, text')
	                    .attr('class', 'whisker')
	                    .attr('x1', 0)
	                    .attr('y1', x0)
	                    .attr('x2', width)
	                    .attr('y2', x0)
	                    .style('opacity', 1e-6)
	                  .transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1);
	
	                whisker.transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1);
	
	                whisker.exit().transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1e-6)
	                    .remove();
	
	                // Update outliers.
	                var outlier = g.selectAll('circle.outlier')
	                    .data(outlierIndices, Number);
	
	                outlier.enter().insert('circle', 'text')
	                    .attr('class', 'outlier')
	                    .attr('r', 5)
	                    .attr('cx', width / 2)
	                    .attr('cy', function (i) { return x0(d[i]); })
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1);
	
	                outlier.transition()
	                    .duration(duration)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1);
	
	                outlier.exit().transition()
	                    .duration(duration)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1e-6)
	                    .remove();
	
	                // Compute the tick format.
	                var format = tickFormat || x1.tickFormat(8);
	
	                // Update box ticks.
	                var boxTick = g.selectAll('text.box')
	                    .data(quartileData);
	
	                boxTick.enter().append('text')
	                    .attr('class', 'box')
	                    .attr('dy', '.3em')
	                    .attr('dx', function (d, i) { return i & 1 ? 6 : -6; })
	                    .attr('x', function (d, i) { return i & 1 ? width : 0; })
	                    .attr('y', x0)
	                    .attr('text-anchor', function (d, i) { return i & 1 ? 'start' : 'end'; })
	                    .text(format)
	                    .transition()
	                    .duration(duration)
	                    .attr('y', x1);
	
	                boxTick.transition()
	                    .duration(duration)
	                    .text(format)
	                    .attr('y', x1);
	
	                // Update whisker ticks. These are handled separately from the box
	                // ticks because they may or may not exist, and we want don't want
	                // to join box ticks pre-transition with whisker ticks post-.
	                var whiskerTick = g.selectAll('text.whisker')
	                    .data(whiskerData || []);
	
	                whiskerTick.enter().append('text')
	                    .attr('class', 'whisker')
	                    .attr('dy', '.3em')
	                    .attr('dx', 6)
	                    .attr('x', width)
	                    .attr('y', x0)
	                    .text(format)
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .attr('y', x1)
	                    .style('opacity', 1);
	
	                whiskerTick.transition()
	                    .duration(duration)
	                    .text(format)
	                    .attr('y', x1)
	                    .style('opacity', 1);
	
	                whiskerTick.exit().transition()
	                    .duration(duration)
	                    .attr('y', x1)
	                    .style('opacity', 1e-6)
	                    .remove();
	            });
	            d3.timer.flush();
	        }
	
	        box.width = function (x) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = x;
	            return box;
	        };
	
	        box.height = function (x) {
	            if (!arguments.length) {
	                return height;
	            }
	            height = x;
	            return box;
	        };
	
	        box.tickFormat = function (x) {
	            if (!arguments.length) {
	                return tickFormat;
	            }
	            tickFormat = x;
	            return box;
	        };
	
	        box.duration = function (x) {
	            if (!arguments.length) {
	                return duration;
	            }
	            duration = x;
	            return box;
	        };
	
	        box.domain = function (x) {
	            if (!arguments.length) {
	                return domain;
	            }
	            domain = x === null ? x : d3.functor(x);
	            return box;
	        };
	
	        box.value = function (x) {
	            if (!arguments.length) {
	                return value;
	            }
	            value = x;
	            return box;
	        };
	
	        box.whiskers = function (x) {
	            if (!arguments.length) {
	                return whiskers;
	            }
	            whiskers = x;
	            return box;
	        };
	
	        box.quartiles = function (x) {
	            if (!arguments.length) {
	                return quartiles;
	            }
	            quartiles = x;
	            return box;
	        };
	
	        return box;
	    };
	
	    function boxWhiskers (d) {
	        return [0, d.length - 1];
	    }
	
	    function boxQuartiles (d) {
	        return [
	            d3.quantile(d, 0.25),
	            d3.quantile(d, 0.5),
	            d3.quantile(d, 0.75)
	        ];
	    }
	
	})();
	
	/**
	 * A box plot is a chart that depicts numerical data via their quartile ranges.
	 * Examples:
	 * - [Nasdaq 100 Index](http://dc-js.github.com/dc.js/)
	 * - [Canadian City Crime Stats](http://dc-js.github.com/dc.js/crime/index.html)
	 * @name boxPlot
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a box plot under #chart-container1 element using the default global chart group
	 * var boxPlot1 = dc.boxPlot('#chart-container1');
	 * // create a box plot under #chart-container2 element using chart group A
	 * var boxPlot2 = dc.boxPlot('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.  If the bar chart is a sub-chart
	 * in a [Composite Chart](#composite-chart) then pass in the parent composite chart instance.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {BoxPlot}
	 */
	dc.boxPlot = function (parent, chartGroup) {
	    var _chart = dc.coordinateGridMixin({});
	
	    // Returns a function to compute the interquartile range.
	    function DEFAULT_WHISKERS_IQR (k) {
	        return function (d) {
	            var q1 = d.quartiles[0],
	                q3 = d.quartiles[2],
	                iqr = (q3 - q1) * k,
	                i = -1,
	                j = d.length;
	            do { ++i; } while (d[i] < q1 - iqr);
	            do { --j; } while (d[j] > q3 + iqr);
	            return [i, j];
	        };
	    }
	
	    var _whiskerIqrFactor = 1.5;
	    var _whiskersIqr = DEFAULT_WHISKERS_IQR;
	    var _whiskers = _whiskersIqr(_whiskerIqrFactor);
	
	    var _box = d3.box();
	    var _tickFormat = null;
	
	    var _boxWidth = function (innerChartWidth, xUnits) {
	        if (_chart.isOrdinal()) {
	            return _chart.x().rangeBand();
	        } else {
	            return innerChartWidth / (1 + _chart.boxPadding()) / xUnits;
	        }
	    };
	
	    // default padding to handle min/max whisker text
	    _chart.yAxisPadding(12);
	
	    // default to ordinal
	    _chart.x(d3.scale.ordinal());
	    _chart.xUnits(dc.units.ordinal);
	
	    // valueAccessor should return an array of values that can be coerced into numbers
	    // or if data is overloaded for a static array of arrays, it should be `Number`.
	    // Empty arrays are not included.
	    _chart.data(function (group) {
	        return group.all().map(function (d) {
	            d.map = function (accessor) { return accessor.call(d, d); };
	            return d;
	        }).filter(function (d) {
	            var values = _chart.valueAccessor()(d);
	            return values.length !== 0;
	        });
	    });
	
	    /**
	     * Get or set the spacing between boxes as a fraction of box size. Valid values are within 0-1.
	     * See the [d3 docs](https://github.com/mbostock/d3/wiki/Ordinal-Scales#wiki-ordinal_rangeBands)
	     * for a visual description of how the padding is applied.
	     * @name boxPadding
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number} [padding=0.8]
	     * @returns {Number}
	     */
	    _chart.boxPadding = _chart._rangeBandPadding;
	    _chart.boxPadding(0.8);
	
	    /**
	     * Get or set the outer padding on an ordinal box chart. This setting has no effect on non-ordinal charts
	     * or on charts with a custom `.boxWidth`. Will pad the width by `padding * barWidth` on each side of the chart.
	     * @name outerPadding
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number} [padding=0.5]
	     * @returns {Number}
	     */
	    _chart.outerPadding = _chart._outerRangeBandPadding;
	    _chart.outerPadding(0.5);
	
	    /**
	     * Get or set the numerical width of the boxplot box. The width may also be a function taking as
	     * parameters the chart width excluding the right and left margins, as well as the number of x
	     * units.
	     * @example
	     * // Using numerical parameter
	     * chart.boxWidth(10);
	     * // Using function
	     * chart.boxWidth((innerChartWidth, xUnits) { ... });
	     * @name boxWidth
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number|Function} [boxWidth=0.5]
	     * @returns {Number|Function}
	     */
	    _chart.boxWidth = function (boxWidth) {
	        if (!arguments.length) {
	            return _boxWidth;
	        }
	        _boxWidth = d3.functor(boxWidth);
	        return _chart;
	    };
	
	    var boxTransform = function (d, i) {
	        var xOffset = _chart.x()(_chart.keyAccessor()(d, i));
	        return 'translate(' + xOffset + ', 0)';
	    };
	
	    _chart._preprocessData = function () {
	        if (_chart.elasticX()) {
	            _chart.x().domain([]);
	        }
	    };
	
	    _chart.plotData = function () {
	        var _calculatedBoxWidth = _boxWidth(_chart.effectiveWidth(), _chart.xUnitCount());
	
	        _box.whiskers(_whiskers)
	            .width(_calculatedBoxWidth)
	            .height(_chart.effectiveHeight())
	            .value(_chart.valueAccessor())
	            .domain(_chart.y().domain())
	            .duration(_chart.transitionDuration())
	            .tickFormat(_tickFormat);
	
	        var boxesG = _chart.chartBodyG().selectAll('g.box').data(_chart.data(), function (d) { return d.key; });
	
	        renderBoxes(boxesG);
	        updateBoxes(boxesG);
	        removeBoxes(boxesG);
	
	        _chart.fadeDeselectedArea();
	    };
	
	    function renderBoxes (boxesG) {
	        var boxesGEnter = boxesG.enter().append('g');
	
	        boxesGEnter
	            .attr('class', 'box')
	            .attr('transform', boxTransform)
	            .call(_box)
	            .on('click', function (d) {
	                _chart.filter(d.key);
	                _chart.redrawGroup();
	            });
	    }
	
	    function updateBoxes (boxesG) {
	        dc.transition(boxesG, _chart.transitionDuration())
	            .attr('transform', boxTransform)
	            .call(_box)
	            .each(function () {
	                d3.select(this).select('rect.box').attr('fill', _chart.getColor);
	            });
	    }
	
	    function removeBoxes (boxesG) {
	        boxesG.exit().remove().call(_box);
	    }
	
	    _chart.fadeDeselectedArea = function () {
	        if (_chart.hasFilter()) {
	            _chart.g().selectAll('g.box').each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.g().selectAll('g.box').each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    _chart.yAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return d3.min(_chart.valueAccessor()(e));
	        });
	        return dc.utils.subtract(min, _chart.yAxisPadding());
	    };
	
	    _chart.yAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return d3.max(_chart.valueAccessor()(e));
	        });
	        return dc.utils.add(max, _chart.yAxisPadding());
	    };
	
	    /**
	     * Set the numerical format of the boxplot median, whiskers and quartile labels. Defaults to
	     * integer formatting.
	     * @example
	     * // format ticks to 2 decimal places
	     * chart.tickFormat(d3.format('.2f'));
	     * @name tickFormat
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Function} [tickFormat]
	     * @returns {Number|Function}
	     */
	    _chart.tickFormat = function (tickFormat) {
	        if (!arguments.length) {
	            return _tickFormat;
	        }
	        _tickFormat = tickFormat;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	// Renamed functions
	
	dc.abstractBubbleChart = dc.bubbleMixin;
	dc.baseChart = dc.baseMixin;
	dc.capped = dc.capMixin;
	dc.colorChart = dc.colorMixin;
	dc.coordinateGridChart = dc.coordinateGridMixin;
	dc.marginable = dc.marginMixin;
	dc.stackableChart = dc.stackMixin;
	
	// Expose d3 and crossfilter, so that clients in browserify
	// case can obtain them if they need them.
	dc.d3 = d3;
	dc.crossfilter = crossfilter;
	
	return dc;}
	    if(true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56), __webpack_require__(125)], __WEBPACK_AMD_DEFINE_FACTORY__ = (_dc), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if(typeof module === "object" && module.exports) {
	        var _d3 = require('d3');
	        var _crossfilter = require('crossfilter');
	        // When using npm + browserify, 'crossfilter' is a function,
	        // since package.json specifies index.js as main function, and it
	        // does special handling. When using bower + browserify,
	        // there's no main in bower.json (in fact, there's no bower.json),
	        // so we need to fix it.
	        if (typeof _crossfilter !== "function") {
	            _crossfilter = _crossfilter.crossfilter;
	        }
	        module.exports = _dc(_d3, _crossfilter);
	    } else {
	        this.dc = _dc(d3, crossfilter);
	    }
	}
	)();
	
	//# sourceMappingURL=dc.js.map

/***/ },
/* 1147 */,
/* 1148 */,
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2e90d5152ce92858b62ba053c7b9d2cb.woff";

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6ad396399f4022ccd1616cf11d0985be.woff";

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f42641eed834f7b97a9499362c6c8855.woff";

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "45b47f3e9c7d74b80f5c6e0a3c513b23.woff";

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "79515ad0788973c533405f7012dfeccd.woff";

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "697574b47bcfdd2c45e3e63c7380dd67.woff";

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f7c2b4b747b1a225eb8dee034134a1b0.eot";

/***/ },
/* 1156 */
1155,
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2980083682e94d33a66eef2e7d612519.svg";

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "706450d7bba6374ca02fe167d86685cb.ttf";

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "97493d3f11c0a3bd5cbd959f5d19b699.woff2";

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d9ee23d59d0e0e727b51368b458a0bff.woff";

/***/ },
/* 1161 */
/***/ function(module, exports) {

	"use strict";
	
	var create = function create(metadata, exports) {
	  return {
	    metadata: metadata,
	    exports: exports
	  };
	};
	
	module.exports = create;

/***/ },
/* 1162 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PluginStore = (function () {
	  function PluginStore() {
	    _classCallCheck(this, PluginStore);
	  }
	
	  _createClass(PluginStore, null, [{
	    key: "register",
	    value: function register(plugin) {
	      if (!window.plugins) {
	        window.plugins = [];
	      }
	      window.plugins.push(plugin);
	    }
	  }, {
	    key: "get",
	    value: function get() {
	      if (!window.plugins) {
	        window.plugins = [];
	      }
	      return window.plugins;
	    }
	  }, {
	    key: "exports",
	    value: function exports(entity) {
	      return [].concat.apply([], this.get().map(function (plugin) {
	        return plugin.exports && plugin.exports[entity] ? plugin.exports[entity] : [];
	      }));
	    }
	  }]);
	
	  return PluginStore;
	})();
	
	exports["default"] = PluginStore;
	module.exports = exports["default"];

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(28);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(643);
	
	var _ExecutionEnvironment = __webpack_require__(645);
	
	var _DOMUtils = __webpack_require__(640);
	
	var _DOMStateStorage = __webpack_require__(1267);
	
	var _createDOMHistory = __webpack_require__(1268);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(1273);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ? process.env.NODE_ENV !== 'production' ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    historyState = historyState || window.history.state || {};
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null, path);
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(224);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(626);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(224);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(642);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(224);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(1270);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(1163);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(1269);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(1271);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(1272);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(626);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(642);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(643);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(1164);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(1165);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ },
/* 1167 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI :data 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo( function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			} ) :
	
			// Support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			}
	} );
	} ) );


/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Effects 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Effects Core
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/category/effects-core/
	//>>demos: http://jqueryui.com/effect/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var dataSpace = "ui-effects-",
		dataSpaceStyle = "ui-effects-style",
		dataSpaceAnimated = "ui-effects-animated",
	
		// Create a local jQuery because jQuery Color relies on it and the
		// global may not exist with AMD and a custom build (#10199)
		jQuery = $;
	
	$.effects = {
		effect: {}
	};
	
	/*!
	 * jQuery Color Animations v2.1.2
	 * https://github.com/jquery/jquery-color
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * Date: Wed Jan 16 08:47:09 2013 -0600
	 */
	( function( jQuery, undefined ) {
	
		var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
			"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
	
		// Plusequals test for += 100 -= 100
		rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
	
		// A set of RE's that can match strings and generate color tuples.
		stringParsers = [ {
				re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ],
						execResult[ 3 ],
						execResult[ 4 ]
					];
				}
			}, {
				re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ] * 2.55,
						execResult[ 2 ] * 2.55,
						execResult[ 3 ] * 2.55,
						execResult[ 4 ]
					];
				}
			}, {
	
				// This regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ], 16 )
					];
				}
			}, {
	
				// This regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
					];
				}
			}, {
				re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				space: "hsla",
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ] / 100,
						execResult[ 3 ] / 100,
						execResult[ 4 ]
					];
				}
			} ],
	
		// JQuery.Color( )
		color = jQuery.Color = function( color, green, blue, alpha ) {
			return new jQuery.Color.fn.parse( color, green, blue, alpha );
		},
		spaces = {
			rgba: {
				props: {
					red: {
						idx: 0,
						type: "byte"
					},
					green: {
						idx: 1,
						type: "byte"
					},
					blue: {
						idx: 2,
						type: "byte"
					}
				}
			},
	
			hsla: {
				props: {
					hue: {
						idx: 0,
						type: "degrees"
					},
					saturation: {
						idx: 1,
						type: "percent"
					},
					lightness: {
						idx: 2,
						type: "percent"
					}
				}
			}
		},
		propTypes = {
			"byte": {
				floor: true,
				max: 255
			},
			"percent": {
				max: 1
			},
			"degrees": {
				mod: 360,
				floor: true
			}
		},
		support = color.support = {},
	
		// Element for support tests
		supportElem = jQuery( "<p>" )[ 0 ],
	
		// Colors = jQuery.Color.names
		colors,
	
		// Local aliases of functions called often
		each = jQuery.each;
	
	// Determine rgba support immediately
	supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
	support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;
	
	// Define cache name and alpha properties
	// for rgba and hsla spaces
	each( spaces, function( spaceName, space ) {
		space.cache = "_" + spaceName;
		space.props.alpha = {
			idx: 3,
			type: "percent",
			def: 1
		};
	} );
	
	function clamp( value, prop, allowEmpty ) {
		var type = propTypes[ prop.type ] || {};
	
		if ( value == null ) {
			return ( allowEmpty || !prop.def ) ? null : prop.def;
		}
	
		// ~~ is an short way of doing floor for positive numbers
		value = type.floor ? ~~value : parseFloat( value );
	
		// IE will pass in empty strings as value for alpha,
		// which will hit this case
		if ( isNaN( value ) ) {
			return prop.def;
		}
	
		if ( type.mod ) {
	
			// We add mod before modding to make sure that negatives values
			// get converted properly: -10 -> 350
			return ( value + type.mod ) % type.mod;
		}
	
		// For now all property types without mod have min and max
		return 0 > value ? 0 : type.max < value ? type.max : value;
	}
	
	function stringParse( string ) {
		var inst = color(),
			rgba = inst._rgba = [];
	
		string = string.toLowerCase();
	
		each( stringParsers, function( i, parser ) {
			var parsed,
				match = parser.re.exec( string ),
				values = match && parser.parse( match ),
				spaceName = parser.space || "rgba";
	
			if ( values ) {
				parsed = inst[ spaceName ]( values );
	
				// If this was an rgba parse the assignment might happen twice
				// oh well....
				inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
				rgba = inst._rgba = parsed._rgba;
	
				// Exit each( stringParsers ) here because we matched
				return false;
			}
		} );
	
		// Found a stringParser that handled it
		if ( rgba.length ) {
	
			// If this came from a parsed string, force "transparent" when alpha is 0
			// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
			if ( rgba.join() === "0,0,0,0" ) {
				jQuery.extend( rgba, colors.transparent );
			}
			return inst;
		}
	
		// Named colors
		return colors[ string ];
	}
	
	color.fn = jQuery.extend( color.prototype, {
		parse: function( red, green, blue, alpha ) {
			if ( red === undefined ) {
				this._rgba = [ null, null, null, null ];
				return this;
			}
			if ( red.jquery || red.nodeType ) {
				red = jQuery( red ).css( green );
				green = undefined;
			}
	
			var inst = this,
				type = jQuery.type( red ),
				rgba = this._rgba = [];
	
			// More than 1 argument specified - assume ( red, green, blue, alpha )
			if ( green !== undefined ) {
				red = [ red, green, blue, alpha ];
				type = "array";
			}
	
			if ( type === "string" ) {
				return this.parse( stringParse( red ) || colors._default );
			}
	
			if ( type === "array" ) {
				each( spaces.rgba.props, function( key, prop ) {
					rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
				} );
				return this;
			}
	
			if ( type === "object" ) {
				if ( red instanceof color ) {
					each( spaces, function( spaceName, space ) {
						if ( red[ space.cache ] ) {
							inst[ space.cache ] = red[ space.cache ].slice();
						}
					} );
				} else {
					each( spaces, function( spaceName, space ) {
						var cache = space.cache;
						each( space.props, function( key, prop ) {
	
							// If the cache doesn't exist, and we know how to convert
							if ( !inst[ cache ] && space.to ) {
	
								// If the value was null, we don't need to copy it
								// if the key was alpha, we don't need to copy it either
								if ( key === "alpha" || red[ key ] == null ) {
									return;
								}
								inst[ cache ] = space.to( inst._rgba );
							}
	
							// This is the only case where we allow nulls for ALL properties.
							// call clamp with alwaysAllowEmpty
							inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
						} );
	
						// Everything defined but alpha?
						if ( inst[ cache ] &&
								jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
	
							// Use the default of 1
							inst[ cache ][ 3 ] = 1;
							if ( space.from ) {
								inst._rgba = space.from( inst[ cache ] );
							}
						}
					} );
				}
				return this;
			}
		},
		is: function( compare ) {
			var is = color( compare ),
				same = true,
				inst = this;
	
			each( spaces, function( _, space ) {
				var localCache,
					isCache = is[ space.cache ];
				if ( isCache ) {
					localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
					each( space.props, function( _, prop ) {
						if ( isCache[ prop.idx ] != null ) {
							same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
							return same;
						}
					} );
				}
				return same;
			} );
			return same;
		},
		_space: function() {
			var used = [],
				inst = this;
			each( spaces, function( spaceName, space ) {
				if ( inst[ space.cache ] ) {
					used.push( spaceName );
				}
			} );
			return used.pop();
		},
		transition: function( other, distance ) {
			var end = color( other ),
				spaceName = end._space(),
				space = spaces[ spaceName ],
				startColor = this.alpha() === 0 ? color( "transparent" ) : this,
				start = startColor[ space.cache ] || space.to( startColor._rgba ),
				result = start.slice();
	
			end = end[ space.cache ];
			each( space.props, function( key, prop ) {
				var index = prop.idx,
					startValue = start[ index ],
					endValue = end[ index ],
					type = propTypes[ prop.type ] || {};
	
				// If null, don't override start value
				if ( endValue === null ) {
					return;
				}
	
				// If null - use end
				if ( startValue === null ) {
					result[ index ] = endValue;
				} else {
					if ( type.mod ) {
						if ( endValue - startValue > type.mod / 2 ) {
							startValue += type.mod;
						} else if ( startValue - endValue > type.mod / 2 ) {
							startValue -= type.mod;
						}
					}
					result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
				}
			} );
			return this[ spaceName ]( result );
		},
		blend: function( opaque ) {
	
			// If we are already opaque - return ourself
			if ( this._rgba[ 3 ] === 1 ) {
				return this;
			}
	
			var rgb = this._rgba.slice(),
				a = rgb.pop(),
				blend = color( opaque )._rgba;
	
			return color( jQuery.map( rgb, function( v, i ) {
				return ( 1 - a ) * blend[ i ] + a * v;
			} ) );
		},
		toRgbaString: function() {
			var prefix = "rgba(",
				rgba = jQuery.map( this._rgba, function( v, i ) {
					return v == null ? ( i > 2 ? 1 : 0 ) : v;
				} );
	
			if ( rgba[ 3 ] === 1 ) {
				rgba.pop();
				prefix = "rgb(";
			}
	
			return prefix + rgba.join() + ")";
		},
		toHslaString: function() {
			var prefix = "hsla(",
				hsla = jQuery.map( this.hsla(), function( v, i ) {
					if ( v == null ) {
						v = i > 2 ? 1 : 0;
					}
	
					// Catch 1 and 2
					if ( i && i < 3 ) {
						v = Math.round( v * 100 ) + "%";
					}
					return v;
				} );
	
			if ( hsla[ 3 ] === 1 ) {
				hsla.pop();
				prefix = "hsl(";
			}
			return prefix + hsla.join() + ")";
		},
		toHexString: function( includeAlpha ) {
			var rgba = this._rgba.slice(),
				alpha = rgba.pop();
	
			if ( includeAlpha ) {
				rgba.push( ~~( alpha * 255 ) );
			}
	
			return "#" + jQuery.map( rgba, function( v ) {
	
				// Default to 0 when nulls exist
				v = ( v || 0 ).toString( 16 );
				return v.length === 1 ? "0" + v : v;
			} ).join( "" );
		},
		toString: function() {
			return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
		}
	} );
	color.fn.parse.prototype = color.fn;
	
	// Hsla conversions adapted from:
	// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021
	
	function hue2rgb( p, q, h ) {
		h = ( h + 1 ) % 1;
		if ( h * 6 < 1 ) {
			return p + ( q - p ) * h * 6;
		}
		if ( h * 2 < 1 ) {
			return q;
		}
		if ( h * 3 < 2 ) {
			return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
		}
		return p;
	}
	
	spaces.hsla.to = function( rgba ) {
		if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
			return [ null, null, null, rgba[ 3 ] ];
		}
		var r = rgba[ 0 ] / 255,
			g = rgba[ 1 ] / 255,
			b = rgba[ 2 ] / 255,
			a = rgba[ 3 ],
			max = Math.max( r, g, b ),
			min = Math.min( r, g, b ),
			diff = max - min,
			add = max + min,
			l = add * 0.5,
			h, s;
	
		if ( min === max ) {
			h = 0;
		} else if ( r === max ) {
			h = ( 60 * ( g - b ) / diff ) + 360;
		} else if ( g === max ) {
			h = ( 60 * ( b - r ) / diff ) + 120;
		} else {
			h = ( 60 * ( r - g ) / diff ) + 240;
		}
	
		// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
		// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
		if ( diff === 0 ) {
			s = 0;
		} else if ( l <= 0.5 ) {
			s = diff / add;
		} else {
			s = diff / ( 2 - add );
		}
		return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
	};
	
	spaces.hsla.from = function( hsla ) {
		if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
			return [ null, null, null, hsla[ 3 ] ];
		}
		var h = hsla[ 0 ] / 360,
			s = hsla[ 1 ],
			l = hsla[ 2 ],
			a = hsla[ 3 ],
			q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
			p = 2 * l - q;
	
		return [
			Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
			Math.round( hue2rgb( p, q, h ) * 255 ),
			Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
			a
		];
	};
	
	each( spaces, function( spaceName, space ) {
		var props = space.props,
			cache = space.cache,
			to = space.to,
			from = space.from;
	
		// Makes rgba() and hsla()
		color.fn[ spaceName ] = function( value ) {
	
			// Generate a cache for this space if it doesn't exist
			if ( to && !this[ cache ] ) {
				this[ cache ] = to( this._rgba );
			}
			if ( value === undefined ) {
				return this[ cache ].slice();
			}
	
			var ret,
				type = jQuery.type( value ),
				arr = ( type === "array" || type === "object" ) ? value : arguments,
				local = this[ cache ].slice();
	
			each( props, function( key, prop ) {
				var val = arr[ type === "object" ? key : prop.idx ];
				if ( val == null ) {
					val = local[ prop.idx ];
				}
				local[ prop.idx ] = clamp( val, prop );
			} );
	
			if ( from ) {
				ret = color( from( local ) );
				ret[ cache ] = local;
				return ret;
			} else {
				return color( local );
			}
		};
	
		// Makes red() green() blue() alpha() hue() saturation() lightness()
		each( props, function( key, prop ) {
	
			// Alpha is included in more than one space
			if ( color.fn[ key ] ) {
				return;
			}
			color.fn[ key ] = function( value ) {
				var vtype = jQuery.type( value ),
					fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
					local = this[ fn ](),
					cur = local[ prop.idx ],
					match;
	
				if ( vtype === "undefined" ) {
					return cur;
				}
	
				if ( vtype === "function" ) {
					value = value.call( this, cur );
					vtype = jQuery.type( value );
				}
				if ( value == null && prop.empty ) {
					return this;
				}
				if ( vtype === "string" ) {
					match = rplusequals.exec( value );
					if ( match ) {
						value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
					}
				}
				local[ prop.idx ] = value;
				return this[ fn ]( local );
			};
		} );
	} );
	
	// Add cssHook and .fx.step function for each named hook.
	// accept a space separated string of properties
	color.hook = function( hook ) {
		var hooks = hook.split( " " );
		each( hooks, function( i, hook ) {
			jQuery.cssHooks[ hook ] = {
				set: function( elem, value ) {
					var parsed, curElem,
						backgroundColor = "";
	
					if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
							( parsed = stringParse( value ) ) ) ) {
						value = color( parsed || value );
						if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
							curElem = hook === "backgroundColor" ? elem.parentNode : elem;
							while (
								( backgroundColor === "" || backgroundColor === "transparent" ) &&
								curElem && curElem.style
							) {
								try {
									backgroundColor = jQuery.css( curElem, "backgroundColor" );
									curElem = curElem.parentNode;
								} catch ( e ) {
								}
							}
	
							value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
								backgroundColor :
								"_default" );
						}
	
						value = value.toRgbaString();
					}
					try {
						elem.style[ hook ] = value;
					} catch ( e ) {
	
						// Wrapped to prevent IE from throwing errors on "invalid" values like
						// 'auto' or 'inherit'
					}
				}
			};
			jQuery.fx.step[ hook ] = function( fx ) {
				if ( !fx.colorInit ) {
					fx.start = color( fx.elem, hook );
					fx.end = color( fx.end );
					fx.colorInit = true;
				}
				jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
			};
		} );
	
	};
	
	color.hook( stepHooks );
	
	jQuery.cssHooks.borderColor = {
		expand: function( value ) {
			var expanded = {};
	
			each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
				expanded[ "border" + part + "Color" ] = value;
			} );
			return expanded;
		}
	};
	
	// Basic color names only.
	// Usage of any of the other color names requires adding yourself or including
	// jquery.color.svg-names.js.
	colors = jQuery.Color.names = {
	
		// 4.1. Basic color keywords
		aqua: "#00ffff",
		black: "#000000",
		blue: "#0000ff",
		fuchsia: "#ff00ff",
		gray: "#808080",
		green: "#008000",
		lime: "#00ff00",
		maroon: "#800000",
		navy: "#000080",
		olive: "#808000",
		purple: "#800080",
		red: "#ff0000",
		silver: "#c0c0c0",
		teal: "#008080",
		white: "#ffffff",
		yellow: "#ffff00",
	
		// 4.2.3. "transparent" color keyword
		transparent: [ null, null, null, 0 ],
	
		_default: "#ffffff"
	};
	
	} )( jQuery );
	
	/******************************************************************************/
	/****************************** CLASS ANIMATIONS ******************************/
	/******************************************************************************/
	( function() {
	
	var classAnimationActions = [ "add", "remove", "toggle" ],
		shorthandStyles = {
			border: 1,
			borderBottom: 1,
			borderColor: 1,
			borderLeft: 1,
			borderRight: 1,
			borderTop: 1,
			borderWidth: 1,
			margin: 1,
			padding: 1
		};
	
	$.each(
		[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
		function( _, prop ) {
			$.fx.step[ prop ] = function( fx ) {
				if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
					jQuery.style( fx.elem, prop, fx.end );
					fx.setAttr = true;
				}
			};
		}
	);
	
	function getElementStyles( elem ) {
		var key, len,
			style = elem.ownerDocument.defaultView ?
				elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
				elem.currentStyle,
			styles = {};
	
		if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
			len = style.length;
			while ( len-- ) {
				key = style[ len ];
				if ( typeof style[ key ] === "string" ) {
					styles[ $.camelCase( key ) ] = style[ key ];
				}
			}
	
		// Support: Opera, IE <9
		} else {
			for ( key in style ) {
				if ( typeof style[ key ] === "string" ) {
					styles[ key ] = style[ key ];
				}
			}
		}
	
		return styles;
	}
	
	function styleDifference( oldStyle, newStyle ) {
		var diff = {},
			name, value;
	
		for ( name in newStyle ) {
			value = newStyle[ name ];
			if ( oldStyle[ name ] !== value ) {
				if ( !shorthandStyles[ name ] ) {
					if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
						diff[ name ] = value;
					}
				}
			}
		}
	
		return diff;
	}
	
	// Support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	$.effects.animateClass = function( value, duration, easing, callback ) {
		var o = $.speed( duration, easing, callback );
	
		return this.queue( function() {
			var animated = $( this ),
				baseClass = animated.attr( "class" ) || "",
				applyClassChange,
				allAnimations = o.children ? animated.find( "*" ).addBack() : animated;
	
			// Map the animated objects to store the original styles.
			allAnimations = allAnimations.map( function() {
				var el = $( this );
				return {
					el: el,
					start: getElementStyles( this )
				};
			} );
	
			// Apply class change
			applyClassChange = function() {
				$.each( classAnimationActions, function( i, action ) {
					if ( value[ action ] ) {
						animated[ action + "Class" ]( value[ action ] );
					}
				} );
			};
			applyClassChange();
	
			// Map all animated objects again - calculate new styles and diff
			allAnimations = allAnimations.map( function() {
				this.end = getElementStyles( this.el[ 0 ] );
				this.diff = styleDifference( this.start, this.end );
				return this;
			} );
	
			// Apply original class
			animated.attr( "class", baseClass );
	
			// Map all animated objects again - this time collecting a promise
			allAnimations = allAnimations.map( function() {
				var styleInfo = this,
					dfd = $.Deferred(),
					opts = $.extend( {}, o, {
						queue: false,
						complete: function() {
							dfd.resolve( styleInfo );
						}
					} );
	
				this.el.animate( this.diff, opts );
				return dfd.promise();
			} );
	
			// Once all animations have completed:
			$.when.apply( $, allAnimations.get() ).done( function() {
	
				// Set the final class
				applyClassChange();
	
				// For each animated element,
				// clear all css properties that were animated
				$.each( arguments, function() {
					var el = this.el;
					$.each( this.diff, function( key ) {
						el.css( key, "" );
					} );
				} );
	
				// This is guarnteed to be there if you use jQuery.speed()
				// it also handles dequeuing the next anim...
				o.complete.call( animated[ 0 ] );
			} );
		} );
	};
	
	$.fn.extend( {
		addClass: ( function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return speed ?
					$.effects.animateClass.call( this,
						{ add: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		} )( $.fn.addClass ),
	
		removeClass: ( function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return arguments.length > 1 ?
					$.effects.animateClass.call( this,
						{ remove: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		} )( $.fn.removeClass ),
	
		toggleClass: ( function( orig ) {
			return function( classNames, force, speed, easing, callback ) {
				if ( typeof force === "boolean" || force === undefined ) {
					if ( !speed ) {
	
						// Without speed parameter
						return orig.apply( this, arguments );
					} else {
						return $.effects.animateClass.call( this,
							( force ? { add: classNames } : { remove: classNames } ),
							speed, easing, callback );
					}
				} else {
	
					// Without force parameter
					return $.effects.animateClass.call( this,
						{ toggle: classNames }, force, speed, easing );
				}
			};
		} )( $.fn.toggleClass ),
	
		switchClass: function( remove, add, speed, easing, callback ) {
			return $.effects.animateClass.call( this, {
				add: add,
				remove: remove
			}, speed, easing, callback );
		}
	} );
	
	} )();
	
	/******************************************************************************/
	/*********************************** EFFECTS **********************************/
	/******************************************************************************/
	
	( function() {
	
	if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
		$.expr.filters.animated = ( function( orig ) {
			return function( elem ) {
				return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
			};
		} )( $.expr.filters.animated );
	}
	
	if ( $.uiBackCompat !== false ) {
		$.extend( $.effects, {
	
			// Saves a set of properties in a data storage
			save: function( element, set ) {
				var i = 0, length = set.length;
				for ( ; i < length; i++ ) {
					if ( set[ i ] !== null ) {
						element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
					}
				}
			},
	
			// Restores a set of previously saved properties from a data storage
			restore: function( element, set ) {
				var val, i = 0, length = set.length;
				for ( ; i < length; i++ ) {
					if ( set[ i ] !== null ) {
						val = element.data( dataSpace + set[ i ] );
						element.css( set[ i ], val );
					}
				}
			},
	
			setMode: function( el, mode ) {
				if ( mode === "toggle" ) {
					mode = el.is( ":hidden" ) ? "show" : "hide";
				}
				return mode;
			},
	
			// Wraps the element around a wrapper that copies position properties
			createWrapper: function( element ) {
	
				// If the element is already wrapped, return it
				if ( element.parent().is( ".ui-effects-wrapper" ) ) {
					return element.parent();
				}
	
				// Wrap the element
				var props = {
						width: element.outerWidth( true ),
						height: element.outerHeight( true ),
						"float": element.css( "float" )
					},
					wrapper = $( "<div></div>" )
						.addClass( "ui-effects-wrapper" )
						.css( {
							fontSize: "100%",
							background: "transparent",
							border: "none",
							margin: 0,
							padding: 0
						} ),
	
					// Store the size in case width/height are defined in % - Fixes #5245
					size = {
						width: element.width(),
						height: element.height()
					},
					active = document.activeElement;
	
				// Support: Firefox
				// Firefox incorrectly exposes anonymous content
				// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
				try {
					active.id;
				} catch ( e ) {
					active = document.body;
				}
	
				element.wrap( wrapper );
	
				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
	
				// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
				// lose the reference to the wrapped element
				wrapper = element.parent();
	
				// Transfer positioning properties to the wrapper
				if ( element.css( "position" ) === "static" ) {
					wrapper.css( { position: "relative" } );
					element.css( { position: "relative" } );
				} else {
					$.extend( props, {
						position: element.css( "position" ),
						zIndex: element.css( "z-index" )
					} );
					$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
						props[ pos ] = element.css( pos );
						if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
							props[ pos ] = "auto";
						}
					} );
					element.css( {
						position: "relative",
						top: 0,
						left: 0,
						right: "auto",
						bottom: "auto"
					} );
				}
				element.css( size );
	
				return wrapper.css( props ).show();
			},
	
			removeWrapper: function( element ) {
				var active = document.activeElement;
	
				if ( element.parent().is( ".ui-effects-wrapper" ) ) {
					element.parent().replaceWith( element );
	
					// Fixes #7595 - Elements lose focus when wrapped.
					if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
						$( active ).trigger( "focus" );
					}
				}
	
				return element;
			}
		} );
	}
	
	$.extend( $.effects, {
		version: "1.12.1",
	
		define: function( name, mode, effect ) {
			if ( !effect ) {
				effect = mode;
				mode = "effect";
			}
	
			$.effects.effect[ name ] = effect;
			$.effects.effect[ name ].mode = mode;
	
			return effect;
		},
	
		scaledDimensions: function( element, percent, direction ) {
			if ( percent === 0 ) {
				return {
					height: 0,
					width: 0,
					outerHeight: 0,
					outerWidth: 0
				};
			}
	
			var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
				y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;
	
			return {
				height: element.height() * y,
				width: element.width() * x,
				outerHeight: element.outerHeight() * y,
				outerWidth: element.outerWidth() * x
			};
	
		},
	
		clipToBox: function( animation ) {
			return {
				width: animation.clip.right - animation.clip.left,
				height: animation.clip.bottom - animation.clip.top,
				left: animation.clip.left,
				top: animation.clip.top
			};
		},
	
		// Injects recently queued functions to be first in line (after "inprogress")
		unshift: function( element, queueLength, count ) {
			var queue = element.queue();
	
			if ( queueLength > 1 ) {
				queue.splice.apply( queue,
					[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
			}
			element.dequeue();
		},
	
		saveStyle: function( element ) {
			element.data( dataSpaceStyle, element[ 0 ].style.cssText );
		},
	
		restoreStyle: function( element ) {
			element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
			element.removeData( dataSpaceStyle );
		},
	
		mode: function( element, mode ) {
			var hidden = element.is( ":hidden" );
	
			if ( mode === "toggle" ) {
				mode = hidden ? "show" : "hide";
			}
			if ( hidden ? mode === "hide" : mode === "show" ) {
				mode = "none";
			}
			return mode;
		},
	
		// Translates a [top,left] array into a baseline value
		getBaseline: function( origin, original ) {
			var y, x;
	
			switch ( origin[ 0 ] ) {
			case "top":
				y = 0;
				break;
			case "middle":
				y = 0.5;
				break;
			case "bottom":
				y = 1;
				break;
			default:
				y = origin[ 0 ] / original.height;
			}
	
			switch ( origin[ 1 ] ) {
			case "left":
				x = 0;
				break;
			case "center":
				x = 0.5;
				break;
			case "right":
				x = 1;
				break;
			default:
				x = origin[ 1 ] / original.width;
			}
	
			return {
				x: x,
				y: y
			};
		},
	
		// Creates a placeholder element so that the original element can be made absolute
		createPlaceholder: function( element ) {
			var placeholder,
				cssPosition = element.css( "position" ),
				position = element.position();
	
			// Lock in margins first to account for form elements, which
			// will change margin if you explicitly set height
			// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
			// Support: Safari
			element.css( {
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() );
	
			if ( /^(static|relative)/.test( cssPosition ) ) {
				cssPosition = "absolute";
	
				placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {
	
					// Convert inline to inline block to account for inline elements
					// that turn to inline block based on content (like img)
					display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
						"inline-block" :
						"block",
					visibility: "hidden",
	
					// Margins need to be set to account for margin collapse
					marginTop: element.css( "marginTop" ),
					marginBottom: element.css( "marginBottom" ),
					marginLeft: element.css( "marginLeft" ),
					marginRight: element.css( "marginRight" ),
					"float": element.css( "float" )
				} )
				.outerWidth( element.outerWidth() )
				.outerHeight( element.outerHeight() )
				.addClass( "ui-effects-placeholder" );
	
				element.data( dataSpace + "placeholder", placeholder );
			}
	
			element.css( {
				position: cssPosition,
				left: position.left,
				top: position.top
			} );
	
			return placeholder;
		},
	
		removePlaceholder: function( element ) {
			var dataKey = dataSpace + "placeholder",
					placeholder = element.data( dataKey );
	
			if ( placeholder ) {
				placeholder.remove();
				element.removeData( dataKey );
			}
		},
	
		// Removes a placeholder if it exists and restores
		// properties that were modified during placeholder creation
		cleanUp: function( element ) {
			$.effects.restoreStyle( element );
			$.effects.removePlaceholder( element );
		},
	
		setTransition: function( element, list, factor, value ) {
			value = value || {};
			$.each( list, function( i, x ) {
				var unit = element.cssUnit( x );
				if ( unit[ 0 ] > 0 ) {
					value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
				}
			} );
			return value;
		}
	} );
	
	// Return an effect options object for the given parameters:
	function _normalizeArguments( effect, options, speed, callback ) {
	
		// Allow passing all options as the first parameter
		if ( $.isPlainObject( effect ) ) {
			options = effect;
			effect = effect.effect;
		}
	
		// Convert to an object
		effect = { effect: effect };
	
		// Catch (effect, null, ...)
		if ( options == null ) {
			options = {};
		}
	
		// Catch (effect, callback)
		if ( $.isFunction( options ) ) {
			callback = options;
			speed = null;
			options = {};
		}
	
		// Catch (effect, speed, ?)
		if ( typeof options === "number" || $.fx.speeds[ options ] ) {
			callback = speed;
			speed = options;
			options = {};
		}
	
		// Catch (effect, options, callback)
		if ( $.isFunction( speed ) ) {
			callback = speed;
			speed = null;
		}
	
		// Add options to effect
		if ( options ) {
			$.extend( effect, options );
		}
	
		speed = speed || options.duration;
		effect.duration = $.fx.off ? 0 :
			typeof speed === "number" ? speed :
			speed in $.fx.speeds ? $.fx.speeds[ speed ] :
			$.fx.speeds._default;
	
		effect.complete = callback || options.complete;
	
		return effect;
	}
	
	function standardAnimationOption( option ) {
	
		// Valid standard speeds (nothing, number, named speed)
		if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
			return true;
		}
	
		// Invalid strings - treat as "normal" speed
		if ( typeof option === "string" && !$.effects.effect[ option ] ) {
			return true;
		}
	
		// Complete callback
		if ( $.isFunction( option ) ) {
			return true;
		}
	
		// Options hash (but not naming an effect)
		if ( typeof option === "object" && !option.effect ) {
			return true;
		}
	
		// Didn't match any standard API
		return false;
	}
	
	$.fn.extend( {
		effect: function( /* effect, options, speed, callback */ ) {
			var args = _normalizeArguments.apply( this, arguments ),
				effectMethod = $.effects.effect[ args.effect ],
				defaultMode = effectMethod.mode,
				queue = args.queue,
				queueName = queue || "fx",
				complete = args.complete,
				mode = args.mode,
				modes = [],
				prefilter = function( next ) {
					var el = $( this ),
						normalizedMode = $.effects.mode( el, mode ) || defaultMode;
	
					// Sentinel for duck-punching the :animated psuedo-selector
					el.data( dataSpaceAnimated, true );
	
					// Save effect mode for later use,
					// we can't just call $.effects.mode again later,
					// as the .show() below destroys the initial state
					modes.push( normalizedMode );
	
					// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
					if ( defaultMode && ( normalizedMode === "show" ||
							( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
						el.show();
					}
	
					if ( !defaultMode || normalizedMode !== "none" ) {
						$.effects.saveStyle( el );
					}
	
					if ( $.isFunction( next ) ) {
						next();
					}
				};
	
			if ( $.fx.off || !effectMethod ) {
	
				// Delegate to the original method (e.g., .show()) if possible
				if ( mode ) {
					return this[ mode ]( args.duration, complete );
				} else {
					return this.each( function() {
						if ( complete ) {
							complete.call( this );
						}
					} );
				}
			}
	
			function run( next ) {
				var elem = $( this );
	
				function cleanup() {
					elem.removeData( dataSpaceAnimated );
	
					$.effects.cleanUp( elem );
	
					if ( args.mode === "hide" ) {
						elem.hide();
					}
	
					done();
				}
	
				function done() {
					if ( $.isFunction( complete ) ) {
						complete.call( elem[ 0 ] );
					}
	
					if ( $.isFunction( next ) ) {
						next();
					}
				}
	
				// Override mode option on a per element basis,
				// as toggle can be either show or hide depending on element state
				args.mode = modes.shift();
	
				if ( $.uiBackCompat !== false && !defaultMode ) {
					if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
	
						// Call the core method to track "olddisplay" properly
						elem[ mode ]();
						done();
					} else {
						effectMethod.call( elem[ 0 ], args, done );
					}
				} else {
					if ( args.mode === "none" ) {
	
						// Call the core method to track "olddisplay" properly
						elem[ mode ]();
						done();
					} else {
						effectMethod.call( elem[ 0 ], args, cleanup );
					}
				}
			}
	
			// Run prefilter on all elements first to ensure that
			// any showing or hiding happens before placeholder creation,
			// which ensures that any layout changes are correctly captured.
			return queue === false ?
				this.each( prefilter ).each( run ) :
				this.queue( queueName, prefilter ).queue( queueName, run );
		},
	
		show: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "show";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.show ),
	
		hide: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "hide";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.hide ),
	
		toggle: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "toggle";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.toggle ),
	
		cssUnit: function( key ) {
			var style = this.css( key ),
				val = [];
	
			$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
				if ( style.indexOf( unit ) > 0 ) {
					val = [ parseFloat( style ), unit ];
				}
			} );
			return val;
		},
	
		cssClip: function( clipObj ) {
			if ( clipObj ) {
				return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
					clipObj.bottom + "px " + clipObj.left + "px)" );
			}
			return parseClip( this.css( "clip" ), this );
		},
	
		transfer: function( options, done ) {
			var element = $( this ),
				target = $( options.to ),
				targetFixed = target.css( "position" ) === "fixed",
				body = $( "body" ),
				fixTop = targetFixed ? body.scrollTop() : 0,
				fixLeft = targetFixed ? body.scrollLeft() : 0,
				endPosition = target.offset(),
				animation = {
					top: endPosition.top - fixTop,
					left: endPosition.left - fixLeft,
					height: target.innerHeight(),
					width: target.innerWidth()
				},
				startPosition = element.offset(),
				transfer = $( "<div class='ui-effects-transfer'></div>" )
					.appendTo( "body" )
					.addClass( options.className )
					.css( {
						top: startPosition.top - fixTop,
						left: startPosition.left - fixLeft,
						height: element.innerHeight(),
						width: element.innerWidth(),
						position: targetFixed ? "fixed" : "absolute"
					} )
					.animate( animation, options.duration, options.easing, function() {
						transfer.remove();
						if ( $.isFunction( done ) ) {
							done();
						}
					} );
		}
	} );
	
	function parseClip( str, element ) {
			var outerWidth = element.outerWidth(),
				outerHeight = element.outerHeight(),
				clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
				values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];
	
			return {
				top: parseFloat( values[ 1 ] ) || 0,
				right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
				bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
				left: parseFloat( values[ 4 ] ) || 0
			};
	}
	
	$.fx.step.clip = function( fx ) {
		if ( !fx.clipInit ) {
			fx.start = $( fx.elem ).cssClip();
			if ( typeof fx.end === "string" ) {
				fx.end = parseClip( fx.end, fx.elem );
			}
			fx.clipInit = true;
		}
	
		$( fx.elem ).cssClip( {
			top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
			right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
			bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
			left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
		} );
	};
	
	} )();
	
	/******************************************************************************/
	/*********************************** EASING ***********************************/
	/******************************************************************************/
	
	( function() {
	
	// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
	
	var baseEasings = {};
	
	$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
		baseEasings[ name ] = function( p ) {
			return Math.pow( p, i + 2 );
		};
	} );
	
	$.extend( baseEasings, {
		Sine: function( p ) {
			return 1 - Math.cos( p * Math.PI / 2 );
		},
		Circ: function( p ) {
			return 1 - Math.sqrt( 1 - p * p );
		},
		Elastic: function( p ) {
			return p === 0 || p === 1 ? p :
				-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
		},
		Back: function( p ) {
			return p * p * ( 3 * p - 2 );
		},
		Bounce: function( p ) {
			var pow2,
				bounce = 4;
	
			while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
			return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
		}
	} );
	
	$.each( baseEasings, function( name, easeIn ) {
		$.easing[ "easeIn" + name ] = easeIn;
		$.easing[ "easeOut" + name ] = function( p ) {
			return 1 - easeIn( 1 - p );
		};
		$.easing[ "easeInOut" + name ] = function( p ) {
			return p < 0.5 ?
				easeIn( p * 2 ) / 2 :
				1 - easeIn( p * -2 + 2 ) / 2;
		};
	} );
	
	} )();
	
	return $.effects;
	
	} ) );


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// This file is deprecated
	return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	} ) );


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	return $.ui.plugin = {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args, allowDisconnected ) {
			var i,
				set = instance.plugins[ name ];
	
			if ( !set ) {
				return;
			}
	
			if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
					instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
				return;
			}
	
			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	};
	
	} ) );


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeActiveElement = function( document ) {
		var activeElement;
	
		// Support: IE 9 only
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {
			activeElement = document.activeElement;
		} catch ( error ) {
			activeElement = document.body;
		}
	
		// Support: IE 9 - 11 only
		// IE may return null instead of an element
		// Interestingly, this only seems to occur when NOT in an iframe
		if ( !activeElement ) {
			activeElement = document.body;
		}
	
		// Support: IE 11 only
		// IE11 returns a seemingly empty object in some cases when accessing
		// document.activeElement from an <iframe>
		if ( !activeElement.nodeName ) {
			activeElement = document.body;
		}
	
		return activeElement;
	};
	
	} ) );


/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeBlur = function( element ) {
	
		// Support: IE9 - 10 only
		// If the <body> is blurred, IE will switch windows, see #9420
		if ( element && element.nodeName.toLowerCase() !== "body" ) {
			$( element ).trigger( "blur" );
		}
	};
	
	} ) );


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Scroll Parent 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(13), __webpack_require__(50) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.scrollParent = function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
					parent.css( "overflow-x" ) );
			} ).eq( 0 );
	
		return position === "fixed" || !scrollParent.length ?
			$( this[ 0 ].ownerDocument || document ) :
			scrollParent;
	};
	
	} ) );


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Droppable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Droppable
	//>>group: Interactions
	//>>description: Enables drop targets for draggable elements.
	//>>docs: http://api.jqueryui.com/droppable/
	//>>demos: http://jqueryui.com/droppable/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(13),
				__webpack_require__(628),
				__webpack_require__(629),
				__webpack_require__(50),
				__webpack_require__(431)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.droppable", {
		version: "1.12.1",
		widgetEventPrefix: "drop",
		options: {
			accept: "*",
			addClasses: true,
			greedy: false,
			scope: "default",
			tolerance: "intersect",
	
			// Callbacks
			activate: null,
			deactivate: null,
			drop: null,
			out: null,
			over: null
		},
		_create: function() {
	
			var proportions,
				o = this.options,
				accept = o.accept;
	
			this.isover = false;
			this.isout = true;
	
			this.accept = $.isFunction( accept ) ? accept : function( d ) {
				return d.is( accept );
			};
	
			this.proportions = function( /* valueToWrite */ ) {
				if ( arguments.length ) {
	
					// Store the droppable's proportions
					proportions = arguments[ 0 ];
				} else {
	
					// Retrieve or derive the droppable's proportions
					return proportions ?
						proportions :
						proportions = {
							width: this.element[ 0 ].offsetWidth,
							height: this.element[ 0 ].offsetHeight
						};
				}
			};
	
			this._addToManager( o.scope );
	
			o.addClasses && this._addClass( "ui-droppable" );
	
		},
	
		_addToManager: function( scope ) {
	
			// Add the reference and positions to the manager
			$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
			$.ui.ddmanager.droppables[ scope ].push( this );
		},
	
		_splice: function( drop ) {
			var i = 0;
			for ( ; i < drop.length; i++ ) {
				if ( drop[ i ] === this ) {
					drop.splice( i, 1 );
				}
			}
		},
	
		_destroy: function() {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
			this._splice( drop );
		},
	
		_setOption: function( key, value ) {
	
			if ( key === "accept" ) {
				this.accept = $.isFunction( value ) ? value : function( d ) {
					return d.is( value );
				};
			} else if ( key === "scope" ) {
				var drop = $.ui.ddmanager.droppables[ this.options.scope ];
	
				this._splice( drop );
				this._addToManager( value );
			}
	
			this._super( key, value );
		},
	
		_activate: function( event ) {
			var draggable = $.ui.ddmanager.current;
	
			this._addActiveClass();
			if ( draggable ) {
				this._trigger( "activate", event, this.ui( draggable ) );
			}
		},
	
		_deactivate: function( event ) {
			var draggable = $.ui.ddmanager.current;
	
			this._removeActiveClass();
			if ( draggable ) {
				this._trigger( "deactivate", event, this.ui( draggable ) );
			}
		},
	
		_over: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
					draggable.element ) ) ) {
				this._addHoverClass();
				this._trigger( "over", event, this.ui( draggable ) );
			}
	
		},
	
		_out: function( event ) {
	
			var draggable = $.ui.ddmanager.current;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return;
			}
	
			if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
					draggable.element ) ) ) {
				this._removeHoverClass();
				this._trigger( "out", event, this.ui( draggable ) );
			}
	
		},
	
		_drop: function( event, custom ) {
	
			var draggable = custom || $.ui.ddmanager.current,
				childrenIntersection = false;
	
			// Bail if draggable and droppable are same element
			if ( !draggable || ( draggable.currentItem ||
					draggable.element )[ 0 ] === this.element[ 0 ] ) {
				return false;
			}
	
			this.element
				.find( ":data(ui-droppable)" )
				.not( ".ui-draggable-dragging" )
				.each( function() {
					var inst = $( this ).droppable( "instance" );
					if (
						inst.options.greedy &&
						!inst.options.disabled &&
						inst.options.scope === draggable.options.scope &&
						inst.accept.call(
							inst.element[ 0 ], ( draggable.currentItem || draggable.element )
						) &&
						intersect(
							draggable,
							$.extend( inst, { offset: inst.element.offset() } ),
							inst.options.tolerance, event
						)
					) {
						childrenIntersection = true;
						return false; }
				} );
			if ( childrenIntersection ) {
				return false;
			}
	
			if ( this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this._removeActiveClass();
				this._removeHoverClass();
	
				this._trigger( "drop", event, this.ui( draggable ) );
				return this.element;
			}
	
			return false;
	
		},
	
		ui: function( c ) {
			return {
				draggable: ( c.currentItem || c.element ),
				helper: c.helper,
				position: c.position,
				offset: c.positionAbs
			};
		},
	
		// Extension points just to make backcompat sane and avoid duplicating logic
		// TODO: Remove in 1.13 along with call to it below
		_addHoverClass: function() {
			this._addClass( "ui-droppable-hover" );
		},
	
		_removeHoverClass: function() {
			this._removeClass( "ui-droppable-hover" );
		},
	
		_addActiveClass: function() {
			this._addClass( "ui-droppable-active" );
		},
	
		_removeActiveClass: function() {
			this._removeClass( "ui-droppable-active" );
		}
	} );
	
	var intersect = $.ui.intersect = ( function() {
		function isOverAxis( x, reference, size ) {
			return ( x >= reference ) && ( x < ( reference + size ) );
		}
	
		return function( draggable, droppable, toleranceMode, event ) {
	
			if ( !droppable.offset ) {
				return false;
			}
	
			var x1 = ( draggable.positionAbs ||
					draggable.position.absolute ).left + draggable.margins.left,
				y1 = ( draggable.positionAbs ||
					draggable.position.absolute ).top + draggable.margins.top,
				x2 = x1 + draggable.helperProportions.width,
				y2 = y1 + draggable.helperProportions.height,
				l = droppable.offset.left,
				t = droppable.offset.top,
				r = l + droppable.proportions().width,
				b = t + droppable.proportions().height;
	
			switch ( toleranceMode ) {
			case "fit":
				return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
			case "intersect":
				return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
					x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
					t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
					y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
			case "pointer":
				return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
					isOverAxis( event.pageX, l, droppable.proportions().width );
			case "touch":
				return (
					( y1 >= t && y1 <= b ) || // Top edge touching
					( y2 >= t && y2 <= b ) || // Bottom edge touching
					( y1 < t && y2 > b ) // Surrounded vertically
				) && (
					( x1 >= l && x1 <= r ) || // Left edge touching
					( x2 >= l && x2 <= r ) || // Right edge touching
					( x1 < l && x2 > r ) // Surrounded horizontally
				);
			default:
				return false;
			}
		};
	} )();
	
	/*
		This manager tracks offsets of draggables and droppables
	*/
	$.ui.ddmanager = {
		current: null,
		droppables: { "default": [] },
		prepareOffsets: function( t, event ) {
	
			var i, j,
				m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
				type = event ? event.type : null, // workaround for #2317
				list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();
	
			droppablesLoop: for ( i = 0; i < m.length; i++ ) {
	
				// No disabled and non-accepted
				if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
						( t.currentItem || t.element ) ) ) ) {
					continue;
				}
	
				// Filter out elements in the current dragged item
				for ( j = 0; j < list.length; j++ ) {
					if ( list[ j ] === m[ i ].element[ 0 ] ) {
						m[ i ].proportions().height = 0;
						continue droppablesLoop;
					}
				}
	
				m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
				if ( !m[ i ].visible ) {
					continue;
				}
	
				// Activate the droppable if used directly from draggables
				if ( type === "mousedown" ) {
					m[ i ]._activate.call( m[ i ], event );
				}
	
				m[ i ].offset = m[ i ].element.offset();
				m[ i ].proportions( {
					width: m[ i ].element[ 0 ].offsetWidth,
					height: m[ i ].element[ 0 ].offsetHeight
				} );
	
			}
	
		},
		drop: function( draggable, event ) {
	
			var dropped = false;
	
			// Create a copy of the droppables in case the list changes during the drop (#9116)
			$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {
	
				if ( !this.options ) {
					return;
				}
				if ( !this.options.disabled && this.visible &&
						intersect( draggable, this, this.options.tolerance, event ) ) {
					dropped = this._drop.call( this, event ) || dropped;
				}
	
				if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
						( draggable.currentItem || draggable.element ) ) ) {
					this.isout = true;
					this.isover = false;
					this._deactivate.call( this, event );
				}
	
			} );
			return dropped;
	
		},
		dragStart: function( draggable, event ) {
	
			// Listen for scrolling so that if the dragging causes scrolling the position of the
			// droppables can be recalculated (see #5003)
			draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
				if ( !draggable.options.refreshPositions ) {
					$.ui.ddmanager.prepareOffsets( draggable, event );
				}
			} );
		},
		drag: function( draggable, event ) {
	
			// If you have a highly dynamic page, you might try this option. It renders positions
			// every time you move the mouse.
			if ( draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
	
			// Run through all droppables and check their positions based on specific tolerance options
			$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {
	
				if ( this.options.disabled || this.greedyChild || !this.visible ) {
					return;
				}
	
				var parentInstance, scope, parent,
					intersects = intersect( draggable, this, this.options.tolerance, event ),
					c = !intersects && this.isover ?
						"isout" :
						( intersects && !this.isover ? "isover" : null );
				if ( !c ) {
					return;
				}
	
				if ( this.options.greedy ) {
	
					// find droppable parents with same scope
					scope = this.options.scope;
					parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
						return $( this ).droppable( "instance" ).options.scope === scope;
					} );
	
					if ( parent.length ) {
						parentInstance = $( parent[ 0 ] ).droppable( "instance" );
						parentInstance.greedyChild = ( c === "isover" );
					}
				}
	
				// We just moved into a greedy child
				if ( parentInstance && c === "isover" ) {
					parentInstance.isover = false;
					parentInstance.isout = true;
					parentInstance._out.call( parentInstance, event );
				}
	
				this[ c ] = true;
				this[ c === "isout" ? "isover" : "isout" ] = false;
				this[ c === "isover" ? "_over" : "_out" ].call( this, event );
	
				// We just moved out of a greedy child
				if ( parentInstance && c === "isout" ) {
					parentInstance.isout = false;
					parentInstance.isover = true;
					parentInstance._over.call( parentInstance, event );
				}
			} );
	
		},
		dragStop: function( draggable, event ) {
			draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );
	
			// Call prepareOffsets one final time since IE does not fire return scroll events when
			// overflow was caused by drag (see #5003)
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		}
	};
	
	// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if ( $.uiBackCompat !== false ) {
	
		// Backcompat for activeClass and hoverClass options
		$.widget( "ui.droppable", $.ui.droppable, {
			options: {
				hoverClass: false,
				activeClass: false
			},
			_addActiveClass: function() {
				this._super();
				if ( this.options.activeClass ) {
					this.element.addClass( this.options.activeClass );
				}
			},
			_removeActiveClass: function() {
				this._super();
				if ( this.options.activeClass ) {
					this.element.removeClass( this.options.activeClass );
				}
			},
			_addHoverClass: function() {
				this._super();
				if ( this.options.hoverClass ) {
					this.element.addClass( this.options.hoverClass );
				}
			},
			_removeHoverClass: function() {
				this._super();
				if ( this.options.hoverClass ) {
					this.element.removeClass( this.options.hoverClass );
				}
			}
		} );
	}
	
	return $.ui.droppable;
	
	} ) );


/***/ },
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(631);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000,
	    strictNullHandling: false,
	    plainObjects: false,
	    allowPrototypes: false,
	    allowDots: false
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	
	            if (options.strictNullHandling) {
	                obj[Utils.decode(part)] = null;
	            }
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            (options.parseArrays &&
	             index <= options.arrayLimit)) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	
	    if (options.allowDots) {
	        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects &&
	            Object.prototype.hasOwnProperty(segment[1])) {
	
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!options.plainObjects &&
	            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	
	            if (!options.allowPrototypes) {
	                continue;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj, options);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(631);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	
	            return prefix;
	        }
	    },
	    strictNullHandling: false,
	    skipNulls: false,
	    encode: true
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter) {
	
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    }
	    else if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        if (strictNullHandling) {
	            return encode ? Utils.encode(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        if (encode) {
	            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
	        }
	        return [prefix + '=' + obj];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Array.isArray(filter) ? filter : Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls &&
	            obj[key] === null) {
	
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
	    var objKeys;
	    var filter;
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    }
	    else if (Array.isArray(options.filter)) {
	        objKeys = filter = options.filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls &&
	            obj[key] === null) {
	
	            continue;
	        }
	
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 1181 */
/***/ function(module, exports) {

	module.exports = "/*!\n * Bootstrap v3.3.2 (http://getbootstrap.com)\n * Copyright 2011-2015 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n\n/*!\n * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=8cbe4b24dc3441f9a6c1)\n * Config saved to config.json and https://gist.github.com/8cbe4b24dc3441f9a6c1\n */\nif(\"undefined\"==typeof jQuery)throw new Error(\"Bootstrap's JavaScript requires jQuery\");+function(t){\"use strict\";var e=t.fn.jquery.split(\" \")[0].split(\".\");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1)throw new Error(\"Bootstrap's JavaScript requires jQuery version 1.9.1 or higher\")}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var i=t(this),s=i.data(\"bs.alert\");s||i.data(\"bs.alert\",s=new o(this)),\"string\"==typeof e&&s[e].call(i)})}var i='[data-dismiss=\"alert\"]',o=function(e){t(e).on(\"click\",i,this.close)};o.VERSION=\"3.3.2\",o.TRANSITION_DURATION=150,o.prototype.close=function(e){function i(){a.detach().trigger(\"closed.bs.alert\").remove()}var s=t(this),n=s.attr(\"data-target\");n||(n=s.attr(\"href\"),n=n&&n.replace(/.*(?=#[^\\s]*$)/,\"\"));var a=t(n);e&&e.preventDefault(),a.length||(a=s.closest(\".alert\")),a.trigger(e=t.Event(\"close.bs.alert\")),e.isDefaultPrevented()||(a.removeClass(\"in\"),t.support.transition&&a.hasClass(\"fade\")?a.one(\"bsTransitionEnd\",i).emulateTransitionEnd(o.TRANSITION_DURATION):i())};var s=t.fn.alert;t.fn.alert=e,t.fn.alert.Constructor=o,t.fn.alert.noConflict=function(){return t.fn.alert=s,this},t(document).on(\"click.bs.alert.data-api\",i,o.prototype.close)}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),s=o.data(\"bs.button\"),n=\"object\"==typeof e&&e;s||o.data(\"bs.button\",s=new i(this,n)),\"toggle\"==e?s.toggle():e&&s.setState(e)})}var i=function(e,o){this.$element=t(e),this.options=t.extend({},i.DEFAULTS,o),this.isLoading=!1};i.VERSION=\"3.3.2\",i.DEFAULTS={loadingText:\"loading...\"},i.prototype.setState=function(e){var i=\"disabled\",o=this.$element,s=o.is(\"input\")?\"val\":\"html\",n=o.data();e+=\"Text\",null==n.resetText&&o.data(\"resetText\",o[s]()),setTimeout(t.proxy(function(){o[s](null==n[e]?this.options[e]:n[e]),\"loadingText\"==e?(this.isLoading=!0,o.addClass(i).attr(i,i)):this.isLoading&&(this.isLoading=!1,o.removeClass(i).removeAttr(i))},this),0)},i.prototype.toggle=function(){var t=!0,e=this.$element.closest('[data-toggle=\"buttons\"]');if(e.length){var i=this.$element.find(\"input\");\"radio\"==i.prop(\"type\")&&(i.prop(\"checked\")&&this.$element.hasClass(\"active\")?t=!1:e.find(\".active\").removeClass(\"active\")),t&&i.prop(\"checked\",!this.$element.hasClass(\"active\")).trigger(\"change\")}else this.$element.attr(\"aria-pressed\",!this.$element.hasClass(\"active\"));t&&this.$element.toggleClass(\"active\")};var o=t.fn.button;t.fn.button=e,t.fn.button.Constructor=i,t.fn.button.noConflict=function(){return t.fn.button=o,this},t(document).on(\"click.bs.button.data-api\",'[data-toggle^=\"button\"]',function(i){var o=t(i.target);o.hasClass(\"btn\")||(o=o.closest(\".btn\")),e.call(o,\"toggle\"),i.preventDefault()}).on(\"focus.bs.button.data-api blur.bs.button.data-api\",'[data-toggle^=\"button\"]',function(e){t(e.target).closest(\".btn\").toggleClass(\"focus\",/^focus(in)?$/.test(e.type))})}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),s=o.data(\"bs.carousel\"),n=t.extend({},i.DEFAULTS,o.data(),\"object\"==typeof e&&e),a=\"string\"==typeof e?e:n.slide;s||o.data(\"bs.carousel\",s=new i(this,n)),\"number\"==typeof e?s.to(e):a?s[a]():n.interval&&s.pause().cycle()})}var i=function(e,i){this.$element=t(e),this.$indicators=this.$element.find(\".carousel-indicators\"),this.options=i,this.paused=this.sliding=this.interval=this.$active=this.$items=null,this.options.keyboard&&this.$element.on(\"keydown.bs.carousel\",t.proxy(this.keydown,this)),\"hover\"==this.options.pause&&!(\"ontouchstart\"in document.documentElement)&&this.$element.on(\"mouseenter.bs.carousel\",t.proxy(this.pause,this)).on(\"mouseleave.bs.carousel\",t.proxy(this.cycle,this))};i.VERSION=\"3.3.2\",i.TRANSITION_DURATION=600,i.DEFAULTS={interval:5e3,pause:\"hover\",wrap:!0,keyboard:!0},i.prototype.keydown=function(t){if(!/input|textarea/i.test(t.target.tagName)){switch(t.which){case 37:this.prev();break;case 39:this.next();break;default:return}t.preventDefault()}},i.prototype.cycle=function(e){return e||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(t.proxy(this.next,this),this.options.interval)),this},i.prototype.getItemIndex=function(t){return this.$items=t.parent().children(\".item\"),this.$items.index(t||this.$active)},i.prototype.getItemForDirection=function(t,e){var i=this.getItemIndex(e),o=\"prev\"==t&&0===i||\"next\"==t&&i==this.$items.length-1;if(o&&!this.options.wrap)return e;var s=\"prev\"==t?-1:1,n=(i+s)%this.$items.length;return this.$items.eq(n)},i.prototype.to=function(t){var e=this,i=this.getItemIndex(this.$active=this.$element.find(\".item.active\"));return t>this.$items.length-1||0>t?void 0:this.sliding?this.$element.one(\"slid.bs.carousel\",function(){e.to(t)}):i==t?this.pause().cycle():this.slide(t>i?\"next\":\"prev\",this.$items.eq(t))},i.prototype.pause=function(e){return e||(this.paused=!0),this.$element.find(\".next, .prev\").length&&t.support.transition&&(this.$element.trigger(t.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},i.prototype.next=function(){return this.sliding?void 0:this.slide(\"next\")},i.prototype.prev=function(){return this.sliding?void 0:this.slide(\"prev\")},i.prototype.slide=function(e,o){var s=this.$element.find(\".item.active\"),n=o||this.getItemForDirection(e,s),a=this.interval,r=\"next\"==e?\"left\":\"right\",l=this;if(n.hasClass(\"active\"))return this.sliding=!1;var h=n[0],d=t.Event(\"slide.bs.carousel\",{relatedTarget:h,direction:r});if(this.$element.trigger(d),!d.isDefaultPrevented()){if(this.sliding=!0,a&&this.pause(),this.$indicators.length){this.$indicators.find(\".active\").removeClass(\"active\");var p=t(this.$indicators.children()[this.getItemIndex(n)]);p&&p.addClass(\"active\")}var c=t.Event(\"slid.bs.carousel\",{relatedTarget:h,direction:r});return t.support.transition&&this.$element.hasClass(\"slide\")?(n.addClass(e),n[0].offsetWidth,s.addClass(r),n.addClass(r),s.one(\"bsTransitionEnd\",function(){n.removeClass([e,r].join(\" \")).addClass(\"active\"),s.removeClass([\"active\",r].join(\" \")),l.sliding=!1,setTimeout(function(){l.$element.trigger(c)},0)}).emulateTransitionEnd(i.TRANSITION_DURATION)):(s.removeClass(\"active\"),n.addClass(\"active\"),this.sliding=!1,this.$element.trigger(c)),a&&this.cycle(),this}};var o=t.fn.carousel;t.fn.carousel=e,t.fn.carousel.Constructor=i,t.fn.carousel.noConflict=function(){return t.fn.carousel=o,this};var s=function(i){var o,s=t(this),n=t(s.attr(\"data-target\")||(o=s.attr(\"href\"))&&o.replace(/.*(?=#[^\\s]+$)/,\"\"));if(n.hasClass(\"carousel\")){var a=t.extend({},n.data(),s.data()),r=s.attr(\"data-slide-to\");r&&(a.interval=!1),e.call(n,a),r&&n.data(\"bs.carousel\").to(r),i.preventDefault()}};t(document).on(\"click.bs.carousel.data-api\",\"[data-slide]\",s).on(\"click.bs.carousel.data-api\",\"[data-slide-to]\",s),t(window).on(\"load\",function(){t('[data-ride=\"carousel\"]').each(function(){var i=t(this);e.call(i,i.data())})})}(jQuery),+function(t){\"use strict\";function e(e){e&&3===e.which||(t(s).remove(),t(n).each(function(){var o=t(this),s=i(o),n={relatedTarget:this};s.hasClass(\"open\")&&(s.trigger(e=t.Event(\"hide.bs.dropdown\",n)),e.isDefaultPrevented()||(o.attr(\"aria-expanded\",\"false\"),s.removeClass(\"open\").trigger(\"hidden.bs.dropdown\",n)))}))}function i(e){var i=e.attr(\"data-target\");i||(i=e.attr(\"href\"),i=i&&/#[A-Za-z]/.test(i)&&i.replace(/.*(?=#[^\\s]*$)/,\"\"));var o=i&&t(i);return o&&o.length?o:e.parent()}function o(e){return this.each(function(){var i=t(this),o=i.data(\"bs.dropdown\");o||i.data(\"bs.dropdown\",o=new a(this)),\"string\"==typeof e&&o[e].call(i)})}var s=\".dropdown-backdrop\",n='[data-toggle=\"dropdown\"]',a=function(e){t(e).on(\"click.bs.dropdown\",this.toggle)};a.VERSION=\"3.3.2\",a.prototype.toggle=function(o){var s=t(this);if(!s.is(\".disabled, :disabled\")){var n=i(s),a=n.hasClass(\"open\");if(e(),!a){\"ontouchstart\"in document.documentElement&&!n.closest(\".navbar-nav\").length&&t('<div class=\"dropdown-backdrop\"/>').insertAfter(t(this)).on(\"click\",e);var r={relatedTarget:this};if(n.trigger(o=t.Event(\"show.bs.dropdown\",r)),o.isDefaultPrevented())return;s.trigger(\"focus\").attr(\"aria-expanded\",\"true\"),n.toggleClass(\"open\").trigger(\"shown.bs.dropdown\",r)}return!1}},a.prototype.keydown=function(e){if(/(38|40|27|32)/.test(e.which)&&!/input|textarea/i.test(e.target.tagName)){var o=t(this);if(e.preventDefault(),e.stopPropagation(),!o.is(\".disabled, :disabled\")){var s=i(o),a=s.hasClass(\"open\");if(!a&&27!=e.which||a&&27==e.which)return 27==e.which&&s.find(n).trigger(\"focus\"),o.trigger(\"click\");var r=\" li:not(.divider):visible a\",l=s.find('[role=\"menu\"]'+r+', [role=\"listbox\"]'+r);if(l.length){var h=l.index(e.target);38==e.which&&h>0&&h--,40==e.which&&h<l.length-1&&h++,~h||(h=0),l.eq(h).trigger(\"focus\")}}}};var r=t.fn.dropdown;t.fn.dropdown=o,t.fn.dropdown.Constructor=a,t.fn.dropdown.noConflict=function(){return t.fn.dropdown=r,this},t(document).on(\"click.bs.dropdown.data-api\",e).on(\"click.bs.dropdown.data-api\",\".dropdown form\",function(t){t.stopPropagation()}).on(\"click.bs.dropdown.data-api\",n,a.prototype.toggle).on(\"keydown.bs.dropdown.data-api\",n,a.prototype.keydown).on(\"keydown.bs.dropdown.data-api\",'[role=\"menu\"]',a.prototype.keydown).on(\"keydown.bs.dropdown.data-api\",'[role=\"listbox\"]',a.prototype.keydown)}(jQuery),+function(t){\"use strict\";function e(e,o){return this.each(function(){var s=t(this),n=s.data(\"bs.modal\"),a=t.extend({},i.DEFAULTS,s.data(),\"object\"==typeof e&&e);n||s.data(\"bs.modal\",n=new i(this,a)),\"string\"==typeof e?n[e](o):a.show&&n.show(o)})}var i=function(e,i){this.options=i,this.$body=t(document.body),this.$element=t(e),this.$backdrop=this.isShown=null,this.scrollbarWidth=0,this.options.remote&&this.$element.find(\".modal-content\").load(this.options.remote,t.proxy(function(){this.$element.trigger(\"loaded.bs.modal\")},this))};i.VERSION=\"3.3.2\",i.TRANSITION_DURATION=300,i.BACKDROP_TRANSITION_DURATION=150,i.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},i.prototype.toggle=function(t){return this.isShown?this.hide():this.show(t)},i.prototype.show=function(e){var o=this,s=t.Event(\"show.bs.modal\",{relatedTarget:e});this.$element.trigger(s),this.isShown||s.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass(\"modal-open\"),this.escape(),this.resize(),this.$element.on(\"click.dismiss.bs.modal\",'[data-dismiss=\"modal\"]',t.proxy(this.hide,this)),this.backdrop(function(){var s=t.support.transition&&o.$element.hasClass(\"fade\");o.$element.parent().length||o.$element.appendTo(o.$body),o.$element.show().scrollTop(0),o.options.backdrop&&o.adjustBackdrop(),o.adjustDialog(),s&&o.$element[0].offsetWidth,o.$element.addClass(\"in\").attr(\"aria-hidden\",!1),o.enforceFocus();var n=t.Event(\"shown.bs.modal\",{relatedTarget:e});s?o.$element.find(\".modal-dialog\").one(\"bsTransitionEnd\",function(){o.$element.trigger(\"focus\").trigger(n)}).emulateTransitionEnd(i.TRANSITION_DURATION):o.$element.trigger(\"focus\").trigger(n)}))},i.prototype.hide=function(e){e&&e.preventDefault(),e=t.Event(\"hide.bs.modal\"),this.$element.trigger(e),this.isShown&&!e.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),t(document).off(\"focusin.bs.modal\"),this.$element.removeClass(\"in\").attr(\"aria-hidden\",!0).off(\"click.dismiss.bs.modal\"),t.support.transition&&this.$element.hasClass(\"fade\")?this.$element.one(\"bsTransitionEnd\",t.proxy(this.hideModal,this)).emulateTransitionEnd(i.TRANSITION_DURATION):this.hideModal())},i.prototype.enforceFocus=function(){t(document).off(\"focusin.bs.modal\").on(\"focusin.bs.modal\",t.proxy(function(t){this.$element[0]===t.target||this.$element.has(t.target).length||this.$element.trigger(\"focus\")},this))},i.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on(\"keydown.dismiss.bs.modal\",t.proxy(function(t){27==t.which&&this.hide()},this)):this.isShown||this.$element.off(\"keydown.dismiss.bs.modal\")},i.prototype.resize=function(){this.isShown?t(window).on(\"resize.bs.modal\",t.proxy(this.handleUpdate,this)):t(window).off(\"resize.bs.modal\")},i.prototype.hideModal=function(){var t=this;this.$element.hide(),this.backdrop(function(){t.$body.removeClass(\"modal-open\"),t.resetAdjustments(),t.resetScrollbar(),t.$element.trigger(\"hidden.bs.modal\")})},i.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},i.prototype.backdrop=function(e){var o=this,s=this.$element.hasClass(\"fade\")?\"fade\":\"\";if(this.isShown&&this.options.backdrop){var n=t.support.transition&&s;if(this.$backdrop=t('<div class=\"modal-backdrop '+s+'\" />').prependTo(this.$element).on(\"click.dismiss.bs.modal\",t.proxy(function(t){t.target===t.currentTarget&&(\"static\"==this.options.backdrop?this.$element[0].focus.call(this.$element[0]):this.hide.call(this))},this)),n&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass(\"in\"),!e)return;n?this.$backdrop.one(\"bsTransitionEnd\",e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):e()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass(\"in\");var a=function(){o.removeBackdrop(),e&&e()};t.support.transition&&this.$element.hasClass(\"fade\")?this.$backdrop.one(\"bsTransitionEnd\",a).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION):a()}else e&&e()},i.prototype.handleUpdate=function(){this.options.backdrop&&this.adjustBackdrop(),this.adjustDialog()},i.prototype.adjustBackdrop=function(){this.$backdrop.css(\"height\",0).css(\"height\",this.$element[0].scrollHeight)},i.prototype.adjustDialog=function(){var t=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&t?this.scrollbarWidth:\"\",paddingRight:this.bodyIsOverflowing&&!t?this.scrollbarWidth:\"\"})},i.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:\"\",paddingRight:\"\"})},i.prototype.checkScrollbar=function(){this.bodyIsOverflowing=document.body.scrollHeight>document.documentElement.clientHeight,this.scrollbarWidth=this.measureScrollbar()},i.prototype.setScrollbar=function(){var t=parseInt(this.$body.css(\"padding-right\")||0,10);this.bodyIsOverflowing&&this.$body.css(\"padding-right\",t+this.scrollbarWidth)},i.prototype.resetScrollbar=function(){this.$body.css(\"padding-right\",\"\")},i.prototype.measureScrollbar=function(){var t=document.createElement(\"div\");t.className=\"modal-scrollbar-measure\",this.$body.append(t);var e=t.offsetWidth-t.clientWidth;return this.$body[0].removeChild(t),e};var o=t.fn.modal;t.fn.modal=e,t.fn.modal.Constructor=i,t.fn.modal.noConflict=function(){return t.fn.modal=o,this},t(document).on(\"click.bs.modal.data-api\",'[data-toggle=\"modal\"]',function(i){var o=t(this),s=o.attr(\"href\"),n=t(o.attr(\"data-target\")||s&&s.replace(/.*(?=#[^\\s]+$)/,\"\")),a=n.data(\"bs.modal\")?\"toggle\":t.extend({remote:!/#/.test(s)&&s},n.data(),o.data());o.is(\"a\")&&i.preventDefault(),n.one(\"show.bs.modal\",function(t){t.isDefaultPrevented()||n.one(\"hidden.bs.modal\",function(){o.is(\":visible\")&&o.trigger(\"focus\")})}),e.call(n,a,this)})}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),s=o.data(\"bs.tooltip\"),n=\"object\"==typeof e&&e;(s||\"destroy\"!=e)&&(s||o.data(\"bs.tooltip\",s=new i(this,n)),\"string\"==typeof e&&s[e]())})}var i=function(t,e){this.type=this.options=this.enabled=this.timeout=this.hoverState=this.$element=null,this.init(\"tooltip\",t,e)};i.VERSION=\"3.3.2\",i.TRANSITION_DURATION=150,i.DEFAULTS={animation:!0,placement:\"top\",selector:!1,template:'<div class=\"tooltip\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>',trigger:\"hover focus\",title:\"\",delay:0,html:!1,container:!1,viewport:{selector:\"body\",padding:0}},i.prototype.init=function(e,i,o){this.enabled=!0,this.type=e,this.$element=t(i),this.options=this.getOptions(o),this.$viewport=this.options.viewport&&t(this.options.viewport.selector||this.options.viewport);for(var s=this.options.trigger.split(\" \"),n=s.length;n--;){var a=s[n];if(\"click\"==a)this.$element.on(\"click.\"+this.type,this.options.selector,t.proxy(this.toggle,this));else if(\"manual\"!=a){var r=\"hover\"==a?\"mouseenter\":\"focusin\",l=\"hover\"==a?\"mouseleave\":\"focusout\";this.$element.on(r+\".\"+this.type,this.options.selector,t.proxy(this.enter,this)),this.$element.on(l+\".\"+this.type,this.options.selector,t.proxy(this.leave,this))}}this.options.selector?this._options=t.extend({},this.options,{trigger:\"manual\",selector:\"\"}):this.fixTitle()},i.prototype.getDefaults=function(){return i.DEFAULTS},i.prototype.getOptions=function(e){return e=t.extend({},this.getDefaults(),this.$element.data(),e),e.delay&&\"number\"==typeof e.delay&&(e.delay={show:e.delay,hide:e.delay}),e},i.prototype.getDelegateOptions=function(){var e={},i=this.getDefaults();return this._options&&t.each(this._options,function(t,o){i[t]!=o&&(e[t]=o)}),e},i.prototype.enter=function(e){var i=e instanceof this.constructor?e:t(e.currentTarget).data(\"bs.\"+this.type);return i&&i.$tip&&i.$tip.is(\":visible\")?void(i.hoverState=\"in\"):(i||(i=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data(\"bs.\"+this.type,i)),clearTimeout(i.timeout),i.hoverState=\"in\",i.options.delay&&i.options.delay.show?void(i.timeout=setTimeout(function(){\"in\"==i.hoverState&&i.show()},i.options.delay.show)):i.show())},i.prototype.leave=function(e){var i=e instanceof this.constructor?e:t(e.currentTarget).data(\"bs.\"+this.type);return i||(i=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data(\"bs.\"+this.type,i)),clearTimeout(i.timeout),i.hoverState=\"out\",i.options.delay&&i.options.delay.hide?void(i.timeout=setTimeout(function(){\"out\"==i.hoverState&&i.hide()},i.options.delay.hide)):i.hide()},i.prototype.show=function(){var e=t.Event(\"show.bs.\"+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(e);var o=t.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(e.isDefaultPrevented()||!o)return;var s=this,n=this.tip(),a=this.getUID(this.type);this.setContent(),n.attr(\"id\",a),this.$element.attr(\"aria-describedby\",a),this.options.animation&&n.addClass(\"fade\");var r=\"function\"==typeof this.options.placement?this.options.placement.call(this,n[0],this.$element[0]):this.options.placement,l=/\\s?auto?\\s?/i,h=l.test(r);h&&(r=r.replace(l,\"\")||\"top\"),n.detach().css({top:0,left:0,display:\"block\"}).addClass(r).data(\"bs.\"+this.type,this),this.options.container?n.appendTo(this.options.container):n.insertAfter(this.$element);var d=this.getPosition(),p=n[0].offsetWidth,c=n[0].offsetHeight;if(h){var f=r,u=this.options.container?t(this.options.container):this.$element.parent(),g=this.getPosition(u);r=\"bottom\"==r&&d.bottom+c>g.bottom?\"top\":\"top\"==r&&d.top-c<g.top?\"bottom\":\"right\"==r&&d.right+p>g.width?\"left\":\"left\"==r&&d.left-p<g.left?\"right\":r,n.removeClass(f).addClass(r)}var v=this.getCalculatedOffset(r,d,p,c);this.applyPlacement(v,r);var m=function(){var t=s.hoverState;s.$element.trigger(\"shown.bs.\"+s.type),s.hoverState=null,\"out\"==t&&s.leave(s)};t.support.transition&&this.$tip.hasClass(\"fade\")?n.one(\"bsTransitionEnd\",m).emulateTransitionEnd(i.TRANSITION_DURATION):m()}},i.prototype.applyPlacement=function(e,i){var o=this.tip(),s=o[0].offsetWidth,n=o[0].offsetHeight,a=parseInt(o.css(\"margin-top\"),10),r=parseInt(o.css(\"margin-left\"),10);isNaN(a)&&(a=0),isNaN(r)&&(r=0),e.top=e.top+a,e.left=e.left+r,t.offset.setOffset(o[0],t.extend({using:function(t){o.css({top:Math.round(t.top),left:Math.round(t.left)})}},e),0),o.addClass(\"in\");var l=o[0].offsetWidth,h=o[0].offsetHeight;\"top\"==i&&h!=n&&(e.top=e.top+n-h);var d=this.getViewportAdjustedDelta(i,e,l,h);d.left?e.left+=d.left:e.top+=d.top;var p=/top|bottom/.test(i),c=p?2*d.left-s+l:2*d.top-n+h,f=p?\"offsetWidth\":\"offsetHeight\";o.offset(e),this.replaceArrow(c,o[0][f],p)},i.prototype.replaceArrow=function(t,e,i){this.arrow().css(i?\"left\":\"top\",50*(1-t/e)+\"%\").css(i?\"top\":\"left\",\"\")},i.prototype.setContent=function(){var t=this.tip(),e=this.getTitle();t.find(\".tooltip-inner\")[this.options.html?\"html\":\"text\"](e),t.removeClass(\"fade in top bottom left right\")},i.prototype.hide=function(e){function o(){\"in\"!=s.hoverState&&n.detach(),s.$element.removeAttr(\"aria-describedby\").trigger(\"hidden.bs.\"+s.type),e&&e()}var s=this,n=this.tip(),a=t.Event(\"hide.bs.\"+this.type);return this.$element.trigger(a),a.isDefaultPrevented()?void 0:(n.removeClass(\"in\"),t.support.transition&&this.$tip.hasClass(\"fade\")?n.one(\"bsTransitionEnd\",o).emulateTransitionEnd(i.TRANSITION_DURATION):o(),this.hoverState=null,this)},i.prototype.fixTitle=function(){var t=this.$element;(t.attr(\"title\")||\"string\"!=typeof t.attr(\"data-original-title\"))&&t.attr(\"data-original-title\",t.attr(\"title\")||\"\").attr(\"title\",\"\")},i.prototype.hasContent=function(){return this.getTitle()},i.prototype.getPosition=function(e){e=e||this.$element;var i=e[0],o=\"BODY\"==i.tagName,s=i.getBoundingClientRect();null==s.width&&(s=t.extend({},s,{width:s.right-s.left,height:s.bottom-s.top}));var n=o?{top:0,left:0}:e.offset(),a={scroll:o?document.documentElement.scrollTop||document.body.scrollTop:e.scrollTop()},r=o?{width:t(window).width(),height:t(window).height()}:null;return t.extend({},s,a,r,n)},i.prototype.getCalculatedOffset=function(t,e,i,o){return\"bottom\"==t?{top:e.top+e.height,left:e.left+e.width/2-i/2}:\"top\"==t?{top:e.top-o,left:e.left+e.width/2-i/2}:\"left\"==t?{top:e.top+e.height/2-o/2,left:e.left-i}:{top:e.top+e.height/2-o/2,left:e.left+e.width}},i.prototype.getViewportAdjustedDelta=function(t,e,i,o){var s={top:0,left:0};if(!this.$viewport)return s;var n=this.options.viewport&&this.options.viewport.padding||0,a=this.getPosition(this.$viewport);if(/right|left/.test(t)){var r=e.top-n-a.scroll,l=e.top+n-a.scroll+o;r<a.top?s.top=a.top-r:l>a.top+a.height&&(s.top=a.top+a.height-l)}else{var h=e.left-n,d=e.left+n+i;h<a.left?s.left=a.left-h:d>a.width&&(s.left=a.left+a.width-d)}return s},i.prototype.getTitle=function(){var t,e=this.$element,i=this.options;return t=e.attr(\"data-original-title\")||(\"function\"==typeof i.title?i.title.call(e[0]):i.title)},i.prototype.getUID=function(t){do t+=~~(1e6*Math.random());while(document.getElementById(t));return t},i.prototype.tip=function(){return this.$tip=this.$tip||t(this.options.template)},i.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(\".tooltip-arrow\")},i.prototype.enable=function(){this.enabled=!0},i.prototype.disable=function(){this.enabled=!1},i.prototype.toggleEnabled=function(){this.enabled=!this.enabled},i.prototype.toggle=function(e){var i=this;e&&(i=t(e.currentTarget).data(\"bs.\"+this.type),i||(i=new this.constructor(e.currentTarget,this.getDelegateOptions()),t(e.currentTarget).data(\"bs.\"+this.type,i))),i.tip().hasClass(\"in\")?i.leave(i):i.enter(i)},i.prototype.destroy=function(){var t=this;clearTimeout(this.timeout),this.hide(function(){t.$element.off(\".\"+t.type).removeData(\"bs.\"+t.type)})};var o=t.fn.tooltip;t.fn.tooltip=e,t.fn.tooltip.Constructor=i,t.fn.tooltip.noConflict=function(){return t.fn.tooltip=o,this}}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),s=o.data(\"bs.popover\"),n=\"object\"==typeof e&&e;(s||\"destroy\"!=e)&&(s||o.data(\"bs.popover\",s=new i(this,n)),\"string\"==typeof e&&s[e]())})}var i=function(t,e){this.init(\"popover\",t,e)};if(!t.fn.tooltip)throw new Error(\"Popover requires tooltip.js\");i.VERSION=\"3.3.2\",i.DEFAULTS=t.extend({},t.fn.tooltip.Constructor.DEFAULTS,{placement:\"right\",trigger:\"click\",content:\"\",template:'<div class=\"popover\" role=\"tooltip\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>'}),i.prototype=t.extend({},t.fn.tooltip.Constructor.prototype),i.prototype.constructor=i,i.prototype.getDefaults=function(){return i.DEFAULTS},i.prototype.setContent=function(){var t=this.tip(),e=this.getTitle(),i=this.getContent();t.find(\".popover-title\")[this.options.html?\"html\":\"text\"](e),t.find(\".popover-content\").children().detach().end()[this.options.html?\"string\"==typeof i?\"html\":\"append\":\"text\"](i),t.removeClass(\"fade top bottom left right in\"),t.find(\".popover-title\").html()||t.find(\".popover-title\").hide()},i.prototype.hasContent=function(){return this.getTitle()||this.getContent()},i.prototype.getContent=function(){var t=this.$element,e=this.options;return t.attr(\"data-content\")||(\"function\"==typeof e.content?e.content.call(t[0]):e.content)},i.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(\".arrow\")},i.prototype.tip=function(){return this.$tip||(this.$tip=t(this.options.template)),this.$tip};var o=t.fn.popover;t.fn.popover=e,t.fn.popover.Constructor=i,t.fn.popover.noConflict=function(){return t.fn.popover=o,this}}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),s=o.data(\"bs.tab\");s||o.data(\"bs.tab\",s=new i(this)),\"string\"==typeof e&&s[e]()})}var i=function(e){this.element=t(e)};i.VERSION=\"3.3.2\",i.TRANSITION_DURATION=150,i.prototype.show=function(){var e=this.element,i=e.closest(\"ul:not(.dropdown-menu)\"),o=e.data(\"target\");if(o||(o=e.attr(\"href\"),o=o&&o.replace(/.*(?=#[^\\s]*$)/,\"\")),!e.parent(\"li\").hasClass(\"active\")){var s=i.find(\".active:last a\"),n=t.Event(\"hide.bs.tab\",{relatedTarget:e[0]}),a=t.Event(\"show.bs.tab\",{relatedTarget:s[0]});if(s.trigger(n),e.trigger(a),!a.isDefaultPrevented()&&!n.isDefaultPrevented()){var r=t(o);this.activate(e.closest(\"li\"),i),this.activate(r,r.parent(),function(){s.trigger({type:\"hidden.bs.tab\",relatedTarget:e[0]}),e.trigger({type:\"shown.bs.tab\",relatedTarget:s[0]})})}}},i.prototype.activate=function(e,o,s){function n(){a.removeClass(\"active\").find(\"> .dropdown-menu > .active\").removeClass(\"active\").end().find('[data-toggle=\"tab\"]').attr(\"aria-expanded\",!1),e.addClass(\"active\").find('[data-toggle=\"tab\"]').attr(\"aria-expanded\",!0),r?(e[0].offsetWidth,e.addClass(\"in\")):e.removeClass(\"fade\"),e.parent(\".dropdown-menu\")&&e.closest(\"li.dropdown\").addClass(\"active\").end().find('[data-toggle=\"tab\"]').attr(\"aria-expanded\",!0),s&&s()}var a=o.find(\"> .active\"),r=s&&t.support.transition&&(a.length&&a.hasClass(\"fade\")||!!o.find(\"> .fade\").length);a.length&&r?a.one(\"bsTransitionEnd\",n).emulateTransitionEnd(i.TRANSITION_DURATION):n(),a.removeClass(\"in\")};var o=t.fn.tab;t.fn.tab=e,t.fn.tab.Constructor=i,t.fn.tab.noConflict=function(){return t.fn.tab=o,this};var s=function(i){i.preventDefault(),e.call(t(this),\"show\")};t(document).on(\"click.bs.tab.data-api\",'[data-toggle=\"tab\"]',s).on(\"click.bs.tab.data-api\",'[data-toggle=\"pill\"]',s)}(jQuery),+function(t){\"use strict\";function e(e){return this.each(function(){var o=t(this),s=o.data(\"bs.affix\"),n=\"object\"==typeof e&&e;s||o.data(\"bs.affix\",s=new i(this,n)),\"string\"==typeof e&&s[e]()})}var i=function(e,o){this.options=t.extend({},i.DEFAULTS,o),this.$target=t(this.options.target).on(\"scroll.bs.affix.data-api\",t.proxy(this.checkPosition,this)).on(\"click.bs.affix.data-api\",t.proxy(this.checkPositionWithEventLoop,this)),this.$element=t(e),this.affixed=this.unpin=this.pinnedOffset=null,this.checkPosition()};i.VERSION=\"3.3.2\",i.RESET=\"affix affix-top affix-bottom\",i.DEFAULTS={offset:0,target:window},i.prototype.getState=function(t,e,i,o){var s=this.$target.scrollTop(),n=this.$element.offset(),a=this.$target.height();if(null!=i&&\"top\"==this.affixed)return i>s?\"top\":!1;if(\"bottom\"==this.affixed)return null!=i?s+this.unpin<=n.top?!1:\"bottom\":t-o>=s+a?!1:\"bottom\";var r=null==this.affixed,l=r?s:n.top,h=r?a:e;return null!=i&&i>=s?\"top\":null!=o&&l+h>=t-o?\"bottom\":!1},i.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(i.RESET).addClass(\"affix\");var t=this.$target.scrollTop(),e=this.$element.offset();return this.pinnedOffset=e.top-t},i.prototype.checkPositionWithEventLoop=function(){setTimeout(t.proxy(this.checkPosition,this),1)},i.prototype.checkPosition=function(){if(this.$element.is(\":visible\")){var e=this.$element.height(),o=this.options.offset,s=o.top,n=o.bottom,a=t(\"body\").height();\"object\"!=typeof o&&(n=s=o),\"function\"==typeof s&&(s=o.top(this.$element)),\"function\"==typeof n&&(n=o.bottom(this.$element));var r=this.getState(a,e,s,n);if(this.affixed!=r){null!=this.unpin&&this.$element.css(\"top\",\"\");var l=\"affix\"+(r?\"-\"+r:\"\"),h=t.Event(l+\".bs.affix\");if(this.$element.trigger(h),h.isDefaultPrevented())return;this.affixed=r,this.unpin=\"bottom\"==r?this.getPinnedOffset():null,this.$element.removeClass(i.RESET).addClass(l).trigger(l.replace(\"affix\",\"affixed\")+\".bs.affix\")}\"bottom\"==r&&this.$element.offset({top:a-e-n})}};var o=t.fn.affix;t.fn.affix=e,t.fn.affix.Constructor=i,t.fn.affix.noConflict=function(){return t.fn.affix=o,this},t(window).on(\"load\",function(){t('[data-spy=\"affix\"]').each(function(){var i=t(this),o=i.data();o.offset=o.offset||{},null!=o.offsetBottom&&(o.offset.bottom=o.offsetBottom),null!=o.offsetTop&&(o.offset.top=o.offsetTop),e.call(i,o)})})}(jQuery),+function(t){\"use strict\";function e(e){var i,o=e.attr(\"data-target\")||(i=e.attr(\"href\"))&&i.replace(/.*(?=#[^\\s]+$)/,\"\");return t(o)}function i(e){return this.each(function(){var i=t(this),s=i.data(\"bs.collapse\"),n=t.extend({},o.DEFAULTS,i.data(),\"object\"==typeof e&&e);!s&&n.toggle&&\"show\"==e&&(n.toggle=!1),s||i.data(\"bs.collapse\",s=new o(this,n)),\"string\"==typeof e&&s[e]()})}var o=function(e,i){this.$element=t(e),this.options=t.extend({},o.DEFAULTS,i),this.$trigger=t(this.options.trigger).filter('[href=\"#'+e.id+'\"], [data-target=\"#'+e.id+'\"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};o.VERSION=\"3.3.2\",o.TRANSITION_DURATION=350,o.DEFAULTS={toggle:!0,trigger:'[data-toggle=\"collapse\"]'},o.prototype.dimension=function(){var t=this.$element.hasClass(\"width\");return t?\"width\":\"height\"},o.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass(\"in\")){var e,s=this.$parent&&this.$parent.children(\".panel\").children(\".in, .collapsing\");if(!(s&&s.length&&(e=s.data(\"bs.collapse\"),e&&e.transitioning))){var n=t.Event(\"show.bs.collapse\");if(this.$element.trigger(n),!n.isDefaultPrevented()){s&&s.length&&(i.call(s,\"hide\"),e||s.data(\"bs.collapse\",null));var a=this.dimension();this.$element.removeClass(\"collapse\").addClass(\"collapsing\")[a](0).attr(\"aria-expanded\",!0),this.$trigger.removeClass(\"collapsed\").attr(\"aria-expanded\",!0),this.transitioning=1;var r=function(){this.$element.removeClass(\"collapsing\").addClass(\"collapse in\")[a](\"\"),this.transitioning=0,this.$element.trigger(\"shown.bs.collapse\")};if(!t.support.transition)return r.call(this);var l=t.camelCase([\"scroll\",a].join(\"-\"));this.$element.one(\"bsTransitionEnd\",t.proxy(r,this)).emulateTransitionEnd(o.TRANSITION_DURATION)[a](this.$element[0][l])}}}},o.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass(\"in\")){var e=t.Event(\"hide.bs.collapse\");if(this.$element.trigger(e),!e.isDefaultPrevented()){var i=this.dimension();this.$element[i](this.$element[i]())[0].offsetHeight,this.$element.addClass(\"collapsing\").removeClass(\"collapse in\").attr(\"aria-expanded\",!1),this.$trigger.addClass(\"collapsed\").attr(\"aria-expanded\",!1),this.transitioning=1;var s=function(){this.transitioning=0,this.$element.removeClass(\"collapsing\").addClass(\"collapse\").trigger(\"hidden.bs.collapse\")};return t.support.transition?void this.$element[i](0).one(\"bsTransitionEnd\",t.proxy(s,this)).emulateTransitionEnd(o.TRANSITION_DURATION):s.call(this)}}},o.prototype.toggle=function(){this[this.$element.hasClass(\"in\")?\"hide\":\"show\"]()},o.prototype.getParent=function(){return t(this.options.parent).find('[data-toggle=\"collapse\"][data-parent=\"'+this.options.parent+'\"]').each(t.proxy(function(i,o){var s=t(o);this.addAriaAndCollapsedClass(e(s),s)},this)).end()},o.prototype.addAriaAndCollapsedClass=function(t,e){var i=t.hasClass(\"in\");t.attr(\"aria-expanded\",i),e.toggleClass(\"collapsed\",!i).attr(\"aria-expanded\",i)};var s=t.fn.collapse;t.fn.collapse=i,t.fn.collapse.Constructor=o,t.fn.collapse.noConflict=function(){return t.fn.collapse=s,this},t(document).on(\"click.bs.collapse.data-api\",'[data-toggle=\"collapse\"]',function(o){var s=t(this);s.attr(\"data-target\")||o.preventDefault();\nvar n=e(s),a=n.data(\"bs.collapse\"),r=a?\"toggle\":t.extend({},s.data(),{trigger:this});i.call(n,r)})}(jQuery),+function(t){\"use strict\";function e(i,o){var s=t.proxy(this.process,this);this.$body=t(\"body\"),this.$scrollElement=t(t(i).is(\"body\")?window:i),this.options=t.extend({},e.DEFAULTS,o),this.selector=(this.options.target||\"\")+\" .nav li > a\",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on(\"scroll.bs.scrollspy\",s),this.refresh(),this.process()}function i(i){return this.each(function(){var o=t(this),s=o.data(\"bs.scrollspy\"),n=\"object\"==typeof i&&i;s||o.data(\"bs.scrollspy\",s=new e(this,n)),\"string\"==typeof i&&s[i]()})}e.VERSION=\"3.3.2\",e.DEFAULTS={offset:10},e.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},e.prototype.refresh=function(){var e=\"offset\",i=0;t.isWindow(this.$scrollElement[0])||(e=\"position\",i=this.$scrollElement.scrollTop()),this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight();var o=this;this.$body.find(this.selector).map(function(){var o=t(this),s=o.data(\"target\")||o.attr(\"href\"),n=/^#./.test(s)&&t(s);return n&&n.length&&n.is(\":visible\")&&[[n[e]().top+i,s]]||null}).sort(function(t,e){return t[0]-e[0]}).each(function(){o.offsets.push(this[0]),o.targets.push(this[1])})},e.prototype.process=function(){var t,e=this.$scrollElement.scrollTop()+this.options.offset,i=this.getScrollHeight(),o=this.options.offset+i-this.$scrollElement.height(),s=this.offsets,n=this.targets,a=this.activeTarget;if(this.scrollHeight!=i&&this.refresh(),e>=o)return a!=(t=n[n.length-1])&&this.activate(t);if(a&&e<s[0])return this.activeTarget=null,this.clear();for(t=s.length;t--;)a!=n[t]&&e>=s[t]&&(!s[t+1]||e<=s[t+1])&&this.activate(n[t])},e.prototype.activate=function(e){this.activeTarget=e,this.clear();var i=this.selector+'[data-target=\"'+e+'\"],'+this.selector+'[href=\"'+e+'\"]',o=t(i).parents(\"li\").addClass(\"active\");o.parent(\".dropdown-menu\").length&&(o=o.closest(\"li.dropdown\").addClass(\"active\")),o.trigger(\"activate.bs.scrollspy\")},e.prototype.clear=function(){t(this.selector).parentsUntil(this.options.target,\".active\").removeClass(\"active\")};var o=t.fn.scrollspy;t.fn.scrollspy=i,t.fn.scrollspy.Constructor=e,t.fn.scrollspy.noConflict=function(){return t.fn.scrollspy=o,this},t(window).on(\"load.bs.scrollspy.data-api\",function(){t('[data-spy=\"scroll\"]').each(function(){var e=t(this);i.call(e,e.data())})})}(jQuery),+function(t){\"use strict\";function e(){var t=document.createElement(\"bootstrap\"),e={WebkitTransition:\"webkitTransitionEnd\",MozTransition:\"transitionend\",OTransition:\"oTransitionEnd otransitionend\",transition:\"transitionend\"};for(var i in e)if(void 0!==t.style[i])return{end:e[i]};return!1}t.fn.emulateTransitionEnd=function(e){var i=!1,o=this;t(this).one(\"bsTransitionEnd\",function(){i=!0});var s=function(){i||t(o).trigger(t.support.transition.end)};return setTimeout(s,e),this},t(function(){t.support.transition=e(),t.support.transition&&(t.event.special.bsTransitionEnd={bindType:t.support.transition.end,delegateType:t.support.transition.end,handle:function(e){return t(e.target).is(this)?e.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery);"

/***/ },
/* 1182 */
/***/ function(module, exports) {

	module.exports = "/*! jQuery v2.1.1 | (c) 2005, 2014 jQuery Foundation, Inc. | jquery.org/license */\n!function(a,b){\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error(\"jQuery requires a window with a document\");return b(a)}:b(a)}(\"undefined\"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l=a.document,m=\"2.1.1\",n=function(a,b){return new n.fn.init(a,b)},o=/^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g,p=/^-ms-/,q=/-([\\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:\"\",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return n.each(this,a,b)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for(\"boolean\"==typeof g&&(j=g,g=arguments[h]||{},h++),\"object\"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:\"jQuery\"+(m+Math.random()).replace(/\\D/g,\"\"),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return\"function\"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){return!n.isArray(a)&&a-parseFloat(a)>=0},isPlainObject:function(a){return\"object\"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!j.call(a.constructor.prototype,\"isPrototypeOf\")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+\"\":\"object\"==typeof a||\"function\"==typeof a?h[i.call(a)]||\"object\":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf(\"use strict\")?(b=l.createElement(\"script\"),b.text=a,l.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,\"ms-\").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=s(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?\"\":(a+\"\").replace(o,\"\")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,\"string\"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:g.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=s(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return\"string\"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(e=d.call(arguments,2),f=function(){return a.apply(b||this,e.concat(d.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:k}),n.each(\"Boolean Number String Function Array Date RegExp Object Error\".split(\" \"),function(a,b){h[\"[object \"+b+\"]\"]=b.toLowerCase()});function s(a){var b=a.length,c=n.type(a);return\"function\"===c||n.isWindow(a)?!1:1===a.nodeType&&b?!0:\"array\"===c||0===b||\"number\"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u=\"sizzle\"+-new Date,v=a.document,w=0,x=0,y=gb(),z=gb(),A=gb(),B=function(a,b){return a===b&&(l=!0),0},C=\"undefined\",D=1<<31,E={}.hasOwnProperty,F=[],G=F.pop,H=F.push,I=F.push,J=F.slice,K=F.indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(this[b]===a)return b;return-1},L=\"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",M=\"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",N=\"(?:\\\\\\\\.|[\\\\w-]|[^\\\\x00-\\\\xa0])+\",O=N.replace(\"w\",\"w#\"),P=\"\\\\[\"+M+\"*(\"+N+\")(?:\"+M+\"*([*^$|!~]?=)\"+M+\"*(?:'((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\"|(\"+O+\"))|)\"+M+\"*\\\\]\",Q=\":(\"+N+\")(?:\\\\((('((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\"+P+\")*)|.*)\\\\)|)\",R=new RegExp(\"^\"+M+\"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\"+M+\"+$\",\"g\"),S=new RegExp(\"^\"+M+\"*,\"+M+\"*\"),T=new RegExp(\"^\"+M+\"*([>+~]|\"+M+\")\"+M+\"*\"),U=new RegExp(\"=\"+M+\"*([^\\\\]'\\\"]*?)\"+M+\"*\\\\]\",\"g\"),V=new RegExp(Q),W=new RegExp(\"^\"+O+\"$\"),X={ID:new RegExp(\"^#(\"+N+\")\"),CLASS:new RegExp(\"^\\\\.(\"+N+\")\"),TAG:new RegExp(\"^(\"+N.replace(\"w\",\"w*\")+\")\"),ATTR:new RegExp(\"^\"+P),PSEUDO:new RegExp(\"^\"+Q),CHILD:new RegExp(\"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\"+M+\"*(even|odd|(([+-]|)(\\\\d*)n|)\"+M+\"*(?:([+-]|)\"+M+\"*(\\\\d+)|))\"+M+\"*\\\\)|)\",\"i\"),bool:new RegExp(\"^(?:\"+L+\")$\",\"i\"),needsContext:new RegExp(\"^\"+M+\"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\"+M+\"*((?:-\\\\d)?\\\\d*)\"+M+\"*\\\\)|)(?=[^-]|$)\",\"i\")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\\d$/i,$=/^[^{]+\\{\\s*\\[native \\w/,_=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,ab=/[+~]/,bb=/'|\\\\/g,cb=new RegExp(\"\\\\\\\\([\\\\da-f]{1,6}\"+M+\"?|(\"+M+\")|.)\",\"ig\"),db=function(a,b,c){var d=\"0x\"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)};try{I.apply(F=J.call(v.childNodes),v.childNodes),F[v.childNodes.length].nodeType}catch(eb){I={apply:F.length?function(a,b){H.apply(a,J.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fb(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],!a||\"string\"!=typeof a)return d;if(1!==(k=b.nodeType)&&9!==k)return[];if(p&&!e){if(f=_.exec(a))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return I.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName&&b.getElementsByClassName)return I.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=9===k&&a,1===k&&\"object\"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute(\"id\"))?s=r.replace(bb,\"\\\\$&\"):b.setAttribute(\"id\",s),s=\"[id='\"+s+\"'] \",l=o.length;while(l--)o[l]=s+qb(o[l]);w=ab.test(a)&&ob(b.parentNode)||b,x=o.join(\",\")}if(x)try{return I.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute(\"id\")}}}return i(a.replace(R,\"$1\"),b,d,e)}function gb(){var a=[];function b(c,e){return a.push(c+\" \")>d.cacheLength&&delete b[a.shift()],b[c+\" \"]=e}return b}function hb(a){return a[u]=!0,a}function ib(a){var b=n.createElement(\"div\");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function jb(a,b){var c=a.split(\"|\"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function kb(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||D)-(~a.sourceIndex||D);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function lb(a){return function(b){var c=b.nodeName.toLowerCase();return\"input\"===c&&b.type===a}}function mb(a){return function(b){var c=b.nodeName.toLowerCase();return(\"input\"===c||\"button\"===c)&&b.type===a}}function nb(a){return hb(function(b){return b=+b,hb(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function ob(a){return a&&typeof a.getElementsByTagName!==C&&a}c=fb.support={},f=fb.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?\"HTML\"!==b.nodeName:!1},m=fb.setDocument=function(a){var b,e=a?a.ownerDocument||a:v,g=e.defaultView;return e!==n&&9===e.nodeType&&e.documentElement?(n=e,o=e.documentElement,p=!f(e),g&&g!==g.top&&(g.addEventListener?g.addEventListener(\"unload\",function(){m()},!1):g.attachEvent&&g.attachEvent(\"onunload\",function(){m()})),c.attributes=ib(function(a){return a.className=\"i\",!a.getAttribute(\"className\")}),c.getElementsByTagName=ib(function(a){return a.appendChild(e.createComment(\"\")),!a.getElementsByTagName(\"*\").length}),c.getElementsByClassName=$.test(e.getElementsByClassName)&&ib(function(a){return a.innerHTML=\"<div class='a'></div><div class='a i'></div>\",a.firstChild.className=\"i\",2===a.getElementsByClassName(\"i\").length}),c.getById=ib(function(a){return o.appendChild(a).id=u,!e.getElementsByName||!e.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if(typeof b.getElementById!==C&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(cb,db);return function(a){return a.getAttribute(\"id\")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(cb,db);return function(a){var c=typeof a.getAttributeNode!==C&&a.getAttributeNode(\"id\");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return typeof b.getElementsByTagName!==C?b.getElementsByTagName(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if(\"*\"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return typeof b.getElementsByClassName!==C&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(e.querySelectorAll))&&(ib(function(a){a.innerHTML=\"<select msallowclip=''><option selected=''></option></select>\",a.querySelectorAll(\"[msallowclip^='']\").length&&q.push(\"[*^$]=\"+M+\"*(?:''|\\\"\\\")\"),a.querySelectorAll(\"[selected]\").length||q.push(\"\\\\[\"+M+\"*(?:value|\"+L+\")\"),a.querySelectorAll(\":checked\").length||q.push(\":checked\")}),ib(function(a){var b=e.createElement(\"input\");b.setAttribute(\"type\",\"hidden\"),a.appendChild(b).setAttribute(\"name\",\"D\"),a.querySelectorAll(\"[name=d]\").length&&q.push(\"name\"+M+\"*[*^$|!~]?=\"),a.querySelectorAll(\":enabled\").length||q.push(\":enabled\",\":disabled\"),a.querySelectorAll(\"*,:x\"),q.push(\",.*:\")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ib(function(a){c.disconnectedMatch=s.call(a,\"div\"),s.call(a,\"[s!='']:x\"),r.push(\"!=\",Q)}),q=q.length&&new RegExp(q.join(\"|\")),r=r.length&&new RegExp(r.join(\"|\")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===e||a.ownerDocument===v&&t(v,a)?-1:b===e||b.ownerDocument===v&&t(v,b)?1:k?K.call(k,a)-K.call(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,f=a.parentNode,g=b.parentNode,h=[a],i=[b];if(!f||!g)return a===e?-1:b===e?1:f?-1:g?1:k?K.call(k,a)-K.call(k,b):0;if(f===g)return kb(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?kb(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},e):n},fb.matches=function(a,b){return fb(a,null,null,b)},fb.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,\"='$1']\"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fb(b,n,null,[a]).length>0},fb.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fb.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&E.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fb.error=function(a){throw new Error(\"Syntax error, unrecognized expression: \"+a)},fb.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fb.getText=function(a){var b,c=\"\",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if(\"string\"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fb.selectors={cacheLength:50,createPseudo:hb,match:X,attrHandle:{},find:{},relative:{\">\":{dir:\"parentNode\",first:!0},\" \":{dir:\"parentNode\"},\"+\":{dir:\"previousSibling\",first:!0},\"~\":{dir:\"previousSibling\"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(cb,db),a[3]=(a[3]||a[4]||a[5]||\"\").replace(cb,db),\"~=\"===a[2]&&(a[3]=\" \"+a[3]+\" \"),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),\"nth\"===a[1].slice(0,3)?(a[3]||fb.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*(\"even\"===a[3]||\"odd\"===a[3])),a[5]=+(a[7]+a[8]||\"odd\"===a[3])):a[3]&&fb.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||\"\":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(\")\",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(cb,db).toLowerCase();return\"*\"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+\" \"];return b||(b=new RegExp(\"(^|\"+M+\")\"+a+\"(\"+M+\"|$)\"))&&y(a,function(a){return b.test(\"string\"==typeof a.className&&a.className||typeof a.getAttribute!==C&&a.getAttribute(\"class\")||\"\")})},ATTR:function(a,b,c){return function(d){var e=fb.attr(d,a);return null==e?\"!=\"===b:b?(e+=\"\",\"=\"===b?e===c:\"!=\"===b?e!==c:\"^=\"===b?c&&0===e.indexOf(c):\"*=\"===b?c&&e.indexOf(c)>-1:\"$=\"===b?c&&e.slice(-c.length)===c:\"~=\"===b?(\" \"+e+\" \").indexOf(c)>-1:\"|=\"===b?e===c||e.slice(0,c.length+1)===c+\"-\":!1):!0}},CHILD:function(a,b,c,d,e){var f=\"nth\"!==a.slice(0,3),g=\"last\"!==a.slice(-4),h=\"of-type\"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?\"nextSibling\":\"previousSibling\",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p=\"only\"===a&&!o&&\"nextSibling\"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fb.error(\"unsupported pseudo: \"+a);return e[u]?e(b):e.length>1?(c=[a,a,\"\",b],d.setFilters.hasOwnProperty(a.toLowerCase())?hb(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=K.call(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:hb(function(a){var b=[],c=[],d=h(a.replace(R,\"$1\"));return d[u]?hb(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),!c.pop()}}),has:hb(function(a){return function(b){return fb(a,b).length>0}}),contains:hb(function(a){return function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:hb(function(a){return W.test(a||\"\")||fb.error(\"unsupported lang: \"+a),a=a.replace(cb,db).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute(\"xml:lang\")||b.getAttribute(\"lang\"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+\"-\");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return\"input\"===b&&!!a.checked||\"option\"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return\"input\"===b&&\"button\"===a.type||\"button\"===b},text:function(a){var b;return\"input\"===a.nodeName.toLowerCase()&&\"text\"===a.type&&(null==(b=a.getAttribute(\"type\"))||\"text\"===b.toLowerCase())},first:nb(function(){return[0]}),last:nb(function(a,b){return[b-1]}),eq:nb(function(a,b,c){return[0>c?c+b:c]}),even:nb(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:nb(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:nb(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:nb(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=lb(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=mb(b);function pb(){}pb.prototype=d.filters=d.pseudos,d.setFilters=new pb,g=fb.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+\" \"];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R,\" \")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fb.error(a):z(a,i).slice(0)};function qb(a){for(var b=0,c=a.length,d=\"\";c>b;b++)d+=a[b].value;return d}function rb(a,b,c){var d=b.dir,e=c&&\"parentNode\"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function sb(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function tb(a,b,c){for(var d=0,e=b.length;e>d;d++)fb(a,b[d],c);return c}function ub(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function vb(a,b,c,d,e,f){return d&&!d[u]&&(d=vb(d)),e&&!e[u]&&(e=vb(e,f)),hb(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||tb(b||\"*\",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ub(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ub(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?K.call(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ub(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):I.apply(g,r)})}function wb(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[\" \"],i=g?1:0,k=rb(function(a){return a===b},h,!0),l=rb(function(a){return K.call(b,a)>-1},h,!0),m=[function(a,c,d){return!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d))}];f>i;i++)if(c=d.relative[a[i].type])m=[rb(sb(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return vb(i>1&&sb(m),i>1&&qb(a.slice(0,i-1).concat({value:\" \"===a[i-2].type?\"*\":\"\"})).replace(R,\"$1\"),c,e>i&&wb(a.slice(i,e)),f>e&&wb(a=a.slice(e)),f>e&&qb(a))}m.push(c)}return sb(m)}function xb(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q=\"0\",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG(\"*\",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=G.call(i));s=ub(s)}I.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&fb.uniqueSort(i)}return k&&(w=v,j=t),r};return c?hb(f):f}return h=fb.compile=function(a,b){var c,d=[],e=[],f=A[a+\" \"];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wb(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xb(e,d)),f.selector=a}return f},i=fb.select=function(a,b,e,f){var i,j,k,l,m,n=\"function\"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&\"ID\"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(cb,db),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(cb,db),ab.test(j[0].type)&&ob(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qb(j),!a)return I.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,ab.test(a)&&ob(b.parentNode)||b),e},c.sortStable=u.split(\"\").sort(B).join(\"\")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ib(function(a){return 1&a.compareDocumentPosition(n.createElement(\"div\"))}),ib(function(a){return a.innerHTML=\"<a href='#'></a>\",\"#\"===a.firstChild.getAttribute(\"href\")})||jb(\"type|href|height|width\",function(a,b,c){return c?void 0:a.getAttribute(b,\"type\"===b.toLowerCase()?1:2)}),c.attributes&&ib(function(a){return a.innerHTML=\"<input/>\",a.firstChild.setAttribute(\"value\",\"\"),\"\"===a.firstChild.getAttribute(\"value\")})||jb(\"value\",function(a,b,c){return c||\"input\"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ib(function(a){return null==a.getAttribute(\"disabled\")})||jb(L,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fb}(a);n.find=t,n.expr=t.selectors,n.expr[\":\"]=n.expr.pseudos,n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=n.expr.match.needsContext,v=/^<(\\w+)\\s*\\/?>(?:<\\/\\1>|)$/,w=/^.[^:#\\[\\.,]*$/;function x(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if(\"string\"==typeof b){if(w.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return g.call(b,a)>=0!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=\":not(\"+a+\")\"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if(\"string\"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+\" \"+a:a,d},filter:function(a){return this.pushStack(x(this,a||[],!1))},not:function(a){return this.pushStack(x(this,a||[],!0))},is:function(a){return!!x(this,\"string\"==typeof a&&u.test(a)?n(a):a||[],!1).length}});var y,z=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]*))$/,A=n.fn.init=function(a,b){var c,d;if(!a)return this;if(\"string\"==typeof a){if(c=\"<\"===a[0]&&\">\"===a[a.length-1]&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||y).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:l,!0)),v.test(c[1])&&n.isPlainObject(b))for(c in b)n.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}return d=l.getElementById(c[2]),d&&d.parentNode&&(this.length=1,this[0]=d),this.context=l,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?\"undefined\"!=typeof y.ready?y.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};A.prototype=n.fn,y=n(l);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};n.extend({dir:function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=u.test(a)||\"string\"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.unique(f):f)},index:function(a){return a?\"string\"==typeof a?g.call(n(a),this[0]):g.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.unique(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return n.dir(a,\"parentNode\")},parentsUntil:function(a,b,c){return n.dir(a,\"parentNode\",c)},next:function(a){return D(a,\"nextSibling\")},prev:function(a){return D(a,\"previousSibling\")},nextAll:function(a){return n.dir(a,\"nextSibling\")},prevAll:function(a){return n.dir(a,\"previousSibling\")},nextUntil:function(a,b,c){return n.dir(a,\"nextSibling\",c)},prevUntil:function(a,b,c){return n.dir(a,\"previousSibling\",c)},siblings:function(a){return n.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return n.sibling(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return\"Until\"!==a.slice(-5)&&(d=c),d&&\"string\"==typeof d&&(e=n.filter(d,e)),this.length>1&&(C[a]||n.unique(e),B.test(a)&&e.reverse()),this.pushStack(e)}});var E=/\\S+/g,F={};function G(a){var b=F[a]={};return n.each(a.match(E)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a=\"string\"==typeof a?F[a]||G(a):n.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(b=a.memory&&l,c=!0,g=e||0,e=0,f=h.length,d=!0;h&&f>g;g++)if(h[g].apply(l[0],l[1])===!1&&a.stopOnFalse){b=!1;break}d=!1,h&&(i?i.length&&j(i.shift()):b?h=[]:k.disable())},k={add:function(){if(h){var c=h.length;!function g(b){n.each(b,function(b,c){var d=n.type(c);\"function\"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&\"string\"!==d&&g(c)})}(arguments),d?f=h.length:b&&(e=c,j(b))}return this},remove:function(){return h&&n.each(arguments,function(a,b){var c;while((c=n.inArray(b,h,c))>-1)h.splice(c,1),d&&(f>=c&&f--,g>=c&&g--)}),this},has:function(a){return a?n.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],f=0,this},disable:function(){return h=i=b=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,b||k.disable(),this},locked:function(){return!i},fireWith:function(a,b){return!h||c&&!i||(b=b||[],b=[a,b.slice?b.slice():b],d?i.push(b):j(b)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!c}};return k},n.extend({Deferred:function(a){var b=[[\"resolve\",\"done\",n.Callbacks(\"once memory\"),\"resolved\"],[\"reject\",\"fail\",n.Callbacks(\"once memory\"),\"rejected\"],[\"notify\",\"progress\",n.Callbacks(\"memory\")]],c=\"pending\",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+\"With\"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+\"With\"](this===e?d:this,arguments),this},e[f[0]+\"With\"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&n.isFunction(a.promise)?e:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(H.resolveWith(l,[n]),n.fn.triggerHandler&&(n(l).triggerHandler(\"ready\"),n(l).off(\"ready\"))))}});function I(){l.removeEventListener(\"DOMContentLoaded\",I,!1),a.removeEventListener(\"load\",I,!1),n.ready()}n.ready.promise=function(b){return H||(H=n.Deferred(),\"complete\"===l.readyState?setTimeout(n.ready):(l.addEventListener(\"DOMContentLoaded\",I,!1),a.addEventListener(\"load\",I,!1))),H.promise(b)},n.ready.promise();var J=n.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if(\"object\"===n.type(c)){e=!0;for(h in c)n.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f};n.acceptData=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function K(){Object.defineProperty(this.cache={},0,{get:function(){return{}}}),this.expando=n.expando+Math.random()}K.uid=1,K.accepts=n.acceptData,K.prototype={key:function(a){if(!K.accepts(a))return 0;var b={},c=a[this.expando];if(!c){c=K.uid++;try{b[this.expando]={value:c},Object.defineProperties(a,b)}catch(d){b[this.expando]=c,n.extend(a,b)}}return this.cache[c]||(this.cache[c]={}),c},set:function(a,b,c){var d,e=this.key(a),f=this.cache[e];if(\"string\"==typeof b)f[b]=c;else if(n.isEmptyObject(f))n.extend(this.cache[e],b);else for(d in b)f[d]=b[d];return f},get:function(a,b){var c=this.cache[this.key(a)];return void 0===b?c:c[b]},access:function(a,b,c){var d;return void 0===b||b&&\"string\"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=this.key(a),g=this.cache[f];if(void 0===b)this.cache[f]={};else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in g?d=[b,e]:(d=e,d=d in g?[d]:d.match(E)||[])),c=d.length;while(c--)delete g[d[c]]}},hasData:function(a){return!n.isEmptyObject(this.cache[a[this.expando]]||{})},discard:function(a){a[this.expando]&&delete this.cache[a[this.expando]]}};var L=new K,M=new K,N=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,O=/([A-Z])/g;function P(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d=\"data-\"+b.replace(O,\"-$1\").toLowerCase(),c=a.getAttribute(d),\"string\"==typeof c){try{c=\"true\"===c?!0:\"false\"===c?!1:\"null\"===c?null:+c+\"\"===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}M.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return M.hasData(a)||L.hasData(a)},data:function(a,b,c){return M.access(a,b,c)},removeData:function(a,b){M.remove(a,b)\n},_data:function(a,b,c){return L.access(a,b,c)},_removeData:function(a,b){L.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=M.get(f),1===f.nodeType&&!L.get(f,\"hasDataAttrs\"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf(\"data-\")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));L.set(f,\"hasDataAttrs\",!0)}return e}return\"object\"==typeof a?this.each(function(){M.set(this,a)}):J(this,function(b){var c,d=n.camelCase(a);if(f&&void 0===b){if(c=M.get(f,a),void 0!==c)return c;if(c=M.get(f,d),void 0!==c)return c;if(c=P(f,d,void 0),void 0!==c)return c}else this.each(function(){var c=M.get(this,d);M.set(this,d,b),-1!==a.indexOf(\"-\")&&void 0!==c&&M.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){M.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||\"fx\")+\"queue\",d=L.get(a,b),c&&(!d||n.isArray(c)?d=L.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||\"fx\";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};\"inprogress\"===e&&(e=c.shift(),d--),e&&(\"fx\"===b&&c.unshift(\"inprogress\"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+\"queueHooks\";return L.get(a,c)||L.access(a,c,{empty:n.Callbacks(\"once memory\").add(function(){L.remove(a,[b+\"queue\",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return\"string\"!=typeof a&&(b=a,a=\"fx\",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),\"fx\"===a&&\"inprogress\"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||\"fx\",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};\"string\"!=typeof a&&(b=a,a=void 0),a=a||\"fx\";while(g--)c=L.get(f[g],a+\"queueHooks\"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var Q=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,R=[\"Top\",\"Right\",\"Bottom\",\"Left\"],S=function(a,b){return a=b||a,\"none\"===n.css(a,\"display\")||!n.contains(a.ownerDocument,a)},T=/^(?:checkbox|radio)$/i;!function(){var a=l.createDocumentFragment(),b=a.appendChild(l.createElement(\"div\")),c=l.createElement(\"input\");c.setAttribute(\"type\",\"radio\"),c.setAttribute(\"checked\",\"checked\"),c.setAttribute(\"name\",\"t\"),b.appendChild(c),k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML=\"<textarea>x</textarea>\",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var U=\"undefined\";k.focusinBubbles=\"onfocusin\"in a;var V=/^key/,W=/^(?:mouse|pointer|contextmenu)|click/,X=/^(?:focusinfocus|focusoutblur)$/,Y=/^([^.]*)(?:\\.(.+)|)$/;function Z(){return!0}function $(){return!1}function _(){try{return l.activeElement}catch(a){}}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return typeof n!==U&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||\"\").match(E)||[\"\"],j=b.length;while(j--)h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||\"\").split(\".\").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(\".\")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g,!1)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.hasData(a)&&L.get(a);if(r&&(i=r.events)){b=(b||\"\").match(E)||[\"\"],j=b.length;while(j--)if(h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||\"\").split(\".\").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp(\"(^|\\\\.)\"+p.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&(\"**\"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&(delete r.handle,L.remove(a,\"events\"))}},trigger:function(b,c,d,e){var f,g,h,i,k,m,o,p=[d||l],q=j.call(b,\"type\")?b.type:b,r=j.call(b,\"namespace\")?b.namespace.split(\".\"):[];if(g=h=d=d||l,3!==d.nodeType&&8!==d.nodeType&&!X.test(q+n.event.triggered)&&(q.indexOf(\".\")>=0&&(r=q.split(\".\"),q=r.shift(),r.sort()),k=q.indexOf(\":\")<0&&\"on\"+q,b=b[n.expando]?b:new n.Event(q,\"object\"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=r.join(\".\"),b.namespace_re=b.namespace?new RegExp(\"(^|\\\\.)\"+r.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},e||!o.trigger||o.trigger.apply(d,c)!==!1)){if(!e&&!o.noBubble&&!n.isWindow(d)){for(i=o.delegateType||q,X.test(i+q)||(g=g.parentNode);g;g=g.parentNode)p.push(g),h=g;h===(d.ownerDocument||l)&&p.push(h.defaultView||h.parentWindow||a)}f=0;while((g=p[f++])&&!b.isPropagationStopped())b.type=f>1?i:o.bindType||q,m=(L.get(g,\"events\")||{})[b.type]&&L.get(g,\"handle\"),m&&m.apply(g,c),m=k&&g[k],m&&m.apply&&n.acceptData(g)&&(b.result=m.apply(g,c),b.result===!1&&b.preventDefault());return b.type=q,e||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!n.acceptData(d)||k&&n.isFunction(d[q])&&!n.isWindow(d)&&(h=d[k],h&&(d[k]=null),n.event.triggered=q,d[q](),n.event.triggered=void 0,h&&(d[k]=h)),b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(L.get(this,\"events\")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(g.namespace))&&(a.handleObj=g,a.data=g.data,e=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(a.result=e)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||\"click\"!==a.type))for(;i!==this;i=i.parentNode||this)if(i.disabled!==!0||\"click\"!==a.type){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+\" \",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>=0:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:\"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which\".split(\" \"),fixHooks:{},keyHooks:{props:\"char charCode key keyCode\".split(\" \"),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:\"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement\".split(\" \"),filter:function(a,b){var c,d,e,f=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||l,d=c.documentElement,e=c.body,a.pageX=b.clientX+(d&&d.scrollLeft||e&&e.scrollLeft||0)-(d&&d.clientLeft||e&&e.clientLeft||0),a.pageY=b.clientY+(d&&d.scrollTop||e&&e.scrollTop||0)-(d&&d.clientTop||e&&e.clientTop||0)),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=W.test(e)?this.mouseHooks:V.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new n.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=l),3===a.target.nodeType&&(a.target=a.target.parentNode),g.filter?g.filter(a,f):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==_()&&this.focus?(this.focus(),!1):void 0},delegateType:\"focusin\"},blur:{trigger:function(){return this===_()&&this.blur?(this.blur(),!1):void 0},delegateType:\"focusout\"},click:{trigger:function(){return\"checkbox\"===this.type&&this.click&&n.nodeName(this,\"input\")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,\"a\")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=n.extend(new n.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?n.event.trigger(e,null,b):n.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?Z:$):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={isDefaultPrevented:$,isPropagationStopped:$,isImmediatePropagationStopped:$,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=Z,a&&a.preventDefault&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=Z,a&&a.stopPropagation&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=Z,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:\"mouseover\",mouseleave:\"mouseout\",pointerenter:\"pointerover\",pointerleave:\"pointerout\"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.focusinBubbles||n.each({focus:\"focusin\",blur:\"focusout\"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a),!0)};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=L.access(d,b);e||d.addEventListener(a,c,!0),L.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=L.access(d,b)-1;e?L.access(d,b,e):(d.removeEventListener(a,c,!0),L.remove(d,b))}}}),n.fn.extend({on:function(a,b,c,d,e){var f,g;if(\"object\"==typeof a){\"string\"!=typeof b&&(c=c||b,b=void 0);for(g in a)this.on(g,b,c,a[g],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&(\"string\"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=$;else if(!d)return this;return 1===e&&(f=d,d=function(a){return n().off(a),f.apply(this,arguments)},d.guid=f.guid||(f.guid=n.guid++)),this.each(function(){n.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+\".\"+d.namespace:d.origType,d.selector,d.handler),this;if(\"object\"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||\"function\"==typeof b)&&(c=b,b=void 0),c===!1&&(c=$),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var ab=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\\w:]+)[^>]*)\\/>/gi,bb=/<([\\w:]+)/,cb=/<|&#?\\w+;/,db=/<(?:script|style|link)/i,eb=/checked\\s*(?:[^=]|=\\s*.checked.)/i,fb=/^$|\\/(?:java|ecma)script/i,gb=/^true\\/(.*)/,hb=/^\\s*<!(?:\\[CDATA\\[|--)|(?:\\]\\]|--)>\\s*$/g,ib={option:[1,\"<select multiple='multiple'>\",\"</select>\"],thead:[1,\"<table>\",\"</table>\"],col:[2,\"<table><colgroup>\",\"</colgroup></table>\"],tr:[2,\"<table><tbody>\",\"</tbody></table>\"],td:[3,\"<table><tbody><tr>\",\"</tr></tbody></table>\"],_default:[0,\"\",\"\"]};ib.optgroup=ib.option,ib.tbody=ib.tfoot=ib.colgroup=ib.caption=ib.thead,ib.th=ib.td;function jb(a,b){return n.nodeName(a,\"table\")&&n.nodeName(11!==b.nodeType?b:b.firstChild,\"tr\")?a.getElementsByTagName(\"tbody\")[0]||a.appendChild(a.ownerDocument.createElement(\"tbody\")):a}function kb(a){return a.type=(null!==a.getAttribute(\"type\"))+\"/\"+a.type,a}function lb(a){var b=gb.exec(a.type);return b?a.type=b[1]:a.removeAttribute(\"type\"),a}function mb(a,b){for(var c=0,d=a.length;d>c;c++)L.set(a[c],\"globalEval\",!b||L.get(b[c],\"globalEval\"))}function nb(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(L.hasData(a)&&(f=L.access(a),g=L.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}M.hasData(a)&&(h=M.access(a),i=n.extend({},h),M.set(b,i))}}function ob(a,b){var c=a.getElementsByTagName?a.getElementsByTagName(b||\"*\"):a.querySelectorAll?a.querySelectorAll(b||\"*\"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function pb(a,b){var c=b.nodeName.toLowerCase();\"input\"===c&&T.test(a.type)?b.checked=a.checked:(\"input\"===c||\"textarea\"===c)&&(b.defaultValue=a.defaultValue)}n.extend({clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=ob(h),f=ob(a),d=0,e=f.length;e>d;d++)pb(f[d],g[d]);if(b)if(c)for(f=f||ob(a),g=g||ob(h),d=0,e=f.length;e>d;d++)nb(f[d],g[d]);else nb(a,h);return g=ob(h,\"script\"),g.length>0&&mb(g,!i&&ob(a,\"script\")),h},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k=b.createDocumentFragment(),l=[],m=0,o=a.length;o>m;m++)if(e=a[m],e||0===e)if(\"object\"===n.type(e))n.merge(l,e.nodeType?[e]:e);else if(cb.test(e)){f=f||k.appendChild(b.createElement(\"div\")),g=(bb.exec(e)||[\"\",\"\"])[1].toLowerCase(),h=ib[g]||ib._default,f.innerHTML=h[1]+e.replace(ab,\"<$1></$2>\")+h[2],j=h[0];while(j--)f=f.lastChild;n.merge(l,f.childNodes),f=k.firstChild,f.textContent=\"\"}else l.push(b.createTextNode(e));k.textContent=\"\",m=0;while(e=l[m++])if((!d||-1===n.inArray(e,d))&&(i=n.contains(e.ownerDocument,e),f=ob(k.appendChild(e),\"script\"),i&&mb(f),c)){j=0;while(e=f[j++])fb.test(e.type||\"\")&&c.push(e)}return k},cleanData:function(a){for(var b,c,d,e,f=n.event.special,g=0;void 0!==(c=a[g]);g++){if(n.acceptData(c)&&(e=c[L.expando],e&&(b=L.cache[e]))){if(b.events)for(d in b.events)f[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);L.cache[e]&&delete L.cache[e]}delete M.cache[c[M.expando]]}}}),n.fn.extend({text:function(a){return J(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=jb(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=jb(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?n.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||n.cleanData(ob(c)),c.parentNode&&(b&&n.contains(c.ownerDocument,c)&&mb(ob(c,\"script\")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(ob(a,!1)),a.textContent=\"\");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return J(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if(\"string\"==typeof a&&!db.test(a)&&!ib[(bb.exec(a)||[\"\",\"\"])[1].toLowerCase()]){a=a.replace(ab,\"<$1></$2>\");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(ob(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,n.cleanData(ob(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,m=this,o=l-1,p=a[0],q=n.isFunction(p);if(q||l>1&&\"string\"==typeof p&&!k.checkClone&&eb.test(p))return this.each(function(c){var d=m.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(c=n.buildFragment(a,this[0].ownerDocument,!1,this),d=c.firstChild,1===c.childNodes.length&&(c=d),d)){for(f=n.map(ob(c,\"script\"),kb),g=f.length;l>j;j++)h=c,j!==o&&(h=n.clone(h,!0,!0),g&&n.merge(f,ob(h,\"script\"))),b.call(this[j],h,j);if(g)for(i=f[f.length-1].ownerDocument,n.map(f,lb),j=0;g>j;j++)h=f[j],fb.test(h.type||\"\")&&!L.access(h,\"globalEval\")&&n.contains(i,h)&&(h.src?n._evalUrl&&n._evalUrl(h.src):n.globalEval(h.textContent.replace(hb,\"\")))}return this}}),n.each({appendTo:\"append\",prependTo:\"prepend\",insertBefore:\"before\",insertAfter:\"after\",replaceAll:\"replaceWith\"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),g=e.length-1,h=0;g>=h;h++)c=h===g?this:this.clone(!0),n(e[h])[b](c),f.apply(d,c.get());return this.pushStack(d)}});var qb,rb={};function sb(b,c){var d,e=n(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:n.css(e[0],\"display\");return e.detach(),f}function tb(a){var b=l,c=rb[a];return c||(c=sb(a,b),\"none\"!==c&&c||(qb=(qb||n(\"<iframe frameborder='0' width='0' height='0'/>\")).appendTo(b.documentElement),b=qb[0].contentDocument,b.write(),b.close(),c=sb(a,b),qb.detach()),rb[a]=c),c}var ub=/^margin/,vb=new RegExp(\"^(\"+Q+\")(?!px)[a-z%]+$\",\"i\"),wb=function(a){return a.ownerDocument.defaultView.getComputedStyle(a,null)};function xb(a,b,c){var d,e,f,g,h=a.style;return c=c||wb(a),c&&(g=c.getPropertyValue(b)||c[b]),c&&(\"\"!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),vb.test(g)&&ub.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+\"\":g}function yb(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d=l.documentElement,e=l.createElement(\"div\"),f=l.createElement(\"div\");if(f.style){f.style.backgroundClip=\"content-box\",f.cloneNode(!0).style.backgroundClip=\"\",k.clearCloneStyle=\"content-box\"===f.style.backgroundClip,e.style.cssText=\"border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute\",e.appendChild(f);function g(){f.style.cssText=\"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute\",f.innerHTML=\"\",d.appendChild(e);var g=a.getComputedStyle(f,null);b=\"1%\"!==g.top,c=\"4px\"===g.width,d.removeChild(e)}a.getComputedStyle&&n.extend(k,{pixelPosition:function(){return g(),b},boxSizingReliable:function(){return null==c&&g(),c},reliableMarginRight:function(){var b,c=f.appendChild(l.createElement(\"div\"));return c.style.cssText=f.style.cssText=\"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0\",c.style.marginRight=c.style.width=\"0\",f.style.width=\"1px\",d.appendChild(e),b=!parseFloat(a.getComputedStyle(c,null).marginRight),d.removeChild(e),b}})}}(),n.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var zb=/^(none|table(?!-c[ea]).+)/,Ab=new RegExp(\"^(\"+Q+\")(.*)$\",\"i\"),Bb=new RegExp(\"^([+-])=(\"+Q+\")\",\"i\"),Cb={position:\"absolute\",visibility:\"hidden\",display:\"block\"},Db={letterSpacing:\"0\",fontWeight:\"400\"},Eb=[\"Webkit\",\"O\",\"Moz\",\"ms\"];function Fb(a,b){if(b in a)return b;var c=b[0].toUpperCase()+b.slice(1),d=b,e=Eb.length;while(e--)if(b=Eb[e]+c,b in a)return b;return d}function Gb(a,b,c){var d=Ab.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||\"px\"):b}function Hb(a,b,c,d,e){for(var f=c===(d?\"border\":\"content\")?4:\"width\"===b?1:0,g=0;4>f;f+=2)\"margin\"===c&&(g+=n.css(a,c+R[f],!0,e)),d?(\"content\"===c&&(g-=n.css(a,\"padding\"+R[f],!0,e)),\"margin\"!==c&&(g-=n.css(a,\"border\"+R[f]+\"Width\",!0,e))):(g+=n.css(a,\"padding\"+R[f],!0,e),\"padding\"!==c&&(g+=n.css(a,\"border\"+R[f]+\"Width\",!0,e)));return g}function Ib(a,b,c){var d=!0,e=\"width\"===b?a.offsetWidth:a.offsetHeight,f=wb(a),g=\"border-box\"===n.css(a,\"boxSizing\",!1,f);if(0>=e||null==e){if(e=xb(a,b,f),(0>e||null==e)&&(e=a.style[b]),vb.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Hb(a,b,c||(g?\"border\":\"content\"),d,f)+\"px\"}function Jb(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=L.get(d,\"olddisplay\"),c=d.style.display,b?(f[g]||\"none\"!==c||(d.style.display=\"\"),\"\"===d.style.display&&S(d)&&(f[g]=L.access(d,\"olddisplay\",tb(d.nodeName)))):(e=S(d),\"none\"===c&&e||L.set(d,\"olddisplay\",e?c:n.css(d,\"display\"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&\"none\"!==d.style.display&&\"\"!==d.style.display||(d.style.display=b?f[g]||\"\":\"none\"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=xb(a,\"opacity\");return\"\"===c?\"1\":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{\"float\":\"cssFloat\"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Fb(i,h)),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&\"get\"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,\"string\"===f&&(e=Bb.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(n.css(a,b)),f=\"number\"),null!=c&&c===c&&(\"number\"!==f||n.cssNumber[h]||(c+=\"px\"),k.clearCloneStyle||\"\"!==c||0!==b.indexOf(\"background\")||(i[b]=\"inherit\"),g&&\"set\"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Fb(a.style,h)),g=n.cssHooks[b]||n.cssHooks[h],g&&\"get\"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=xb(a,b,d)),\"normal\"===e&&b in Db&&(e=Db[b]),\"\"===c||c?(f=parseFloat(e),c===!0||n.isNumeric(f)?f||0:e):e}}),n.each([\"height\",\"width\"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?zb.test(n.css(a,\"display\"))&&0===a.offsetWidth?n.swap(a,Cb,function(){return Ib(a,b,d)}):Ib(a,b,d):void 0},set:function(a,c,d){var e=d&&wb(a);return Gb(a,c,d?Hb(a,b,d,\"border-box\"===n.css(a,\"boxSizing\",!1,e),e):0)}}}),n.cssHooks.marginRight=yb(k.reliableMarginRight,function(a,b){return b?n.swap(a,{display:\"inline-block\"},xb,[a,\"marginRight\"]):void 0}),n.each({margin:\"\",padding:\"\",border:\"Width\"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f=\"string\"==typeof c?c.split(\" \"):[c];4>d;d++)e[a+R[d]+b]=f[d]||f[d-2]||f[0];return e}},ub.test(a)||(n.cssHooks[a+b].set=Gb)}),n.fn.extend({css:function(a,b){return J(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=wb(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Jb(this,!0)},hide:function(){return Jb(this)},toggle:function(a){return\"boolean\"==typeof a?a?this.show():this.hide():this.each(function(){S(this)?n(this).show():n(this).hide()})}});function Kb(a,b,c,d,e){return new Kb.prototype.init(a,b,c,d,e)}n.Tween=Kb,Kb.prototype={constructor:Kb,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||\"swing\",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?\"\":\"px\")},cur:function(){var a=Kb.propHooks[this.prop];return a&&a.get?a.get(this):Kb.propHooks._default.get(this)},run:function(a){var b,c=Kb.propHooks[this.prop];return this.pos=b=this.options.duration?n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Kb.propHooks._default.set(this),this}},Kb.prototype.init.prototype=Kb.prototype,Kb.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=n.css(a.elem,a.prop,\"\"),b&&\"auto\"!==b?b:0):a.elem[a.prop]},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[n.cssProps[a.prop]]||n.cssHooks[a.prop])?n.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Kb.propHooks.scrollTop=Kb.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},n.fx=Kb.prototype.init,n.fx.step={};var Lb,Mb,Nb=/^(?:toggle|show|hide)$/,Ob=new RegExp(\"^(?:([+-])=|)(\"+Q+\")([a-z%]*)$\",\"i\"),Pb=/queueHooks$/,Qb=[Vb],Rb={\"*\":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=Ob.exec(b),f=e&&e[3]||(n.cssNumber[a]?\"\":\"px\"),g=(n.cssNumber[a]||\"px\"!==f&&+d)&&Ob.exec(n.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||\".5\",g/=h,n.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function Sb(){return setTimeout(function(){Lb=void 0}),Lb=n.now()}function Tb(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=R[d],e[\"margin\"+c]=e[\"padding\"+c]=a;return b&&(e.opacity=e.width=a),e}function Ub(a,b,c){for(var d,e=(Rb[b]||[]).concat(Rb[\"*\"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Vb(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&S(a),q=L.get(a,\"fxshow\");c.queue||(h=n._queueHooks(a,\"fx\"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,\"fx\").length||h.empty.fire()})})),1===a.nodeType&&(\"height\"in b||\"width\"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,\"display\"),k=\"none\"===j?L.get(a,\"olddisplay\")||tb(a.nodeName):j,\"inline\"===k&&\"none\"===n.css(a,\"float\")&&(o.display=\"inline-block\")),c.overflow&&(o.overflow=\"hidden\",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Nb.exec(e)){if(delete b[d],f=f||\"toggle\"===e,e===(p?\"hide\":\"show\")){if(\"show\"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))\"inline\"===(\"none\"===j?tb(a.nodeName):j)&&(o.display=j);else{q?\"hidden\"in q&&(p=q.hidden):q=L.access(a,\"fxshow\",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;L.remove(a,\"fxshow\");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ub(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start=\"width\"===d||\"height\"===d?1:0))}}function Wb(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&\"expand\"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function Xb(a,b,c){var d,e,f=0,g=Qb.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Lb||Sb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:Lb||Sb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(Wb(k,j.opts.specialEasing);g>f;f++)if(d=Qb[f].call(j,a,k,j.opts))return d;return n.map(k,Ub,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(Xb,{tweener:function(a,b){n.isFunction(a)?(b=a,a=[\"*\"]):a=a.split(\" \");for(var c,d=0,e=a.length;e>d;d++)c=a[d],Rb[c]=Rb[c]||[],Rb[c].unshift(b)},prefilter:function(a,b){b?Qb.unshift(a):Qb.push(a)}}),n.speed=function(a,b,c){var d=a&&\"object\"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:\"number\"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue=\"fx\"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(S).css(\"opacity\",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=Xb(this,n.extend({},a),f);(e||L.get(this,\"finish\"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return\"string\"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||\"fx\",[]),this.each(function(){var b=!0,e=null!=a&&a+\"queueHooks\",f=n.timers,g=L.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Pb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||\"fx\"),this.each(function(){var b,c=L.get(this),d=c[a+\"queue\"],e=c[a+\"queueHooks\"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each([\"toggle\",\"show\",\"hide\"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||\"boolean\"==typeof a?c.apply(this,arguments):this.animate(Tb(b,!0),a,d,e)}}),n.each({slideDown:Tb(\"show\"),slideUp:Tb(\"hide\"),slideToggle:Tb(\"toggle\"),fadeIn:{opacity:\"show\"},fadeOut:{opacity:\"hide\"},fadeToggle:{opacity:\"toggle\"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Lb=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Lb=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Mb||(Mb=setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){clearInterval(Mb),Mb=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(a,b){return a=n.fx?n.fx.speeds[a]||a:a,b=b||\"fx\",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a=l.createElement(\"input\"),b=l.createElement(\"select\"),c=b.appendChild(l.createElement(\"option\"));a.type=\"checkbox\",k.checkOn=\"\"!==a.value,k.optSelected=c.selected,b.disabled=!0,k.optDisabled=!c.disabled,a=l.createElement(\"input\"),a.value=\"t\",a.type=\"radio\",k.radioValue=\"t\"===a.value}();var Yb,Zb,$b=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return J(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===U?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),d=n.attrHooks[b]||(n.expr.match.bool.test(b)?Zb:Yb)),void 0===c?d&&\"get\"in d&&null!==(e=d.get(a,b))?e:(e=n.find.attr(a,b),null==e?void 0:e):null!==c?d&&\"set\"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+\"\"),c):void n.removeAttr(a,b))\n},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&\"radio\"===b&&n.nodeName(a,\"input\")){var c=a.value;return a.setAttribute(\"type\",b),c&&(a.value=c),b}}}}}),Zb={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\\w+/g),function(a,b){var c=$b[b]||n.find.attr;$b[b]=function(a,b,d){var e,f;return d||(f=$b[b],$b[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,$b[b]=f),e}});var _b=/^(?:input|select|textarea|button)$/i;n.fn.extend({prop:function(a,b){return J(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({propFix:{\"for\":\"htmlFor\",\"class\":\"className\"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!n.isXMLDoc(a),f&&(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&\"set\"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&\"get\"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){return a.hasAttribute(\"tabindex\")||_b.test(a.nodeName)||a.href?a.tabIndex:-1}}}}),k.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each([\"tabIndex\",\"readOnly\",\"maxLength\",\"cellSpacing\",\"cellPadding\",\"rowSpan\",\"colSpan\",\"useMap\",\"frameBorder\",\"contentEditable\"],function(){n.propFix[this.toLowerCase()]=this});var ac=/[\\t\\r\\n\\f]/g;n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h=\"string\"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,this.className))});if(h)for(b=(a||\"\").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(\" \"+c.className+\" \").replace(ac,\" \"):\" \")){f=0;while(e=b[f++])d.indexOf(\" \"+e+\" \")<0&&(d+=e+\" \");g=n.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0===arguments.length||\"string\"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,this.className))});if(h)for(b=(a||\"\").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(\" \"+c.className+\" \").replace(ac,\" \"):\"\")){f=0;while(e=b[f++])while(d.indexOf(\" \"+e+\" \")>=0)d=d.replace(\" \"+e+\" \",\" \");g=a?n.trim(d):\"\",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return\"boolean\"==typeof b&&\"string\"===c?b?this.addClass(a):this.removeClass(a):this.each(n.isFunction(a)?function(c){n(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if(\"string\"===c){var b,d=0,e=n(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===U||\"boolean\"===c)&&(this.className&&L.set(this,\"__className__\",this.className),this.className=this.className||a===!1?\"\":L.get(this,\"__className__\")||\"\")})},hasClass:function(a){for(var b=\" \"+a+\" \",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(\" \"+this[c].className+\" \").replace(ac,\" \").indexOf(b)>=0)return!0;return!1}});var bc=/\\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e=\"\":\"number\"==typeof e?e+=\"\":n.isArray(e)&&(e=n.map(e,function(a){return null==a?\"\":a+\"\"})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&\"set\"in b&&void 0!==b.set(this,e,\"value\")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&\"get\"in b&&void 0!==(c=b.get(e,\"value\"))?c:(c=e.value,\"string\"==typeof c?c.replace(bc,\"\"):null==c?\"\":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,\"value\");return null!=b?b:n.trim(n.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f=\"select-one\"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute(\"disabled\"))||c.parentNode.disabled&&n.nodeName(c.parentNode,\"optgroup\"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(d.value,f)>=0)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each([\"radio\",\"checkbox\"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>=0:void 0}},k.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute(\"value\")?\"on\":a.value})}),n.each(\"blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu\".split(\" \"),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,\"**\"):this.off(b,a||\"**\",c)}});var cc=n.now(),dc=/\\?/;n.parseJSON=function(a){return JSON.parse(a+\"\")},n.parseXML=function(a){var b,c;if(!a||\"string\"!=typeof a)return null;try{c=new DOMParser,b=c.parseFromString(a,\"text/xml\")}catch(d){b=void 0}return(!b||b.getElementsByTagName(\"parsererror\").length)&&n.error(\"Invalid XML: \"+a),b};var ec,fc,gc=/#.*$/,hc=/([?&])_=[^&]*/,ic=/^(.*?):[ \\t]*([^\\r\\n]*)$/gm,jc=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,kc=/^(?:GET|HEAD)$/,lc=/^\\/\\//,mc=/^([\\w.+-]+:)(?:\\/\\/(?:[^\\/?#]*@|)([^\\/?#:]*)(?::(\\d+)|)|)/,nc={},oc={},pc=\"*/\".concat(\"*\");try{fc=location.href}catch(qc){fc=l.createElement(\"a\"),fc.href=\"\",fc=fc.href}ec=mc.exec(fc.toLowerCase())||[];function rc(a){return function(b,c){\"string\"!=typeof b&&(c=b,b=\"*\");var d,e=0,f=b.toLowerCase().match(E)||[];if(n.isFunction(c))while(d=f[e++])\"+\"===d[0]?(d=d.slice(1)||\"*\",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function sc(a,b,c,d){var e={},f=a===oc;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return\"string\"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e[\"*\"]&&g(\"*\")}function tc(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function uc(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while(\"*\"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader(\"Content-Type\"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+\" \"+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function vc(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if(\"*\"===f)f=i;else if(\"*\"!==i&&i!==f){if(g=j[i+\" \"+f]||j[\"* \"+f],!g)for(e in j)if(h=e.split(\" \"),h[1]===f&&(g=j[i+\" \"+h[0]]||j[\"* \"+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a[\"throws\"])b=g(b);else try{b=g(b)}catch(l){return{state:\"parsererror\",error:g?l:\"No conversion from \"+i+\" to \"+f}}}return{state:\"success\",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:fc,type:\"GET\",isLocal:jc.test(ec[1]),global:!0,processData:!0,async:!0,contentType:\"application/x-www-form-urlencoded; charset=UTF-8\",accepts:{\"*\":pc,text:\"text/plain\",html:\"text/html\",xml:\"application/xml, text/xml\",json:\"application/json, text/javascript\"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:\"responseXML\",text:\"responseText\",json:\"responseJSON\"},converters:{\"* text\":String,\"text html\":!0,\"text json\":n.parseJSON,\"text xml\":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?tc(tc(a,n.ajaxSettings),b):tc(n.ajaxSettings,a)},ajaxPrefilter:rc(nc),ajaxTransport:rc(oc),ajax:function(a,b){\"object\"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=n.ajaxSetup({},b),l=k.context||k,m=k.context&&(l.nodeType||l.jquery)?n(l):n.event,o=n.Deferred(),p=n.Callbacks(\"once memory\"),q=k.statusCode||{},r={},s={},t=0,u=\"canceled\",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!f){f={};while(b=ic.exec(e))f[b[1].toLowerCase()]=b[2]}b=f[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?e:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return c&&c.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||fc)+\"\").replace(gc,\"\").replace(lc,ec[1]+\"//\"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=n.trim(k.dataType||\"*\").toLowerCase().match(E)||[\"\"],null==k.crossDomain&&(h=mc.exec(k.url.toLowerCase()),k.crossDomain=!(!h||h[1]===ec[1]&&h[2]===ec[2]&&(h[3]||(\"http:\"===h[1]?\"80\":\"443\"))===(ec[3]||(\"http:\"===ec[1]?\"80\":\"443\")))),k.data&&k.processData&&\"string\"!=typeof k.data&&(k.data=n.param(k.data,k.traditional)),sc(nc,k,b,v),2===t)return v;i=k.global,i&&0===n.active++&&n.event.trigger(\"ajaxStart\"),k.type=k.type.toUpperCase(),k.hasContent=!kc.test(k.type),d=k.url,k.hasContent||(k.data&&(d=k.url+=(dc.test(d)?\"&\":\"?\")+k.data,delete k.data),k.cache===!1&&(k.url=hc.test(d)?d.replace(hc,\"$1_=\"+cc++):d+(dc.test(d)?\"&\":\"?\")+\"_=\"+cc++)),k.ifModified&&(n.lastModified[d]&&v.setRequestHeader(\"If-Modified-Since\",n.lastModified[d]),n.etag[d]&&v.setRequestHeader(\"If-None-Match\",n.etag[d])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader(\"Content-Type\",k.contentType),v.setRequestHeader(\"Accept\",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+(\"*\"!==k.dataTypes[0]?\", \"+pc+\"; q=0.01\":\"\"):k.accepts[\"*\"]);for(j in k.headers)v.setRequestHeader(j,k.headers[j]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u=\"abort\";for(j in{success:1,error:1,complete:1})v[j](k[j]);if(c=sc(oc,k,b,v)){v.readyState=1,i&&m.trigger(\"ajaxSend\",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort(\"timeout\")},k.timeout));try{t=1,c.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,\"No Transport\");function x(a,b,f,h){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),c=void 0,e=h||\"\",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,f&&(u=uc(k,v,f)),u=vc(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader(\"Last-Modified\"),w&&(n.lastModified[d]=w),w=v.getResponseHeader(\"etag\"),w&&(n.etag[d]=w)),204===a||\"HEAD\"===k.type?x=\"nocontent\":304===a?x=\"notmodified\":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x=\"error\",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+\"\",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,i&&m.trigger(j?\"ajaxSuccess\":\"ajaxError\",[v,k,j?r:s]),p.fireWith(l,[v,x]),i&&(m.trigger(\"ajaxComplete\",[v,k]),--n.active||n.event.trigger(\"ajaxStop\")))}return v},getJSON:function(a,b,c){return n.get(a,b,c,\"json\")},getScript:function(a,b){return n.get(a,void 0,b,\"script\")}}),n.each([\"get\",\"post\"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),n.each([\"ajaxStart\",\"ajaxStop\",\"ajaxComplete\",\"ajaxError\",\"ajaxSuccess\",\"ajaxSend\"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n._evalUrl=function(a){return n.ajax({url:a,type:\"GET\",dataType:\"script\",async:!1,global:!1,\"throws\":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return this.each(n.isFunction(a)?function(b){n(this).wrapInner(a.call(this,b))}:function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,\"body\")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var wc=/%20/g,xc=/\\[\\]$/,yc=/\\r?\\n/g,zc=/^(?:submit|button|image|reset|file)$/i,Ac=/^(?:input|select|textarea|keygen)/i;function Bc(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||xc.test(a)?d(a,e):Bc(a+\"[\"+(\"object\"==typeof e?b:\"\")+\"]\",e,c,d)});else if(c||\"object\"!==n.type(b))d(a,b);else for(e in b)Bc(a+\"[\"+e+\"]\",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?\"\":b,d[d.length]=encodeURIComponent(a)+\"=\"+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Bc(c,a[c],b,e);return d.join(\"&\").replace(wc,\"+\")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,\"elements\");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(\":disabled\")&&Ac.test(this.nodeName)&&!zc.test(a)&&(this.checked||!T.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(yc,\"\\r\\n\")}}):{name:b.name,value:c.replace(yc,\"\\r\\n\")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new XMLHttpRequest}catch(a){}};var Cc=0,Dc={},Ec={0:200,1223:204},Fc=n.ajaxSettings.xhr();a.ActiveXObject&&n(a).on(\"unload\",function(){for(var a in Dc)Dc[a]()}),k.cors=!!Fc&&\"withCredentials\"in Fc,k.ajax=Fc=!!Fc,n.ajaxTransport(function(a){var b;return k.cors||Fc&&!a.crossDomain?{send:function(c,d){var e,f=a.xhr(),g=++Cc;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c[\"X-Requested-With\"]||(c[\"X-Requested-With\"]=\"XMLHttpRequest\");for(e in c)f.setRequestHeader(e,c[e]);b=function(a){return function(){b&&(delete Dc[g],b=f.onload=f.onerror=null,\"abort\"===a?f.abort():\"error\"===a?d(f.status,f.statusText):d(Ec[f.status]||f.status,f.statusText,\"string\"==typeof f.responseText?{text:f.responseText}:void 0,f.getAllResponseHeaders()))}},f.onload=b(),f.onerror=b(\"error\"),b=Dc[g]=b(\"abort\");try{f.send(a.hasContent&&a.data||null)}catch(h){if(b)throw h}},abort:function(){b&&b()}}:void 0}),n.ajaxSetup({accepts:{script:\"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript\"},contents:{script:/(?:java|ecma)script/},converters:{\"text script\":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter(\"script\",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type=\"GET\")}),n.ajaxTransport(\"script\",function(a){if(a.crossDomain){var b,c;return{send:function(d,e){b=n(\"<script>\").prop({async:!0,charset:a.scriptCharset,src:a.url}).on(\"load error\",c=function(a){b.remove(),c=null,a&&e(\"error\"===a.type?404:200,a.type)}),l.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Gc=[],Hc=/(=)\\?(?=&|$)|\\?\\?/;n.ajaxSetup({jsonp:\"callback\",jsonpCallback:function(){var a=Gc.pop()||n.expando+\"_\"+cc++;return this[a]=!0,a}}),n.ajaxPrefilter(\"json jsonp\",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Hc.test(b.url)?\"url\":\"string\"==typeof b.data&&!(b.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&Hc.test(b.data)&&\"data\");return h||\"jsonp\"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Hc,\"$1\"+e):b.jsonp!==!1&&(b.url+=(dc.test(b.url)?\"&\":\"?\")+b.jsonp+\"=\"+e),b.converters[\"script json\"]=function(){return g||n.error(e+\" was not called\"),g[0]},b.dataTypes[0]=\"json\",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Gc.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),\"script\"):void 0}),n.parseHTML=function(a,b,c){if(!a||\"string\"!=typeof a)return null;\"boolean\"==typeof b&&(c=b,b=!1),b=b||l;var d=v.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=n.buildFragment([a],b,e),e&&e.length&&n(e).remove(),n.merge([],d.childNodes))};var Ic=n.fn.load;n.fn.load=function(a,b,c){if(\"string\"!=typeof a&&Ic)return Ic.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(\" \");return h>=0&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&\"object\"==typeof b&&(e=\"POST\"),g.length>0&&n.ajax({url:a,type:e,dataType:\"html\",data:b}).done(function(a){f=arguments,g.html(d?n(\"<div>\").append(n.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,f||[a.responseText,b,a])}),this},n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};var Jc=a.document.documentElement;function Kc(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,\"position\"),l=n(a),m={};\"static\"===k&&(a.style.position=\"relative\"),h=l.offset(),f=n.css(a,\"top\"),i=n.css(a,\"left\"),j=(\"absolute\"===k||\"fixed\"===k)&&(f+i).indexOf(\"auto\")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),\"using\"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(typeof d.getBoundingClientRect!==U&&(e=d.getBoundingClientRect()),c=Kc(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return\"fixed\"===n.css(c,\"position\")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],\"html\")||(d=a.offset()),d.top+=n.css(a[0],\"borderTopWidth\",!0),d.left+=n.css(a[0],\"borderLeftWidth\",!0)),{top:b.top-d.top-n.css(c,\"marginTop\",!0),left:b.left-d.left-n.css(c,\"marginLeft\",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||Jc;while(a&&!n.nodeName(a,\"html\")&&\"static\"===n.css(a,\"position\"))a=a.offsetParent;return a||Jc})}}),n.each({scrollLeft:\"pageXOffset\",scrollTop:\"pageYOffset\"},function(b,c){var d=\"pageYOffset\"===c;n.fn[b]=function(e){return J(this,function(b,e,f){var g=Kc(b);return void 0===f?g?g[c]:b[e]:void(g?g.scrollTo(d?a.pageXOffset:f,d?f:a.pageYOffset):b[e]=f)},b,e,arguments.length,null)}}),n.each([\"top\",\"left\"],function(a,b){n.cssHooks[b]=yb(k.pixelPosition,function(a,c){return c?(c=xb(a,b),vb.test(c)?n(a).position()[b]+\"px\":c):void 0})}),n.each({Height:\"height\",Width:\"width\"},function(a,b){n.each({padding:\"inner\"+a,content:b,\"\":\"outer\"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||\"boolean\"!=typeof d),g=c||(d===!0||e===!0?\"margin\":\"border\");return J(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement[\"client\"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body[\"scroll\"+a],e[\"scroll\"+a],b.body[\"offset\"+a],e[\"offset\"+a],e[\"client\"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,\"function\"==typeof define&&define.amd&&define(\"jquery\",[],function(){return n});var Lc=a.jQuery,Mc=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Mc),b&&a.jQuery===n&&(a.jQuery=Lc),n},typeof b===U&&(a.jQuery=a.$=n),n});\n"

/***/ },
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var component;
	var desc = {
		loadComponent: function(callback) {
			if(!component) {
				__webpack_require__.e/* nsure */(4, function() {
					component = __webpack_require__(534);
					if(callback) callback(component);
				});
			} else if(callback) callback(component);
			return component;
		},
	};
	var mixinReactProxy = __webpack_require__(14);
	mixinReactProxy(React, desc);
	module.exports = React.createClass(desc);
	module.exports.Mixin = desc;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var component;
	var desc = {
		loadComponent: function(callback) {
			if(!component) {
				__webpack_require__.e/* nsure */(3, function() {
					component = __webpack_require__(1204);
					if(callback) callback(component);
				});
			} else if(callback) callback(component);
			return component;
		},
	};
	var mixinReactProxy = __webpack_require__(14);
	mixinReactProxy(React, desc);
	module.exports = React.createClass(desc);
	module.exports.Mixin = desc;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var component;
	var desc = {
		loadComponent: function(callback) {
			if(!component) {
				__webpack_require__.e/* nsure */(2, function() {
					component = __webpack_require__(1206);
					if(callback) callback(component);
				});
			} else if(callback) callback(component);
			return component;
		},
	};
	var mixinReactProxy = __webpack_require__(14);
	mixinReactProxy(React, desc);
	module.exports = React.createClass(desc);
	module.exports.Mixin = desc;

/***/ },
/* 1229 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 1230 */,
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 1232 */,
/* 1233 */,
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1126);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./bootstrap-submenus.less", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./bootstrap-submenus.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1235 */,
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./graylog2.less", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./graylog2.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1130);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./newfonts.less", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/less-loader/index.js!./newfonts.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1238 */,
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1132);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./shim.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./shim.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1133);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./bootstrap.min.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./bootstrap.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1241 */,
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1135);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./font-awesome.min.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./font-awesome.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1243 */,
/* 1244 */,
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1138);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./rickshaw.min.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./rickshaw.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1139);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(20)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./toastr.min.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./toastr.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	// From https://gist.github.com/epeli/11209665
	
	var Promise = __webpack_require__(208);
	
	// So you can `var request = require("superagent-bluebird-promise")`
	var superagent = module.exports = __webpack_require__(1253);
	var Request = superagent.Request;
	
	// Create custom error type.
	// Create a new object, that prototypally inherits from the Error constructor.
	var SuperagentPromiseError = function(message, originalError) {
	  var stack;
	  this.message = message;
	  this.name = 'SuperagentPromiseError';
	  this.originalError = originalError;
	
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, this.constructor);
	    stack = this.stack;
	  }
	  else {
	    stack = (new Error(message)).stack;
	  }
	
	  if (Object.defineProperty) {
	    Object.defineProperty(this, 'stack', {
	      get: function() {
	        if (this.originalError) {
	          return stack + '\nCaused by:  ' + this.originalError.stack;
	        }
	
	        return stack;
	      }
	    });
	  }
	};
	
	SuperagentPromiseError.prototype = new Error();
	SuperagentPromiseError.prototype.constructor = SuperagentPromiseError;
	superagent.SuperagentPromiseError = SuperagentPromiseError;
	
	/**
	 * @namespace utils
	 * @class Superagent
	 */
	
	/**
	 *
	 * Add promise support for superagent/supertest
	 *
	 * Call .promise() to return promise for the request
	 *
	 * @method then
	 * @return {Bluebird.Promise}
	 */
	Request.prototype.promise = function() {
	  var req = this;
	  var error;
	
	  return new Promise(function(resolve, reject) {
	      req.end(function(err, res) {
	        if (typeof res !== "undefined" && res.status >= 400) {
	          var msg = 'cannot ' + req.method + ' ' + req.url + ' (' + res.status + ')';
	          error = new SuperagentPromiseError(msg);
	          error.status = res.status;
	          error.body = res.body;
	          error.res = res;
	          reject(error);
	        } else if (err) {
	          reject(new SuperagentPromiseError('Bad request', err));
	        } else {
	          resolve(res);
	        }
	      });
	    })
	    .cancellable()
	    .caught(Promise.CancellationError, function(err) {
	      req.abort();
	      throw err;
	    });
	};
	
	/**
	 *
	 * Make superagent requests Promises/A+ conformant
	 *
	 * Call .then([onFulfilled], [onRejected]) to register callbacks
	 *
	 * @method then
	 * @param {function} [onFulfilled]
	 * @param {function} [onRejected]
	 * @return {Bluebird.Promise}
	 */
	Request.prototype.then = function() {
	  var promise = this.promise();
	  return promise.then.apply(promise, arguments);
	};


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(1006);
	var reduce = __webpack_require__(1229);
	var requestBase = __webpack_require__(1254);
	var isObject = __webpack_require__(636);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(1255).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr && this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};
	
	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(636);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};


/***/ },
/* 1255 */
/***/ function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Toastr
	 * Copyright 2012-2015
	 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
	 * All Rights Reserved.
	 * Use, reproduction, distribution, and modification of this code is subject to the terms and
	 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
	 *
	 * ARIA Support: Greta Krafsig
	 *
	 * Project: https://github.com/CodeSeven/toastr
	 */
	/* global define */
	; (function (define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	        return (function () {
	            var $container;
	            var listener;
	            var toastId = 0;
	            var toastType = {
	                error: 'error',
	                info: 'info',
	                success: 'success',
	                warning: 'warning'
	            };
	
	            var toastr = {
	                clear: clear,
	                remove: remove,
	                error: error,
	                getContainer: getContainer,
	                info: info,
	                options: {},
	                subscribe: subscribe,
	                success: success,
	                version: '2.1.2',
	                warning: warning
	            };
	
	            var previousToast;
	
	            return toastr;
	
	            ////////////////
	
	            function error(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.error,
	                    iconClass: getOptions().iconClasses.error,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function getContainer(options, create) {
	                if (!options) { options = getOptions(); }
	                $container = $('#' + options.containerId);
	                if ($container.length) {
	                    return $container;
	                }
	                if (create) {
	                    $container = createContainer(options);
	                }
	                return $container;
	            }
	
	            function info(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.info,
	                    iconClass: getOptions().iconClasses.info,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function subscribe(callback) {
	                listener = callback;
	            }
	
	            function success(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.success,
	                    iconClass: getOptions().iconClasses.success,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function warning(message, title, optionsOverride) {
	                return notify({
	                    type: toastType.warning,
	                    iconClass: getOptions().iconClasses.warning,
	                    message: message,
	                    optionsOverride: optionsOverride,
	                    title: title
	                });
	            }
	
	            function clear($toastElement, clearOptions) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if (!clearToast($toastElement, options, clearOptions)) {
	                    clearContainer(options);
	                }
	            }
	
	            function remove($toastElement) {
	                var options = getOptions();
	                if (!$container) { getContainer(options); }
	                if ($toastElement && $(':focus', $toastElement).length === 0) {
	                    removeToast($toastElement);
	                    return;
	                }
	                if ($container.children().length) {
	                    $container.remove();
	                }
	            }
	
	            // internal functions
	
	            function clearContainer (options) {
	                var toastsToClear = $container.children();
	                for (var i = toastsToClear.length - 1; i >= 0; i--) {
	                    clearToast($(toastsToClear[i]), options);
	                }
	            }
	
	            function clearToast ($toastElement, options, clearOptions) {
	                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
	                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
	                    $toastElement[options.hideMethod]({
	                        duration: options.hideDuration,
	                        easing: options.hideEasing,
	                        complete: function () { removeToast($toastElement); }
	                    });
	                    return true;
	                }
	                return false;
	            }
	
	            function createContainer(options) {
	                $container = $('<div/>')
	                    .attr('id', options.containerId)
	                    .addClass(options.positionClass)
	                    .attr('aria-live', 'polite')
	                    .attr('role', 'alert');
	
	                $container.appendTo($(options.target));
	                return $container;
	            }
	
	            function getDefaults() {
	                return {
	                    tapToDismiss: true,
	                    toastClass: 'toast',
	                    containerId: 'toast-container',
	                    debug: false,
	
	                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
	                    showDuration: 300,
	                    showEasing: 'swing', //swing and linear are built into jQuery
	                    onShown: undefined,
	                    hideMethod: 'fadeOut',
	                    hideDuration: 1000,
	                    hideEasing: 'swing',
	                    onHidden: undefined,
	                    closeMethod: false,
	                    closeDuration: false,
	                    closeEasing: false,
	
	                    extendedTimeOut: 1000,
	                    iconClasses: {
	                        error: 'toast-error',
	                        info: 'toast-info',
	                        success: 'toast-success',
	                        warning: 'toast-warning'
	                    },
	                    iconClass: 'toast-info',
	                    positionClass: 'toast-top-right',
	                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
	                    titleClass: 'toast-title',
	                    messageClass: 'toast-message',
	                    escapeHtml: false,
	                    target: 'body',
	                    closeHtml: '<button type="button">&times;</button>',
	                    newestOnTop: true,
	                    preventDuplicates: false,
	                    progressBar: false
	                };
	            }
	
	            function publish(args) {
	                if (!listener) { return; }
	                listener(args);
	            }
	
	            function notify(map) {
	                var options = getOptions();
	                var iconClass = map.iconClass || options.iconClass;
	
	                if (typeof (map.optionsOverride) !== 'undefined') {
	                    options = $.extend(options, map.optionsOverride);
	                    iconClass = map.optionsOverride.iconClass || iconClass;
	                }
	
	                if (shouldExit(options, map)) { return; }
	
	                toastId++;
	
	                $container = getContainer(options, true);
	
	                var intervalId = null;
	                var $toastElement = $('<div/>');
	                var $titleElement = $('<div/>');
	                var $messageElement = $('<div/>');
	                var $progressElement = $('<div/>');
	                var $closeElement = $(options.closeHtml);
	                var progressBar = {
	                    intervalId: null,
	                    hideEta: null,
	                    maxHideTime: null
	                };
	                var response = {
	                    toastId: toastId,
	                    state: 'visible',
	                    startTime: new Date(),
	                    options: options,
	                    map: map
	                };
	
	                personalizeToast();
	
	                displayToast();
	
	                handleEvents();
	
	                publish(response);
	
	                if (options.debug && console) {
	                    console.log(response);
	                }
	
	                return $toastElement;
	
	                function escapeHtml(source) {
	                    if (source == null)
	                        source = "";
	
	                    return new String(source)
	                        .replace(/&/g, '&amp;')
	                        .replace(/"/g, '&quot;')
	                        .replace(/'/g, '&#39;')
	                        .replace(/</g, '&lt;')
	                        .replace(/>/g, '&gt;');
	                }
	
	                function personalizeToast() {
	                    setIcon();
	                    setTitle();
	                    setMessage();
	                    setCloseButton();
	                    setProgressBar();
	                    setSequence();
	                }
	
	                function handleEvents() {
	                    $toastElement.hover(stickAround, delayedHideToast);
	                    if (!options.onclick && options.tapToDismiss) {
	                        $toastElement.click(hideToast);
	                    }
	
	                    if (options.closeButton && $closeElement) {
	                        $closeElement.click(function (event) {
	                            if (event.stopPropagation) {
	                                event.stopPropagation();
	                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
	                                event.cancelBubble = true;
	                            }
	                            hideToast(true);
	                        });
	                    }
	
	                    if (options.onclick) {
	                        $toastElement.click(function (event) {
	                            options.onclick(event);
	                            hideToast();
	                        });
	                    }
	                }
	
	                function displayToast() {
	                    $toastElement.hide();
	
	                    $toastElement[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
	                    );
	
	                    if (options.timeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.timeOut);
	                        progressBar.maxHideTime = parseFloat(options.timeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                        if (options.progressBar) {
	                            progressBar.intervalId = setInterval(updateProgress, 10);
	                        }
	                    }
	                }
	
	                function setIcon() {
	                    if (map.iconClass) {
	                        $toastElement.addClass(options.toastClass).addClass(iconClass);
	                    }
	                }
	
	                function setSequence() {
	                    if (options.newestOnTop) {
	                        $container.prepend($toastElement);
	                    } else {
	                        $container.append($toastElement);
	                    }
	                }
	
	                function setTitle() {
	                    if (map.title) {
	                        $titleElement.append(!options.escapeHtml ? map.title : escapeHtml(map.title)).addClass(options.titleClass);
	                        $toastElement.append($titleElement);
	                    }
	                }
	
	                function setMessage() {
	                    if (map.message) {
	                        $messageElement.append(!options.escapeHtml ? map.message : escapeHtml(map.message)).addClass(options.messageClass);
	                        $toastElement.append($messageElement);
	                    }
	                }
	
	                function setCloseButton() {
	                    if (options.closeButton) {
	                        $closeElement.addClass('toast-close-button').attr('role', 'button');
	                        $toastElement.prepend($closeElement);
	                    }
	                }
	
	                function setProgressBar() {
	                    if (options.progressBar) {
	                        $progressElement.addClass('toast-progress');
	                        $toastElement.prepend($progressElement);
	                    }
	                }
	
	                function shouldExit(options, map) {
	                    if (options.preventDuplicates) {
	                        if (map.message === previousToast) {
	                            return true;
	                        } else {
	                            previousToast = map.message;
	                        }
	                    }
	                    return false;
	                }
	
	                function hideToast(override) {
	                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
	                    var duration = override && options.closeDuration !== false ?
	                        options.closeDuration : options.hideDuration;
	                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
	                    if ($(':focus', $toastElement).length && !override) {
	                        return;
	                    }
	                    clearTimeout(progressBar.intervalId);
	                    return $toastElement[method]({
	                        duration: duration,
	                        easing: easing,
	                        complete: function () {
	                            removeToast($toastElement);
	                            if (options.onHidden && response.state !== 'hidden') {
	                                options.onHidden();
	                            }
	                            response.state = 'hidden';
	                            response.endTime = new Date();
	                            publish(response);
	                        }
	                    });
	                }
	
	                function delayedHideToast() {
	                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
	                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
	                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
	                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
	                    }
	                }
	
	                function stickAround() {
	                    clearTimeout(intervalId);
	                    progressBar.hideEta = 0;
	                    $toastElement.stop(true, true)[options.showMethod](
	                        {duration: options.showDuration, easing: options.showEasing}
	                    );
	                }
	
	                function updateProgress() {
	                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
	                    $progressElement.width(percentage + '%');
	                }
	            }
	
	            function getOptions() {
	                return $.extend({}, getDefaults(), toastr.options);
	            }
	
	            function removeToast($toastElement) {
	                if (!$container) { $container = getContainer(); }
	                if ($toastElement.is(':visible')) {
	                    return;
	                }
	                $toastElement.remove();
	                $toastElement = null;
	                if ($container.children().length === 0) {
	                    $container.remove();
	                    previousToast = undefined;
	                }
	            }
	
	        })();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(1262)));


/***/ },
/* 1257 */,
/* 1258 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAABBAQAAAADHuBTvAAAAAnRSTlMAAHaTzTgAAAAWSURBVHgBYxhuYBSMglEwCkbBKBgFAAffAAHn7MpbAAAAAElFTkSuQmCC"

/***/ },
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(323);

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(324);

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(325);

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(326);

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(327);

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(328);

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(44);

/***/ },
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(594);

/***/ },
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(12))(769);

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// app.7efde769d3fee97e95fa.js